(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory(require("react"), require("react-dom"));else if (typeof define === 'function' && define.amd) define(["react", "react-dom"], factory);else if (typeof exports === 'object') exports["MarkdownInput"] = factory(require("react"), require("react-dom"));else root["MarkdownInput"] = factory(root["React"], root["ReactDOM"]);
})(this, function (__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_4__) {
  return /******/function (modules) {
    // webpackBootstrap
    /******/ // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/ // The require function
    /******/
    function __webpack_require__(moduleId) {
      /******/
      /******/ // Check if module is in cache
      /******/if (installedModules[moduleId]) /******/return installedModules[moduleId].exports;
      /******/
      /******/ // Create a new module (and put it into the cache)
      /******/
      var module = installedModules[moduleId] = {
        /******/i: moduleId,
        /******/l: false,
        /******/exports: {}
        /******/
      };
      /******/
      /******/ // Execute the module function
      /******/
      modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
      /******/
      /******/ // Flag the module as loaded
      /******/
      module.l = true;
      /******/
      /******/ // Return the exports of the module
      /******/
      return module.exports;
      /******/
    }
    /******/
    /******/
    /******/ // expose the modules object (__webpack_modules__)
    /******/
    __webpack_require__.m = modules;
    /******/
    /******/ // expose the module cache
    /******/
    __webpack_require__.c = installedModules;
    /******/
    /******/ // identity function for calling harmony imports with the correct context
    /******/
    __webpack_require__.i = function (value) {
      return value;
    };
    /******/
    /******/ // define getter function for harmony exports
    /******/
    __webpack_require__.d = function (exports, name, getter) {
      /******/if (!__webpack_require__.o(exports, name)) {
        /******/Object.defineProperty(exports, name, {
          /******/configurable: false,
          /******/enumerable: true,
          /******/get: getter
          /******/
        });
        /******/
      }
      /******/
    };
    /******/
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/
    __webpack_require__.n = function (module) {
      /******/var getter = module && module.__esModule ? /******/function getDefault() {
        return module['default'];
      } : /******/function getModuleExports() {
        return module;
      };
      /******/
      __webpack_require__.d(getter, 'a', getter);
      /******/
      return getter;
      /******/
    };
    /******/
    /******/ // Object.prototype.hasOwnProperty.call
    /******/
    __webpack_require__.o = function (object, property) {
      return Object.prototype.hasOwnProperty.call(object, property);
    };
    /******/
    /******/ // __webpack_public_path__
    /******/
    __webpack_require__.p = "";
    /******/
    /******/ // Load entry module and return exports
    /******/
    return __webpack_require__(__webpack_require__.s = 698);
    /******/
  }
  /************************************************************************/
  /******/([( /* 0 */
  /***/function (module, exports) {
    module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

    /***/
  }), ( /* 1 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Utilities
    //
    function _class(obj) {
      return Object.prototype.toString.call(obj);
    }
    function isString(obj) {
      return _class(obj) === '[object String]';
    }
    var _hasOwnProperty = Object.prototype.hasOwnProperty;
    function has(object, key) {
      return _hasOwnProperty.call(object, key);
    }

    // Merge objects
    //
    function assign(obj /*from1, from2, from3, ...*/) {
      var sources = Array.prototype.slice.call(arguments, 1);
      sources.forEach(function (source) {
        if (!source) {
          return;
        }
        if (typeof source !== 'object') {
          throw new TypeError(source + 'must be object');
        }
        Object.keys(source).forEach(function (key) {
          obj[key] = source[key];
        });
      });
      return obj;
    }

    // Remove element from array and put another array at those position.
    // Useful for some operations with tokens
    function arrayReplaceAt(src, pos, newElements) {
      return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
    }

    ////////////////////////////////////////////////////////////////////////////////

    function isValidEntityCode(c) {
      /*eslint no-bitwise:0*/
      // broken sequence
      if (c >= 0xD800 && c <= 0xDFFF) {
        return false;
      }
      // never used
      if (c >= 0xFDD0 && c <= 0xFDEF) {
        return false;
      }
      if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) {
        return false;
      }
      // control codes
      if (c >= 0x00 && c <= 0x08) {
        return false;
      }
      if (c === 0x0B) {
        return false;
      }
      if (c >= 0x0E && c <= 0x1F) {
        return false;
      }
      if (c >= 0x7F && c <= 0x9F) {
        return false;
      }
      // out of range
      if (c > 0x10FFFF) {
        return false;
      }
      return true;
    }
    function fromCodePoint(c) {
      /*eslint no-bitwise:0*/
      if (c > 0xffff) {
        c -= 0x10000;
        var surrogate1 = 0xd800 + (c >> 10),
          surrogate2 = 0xdc00 + (c & 0x3ff);
        return String.fromCharCode(surrogate1, surrogate2);
      }
      return String.fromCharCode(c);
    }
    var UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])/g;
    var ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
    var UNESCAPE_ALL_RE = new RegExp(UNESCAPE_MD_RE.source + '|' + ENTITY_RE.source, 'gi');
    var DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))/i;
    var entities = __webpack_require__(212);
    function replaceEntityPattern(match, name) {
      var code = 0;
      if (has(entities, name)) {
        return entities[name];
      }
      if (name.charCodeAt(0) === 0x23 /* # */ && DIGITAL_ENTITY_TEST_RE.test(name)) {
        code = name[1].toLowerCase() === 'x' ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
        if (isValidEntityCode(code)) {
          return fromCodePoint(code);
        }
      }
      return match;
    }

    /*function replaceEntities(str) {
      if (str.indexOf('&') < 0) { return str; }
    
      return str.replace(ENTITY_RE, replaceEntityPattern);
    }*/

    function unescapeMd(str) {
      if (str.indexOf('\\') < 0) {
        return str;
      }
      return str.replace(UNESCAPE_MD_RE, '$1');
    }
    function unescapeAll(str) {
      if (str.indexOf('\\') < 0 && str.indexOf('&') < 0) {
        return str;
      }
      return str.replace(UNESCAPE_ALL_RE, function (match, escaped, entity) {
        if (escaped) {
          return escaped;
        }
        return replaceEntityPattern(match, entity);
      });
    }

    ////////////////////////////////////////////////////////////////////////////////

    var HTML_ESCAPE_TEST_RE = /[&<>"]/;
    var HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
    var HTML_REPLACEMENTS = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;'
    };
    function replaceUnsafeChar(ch) {
      return HTML_REPLACEMENTS[ch];
    }
    function escapeHtml(str) {
      if (HTML_ESCAPE_TEST_RE.test(str)) {
        return str.replace(HTML_ESCAPE_REPLACE_RE, replaceUnsafeChar);
      }
      return str;
    }

    ////////////////////////////////////////////////////////////////////////////////

    var REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
    function escapeRE(str) {
      return str.replace(REGEXP_ESCAPE_RE, '\\$&');
    }

    ////////////////////////////////////////////////////////////////////////////////

    function isSpace(code) {
      switch (code) {
        case 0x09:
        case 0x20:
          return true;
      }
      return false;
    }

    // Zs (unicode class) || [\t\f\v\r\n]
    function isWhiteSpace(code) {
      if (code >= 0x2000 && code <= 0x200A) {
        return true;
      }
      switch (code) {
        case 0x09: // \t
        case 0x0A: // \n
        case 0x0B: // \v
        case 0x0C: // \f
        case 0x0D: // \r
        case 0x20:
        case 0xA0:
        case 0x1680:
        case 0x202F:
        case 0x205F:
        case 0x3000:
          return true;
      }
      return false;
    }

    ////////////////////////////////////////////////////////////////////////////////

    /*eslint-disable max-len*/
    var UNICODE_PUNCT_RE = __webpack_require__(163);

    // Currently without astral characters support.
    function isPunctChar(ch) {
      return UNICODE_PUNCT_RE.test(ch);
    }

    // Markdown ASCII punctuation characters.
    //
    // !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
    // http://spec.commonmark.org/0.15/#ascii-punctuation-character
    //
    // Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
    //
    function isMdAsciiPunct(ch) {
      switch (ch) {
        case 0x21 /* ! */:
        case 0x22 /* " */:
        case 0x23 /* # */:
        case 0x24 /* $ */:
        case 0x25 /* % */:
        case 0x26 /* & */:
        case 0x27 /* ' */:
        case 0x28 /* ( */:
        case 0x29 /* ) */:
        case 0x2A /* * */:
        case 0x2B /* + */:
        case 0x2C /* , */:
        case 0x2D /* - */:
        case 0x2E /* . */:
        case 0x2F /* / */:
        case 0x3A /* : */:
        case 0x3B /* ; */:
        case 0x3C /* < */:
        case 0x3D /* = */:
        case 0x3E /* > */:
        case 0x3F /* ? */:
        case 0x40 /* @ */:
        case 0x5B /* [ */:
        case 0x5C /* \ */:
        case 0x5D /* ] */:
        case 0x5E /* ^ */:
        case 0x5F /* _ */:
        case 0x60 /* ` */:
        case 0x7B /* { */:
        case 0x7C /* | */:
        case 0x7D /* } */:
        case 0x7E /* ~ */:
          return true;
        default:
          return false;
      }
    }

    // Hepler to unify [reference labels].
    //
    function normalizeReference(str) {
      // use .toUpperCase() instead of .toLowerCase()
      // here to avoid a conflict with Object.prototype
      // members (most notably, `__proto__`)
      return str.trim().replace(/\s+/g, ' ').toUpperCase();
    }

    ////////////////////////////////////////////////////////////////////////////////

    // Re-export libraries commonly used in both markdown-it and its plugins,
    // so plugins won't have to depend on them explicitly, which reduces their
    // bundled size (e.g. a browser build).
    //
    exports.lib = {};
    exports.lib.mdurl = __webpack_require__(216);
    exports.lib.ucmicro = __webpack_require__(694);
    exports.assign = assign;
    exports.isString = isString;
    exports.has = has;
    exports.unescapeMd = unescapeMd;
    exports.unescapeAll = unescapeAll;
    exports.isValidEntityCode = isValidEntityCode;
    exports.fromCodePoint = fromCodePoint;
    // exports.replaceEntities     = replaceEntities;
    exports.escapeHtml = escapeHtml;
    exports.arrayReplaceAt = arrayReplaceAt;
    exports.isSpace = isSpace;
    exports.isWhiteSpace = isWhiteSpace;
    exports.isMdAsciiPunct = isMdAsciiPunct;
    exports.isPunctChar = isPunctChar;
    exports.escapeRE = escapeRE;
    exports.normalizeReference = normalizeReference;

    /***/
  }), ( /* 2 */
  /***/function (module, exports, __webpack_require__) {
    /**
     *  Copyright (c) 2014-2015, Facebook, Inc.
     *  All rights reserved.
     *
     *  This source code is licensed under the BSD-style license found in the
     *  LICENSE file in the root directory of this source tree. An additional grant
     *  of patent rights can be found in the PATENTS file in the same directory.
     */

    (function (global, factory) {
      true ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : global.Immutable = factory();
    })(this, function () {
      'use strict';

      var SLICE$0 = Array.prototype.slice;
      function createClass(ctor, superClass) {
        if (superClass) {
          ctor.prototype = Object.create(superClass.prototype);
        }
        ctor.prototype.constructor = ctor;
      }
      function Iterable(value) {
        return isIterable(value) ? value : Seq(value);
      }
      createClass(KeyedIterable, Iterable);
      function KeyedIterable(value) {
        return isKeyed(value) ? value : KeyedSeq(value);
      }
      createClass(IndexedIterable, Iterable);
      function IndexedIterable(value) {
        return isIndexed(value) ? value : IndexedSeq(value);
      }
      createClass(SetIterable, Iterable);
      function SetIterable(value) {
        return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
      }
      function isIterable(maybeIterable) {
        return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
      }
      function isKeyed(maybeKeyed) {
        return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
      }
      function isIndexed(maybeIndexed) {
        return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
      }
      function isAssociative(maybeAssociative) {
        return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
      }
      function isOrdered(maybeOrdered) {
        return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
      }
      Iterable.isIterable = isIterable;
      Iterable.isKeyed = isKeyed;
      Iterable.isIndexed = isIndexed;
      Iterable.isAssociative = isAssociative;
      Iterable.isOrdered = isOrdered;
      Iterable.Keyed = KeyedIterable;
      Iterable.Indexed = IndexedIterable;
      Iterable.Set = SetIterable;
      var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
      var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
      var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
      var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

      // Used for setting prototype methods that IE8 chokes on.
      var DELETE = 'delete';

      // Constants describing the size of trie nodes.
      var SHIFT = 5; // Resulted in best performance after ______?
      var SIZE = 1 << SHIFT;
      var MASK = SIZE - 1;

      // A consistent shared value representing "not set" which equals nothing other
      // than itself, and nothing that could be provided externally.
      var NOT_SET = {};

      // Boolean references, Rough equivalent of `bool &`.
      var CHANGE_LENGTH = {
        value: false
      };
      var DID_ALTER = {
        value: false
      };
      function MakeRef(ref) {
        ref.value = false;
        return ref;
      }
      function SetRef(ref) {
        ref && (ref.value = true);
      }

      // A function which returns a value representing an "owner" for transient writes
      // to tries. The return value will only ever equal itself, and will not equal
      // the return of any subsequent call of this function.
      function OwnerID() {}

      // http://jsperf.com/copy-array-inline
      function arrCopy(arr, offset) {
        offset = offset || 0;
        var len = Math.max(0, arr.length - offset);
        var newArr = new Array(len);
        for (var ii = 0; ii < len; ii++) {
          newArr[ii] = arr[ii + offset];
        }
        return newArr;
      }
      function ensureSize(iter) {
        if (iter.size === undefined) {
          iter.size = iter.__iterate(returnTrue);
        }
        return iter.size;
      }
      function wrapIndex(iter, index) {
        // This implements "is array index" which the ECMAString spec defines as:
        //
        //     A String property name P is an array index if and only if
        //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
        //     to 2^32−1.
        //
        // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
        if (typeof index !== 'number') {
          var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
          if ('' + uint32Index !== index || uint32Index === 4294967295) {
            return NaN;
          }
          index = uint32Index;
        }
        return index < 0 ? ensureSize(iter) + index : index;
      }
      function returnTrue() {
        return true;
      }
      function wholeSlice(begin, end, size) {
        return (begin === 0 || size !== undefined && begin <= -size) && (end === undefined || size !== undefined && end >= size);
      }
      function resolveBegin(begin, size) {
        return resolveIndex(begin, size, 0);
      }
      function resolveEnd(end, size) {
        return resolveIndex(end, size, size);
      }
      function resolveIndex(index, size, defaultIndex) {
        return index === undefined ? defaultIndex : index < 0 ? Math.max(0, size + index) : size === undefined ? index : Math.min(size, index);
      }

      /* global Symbol */

      var ITERATE_KEYS = 0;
      var ITERATE_VALUES = 1;
      var ITERATE_ENTRIES = 2;
      var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = '@@iterator';
      var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
      function Iterator(next) {
        this.next = next;
      }
      Iterator.prototype.toString = function () {
        return '[Iterator]';
      };
      Iterator.KEYS = ITERATE_KEYS;
      Iterator.VALUES = ITERATE_VALUES;
      Iterator.ENTRIES = ITERATE_ENTRIES;
      Iterator.prototype.inspect = Iterator.prototype.toSource = function () {
        return this.toString();
      };
      Iterator.prototype[ITERATOR_SYMBOL] = function () {
        return this;
      };
      function iteratorValue(type, k, v, iteratorResult) {
        var value = type === 0 ? k : type === 1 ? v : [k, v];
        iteratorResult ? iteratorResult.value = value : iteratorResult = {
          value: value,
          done: false
        };
        return iteratorResult;
      }
      function iteratorDone() {
        return {
          value: undefined,
          done: true
        };
      }
      function hasIterator(maybeIterable) {
        return !!getIteratorFn(maybeIterable);
      }
      function isIterator(maybeIterator) {
        return maybeIterator && typeof maybeIterator.next === 'function';
      }
      function getIterator(iterable) {
        var iteratorFn = getIteratorFn(iterable);
        return iteratorFn && iteratorFn.call(iterable);
      }
      function getIteratorFn(iterable) {
        var iteratorFn = iterable && (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL] || iterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === 'function') {
          return iteratorFn;
        }
      }
      function isArrayLike(value) {
        return value && typeof value.length === 'number';
      }
      createClass(Seq, Iterable);
      function Seq(value) {
        return value === null || value === undefined ? emptySequence() : isIterable(value) ? value.toSeq() : seqFromValue(value);
      }
      Seq.of = function /*...values*/
      () {
        return Seq(arguments);
      };
      Seq.prototype.toSeq = function () {
        return this;
      };
      Seq.prototype.toString = function () {
        return this.__toString('Seq {', '}');
      };
      Seq.prototype.cacheResult = function () {
        if (!this._cache && this.__iterateUncached) {
          this._cache = this.entrySeq().toArray();
          this.size = this._cache.length;
        }
        return this;
      };

      // abstract __iterateUncached(fn, reverse)

      Seq.prototype.__iterate = function (fn, reverse) {
        return seqIterate(this, fn, reverse, true);
      };

      // abstract __iteratorUncached(type, reverse)

      Seq.prototype.__iterator = function (type, reverse) {
        return seqIterator(this, type, reverse, true);
      };
      createClass(KeyedSeq, Seq);
      function KeyedSeq(value) {
        return value === null || value === undefined ? emptySequence().toKeyedSeq() : isIterable(value) ? isKeyed(value) ? value.toSeq() : value.fromEntrySeq() : keyedSeqFromValue(value);
      }
      KeyedSeq.prototype.toKeyedSeq = function () {
        return this;
      };
      createClass(IndexedSeq, Seq);
      function IndexedSeq(value) {
        return value === null || value === undefined ? emptySequence() : !isIterable(value) ? indexedSeqFromValue(value) : isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
      }
      IndexedSeq.of = function /*...values*/
      () {
        return IndexedSeq(arguments);
      };
      IndexedSeq.prototype.toIndexedSeq = function () {
        return this;
      };
      IndexedSeq.prototype.toString = function () {
        return this.__toString('Seq [', ']');
      };
      IndexedSeq.prototype.__iterate = function (fn, reverse) {
        return seqIterate(this, fn, reverse, false);
      };
      IndexedSeq.prototype.__iterator = function (type, reverse) {
        return seqIterator(this, type, reverse, false);
      };
      createClass(SetSeq, Seq);
      function SetSeq(value) {
        return (value === null || value === undefined ? emptySequence() : !isIterable(value) ? indexedSeqFromValue(value) : isKeyed(value) ? value.entrySeq() : value).toSetSeq();
      }
      SetSeq.of = function /*...values*/
      () {
        return SetSeq(arguments);
      };
      SetSeq.prototype.toSetSeq = function () {
        return this;
      };
      Seq.isSeq = isSeq;
      Seq.Keyed = KeyedSeq;
      Seq.Set = SetSeq;
      Seq.Indexed = IndexedSeq;
      var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
      Seq.prototype[IS_SEQ_SENTINEL] = true;
      createClass(ArraySeq, IndexedSeq);
      function ArraySeq(array) {
        this._array = array;
        this.size = array.length;
      }
      ArraySeq.prototype.get = function (index, notSetValue) {
        return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
      };
      ArraySeq.prototype.__iterate = function (fn, reverse) {
        var array = this._array;
        var maxIndex = array.length - 1;
        for (var ii = 0; ii <= maxIndex; ii++) {
          if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
            return ii + 1;
          }
        }
        return ii;
      };
      ArraySeq.prototype.__iterator = function (type, reverse) {
        var array = this._array;
        var maxIndex = array.length - 1;
        var ii = 0;
        return new Iterator(function () {
          return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++]);
        });
      };
      createClass(ObjectSeq, KeyedSeq);
      function ObjectSeq(object) {
        var keys = Object.keys(object);
        this._object = object;
        this._keys = keys;
        this.size = keys.length;
      }
      ObjectSeq.prototype.get = function (key, notSetValue) {
        if (notSetValue !== undefined && !this.has(key)) {
          return notSetValue;
        }
        return this._object[key];
      };
      ObjectSeq.prototype.has = function (key) {
        return this._object.hasOwnProperty(key);
      };
      ObjectSeq.prototype.__iterate = function (fn, reverse) {
        var object = this._object;
        var keys = this._keys;
        var maxIndex = keys.length - 1;
        for (var ii = 0; ii <= maxIndex; ii++) {
          var key = keys[reverse ? maxIndex - ii : ii];
          if (fn(object[key], key, this) === false) {
            return ii + 1;
          }
        }
        return ii;
      };
      ObjectSeq.prototype.__iterator = function (type, reverse) {
        var object = this._object;
        var keys = this._keys;
        var maxIndex = keys.length - 1;
        var ii = 0;
        return new Iterator(function () {
          var key = keys[reverse ? maxIndex - ii : ii];
          return ii++ > maxIndex ? iteratorDone() : iteratorValue(type, key, object[key]);
        });
      };
      ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
      createClass(IterableSeq, IndexedSeq);
      function IterableSeq(iterable) {
        this._iterable = iterable;
        this.size = iterable.length || iterable.size;
      }
      IterableSeq.prototype.__iterateUncached = function (fn, reverse) {
        if (reverse) {
          return this.cacheResult().__iterate(fn, reverse);
        }
        var iterable = this._iterable;
        var iterator = getIterator(iterable);
        var iterations = 0;
        if (isIterator(iterator)) {
          var step;
          while (!(step = iterator.next()).done) {
            if (fn(step.value, iterations++, this) === false) {
              break;
            }
          }
        }
        return iterations;
      };
      IterableSeq.prototype.__iteratorUncached = function (type, reverse) {
        if (reverse) {
          return this.cacheResult().__iterator(type, reverse);
        }
        var iterable = this._iterable;
        var iterator = getIterator(iterable);
        if (!isIterator(iterator)) {
          return new Iterator(iteratorDone);
        }
        var iterations = 0;
        return new Iterator(function () {
          var step = iterator.next();
          return step.done ? step : iteratorValue(type, iterations++, step.value);
        });
      };
      createClass(IteratorSeq, IndexedSeq);
      function IteratorSeq(iterator) {
        this._iterator = iterator;
        this._iteratorCache = [];
      }
      IteratorSeq.prototype.__iterateUncached = function (fn, reverse) {
        if (reverse) {
          return this.cacheResult().__iterate(fn, reverse);
        }
        var iterator = this._iterator;
        var cache = this._iteratorCache;
        var iterations = 0;
        while (iterations < cache.length) {
          if (fn(cache[iterations], iterations++, this) === false) {
            return iterations;
          }
        }
        var step;
        while (!(step = iterator.next()).done) {
          var val = step.value;
          cache[iterations] = val;
          if (fn(val, iterations++, this) === false) {
            break;
          }
        }
        return iterations;
      };
      IteratorSeq.prototype.__iteratorUncached = function (type, reverse) {
        if (reverse) {
          return this.cacheResult().__iterator(type, reverse);
        }
        var iterator = this._iterator;
        var cache = this._iteratorCache;
        var iterations = 0;
        return new Iterator(function () {
          if (iterations >= cache.length) {
            var step = iterator.next();
            if (step.done) {
              return step;
            }
            cache[iterations] = step.value;
          }
          return iteratorValue(type, iterations, cache[iterations++]);
        });
      };

      // # pragma Helper functions

      function isSeq(maybeSeq) {
        return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
      }
      var EMPTY_SEQ;
      function emptySequence() {
        return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
      }
      function keyedSeqFromValue(value) {
        var seq = Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() : isIterator(value) ? new IteratorSeq(value).fromEntrySeq() : hasIterator(value) ? new IterableSeq(value).fromEntrySeq() : typeof value === 'object' ? new ObjectSeq(value) : undefined;
        if (!seq) {
          throw new TypeError('Expected Array or iterable object of [k, v] entries, ' + 'or keyed object: ' + value);
        }
        return seq;
      }
      function indexedSeqFromValue(value) {
        var seq = maybeIndexedSeqFromValue(value);
        if (!seq) {
          throw new TypeError('Expected Array or iterable object of values: ' + value);
        }
        return seq;
      }
      function seqFromValue(value) {
        var seq = maybeIndexedSeqFromValue(value) || typeof value === 'object' && new ObjectSeq(value);
        if (!seq) {
          throw new TypeError('Expected Array or iterable object of values, or keyed object: ' + value);
        }
        return seq;
      }
      function maybeIndexedSeqFromValue(value) {
        return isArrayLike(value) ? new ArraySeq(value) : isIterator(value) ? new IteratorSeq(value) : hasIterator(value) ? new IterableSeq(value) : undefined;
      }
      function seqIterate(seq, fn, reverse, useKeys) {
        var cache = seq._cache;
        if (cache) {
          var maxIndex = cache.length - 1;
          for (var ii = 0; ii <= maxIndex; ii++) {
            var entry = cache[reverse ? maxIndex - ii : ii];
            if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
              return ii + 1;
            }
          }
          return ii;
        }
        return seq.__iterateUncached(fn, reverse);
      }
      function seqIterator(seq, type, reverse, useKeys) {
        var cache = seq._cache;
        if (cache) {
          var maxIndex = cache.length - 1;
          var ii = 0;
          return new Iterator(function () {
            var entry = cache[reverse ? maxIndex - ii : ii];
            return ii++ > maxIndex ? iteratorDone() : iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
          });
        }
        return seq.__iteratorUncached(type, reverse);
      }
      function fromJS(json, converter) {
        return converter ? fromJSWith(converter, json, '', {
          '': json
        }) : fromJSDefault(json);
      }
      function fromJSWith(converter, json, key, parentJSON) {
        if (Array.isArray(json)) {
          return converter.call(parentJSON, key, IndexedSeq(json).map(function (v, k) {
            return fromJSWith(converter, v, k, json);
          }));
        }
        if (isPlainObj(json)) {
          return converter.call(parentJSON, key, KeyedSeq(json).map(function (v, k) {
            return fromJSWith(converter, v, k, json);
          }));
        }
        return json;
      }
      function fromJSDefault(json) {
        if (Array.isArray(json)) {
          return IndexedSeq(json).map(fromJSDefault).toList();
        }
        if (isPlainObj(json)) {
          return KeyedSeq(json).map(fromJSDefault).toMap();
        }
        return json;
      }
      function isPlainObj(value) {
        return value && (value.constructor === Object || value.constructor === undefined);
      }

      /**
       * An extension of the "same-value" algorithm as [described for use by ES6 Map
       * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
       *
       * NaN is considered the same as NaN, however -0 and 0 are considered the same
       * value, which is different from the algorithm described by
       * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
       *
       * This is extended further to allow Objects to describe the values they
       * represent, by way of `valueOf` or `equals` (and `hashCode`).
       *
       * Note: because of this extension, the key equality of Immutable.Map and the
       * value equality of Immutable.Set will differ from ES6 Map and Set.
       *
       * ### Defining custom values
       *
       * The easiest way to describe the value an object represents is by implementing
       * `valueOf`. For example, `Date` represents a value by returning a unix
       * timestamp for `valueOf`:
       *
       *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
       *     var date2 = new Date(1234567890000);
       *     date1.valueOf(); // 1234567890000
       *     assert( date1 !== date2 );
       *     assert( Immutable.is( date1, date2 ) );
       *
       * Note: overriding `valueOf` may have other implications if you use this object
       * where JavaScript expects a primitive, such as implicit string coercion.
       *
       * For more complex types, especially collections, implementing `valueOf` may
       * not be performant. An alternative is to implement `equals` and `hashCode`.
       *
       * `equals` takes another object, presumably of similar type, and returns true
       * if the it is equal. Equality is symmetrical, so the same result should be
       * returned if this and the argument are flipped.
       *
       *     assert( a.equals(b) === b.equals(a) );
       *
       * `hashCode` returns a 32bit integer number representing the object which will
       * be used to determine how to store the value object in a Map or Set. You must
       * provide both or neither methods, one must not exist without the other.
       *
       * Also, an important relationship between these methods must be upheld: if two
       * values are equal, they *must* return the same hashCode. If the values are not
       * equal, they might have the same hashCode; this is called a hash collision,
       * and while undesirable for performance reasons, it is acceptable.
       *
       *     if (a.equals(b)) {
       *       assert( a.hashCode() === b.hashCode() );
       *     }
       *
       * All Immutable collections implement `equals` and `hashCode`.
       *
       */
      function is(valueA, valueB) {
        if (valueA === valueB || valueA !== valueA && valueB !== valueB) {
          return true;
        }
        if (!valueA || !valueB) {
          return false;
        }
        if (typeof valueA.valueOf === 'function' && typeof valueB.valueOf === 'function') {
          valueA = valueA.valueOf();
          valueB = valueB.valueOf();
          if (valueA === valueB || valueA !== valueA && valueB !== valueB) {
            return true;
          }
          if (!valueA || !valueB) {
            return false;
          }
        }
        if (typeof valueA.equals === 'function' && typeof valueB.equals === 'function' && valueA.equals(valueB)) {
          return true;
        }
        return false;
      }
      function deepEqual(a, b) {
        if (a === b) {
          return true;
        }
        if (!isIterable(b) || a.size !== undefined && b.size !== undefined && a.size !== b.size || a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash || isKeyed(a) !== isKeyed(b) || isIndexed(a) !== isIndexed(b) || isOrdered(a) !== isOrdered(b)) {
          return false;
        }
        if (a.size === 0 && b.size === 0) {
          return true;
        }
        var notAssociative = !isAssociative(a);
        if (isOrdered(a)) {
          var entries = a.entries();
          return b.every(function (v, k) {
            var entry = entries.next().value;
            return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
          }) && entries.next().done;
        }
        var flipped = false;
        if (a.size === undefined) {
          if (b.size === undefined) {
            if (typeof a.cacheResult === 'function') {
              a.cacheResult();
            }
          } else {
            flipped = true;
            var _ = a;
            a = b;
            b = _;
          }
        }
        var allEqual = true;
        var bSize = b.__iterate(function (v, k) {
          if (notAssociative ? !a.has(v) : flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
            allEqual = false;
            return false;
          }
        });
        return allEqual && a.size === bSize;
      }
      createClass(Repeat, IndexedSeq);
      function Repeat(value, times) {
        if (!(this instanceof Repeat)) {
          return new Repeat(value, times);
        }
        this._value = value;
        this.size = times === undefined ? Infinity : Math.max(0, times);
        if (this.size === 0) {
          if (EMPTY_REPEAT) {
            return EMPTY_REPEAT;
          }
          EMPTY_REPEAT = this;
        }
      }
      Repeat.prototype.toString = function () {
        if (this.size === 0) {
          return 'Repeat []';
        }
        return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
      };
      Repeat.prototype.get = function (index, notSetValue) {
        return this.has(index) ? this._value : notSetValue;
      };
      Repeat.prototype.includes = function (searchValue) {
        return is(this._value, searchValue);
      };
      Repeat.prototype.slice = function (begin, end) {
        var size = this.size;
        return wholeSlice(begin, end, size) ? this : new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
      };
      Repeat.prototype.reverse = function () {
        return this;
      };
      Repeat.prototype.indexOf = function (searchValue) {
        if (is(this._value, searchValue)) {
          return 0;
        }
        return -1;
      };
      Repeat.prototype.lastIndexOf = function (searchValue) {
        if (is(this._value, searchValue)) {
          return this.size;
        }
        return -1;
      };
      Repeat.prototype.__iterate = function (fn, reverse) {
        for (var ii = 0; ii < this.size; ii++) {
          if (fn(this._value, ii, this) === false) {
            return ii + 1;
          }
        }
        return ii;
      };
      Repeat.prototype.__iterator = function (type, reverse) {
        var this$0 = this;
        var ii = 0;
        return new Iterator(function () {
          return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone();
        });
      };
      Repeat.prototype.equals = function (other) {
        return other instanceof Repeat ? is(this._value, other._value) : deepEqual(other);
      };
      var EMPTY_REPEAT;
      function invariant(condition, error) {
        if (!condition) throw new Error(error);
      }
      createClass(Range, IndexedSeq);
      function Range(start, end, step) {
        if (!(this instanceof Range)) {
          return new Range(start, end, step);
        }
        invariant(step !== 0, 'Cannot step a Range by 0');
        start = start || 0;
        if (end === undefined) {
          end = Infinity;
        }
        step = step === undefined ? 1 : Math.abs(step);
        if (end < start) {
          step = -step;
        }
        this._start = start;
        this._end = end;
        this._step = step;
        this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
        if (this.size === 0) {
          if (EMPTY_RANGE) {
            return EMPTY_RANGE;
          }
          EMPTY_RANGE = this;
        }
      }
      Range.prototype.toString = function () {
        if (this.size === 0) {
          return 'Range []';
        }
        return 'Range [ ' + this._start + '...' + this._end + (this._step !== 1 ? ' by ' + this._step : '') + ' ]';
      };
      Range.prototype.get = function (index, notSetValue) {
        return this.has(index) ? this._start + wrapIndex(this, index) * this._step : notSetValue;
      };
      Range.prototype.includes = function (searchValue) {
        var possibleIndex = (searchValue - this._start) / this._step;
        return possibleIndex >= 0 && possibleIndex < this.size && possibleIndex === Math.floor(possibleIndex);
      };
      Range.prototype.slice = function (begin, end) {
        if (wholeSlice(begin, end, this.size)) {
          return this;
        }
        begin = resolveBegin(begin, this.size);
        end = resolveEnd(end, this.size);
        if (end <= begin) {
          return new Range(0, 0);
        }
        return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
      };
      Range.prototype.indexOf = function (searchValue) {
        var offsetValue = searchValue - this._start;
        if (offsetValue % this._step === 0) {
          var index = offsetValue / this._step;
          if (index >= 0 && index < this.size) {
            return index;
          }
        }
        return -1;
      };
      Range.prototype.lastIndexOf = function (searchValue) {
        return this.indexOf(searchValue);
      };
      Range.prototype.__iterate = function (fn, reverse) {
        var maxIndex = this.size - 1;
        var step = this._step;
        var value = reverse ? this._start + maxIndex * step : this._start;
        for (var ii = 0; ii <= maxIndex; ii++) {
          if (fn(value, ii, this) === false) {
            return ii + 1;
          }
          value += reverse ? -step : step;
        }
        return ii;
      };
      Range.prototype.__iterator = function (type, reverse) {
        var maxIndex = this.size - 1;
        var step = this._step;
        var value = reverse ? this._start + maxIndex * step : this._start;
        var ii = 0;
        return new Iterator(function () {
          var v = value;
          value += reverse ? -step : step;
          return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
        });
      };
      Range.prototype.equals = function (other) {
        return other instanceof Range ? this._start === other._start && this._end === other._end && this._step === other._step : deepEqual(this, other);
      };
      var EMPTY_RANGE;
      createClass(Collection, Iterable);
      function Collection() {
        throw TypeError('Abstract');
      }
      createClass(KeyedCollection, Collection);
      function KeyedCollection() {}
      createClass(IndexedCollection, Collection);
      function IndexedCollection() {}
      createClass(SetCollection, Collection);
      function SetCollection() {}
      Collection.Keyed = KeyedCollection;
      Collection.Indexed = IndexedCollection;
      Collection.Set = SetCollection;
      var imul = typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ? Math.imul : function imul(a, b) {
        a = a | 0; // int
        b = b | 0; // int
        var c = a & 0xffff;
        var d = b & 0xffff;
        // Shift by 0 fixes the sign on the high part.
        return c * d + ((a >>> 16) * d + c * (b >>> 16) << 16 >>> 0) | 0; // int
      };

      // v8 has an optimization for storing 31-bit signed numbers.
      // Values which have either 00 or 11 as the high order bits qualify.
      // This function drops the highest order bit in a signed number, maintaining
      // the sign bit.
      function smi(i32) {
        return i32 >>> 1 & 0x40000000 | i32 & 0xBFFFFFFF;
      }
      function hash(o) {
        if (o === false || o === null || o === undefined) {
          return 0;
        }
        if (typeof o.valueOf === 'function') {
          o = o.valueOf();
          if (o === false || o === null || o === undefined) {
            return 0;
          }
        }
        if (o === true) {
          return 1;
        }
        var type = typeof o;
        if (type === 'number') {
          if (o !== o || o === Infinity) {
            return 0;
          }
          var h = o | 0;
          if (h !== o) {
            h ^= o * 0xFFFFFFFF;
          }
          while (o > 0xFFFFFFFF) {
            o /= 0xFFFFFFFF;
            h ^= o;
          }
          return smi(h);
        }
        if (type === 'string') {
          return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
        }
        if (typeof o.hashCode === 'function') {
          return o.hashCode();
        }
        if (type === 'object') {
          return hashJSObj(o);
        }
        if (typeof o.toString === 'function') {
          return hashString(o.toString());
        }
        throw new Error('Value type ' + type + ' cannot be hashed.');
      }
      function cachedHashString(string) {
        var hash = stringHashCache[string];
        if (hash === undefined) {
          hash = hashString(string);
          if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
            STRING_HASH_CACHE_SIZE = 0;
            stringHashCache = {};
          }
          STRING_HASH_CACHE_SIZE++;
          stringHashCache[string] = hash;
        }
        return hash;
      }

      // http://jsperf.com/hashing-strings
      function hashString(string) {
        // This is the hash from JVM
        // The hash code for a string is computed as
        // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
        // where s[i] is the ith character of the string and n is the length of
        // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
        // (exclusive) by dropping high bits.
        var hash = 0;
        for (var ii = 0; ii < string.length; ii++) {
          hash = 31 * hash + string.charCodeAt(ii) | 0;
        }
        return smi(hash);
      }
      function hashJSObj(obj) {
        var hash;
        if (usingWeakMap) {
          hash = weakMap.get(obj);
          if (hash !== undefined) {
            return hash;
          }
        }
        hash = obj[UID_HASH_KEY];
        if (hash !== undefined) {
          return hash;
        }
        if (!canDefineProperty) {
          hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
          if (hash !== undefined) {
            return hash;
          }
          hash = getIENodeHash(obj);
          if (hash !== undefined) {
            return hash;
          }
        }
        hash = ++objHashUID;
        if (objHashUID & 0x40000000) {
          objHashUID = 0;
        }
        if (usingWeakMap) {
          weakMap.set(obj, hash);
        } else if (isExtensible !== undefined && isExtensible(obj) === false) {
          throw new Error('Non-extensible objects are not allowed as keys.');
        } else if (canDefineProperty) {
          Object.defineProperty(obj, UID_HASH_KEY, {
            'enumerable': false,
            'configurable': false,
            'writable': false,
            'value': hash
          });
        } else if (obj.propertyIsEnumerable !== undefined && obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
          // Since we can't define a non-enumerable property on the object
          // we'll hijack one of the less-used non-enumerable properties to
          // save our hash on it. Since this is a function it will not show up in
          // `JSON.stringify` which is what we want.
          obj.propertyIsEnumerable = function () {
            return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
          };
          obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
        } else if (obj.nodeType !== undefined) {
          // At this point we couldn't get the IE `uniqueID` to use as a hash
          // and we couldn't use a non-enumerable property to exploit the
          // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
          // itself.
          obj[UID_HASH_KEY] = hash;
        } else {
          throw new Error('Unable to set a non-enumerable property on object.');
        }
        return hash;
      }

      // Get references to ES5 object methods.
      var isExtensible = Object.isExtensible;

      // True if Object.defineProperty works as expected. IE8 fails this test.
      var canDefineProperty = function () {
        try {
          Object.defineProperty({}, '@', {});
          return true;
        } catch (e) {
          return false;
        }
      }();

      // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
      // and avoid memory leaks from the IE cloneNode bug.
      function getIENodeHash(node) {
        if (node && node.nodeType > 0) {
          switch (node.nodeType) {
            case 1:
              // Element
              return node.uniqueID;
            case 9:
              // Document
              return node.documentElement && node.documentElement.uniqueID;
          }
        }
      }

      // If possible, use a WeakMap.
      var usingWeakMap = typeof WeakMap === 'function';
      var weakMap;
      if (usingWeakMap) {
        weakMap = new WeakMap();
      }
      var objHashUID = 0;
      var UID_HASH_KEY = '__immutablehash__';
      if (typeof Symbol === 'function') {
        UID_HASH_KEY = Symbol(UID_HASH_KEY);
      }
      var STRING_HASH_CACHE_MIN_STRLEN = 16;
      var STRING_HASH_CACHE_MAX_SIZE = 255;
      var STRING_HASH_CACHE_SIZE = 0;
      var stringHashCache = {};
      function assertNotInfinite(size) {
        invariant(size !== Infinity, 'Cannot perform this action with an infinite size.');
      }
      createClass(Map, KeyedCollection);

      // @pragma Construction

      function Map(value) {
        return value === null || value === undefined ? emptyMap() : isMap(value) && !isOrdered(value) ? value : emptyMap().withMutations(function (map) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function (v, k) {
            return map.set(k, v);
          });
        });
      }
      Map.of = function () {
        var keyValues = SLICE$0.call(arguments, 0);
        return emptyMap().withMutations(function (map) {
          for (var i = 0; i < keyValues.length; i += 2) {
            if (i + 1 >= keyValues.length) {
              throw new Error('Missing value for key: ' + keyValues[i]);
            }
            map.set(keyValues[i], keyValues[i + 1]);
          }
        });
      };
      Map.prototype.toString = function () {
        return this.__toString('Map {', '}');
      };

      // @pragma Access

      Map.prototype.get = function (k, notSetValue) {
        return this._root ? this._root.get(0, undefined, k, notSetValue) : notSetValue;
      };

      // @pragma Modification

      Map.prototype.set = function (k, v) {
        return updateMap(this, k, v);
      };
      Map.prototype.setIn = function (keyPath, v) {
        return this.updateIn(keyPath, NOT_SET, function () {
          return v;
        });
      };
      Map.prototype.remove = function (k) {
        return updateMap(this, k, NOT_SET);
      };
      Map.prototype.deleteIn = function (keyPath) {
        return this.updateIn(keyPath, function () {
          return NOT_SET;
        });
      };
      Map.prototype.update = function (k, notSetValue, updater) {
        return arguments.length === 1 ? k(this) : this.updateIn([k], notSetValue, updater);
      };
      Map.prototype.updateIn = function (keyPath, notSetValue, updater) {
        if (!updater) {
          updater = notSetValue;
          notSetValue = undefined;
        }
        var updatedValue = updateInDeepMap(this, forceIterator(keyPath), notSetValue, updater);
        return updatedValue === NOT_SET ? undefined : updatedValue;
      };
      Map.prototype.clear = function () {
        if (this.size === 0) {
          return this;
        }
        if (this.__ownerID) {
          this.size = 0;
          this._root = null;
          this.__hash = undefined;
          this.__altered = true;
          return this;
        }
        return emptyMap();
      };

      // @pragma Composition

      Map.prototype.merge = function /*...iters*/
      () {
        return mergeIntoMapWith(this, undefined, arguments);
      };
      Map.prototype.mergeWith = function (merger) {
        var iters = SLICE$0.call(arguments, 1);
        return mergeIntoMapWith(this, merger, iters);
      };
      Map.prototype.mergeIn = function (keyPath) {
        var iters = SLICE$0.call(arguments, 1);
        return this.updateIn(keyPath, emptyMap(), function (m) {
          return typeof m.merge === 'function' ? m.merge.apply(m, iters) : iters[iters.length - 1];
        });
      };
      Map.prototype.mergeDeep = function /*...iters*/
      () {
        return mergeIntoMapWith(this, deepMerger, arguments);
      };
      Map.prototype.mergeDeepWith = function (merger) {
        var iters = SLICE$0.call(arguments, 1);
        return mergeIntoMapWith(this, deepMergerWith(merger), iters);
      };
      Map.prototype.mergeDeepIn = function (keyPath) {
        var iters = SLICE$0.call(arguments, 1);
        return this.updateIn(keyPath, emptyMap(), function (m) {
          return typeof m.mergeDeep === 'function' ? m.mergeDeep.apply(m, iters) : iters[iters.length - 1];
        });
      };
      Map.prototype.sort = function (comparator) {
        // Late binding
        return OrderedMap(sortFactory(this, comparator));
      };
      Map.prototype.sortBy = function (mapper, comparator) {
        // Late binding
        return OrderedMap(sortFactory(this, comparator, mapper));
      };

      // @pragma Mutability

      Map.prototype.withMutations = function (fn) {
        var mutable = this.asMutable();
        fn(mutable);
        return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
      };
      Map.prototype.asMutable = function () {
        return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
      };
      Map.prototype.asImmutable = function () {
        return this.__ensureOwner();
      };
      Map.prototype.wasAltered = function () {
        return this.__altered;
      };
      Map.prototype.__iterator = function (type, reverse) {
        return new MapIterator(this, type, reverse);
      };
      Map.prototype.__iterate = function (fn, reverse) {
        var this$0 = this;
        var iterations = 0;
        this._root && this._root.iterate(function (entry) {
          iterations++;
          return fn(entry[1], entry[0], this$0);
        }, reverse);
        return iterations;
      };
      Map.prototype.__ensureOwner = function (ownerID) {
        if (ownerID === this.__ownerID) {
          return this;
        }
        if (!ownerID) {
          this.__ownerID = ownerID;
          this.__altered = false;
          return this;
        }
        return makeMap(this.size, this._root, ownerID, this.__hash);
      };
      function isMap(maybeMap) {
        return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
      }
      Map.isMap = isMap;
      var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
      var MapPrototype = Map.prototype;
      MapPrototype[IS_MAP_SENTINEL] = true;
      MapPrototype[DELETE] = MapPrototype.remove;
      MapPrototype.removeIn = MapPrototype.deleteIn;

      // #pragma Trie Nodes

      function ArrayMapNode(ownerID, entries) {
        this.ownerID = ownerID;
        this.entries = entries;
      }
      ArrayMapNode.prototype.get = function (shift, keyHash, key, notSetValue) {
        var entries = this.entries;
        for (var ii = 0, len = entries.length; ii < len; ii++) {
          if (is(key, entries[ii][0])) {
            return entries[ii][1];
          }
        }
        return notSetValue;
      };
      ArrayMapNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        var removed = value === NOT_SET;
        var entries = this.entries;
        var idx = 0;
        for (var len = entries.length; idx < len; idx++) {
          if (is(key, entries[idx][0])) {
            break;
          }
        }
        var exists = idx < len;
        if (exists ? entries[idx][1] === value : removed) {
          return this;
        }
        SetRef(didAlter);
        (removed || !exists) && SetRef(didChangeSize);
        if (removed && entries.length === 1) {
          return; // undefined
        }
        if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
          return createNodes(ownerID, entries, key, value);
        }
        var isEditable = ownerID && ownerID === this.ownerID;
        var newEntries = isEditable ? entries : arrCopy(entries);
        if (exists) {
          if (removed) {
            idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
          } else {
            newEntries[idx] = [key, value];
          }
        } else {
          newEntries.push([key, value]);
        }
        if (isEditable) {
          this.entries = newEntries;
          return this;
        }
        return new ArrayMapNode(ownerID, newEntries);
      };
      function BitmapIndexedNode(ownerID, bitmap, nodes) {
        this.ownerID = ownerID;
        this.bitmap = bitmap;
        this.nodes = nodes;
      }
      BitmapIndexedNode.prototype.get = function (shift, keyHash, key, notSetValue) {
        if (keyHash === undefined) {
          keyHash = hash(key);
        }
        var bit = 1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK);
        var bitmap = this.bitmap;
        return (bitmap & bit) === 0 ? notSetValue : this.nodes[popCount(bitmap & bit - 1)].get(shift + SHIFT, keyHash, key, notSetValue);
      };
      BitmapIndexedNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        if (keyHash === undefined) {
          keyHash = hash(key);
        }
        var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
        var bit = 1 << keyHashFrag;
        var bitmap = this.bitmap;
        var exists = (bitmap & bit) !== 0;
        if (!exists && value === NOT_SET) {
          return this;
        }
        var idx = popCount(bitmap & bit - 1);
        var nodes = this.nodes;
        var node = exists ? nodes[idx] : undefined;
        var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
        if (newNode === node) {
          return this;
        }
        if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
          return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
        }
        if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
          return nodes[idx ^ 1];
        }
        if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
          return newNode;
        }
        var isEditable = ownerID && ownerID === this.ownerID;
        var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
        var newNodes = exists ? newNode ? setIn(nodes, idx, newNode, isEditable) : spliceOut(nodes, idx, isEditable) : spliceIn(nodes, idx, newNode, isEditable);
        if (isEditable) {
          this.bitmap = newBitmap;
          this.nodes = newNodes;
          return this;
        }
        return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
      };
      function HashArrayMapNode(ownerID, count, nodes) {
        this.ownerID = ownerID;
        this.count = count;
        this.nodes = nodes;
      }
      HashArrayMapNode.prototype.get = function (shift, keyHash, key, notSetValue) {
        if (keyHash === undefined) {
          keyHash = hash(key);
        }
        var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
        var node = this.nodes[idx];
        return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
      };
      HashArrayMapNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        if (keyHash === undefined) {
          keyHash = hash(key);
        }
        var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
        var removed = value === NOT_SET;
        var nodes = this.nodes;
        var node = nodes[idx];
        if (removed && !node) {
          return this;
        }
        var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
        if (newNode === node) {
          return this;
        }
        var newCount = this.count;
        if (!node) {
          newCount++;
        } else if (!newNode) {
          newCount--;
          if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
            return packNodes(ownerID, nodes, newCount, idx);
          }
        }
        var isEditable = ownerID && ownerID === this.ownerID;
        var newNodes = setIn(nodes, idx, newNode, isEditable);
        if (isEditable) {
          this.count = newCount;
          this.nodes = newNodes;
          return this;
        }
        return new HashArrayMapNode(ownerID, newCount, newNodes);
      };
      function HashCollisionNode(ownerID, keyHash, entries) {
        this.ownerID = ownerID;
        this.keyHash = keyHash;
        this.entries = entries;
      }
      HashCollisionNode.prototype.get = function (shift, keyHash, key, notSetValue) {
        var entries = this.entries;
        for (var ii = 0, len = entries.length; ii < len; ii++) {
          if (is(key, entries[ii][0])) {
            return entries[ii][1];
          }
        }
        return notSetValue;
      };
      HashCollisionNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        if (keyHash === undefined) {
          keyHash = hash(key);
        }
        var removed = value === NOT_SET;
        if (keyHash !== this.keyHash) {
          if (removed) {
            return this;
          }
          SetRef(didAlter);
          SetRef(didChangeSize);
          return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
        }
        var entries = this.entries;
        var idx = 0;
        for (var len = entries.length; idx < len; idx++) {
          if (is(key, entries[idx][0])) {
            break;
          }
        }
        var exists = idx < len;
        if (exists ? entries[idx][1] === value : removed) {
          return this;
        }
        SetRef(didAlter);
        (removed || !exists) && SetRef(didChangeSize);
        if (removed && len === 2) {
          return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
        }
        var isEditable = ownerID && ownerID === this.ownerID;
        var newEntries = isEditable ? entries : arrCopy(entries);
        if (exists) {
          if (removed) {
            idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
          } else {
            newEntries[idx] = [key, value];
          }
        } else {
          newEntries.push([key, value]);
        }
        if (isEditable) {
          this.entries = newEntries;
          return this;
        }
        return new HashCollisionNode(ownerID, this.keyHash, newEntries);
      };
      function ValueNode(ownerID, keyHash, entry) {
        this.ownerID = ownerID;
        this.keyHash = keyHash;
        this.entry = entry;
      }
      ValueNode.prototype.get = function (shift, keyHash, key, notSetValue) {
        return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
      };
      ValueNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        var removed = value === NOT_SET;
        var keyMatch = is(key, this.entry[0]);
        if (keyMatch ? value === this.entry[1] : removed) {
          return this;
        }
        SetRef(didAlter);
        if (removed) {
          SetRef(didChangeSize);
          return; // undefined
        }
        if (keyMatch) {
          if (ownerID && ownerID === this.ownerID) {
            this.entry[1] = value;
            return this;
          }
          return new ValueNode(ownerID, this.keyHash, [key, value]);
        }
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
      };

      // #pragma Iterators

      ArrayMapNode.prototype.iterate = HashCollisionNode.prototype.iterate = function (fn, reverse) {
        var entries = this.entries;
        for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
          if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
            return false;
          }
        }
      };
      BitmapIndexedNode.prototype.iterate = HashArrayMapNode.prototype.iterate = function (fn, reverse) {
        var nodes = this.nodes;
        for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
          var node = nodes[reverse ? maxIndex - ii : ii];
          if (node && node.iterate(fn, reverse) === false) {
            return false;
          }
        }
      };
      ValueNode.prototype.iterate = function (fn, reverse) {
        return fn(this.entry);
      };
      createClass(MapIterator, Iterator);
      function MapIterator(map, type, reverse) {
        this._type = type;
        this._reverse = reverse;
        this._stack = map._root && mapIteratorFrame(map._root);
      }
      MapIterator.prototype.next = function () {
        var type = this._type;
        var stack = this._stack;
        while (stack) {
          var node = stack.node;
          var index = stack.index++;
          var maxIndex;
          if (node.entry) {
            if (index === 0) {
              return mapIteratorValue(type, node.entry);
            }
          } else if (node.entries) {
            maxIndex = node.entries.length - 1;
            if (index <= maxIndex) {
              return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
            }
          } else {
            maxIndex = node.nodes.length - 1;
            if (index <= maxIndex) {
              var subNode = node.nodes[this._reverse ? maxIndex - index : index];
              if (subNode) {
                if (subNode.entry) {
                  return mapIteratorValue(type, subNode.entry);
                }
                stack = this._stack = mapIteratorFrame(subNode, stack);
              }
              continue;
            }
          }
          stack = this._stack = this._stack.__prev;
        }
        return iteratorDone();
      };
      function mapIteratorValue(type, entry) {
        return iteratorValue(type, entry[0], entry[1]);
      }
      function mapIteratorFrame(node, prev) {
        return {
          node: node,
          index: 0,
          __prev: prev
        };
      }
      function makeMap(size, root, ownerID, hash) {
        var map = Object.create(MapPrototype);
        map.size = size;
        map._root = root;
        map.__ownerID = ownerID;
        map.__hash = hash;
        map.__altered = false;
        return map;
      }
      var EMPTY_MAP;
      function emptyMap() {
        return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
      }
      function updateMap(map, k, v) {
        var newRoot;
        var newSize;
        if (!map._root) {
          if (v === NOT_SET) {
            return map;
          }
          newSize = 1;
          newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
        } else {
          var didChangeSize = MakeRef(CHANGE_LENGTH);
          var didAlter = MakeRef(DID_ALTER);
          newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
          if (!didAlter.value) {
            return map;
          }
          newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
        }
        if (map.__ownerID) {
          map.size = newSize;
          map._root = newRoot;
          map.__hash = undefined;
          map.__altered = true;
          return map;
        }
        return newRoot ? makeMap(newSize, newRoot) : emptyMap();
      }
      function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        if (!node) {
          if (value === NOT_SET) {
            return node;
          }
          SetRef(didAlter);
          SetRef(didChangeSize);
          return new ValueNode(ownerID, keyHash, [key, value]);
        }
        return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
      }
      function isLeafNode(node) {
        return node.constructor === ValueNode || node.constructor === HashCollisionNode;
      }
      function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
        if (node.keyHash === keyHash) {
          return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
        }
        var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
        var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
        var newNode;
        var nodes = idx1 === idx2 ? [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] : (newNode = new ValueNode(ownerID, keyHash, entry), idx1 < idx2 ? [node, newNode] : [newNode, node]);
        return new BitmapIndexedNode(ownerID, 1 << idx1 | 1 << idx2, nodes);
      }
      function createNodes(ownerID, entries, key, value) {
        if (!ownerID) {
          ownerID = new OwnerID();
        }
        var node = new ValueNode(ownerID, hash(key), [key, value]);
        for (var ii = 0; ii < entries.length; ii++) {
          var entry = entries[ii];
          node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
        }
        return node;
      }
      function packNodes(ownerID, nodes, count, excluding) {
        var bitmap = 0;
        var packedII = 0;
        var packedNodes = new Array(count);
        for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
          var node = nodes[ii];
          if (node !== undefined && ii !== excluding) {
            bitmap |= bit;
            packedNodes[packedII++] = node;
          }
        }
        return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
      }
      function expandNodes(ownerID, nodes, bitmap, including, node) {
        var count = 0;
        var expandedNodes = new Array(SIZE);
        for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
          expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
        }
        expandedNodes[including] = node;
        return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
      }
      function mergeIntoMapWith(map, merger, iterables) {
        var iters = [];
        for (var ii = 0; ii < iterables.length; ii++) {
          var value = iterables[ii];
          var iter = KeyedIterable(value);
          if (!isIterable(value)) {
            iter = iter.map(function (v) {
              return fromJS(v);
            });
          }
          iters.push(iter);
        }
        return mergeIntoCollectionWith(map, merger, iters);
      }
      function deepMerger(existing, value, key) {
        return existing && existing.mergeDeep && isIterable(value) ? existing.mergeDeep(value) : is(existing, value) ? existing : value;
      }
      function deepMergerWith(merger) {
        return function (existing, value, key) {
          if (existing && existing.mergeDeepWith && isIterable(value)) {
            return existing.mergeDeepWith(merger, value);
          }
          var nextValue = merger(existing, value, key);
          return is(existing, nextValue) ? existing : nextValue;
        };
      }
      function mergeIntoCollectionWith(collection, merger, iters) {
        iters = iters.filter(function (x) {
          return x.size !== 0;
        });
        if (iters.length === 0) {
          return collection;
        }
        if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
          return collection.constructor(iters[0]);
        }
        return collection.withMutations(function (collection) {
          var mergeIntoMap = merger ? function (value, key) {
            collection.update(key, NOT_SET, function (existing) {
              return existing === NOT_SET ? value : merger(existing, value, key);
            });
          } : function (value, key) {
            collection.set(key, value);
          };
          for (var ii = 0; ii < iters.length; ii++) {
            iters[ii].forEach(mergeIntoMap);
          }
        });
      }
      function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
        var isNotSet = existing === NOT_SET;
        var step = keyPathIter.next();
        if (step.done) {
          var existingValue = isNotSet ? notSetValue : existing;
          var newValue = updater(existingValue);
          return newValue === existingValue ? existing : newValue;
        }
        invariant(isNotSet || existing && existing.set, 'invalid keyPath');
        var key = step.value;
        var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
        var nextUpdated = updateInDeepMap(nextExisting, keyPathIter, notSetValue, updater);
        return nextUpdated === nextExisting ? existing : nextUpdated === NOT_SET ? existing.remove(key) : (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
      }
      function popCount(x) {
        x = x - (x >> 1 & 0x55555555);
        x = (x & 0x33333333) + (x >> 2 & 0x33333333);
        x = x + (x >> 4) & 0x0f0f0f0f;
        x = x + (x >> 8);
        x = x + (x >> 16);
        return x & 0x7f;
      }
      function setIn(array, idx, val, canEdit) {
        var newArray = canEdit ? array : arrCopy(array);
        newArray[idx] = val;
        return newArray;
      }
      function spliceIn(array, idx, val, canEdit) {
        var newLen = array.length + 1;
        if (canEdit && idx + 1 === newLen) {
          array[idx] = val;
          return array;
        }
        var newArray = new Array(newLen);
        var after = 0;
        for (var ii = 0; ii < newLen; ii++) {
          if (ii === idx) {
            newArray[ii] = val;
            after = -1;
          } else {
            newArray[ii] = array[ii + after];
          }
        }
        return newArray;
      }
      function spliceOut(array, idx, canEdit) {
        var newLen = array.length - 1;
        if (canEdit && idx === newLen) {
          array.pop();
          return array;
        }
        var newArray = new Array(newLen);
        var after = 0;
        for (var ii = 0; ii < newLen; ii++) {
          if (ii === idx) {
            after = 1;
          }
          newArray[ii] = array[ii + after];
        }
        return newArray;
      }
      var MAX_ARRAY_MAP_SIZE = SIZE / 4;
      var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
      var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
      createClass(List, IndexedCollection);

      // @pragma Construction

      function List(value) {
        var empty = emptyList();
        if (value === null || value === undefined) {
          return empty;
        }
        if (isList(value)) {
          return value;
        }
        var iter = IndexedIterable(value);
        var size = iter.size;
        if (size === 0) {
          return empty;
        }
        assertNotInfinite(size);
        if (size > 0 && size < SIZE) {
          return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
        }
        return empty.withMutations(function (list) {
          list.setSize(size);
          iter.forEach(function (v, i) {
            return list.set(i, v);
          });
        });
      }
      List.of = function /*...values*/
      () {
        return this(arguments);
      };
      List.prototype.toString = function () {
        return this.__toString('List [', ']');
      };

      // @pragma Access

      List.prototype.get = function (index, notSetValue) {
        index = wrapIndex(this, index);
        if (index >= 0 && index < this.size) {
          index += this._origin;
          var node = listNodeFor(this, index);
          return node && node.array[index & MASK];
        }
        return notSetValue;
      };

      // @pragma Modification

      List.prototype.set = function (index, value) {
        return updateList(this, index, value);
      };
      List.prototype.remove = function (index) {
        return !this.has(index) ? this : index === 0 ? this.shift() : index === this.size - 1 ? this.pop() : this.splice(index, 1);
      };
      List.prototype.insert = function (index, value) {
        return this.splice(index, 0, value);
      };
      List.prototype.clear = function () {
        if (this.size === 0) {
          return this;
        }
        if (this.__ownerID) {
          this.size = this._origin = this._capacity = 0;
          this._level = SHIFT;
          this._root = this._tail = null;
          this.__hash = undefined;
          this.__altered = true;
          return this;
        }
        return emptyList();
      };
      List.prototype.push = function /*...values*/
      () {
        var values = arguments;
        var oldSize = this.size;
        return this.withMutations(function (list) {
          setListBounds(list, 0, oldSize + values.length);
          for (var ii = 0; ii < values.length; ii++) {
            list.set(oldSize + ii, values[ii]);
          }
        });
      };
      List.prototype.pop = function () {
        return setListBounds(this, 0, -1);
      };
      List.prototype.unshift = function /*...values*/
      () {
        var values = arguments;
        return this.withMutations(function (list) {
          setListBounds(list, -values.length);
          for (var ii = 0; ii < values.length; ii++) {
            list.set(ii, values[ii]);
          }
        });
      };
      List.prototype.shift = function () {
        return setListBounds(this, 1);
      };

      // @pragma Composition

      List.prototype.merge = function /*...iters*/
      () {
        return mergeIntoListWith(this, undefined, arguments);
      };
      List.prototype.mergeWith = function (merger) {
        var iters = SLICE$0.call(arguments, 1);
        return mergeIntoListWith(this, merger, iters);
      };
      List.prototype.mergeDeep = function /*...iters*/
      () {
        return mergeIntoListWith(this, deepMerger, arguments);
      };
      List.prototype.mergeDeepWith = function (merger) {
        var iters = SLICE$0.call(arguments, 1);
        return mergeIntoListWith(this, deepMergerWith(merger), iters);
      };
      List.prototype.setSize = function (size) {
        return setListBounds(this, 0, size);
      };

      // @pragma Iteration

      List.prototype.slice = function (begin, end) {
        var size = this.size;
        if (wholeSlice(begin, end, size)) {
          return this;
        }
        return setListBounds(this, resolveBegin(begin, size), resolveEnd(end, size));
      };
      List.prototype.__iterator = function (type, reverse) {
        var index = 0;
        var values = iterateList(this, reverse);
        return new Iterator(function () {
          var value = values();
          return value === DONE ? iteratorDone() : iteratorValue(type, index++, value);
        });
      };
      List.prototype.__iterate = function (fn, reverse) {
        var index = 0;
        var values = iterateList(this, reverse);
        var value;
        while ((value = values()) !== DONE) {
          if (fn(value, index++, this) === false) {
            break;
          }
        }
        return index;
      };
      List.prototype.__ensureOwner = function (ownerID) {
        if (ownerID === this.__ownerID) {
          return this;
        }
        if (!ownerID) {
          this.__ownerID = ownerID;
          return this;
        }
        return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
      };
      function isList(maybeList) {
        return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
      }
      List.isList = isList;
      var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
      var ListPrototype = List.prototype;
      ListPrototype[IS_LIST_SENTINEL] = true;
      ListPrototype[DELETE] = ListPrototype.remove;
      ListPrototype.setIn = MapPrototype.setIn;
      ListPrototype.deleteIn = ListPrototype.removeIn = MapPrototype.removeIn;
      ListPrototype.update = MapPrototype.update;
      ListPrototype.updateIn = MapPrototype.updateIn;
      ListPrototype.mergeIn = MapPrototype.mergeIn;
      ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
      ListPrototype.withMutations = MapPrototype.withMutations;
      ListPrototype.asMutable = MapPrototype.asMutable;
      ListPrototype.asImmutable = MapPrototype.asImmutable;
      ListPrototype.wasAltered = MapPrototype.wasAltered;
      function VNode(array, ownerID) {
        this.array = array;
        this.ownerID = ownerID;
      }

      // TODO: seems like these methods are very similar

      VNode.prototype.removeBefore = function (ownerID, level, index) {
        if (index === level ? 1 << level : 0 || this.array.length === 0) {
          return this;
        }
        var originIndex = index >>> level & MASK;
        if (originIndex >= this.array.length) {
          return new VNode([], ownerID);
        }
        var removingFirst = originIndex === 0;
        var newChild;
        if (level > 0) {
          var oldChild = this.array[originIndex];
          newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
          if (newChild === oldChild && removingFirst) {
            return this;
          }
        }
        if (removingFirst && !newChild) {
          return this;
        }
        var editable = editableVNode(this, ownerID);
        if (!removingFirst) {
          for (var ii = 0; ii < originIndex; ii++) {
            editable.array[ii] = undefined;
          }
        }
        if (newChild) {
          editable.array[originIndex] = newChild;
        }
        return editable;
      };
      VNode.prototype.removeAfter = function (ownerID, level, index) {
        if (index === (level ? 1 << level : 0) || this.array.length === 0) {
          return this;
        }
        var sizeIndex = index - 1 >>> level & MASK;
        if (sizeIndex >= this.array.length) {
          return this;
        }
        var newChild;
        if (level > 0) {
          var oldChild = this.array[sizeIndex];
          newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
          if (newChild === oldChild && sizeIndex === this.array.length - 1) {
            return this;
          }
        }
        var editable = editableVNode(this, ownerID);
        editable.array.splice(sizeIndex + 1);
        if (newChild) {
          editable.array[sizeIndex] = newChild;
        }
        return editable;
      };
      var DONE = {};
      function iterateList(list, reverse) {
        var left = list._origin;
        var right = list._capacity;
        var tailPos = getTailOffset(right);
        var tail = list._tail;
        return iterateNodeOrLeaf(list._root, list._level, 0);
        function iterateNodeOrLeaf(node, level, offset) {
          return level === 0 ? iterateLeaf(node, offset) : iterateNode(node, level, offset);
        }
        function iterateLeaf(node, offset) {
          var array = offset === tailPos ? tail && tail.array : node && node.array;
          var from = offset > left ? 0 : left - offset;
          var to = right - offset;
          if (to > SIZE) {
            to = SIZE;
          }
          return function () {
            if (from === to) {
              return DONE;
            }
            var idx = reverse ? --to : from++;
            return array && array[idx];
          };
        }
        function iterateNode(node, level, offset) {
          var values;
          var array = node && node.array;
          var from = offset > left ? 0 : left - offset >> level;
          var to = (right - offset >> level) + 1;
          if (to > SIZE) {
            to = SIZE;
          }
          return function () {
            do {
              if (values) {
                var value = values();
                if (value !== DONE) {
                  return value;
                }
                values = null;
              }
              if (from === to) {
                return DONE;
              }
              var idx = reverse ? --to : from++;
              values = iterateNodeOrLeaf(array && array[idx], level - SHIFT, offset + (idx << level));
            } while (true);
          };
        }
      }
      function makeList(origin, capacity, level, root, tail, ownerID, hash) {
        var list = Object.create(ListPrototype);
        list.size = capacity - origin;
        list._origin = origin;
        list._capacity = capacity;
        list._level = level;
        list._root = root;
        list._tail = tail;
        list.__ownerID = ownerID;
        list.__hash = hash;
        list.__altered = false;
        return list;
      }
      var EMPTY_LIST;
      function emptyList() {
        return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
      }
      function updateList(list, index, value) {
        index = wrapIndex(list, index);
        if (index !== index) {
          return list;
        }
        if (index >= list.size || index < 0) {
          return list.withMutations(function (list) {
            index < 0 ? setListBounds(list, index).set(0, value) : setListBounds(list, 0, index + 1).set(index, value);
          });
        }
        index += list._origin;
        var newTail = list._tail;
        var newRoot = list._root;
        var didAlter = MakeRef(DID_ALTER);
        if (index >= getTailOffset(list._capacity)) {
          newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
        } else {
          newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
        }
        if (!didAlter.value) {
          return list;
        }
        if (list.__ownerID) {
          list._root = newRoot;
          list._tail = newTail;
          list.__hash = undefined;
          list.__altered = true;
          return list;
        }
        return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
      }
      function updateVNode(node, ownerID, level, index, value, didAlter) {
        var idx = index >>> level & MASK;
        var nodeHas = node && idx < node.array.length;
        if (!nodeHas && value === undefined) {
          return node;
        }
        var newNode;
        if (level > 0) {
          var lowerNode = node && node.array[idx];
          var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
          if (newLowerNode === lowerNode) {
            return node;
          }
          newNode = editableVNode(node, ownerID);
          newNode.array[idx] = newLowerNode;
          return newNode;
        }
        if (nodeHas && node.array[idx] === value) {
          return node;
        }
        SetRef(didAlter);
        newNode = editableVNode(node, ownerID);
        if (value === undefined && idx === newNode.array.length - 1) {
          newNode.array.pop();
        } else {
          newNode.array[idx] = value;
        }
        return newNode;
      }
      function editableVNode(node, ownerID) {
        if (ownerID && node && ownerID === node.ownerID) {
          return node;
        }
        return new VNode(node ? node.array.slice() : [], ownerID);
      }
      function listNodeFor(list, rawIndex) {
        if (rawIndex >= getTailOffset(list._capacity)) {
          return list._tail;
        }
        if (rawIndex < 1 << list._level + SHIFT) {
          var node = list._root;
          var level = list._level;
          while (node && level > 0) {
            node = node.array[rawIndex >>> level & MASK];
            level -= SHIFT;
          }
          return node;
        }
      }
      function setListBounds(list, begin, end) {
        // Sanitize begin & end using this shorthand for ToInt32(argument)
        // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
        if (begin !== undefined) {
          begin = begin | 0;
        }
        if (end !== undefined) {
          end = end | 0;
        }
        var owner = list.__ownerID || new OwnerID();
        var oldOrigin = list._origin;
        var oldCapacity = list._capacity;
        var newOrigin = oldOrigin + begin;
        var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
        if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
          return list;
        }

        // If it's going to end after it starts, it's empty.
        if (newOrigin >= newCapacity) {
          return list.clear();
        }
        var newLevel = list._level;
        var newRoot = list._root;

        // New origin might need creating a higher root.
        var offsetShift = 0;
        while (newOrigin + offsetShift < 0) {
          newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
          newLevel += SHIFT;
          offsetShift += 1 << newLevel;
        }
        if (offsetShift) {
          newOrigin += offsetShift;
          oldOrigin += offsetShift;
          newCapacity += offsetShift;
          oldCapacity += offsetShift;
        }
        var oldTailOffset = getTailOffset(oldCapacity);
        var newTailOffset = getTailOffset(newCapacity);

        // New size might need creating a higher root.
        while (newTailOffset >= 1 << newLevel + SHIFT) {
          newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
          newLevel += SHIFT;
        }

        // Locate or create the new tail.
        var oldTail = list._tail;
        var newTail = newTailOffset < oldTailOffset ? listNodeFor(list, newCapacity - 1) : newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

        // Merge Tail into tree.
        if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
          newRoot = editableVNode(newRoot, owner);
          var node = newRoot;
          for (var level = newLevel; level > SHIFT; level -= SHIFT) {
            var idx = oldTailOffset >>> level & MASK;
            node = node.array[idx] = editableVNode(node.array[idx], owner);
          }
          node.array[oldTailOffset >>> SHIFT & MASK] = oldTail;
        }

        // If the size has been reduced, there's a chance the tail needs to be trimmed.
        if (newCapacity < oldCapacity) {
          newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
        }

        // If the new origin is within the tail, then we do not need a root.
        if (newOrigin >= newTailOffset) {
          newOrigin -= newTailOffset;
          newCapacity -= newTailOffset;
          newLevel = SHIFT;
          newRoot = null;
          newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

          // Otherwise, if the root has been trimmed, garbage collect.
        } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
          offsetShift = 0;

          // Identify the new top root node of the subtree of the old root.
          while (newRoot) {
            var beginIndex = newOrigin >>> newLevel & MASK;
            if (beginIndex !== newTailOffset >>> newLevel & MASK) {
              break;
            }
            if (beginIndex) {
              offsetShift += (1 << newLevel) * beginIndex;
            }
            newLevel -= SHIFT;
            newRoot = newRoot.array[beginIndex];
          }

          // Trim the new sides of the new root.
          if (newRoot && newOrigin > oldOrigin) {
            newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
          }
          if (newRoot && newTailOffset < oldTailOffset) {
            newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
          }
          if (offsetShift) {
            newOrigin -= offsetShift;
            newCapacity -= offsetShift;
          }
        }
        if (list.__ownerID) {
          list.size = newCapacity - newOrigin;
          list._origin = newOrigin;
          list._capacity = newCapacity;
          list._level = newLevel;
          list._root = newRoot;
          list._tail = newTail;
          list.__hash = undefined;
          list.__altered = true;
          return list;
        }
        return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
      }
      function mergeIntoListWith(list, merger, iterables) {
        var iters = [];
        var maxSize = 0;
        for (var ii = 0; ii < iterables.length; ii++) {
          var value = iterables[ii];
          var iter = IndexedIterable(value);
          if (iter.size > maxSize) {
            maxSize = iter.size;
          }
          if (!isIterable(value)) {
            iter = iter.map(function (v) {
              return fromJS(v);
            });
          }
          iters.push(iter);
        }
        if (maxSize > list.size) {
          list = list.setSize(maxSize);
        }
        return mergeIntoCollectionWith(list, merger, iters);
      }
      function getTailOffset(size) {
        return size < SIZE ? 0 : size - 1 >>> SHIFT << SHIFT;
      }
      createClass(OrderedMap, Map);

      // @pragma Construction

      function OrderedMap(value) {
        return value === null || value === undefined ? emptyOrderedMap() : isOrderedMap(value) ? value : emptyOrderedMap().withMutations(function (map) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function (v, k) {
            return map.set(k, v);
          });
        });
      }
      OrderedMap.of = function /*...values*/
      () {
        return this(arguments);
      };
      OrderedMap.prototype.toString = function () {
        return this.__toString('OrderedMap {', '}');
      };

      // @pragma Access

      OrderedMap.prototype.get = function (k, notSetValue) {
        var index = this._map.get(k);
        return index !== undefined ? this._list.get(index)[1] : notSetValue;
      };

      // @pragma Modification

      OrderedMap.prototype.clear = function () {
        if (this.size === 0) {
          return this;
        }
        if (this.__ownerID) {
          this.size = 0;
          this._map.clear();
          this._list.clear();
          return this;
        }
        return emptyOrderedMap();
      };
      OrderedMap.prototype.set = function (k, v) {
        return updateOrderedMap(this, k, v);
      };
      OrderedMap.prototype.remove = function (k) {
        return updateOrderedMap(this, k, NOT_SET);
      };
      OrderedMap.prototype.wasAltered = function () {
        return this._map.wasAltered() || this._list.wasAltered();
      };
      OrderedMap.prototype.__iterate = function (fn, reverse) {
        var this$0 = this;
        return this._list.__iterate(function (entry) {
          return entry && fn(entry[1], entry[0], this$0);
        }, reverse);
      };
      OrderedMap.prototype.__iterator = function (type, reverse) {
        return this._list.fromEntrySeq().__iterator(type, reverse);
      };
      OrderedMap.prototype.__ensureOwner = function (ownerID) {
        if (ownerID === this.__ownerID) {
          return this;
        }
        var newMap = this._map.__ensureOwner(ownerID);
        var newList = this._list.__ensureOwner(ownerID);
        if (!ownerID) {
          this.__ownerID = ownerID;
          this._map = newMap;
          this._list = newList;
          return this;
        }
        return makeOrderedMap(newMap, newList, ownerID, this.__hash);
      };
      function isOrderedMap(maybeOrderedMap) {
        return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
      }
      OrderedMap.isOrderedMap = isOrderedMap;
      OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
      OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
      function makeOrderedMap(map, list, ownerID, hash) {
        var omap = Object.create(OrderedMap.prototype);
        omap.size = map ? map.size : 0;
        omap._map = map;
        omap._list = list;
        omap.__ownerID = ownerID;
        omap.__hash = hash;
        return omap;
      }
      var EMPTY_ORDERED_MAP;
      function emptyOrderedMap() {
        return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
      }
      function updateOrderedMap(omap, k, v) {
        var map = omap._map;
        var list = omap._list;
        var i = map.get(k);
        var has = i !== undefined;
        var newMap;
        var newList;
        if (v === NOT_SET) {
          // removed
          if (!has) {
            return omap;
          }
          if (list.size >= SIZE && list.size >= map.size * 2) {
            newList = list.filter(function (entry, idx) {
              return entry !== undefined && i !== idx;
            });
            newMap = newList.toKeyedSeq().map(function (entry) {
              return entry[0];
            }).flip().toMap();
            if (omap.__ownerID) {
              newMap.__ownerID = newList.__ownerID = omap.__ownerID;
            }
          } else {
            newMap = map.remove(k);
            newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
          }
        } else {
          if (has) {
            if (v === list.get(i)[1]) {
              return omap;
            }
            newMap = map;
            newList = list.set(i, [k, v]);
          } else {
            newMap = map.set(k, list.size);
            newList = list.set(list.size, [k, v]);
          }
        }
        if (omap.__ownerID) {
          omap.size = newMap.size;
          omap._map = newMap;
          omap._list = newList;
          omap.__hash = undefined;
          return omap;
        }
        return makeOrderedMap(newMap, newList);
      }
      createClass(ToKeyedSequence, KeyedSeq);
      function ToKeyedSequence(indexed, useKeys) {
        this._iter = indexed;
        this._useKeys = useKeys;
        this.size = indexed.size;
      }
      ToKeyedSequence.prototype.get = function (key, notSetValue) {
        return this._iter.get(key, notSetValue);
      };
      ToKeyedSequence.prototype.has = function (key) {
        return this._iter.has(key);
      };
      ToKeyedSequence.prototype.valueSeq = function () {
        return this._iter.valueSeq();
      };
      ToKeyedSequence.prototype.reverse = function () {
        var this$0 = this;
        var reversedSequence = reverseFactory(this, true);
        if (!this._useKeys) {
          reversedSequence.valueSeq = function () {
            return this$0._iter.toSeq().reverse();
          };
        }
        return reversedSequence;
      };
      ToKeyedSequence.prototype.map = function (mapper, context) {
        var this$0 = this;
        var mappedSequence = mapFactory(this, mapper, context);
        if (!this._useKeys) {
          mappedSequence.valueSeq = function () {
            return this$0._iter.toSeq().map(mapper, context);
          };
        }
        return mappedSequence;
      };
      ToKeyedSequence.prototype.__iterate = function (fn, reverse) {
        var this$0 = this;
        var ii;
        return this._iter.__iterate(this._useKeys ? function (v, k) {
          return fn(v, k, this$0);
        } : (ii = reverse ? resolveSize(this) : 0, function (v) {
          return fn(v, reverse ? --ii : ii++, this$0);
        }), reverse);
      };
      ToKeyedSequence.prototype.__iterator = function (type, reverse) {
        if (this._useKeys) {
          return this._iter.__iterator(type, reverse);
        }
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        var ii = reverse ? resolveSize(this) : 0;
        return new Iterator(function () {
          var step = iterator.next();
          return step.done ? step : iteratorValue(type, reverse ? --ii : ii++, step.value, step);
        });
      };
      ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
      createClass(ToIndexedSequence, IndexedSeq);
      function ToIndexedSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
      }
      ToIndexedSequence.prototype.includes = function (value) {
        return this._iter.includes(value);
      };
      ToIndexedSequence.prototype.__iterate = function (fn, reverse) {
        var this$0 = this;
        var iterations = 0;
        return this._iter.__iterate(function (v) {
          return fn(v, iterations++, this$0);
        }, reverse);
      };
      ToIndexedSequence.prototype.__iterator = function (type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        var iterations = 0;
        return new Iterator(function () {
          var step = iterator.next();
          return step.done ? step : iteratorValue(type, iterations++, step.value, step);
        });
      };
      createClass(ToSetSequence, SetSeq);
      function ToSetSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
      }
      ToSetSequence.prototype.has = function (key) {
        return this._iter.includes(key);
      };
      ToSetSequence.prototype.__iterate = function (fn, reverse) {
        var this$0 = this;
        return this._iter.__iterate(function (v) {
          return fn(v, v, this$0);
        }, reverse);
      };
      ToSetSequence.prototype.__iterator = function (type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        return new Iterator(function () {
          var step = iterator.next();
          return step.done ? step : iteratorValue(type, step.value, step.value, step);
        });
      };
      createClass(FromEntriesSequence, KeyedSeq);
      function FromEntriesSequence(entries) {
        this._iter = entries;
        this.size = entries.size;
      }
      FromEntriesSequence.prototype.entrySeq = function () {
        return this._iter.toSeq();
      };
      FromEntriesSequence.prototype.__iterate = function (fn, reverse) {
        var this$0 = this;
        return this._iter.__iterate(function (entry) {
          // Check if entry exists first so array access doesn't throw for holes
          // in the parent iteration.
          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return fn(indexedIterable ? entry.get(1) : entry[1], indexedIterable ? entry.get(0) : entry[0], this$0);
          }
        }, reverse);
      };
      FromEntriesSequence.prototype.__iterator = function (type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        return new Iterator(function () {
          while (true) {
            var step = iterator.next();
            if (step.done) {
              return step;
            }
            var entry = step.value;
            // Check if entry exists first so array access doesn't throw for holes
            // in the parent iteration.
            if (entry) {
              validateEntry(entry);
              var indexedIterable = isIterable(entry);
              return iteratorValue(type, indexedIterable ? entry.get(0) : entry[0], indexedIterable ? entry.get(1) : entry[1], step);
            }
          }
        });
      };
      ToIndexedSequence.prototype.cacheResult = ToKeyedSequence.prototype.cacheResult = ToSetSequence.prototype.cacheResult = FromEntriesSequence.prototype.cacheResult = cacheResultThrough;
      function flipFactory(iterable) {
        var flipSequence = makeSequence(iterable);
        flipSequence._iter = iterable;
        flipSequence.size = iterable.size;
        flipSequence.flip = function () {
          return iterable;
        };
        flipSequence.reverse = function () {
          var reversedSequence = iterable.reverse.apply(this); // super.reverse()
          reversedSequence.flip = function () {
            return iterable.reverse();
          };
          return reversedSequence;
        };
        flipSequence.has = function (key) {
          return iterable.includes(key);
        };
        flipSequence.includes = function (key) {
          return iterable.has(key);
        };
        flipSequence.cacheResult = cacheResultThrough;
        flipSequence.__iterateUncached = function (fn, reverse) {
          var this$0 = this;
          return iterable.__iterate(function (v, k) {
            return fn(k, v, this$0) !== false;
          }, reverse);
        };
        flipSequence.__iteratorUncached = function (type, reverse) {
          if (type === ITERATE_ENTRIES) {
            var iterator = iterable.__iterator(type, reverse);
            return new Iterator(function () {
              var step = iterator.next();
              if (!step.done) {
                var k = step.value[0];
                step.value[0] = step.value[1];
                step.value[1] = k;
              }
              return step;
            });
          }
          return iterable.__iterator(type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES, reverse);
        };
        return flipSequence;
      }
      function mapFactory(iterable, mapper, context) {
        var mappedSequence = makeSequence(iterable);
        mappedSequence.size = iterable.size;
        mappedSequence.has = function (key) {
          return iterable.has(key);
        };
        mappedSequence.get = function (key, notSetValue) {
          var v = iterable.get(key, NOT_SET);
          return v === NOT_SET ? notSetValue : mapper.call(context, v, key, iterable);
        };
        mappedSequence.__iterateUncached = function (fn, reverse) {
          var this$0 = this;
          return iterable.__iterate(function (v, k, c) {
            return fn(mapper.call(context, v, k, c), k, this$0) !== false;
          }, reverse);
        };
        mappedSequence.__iteratorUncached = function (type, reverse) {
          var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
          return new Iterator(function () {
            var step = iterator.next();
            if (step.done) {
              return step;
            }
            var entry = step.value;
            var key = entry[0];
            return iteratorValue(type, key, mapper.call(context, entry[1], key, iterable), step);
          });
        };
        return mappedSequence;
      }
      function reverseFactory(iterable, useKeys) {
        var reversedSequence = makeSequence(iterable);
        reversedSequence._iter = iterable;
        reversedSequence.size = iterable.size;
        reversedSequence.reverse = function () {
          return iterable;
        };
        if (iterable.flip) {
          reversedSequence.flip = function () {
            var flipSequence = flipFactory(iterable);
            flipSequence.reverse = function () {
              return iterable.flip();
            };
            return flipSequence;
          };
        }
        reversedSequence.get = function (key, notSetValue) {
          return iterable.get(useKeys ? key : -1 - key, notSetValue);
        };
        reversedSequence.has = function (key) {
          return iterable.has(useKeys ? key : -1 - key);
        };
        reversedSequence.includes = function (value) {
          return iterable.includes(value);
        };
        reversedSequence.cacheResult = cacheResultThrough;
        reversedSequence.__iterate = function (fn, reverse) {
          var this$0 = this;
          return iterable.__iterate(function (v, k) {
            return fn(v, k, this$0);
          }, !reverse);
        };
        reversedSequence.__iterator = function (type, reverse) {
          return iterable.__iterator(type, !reverse);
        };
        return reversedSequence;
      }
      function filterFactory(iterable, predicate, context, useKeys) {
        var filterSequence = makeSequence(iterable);
        if (useKeys) {
          filterSequence.has = function (key) {
            var v = iterable.get(key, NOT_SET);
            return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
          };
          filterSequence.get = function (key, notSetValue) {
            var v = iterable.get(key, NOT_SET);
            return v !== NOT_SET && predicate.call(context, v, key, iterable) ? v : notSetValue;
          };
        }
        filterSequence.__iterateUncached = function (fn, reverse) {
          var this$0 = this;
          var iterations = 0;
          iterable.__iterate(function (v, k, c) {
            if (predicate.call(context, v, k, c)) {
              iterations++;
              return fn(v, useKeys ? k : iterations - 1, this$0);
            }
          }, reverse);
          return iterations;
        };
        filterSequence.__iteratorUncached = function (type, reverse) {
          var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
          var iterations = 0;
          return new Iterator(function () {
            while (true) {
              var step = iterator.next();
              if (step.done) {
                return step;
              }
              var entry = step.value;
              var key = entry[0];
              var value = entry[1];
              if (predicate.call(context, value, key, iterable)) {
                return iteratorValue(type, useKeys ? key : iterations++, value, step);
              }
            }
          });
        };
        return filterSequence;
      }
      function countByFactory(iterable, grouper, context) {
        var groups = Map().asMutable();
        iterable.__iterate(function (v, k) {
          groups.update(grouper.call(context, v, k, iterable), 0, function (a) {
            return a + 1;
          });
        });
        return groups.asImmutable();
      }
      function groupByFactory(iterable, grouper, context) {
        var isKeyedIter = isKeyed(iterable);
        var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
        iterable.__iterate(function (v, k) {
          groups.update(grouper.call(context, v, k, iterable), function (a) {
            return a = a || [], a.push(isKeyedIter ? [k, v] : v), a;
          });
        });
        var coerce = iterableClass(iterable);
        return groups.map(function (arr) {
          return reify(iterable, coerce(arr));
        });
      }
      function sliceFactory(iterable, begin, end, useKeys) {
        var originalSize = iterable.size;

        // Sanitize begin & end using this shorthand for ToInt32(argument)
        // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
        if (begin !== undefined) {
          begin = begin | 0;
        }
        if (end !== undefined) {
          if (end === Infinity) {
            end = originalSize;
          } else {
            end = end | 0;
          }
        }
        if (wholeSlice(begin, end, originalSize)) {
          return iterable;
        }
        var resolvedBegin = resolveBegin(begin, originalSize);
        var resolvedEnd = resolveEnd(end, originalSize);

        // begin or end will be NaN if they were provided as negative numbers and
        // this iterable's size is unknown. In that case, cache first so there is
        // a known size and these do not resolve to NaN.
        if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
          return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
        }

        // Note: resolvedEnd is undefined when the original sequence's length is
        // unknown and this slice did not supply an end and should contain all
        // elements after resolvedBegin.
        // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
        var resolvedSize = resolvedEnd - resolvedBegin;
        var sliceSize;
        if (resolvedSize === resolvedSize) {
          sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
        }
        var sliceSeq = makeSequence(iterable);

        // If iterable.size is undefined, the size of the realized sliceSeq is
        // unknown at this point unless the number of items to slice is 0
        sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
        if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
          sliceSeq.get = function (index, notSetValue) {
            index = wrapIndex(this, index);
            return index >= 0 && index < sliceSize ? iterable.get(index + resolvedBegin, notSetValue) : notSetValue;
          };
        }
        sliceSeq.__iterateUncached = function (fn, reverse) {
          var this$0 = this;
          if (sliceSize === 0) {
            return 0;
          }
          if (reverse) {
            return this.cacheResult().__iterate(fn, reverse);
          }
          var skipped = 0;
          var isSkipping = true;
          var iterations = 0;
          iterable.__iterate(function (v, k) {
            if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
              iterations++;
              return fn(v, useKeys ? k : iterations - 1, this$0) !== false && iterations !== sliceSize;
            }
          });
          return iterations;
        };
        sliceSeq.__iteratorUncached = function (type, reverse) {
          if (sliceSize !== 0 && reverse) {
            return this.cacheResult().__iterator(type, reverse);
          }
          // Don't bother instantiating parent iterator if taking 0.
          var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
          var skipped = 0;
          var iterations = 0;
          return new Iterator(function () {
            while (skipped++ < resolvedBegin) {
              iterator.next();
            }
            if (++iterations > sliceSize) {
              return iteratorDone();
            }
            var step = iterator.next();
            if (useKeys || type === ITERATE_VALUES) {
              return step;
            } else if (type === ITERATE_KEYS) {
              return iteratorValue(type, iterations - 1, undefined, step);
            } else {
              return iteratorValue(type, iterations - 1, step.value[1], step);
            }
          });
        };
        return sliceSeq;
      }
      function takeWhileFactory(iterable, predicate, context) {
        var takeSequence = makeSequence(iterable);
        takeSequence.__iterateUncached = function (fn, reverse) {
          var this$0 = this;
          if (reverse) {
            return this.cacheResult().__iterate(fn, reverse);
          }
          var iterations = 0;
          iterable.__iterate(function (v, k, c) {
            return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0);
          });
          return iterations;
        };
        takeSequence.__iteratorUncached = function (type, reverse) {
          var this$0 = this;
          if (reverse) {
            return this.cacheResult().__iterator(type, reverse);
          }
          var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
          var iterating = true;
          return new Iterator(function () {
            if (!iterating) {
              return iteratorDone();
            }
            var step = iterator.next();
            if (step.done) {
              return step;
            }
            var entry = step.value;
            var k = entry[0];
            var v = entry[1];
            if (!predicate.call(context, v, k, this$0)) {
              iterating = false;
              return iteratorDone();
            }
            return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
          });
        };
        return takeSequence;
      }
      function skipWhileFactory(iterable, predicate, context, useKeys) {
        var skipSequence = makeSequence(iterable);
        skipSequence.__iterateUncached = function (fn, reverse) {
          var this$0 = this;
          if (reverse) {
            return this.cacheResult().__iterate(fn, reverse);
          }
          var isSkipping = true;
          var iterations = 0;
          iterable.__iterate(function (v, k, c) {
            if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
              iterations++;
              return fn(v, useKeys ? k : iterations - 1, this$0);
            }
          });
          return iterations;
        };
        skipSequence.__iteratorUncached = function (type, reverse) {
          var this$0 = this;
          if (reverse) {
            return this.cacheResult().__iterator(type, reverse);
          }
          var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
          var skipping = true;
          var iterations = 0;
          return new Iterator(function () {
            var step, k, v;
            do {
              step = iterator.next();
              if (step.done) {
                if (useKeys || type === ITERATE_VALUES) {
                  return step;
                } else if (type === ITERATE_KEYS) {
                  return iteratorValue(type, iterations++, undefined, step);
                } else {
                  return iteratorValue(type, iterations++, step.value[1], step);
                }
              }
              var entry = step.value;
              k = entry[0];
              v = entry[1];
              skipping && (skipping = predicate.call(context, v, k, this$0));
            } while (skipping);
            return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
          });
        };
        return skipSequence;
      }
      function concatFactory(iterable, values) {
        var isKeyedIterable = isKeyed(iterable);
        var iters = [iterable].concat(values).map(function (v) {
          if (!isIterable(v)) {
            v = isKeyedIterable ? keyedSeqFromValue(v) : indexedSeqFromValue(Array.isArray(v) ? v : [v]);
          } else if (isKeyedIterable) {
            v = KeyedIterable(v);
          }
          return v;
        }).filter(function (v) {
          return v.size !== 0;
        });
        if (iters.length === 0) {
          return iterable;
        }
        if (iters.length === 1) {
          var singleton = iters[0];
          if (singleton === iterable || isKeyedIterable && isKeyed(singleton) || isIndexed(iterable) && isIndexed(singleton)) {
            return singleton;
          }
        }
        var concatSeq = new ArraySeq(iters);
        if (isKeyedIterable) {
          concatSeq = concatSeq.toKeyedSeq();
        } else if (!isIndexed(iterable)) {
          concatSeq = concatSeq.toSetSeq();
        }
        concatSeq = concatSeq.flatten(true);
        concatSeq.size = iters.reduce(function (sum, seq) {
          if (sum !== undefined) {
            var size = seq.size;
            if (size !== undefined) {
              return sum + size;
            }
          }
        }, 0);
        return concatSeq;
      }
      function flattenFactory(iterable, depth, useKeys) {
        var flatSequence = makeSequence(iterable);
        flatSequence.__iterateUncached = function (fn, reverse) {
          var iterations = 0;
          var stopped = false;
          function flatDeep(iter, currentDepth) {
            var this$0 = this;
            iter.__iterate(function (v, k) {
              if ((!depth || currentDepth < depth) && isIterable(v)) {
                flatDeep(v, currentDepth + 1);
              } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
                stopped = true;
              }
              return !stopped;
            }, reverse);
          }
          flatDeep(iterable, 0);
          return iterations;
        };
        flatSequence.__iteratorUncached = function (type, reverse) {
          var iterator = iterable.__iterator(type, reverse);
          var stack = [];
          var iterations = 0;
          return new Iterator(function () {
            while (iterator) {
              var step = iterator.next();
              if (step.done !== false) {
                iterator = stack.pop();
                continue;
              }
              var v = step.value;
              if (type === ITERATE_ENTRIES) {
                v = v[1];
              }
              if ((!depth || stack.length < depth) && isIterable(v)) {
                stack.push(iterator);
                iterator = v.__iterator(type, reverse);
              } else {
                return useKeys ? step : iteratorValue(type, iterations++, v, step);
              }
            }
            return iteratorDone();
          });
        };
        return flatSequence;
      }
      function flatMapFactory(iterable, mapper, context) {
        var coerce = iterableClass(iterable);
        return iterable.toSeq().map(function (v, k) {
          return coerce(mapper.call(context, v, k, iterable));
        }).flatten(true);
      }
      function interposeFactory(iterable, separator) {
        var interposedSequence = makeSequence(iterable);
        interposedSequence.size = iterable.size && iterable.size * 2 - 1;
        interposedSequence.__iterateUncached = function (fn, reverse) {
          var this$0 = this;
          var iterations = 0;
          iterable.__iterate(function (v, k) {
            return (!iterations || fn(separator, iterations++, this$0) !== false) && fn(v, iterations++, this$0) !== false;
          }, reverse);
          return iterations;
        };
        interposedSequence.__iteratorUncached = function (type, reverse) {
          var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
          var iterations = 0;
          var step;
          return new Iterator(function () {
            if (!step || iterations % 2) {
              step = iterator.next();
              if (step.done) {
                return step;
              }
            }
            return iterations % 2 ? iteratorValue(type, iterations++, separator) : iteratorValue(type, iterations++, step.value, step);
          });
        };
        return interposedSequence;
      }
      function sortFactory(iterable, comparator, mapper) {
        if (!comparator) {
          comparator = defaultComparator;
        }
        var isKeyedIterable = isKeyed(iterable);
        var index = 0;
        var entries = iterable.toSeq().map(function (v, k) {
          return [k, v, index++, mapper ? mapper(v, k, iterable) : v];
        }).toArray();
        entries.sort(function (a, b) {
          return comparator(a[3], b[3]) || a[2] - b[2];
        }).forEach(isKeyedIterable ? function (v, i) {
          entries[i].length = 2;
        } : function (v, i) {
          entries[i] = v[1];
        });
        return isKeyedIterable ? KeyedSeq(entries) : isIndexed(iterable) ? IndexedSeq(entries) : SetSeq(entries);
      }
      function maxFactory(iterable, comparator, mapper) {
        if (!comparator) {
          comparator = defaultComparator;
        }
        if (mapper) {
          var entry = iterable.toSeq().map(function (v, k) {
            return [v, mapper(v, k, iterable)];
          }).reduce(function (a, b) {
            return maxCompare(comparator, a[1], b[1]) ? b : a;
          });
          return entry && entry[0];
        } else {
          return iterable.reduce(function (a, b) {
            return maxCompare(comparator, a, b) ? b : a;
          });
        }
      }
      function maxCompare(comparator, a, b) {
        var comp = comparator(b, a);
        // b is considered the new max if the comparator declares them equal, but
        // they are not equal and b is in fact a nullish value.
        return comp === 0 && b !== a && (b === undefined || b === null || b !== b) || comp > 0;
      }
      function zipWithFactory(keyIter, zipper, iters) {
        var zipSequence = makeSequence(keyIter);
        zipSequence.size = new ArraySeq(iters).map(function (i) {
          return i.size;
        }).min();
        // Note: this a generic base implementation of __iterate in terms of
        // __iterator which may be more generically useful in the future.
        zipSequence.__iterate = function (fn, reverse) {
          /* generic:
          var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
          var step;
          var iterations = 0;
          while (!(step = iterator.next()).done) {
            iterations++;
            if (fn(step.value[1], step.value[0], this) === false) {
              break;
            }
          }
          return iterations;
          */
          // indexed:
          var iterator = this.__iterator(ITERATE_VALUES, reverse);
          var step;
          var iterations = 0;
          while (!(step = iterator.next()).done) {
            if (fn(step.value, iterations++, this) === false) {
              break;
            }
          }
          return iterations;
        };
        zipSequence.__iteratorUncached = function (type, reverse) {
          var iterators = iters.map(function (i) {
            return i = Iterable(i), getIterator(reverse ? i.reverse() : i);
          });
          var iterations = 0;
          var isDone = false;
          return new Iterator(function () {
            var steps;
            if (!isDone) {
              steps = iterators.map(function (i) {
                return i.next();
              });
              isDone = steps.some(function (s) {
                return s.done;
              });
            }
            if (isDone) {
              return iteratorDone();
            }
            return iteratorValue(type, iterations++, zipper.apply(null, steps.map(function (s) {
              return s.value;
            })));
          });
        };
        return zipSequence;
      }

      // #pragma Helper Functions

      function reify(iter, seq) {
        return isSeq(iter) ? seq : iter.constructor(seq);
      }
      function validateEntry(entry) {
        if (entry !== Object(entry)) {
          throw new TypeError('Expected [K, V] tuple: ' + entry);
        }
      }
      function resolveSize(iter) {
        assertNotInfinite(iter.size);
        return ensureSize(iter);
      }
      function iterableClass(iterable) {
        return isKeyed(iterable) ? KeyedIterable : isIndexed(iterable) ? IndexedIterable : SetIterable;
      }
      function makeSequence(iterable) {
        return Object.create((isKeyed(iterable) ? KeyedSeq : isIndexed(iterable) ? IndexedSeq : SetSeq).prototype);
      }
      function cacheResultThrough() {
        if (this._iter.cacheResult) {
          this._iter.cacheResult();
          this.size = this._iter.size;
          return this;
        } else {
          return Seq.prototype.cacheResult.call(this);
        }
      }
      function defaultComparator(a, b) {
        return a > b ? 1 : a < b ? -1 : 0;
      }
      function forceIterator(keyPath) {
        var iter = getIterator(keyPath);
        if (!iter) {
          // Array might not be iterable in this environment, so we need a fallback
          // to our wrapped type.
          if (!isArrayLike(keyPath)) {
            throw new TypeError('Expected iterable or array-like: ' + keyPath);
          }
          iter = getIterator(Iterable(keyPath));
        }
        return iter;
      }
      createClass(Record, KeyedCollection);
      function Record(defaultValues, name) {
        var hasInitialized;
        var RecordType = function Record(values) {
          if (values instanceof RecordType) {
            return values;
          }
          if (!(this instanceof RecordType)) {
            return new RecordType(values);
          }
          if (!hasInitialized) {
            hasInitialized = true;
            var keys = Object.keys(defaultValues);
            setProps(RecordTypePrototype, keys);
            RecordTypePrototype.size = keys.length;
            RecordTypePrototype._name = name;
            RecordTypePrototype._keys = keys;
            RecordTypePrototype._defaultValues = defaultValues;
          }
          this._map = Map(values);
        };
        var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
        RecordTypePrototype.constructor = RecordType;
        return RecordType;
      }
      Record.prototype.toString = function () {
        return this.__toString(recordName(this) + ' {', '}');
      };

      // @pragma Access

      Record.prototype.has = function (k) {
        return this._defaultValues.hasOwnProperty(k);
      };
      Record.prototype.get = function (k, notSetValue) {
        if (!this.has(k)) {
          return notSetValue;
        }
        var defaultVal = this._defaultValues[k];
        return this._map ? this._map.get(k, defaultVal) : defaultVal;
      };

      // @pragma Modification

      Record.prototype.clear = function () {
        if (this.__ownerID) {
          this._map && this._map.clear();
          return this;
        }
        var RecordType = this.constructor;
        return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
      };
      Record.prototype.set = function (k, v) {
        if (!this.has(k)) {
          throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
        }
        if (this._map && !this._map.has(k)) {
          var defaultVal = this._defaultValues[k];
          if (v === defaultVal) {
            return this;
          }
        }
        var newMap = this._map && this._map.set(k, v);
        if (this.__ownerID || newMap === this._map) {
          return this;
        }
        return makeRecord(this, newMap);
      };
      Record.prototype.remove = function (k) {
        if (!this.has(k)) {
          return this;
        }
        var newMap = this._map && this._map.remove(k);
        if (this.__ownerID || newMap === this._map) {
          return this;
        }
        return makeRecord(this, newMap);
      };
      Record.prototype.wasAltered = function () {
        return this._map.wasAltered();
      };
      Record.prototype.__iterator = function (type, reverse) {
        var this$0 = this;
        return KeyedIterable(this._defaultValues).map(function (_, k) {
          return this$0.get(k);
        }).__iterator(type, reverse);
      };
      Record.prototype.__iterate = function (fn, reverse) {
        var this$0 = this;
        return KeyedIterable(this._defaultValues).map(function (_, k) {
          return this$0.get(k);
        }).__iterate(fn, reverse);
      };
      Record.prototype.__ensureOwner = function (ownerID) {
        if (ownerID === this.__ownerID) {
          return this;
        }
        var newMap = this._map && this._map.__ensureOwner(ownerID);
        if (!ownerID) {
          this.__ownerID = ownerID;
          this._map = newMap;
          return this;
        }
        return makeRecord(this, newMap, ownerID);
      };
      var RecordPrototype = Record.prototype;
      RecordPrototype[DELETE] = RecordPrototype.remove;
      RecordPrototype.deleteIn = RecordPrototype.removeIn = MapPrototype.removeIn;
      RecordPrototype.merge = MapPrototype.merge;
      RecordPrototype.mergeWith = MapPrototype.mergeWith;
      RecordPrototype.mergeIn = MapPrototype.mergeIn;
      RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
      RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
      RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
      RecordPrototype.setIn = MapPrototype.setIn;
      RecordPrototype.update = MapPrototype.update;
      RecordPrototype.updateIn = MapPrototype.updateIn;
      RecordPrototype.withMutations = MapPrototype.withMutations;
      RecordPrototype.asMutable = MapPrototype.asMutable;
      RecordPrototype.asImmutable = MapPrototype.asImmutable;
      function makeRecord(likeRecord, map, ownerID) {
        var record = Object.create(Object.getPrototypeOf(likeRecord));
        record._map = map;
        record.__ownerID = ownerID;
        return record;
      }
      function recordName(record) {
        return record._name || record.constructor.name || 'Record';
      }
      function setProps(prototype, names) {
        try {
          names.forEach(setProp.bind(undefined, prototype));
        } catch (error) {
          // Object.defineProperty failed. Probably IE8.
        }
      }
      function setProp(prototype, name) {
        Object.defineProperty(prototype, name, {
          get: function get() {
            return this.get(name);
          },
          set: function set(value) {
            invariant(this.__ownerID, 'Cannot set on an immutable record.');
            this.set(name, value);
          }
        });
      }
      createClass(Set, SetCollection);

      // @pragma Construction

      function Set(value) {
        return value === null || value === undefined ? emptySet() : isSet(value) && !isOrdered(value) ? value : emptySet().withMutations(function (set) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function (v) {
            return set.add(v);
          });
        });
      }
      Set.of = function /*...values*/
      () {
        return this(arguments);
      };
      Set.fromKeys = function (value) {
        return this(KeyedIterable(value).keySeq());
      };
      Set.prototype.toString = function () {
        return this.__toString('Set {', '}');
      };

      // @pragma Access

      Set.prototype.has = function (value) {
        return this._map.has(value);
      };

      // @pragma Modification

      Set.prototype.add = function (value) {
        return updateSet(this, this._map.set(value, true));
      };
      Set.prototype.remove = function (value) {
        return updateSet(this, this._map.remove(value));
      };
      Set.prototype.clear = function () {
        return updateSet(this, this._map.clear());
      };

      // @pragma Composition

      Set.prototype.union = function () {
        var iters = SLICE$0.call(arguments, 0);
        iters = iters.filter(function (x) {
          return x.size !== 0;
        });
        if (iters.length === 0) {
          return this;
        }
        if (this.size === 0 && !this.__ownerID && iters.length === 1) {
          return this.constructor(iters[0]);
        }
        return this.withMutations(function (set) {
          for (var ii = 0; ii < iters.length; ii++) {
            SetIterable(iters[ii]).forEach(function (value) {
              return set.add(value);
            });
          }
        });
      };
      Set.prototype.intersect = function () {
        var iters = SLICE$0.call(arguments, 0);
        if (iters.length === 0) {
          return this;
        }
        iters = iters.map(function (iter) {
          return SetIterable(iter);
        });
        var originalSet = this;
        return this.withMutations(function (set) {
          originalSet.forEach(function (value) {
            if (!iters.every(function (iter) {
              return iter.includes(value);
            })) {
              set.remove(value);
            }
          });
        });
      };
      Set.prototype.subtract = function () {
        var iters = SLICE$0.call(arguments, 0);
        if (iters.length === 0) {
          return this;
        }
        iters = iters.map(function (iter) {
          return SetIterable(iter);
        });
        var originalSet = this;
        return this.withMutations(function (set) {
          originalSet.forEach(function (value) {
            if (iters.some(function (iter) {
              return iter.includes(value);
            })) {
              set.remove(value);
            }
          });
        });
      };
      Set.prototype.merge = function () {
        return this.union.apply(this, arguments);
      };
      Set.prototype.mergeWith = function (merger) {
        var iters = SLICE$0.call(arguments, 1);
        return this.union.apply(this, iters);
      };
      Set.prototype.sort = function (comparator) {
        // Late binding
        return OrderedSet(sortFactory(this, comparator));
      };
      Set.prototype.sortBy = function (mapper, comparator) {
        // Late binding
        return OrderedSet(sortFactory(this, comparator, mapper));
      };
      Set.prototype.wasAltered = function () {
        return this._map.wasAltered();
      };
      Set.prototype.__iterate = function (fn, reverse) {
        var this$0 = this;
        return this._map.__iterate(function (_, k) {
          return fn(k, k, this$0);
        }, reverse);
      };
      Set.prototype.__iterator = function (type, reverse) {
        return this._map.map(function (_, k) {
          return k;
        }).__iterator(type, reverse);
      };
      Set.prototype.__ensureOwner = function (ownerID) {
        if (ownerID === this.__ownerID) {
          return this;
        }
        var newMap = this._map.__ensureOwner(ownerID);
        if (!ownerID) {
          this.__ownerID = ownerID;
          this._map = newMap;
          return this;
        }
        return this.__make(newMap, ownerID);
      };
      function isSet(maybeSet) {
        return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
      }
      Set.isSet = isSet;
      var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
      var SetPrototype = Set.prototype;
      SetPrototype[IS_SET_SENTINEL] = true;
      SetPrototype[DELETE] = SetPrototype.remove;
      SetPrototype.mergeDeep = SetPrototype.merge;
      SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
      SetPrototype.withMutations = MapPrototype.withMutations;
      SetPrototype.asMutable = MapPrototype.asMutable;
      SetPrototype.asImmutable = MapPrototype.asImmutable;
      SetPrototype.__empty = emptySet;
      SetPrototype.__make = makeSet;
      function updateSet(set, newMap) {
        if (set.__ownerID) {
          set.size = newMap.size;
          set._map = newMap;
          return set;
        }
        return newMap === set._map ? set : newMap.size === 0 ? set.__empty() : set.__make(newMap);
      }
      function makeSet(map, ownerID) {
        var set = Object.create(SetPrototype);
        set.size = map ? map.size : 0;
        set._map = map;
        set.__ownerID = ownerID;
        return set;
      }
      var EMPTY_SET;
      function emptySet() {
        return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
      }
      createClass(OrderedSet, Set);

      // @pragma Construction

      function OrderedSet(value) {
        return value === null || value === undefined ? emptyOrderedSet() : isOrderedSet(value) ? value : emptyOrderedSet().withMutations(function (set) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function (v) {
            return set.add(v);
          });
        });
      }
      OrderedSet.of = function /*...values*/
      () {
        return this(arguments);
      };
      OrderedSet.fromKeys = function (value) {
        return this(KeyedIterable(value).keySeq());
      };
      OrderedSet.prototype.toString = function () {
        return this.__toString('OrderedSet {', '}');
      };
      function isOrderedSet(maybeOrderedSet) {
        return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
      }
      OrderedSet.isOrderedSet = isOrderedSet;
      var OrderedSetPrototype = OrderedSet.prototype;
      OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
      OrderedSetPrototype.__empty = emptyOrderedSet;
      OrderedSetPrototype.__make = makeOrderedSet;
      function makeOrderedSet(map, ownerID) {
        var set = Object.create(OrderedSetPrototype);
        set.size = map ? map.size : 0;
        set._map = map;
        set.__ownerID = ownerID;
        return set;
      }
      var EMPTY_ORDERED_SET;
      function emptyOrderedSet() {
        return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
      }
      createClass(Stack, IndexedCollection);

      // @pragma Construction

      function Stack(value) {
        return value === null || value === undefined ? emptyStack() : isStack(value) ? value : emptyStack().unshiftAll(value);
      }
      Stack.of = function /*...values*/
      () {
        return this(arguments);
      };
      Stack.prototype.toString = function () {
        return this.__toString('Stack [', ']');
      };

      // @pragma Access

      Stack.prototype.get = function (index, notSetValue) {
        var head = this._head;
        index = wrapIndex(this, index);
        while (head && index--) {
          head = head.next;
        }
        return head ? head.value : notSetValue;
      };
      Stack.prototype.peek = function () {
        return this._head && this._head.value;
      };

      // @pragma Modification

      Stack.prototype.push = function /*...values*/
      () {
        if (arguments.length === 0) {
          return this;
        }
        var newSize = this.size + arguments.length;
        var head = this._head;
        for (var ii = arguments.length - 1; ii >= 0; ii--) {
          head = {
            value: arguments[ii],
            next: head
          };
        }
        if (this.__ownerID) {
          this.size = newSize;
          this._head = head;
          this.__hash = undefined;
          this.__altered = true;
          return this;
        }
        return makeStack(newSize, head);
      };
      Stack.prototype.pushAll = function (iter) {
        iter = IndexedIterable(iter);
        if (iter.size === 0) {
          return this;
        }
        assertNotInfinite(iter.size);
        var newSize = this.size;
        var head = this._head;
        iter.reverse().forEach(function (value) {
          newSize++;
          head = {
            value: value,
            next: head
          };
        });
        if (this.__ownerID) {
          this.size = newSize;
          this._head = head;
          this.__hash = undefined;
          this.__altered = true;
          return this;
        }
        return makeStack(newSize, head);
      };
      Stack.prototype.pop = function () {
        return this.slice(1);
      };
      Stack.prototype.unshift = function /*...values*/
      () {
        return this.push.apply(this, arguments);
      };
      Stack.prototype.unshiftAll = function (iter) {
        return this.pushAll(iter);
      };
      Stack.prototype.shift = function () {
        return this.pop.apply(this, arguments);
      };
      Stack.prototype.clear = function () {
        if (this.size === 0) {
          return this;
        }
        if (this.__ownerID) {
          this.size = 0;
          this._head = undefined;
          this.__hash = undefined;
          this.__altered = true;
          return this;
        }
        return emptyStack();
      };
      Stack.prototype.slice = function (begin, end) {
        if (wholeSlice(begin, end, this.size)) {
          return this;
        }
        var resolvedBegin = resolveBegin(begin, this.size);
        var resolvedEnd = resolveEnd(end, this.size);
        if (resolvedEnd !== this.size) {
          // super.slice(begin, end);
          return IndexedCollection.prototype.slice.call(this, begin, end);
        }
        var newSize = this.size - resolvedBegin;
        var head = this._head;
        while (resolvedBegin--) {
          head = head.next;
        }
        if (this.__ownerID) {
          this.size = newSize;
          this._head = head;
          this.__hash = undefined;
          this.__altered = true;
          return this;
        }
        return makeStack(newSize, head);
      };

      // @pragma Mutability

      Stack.prototype.__ensureOwner = function (ownerID) {
        if (ownerID === this.__ownerID) {
          return this;
        }
        if (!ownerID) {
          this.__ownerID = ownerID;
          this.__altered = false;
          return this;
        }
        return makeStack(this.size, this._head, ownerID, this.__hash);
      };

      // @pragma Iteration

      Stack.prototype.__iterate = function (fn, reverse) {
        if (reverse) {
          return this.reverse().__iterate(fn);
        }
        var iterations = 0;
        var node = this._head;
        while (node) {
          if (fn(node.value, iterations++, this) === false) {
            break;
          }
          node = node.next;
        }
        return iterations;
      };
      Stack.prototype.__iterator = function (type, reverse) {
        if (reverse) {
          return this.reverse().__iterator(type);
        }
        var iterations = 0;
        var node = this._head;
        return new Iterator(function () {
          if (node) {
            var value = node.value;
            node = node.next;
            return iteratorValue(type, iterations++, value);
          }
          return iteratorDone();
        });
      };
      function isStack(maybeStack) {
        return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
      }
      Stack.isStack = isStack;
      var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
      var StackPrototype = Stack.prototype;
      StackPrototype[IS_STACK_SENTINEL] = true;
      StackPrototype.withMutations = MapPrototype.withMutations;
      StackPrototype.asMutable = MapPrototype.asMutable;
      StackPrototype.asImmutable = MapPrototype.asImmutable;
      StackPrototype.wasAltered = MapPrototype.wasAltered;
      function makeStack(size, head, ownerID, hash) {
        var map = Object.create(StackPrototype);
        map.size = size;
        map._head = head;
        map.__ownerID = ownerID;
        map.__hash = hash;
        map.__altered = false;
        return map;
      }
      var EMPTY_STACK;
      function emptyStack() {
        return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
      }

      /**
       * Contributes additional methods to a constructor
       */
      function mixin(ctor, methods) {
        var keyCopier = function keyCopier(key) {
          ctor.prototype[key] = methods[key];
        };
        Object.keys(methods).forEach(keyCopier);
        Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(methods).forEach(keyCopier);
        return ctor;
      }
      Iterable.Iterator = Iterator;
      mixin(Iterable, {
        // ### Conversion to other types

        toArray: function toArray() {
          assertNotInfinite(this.size);
          var array = new Array(this.size || 0);
          this.valueSeq().__iterate(function (v, i) {
            array[i] = v;
          });
          return array;
        },
        toIndexedSeq: function toIndexedSeq() {
          return new ToIndexedSequence(this);
        },
        toJS: function toJS() {
          return this.toSeq().map(function (value) {
            return value && typeof value.toJS === 'function' ? value.toJS() : value;
          }).__toJS();
        },
        toJSON: function toJSON() {
          return this.toSeq().map(function (value) {
            return value && typeof value.toJSON === 'function' ? value.toJSON() : value;
          }).__toJS();
        },
        toKeyedSeq: function toKeyedSeq() {
          return new ToKeyedSequence(this, true);
        },
        toMap: function toMap() {
          // Use Late Binding here to solve the circular dependency.
          return Map(this.toKeyedSeq());
        },
        toObject: function toObject() {
          assertNotInfinite(this.size);
          var object = {};
          this.__iterate(function (v, k) {
            object[k] = v;
          });
          return object;
        },
        toOrderedMap: function toOrderedMap() {
          // Use Late Binding here to solve the circular dependency.
          return OrderedMap(this.toKeyedSeq());
        },
        toOrderedSet: function toOrderedSet() {
          // Use Late Binding here to solve the circular dependency.
          return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
        },
        toSet: function toSet() {
          // Use Late Binding here to solve the circular dependency.
          return Set(isKeyed(this) ? this.valueSeq() : this);
        },
        toSetSeq: function toSetSeq() {
          return new ToSetSequence(this);
        },
        toSeq: function toSeq() {
          return isIndexed(this) ? this.toIndexedSeq() : isKeyed(this) ? this.toKeyedSeq() : this.toSetSeq();
        },
        toStack: function toStack() {
          // Use Late Binding here to solve the circular dependency.
          return Stack(isKeyed(this) ? this.valueSeq() : this);
        },
        toList: function toList() {
          // Use Late Binding here to solve the circular dependency.
          return List(isKeyed(this) ? this.valueSeq() : this);
        },
        // ### Common JavaScript methods and properties

        toString: function toString() {
          return '[Iterable]';
        },
        __toString: function __toString(head, tail) {
          if (this.size === 0) {
            return head + tail;
          }
          return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
        },
        // ### ES6 Collection methods (ES6 Array and Map)

        concat: function concat() {
          var values = SLICE$0.call(arguments, 0);
          return reify(this, concatFactory(this, values));
        },
        includes: function includes(searchValue) {
          return this.some(function (value) {
            return is(value, searchValue);
          });
        },
        entries: function entries() {
          return this.__iterator(ITERATE_ENTRIES);
        },
        every: function every(predicate, context) {
          assertNotInfinite(this.size);
          var returnValue = true;
          this.__iterate(function (v, k, c) {
            if (!predicate.call(context, v, k, c)) {
              returnValue = false;
              return false;
            }
          });
          return returnValue;
        },
        filter: function filter(predicate, context) {
          return reify(this, filterFactory(this, predicate, context, true));
        },
        find: function find(predicate, context, notSetValue) {
          var entry = this.findEntry(predicate, context);
          return entry ? entry[1] : notSetValue;
        },
        forEach: function forEach(sideEffect, context) {
          assertNotInfinite(this.size);
          return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
        },
        join: function join(separator) {
          assertNotInfinite(this.size);
          separator = separator !== undefined ? '' + separator : ',';
          var joined = '';
          var isFirst = true;
          this.__iterate(function (v) {
            isFirst ? isFirst = false : joined += separator;
            joined += v !== null && v !== undefined ? v.toString() : '';
          });
          return joined;
        },
        keys: function keys() {
          return this.__iterator(ITERATE_KEYS);
        },
        map: function map(mapper, context) {
          return reify(this, mapFactory(this, mapper, context));
        },
        reduce: function reduce(reducer, initialReduction, context) {
          assertNotInfinite(this.size);
          var reduction;
          var useFirst;
          if (arguments.length < 2) {
            useFirst = true;
          } else {
            reduction = initialReduction;
          }
          this.__iterate(function (v, k, c) {
            if (useFirst) {
              useFirst = false;
              reduction = v;
            } else {
              reduction = reducer.call(context, reduction, v, k, c);
            }
          });
          return reduction;
        },
        reduceRight: function reduceRight(reducer, initialReduction, context) {
          var reversed = this.toKeyedSeq().reverse();
          return reversed.reduce.apply(reversed, arguments);
        },
        reverse: function reverse() {
          return reify(this, reverseFactory(this, true));
        },
        slice: function slice(begin, end) {
          return reify(this, sliceFactory(this, begin, end, true));
        },
        some: function some(predicate, context) {
          return !this.every(not(predicate), context);
        },
        sort: function sort(comparator) {
          return reify(this, sortFactory(this, comparator));
        },
        values: function values() {
          return this.__iterator(ITERATE_VALUES);
        },
        // ### More sequential methods

        butLast: function butLast() {
          return this.slice(0, -1);
        },
        isEmpty: function isEmpty() {
          return this.size !== undefined ? this.size === 0 : !this.some(function () {
            return true;
          });
        },
        count: function count(predicate, context) {
          return ensureSize(predicate ? this.toSeq().filter(predicate, context) : this);
        },
        countBy: function countBy(grouper, context) {
          return countByFactory(this, grouper, context);
        },
        equals: function equals(other) {
          return deepEqual(this, other);
        },
        entrySeq: function entrySeq() {
          var iterable = this;
          if (iterable._cache) {
            // We cache as an entries array, so we can just return the cache!
            return new ArraySeq(iterable._cache);
          }
          var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
          entriesSequence.fromEntrySeq = function () {
            return iterable.toSeq();
          };
          return entriesSequence;
        },
        filterNot: function filterNot(predicate, context) {
          return this.filter(not(predicate), context);
        },
        findEntry: function findEntry(predicate, context, notSetValue) {
          var found = notSetValue;
          this.__iterate(function (v, k, c) {
            if (predicate.call(context, v, k, c)) {
              found = [k, v];
              return false;
            }
          });
          return found;
        },
        findKey: function findKey(predicate, context) {
          var entry = this.findEntry(predicate, context);
          return entry && entry[0];
        },
        findLast: function findLast(predicate, context, notSetValue) {
          return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
        },
        findLastEntry: function findLastEntry(predicate, context, notSetValue) {
          return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
        },
        findLastKey: function findLastKey(predicate, context) {
          return this.toKeyedSeq().reverse().findKey(predicate, context);
        },
        first: function first() {
          return this.find(returnTrue);
        },
        flatMap: function flatMap(mapper, context) {
          return reify(this, flatMapFactory(this, mapper, context));
        },
        flatten: function flatten(depth) {
          return reify(this, flattenFactory(this, depth, true));
        },
        fromEntrySeq: function fromEntrySeq() {
          return new FromEntriesSequence(this);
        },
        get: function get(searchKey, notSetValue) {
          return this.find(function (_, key) {
            return is(key, searchKey);
          }, undefined, notSetValue);
        },
        getIn: function getIn(searchKeyPath, notSetValue) {
          var nested = this;
          // Note: in an ES6 environment, we would prefer:
          // for (var key of searchKeyPath) {
          var iter = forceIterator(searchKeyPath);
          var step;
          while (!(step = iter.next()).done) {
            var key = step.value;
            nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
            if (nested === NOT_SET) {
              return notSetValue;
            }
          }
          return nested;
        },
        groupBy: function groupBy(grouper, context) {
          return groupByFactory(this, grouper, context);
        },
        has: function has(searchKey) {
          return this.get(searchKey, NOT_SET) !== NOT_SET;
        },
        hasIn: function hasIn(searchKeyPath) {
          return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
        },
        isSubset: function isSubset(iter) {
          iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
          return this.every(function (value) {
            return iter.includes(value);
          });
        },
        isSuperset: function isSuperset(iter) {
          iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
          return iter.isSubset(this);
        },
        keyOf: function keyOf(searchValue) {
          return this.findKey(function (value) {
            return is(value, searchValue);
          });
        },
        keySeq: function keySeq() {
          return this.toSeq().map(keyMapper).toIndexedSeq();
        },
        last: function last() {
          return this.toSeq().reverse().first();
        },
        lastKeyOf: function lastKeyOf(searchValue) {
          return this.toKeyedSeq().reverse().keyOf(searchValue);
        },
        max: function max(comparator) {
          return maxFactory(this, comparator);
        },
        maxBy: function maxBy(mapper, comparator) {
          return maxFactory(this, comparator, mapper);
        },
        min: function min(comparator) {
          return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
        },
        minBy: function minBy(mapper, comparator) {
          return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
        },
        rest: function rest() {
          return this.slice(1);
        },
        skip: function skip(amount) {
          return this.slice(Math.max(0, amount));
        },
        skipLast: function skipLast(amount) {
          return reify(this, this.toSeq().reverse().skip(amount).reverse());
        },
        skipWhile: function skipWhile(predicate, context) {
          return reify(this, skipWhileFactory(this, predicate, context, true));
        },
        skipUntil: function skipUntil(predicate, context) {
          return this.skipWhile(not(predicate), context);
        },
        sortBy: function sortBy(mapper, comparator) {
          return reify(this, sortFactory(this, comparator, mapper));
        },
        take: function take(amount) {
          return this.slice(0, Math.max(0, amount));
        },
        takeLast: function takeLast(amount) {
          return reify(this, this.toSeq().reverse().take(amount).reverse());
        },
        takeWhile: function takeWhile(predicate, context) {
          return reify(this, takeWhileFactory(this, predicate, context));
        },
        takeUntil: function takeUntil(predicate, context) {
          return this.takeWhile(not(predicate), context);
        },
        valueSeq: function valueSeq() {
          return this.toIndexedSeq();
        },
        // ### Hashable Object

        hashCode: function hashCode() {
          return this.__hash || (this.__hash = hashIterable(this));
        }

        // ### Internal

        // abstract __iterate(fn, reverse)

        // abstract __iterator(type, reverse)
      });

      // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
      // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
      // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
      // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

      var IterablePrototype = Iterable.prototype;
      IterablePrototype[IS_ITERABLE_SENTINEL] = true;
      IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
      IterablePrototype.__toJS = IterablePrototype.toArray;
      IterablePrototype.__toStringMapper = quoteString;
      IterablePrototype.inspect = IterablePrototype.toSource = function () {
        return this.toString();
      };
      IterablePrototype.chain = IterablePrototype.flatMap;
      IterablePrototype.contains = IterablePrototype.includes;
      mixin(KeyedIterable, {
        // ### More sequential methods

        flip: function flip() {
          return reify(this, flipFactory(this));
        },
        mapEntries: function mapEntries(mapper, context) {
          var this$0 = this;
          var iterations = 0;
          return reify(this, this.toSeq().map(function (v, k) {
            return mapper.call(context, [k, v], iterations++, this$0);
          }).fromEntrySeq());
        },
        mapKeys: function mapKeys(mapper, context) {
          var this$0 = this;
          return reify(this, this.toSeq().flip().map(function (k, v) {
            return mapper.call(context, k, v, this$0);
          }).flip());
        }
      });
      var KeyedIterablePrototype = KeyedIterable.prototype;
      KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
      KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
      KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
      KeyedIterablePrototype.__toStringMapper = function (v, k) {
        return JSON.stringify(k) + ': ' + quoteString(v);
      };
      mixin(IndexedIterable, {
        // ### Conversion to other types

        toKeyedSeq: function toKeyedSeq() {
          return new ToKeyedSequence(this, false);
        },
        // ### ES6 Collection methods (ES6 Array and Map)

        filter: function filter(predicate, context) {
          return reify(this, filterFactory(this, predicate, context, false));
        },
        findIndex: function findIndex(predicate, context) {
          var entry = this.findEntry(predicate, context);
          return entry ? entry[0] : -1;
        },
        indexOf: function indexOf(searchValue) {
          var key = this.keyOf(searchValue);
          return key === undefined ? -1 : key;
        },
        lastIndexOf: function lastIndexOf(searchValue) {
          var key = this.lastKeyOf(searchValue);
          return key === undefined ? -1 : key;
        },
        reverse: function reverse() {
          return reify(this, reverseFactory(this, false));
        },
        slice: function slice(begin, end) {
          return reify(this, sliceFactory(this, begin, end, false));
        },
        splice: function splice(index, removeNum /*, ...values*/) {
          var numArgs = arguments.length;
          removeNum = Math.max(removeNum | 0, 0);
          if (numArgs === 0 || numArgs === 2 && !removeNum) {
            return this;
          }
          // If index is negative, it should resolve relative to the size of the
          // collection. However size may be expensive to compute if not cached, so
          // only call count() if the number is in fact negative.
          index = resolveBegin(index, index < 0 ? this.count() : this.size);
          var spliced = this.slice(0, index);
          return reify(this, numArgs === 1 ? spliced : spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum)));
        },
        // ### More collection methods

        findLastIndex: function findLastIndex(predicate, context) {
          var entry = this.findLastEntry(predicate, context);
          return entry ? entry[0] : -1;
        },
        first: function first() {
          return this.get(0);
        },
        flatten: function flatten(depth) {
          return reify(this, flattenFactory(this, depth, false));
        },
        get: function get(index, notSetValue) {
          index = wrapIndex(this, index);
          return index < 0 || this.size === Infinity || this.size !== undefined && index > this.size ? notSetValue : this.find(function (_, key) {
            return key === index;
          }, undefined, notSetValue);
        },
        has: function has(index) {
          index = wrapIndex(this, index);
          return index >= 0 && (this.size !== undefined ? this.size === Infinity || index < this.size : this.indexOf(index) !== -1);
        },
        interpose: function interpose(separator) {
          return reify(this, interposeFactory(this, separator));
        },
        interleave: function interleave( /*...iterables*/
        ) {
          var iterables = [this].concat(arrCopy(arguments));
          var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
          var interleaved = zipped.flatten(true);
          if (zipped.size) {
            interleaved.size = zipped.size * iterables.length;
          }
          return reify(this, interleaved);
        },
        keySeq: function keySeq() {
          return Range(0, this.size);
        },
        last: function last() {
          return this.get(-1);
        },
        skipWhile: function skipWhile(predicate, context) {
          return reify(this, skipWhileFactory(this, predicate, context, false));
        },
        zip: function zip( /*, ...iterables */
        ) {
          var iterables = [this].concat(arrCopy(arguments));
          return reify(this, zipWithFactory(this, defaultZipper, iterables));
        },
        zipWith: function zipWith(zipper /*, ...iterables */) {
          var iterables = arrCopy(arguments);
          iterables[0] = this;
          return reify(this, zipWithFactory(this, zipper, iterables));
        }
      });
      IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
      IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
      mixin(SetIterable, {
        // ### ES6 Collection methods (ES6 Array and Map)

        get: function get(value, notSetValue) {
          return this.has(value) ? value : notSetValue;
        },
        includes: function includes(value) {
          return this.has(value);
        },
        // ### More sequential methods

        keySeq: function keySeq() {
          return this.valueSeq();
        }
      });
      SetIterable.prototype.has = IterablePrototype.includes;
      SetIterable.prototype.contains = SetIterable.prototype.includes;

      // Mixin subclasses

      mixin(KeyedSeq, KeyedIterable.prototype);
      mixin(IndexedSeq, IndexedIterable.prototype);
      mixin(SetSeq, SetIterable.prototype);
      mixin(KeyedCollection, KeyedIterable.prototype);
      mixin(IndexedCollection, IndexedIterable.prototype);
      mixin(SetCollection, SetIterable.prototype);

      // #pragma Helper functions

      function keyMapper(v, k) {
        return k;
      }
      function entryMapper(v, k) {
        return [k, v];
      }
      function not(predicate) {
        return function () {
          return !predicate.apply(this, arguments);
        };
      }
      function neg(predicate) {
        return function () {
          return -predicate.apply(this, arguments);
        };
      }
      function quoteString(value) {
        return typeof value === 'string' ? JSON.stringify(value) : String(value);
      }
      function defaultZipper() {
        return arrCopy(arguments);
      }
      function defaultNegComparator(a, b) {
        return a < b ? 1 : a > b ? -1 : 0;
      }
      function hashIterable(iterable) {
        if (iterable.size === Infinity) {
          return 0;
        }
        var ordered = isOrdered(iterable);
        var keyed = isKeyed(iterable);
        var h = ordered ? 1 : 0;
        var size = iterable.__iterate(keyed ? ordered ? function (v, k) {
          h = 31 * h + hashMerge(hash(v), hash(k)) | 0;
        } : function (v, k) {
          h = h + hashMerge(hash(v), hash(k)) | 0;
        } : ordered ? function (v) {
          h = 31 * h + hash(v) | 0;
        } : function (v) {
          h = h + hash(v) | 0;
        });
        return murmurHashOfSize(size, h);
      }
      function murmurHashOfSize(size, h) {
        h = imul(h, 0xCC9E2D51);
        h = imul(h << 15 | h >>> -15, 0x1B873593);
        h = imul(h << 13 | h >>> -13, 5);
        h = (h + 0xE6546B64 | 0) ^ size;
        h = imul(h ^ h >>> 16, 0x85EBCA6B);
        h = imul(h ^ h >>> 13, 0xC2B2AE35);
        h = smi(h ^ h >>> 16);
        return h;
      }
      function hashMerge(a, b) {
        return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
      }
      var Immutable = {
        Iterable: Iterable,
        Seq: Seq,
        Collection: Collection,
        Map: Map,
        OrderedMap: OrderedMap,
        List: List,
        Stack: Stack,
        Set: Set,
        OrderedSet: OrderedSet,
        Record: Record,
        Range: Range,
        Repeat: Repeat,
        is: is,
        fromJS: fromJS
      };
      return Immutable;
    });

    /***/
  }), ( /* 3 */
  /***/function (module, exports, __webpack_require__) {
    var store = __webpack_require__(191)('wks');
    var uid = __webpack_require__(129);
    var Symbol = __webpack_require__(19).Symbol;
    var USE_SYMBOL = typeof Symbol == 'function';
    var $exports = module.exports = function (name) {
      return store[name] || (store[name] = USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
    };
    $exports.store = store;

    /***/
  }), ( /* 4 */
  /***/function (module, exports) {
    module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

    /***/
  }), ( /* 5 */
  /***/function (module, exports) {
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        "default": obj
      };
    }
    module.exports = _interopRequireDefault;

    /***/
  }), ( /* 6 */
  /***/function (module, exports, __webpack_require__) {
    var global = __webpack_require__(19);
    var core = __webpack_require__(36);
    var hide = __webpack_require__(37);
    var redefine = __webpack_require__(50);
    var ctx = __webpack_require__(66);
    var PROTOTYPE = 'prototype';
    var $export = function $export(type, name, source) {
      var IS_FORCED = type & $export.F;
      var IS_GLOBAL = type & $export.G;
      var IS_STATIC = type & $export.S;
      var IS_PROTO = type & $export.P;
      var IS_BIND = type & $export.B;
      var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
      var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
      var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
      var key, own, out, exp;
      if (IS_GLOBAL) source = name;
      for (key in source) {
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        // export native or passed
        out = (own ? target : source)[key];
        // bind timers to global for call from export context
        exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
        // extend global
        if (target) redefine(target, key, out, type & $export.U);
        // export
        if (exports[key] != out) hide(exports, key, exp);
        if (IS_PROTO && expProto[key] != out) expProto[key] = out;
      }
    };
    global.core = core;
    // type bitmap
    $export.F = 1; // forced
    $export.G = 2; // global
    $export.S = 4; // static
    $export.P = 8; // proto
    $export.B = 16; // bind
    $export.W = 32; // wrap
    $export.U = 64; // safe
    $export.R = 128; // real proto method for `library`
    module.exports = $export;

    /***/
  }), ( /* 7 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    var _assign = __webpack_require__(279);
    var _assign2 = _interopRequireDefault(_assign);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    exports.default = _assign2.default || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };

    /***/
  }), ( /* 8 */
  /***/function (module, exports, __webpack_require__) {
    var $export = __webpack_require__(6);
    var fails = __webpack_require__(68);
    var defined = __webpack_require__(30);
    var quot = /"/g;
    // B.2.3.2.1 CreateHTML(string, tag, attribute, value)
    var createHTML = function createHTML(string, tag, attribute, value) {
      var S = String(defined(string));
      var p1 = '<' + tag;
      if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
      return p1 + '>' + S + '</' + tag + '>';
    };
    module.exports = function (NAME, exec) {
      var O = {};
      O[NAME] = exec(createHTML);
      $export($export.P + $export.F * fails(function () {
        var test = ''[NAME]('"');
        return test !== test.toLowerCase() || test.split('"').length > 3;
      }), 'String', O);
    };

    /***/
  }), ( /* 9 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    /*!
     * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
     *
     * Copyright (c) 2014-2017, Jon Schlinkert.
     * Released under the MIT License.
     */
    var isObject = __webpack_require__(453);
    function isObjectObject(o) {
      return isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
    }
    module.exports = function isPlainObject(o) {
      var ctor, prot;
      if (isObjectObject(o) === false) return false;

      // If has modified constructor
      ctor = o.constructor;
      if (typeof ctor !== 'function') return false;

      // If has modified prototype
      prot = ctor.prototype;
      if (isObjectObject(prot) === false) return false;

      // If constructor does not have an Object-specific method
      if (prot.hasOwnProperty('isPrototypeOf') === false) {
        return false;
      }

      // Most likely a plain Object
      return true;
    };

    /***/
  }), ( /* 10 */
  /***/function (module, exports, __webpack_require__) {
    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    if (false) {
      var ReactIs = require('react-is');

      // By explicitly using `prop-types` you are opting into new development behavior.
      // http://fb.me/prop-types-in-prod
      var throwOnDirectAccess = true;
      module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
    } else {
      // By explicitly using `prop-types` you are opting into new production behavior.
      // http://fb.me/prop-types-in-prod
      module.exports = __webpack_require__(533)();
    }

    /***/
  }), ( /* 11 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    /**
     * Slate-specific model types.
     *
     * @type {Object}
     */

    var MODEL_TYPES = {
      BLOCK: '@@__SLATE_BLOCK__@@',
      CHANGE: '@@__SLATE_CHANGE__@@',
      CHARACTER: '@@__SLATE_CHARACTER__@@',
      DOCUMENT: '@@__SLATE_DOCUMENT__@@',
      HISTORY: '@@__SLATE_HISTORY__@@',
      INLINE: '@@__SLATE_INLINE__@@',
      MARK: '@@__SLATE_MARK__@@',
      RANGE: '@@__SLATE_RANGE__@@',
      SCHEMA: '@@__SLATE_SCHEMA__@@',
      SELECTION: '@@__SLATE_SELECTION__@@',
      STACK: '@@__SLATE_STACK__@@',
      STATE: '@@__SLATE_STATE__@@',
      TEXT: '@@__SLATE_TEXT__@@'
    };

    /**
     * Export.
     *
     * @type {Object}
     */

    exports.default = MODEL_TYPES;

    /***/
  }), ( /* 12 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    exports.default = function (instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    };

    /***/
  }), ( /* 13 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    var _setPrototypeOf = __webpack_require__(281);
    var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
    var _create = __webpack_require__(280);
    var _create2 = _interopRequireDefault(_create);
    var _typeof2 = __webpack_require__(167);
    var _typeof3 = _interopRequireDefault(_typeof2);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    exports.default = function (subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
      }
      subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
    };

    /***/
  }), ( /* 14 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    var _typeof2 = __webpack_require__(167);
    var _typeof3 = _interopRequireDefault(_typeof2);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    exports.default = function (self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
    };

    /***/
  }), ( /* 15 */
  /***/function (module, exports, __webpack_require__) {
    /**
     * Copyright 2013-present, Facebook, Inc.
     * All rights reserved.
     *
     * This source code is licensed under the BSD-style license found in the
     * LICENSE file in the root directory of this source tree. An additional grant
     * of patent rights can be found in the PATENTS file in the same directory.
     */

    if (false) {
      var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;
      var isValidElement = function isValidElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      };

      // By explicitly using `prop-types` you are opting into new development behavior.
      // http://fb.me/prop-types-in-prod
      var throwOnDirectAccess = true;
      module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
    } else {
      // By explicitly using `prop-types` you are opting into new production behavior.
      // http://fb.me/prop-types-in-prod
      module.exports = __webpack_require__(518)();
    }

    /***/
  }), ( /* 16 */
  /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    /* WEBPACK VAR INJECTION */
    (function (global) {
      Object.defineProperty(__webpack_exports__, "__esModule", {
        value: true
      });
      var global$1 = typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {};

      // shim for using process in browser
      // based off https://github.com/defunctzombie/node-process/blob/master/browser.js

      function defaultSetTimout() {
        throw new Error('setTimeout has not been defined');
      }
      function defaultClearTimeout() {
        throw new Error('clearTimeout has not been defined');
      }
      var cachedSetTimeout = defaultSetTimout;
      var cachedClearTimeout = defaultClearTimeout;
      if (typeof global$1.setTimeout === 'function') {
        cachedSetTimeout = setTimeout;
      }
      if (typeof global$1.clearTimeout === 'function') {
        cachedClearTimeout = clearTimeout;
      }
      function runTimeout(fun) {
        if (cachedSetTimeout === setTimeout) {
          //normal enviroments in sane situations
          return setTimeout(fun, 0);
        }
        // if setTimeout wasn't available but was latter defined
        if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
          cachedSetTimeout = setTimeout;
          return setTimeout(fun, 0);
        }
        try {
          // when when somebody has screwed with setTimeout but no I.E. maddness
          return cachedSetTimeout(fun, 0);
        } catch (e) {
          try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
          } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
          }
        }
      }
      function runClearTimeout(marker) {
        if (cachedClearTimeout === clearTimeout) {
          //normal enviroments in sane situations
          return clearTimeout(marker);
        }
        // if clearTimeout wasn't available but was latter defined
        if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
          cachedClearTimeout = clearTimeout;
          return clearTimeout(marker);
        }
        try {
          // when when somebody has screwed with setTimeout but no I.E. maddness
          return cachedClearTimeout(marker);
        } catch (e) {
          try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
          } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
          }
        }
      }
      var queue = [];
      var draining = false;
      var currentQueue;
      var queueIndex = -1;
      function cleanUpNextTick() {
        if (!draining || !currentQueue) {
          return;
        }
        draining = false;
        if (currentQueue.length) {
          queue = currentQueue.concat(queue);
        } else {
          queueIndex = -1;
        }
        if (queue.length) {
          drainQueue();
        }
      }
      function drainQueue() {
        if (draining) {
          return;
        }
        var timeout = runTimeout(cleanUpNextTick);
        draining = true;
        var len = queue.length;
        while (len) {
          currentQueue = queue;
          queue = [];
          while (++queueIndex < len) {
            if (currentQueue) {
              currentQueue[queueIndex].run();
            }
          }
          queueIndex = -1;
          len = queue.length;
        }
        currentQueue = null;
        draining = false;
        runClearTimeout(timeout);
      }
      function nextTick(fun) {
        var args = new Array(arguments.length - 1);
        if (arguments.length > 1) {
          for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
          }
        }
        queue.push(new Item(fun, args));
        if (queue.length === 1 && !draining) {
          runTimeout(drainQueue);
        }
      }
      // v8 likes predictible objects
      function Item(fun, array) {
        this.fun = fun;
        this.array = array;
      }
      Item.prototype.run = function () {
        this.fun.apply(null, this.array);
      };
      var title = 'browser';
      var platform = 'browser';
      var browser = true;
      var env = {};
      var argv = [];
      var version = ''; // empty string to avoid regexp issues
      var versions = {};
      var release = {};
      var config = {};
      function noop() {}
      var on = noop;
      var addListener = noop;
      var once = noop;
      var off = noop;
      var removeListener = noop;
      var removeAllListeners = noop;
      var emit = noop;
      function binding(name) {
        throw new Error('process.binding is not supported');
      }
      function cwd() {
        return '/';
      }
      function chdir(dir) {
        throw new Error('process.chdir is not supported');
      }
      function umask() {
        return 0;
      }

      // from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js
      var performance = global$1.performance || {};
      var performanceNow = performance.now || performance.mozNow || performance.msNow || performance.oNow || performance.webkitNow || function () {
        return new Date().getTime();
      };

      // generate timestamp or delta
      // see http://nodejs.org/api/process.html#process_process_hrtime
      function hrtime(previousTimestamp) {
        var clocktime = performanceNow.call(performance) * 1e-3;
        var seconds = Math.floor(clocktime);
        var nanoseconds = Math.floor(clocktime % 1 * 1e9);
        if (previousTimestamp) {
          seconds = seconds - previousTimestamp[0];
          nanoseconds = nanoseconds - previousTimestamp[1];
          if (nanoseconds < 0) {
            seconds--;
            nanoseconds += 1e9;
          }
        }
        return [seconds, nanoseconds];
      }
      var startTime = new Date();
      function uptime() {
        var currentTime = new Date();
        var dif = currentTime - startTime;
        return dif / 1000;
      }
      var process = {
        nextTick: nextTick,
        title: title,
        browser: browser,
        env: env,
        argv: argv,
        version: version,
        versions: versions,
        on: on,
        addListener: addListener,
        once: once,
        off: off,
        removeListener: removeListener,
        removeAllListeners: removeAllListeners,
        emit: emit,
        binding: binding,
        cwd: cwd,
        chdir: chdir,
        umask: umask,
        hrtime: hrtime,
        platform: platform,
        release: release,
        config: config,
        uptime: uptime
      };

      /* eslint-disable no-console */

      /**
       * Is deprecate interface forbidden?
       */

      var FORBID_DEPRECATE = process && process.env && process.env.FORBID_DEPRECATIONS;

      /**
       * Is warning scenarios forbidden?
       */

      var FORBID_WARNING = process && process.env && process.env.FORBID_WARNINGS;

      /**
       * Is in development?
       *
       * @type {Boolean}
       */

      var IS_DEV = typeof process !== 'undefined' && process.env && "development" !== 'production';

      /**
       * Has console?
       *
       * @type {Boolean}
       */

      var HAS_CONSOLE = typeof console != 'undefined' && typeof console.log == 'function' && typeof console.warn == 'function' && typeof console.error == 'function';

      /**
       * Log a `message` at `level`.
       *
       * @param {String} level
       * @param {String} message
       * @param {Any} ...args
       */

      function log(level, message) {
        if (!IS_DEV) {
          return;
        }
        if (HAS_CONSOLE) {
          var _console;
          for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            args[_key - 2] = arguments[_key];
          }
          (_console = console)[level].apply(_console, [message].concat(args));
        }
      }

      /**
       * Log an error `message`.
       *
       * @param {String} message
       * @param {Any} ...args
       */

      function error(message) {
        if (HAS_CONSOLE) {
          var _console2;
          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }
          (_console2 = console).error.apply(_console2, [message].concat(args));
        }
      }

      /**
       * Log a warning `message` in development only.
       *
       * @param {String} message
       * @param {Any} ...args
       */

      function warn(message) {
        var logger = FORBID_WARNING ? forbidden : log;
        for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          args[_key3 - 1] = arguments[_key3];
        }
        logger.apply(undefined, ['warn', 'Warning: ' + message].concat(args));
      }

      /**
       * Log a deprecation warning `message`, with helpful `version` number in
       * development only.
       *
       * @param {String} version
       * @param {String} message
       * @param {Any} ...args
       */

      function deprecate(version$$1, message) {
        var logger = FORBID_DEPRECATE ? forbidden : log;
        for (var _len4 = arguments.length, args = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
          args[_key4 - 2] = arguments[_key4];
        }
        logger.apply(undefined, ['warn', 'Deprecation (' + version$$1 + '): ' + message].concat(args));
      }
      function forbidden(level, message) {
        throw new Error(message);
      }

      /**
       * Export.
       *
       * @type {Function}
       */

      var index = {
        deprecate: deprecate,
        error: error,
        warn: warn
      };

      /* harmony default export */
      __webpack_exports__["default"] = index;

      /* WEBPACK VAR INJECTION */
    }).call(__webpack_exports__, __webpack_require__(80));

    /***/
  }), ( /* 17 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    exports.default = function (obj, keys) {
      var target = {};
      for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
      }
      return target;
    };

    /***/
  }), ( /* 18 */
  /***/function (module, exports) {
    var core = module.exports = {
      version: '2.6.9'
    };
    if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

    /***/
  }), ( /* 19 */
  /***/function (module, exports) {
    // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
    var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self
    // eslint-disable-next-line no-new-func
    : Function('return this')();
    if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

    /***/
  }), ( /* 20 */
  /***/function (module, exports, __webpack_require__) {
    /* WEBPACK VAR INJECTION */(function (process) {
      /**
      * This is the web browser implementation of `debug()`.
      *
      * Expose `debug()` as the module.
      */

      exports = module.exports = __webpack_require__(389);
      exports.log = log;
      exports.formatArgs = formatArgs;
      exports.save = save;
      exports.load = load;
      exports.useColors = useColors;
      exports.storage = 'undefined' != typeof chrome && 'undefined' != typeof chrome.storage ? chrome.storage.local : localstorage();

      /**
       * Colors.
       */

      exports.colors = ['lightseagreen', 'forestgreen', 'goldenrod', 'dodgerblue', 'darkorchid', 'crimson'];

      /**
       * Currently only WebKit-based Web Inspectors, Firefox >= v31,
       * and the Firebug extension (any Firefox version) are known
       * to support "%c" CSS customizations.
       *
       * TODO: add a `localStorage` variable to explicitly enable/disable colors
       */

      function useColors() {
        // NB: In an Electron preload script, document will be defined but not fully
        // initialized. Since we know we're in Chrome, we'll just detect this case
        // explicitly
        if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
          return true;
        }

        // is webkit? http://stackoverflow.com/a/16459606/376773
        // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
        return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance ||
        // is firebug? http://stackoverflow.com/a/398120/376773
        typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) ||
        // is firefox >= v31?
        // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
        typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 ||
        // double check webkit in userAgent just in case we are in a worker
        typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
      }

      /**
       * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
       */

      exports.formatters.j = function (v) {
        try {
          return JSON.stringify(v);
        } catch (err) {
          return '[UnexpectedJSONParseError]: ' + err.message;
        }
      };

      /**
       * Colorize log arguments if enabled.
       *
       * @api public
       */

      function formatArgs(args) {
        var useColors = this.useColors;
        args[0] = (useColors ? '%c' : '') + this.namespace + (useColors ? ' %c' : ' ') + args[0] + (useColors ? '%c ' : ' ') + '+' + exports.humanize(this.diff);
        if (!useColors) return;
        var c = 'color: ' + this.color;
        args.splice(1, 0, c, 'color: inherit');

        // the final "%c" is somewhat tricky, because there could be other
        // arguments passed either before or after the %c, so we need to
        // figure out the correct index to insert the CSS into
        var index = 0;
        var lastC = 0;
        args[0].replace(/%[a-zA-Z%]/g, function (match) {
          if ('%%' === match) return;
          index++;
          if ('%c' === match) {
            // we only are interested in the *last* %c
            // (the user may have provided their own)
            lastC = index;
          }
        });
        args.splice(lastC, 0, c);
      }

      /**
       * Invokes `console.log()` when available.
       * No-op when `console.log` is not a "function".
       *
       * @api public
       */

      function log() {
        // this hackery is required for IE8/9, where
        // the `console.log` function doesn't have 'apply'
        return 'object' === typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
      }

      /**
       * Save `namespaces`.
       *
       * @param {String} namespaces
       * @api private
       */

      function save(namespaces) {
        try {
          if (null == namespaces) {
            exports.storage.removeItem('debug');
          } else {
            exports.storage.debug = namespaces;
          }
        } catch (e) {}
      }

      /**
       * Load `namespaces`.
       *
       * @return {String} returns the previously persisted debug modes
       * @api private
       */

      function load() {
        var r;
        try {
          r = exports.storage.debug;
        } catch (e) {}

        // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
        if (!r && typeof process !== 'undefined' && 'env' in process) {
          r = process.env.DEBUG;
        }
        return r;
      }

      /**
       * Enable namespaces listed in `localStorage.debug` initially.
       */

      exports.enable(load());

      /**
       * Localstorage attempts to return the localstorage.
       *
       * This is necessary because safari throws
       * when a user disables cookies/localstorage
       * and you attempt to access it.
       *
       * @return {LocalStorage}
       * @api private
       */

      function localstorage() {
        try {
          return window.localStorage;
        } catch (e) {}
      }

      /* WEBPACK VAR INJECTION */
    }).call(exports, __webpack_require__(217));

    /***/
  }), ( /* 21 */
  /***/function (module, exports, __webpack_require__) {
    var store = __webpack_require__(116)('wks');
    var uid = __webpack_require__(83);
    var Symbol = __webpack_require__(29).Symbol;
    var USE_SYMBOL = typeof Symbol == 'function';
    var $exports = module.exports = function (name) {
      return store[name] || (store[name] = USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
    };
    $exports.store = store;

    /***/
  }), ( /* 22 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.setKeyGenerator = exports.resetKeyGenerator = exports.Changes = exports.Text = exports.State = exports.Stack = exports.Selection = exports.Schema = exports.Range = exports.Operations = exports.Node = exports.Mark = exports.Inline = exports.History = exports.Document = exports.Data = exports.Character = exports.Block = undefined;
    var _block = __webpack_require__(55);
    var _block2 = _interopRequireDefault(_block);
    var _character = __webpack_require__(145);
    var _character2 = _interopRequireDefault(_character);
    var _data = __webpack_require__(146);
    var _data2 = _interopRequireDefault(_data);
    var _document = __webpack_require__(74);
    var _document2 = _interopRequireDefault(_document);
    var _history = __webpack_require__(230);
    var _history2 = _interopRequireDefault(_history);
    var _inline = __webpack_require__(56);
    var _inline2 = _interopRequireDefault(_inline);
    var _mark = __webpack_require__(42);
    var _mark2 = _interopRequireDefault(_mark);
    var _node = __webpack_require__(43);
    var _node2 = _interopRequireDefault(_node);
    var _schema = __webpack_require__(99);
    var _schema2 = _interopRequireDefault(_schema);
    var _selection = __webpack_require__(147);
    var _selection2 = _interopRequireDefault(_selection);
    var _stack = __webpack_require__(578);
    var _stack2 = _interopRequireDefault(_stack);
    var _state = __webpack_require__(579);
    var _state2 = _interopRequireDefault(_state);
    var _text = __webpack_require__(148);
    var _text2 = _interopRequireDefault(_text);
    var _range = __webpack_require__(231);
    var _range2 = _interopRequireDefault(_range);
    var _operations = __webpack_require__(580);
    var _operations2 = _interopRequireDefault(_operations);
    var _changes = __webpack_require__(229);
    var _changes2 = _interopRequireDefault(_changes);
    var _generateKey = __webpack_require__(57);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    /**
     * Export.
     *
     * @type {Object}
     */

    /**
     * Changes.
     */

    exports.Block = _block2.default;
    exports.Character = _character2.default;
    exports.Data = _data2.default;
    exports.Document = _document2.default;
    exports.History = _history2.default;
    exports.Inline = _inline2.default;
    exports.Mark = _mark2.default;
    exports.Node = _node2.default;
    exports.Operations = _operations2.default;
    exports.Range = _range2.default;
    exports.Schema = _schema2.default;
    exports.Selection = _selection2.default;
    exports.Stack = _stack2.default;
    exports.State = _state2.default;
    exports.Text = _text2.default;
    exports.Changes = _changes2.default;
    exports.resetKeyGenerator = _generateKey.resetKeyGenerator;
    exports.setKeyGenerator = _generateKey.setKeyGenerator;

    /**
     * Utils.
     */

    /**
     * Operations.
     */

    /**
     * Models.
     */

    exports.default = {
      Block: _block2.default,
      Character: _character2.default,
      Data: _data2.default,
      Document: _document2.default,
      History: _history2.default,
      Inline: _inline2.default,
      Mark: _mark2.default,
      Node: _node2.default,
      Operations: _operations2.default,
      Range: _range2.default,
      Schema: _schema2.default,
      Selection: _selection2.default,
      Stack: _stack2.default,
      State: _state2.default,
      Text: _text2.default,
      Changes: _changes2.default,
      resetKeyGenerator: _generateKey.resetKeyGenerator,
      setKeyGenerator: _generateKey.setKeyGenerator
    };

    /***/
  }), ( /* 23 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var isValue = __webpack_require__(51);
    module.exports = function (value) {
      if (!isValue(value)) throw new TypeError("Cannot use null or undefined");
      return value;
    };

    /***/
  }), ( /* 24 */
  /***/function (module, exports, __webpack_require__) {
    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; /*!
                                                                     Copyright (c) 2017 Jed Watson.
                                                                     Licensed under the MIT License (MIT), see
                                                                     http://jedwatson.github.io/classnames
                                                                     */
    /* global define */

    (function () {
      'use strict';

      var hasOwn = {}.hasOwnProperty;
      function classNames() {
        var classes = [];
        for (var i = 0; i < arguments.length; i++) {
          var arg = arguments[i];
          if (!arg) continue;
          var argType = typeof arg;
          if (argType === 'string' || argType === 'number') {
            classes.push(arg);
          } else if (Array.isArray(arg) && arg.length) {
            var inner = classNames.apply(null, arg);
            if (inner) {
              classes.push(inner);
            }
          } else if (argType === 'object') {
            for (var key in arg) {
              if (hasOwn.call(arg, key) && arg[key]) {
                classes.push(key);
              }
            }
          }
        }
        return classes.join(' ');
      }
      if (typeof module !== 'undefined' && module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
      } else if (true) {
        // register as 'classnames', consistent with npm package name
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
          return classNames;
        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      } else {
        window.classNames = classNames;
      }
    })();

    /***/
  }), ( /* 25 */
  /***/function (module, exports, __webpack_require__) {
    var freeGlobal = __webpack_require__(239);

    /** Detect free variable `self`. */
    var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

    /** Used as a reference to the global object. */
    var root = freeGlobal || freeSelf || Function('return this')();
    module.exports = root;

    /***/
  }), ( /* 26 */
  /***/function (module, exports) {
    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;
    module.exports = isArray;

    /***/
  }), ( /* 27 */
  /***/function (module, exports, __webpack_require__) {
    // Thank's IE8 for his funny defineProperty
    module.exports = !__webpack_require__(60)(function () {
      return Object.defineProperty({}, 'a', {
        get: function get() {
          return 7;
        }
      }).a != 7;
    });

    /***/
  }), ( /* 28 */
  /***/function (module, exports, __webpack_require__) {
    var global = __webpack_require__(29);
    var core = __webpack_require__(18);
    var ctx = __webpack_require__(109);
    var hide = __webpack_require__(46);
    var has = __webpack_require__(33);
    var PROTOTYPE = 'prototype';
    var $export = function $export(type, name, source) {
      var IS_FORCED = type & $export.F;
      var IS_GLOBAL = type & $export.G;
      var IS_STATIC = type & $export.S;
      var IS_PROTO = type & $export.P;
      var IS_BIND = type & $export.B;
      var IS_WRAP = type & $export.W;
      var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
      var expProto = exports[PROTOTYPE];
      var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
      var key, own, out;
      if (IS_GLOBAL) source = name;
      for (key in source) {
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && has(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
        // bind timers to global for call from export context
        : IS_BIND && own ? ctx(out, global)
        // wrap global constructors for prevent change them in library
        : IS_WRAP && target[key] == out ? function (C) {
          var F = function F(a, b, c) {
            if (this instanceof C) {
              switch (arguments.length) {
                case 0:
                  return new C();
                case 1:
                  return new C(a);
                case 2:
                  return new C(a, b);
              }
              return new C(a, b, c);
            }
            return C.apply(this, arguments);
          };
          F[PROTOTYPE] = C[PROTOTYPE];
          return F;
          // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
          (exports.virtual || (exports.virtual = {}))[key] = out;
          // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
          if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
        }
      }
    };
    // type bitmap
    $export.F = 1; // forced
    $export.G = 2; // global
    $export.S = 4; // static
    $export.P = 8; // proto
    $export.B = 16; // bind
    $export.W = 32; // wrap
    $export.U = 64; // safe
    $export.R = 128; // real proto method for `library`
    module.exports = $export;

    /***/
  }), ( /* 29 */
  /***/function (module, exports) {
    // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
    var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self
    // eslint-disable-next-line no-new-func
    : Function('return this')();
    if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

    /***/
  }), ( /* 30 */
  /***/function (module, exports) {
    // 7.2.1 RequireObjectCoercible(argument)
    module.exports = function (it) {
      if (it == undefined) throw TypeError("Can't call method on  " + it);
      return it;
    };

    /***/
  }), ( /* 31 */
  /***/function (module, exports, __webpack_require__) {
    // 7.1.15 ToLength
    var toInteger = __webpack_require__(71);
    var min = Math.min;
    module.exports = function (it) {
      return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
    };

    /***/
  }), ( /* 32 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    module.exports = __webpack_require__(440)() ? Symbol : __webpack_require__(442);

    /***/
  }), ( /* 33 */
  /***/function (module, exports) {
    var hasOwnProperty = {}.hasOwnProperty;
    module.exports = function (it, key) {
      return hasOwnProperty.call(it, key);
    };

    /***/
  }), ( /* 34 */
  /***/function (module, exports, __webpack_require__) {
    var anObject = __webpack_require__(45);
    var IE8_DOM_DEFINE = __webpack_require__(169);
    var toPrimitive = __webpack_require__(118);
    var dP = Object.defineProperty;
    exports.f = __webpack_require__(27) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
      anObject(O);
      P = toPrimitive(P, true);
      anObject(Attributes);
      if (IE8_DOM_DEFINE) try {
        return dP(O, P, Attributes);
      } catch (e) {/* empty */}
      if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
      if ('value' in Attributes) O[P] = Attributes.value;
      return O;
    };

    /***/
  }), ( /* 35 */
  /***/function (module, exports, __webpack_require__) {
    // to indexed object, toObject with fallback for non-array-like ES3 strings
    var IObject = __webpack_require__(170);
    var defined = __webpack_require__(110);
    module.exports = function (it) {
      return IObject(defined(it));
    };

    /***/
  }), ( /* 36 */
  /***/function (module, exports) {
    var core = module.exports = {
      version: '2.5.0'
    };
    if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

    /***/
  }), ( /* 37 */
  /***/function (module, exports, __webpack_require__) {
    var dP = __webpack_require__(86);
    var createDesc = __webpack_require__(190);
    module.exports = __webpack_require__(67) ? function (object, key, value) {
      return dP.f(object, key, createDesc(1, value));
    } : function (object, key, value) {
      object[key] = value;
      return object;
    };

    /***/
  }), ( /* 38 */
  /***/function (module, exports) {
    module.exports = function (it) {
      return typeof it === 'object' ? it !== null : typeof it === 'function';
    };

    /***/
  }), ( /* 39 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var isValue = __webpack_require__(58),
      isPlainFunction = __webpack_require__(251),
      assign = __webpack_require__(131),
      normalizeOpts = __webpack_require__(206),
      contains = __webpack_require__(209);
    var d = module.exports = function (dscr, value /*, options*/) {
      var c, e, w, options, desc;
      if (arguments.length < 2 || typeof dscr !== "string") {
        options = value;
        value = dscr;
        dscr = null;
      } else {
        options = arguments[2];
      }
      if (isValue(dscr)) {
        c = contains.call(dscr, "c");
        e = contains.call(dscr, "e");
        w = contains.call(dscr, "w");
      } else {
        c = w = true;
        e = false;
      }
      desc = {
        value: value,
        configurable: c,
        enumerable: e,
        writable: w
      };
      return !options ? desc : assign(normalizeOpts(options), desc);
    };
    d.gs = function (dscr, get, set /*, options*/) {
      var c, e, options, desc;
      if (typeof dscr !== "string") {
        options = set;
        set = get;
        get = dscr;
        dscr = null;
      } else {
        options = arguments[3];
      }
      if (!isValue(get)) {
        get = undefined;
      } else if (!isPlainFunction(get)) {
        options = get;
        get = set = undefined;
      } else if (!isValue(set)) {
        set = undefined;
      } else if (!isPlainFunction(set)) {
        options = set;
        set = undefined;
      }
      if (isValue(dscr)) {
        c = contains.call(dscr, "c");
        e = contains.call(dscr, "e");
      } else {
        c = true;
        e = false;
      }
      desc = {
        get: get,
        set: set,
        configurable: c,
        enumerable: e
      };
      return !options ? desc : assign(normalizeOpts(options), desc);
    };

    /***/
  }), ( /* 40 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    module.exports = function (fn) {
      if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
      return fn;
    };

    /***/
  }), ( /* 41 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    exports._curry = exports.bsSizes = exports.bsStyles = exports.bsClass = undefined;
    var _entries = __webpack_require__(166);
    var _entries2 = _interopRequireDefault(_entries);
    var _extends2 = __webpack_require__(7);
    var _extends3 = _interopRequireDefault(_extends2);
    exports.prefix = prefix;
    exports.getClassSet = getClassSet;
    exports.splitBsProps = splitBsProps;
    exports.splitBsPropsAndOmit = splitBsPropsAndOmit;
    exports.addStyle = addStyle;
    var _invariant = __webpack_require__(133);
    var _invariant2 = _interopRequireDefault(_invariant);
    var _propTypes = __webpack_require__(10);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _StyleConfig = __webpack_require__(220);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        'default': obj
      };
    }
    function curry(fn) {
      return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        var last = args[args.length - 1];
        if (typeof last === 'function') {
          return fn.apply(undefined, args);
        }
        return function (Component) {
          return fn.apply(undefined, args.concat([Component]));
        };
      };
    } // TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.

    function prefix(props, variant) {
      !(props.bsClass != null) ? false ? (0, _invariant2['default'])(false, 'A `bsClass` prop is required for this component') : (0, _invariant2['default'])(false) : void 0;
      return props.bsClass + (variant ? '-' + variant : '');
    }
    var bsClass = exports.bsClass = curry(function (defaultClass, Component) {
      var propTypes = Component.propTypes || (Component.propTypes = {});
      var defaultProps = Component.defaultProps || (Component.defaultProps = {});
      propTypes.bsClass = _propTypes2['default'].string;
      defaultProps.bsClass = defaultClass;
      return Component;
    });
    var bsStyles = exports.bsStyles = curry(function (styles, defaultStyle, Component) {
      if (typeof defaultStyle !== 'string') {
        Component = defaultStyle;
        defaultStyle = undefined;
      }
      var existing = Component.STYLES || [];
      var propTypes = Component.propTypes || {};
      styles.forEach(function (style) {
        if (existing.indexOf(style) === -1) {
          existing.push(style);
        }
      });
      var propType = _propTypes2['default'].oneOf(existing);

      // expose the values on the propType function for documentation
      Component.STYLES = propType._values = existing;
      Component.propTypes = (0, _extends3['default'])({}, propTypes, {
        bsStyle: propType
      });
      if (defaultStyle !== undefined) {
        var defaultProps = Component.defaultProps || (Component.defaultProps = {});
        defaultProps.bsStyle = defaultStyle;
      }
      return Component;
    });
    var bsSizes = exports.bsSizes = curry(function (sizes, defaultSize, Component) {
      if (typeof defaultSize !== 'string') {
        Component = defaultSize;
        defaultSize = undefined;
      }
      var existing = Component.SIZES || [];
      var propTypes = Component.propTypes || {};
      sizes.forEach(function (size) {
        if (existing.indexOf(size) === -1) {
          existing.push(size);
        }
      });
      var values = [];
      existing.forEach(function (size) {
        var mappedSize = _StyleConfig.SIZE_MAP[size];
        if (mappedSize && mappedSize !== size) {
          values.push(mappedSize);
        }
        values.push(size);
      });
      var propType = _propTypes2['default'].oneOf(values);
      propType._values = values;

      // expose the values on the propType function for documentation
      Component.SIZES = existing;
      Component.propTypes = (0, _extends3['default'])({}, propTypes, {
        bsSize: propType
      });
      if (defaultSize !== undefined) {
        if (!Component.defaultProps) {
          Component.defaultProps = {};
        }
        Component.defaultProps.bsSize = defaultSize;
      }
      return Component;
    });
    function getClassSet(props) {
      var _classes;
      var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);
      if (props.bsSize) {
        var bsSize = _StyleConfig.SIZE_MAP[props.bsSize] || props.bsSize;
        classes[prefix(props, bsSize)] = true;
      }
      if (props.bsStyle) {
        classes[prefix(props, props.bsStyle)] = true;
      }
      return classes;
    }
    function getBsProps(props) {
      return {
        bsClass: props.bsClass,
        bsSize: props.bsSize,
        bsStyle: props.bsStyle,
        bsRole: props.bsRole
      };
    }
    function isBsProp(propName) {
      return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
    }
    function splitBsProps(props) {
      var elementProps = {};
      (0, _entries2['default'])(props).forEach(function (_ref) {
        var propName = _ref[0],
          propValue = _ref[1];
        if (!isBsProp(propName)) {
          elementProps[propName] = propValue;
        }
      });
      return [getBsProps(props), elementProps];
    }
    function splitBsPropsAndOmit(props, omittedPropNames) {
      var isOmittedProp = {};
      omittedPropNames.forEach(function (propName) {
        isOmittedProp[propName] = true;
      });
      var elementProps = {};
      (0, _entries2['default'])(props).forEach(function (_ref2) {
        var propName = _ref2[0],
          propValue = _ref2[1];
        if (!isBsProp(propName) && !isOmittedProp[propName]) {
          elementProps[propName] = propValue;
        }
      });
      return [getBsProps(props), elementProps];
    }

    /**
     * Add a style variant to a Component. Mutates the propTypes of the component
     * in order to validate the new variant.
     */
    function addStyle(Component) {
      for (var _len2 = arguments.length, styleVariant = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        styleVariant[_key2 - 1] = arguments[_key2];
      }
      bsStyles(styleVariant, Component);
    }
    var _curry = exports._curry = curry;

    /***/
  }), ( /* 42 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    var _isPlainObject = __webpack_require__(9);
    var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
    var _immutable = __webpack_require__(2);
    var _modelTypes = __webpack_require__(11);
    var _modelTypes2 = _interopRequireDefault(_modelTypes);
    var _data = __webpack_require__(146);
    var _data2 = _interopRequireDefault(_data);
    var _memoize = __webpack_require__(150);
    var _memoize2 = _interopRequireDefault(_memoize);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    /**
     * Default properties.
     *
     * @type {Object}
     */

    var DEFAULTS = {
      data: new _immutable.Map(),
      type: undefined
    };

    /**
     * Mark.
     *
     * @type {Mark}
     */

    var Mark = function (_Record) {
      _inherits(Mark, _Record);
      function Mark() {
        _classCallCheck(this, Mark);
        return _possibleConstructorReturn(this, (Mark.__proto__ || Object.getPrototypeOf(Mark)).apply(this, arguments));
      }
      _createClass(Mark, [{
        key: 'getComponent',
        /**
         * Get the component for the node from a `schema`.
         *
         * @param {Schema} schema
         * @return {Component|Void}
         */

        value: function getComponent(schema) {
          return schema.__getComponent(this);
        }

        /**
         * Return a JSON representation of the mark.
         *
         * @return {Object}
         */
      }, {
        key: 'toJSON',
        value: function toJSON() {
          var object = {
            data: this.data.toJSON(),
            kind: this.kind,
            type: this.type
          };
          return object;
        }

        /**
         * Alias `toJS`.
         */
      }, {
        key: 'toJS',
        value: function toJS() {
          return this.toJSON();
        }
      }, {
        key: 'kind',
        /**
         * Get the kind.
         */

        get: function get() {
          return 'mark';
        }
      }], [{
        key: 'create',
        /**
         * Create a new `Mark` with `attrs`.
         *
         * @param {Object|Mark} attrs
         * @return {Mark}
         */

        value: function create() {
          var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          if (Mark.isMark(attrs)) {
            return attrs;
          }
          if (typeof attrs == 'string') {
            attrs = {
              type: attrs
            };
          }
          if ((0, _isPlainObject2.default)(attrs)) {
            return Mark.fromJSON(attrs);
          }
          throw new Error('`Mark.create` only accepts objects, strings or marks, but you passed it: ' + attrs);
        }

        /**
         * Create a set of marks.
         *
         * @param {Array<Object|Mark>} elements
         * @return {Set<Mark>}
         */
      }, {
        key: 'createSet',
        value: function createSet(elements) {
          if (_immutable.Set.isSet(elements) || Array.isArray(elements)) {
            var marks = new _immutable.Set(elements.map(Mark.create));
            return marks;
          }
          if (elements == null) {
            return new _immutable.Set();
          }
          throw new Error('`Mark.createSet` only accepts sets, arrays or null, but you passed it: ' + elements);
        }

        /**
         * Create a dictionary of settable mark properties from `attrs`.
         *
         * @param {Object|String|Mark} attrs
         * @return {Object}
         */
      }, {
        key: 'createProperties',
        value: function createProperties() {
          var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          if (Mark.isMark(attrs)) {
            return {
              data: attrs.data,
              type: attrs.type
            };
          }
          if (typeof attrs == 'string') {
            return {
              type: attrs
            };
          }
          if ((0, _isPlainObject2.default)(attrs)) {
            var props = {};
            if ('type' in attrs) props.type = attrs.type;
            if ('data' in attrs) props.data = _data2.default.create(attrs.data);
            return props;
          }
          throw new Error('`Mark.createProperties` only accepts objects, strings or marks, but you passed it: ' + attrs);
        }

        /**
         * Create a `Mark` from a JSON `object`.
         *
         * @param {Object} object
         * @return {Mark}
         */
      }, {
        key: 'fromJSON',
        value: function fromJSON(object) {
          var _object$data = object.data,
            data = _object$data === undefined ? {} : _object$data,
            type = object.type;
          if (typeof type != 'string') {
            throw new Error('`Mark.fromJS` requires a `type` string.');
          }
          var mark = new Mark({
            type: type,
            data: new _immutable.Map(data)
          });
          return mark;
        }

        /**
         * Alias `fromJS`.
         */
      }, {
        key: 'isMark',
        /**
         * Check if a `value` is a `Mark`.
         *
         * @param {Any} value
         * @return {Boolean}
         */

        value: function isMark(value) {
          return !!(value && value[_modelTypes2.default.MARK]);
        }

        /**
         * Check if a `value` is a set of marks.
         *
         * @param {Any} value
         * @return {Boolean}
         */
      }, {
        key: 'isMarkSet',
        value: function isMarkSet(value) {
          return _immutable.Set.isSet(value) && value.every(function (item) {
            return Mark.isMark(item);
          });
        }
      }]);
      return Mark;
    }((0, _immutable.Record)(DEFAULTS));

    /**
     * Attach a pseudo-symbol for type checking.
     */

    Mark.fromJS = Mark.fromJSON;
    Mark.prototype[_modelTypes2.default.MARK] = true;

    /**
     * Memoize read methods.
     */

    (0, _memoize2.default)(Mark.prototype, ['getComponent'], {
      takesArguments: true
    });

    /**
     * Export.
     *
     * @type {Mark}
     */

    exports.default = Mark;

    /***/
  }), ( /* 43 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    var _direction = __webpack_require__(390);
    var _direction2 = _interopRequireDefault(_direction);
    var _isPlainObject = __webpack_require__(9);
    var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
    var _slateDevLogger = __webpack_require__(16);
    var _slateDevLogger2 = _interopRequireDefault(_slateDevLogger);
    var _immutable = __webpack_require__(2);
    var _block = __webpack_require__(55);
    var _block2 = _interopRequireDefault(_block);
    var _data = __webpack_require__(146);
    var _data2 = _interopRequireDefault(_data);
    var _document = __webpack_require__(74);
    var _document2 = _interopRequireDefault(_document);
    var _inline = __webpack_require__(56);
    var _inline2 = _interopRequireDefault(_inline);
    var _text = __webpack_require__(148);
    var _text2 = _interopRequireDefault(_text);
    var _generateKey = __webpack_require__(57);
    var _generateKey2 = _interopRequireDefault(_generateKey);
    var _isIndexInRange = __webpack_require__(581);
    var _isIndexInRange2 = _interopRequireDefault(_isIndexInRange);
    var _memoize = __webpack_require__(150);
    var _memoize2 = _interopRequireDefault(_memoize);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    /**
     * Node.
     *
     * And interface that `Document`, `Block` and `Inline` all implement, to make
     * working with the recursive node tree easier.
     *
     * @type {Node}
     */

    var Node = function () {
      function Node() {
        _classCallCheck(this, Node);
      }
      _createClass(Node, [{
        key: 'areDescendantsSorted',
        /**
         * True if the node has both descendants in that order, false otherwise. The
         * order is depth-first, post-order.
         *
         * @param {String} first
         * @param {String} second
         * @return {Boolean}
         */

        value: function areDescendantsSorted(first, second) {
          first = normalizeKey(first);
          second = normalizeKey(second);
          var sorted = void 0;
          this.forEachDescendant(function (n) {
            if (n.key === first) {
              sorted = true;
              return false;
            } else if (n.key === second) {
              sorted = false;
              return false;
            }
          });
          return sorted;
        }

        /**
         * Assert that a node has a child by `key` and return it.
         *
         * @param {String} key
         * @return {Node}
         */
      }, {
        key: 'assertChild',
        value: function assertChild(key) {
          var child = this.getChild(key);
          if (!child) {
            key = normalizeKey(key);
            throw new Error('Could not find a child node with key "' + key + '".');
          }
          return child;
        }

        /**
         * Assert that a node has a descendant by `key` and return it.
         *
         * @param {String} key
         * @return {Node}
         */
      }, {
        key: 'assertDescendant',
        value: function assertDescendant(key) {
          var descendant = this.getDescendant(key);
          if (!descendant) {
            key = normalizeKey(key);
            throw new Error('Could not find a descendant node with key "' + key + '".');
          }
          return descendant;
        }

        /**
         * Assert that a node's tree has a node by `key` and return it.
         *
         * @param {String} key
         * @return {Node}
         */
      }, {
        key: 'assertNode',
        value: function assertNode(key) {
          var node = this.getNode(key);
          if (!node) {
            key = normalizeKey(key);
            throw new Error('Could not find a node with key "' + key + '".');
          }
          return node;
        }

        /**
         * Assert that a node exists at `path` and return it.
         *
         * @param {Array} path
         * @return {Node}
         */
      }, {
        key: 'assertPath',
        value: function assertPath(path) {
          var descendant = this.getDescendantAtPath(path);
          if (!descendant) {
            throw new Error('Could not find a descendant at path "' + path + '".');
          }
          return descendant;
        }

        /**
         * Recursively filter all descendant nodes with `iterator`.
         *
         * @param {Function} iterator
         * @return {List<Node>}
         */
      }, {
        key: 'filterDescendants',
        value: function filterDescendants(iterator) {
          var matches = [];
          this.forEachDescendant(function (node, i, nodes) {
            if (iterator(node, i, nodes)) matches.push(node);
          });
          return (0, _immutable.List)(matches);
        }

        /**
         * Recursively find all descendant nodes by `iterator`.
         *
         * @param {Function} iterator
         * @return {Node|Null}
         */
      }, {
        key: 'findDescendant',
        value: function findDescendant(iterator) {
          var found = null;
          this.forEachDescendant(function (node, i, nodes) {
            if (iterator(node, i, nodes)) {
              found = node;
              return false;
            }
          });
          return found;
        }

        /**
         * Recursively iterate over all descendant nodes with `iterator`. If the
         * iterator returns false it will break the loop.
         *
         * @param {Function} iterator
         */
      }, {
        key: 'forEachDescendant',
        value: function forEachDescendant(iterator) {
          var ret = void 0;
          this.nodes.forEach(function (child, i, nodes) {
            if (iterator(child, i, nodes) === false) {
              ret = false;
              return false;
            }
            if (child.kind != 'text') {
              ret = child.forEachDescendant(iterator);
              return ret;
            }
          });
          return ret;
        }

        /**
         * Get the path of ancestors of a descendant node by `key`.
         *
         * @param {String|Node} key
         * @return {List<Node>|Null}
         */
      }, {
        key: 'getAncestors',
        value: function getAncestors(key) {
          key = normalizeKey(key);
          if (key == this.key) return (0, _immutable.List)();
          if (this.hasChild(key)) return (0, _immutable.List)([this]);
          var ancestors = void 0;
          this.nodes.find(function (node) {
            if (node.kind == 'text') return false;
            ancestors = node.getAncestors(key);
            return ancestors;
          });
          if (ancestors) {
            return ancestors.unshift(this);
          } else {
            return null;
          }
        }

        /**
         * Get the leaf block descendants of the node.
         *
         * @return {List<Node>}
         */
      }, {
        key: 'getBlocks',
        value: function getBlocks() {
          var array = this.getBlocksAsArray();
          return new _immutable.List(array);
        }

        /**
         * Get the leaf block descendants of the node.
         *
         * @return {List<Node>}
         */
      }, {
        key: 'getBlocksAsArray',
        value: function getBlocksAsArray() {
          return this.nodes.reduce(function (array, child) {
            if (child.kind != 'block') return array;
            if (!child.isLeafBlock()) return array.concat(child.getBlocksAsArray());
            array.push(child);
            return array;
          }, []);
        }

        /**
         * Get the leaf block descendants in a `range`.
         *
         * @param {Selection} range
         * @return {List<Node>}
         */
      }, {
        key: 'getBlocksAtRange',
        value: function getBlocksAtRange(range) {
          var array = this.getBlocksAtRangeAsArray(range);
          // Eliminate duplicates by converting to an `OrderedSet` first.
          return new _immutable.List(new _immutable.OrderedSet(array));
        }

        /**
         * Get the leaf block descendants in a `range` as an array
         *
         * @param {Selection} range
         * @return {Array}
         */
      }, {
        key: 'getBlocksAtRangeAsArray',
        value: function getBlocksAtRangeAsArray(range) {
          range = range.normalize(this);
          if (range.isUnset) return [];
          var _range = range,
            startKey = _range.startKey,
            endKey = _range.endKey;
          var startBlock = this.getClosestBlock(startKey);

          // PERF: the most common case is when the range is in a single block node,
          // where we can avoid a lot of iterating of the tree.
          if (startKey == endKey) return [startBlock];
          var endBlock = this.getClosestBlock(endKey);
          var blocks = this.getBlocksAsArray();
          var start = blocks.indexOf(startBlock);
          var end = blocks.indexOf(endBlock);
          return blocks.slice(start, end + 1);
        }

        /**
         * Get all of the leaf blocks that match a `type`.
         *
         * @param {String} type
         * @return {List<Node>}
         */
      }, {
        key: 'getBlocksByType',
        value: function getBlocksByType(type) {
          var array = this.getBlocksByTypeAsArray(type);
          return new _immutable.List(array);
        }

        /**
         * Get all of the leaf blocks that match a `type` as an array
         *
         * @param {String} type
         * @return {Array}
         */
      }, {
        key: 'getBlocksByTypeAsArray',
        value: function getBlocksByTypeAsArray(type) {
          return this.nodes.reduce(function (array, node) {
            if (node.kind != 'block') {
              return array;
            } else if (node.isLeafBlock() && node.type == type) {
              array.push(node);
              return array;
            } else {
              return array.concat(node.getBlocksByTypeAsArray(type));
            }
          }, []);
        }

        /**
         * Get all of the characters for every text node.
         *
         * @return {List<Character>}
         */
      }, {
        key: 'getCharacters',
        value: function getCharacters() {
          var array = this.getCharactersAsArray();
          return new _immutable.List(array);
        }

        /**
         * Get all of the characters for every text node as an array
         *
         * @return {Array}
         */
      }, {
        key: 'getCharactersAsArray',
        value: function getCharactersAsArray() {
          return this.nodes.reduce(function (arr, node) {
            return node.kind == 'text' ? arr.concat(node.characters.toArray()) : arr.concat(node.getCharactersAsArray());
          }, []);
        }

        /**
         * Get a list of the characters in a `range`.
         *
         * @param {Selection} range
         * @return {List<Character>}
         */
      }, {
        key: 'getCharactersAtRange',
        value: function getCharactersAtRange(range) {
          var array = this.getCharactersAtRangeAsArray(range);
          return new _immutable.List(array);
        }

        /**
         * Get a list of the characters in a `range` as an array.
         *
         * @param {Selection} range
         * @return {Array}
         */
      }, {
        key: 'getCharactersAtRangeAsArray',
        value: function getCharactersAtRangeAsArray(range) {
          range = range.normalize(this);
          if (range.isUnset) return [];
          return this.getTextsAtRange(range).reduce(function (arr, text) {
            var chars = text.characters.filter(function (char, i) {
              return (0, _isIndexInRange2.default)(i, text, range);
            }).toArray();
            return arr.concat(chars);
          }, []);
        }

        /**
         * Get a child node by `key`.
         *
         * @param {String} key
         * @return {Node|Null}
         */
      }, {
        key: 'getChild',
        value: function getChild(key) {
          key = normalizeKey(key);
          return this.nodes.find(function (node) {
            return node.key == key;
          });
        }

        /**
         * Get closest parent of node by `key` that matches `iterator`.
         *
         * @param {String} key
         * @param {Function} iterator
         * @return {Node|Null}
         */
      }, {
        key: 'getClosest',
        value: function getClosest(key, iterator) {
          key = normalizeKey(key);
          var ancestors = this.getAncestors(key);
          if (!ancestors) {
            throw new Error('Could not find a descendant node with key "' + key + '".');
          }

          // Exclude this node itself.
          return ancestors.rest().findLast(iterator);
        }

        /**
         * Get the closest block parent of a `node`.
         *
         * @param {String} key
         * @return {Node|Null}
         */
      }, {
        key: 'getClosestBlock',
        value: function getClosestBlock(key) {
          return this.getClosest(key, function (parent) {
            return parent.kind == 'block';
          });
        }

        /**
         * Get the closest inline parent of a `node`.
         *
         * @param {String} key
         * @return {Node|Null}
         */
      }, {
        key: 'getClosestInline',
        value: function getClosestInline(key) {
          return this.getClosest(key, function (parent) {
            return parent.kind == 'inline';
          });
        }

        /**
         * Get the closest void parent of a `node`.
         *
         * @param {String} key
         * @return {Node|Null}
         */
      }, {
        key: 'getClosestVoid',
        value: function getClosestVoid(key) {
          return this.getClosest(key, function (parent) {
            return parent.isVoid;
          });
        }

        /**
         * Get the common ancestor of nodes `one` and `two` by keys.
         *
         * @param {String} one
         * @param {String} two
         * @return {Node}
         */
      }, {
        key: 'getCommonAncestor',
        value: function getCommonAncestor(one, two) {
          one = normalizeKey(one);
          two = normalizeKey(two);
          if (one == this.key) return this;
          if (two == this.key) return this;
          this.assertDescendant(one);
          this.assertDescendant(two);
          var ancestors = new _immutable.List();
          var oneParent = this.getParent(one);
          var twoParent = this.getParent(two);
          while (oneParent) {
            ancestors = ancestors.push(oneParent);
            oneParent = this.getParent(oneParent.key);
          }
          while (twoParent) {
            if (ancestors.includes(twoParent)) return twoParent;
            twoParent = this.getParent(twoParent.key);
          }
        }

        /**
         * Get the component for the node from a `schema`.
         *
         * @param {Schema} schema
         * @return {Component|Void}
         */
      }, {
        key: 'getComponent',
        value: function getComponent(schema) {
          return schema.__getComponent(this);
        }

        /**
         * Get the decorations for the node from a `schema`.
         *
         * @param {Schema} schema
         * @return {Array}
         */
      }, {
        key: 'getDecorators',
        value: function getDecorators(schema) {
          return schema.__getDecorators(this);
        }

        /**
         * Get the depth of a child node by `key`, with optional `startAt`.
         *
         * @param {String} key
         * @param {Number} startAt (optional)
         * @return {Number} depth
         */
      }, {
        key: 'getDepth',
        value: function getDepth(key) {
          var startAt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
          this.assertDescendant(key);
          if (this.hasChild(key)) return startAt;
          return this.getFurthestAncestor(key).getDepth(key, startAt + 1);
        }

        /**
         * Get a descendant node by `key`.
         *
         * @param {String} key
         * @return {Node|Null}
         */
      }, {
        key: 'getDescendant',
        value: function getDescendant(key) {
          key = normalizeKey(key);
          var descendantFound = null;
          var found = this.nodes.find(function (node) {
            if (node.key === key) {
              return node;
            } else if (node.kind !== 'text') {
              descendantFound = node.getDescendant(key);
              return descendantFound;
            } else {
              return false;
            }
          });
          return descendantFound || found;
        }

        /**
         * Get a descendant by `path`.
         *
         * @param {Array} path
         * @return {Node|Null}
         */
      }, {
        key: 'getDescendantAtPath',
        value: function getDescendantAtPath(path) {
          var descendant = this;
          for (var i = 0; i < path.length; i++) {
            var index = path[i];
            if (!descendant) return;
            if (!descendant.nodes) return;
            descendant = descendant.nodes.get(index);
          }
          return descendant;
        }

        /**
         * Get the decorators for a descendant by `key` given a `schema`.
         *
         * @param {String} key
         * @param {Schema} schema
         * @return {Array}
         */
      }, {
        key: 'getDescendantDecorators',
        value: function getDescendantDecorators(key, schema) {
          if (!schema.hasDecorators) {
            return [];
          }
          var descendant = this.assertDescendant(key);
          var child = this.getFurthestAncestor(key);
          var decorators = [];
          while (child != descendant) {
            decorators = decorators.concat(child.getDecorators(schema));
            child = child.getFurthestAncestor(key);
          }
          decorators = decorators.concat(descendant.getDecorators(schema));
          return decorators;
        }

        /**
         * Get the first child text node.
         *
         * @return {Node|Null}
         */
      }, {
        key: 'getFirstText',
        value: function getFirstText() {
          var descendantFound = null;
          var found = this.nodes.find(function (node) {
            if (node.kind == 'text') return true;
            descendantFound = node.getFirstText();
            return descendantFound;
          });
          return descendantFound || found;
        }

        /**
         * Get a fragment of the node at a `range`.
         *
         * @param {Selection} range
         * @return {Document}
         */
      }, {
        key: 'getFragmentAtRange',
        value: function getFragmentAtRange(range) {
          range = range.normalize(this);
          if (range.isUnset) return _document2.default.create();
          var node = this;

          // Make sure the children exist.
          var _range2 = range,
            startKey = _range2.startKey,
            startOffset = _range2.startOffset,
            endKey = _range2.endKey,
            endOffset = _range2.endOffset;
          var startText = node.assertDescendant(startKey);
          var endText = node.assertDescendant(endKey);

          // Split at the start and end.
          var child = startText;
          var previous = void 0;
          var parent = void 0;
          while (parent = node.getParent(child.key)) {
            var index = parent.nodes.indexOf(child);
            var position = child.kind == 'text' ? startOffset : child.nodes.indexOf(previous);
            parent = parent.splitNode(index, position);
            node = node.updateNode(parent);
            previous = parent.nodes.get(index + 1);
            child = parent;
          }
          child = endText;
          while (parent = node.getParent(child.key)) {
            var _index = parent.nodes.indexOf(child);
            var _position = child.kind == 'text' ? endOffset : child.nodes.indexOf(previous);
            parent = parent.splitNode(_index, _position);
            node = node.updateNode(parent);
            previous = parent.nodes.get(_index + 1);
            child = parent;
          }

          // Get the start and end nodes.
          var next = node.getNextText(startKey);
          var startNode = node.getNextSibling(node.getFurthestAncestor(startKey).key);
          var endNode = startKey == endKey ? node.getFurthestAncestor(next.key) : node.getFurthestAncestor(endKey);

          // Get children range of nodes from start to end nodes
          var startIndex = node.nodes.indexOf(startNode);
          var endIndex = node.nodes.indexOf(endNode);
          var nodes = node.nodes.slice(startIndex, endIndex + 1);

          // Return a new document fragment.
          return _document2.default.create({
            nodes: nodes
          });
        }

        /**
         * Get the furthest parent of a node by `key` that matches an `iterator`.
         *
         * @param {String} key
         * @param {Function} iterator
         * @return {Node|Null}
         */
      }, {
        key: 'getFurthest',
        value: function getFurthest(key, iterator) {
          var ancestors = this.getAncestors(key);
          if (!ancestors) {
            key = normalizeKey(key);
            throw new Error('Could not find a descendant node with key "' + key + '".');
          }

          // Exclude this node itself
          return ancestors.rest().find(iterator);
        }

        /**
         * Get the furthest block parent of a node by `key`.
         *
         * @param {String} key
         * @return {Node|Null}
         */
      }, {
        key: 'getFurthestBlock',
        value: function getFurthestBlock(key) {
          return this.getFurthest(key, function (node) {
            return node.kind == 'block';
          });
        }

        /**
         * Get the furthest inline parent of a node by `key`.
         *
         * @param {String} key
         * @return {Node|Null}
         */
      }, {
        key: 'getFurthestInline',
        value: function getFurthestInline(key) {
          return this.getFurthest(key, function (node) {
            return node.kind == 'inline';
          });
        }

        /**
         * Get the furthest ancestor of a node by `key`.
         *
         * @param {String} key
         * @return {Node|Null}
         */
      }, {
        key: 'getFurthestAncestor',
        value: function getFurthestAncestor(key) {
          key = normalizeKey(key);
          return this.nodes.find(function (node) {
            if (node.key == key) return true;
            if (node.kind == 'text') return false;
            return node.hasDescendant(key);
          });
        }

        /**
         * Get the furthest ancestor of a node by `key` that has only one child.
         *
         * @param {String} key
         * @return {Node|Null}
         */
      }, {
        key: 'getFurthestOnlyChildAncestor',
        value: function getFurthestOnlyChildAncestor(key) {
          var ancestors = this.getAncestors(key);
          if (!ancestors) {
            key = normalizeKey(key);
            throw new Error('Could not find a descendant node with key "' + key + '".');
          }
          return ancestors
          // Skip this node...
          .skipLast()
          // Take parents until there are more than one child...
          .reverse().takeUntil(function (p) {
            return p.nodes.size > 1;
          })
          // And pick the highest.
          .last();
        }

        /**
         * Get the closest inline nodes for each text node in the node.
         *
         * @return {List<Node>}
         */
      }, {
        key: 'getInlines',
        value: function getInlines() {
          var array = this.getInlinesAsArray();
          return new _immutable.List(array);
        }

        /**
         * Get the closest inline nodes for each text node in the node, as an array.
         *
         * @return {List<Node>}
         */
      }, {
        key: 'getInlinesAsArray',
        value: function getInlinesAsArray() {
          var array = [];
          this.nodes.forEach(function (child) {
            if (child.kind == 'text') return;
            if (child.isLeafInline()) {
              array.push(child);
            } else {
              array = array.concat(child.getInlinesAsArray());
            }
          });
          return array;
        }

        /**
         * Get the closest inline nodes for each text node in a `range`.
         *
         * @param {Selection} range
         * @return {List<Node>}
         */
      }, {
        key: 'getInlinesAtRange',
        value: function getInlinesAtRange(range) {
          var array = this.getInlinesAtRangeAsArray(range);
          // Remove duplicates by converting it to an `OrderedSet` first.
          return new _immutable.List(new _immutable.OrderedSet(array));
        }

        /**
         * Get the closest inline nodes for each text node in a `range` as an array.
         *
         * @param {Selection} range
         * @return {Array}
         */
      }, {
        key: 'getInlinesAtRangeAsArray',
        value: function getInlinesAtRangeAsArray(range) {
          var _this = this;
          range = range.normalize(this);
          if (range.isUnset) return [];
          return this.getTextsAtRangeAsArray(range).map(function (text) {
            return _this.getClosestInline(text.key);
          }).filter(function (exists) {
            return exists;
          });
        }

        /**
         * Get all of the leaf inline nodes that match a `type`.
         *
         * @param {String} type
         * @return {List<Node>}
         */
      }, {
        key: 'getInlinesByType',
        value: function getInlinesByType(type) {
          var array = this.getInlinesByTypeAsArray(type);
          return new _immutable.List(array);
        }

        /**
         * Get all of the leaf inline nodes that match a `type` as an array.
         *
         * @param {String} type
         * @return {Array}
         */
      }, {
        key: 'getInlinesByTypeAsArray',
        value: function getInlinesByTypeAsArray(type) {
          return this.nodes.reduce(function (inlines, node) {
            if (node.kind == 'text') {
              return inlines;
            } else if (node.isLeafInline() && node.type == type) {
              inlines.push(node);
              return inlines;
            } else {
              return inlines.concat(node.getInlinesByTypeAsArray(type));
            }
          }, []);
        }

        /**
         * Return a set of all keys in the node.
         *
         * @return {Set<String>}
         */
      }, {
        key: 'getKeys',
        value: function getKeys() {
          var keys = [];
          this.forEachDescendant(function (desc) {
            keys.push(desc.key);
          });
          return new _immutable.Set(keys);
        }

        /**
         * Get the last child text node.
         *
         * @return {Node|Null}
         */
      }, {
        key: 'getLastText',
        value: function getLastText() {
          var descendantFound = null;
          var found = this.nodes.findLast(function (node) {
            if (node.kind == 'text') return true;
            descendantFound = node.getLastText();
            return descendantFound;
          });
          return descendantFound || found;
        }

        /**
         * Get all of the marks for all of the characters of every text node.
         *
         * @return {Set<Mark>}
         */
      }, {
        key: 'getMarks',
        value: function getMarks() {
          var array = this.getMarksAsArray();
          return new _immutable.Set(array);
        }

        /**
         * Get all of the marks for all of the characters of every text node.
         *
         * @return {OrderedSet<Mark>}
         */
      }, {
        key: 'getOrderedMarks',
        value: function getOrderedMarks() {
          var array = this.getMarksAsArray();
          return new _immutable.OrderedSet(array);
        }

        /**
         * Get all of the marks as an array.
         *
         * @return {Array}
         */
      }, {
        key: 'getMarksAsArray',
        value: function getMarksAsArray() {
          return this.nodes.reduce(function (marks, node) {
            return marks.concat(node.getMarksAsArray());
          }, []);
        }

        /**
         * Get a set of the marks in a `range`.
         *
         * @param {Selection} range
         * @return {Set<Mark>}
         */
      }, {
        key: 'getMarksAtRange',
        value: function getMarksAtRange(range) {
          var array = this.getMarksAtRangeAsArray(range);
          return new _immutable.Set(array);
        }

        /**
         * Get a set of the marks in a `range`.
         *
         * @param {Selection} range
         * @return {OrderedSet<Mark>}
         */
      }, {
        key: 'getOrderedMarksAtRange',
        value: function getOrderedMarksAtRange(range) {
          var array = this.getMarksAtRangeAsArray(range);
          return new _immutable.OrderedSet(array);
        }

        /**
         * Get a set of the active marks in a `range`.
         *
         * @param {Selection} range
         * @return {Set<Mark>}
         */
      }, {
        key: 'getActiveMarksAtRange',
        value: function getActiveMarksAtRange(range) {
          var array = this.getActiveMarksAtRangeAsArray(range);
          return new _immutable.Set(array);
        }

        /**
         * Get a set of the marks in a `range`, by unioning.
         *
         * @param {Selection} range
         * @return {Array}
         */
      }, {
        key: 'getMarksAtRangeAsArray',
        value: function getMarksAtRangeAsArray(range) {
          range = range.normalize(this);
          if (range.isUnset) return [];
          var _range3 = range,
            startKey = _range3.startKey,
            startOffset = _range3.startOffset;

          // If the range is collapsed at the start of the node, check the previous.

          if (range.isCollapsed && startOffset == 0) {
            var previous = this.getPreviousText(startKey);
            if (!previous || previous.text.length == 0) return [];
            var char = previous.characters.get(previous.text.length - 1);
            return char.marks.toArray();
          }

          // If the range is collapsed, check the character before the start.
          if (range.isCollapsed) {
            var text = this.getDescendant(startKey);
            var _char = text.characters.get(range.startOffset - 1);
            return _char.marks.toArray();
          }

          // Otherwise, get a set of the marks for each character in the range.
          return this.getCharactersAtRange(range).reduce(function (memo, char) {
            char.marks.toArray().forEach(function (c) {
              return memo.push(c);
            });
            return memo;
          }, []);
        }

        /**
         * Get a set of marks in a `range`, by intersecting.
         *
         * @param {Selection} range
         * @return {Array}
         */
      }, {
        key: 'getActiveMarksAtRangeAsArray',
        value: function getActiveMarksAtRangeAsArray(range) {
          range = range.normalize(this);
          if (range.isUnset) return [];
          var _range4 = range,
            startKey = _range4.startKey,
            startOffset = _range4.startOffset;

          // If the range is collapsed at the start of the node, check the previous.

          if (range.isCollapsed && startOffset == 0) {
            var previous = this.getPreviousText(startKey);
            if (!previous || !previous.length) return [];
            var char = previous.characters.get(previous.length - 1);
            return char.marks.toArray();
          }

          // If the range is collapsed, check the character before the start.
          if (range.isCollapsed) {
            var text = this.getDescendant(startKey);
            var _char2 = text.characters.get(range.startOffset - 1);
            return _char2.marks.toArray();
          }

          // Otherwise, get a set of the marks for each character in the range.
          var chars = this.getCharactersAtRange(range);
          var first = chars.first();
          if (!first) return [];
          var memo = first.marks;
          chars.slice(1).forEach(function (char) {
            memo = memo.intersect(char.marks);
            return memo.size != 0;
          });
          return memo.toArray();
        }

        /**
         * Get all of the marks that match a `type`.
         *
         * @param {String} type
         * @return {Set<Mark>}
         */
      }, {
        key: 'getMarksByType',
        value: function getMarksByType(type) {
          var array = this.getMarksByTypeAsArray(type);
          return new _immutable.Set(array);
        }

        /**
         * Get all of the marks that match a `type`.
         *
         * @param {String} type
         * @return {OrderedSet<Mark>}
         */
      }, {
        key: 'getOrderedMarksByType',
        value: function getOrderedMarksByType(type) {
          var array = this.getMarksByTypeAsArray(type);
          return new _immutable.OrderedSet(array);
        }

        /**
         * Get all of the marks that match a `type` as an array.
         *
         * @param {String} type
         * @return {Array}
         */
      }, {
        key: 'getMarksByTypeAsArray',
        value: function getMarksByTypeAsArray(type) {
          return this.nodes.reduce(function (array, node) {
            return node.kind == 'text' ? array.concat(node.getMarksAsArray().filter(function (m) {
              return m.type == type;
            })) : array.concat(node.getMarksByTypeAsArray(type));
          }, []);
        }

        /**
         * Get the block node before a descendant text node by `key`.
         *
         * @param {String} key
         * @return {Node|Null}
         */
      }, {
        key: 'getNextBlock',
        value: function getNextBlock(key) {
          var child = this.assertDescendant(key);
          var last = void 0;
          if (child.kind == 'block') {
            last = child.getLastText();
          } else {
            var block = this.getClosestBlock(key);
            last = block.getLastText();
          }
          var next = this.getNextText(last.key);
          if (!next) return null;
          return this.getClosestBlock(next.key);
        }

        /**
         * Get the node after a descendant by `key`.
         *
         * @param {String} key
         * @return {Node|Null}
         */
      }, {
        key: 'getNextSibling',
        value: function getNextSibling(key) {
          key = normalizeKey(key);
          var parent = this.getParent(key);
          var after = parent.nodes.skipUntil(function (child) {
            return child.key == key;
          });
          if (after.size == 0) {
            throw new Error('Could not find a child node with key "' + key + '".');
          }
          return after.get(1);
        }

        /**
         * Get the text node after a descendant text node by `key`.
         *
         * @param {String} key
         * @return {Node|Null}
         */
      }, {
        key: 'getNextText',
        value: function getNextText(key) {
          key = normalizeKey(key);
          return this.getTexts().skipUntil(function (text) {
            return text.key == key;
          }).get(1);
        }

        /**
         * Get a node in the tree by `key`.
         *
         * @param {String} key
         * @return {Node|Null}
         */
      }, {
        key: 'getNode',
        value: function getNode(key) {
          key = normalizeKey(key);
          return this.key == key ? this : this.getDescendant(key);
        }

        /**
         * Get a node in the tree by `path`.
         *
         * @param {Array} path
         * @return {Node|Null}
         */
      }, {
        key: 'getNodeAtPath',
        value: function getNodeAtPath(path) {
          return path.length ? this.getDescendantAtPath(path) : this;
        }

        /**
         * Get the offset for a descendant text node by `key`.
         *
         * @param {String} key
         * @return {Number}
         */
      }, {
        key: 'getOffset',
        value: function getOffset(key) {
          this.assertDescendant(key);

          // Calculate the offset of the nodes before the highest child.
          var child = this.getFurthestAncestor(key);
          var offset = this.nodes.takeUntil(function (n) {
            return n == child;
          }).reduce(function (memo, n) {
            return memo + n.text.length;
          }, 0);

          // Recurse if need be.
          return this.hasChild(key) ? offset : offset + child.getOffset(key);
        }

        /**
         * Get the offset from a `range`.
         *
         * @param {Selection} range
         * @return {Number}
         */
      }, {
        key: 'getOffsetAtRange',
        value: function getOffsetAtRange(range) {
          range = range.normalize(this);
          if (range.isUnset) {
            throw new Error('The range cannot be unset to calculcate its offset.');
          }
          if (range.isExpanded) {
            throw new Error('The range must be collapsed to calculcate its offset.');
          }
          var _range5 = range,
            startKey = _range5.startKey,
            startOffset = _range5.startOffset;
          return this.getOffset(startKey) + startOffset;
        }

        /**
         * Get the parent of a child node by `key`.
         *
         * @param {String} key
         * @return {Node|Null}
         */
      }, {
        key: 'getParent',
        value: function getParent(key) {
          if (this.hasChild(key)) return this;
          var node = null;
          this.nodes.find(function (child) {
            if (child.kind == 'text') {
              return false;
            } else {
              node = child.getParent(key);
              return node;
            }
          });
          return node;
        }

        /**
         * Get the path of a descendant node by `key`.
         *
         * @param {String|Node} key
         * @return {Array}
         */
      }, {
        key: 'getPath',
        value: function getPath(key) {
          var child = this.assertNode(key);
          var ancestors = this.getAncestors(key);
          var path = [];
          ancestors.reverse().forEach(function (ancestor) {
            var index = ancestor.nodes.indexOf(child);
            path.unshift(index);
            child = ancestor;
          });
          return path;
        }

        /**
         * Get the block node before a descendant text node by `key`.
         *
         * @param {String} key
         * @return {Node|Null}
         */
      }, {
        key: 'getPreviousBlock',
        value: function getPreviousBlock(key) {
          var child = this.assertDescendant(key);
          var first = void 0;
          if (child.kind == 'block') {
            first = child.getFirstText();
          } else {
            var block = this.getClosestBlock(key);
            first = block.getFirstText();
          }
          var previous = this.getPreviousText(first.key);
          if (!previous) return null;
          return this.getClosestBlock(previous.key);
        }

        /**
         * Get the node before a descendant node by `key`.
         *
         * @param {String} key
         * @return {Node|Null}
         */
      }, {
        key: 'getPreviousSibling',
        value: function getPreviousSibling(key) {
          key = normalizeKey(key);
          var parent = this.getParent(key);
          var before = parent.nodes.takeUntil(function (child) {
            return child.key == key;
          });
          if (before.size == parent.nodes.size) {
            throw new Error('Could not find a child node with key "' + key + '".');
          }
          return before.last();
        }

        /**
         * Get the text node before a descendant text node by `key`.
         *
         * @param {String} key
         * @return {Node|Null}
         */
      }, {
        key: 'getPreviousText',
        value: function getPreviousText(key) {
          key = normalizeKey(key);
          return this.getTexts().takeUntil(function (text) {
            return text.key == key;
          }).last();
        }

        /**
         * Get the indexes of the selection for a `range`, given an extra flag for
         * whether the node `isSelected`, to determine whether not finding matches
         * means everything is selected or nothing is.
         *
         * @param {Selection} range
         * @param {Boolean} isSelected
         * @return {Object|Null}
         */
      }, {
        key: 'getSelectionIndexes',
        value: function getSelectionIndexes(range) {
          var isSelected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
          var startKey = range.startKey,
            endKey = range.endKey;

          // PERF: if we're not selected, or the range is blurred, we can exit early.

          if (!isSelected || range.isBlurred) {
            return null;
          }

          // PERF: if the start and end keys are the same, just check for the child
          // that contains that single key.
          if (startKey == endKey) {
            var child = this.getFurthestAncestor(startKey);
            var index = child ? this.nodes.indexOf(child) : null;
            return {
              start: index,
              end: index + 1
            };
          }

          // Otherwise, check all of the children...
          var start = null;
          var end = null;
          this.nodes.forEach(function (child, i) {
            if (child.kind == 'text') {
              if (start == null && child.key == startKey) start = i;
              if (end == null && child.key == endKey) end = i + 1;
            } else {
              if (start == null && child.hasDescendant(startKey)) start = i;
              if (end == null && child.hasDescendant(endKey)) end = i + 1;
            }

            // PERF: exit early if both start and end have been found.
            return start != null && end != null;
          });
          if (isSelected && start == null) start = 0;
          if (isSelected && end == null) end = this.nodes.size;
          return start == null ? null : {
            start: start,
            end: end
          };
        }

        /**
         * Get the concatenated text string of all child nodes.
         *
         * @return {String}
         */
      }, {
        key: 'getText',
        value: function getText() {
          return this.nodes.reduce(function (string, node) {
            return string + node.text;
          }, '');
        }

        /**
         * Get the descendent text node at an `offset`.
         *
         * @param {String} offset
         * @return {Node|Null}
         */
      }, {
        key: 'getTextAtOffset',
        value: function getTextAtOffset(offset) {
          // PERF: Add a few shortcuts for the obvious cases.
          if (offset == 0) return this.getFirstText();
          if (offset == this.text.length) return this.getLastText();
          if (offset < 0 || offset > this.text.length) return null;
          var length = 0;
          return this.getTexts().find(function (node, i, nodes) {
            length += node.text.length;
            return length > offset;
          });
        }

        /**
         * Get the direction of the node's text.
         *
         * @return {String}
         */
      }, {
        key: 'getTextDirection',
        value: function getTextDirection() {
          var dir = (0, _direction2.default)(this.text);
          return dir == 'neutral' ? undefined : dir;
        }

        /**
         * Recursively get all of the child text nodes in order of appearance.
         *
         * @return {List<Node>}
         */
      }, {
        key: 'getTexts',
        value: function getTexts() {
          var array = this.getTextsAsArray();
          return new _immutable.List(array);
        }

        /**
         * Recursively get all the leaf text nodes in order of appearance, as array.
         *
         * @return {List<Node>}
         */
      }, {
        key: 'getTextsAsArray',
        value: function getTextsAsArray() {
          var array = [];
          this.nodes.forEach(function (node) {
            if (node.kind == 'text') {
              array.push(node);
            } else {
              array = array.concat(node.getTextsAsArray());
            }
          });
          return array;
        }

        /**
         * Get all of the text nodes in a `range`.
         *
         * @param {Selection} range
         * @return {List<Node>}
         */
      }, {
        key: 'getTextsAtRange',
        value: function getTextsAtRange(range) {
          var array = this.getTextsAtRangeAsArray(range);
          return new _immutable.List(array);
        }

        /**
         * Get all of the text nodes in a `range` as an array.
         *
         * @param {Selection} range
         * @return {Array}
         */
      }, {
        key: 'getTextsAtRangeAsArray',
        value: function getTextsAtRangeAsArray(range) {
          range = range.normalize(this);
          if (range.isUnset) return [];
          var _range6 = range,
            startKey = _range6.startKey,
            endKey = _range6.endKey;
          var startText = this.getDescendant(startKey);

          // PERF: the most common case is when the range is in a single text node,
          // where we can avoid a lot of iterating of the tree.
          if (startKey == endKey) return [startText];
          var endText = this.getDescendant(endKey);
          var texts = this.getTextsAsArray();
          var start = texts.indexOf(startText);
          var end = texts.indexOf(endText);
          return texts.slice(start, end + 1);
        }

        /**
         * Check if a child node exists by `key`.
         *
         * @param {String} key
         * @return {Boolean}
         */
      }, {
        key: 'hasChild',
        value: function hasChild(key) {
          return !!this.getChild(key);
        }

        /**
         * Recursively check if a child node exists by `key`.
         *
         * @param {String} key
         * @return {Boolean}
         */
      }, {
        key: 'hasDescendant',
        value: function hasDescendant(key) {
          return !!this.getDescendant(key);
        }

        /**
         * Recursively check if a node exists by `key`.
         *
         * @param {String} key
         * @return {Boolean}
         */
      }, {
        key: 'hasNode',
        value: function hasNode(key) {
          return !!this.getNode(key);
        }

        /**
         * Check if a node has a void parent by `key`.
         *
         * @param {String} key
         * @return {Boolean}
         */
      }, {
        key: 'hasVoidParent',
        value: function hasVoidParent(key) {
          return !!this.getClosest(key, function (parent) {
            return parent.isVoid;
          });
        }

        /**
         * Insert a `node` at `index`.
         *
         * @param {Number} index
         * @param {Node} node
         * @return {Node}
         */
      }, {
        key: 'insertNode',
        value: function insertNode(index, node) {
          var keys = this.getKeys();
          if (keys.contains(node.key)) {
            node = node.regenerateKey();
          }
          if (node.kind != 'text') {
            node = node.mapDescendants(function (desc) {
              return keys.contains(desc.key) ? desc.regenerateKey() : desc;
            });
          }
          var nodes = this.nodes.insert(index, node);
          return this.set('nodes', nodes);
        }

        /**
         * Check whether the node is in a `range`.
         *
         * @param {Selection} range
         * @return {Boolean}
         */
      }, {
        key: 'isInRange',
        value: function isInRange(range) {
          range = range.normalize(this);
          var node = this;
          var _range7 = range,
            startKey = _range7.startKey,
            endKey = _range7.endKey,
            isCollapsed = _range7.isCollapsed;

          // PERF: solve the most common cast where the start or end key are inside
          // the node, for collapsed selections.

          if (node.key == startKey || node.key == endKey || node.hasDescendant(startKey) || node.hasDescendant(endKey)) {
            return true;
          }

          // PERF: if the selection is collapsed and the previous check didn't return
          // true, then it must be false.
          if (isCollapsed) {
            return false;
          }

          // Otherwise, look through all of the leaf text nodes in the range, to see
          // if any of them are inside the node.
          var texts = node.getTextsAtRange(range);
          var memo = false;
          texts.forEach(function (text) {
            if (node.hasDescendant(text.key)) memo = true;
            return memo;
          });
          return memo;
        }

        /**
         * Check whether the node is a leaf block.
         *
         * @return {Boolean}
         */
      }, {
        key: 'isLeafBlock',
        value: function isLeafBlock() {
          return this.kind == 'block' && this.nodes.every(function (n) {
            return n.kind != 'block';
          });
        }

        /**
         * Check whether the node is a leaf inline.
         *
         * @return {Boolean}
         */
      }, {
        key: 'isLeafInline',
        value: function isLeafInline() {
          return this.kind == 'inline' && this.nodes.every(function (n) {
            return n.kind != 'inline';
          });
        }

        /**
         * Merge a children node `first` with another children node `second`.
         * `first` and `second` will be concatenated in that order.
         * `first` and `second` must be two Nodes or two Text.
         *
         * @param {Node} first
         * @param {Node} second
         * @return {Node}
         */
      }, {
        key: 'mergeNode',
        value: function mergeNode(withIndex, index) {
          var node = this;
          var one = node.nodes.get(withIndex);
          var two = node.nodes.get(index);
          if (one.kind != two.kind) {
            throw new Error('Tried to merge two nodes of different kinds: "' + one.kind + '" and "' + two.kind + '".');
          }

          // If the nodes are text nodes, concatenate their characters together.
          if (one.kind == 'text') {
            var characters = one.characters.concat(two.characters);
            one = one.set('characters', characters);
          }

          // Otherwise, concatenate their child nodes together.
          else {
            var nodes = one.nodes.concat(two.nodes);
            one = one.set('nodes', nodes);
          }
          node = node.removeNode(index);
          node = node.removeNode(withIndex);
          node = node.insertNode(withIndex, one);
          return node;
        }

        /**
         * Map all child nodes, updating them in their parents. This method is
         * optimized to not return a new node if no changes are made.
         *
         * @param {Function} iterator
         * @return {Node}
         */
      }, {
        key: 'mapChildren',
        value: function mapChildren(iterator) {
          var _this2 = this;
          var nodes = this.nodes;
          nodes.forEach(function (node, i) {
            var ret = iterator(node, i, _this2.nodes);
            if (ret != node) nodes = nodes.set(ret.key, ret);
          });
          return this.set('nodes', nodes);
        }

        /**
         * Map all descendant nodes, updating them in their parents. This method is
         * optimized to not return a new node if no changes are made.
         *
         * @param {Function} iterator
         * @return {Node}
         */
      }, {
        key: 'mapDescendants',
        value: function mapDescendants(iterator) {
          var _this3 = this;
          var nodes = this.nodes;
          nodes.forEach(function (node, i) {
            var ret = node;
            if (ret.kind != 'text') ret = ret.mapDescendants(iterator);
            ret = iterator(ret, i, _this3.nodes);
            if (ret == node) return;
            var index = nodes.indexOf(node);
            nodes = nodes.set(index, ret);
          });
          return this.set('nodes', nodes);
        }

        /**
         * Regenerate the node's key.
         *
         * @return {Node}
         */
      }, {
        key: 'regenerateKey',
        value: function regenerateKey() {
          var key = (0, _generateKey2.default)();
          return this.set('key', key);
        }

        /**
         * Remove a `node` from the children node map.
         *
         * @param {String} key
         * @return {Node}
         */
      }, {
        key: 'removeDescendant',
        value: function removeDescendant(key) {
          key = normalizeKey(key);
          var node = this;
          var parent = node.getParent(key);
          if (!parent) throw new Error('Could not find a descendant node with key "' + key + '".');
          var index = parent.nodes.findIndex(function (n) {
            return n.key === key;
          });
          var nodes = parent.nodes.splice(index, 1);
          parent = parent.set('nodes', nodes);
          node = node.updateNode(parent);
          return node;
        }

        /**
         * Remove a node at `index`.
         *
         * @param {Number} index
         * @return {Node}
         */
      }, {
        key: 'removeNode',
        value: function removeNode(index) {
          var nodes = this.nodes.splice(index, 1);
          return this.set('nodes', nodes);
        }

        /**
         * Split a child node by `index` at `position`.
         *
         * @param {Number} index
         * @param {Number} position
         * @return {Node}
         */
      }, {
        key: 'splitNode',
        value: function splitNode(index, position) {
          var node = this;
          var child = node.nodes.get(index);
          var one = void 0;
          var two = void 0;

          // If the child is a text node, the `position` refers to the text offset at
          // which to split it.
          if (child.kind == 'text') {
            var befores = child.characters.take(position);
            var afters = child.characters.skip(position);
            one = child.set('characters', befores);
            two = child.set('characters', afters).regenerateKey();
          }

          // Otherwise, if the child is not a text node, the `position` refers to the
          // index at which to split its children.
          else {
            var _befores = child.nodes.take(position);
            var _afters = child.nodes.skip(position);
            one = child.set('nodes', _befores);
            two = child.set('nodes', _afters).regenerateKey();
          }

          // Remove the old node and insert the newly split children.
          node = node.removeNode(index);
          node = node.insertNode(index, two);
          node = node.insertNode(index, one);
          return node;
        }

        /**
         * Set a new value for a child node by `key`.
         *
         * @param {Node} node
         * @return {Node}
         */
      }, {
        key: 'updateNode',
        value: function updateNode(node) {
          if (node.key == this.key) {
            return node;
          }
          var child = this.assertDescendant(node.key);
          var ancestors = this.getAncestors(node.key);
          ancestors.reverse().forEach(function (parent) {
            var _parent = parent,
              nodes = _parent.nodes;
            var index = nodes.indexOf(child);
            child = parent;
            nodes = nodes.set(index, node);
            parent = parent.set('nodes', nodes);
            node = parent;
          });
          return node;
        }

        /**
         * Validate the node against a `schema`.
         *
         * @param {Schema} schema
         * @return {Object|Null}
         */
      }, {
        key: 'validate',
        value: function validate(schema) {
          return schema.__validate(this);
        }

        /**
         * True if the node has both descendants in that order, false otherwise. The
         * order is depth-first, post-order.
         *
         * @param {String} first
         * @param {String} second
         * @return {Boolean}
         */
      }, {
        key: 'areDescendantSorted',
        value: function areDescendantSorted(first, second) {
          _slateDevLogger2.default.deprecate('0.19.0', 'The Node.areDescendantSorted(first, second) method is deprecated, please use `Node.areDescendantsSorted(first, second) instead.');
          return this.areDescendantsSorted(first, second);
        }

        /**
         * Concat children `nodes` on to the end of the node.
         *
         * @param {List<Node>} nodes
         * @return {Node}
         */
      }, {
        key: 'concatChildren',
        value: function concatChildren(nodes) {
          _slateDevLogger2.default.deprecate('0.19.0', 'The `Node.concatChildren(nodes)` method is deprecated.');
          nodes = this.nodes.concat(nodes);
          return this.set('nodes', nodes);
        }

        /**
         * Decorate all of the text nodes with a `decorator` function.
         *
         * @param {Function} decorator
         * @return {Node}
         */
      }, {
        key: 'decorateTexts',
        value: function decorateTexts(decorator) {
          _slateDevLogger2.default.deprecate('0.19.0', 'The `Node.decorateTexts(decorator) method is deprecated.');
          return this.mapDescendants(function (child) {
            return child.kind == 'text' ? child.decorateCharacters(decorator) : child;
          });
        }

        /**
         * Recursively filter all descendant nodes with `iterator`, depth-first.
         * It is different from `filterDescendants` in regard of the order of results.
         *
         * @param {Function} iterator
         * @return {List<Node>}
         */
      }, {
        key: 'filterDescendantsDeep',
        value: function filterDescendantsDeep(iterator) {
          _slateDevLogger2.default.deprecate('0.19.0', 'The Node.filterDescendantsDeep(iterator) method is deprecated.');
          return this.nodes.reduce(function (matches, child, i, nodes) {
            if (child.kind != 'text') matches = matches.concat(child.filterDescendantsDeep(iterator));
            if (iterator(child, i, nodes)) matches = matches.push(child);
            return matches;
          }, new _immutable.List());
        }

        /**
         * Recursively find all descendant nodes by `iterator`. Depth first.
         *
         * @param {Function} iterator
         * @return {Node|Null}
         */
      }, {
        key: 'findDescendantDeep',
        value: function findDescendantDeep(iterator) {
          _slateDevLogger2.default.deprecate('0.19.0', 'The Node.findDescendantDeep(iterator) method is deprecated.');
          var found = void 0;
          this.forEachDescendant(function (node) {
            if (iterator(node)) {
              found = node;
              return false;
            }
          });
          return found;
        }

        /**
         * Get children between two child keys.
         *
         * @param {String} start
         * @param {String} end
         * @return {Node}
         */
      }, {
        key: 'getChildrenBetween',
        value: function getChildrenBetween(start, end) {
          _slateDevLogger2.default.deprecate('0.19.0', 'The `Node.getChildrenBetween(start, end)` method is deprecated.');
          start = this.assertChild(start);
          start = this.nodes.indexOf(start);
          end = this.assertChild(end);
          end = this.nodes.indexOf(end);
          return this.nodes.slice(start + 1, end);
        }

        /**
         * Get children between two child keys, including the two children.
         *
         * @param {String} start
         * @param {String} end
         * @return {Node}
         */
      }, {
        key: 'getChildrenBetweenIncluding',
        value: function getChildrenBetweenIncluding(start, end) {
          _slateDevLogger2.default.deprecate('0.19.0', 'The `Node.getChildrenBetweenIncluding(start, end)` method is deprecated.');
          start = this.assertChild(start);
          start = this.nodes.indexOf(start);
          end = this.assertChild(end);
          end = this.nodes.indexOf(end);
          return this.nodes.slice(start, end + 1);
        }

        /**
         * Get the highest child ancestor of a node by `key`.
         *
         * @param {String} key
         * @return {Node|Null}
         */
      }, {
        key: 'getHighestChild',
        value: function getHighestChild(key) {
          _slateDevLogger2.default.deprecate('0.19.0', 'The `Node.getHighestChild(key) method is deprecated, please use `Node.getFurthestAncestor(key) instead.');
          return this.getFurthestAncestor(key);
        }

        /**
         * Get the highest parent of a node by `key` which has an only child.
         *
         * @param {String} key
         * @return {Node|Null}
         */
      }, {
        key: 'getHighestOnlyChildParent',
        value: function getHighestOnlyChildParent(key) {
          _slateDevLogger2.default.deprecate('0.19.0', 'The `Node.getHighestOnlyChildParent(key)` method is deprecated, please use `Node.getFurthestOnlyChildAncestor` instead.');
          return this.getFurthestOnlyChildAncestor(key);
        }

        /**
         * Check if the inline nodes are split at a `range`.
         *
         * @param {Selection} range
         * @return {Boolean}
         */
      }, {
        key: 'isInlineSplitAtRange',
        value: function isInlineSplitAtRange(range) {
          _slateDevLogger2.default.deprecate('0.19.0', 'The `Node.isInlineSplitAtRange(range)` method is deprecated.');
          range = range.normalize(this);
          if (range.isExpanded) throw new Error();
          var _range8 = range,
            startKey = _range8.startKey;
          var start = this.getFurthestInline(startKey) || this.getDescendant(startKey);
          return range.isAtStartOf(start) || range.isAtEndOf(start);
        }
      }], [{
        key: 'create',
        /**
         * Create a new `Node` with `attrs`.
         *
         * @param {Object|Node} attrs
         * @return {Node}
         */

        value: function create() {
          var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          if (Node.isNode(attrs)) {
            return attrs;
          }
          if ((0, _isPlainObject2.default)(attrs)) {
            switch (attrs.kind) {
              case 'block':
                return _block2.default.create(attrs);
              case 'document':
                return _document2.default.create(attrs);
              case 'inline':
                return _inline2.default.create(attrs);
              case 'text':
                return _text2.default.create(attrs);
              default:
                {
                  throw new Error('`Node.create` requires a `kind` string.');
                }
            }
          }
          throw new Error('`Node.create` only accepts objects or nodes but you passed it: ' + attrs);
        }

        /**
         * Create a list of `Nodes` from an array.
         *
         * @param {Array<Object|Node>} elements
         * @return {List<Node>}
         */
      }, {
        key: 'createList',
        value: function createList() {
          var elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
          if (_immutable.List.isList(elements) || Array.isArray(elements)) {
            var list = new _immutable.List(elements.map(Node.create));
            return list;
          }
          throw new Error('`Node.createList` only accepts lists or arrays, but you passed it: ' + elements);
        }

        /**
         * Create a dictionary of settable node properties from `attrs`.
         *
         * @param {Object|String|Node} attrs
         * @return {Object}
         */
      }, {
        key: 'createProperties',
        value: function createProperties() {
          var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          if (_block2.default.isBlock(attrs) || _inline2.default.isInline(attrs)) {
            return {
              data: attrs.data,
              isVoid: attrs.isVoid,
              type: attrs.type
            };
          }
          if (typeof attrs == 'string') {
            return {
              type: attrs
            };
          }
          if ((0, _isPlainObject2.default)(attrs)) {
            var props = {};
            if ('type' in attrs) props.type = attrs.type;
            if ('data' in attrs) props.data = _data2.default.create(attrs.data);
            if ('isVoid' in attrs) props.isVoid = attrs.isVoid;
            return props;
          }
          throw new Error('`Node.createProperties` only accepts objects, strings, blocks or inlines, but you passed it: ' + attrs);
        }

        /**
         * Create a `Node` from a JSON `object`.
         *
         * @param {Object} object
         * @return {Node}
         */
      }, {
        key: 'fromJSON',
        value: function fromJSON(object) {
          var kind = object.kind;
          switch (kind) {
            case 'block':
              return _block2.default.fromJSON(object);
            case 'document':
              return _document2.default.fromJSON(object);
            case 'inline':
              return _inline2.default.fromJSON(object);
            case 'text':
              return _text2.default.fromJSON(object);
            default:
              {
                throw new Error('`Node.fromJSON` requires a `kind` of either \'block\', \'document\', \'inline\' or \'text\', but you passed: ' + kind);
              }
          }
        }

        /**
         * Alias `fromJS`.
         */
      }, {
        key: 'isNode',
        /**
         * Check if a `value` is a `Node`.
         *
         * @param {Any} value
         * @return {Boolean}
         */

        value: function isNode(value) {
          return _block2.default.isBlock(value) || _document2.default.isDocument(value) || _inline2.default.isInline(value) || _text2.default.isText(value);
        }

        /**
         * Check if a `value` is a list of nodes.
         *
         * @param {Any} value
         * @return {Boolean}
         */
      }, {
        key: 'isNodeList',
        value: function isNodeList(value) {
          return _immutable.List.isList(value) && value.every(function (item) {
            return Node.isNode(item);
          });
        }
      }]);
      return Node;
    }();

    /**
     * Normalize a key argument `value`.
     *
     * @param {String|Node} value
     * @return {String}
     */

    Node.fromJS = Node.fromJSON;
    function normalizeKey(value) {
      if (typeof value == 'string') return value;
      _slateDevLogger2.default.deprecate('0.14.0', 'An object was passed to a Node method instead of a `key` string. This was previously supported, but is being deprecated because it can have a negative impact on performance. The object in question was:', value);
      if (Node.isNode(value)) {
        return value.key;
      }
      throw new Error('Invalid `key` argument! It must be either a block, an inline, a text, or a string. You passed: ' + value);
    }

    /**
     * Memoize read methods.
     */

    (0, _memoize2.default)(Node.prototype, ['getBlocks', 'getBlocksAsArray', 'getCharacters', 'getCharactersAsArray', 'getFirstText', 'getInlines', 'getInlinesAsArray', 'getKeys', 'getLastText', 'getMarks', 'getOrderedMarks', 'getMarksAsArray', 'getText', 'getTextDirection', 'getTexts', 'getTextsAsArray', 'isLeafBlock', 'isLeafInline'], {
      takesArguments: false
    });
    (0, _memoize2.default)(Node.prototype, ['areDescendantsSorted', 'getActiveMarksAtRange', 'getActiveMarksAtRangeAsArray', 'getAncestors', 'getBlocksAtRange', 'getBlocksAtRangeAsArray', 'getBlocksByType', 'getBlocksByTypeAsArray', 'getCharactersAtRange', 'getCharactersAtRangeAsArray', 'getChild', 'getChildrenBetween', 'getChildrenBetweenIncluding', 'getClosestBlock', 'getClosestInline', 'getClosestVoid', 'getCommonAncestor', 'getComponent', 'getDecorators', 'getDepth', 'getDescendant', 'getDescendantAtPath', 'getDescendantDecorators', 'getFragmentAtRange', 'getFurthestBlock', 'getFurthestInline', 'getFurthestAncestor', 'getFurthestOnlyChildAncestor', 'getInlinesAtRange', 'getInlinesAtRangeAsArray', 'getInlinesByType', 'getInlinesByTypeAsArray', 'getMarksAtRange', 'getOrderedMarksAtRange', 'getMarksAtRangeAsArray', 'getMarksByType', 'getOrderedMarksByType', 'getMarksByTypeAsArray', 'getNextBlock', 'getNextSibling', 'getNextText', 'getNode', 'getNodeAtPath', 'getOffset', 'getOffsetAtRange', 'getParent', 'getPath', 'getPreviousBlock', 'getPreviousSibling', 'getPreviousText', 'getTextAtOffset', 'getTextsAtRange', 'getTextsAtRangeAsArray', 'hasChild', 'hasDescendant', 'hasNode', 'hasVoidParent', 'isInlineSplitAtRange', 'validate'], {
      takesArguments: true
    });

    /**
     * Export.
     *
     * @type {Object}
     */

    exports.default = Node;

    /***/
  }), ( /* 44 */
  /***/function (module, exports, __webpack_require__) {
    var baseIsNative = __webpack_require__(605),
      getValue = __webpack_require__(630);

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }
    module.exports = getNative;

    /***/
  }), ( /* 45 */
  /***/function (module, exports, __webpack_require__) {
    var isObject = __webpack_require__(47);
    module.exports = function (it) {
      if (!isObject(it)) throw TypeError(it + ' is not an object!');
      return it;
    };

    /***/
  }), ( /* 46 */
  /***/function (module, exports, __webpack_require__) {
    var dP = __webpack_require__(34);
    var createDesc = __webpack_require__(64);
    module.exports = __webpack_require__(27) ? function (object, key, value) {
      return dP.f(object, key, createDesc(1, value));
    } : function (object, key, value) {
      object[key] = value;
      return object;
    };

    /***/
  }), ( /* 47 */
  /***/function (module, exports) {
    module.exports = function (it) {
      return typeof it === 'object' ? it !== null : typeof it === 'function';
    };

    /***/
  }), ( /* 48 */
  /***/function (module, exports, __webpack_require__) {
    var isObject = __webpack_require__(38);
    module.exports = function (it) {
      if (!isObject(it)) throw TypeError(it + ' is not an object!');
      return it;
    };

    /***/
  }), ( /* 49 */
  /***/function (module, exports) {
    var toString = {}.toString;
    module.exports = function (it) {
      return toString.call(it).slice(8, -1);
    };

    /***/
  }), ( /* 50 */
  /***/function (module, exports, __webpack_require__) {
    var global = __webpack_require__(19);
    var hide = __webpack_require__(37);
    var has = __webpack_require__(69);
    var SRC = __webpack_require__(129)('src');
    var TO_STRING = 'toString';
    var $toString = Function[TO_STRING];
    var TPL = ('' + $toString).split(TO_STRING);
    __webpack_require__(36).inspectSource = function (it) {
      return $toString.call(it);
    };
    (module.exports = function (O, key, val, safe) {
      var isFunction = typeof val == 'function';
      if (isFunction) has(val, 'name') || hide(val, 'name', key);
      if (O[key] === val) return;
      if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
      if (O === global) {
        O[key] = val;
      } else if (!safe) {
        delete O[key];
        hide(O, key, val);
      } else if (O[key]) {
        O[key] = val;
      } else {
        hide(O, key, val);
      }
      // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
    })(Function.prototype, TO_STRING, function toString() {
      return typeof this == 'function' && this[SRC] || $toString.call(this);
    });

    /***/
  }), ( /* 51 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var _undefined = __webpack_require__(204)(); // Support ES3 engines

    module.exports = function (val) {
      return val !== _undefined && val !== null;
    };

    /***/
  }), ( /* 52 */
  /***/function (module, exports, __webpack_require__) {
    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    if (false) {
      var ReactIs = require('react-is');

      // By explicitly using `prop-types` you are opting into new development behavior.
      // http://fb.me/prop-types-in-prod
      var throwOnDirectAccess = true;
      module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
    } else {
      // By explicitly using `prop-types` you are opting into new production behavior.
      // http://fb.me/prop-types-in-prod
      module.exports = __webpack_require__(545)();
    }

    /***/
  }), ( /* 53 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _slate = __webpack_require__(22);

    /**
     * Create a prop type checker for Slate objects with `name` and `validate`.
     *
     * @param {String} name
     * @param {Function} validate
     * @return {Function}
     */

    function create(name, validate) {
      function check(isRequired, props, propName, componentName, location) {
        var value = props[propName];
        if (value == null && !isRequired) return null;
        if (value == null && isRequired) return new Error('The ' + location + ' `' + propName + '` is marked as required in `' + componentName + '`, but it was not supplied.');
        if (validate(value)) return null;
        return new Error('Invalid ' + location + ' `' + propName + '` supplied to `' + componentName + '`, expected a Slate `' + name + '` but received: ' + value);
      }
      function propType() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return check.apply(undefined, [false].concat(args));
      }
      propType.isRequired = function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        return check.apply(undefined, [true].concat(args));
      };
      return propType;
    }

    /**
     * Prop type checkers.
     *
     * @type {Object}
     */

    var Types = {
      block: create('Block', function (v) {
        return _slate.Block.isBlock(v);
      }),
      blocks: create('List<Block>', function (v) {
        return _slate.Block.isBlockList(v);
      }),
      change: create('Change', function (v) {
        return _slate.Change.isChange(v);
      }),
      character: create('Character', function (v) {
        return _slate.Character.isCharacter(v);
      }),
      characters: create('List<Character>', function (v) {
        return _slate.Character.isCharacterList(v);
      }),
      data: create('Data', function (v) {
        return _slate.Data.isData(v);
      }),
      document: create('Document', function (v) {
        return _slate.Document.isDocument(v);
      }),
      history: create('History', function (v) {
        return _slate.History.isHistory(v);
      }),
      inline: create('Inline', function (v) {
        return _slate.Inline.isInline(v);
      }),
      inlines: create('Inline', function (v) {
        return _slate.Inline.isInlineList(v);
      }),
      mark: create('Mark', function (v) {
        return _slate.Mark.isMark(v);
      }),
      marks: create('Set<Mark>', function (v) {
        return _slate.Mark.isMarkSet(v);
      }),
      node: create('Node', function (v) {
        return _slate.Node.isNode(v);
      }),
      nodes: create('List<Node>', function (v) {
        return _slate.Node.isNodeList(v);
      }),
      range: create('Range', function (v) {
        return _slate.Range.isRange(v);
      }),
      ranges: create('List<Range>', function (v) {
        return _slate.Range.isRangeList(v);
      }),
      schema: create('Schema', function (v) {
        return _slate.Schema.isSchema(v);
      }),
      selection: create('Selection', function (v) {
        return _slate.Selection.isSelection(v);
      }),
      stack: create('Stack', function (v) {
        return _slate.Stack.isStack(v);
      }),
      state: create('State', function (v) {
        return _slate.State.isState(v);
      }),
      text: create('Text', function (v) {
        return _slate.Text.isText(v);
      }),
      texts: create('List<Text>', function (v) {
        return _slate.Text.isTextList(v);
      })
    };

    /**
     * Export.
     *
     * @type {Object}
     */

    exports.default = Types;

    /***/
  }), ( /* 54 */
  /***/function (module, exports, __webpack_require__) {
    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    if (false) {
      var ReactIs = require('react-is');

      // By explicitly using `prop-types` you are opting into new development behavior.
      // http://fb.me/prop-types-in-prod
      var throwOnDirectAccess = true;
      module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
    } else {
      // By explicitly using `prop-types` you are opting into new production behavior.
      // http://fb.me/prop-types-in-prod
      module.exports = __webpack_require__(567)();
    }

    /***/
  }), ( /* 55 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    __webpack_require__(74);
    var _isPlainObject = __webpack_require__(9);
    var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
    var _immutable = __webpack_require__(2);
    var _modelTypes = __webpack_require__(11);
    var _modelTypes2 = _interopRequireDefault(_modelTypes);
    var _node = __webpack_require__(43);
    var _node2 = _interopRequireDefault(_node);
    var _generateKey = __webpack_require__(57);
    var _generateKey2 = _interopRequireDefault(_generateKey);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    /**
     * Prevent circular dependencies.
     */

    /**
     * Dependencies.
     */

    /**
     * Default properties.
     *
     * @type {Object}
     */

    var DEFAULTS = {
      data: new _immutable.Map(),
      isVoid: false,
      key: undefined,
      nodes: new _immutable.List(),
      type: undefined
    };

    /**
     * Block.
     *
     * @type {Block}
     */

    var Block = function (_Record) {
      _inherits(Block, _Record);
      function Block() {
        _classCallCheck(this, Block);
        return _possibleConstructorReturn(this, (Block.__proto__ || Object.getPrototypeOf(Block)).apply(this, arguments));
      }
      _createClass(Block, [{
        key: 'toJSON',
        /**
         * Return a JSON representation of the block.
         *
         * @param {Object} options
         * @return {Object}
         */

        value: function toJSON() {
          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var object = {
            data: this.data.toJSON(),
            key: this.key,
            kind: this.kind,
            isVoid: this.isVoid,
            type: this.type,
            nodes: this.nodes.toArray().map(function (n) {
              return n.toJSON(options);
            })
          };
          if (!options.preserveKeys) {
            delete object.key;
          }
          return object;
        }

        /**
         * Alias `toJS`.
         */
      }, {
        key: 'toJS',
        value: function toJS(options) {
          return this.toJSON(options);
        }
      }, {
        key: 'kind',
        /**
         * Get the node's kind.
         *
         * @return {String}
         */

        get: function get() {
          return 'block';
        }

        /**
         * Check if the block is empty.
         *
         * @return {Boolean}
         */
      }, {
        key: 'isEmpty',
        get: function get() {
          return this.text == '';
        }

        /**
         * Get the concatenated text of all the block's children.
         *
         * @return {String}
         */
      }, {
        key: 'text',
        get: function get() {
          return this.getText();
        }
      }], [{
        key: 'create',
        /**
         * Create a new `Block` from `value`.
         *
         * @param {Object|String|Block} value
         * @return {Block}
         */

        value: function create() {
          var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          if (Block.isBlock(value)) {
            return value;
          }
          if (typeof value == 'string') {
            value = {
              type: value
            };
          }
          if ((0, _isPlainObject2.default)(value)) {
            return Block.fromJSON(value);
          }
          throw new Error('`Block.create` only accepts objects, strings or blocks, but you passed it: ' + value);
        }

        /**
         * Create a list of `Blocks` from `value`.
         *
         * @param {Array<Block|Object>|List<Block|Object>} value
         * @return {List<Block>}
         */
      }, {
        key: 'createList',
        value: function createList() {
          var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
          if (_immutable.List.isList(value) || Array.isArray(value)) {
            var list = new _immutable.List(value.map(Block.create));
            return list;
          }
          throw new Error('`Block.createList` only accepts arrays or lists, but you passed it: ' + value);
        }

        /**
         * Create a `Block` from a JSON `object`.
         *
         * @param {Object|Block} object
         * @return {Block}
         */
      }, {
        key: 'fromJSON',
        value: function fromJSON(object) {
          if (Block.isBlock(object)) {
            return object;
          }
          var _object$data = object.data,
            data = _object$data === undefined ? {} : _object$data,
            _object$isVoid = object.isVoid,
            isVoid = _object$isVoid === undefined ? false : _object$isVoid,
            _object$key = object.key,
            key = _object$key === undefined ? (0, _generateKey2.default)() : _object$key,
            type = object.type;
          var _object$nodes = object.nodes,
            nodes = _object$nodes === undefined ? [] : _object$nodes;
          if (typeof type != 'string') {
            throw new Error('`Block.fromJSON` requires a `type` string.');
          }
          if (nodes.length == 0) {
            nodes = [{
              kind: 'text',
              text: ''
            }];
          }
          var block = new Block({
            key: key,
            type: type,
            isVoid: !!isVoid,
            data: new _immutable.Map(data),
            nodes: new _immutable.List(nodes.map(_node2.default.fromJSON))
          });
          return block;
        }

        /**
         * Alias `fromJS`.
         */
      }, {
        key: 'isBlock',
        /**
         * Check if a `value` is a `Block`.
         *
         * @param {Any} value
         * @return {Boolean}
         */

        value: function isBlock(value) {
          return !!(value && value[_modelTypes2.default.BLOCK]);
        }

        /**
         * Check if a `value` is a block list.
         *
         * @param {Any} value
         * @return {Boolean}
         */
      }, {
        key: 'isBlockList',
        value: function isBlockList(value) {
          return _immutable.List.isList(value) && value.every(function (item) {
            return Block.isBlock(item);
          });
        }
      }]);
      return Block;
    }((0, _immutable.Record)(DEFAULTS));

    /**
     * Attach a pseudo-symbol for type checking.
     */

    Block.fromJS = Block.fromJSON;
    Block.prototype[_modelTypes2.default.BLOCK] = true;

    /**
     * Mix in `Node` methods.
     */

    Object.getOwnPropertyNames(_node2.default.prototype).forEach(function (method) {
      if (method == 'constructor') return;
      Block.prototype[method] = _node2.default.prototype[method];
    });

    /**
     * Export.
     *
     * @type {Block}
     */

    exports.default = Block;

    /***/
  }), ( /* 56 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    __webpack_require__(74);
    var _isPlainObject = __webpack_require__(9);
    var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
    var _immutable = __webpack_require__(2);
    var _node = __webpack_require__(43);
    var _node2 = _interopRequireDefault(_node);
    var _modelTypes = __webpack_require__(11);
    var _modelTypes2 = _interopRequireDefault(_modelTypes);
    var _generateKey = __webpack_require__(57);
    var _generateKey2 = _interopRequireDefault(_generateKey);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    /**
     * Prevent circular dependencies.
     */

    /**
     * Dependencies.
     */

    /**
     * Default properties.
     *
     * @type {Object}
     */

    var DEFAULTS = {
      data: new _immutable.Map(),
      isVoid: false,
      key: undefined,
      nodes: new _immutable.List(),
      type: undefined
    };

    /**
     * Inline.
     *
     * @type {Inline}
     */

    var Inline = function (_Record) {
      _inherits(Inline, _Record);
      function Inline() {
        _classCallCheck(this, Inline);
        return _possibleConstructorReturn(this, (Inline.__proto__ || Object.getPrototypeOf(Inline)).apply(this, arguments));
      }
      _createClass(Inline, [{
        key: 'toJSON',
        /**
         * Return a JSON representation of the inline.
         *
         * @param {Object} options
         * @return {Object}
         */

        value: function toJSON() {
          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var object = {
            data: this.data.toJSON(),
            key: this.key,
            kind: this.kind,
            isVoid: this.isVoid,
            type: this.type,
            nodes: this.nodes.toArray().map(function (n) {
              return n.toJSON(options);
            })
          };
          if (!options.preserveKeys) {
            delete object.key;
          }
          return object;
        }

        /**
         * Alias `toJS`.
         */
      }, {
        key: 'toJS',
        value: function toJS(options) {
          return this.toJSON(options);
        }
      }, {
        key: 'kind',
        /**
         * Get the node's kind.
         *
         * @return {String}
         */

        get: function get() {
          return 'inline';
        }

        /**
         * Check if the inline is empty.
         *
         * @return {Boolean}
         */
      }, {
        key: 'isEmpty',
        get: function get() {
          return this.text == '';
        }

        /**
         * Get the concatenated text of all the inline's children.
         *
         * @return {String}
         */
      }, {
        key: 'text',
        get: function get() {
          return this.getText();
        }
      }], [{
        key: 'create',
        /**
         * Create a new `Inline` with `attrs`.
         *
         * @param {Object|String|Inline} attrs
         * @return {Inline}
         */

        value: function create() {
          var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          if (Inline.isInline(attrs)) {
            return attrs;
          }
          if (typeof attrs == 'string') {
            attrs = {
              type: attrs
            };
          }
          if ((0, _isPlainObject2.default)(attrs)) {
            return Inline.fromJSON(attrs);
          }
          throw new Error('`Inline.create` only accepts objects, strings or inlines, but you passed it: ' + attrs);
        }

        /**
         * Create a list of `Inlines` from an array.
         *
         * @param {Array<Inline|Object>|List<Inline|Object>} elements
         * @return {List<Inline>}
         */
      }, {
        key: 'createList',
        value: function createList() {
          var elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
          if (_immutable.List.isList(elements) || Array.isArray(elements)) {
            var list = new _immutable.List(elements.map(Inline.create));
            return list;
          }
          throw new Error('`Inline.createList` only accepts arrays or lists, but you passed it: ' + elements);
        }

        /**
         * Create a `Inline` from a JSON `object`.
         *
         * @param {Object|Inline} object
         * @return {Inline}
         */
      }, {
        key: 'fromJSON',
        value: function fromJSON(object) {
          if (Inline.isInline(object)) {
            return object;
          }
          var _object$data = object.data,
            data = _object$data === undefined ? {} : _object$data,
            _object$isVoid = object.isVoid,
            isVoid = _object$isVoid === undefined ? false : _object$isVoid,
            _object$key = object.key,
            key = _object$key === undefined ? (0, _generateKey2.default)() : _object$key,
            type = object.type;
          var _object$nodes = object.nodes,
            nodes = _object$nodes === undefined ? [] : _object$nodes;
          if (typeof type != 'string') {
            throw new Error('`Inline.fromJS` requires a `type` string.');
          }
          if (nodes.length == 0) {
            nodes = [{
              kind: 'text',
              text: ''
            }];
          }
          var inline = new Inline({
            key: key,
            type: type,
            isVoid: !!isVoid,
            data: new _immutable.Map(data),
            nodes: new _immutable.List(nodes.map(_node2.default.fromJSON))
          });
          return inline;
        }

        /**
         * Alias `fromJS`.
         */
      }, {
        key: 'isInline',
        /**
         * Check if a `value` is a `Inline`.
         *
         * @param {Any} value
         * @return {Boolean}
         */

        value: function isInline(value) {
          return !!(value && value[_modelTypes2.default.INLINE]);
        }

        /**
         * Check if a `value` is a list of inlines.
         *
         * @param {Any} value
         * @return {Boolean}
         */
      }, {
        key: 'isInlineList',
        value: function isInlineList(value) {
          return _immutable.List.isList(value) && value.every(function (item) {
            return Inline.isInline(item);
          });
        }
      }]);
      return Inline;
    }((0, _immutable.Record)(DEFAULTS));

    /**
     * Attach a pseudo-symbol for type checking.
     */

    Inline.fromJS = Inline.fromJSON;
    Inline.prototype[_modelTypes2.default.INLINE] = true;

    /**
     * Mix in `Node` methods.
     */

    Object.getOwnPropertyNames(_node2.default.prototype).forEach(function (method) {
      if (method == 'constructor') return;
      Inline.prototype[method] = _node2.default.prototype[method];
    });

    /**
     * Export.
     *
     * @type {Inline}
     */

    exports.default = Inline;

    /***/
  }), ( /* 57 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    /**
     * An auto-incrementing index for generating keys.
     *
     * @type {Number}
     */

    var n = void 0;

    /**
     * The global key generating function.
     *
     * @type {Function}
     */

    var generate = void 0;

    /**
     * Generate a key.
     *
     * @return {String}
     */

    function generateKey() {
      return generate();
    }

    /**
     * Set a different unique ID generating `function`.
     *
     * @param {Function} func
     */

    function setKeyGenerator(func) {
      generate = func;
    }

    /**
     * Reset the key generating function to its initial state.
     */

    function resetKeyGenerator() {
      n = 0;
      generate = function generate() {
        return "" + n++;
      };
    }

    /**
     * Set the initial state.
     */

    resetKeyGenerator();

    /**
     * Export.
     *
     * @type {Object}
     */

    exports.default = generateKey;
    exports.setKeyGenerator = setKeyGenerator;
    exports.resetKeyGenerator = resetKeyGenerator;

    /***/
  }), ( /* 58 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // ES3 safe
    var _undefined = void 0;
    module.exports = function (value) {
      return value !== _undefined && value !== null;
    };

    /***/
  }), ( /* 59 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var translations = {
      en: {
        insertHeader: 'Insert header',
        insertLink: 'Insert link',
        numberedList: 'Numbered list',
        bulletedList: 'Bulleted list',
        bold: 'Bold (Ctrl + B)',
        italic: 'Italic (Ctrl + I)',
        strikethrough: 'Strikethrough (Ctrl + S)',
        noMatchesFound: 'No matches found',
        fullscreen: 'Fullscreen',
        Product: 'Product',
        Term: 'Term',
        Maximize: 'Maximize',
        Minimize: 'Minimize',
        searching: 'Searching'
      },
      de: {
        insertHeader: 'Kopfzeile einfügen',
        insertLink: 'Link einfügen',
        numberedList: 'Nummerierte Liste',
        bulletedList: 'Aufzählung',
        bold: 'Fett (Strg + B)',
        italic: 'Kursiv (Strg + I)',
        strikethrough: 'Durchgestrichen (Strg + S)',
        noMatchesFound: 'Keine Treffer gefunden',
        fullscreen: 'Vollbild',
        Product: 'Product',
        Term: 'Term',
        Maximize: 'Maximieren',
        Minimize: 'Minimieren',
        searching: 'Suchen'
      }
    };
    exports.default = function (locale, key) {
      return translations[locale] && translations[locale][key] || translations['en'][key];
    };

    /***/
  }), ( /* 60 */
  /***/function (module, exports) {
    module.exports = function (exec) {
      try {
        return !!exec();
      } catch (e) {
        return true;
      }
    };

    /***/
  }), ( /* 61 */
  /***/function (module, exports) {
    module.exports = {};

    /***/
  }), ( /* 62 */
  /***/function (module, exports, __webpack_require__) {
    // 19.1.2.14 / 15.2.3.14 Object.keys(O)
    var $keys = __webpack_require__(174);
    var enumBugKeys = __webpack_require__(111);
    module.exports = Object.keys || function keys(O) {
      return $keys(O, enumBugKeys);
    };

    /***/
  }), ( /* 63 */
  /***/function (module, exports) {
    exports.f = {}.propertyIsEnumerable;

    /***/
  }), ( /* 64 */
  /***/function (module, exports) {
    module.exports = function (bitmap, value) {
      return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
      };
    };

    /***/
  }), ( /* 65 */
  /***/function (module, exports) {
    module.exports = function (it) {
      if (typeof it != 'function') throw TypeError(it + ' is not a function!');
      return it;
    };

    /***/
  }), ( /* 66 */
  /***/function (module, exports, __webpack_require__) {
    // optional / simple context binding
    var aFunction = __webpack_require__(65);
    module.exports = function (fn, that, length) {
      aFunction(fn);
      if (that === undefined) return fn;
      switch (length) {
        case 1:
          return function (a) {
            return fn.call(that, a);
          };
        case 2:
          return function (a, b) {
            return fn.call(that, a, b);
          };
        case 3:
          return function (a, b, c) {
            return fn.call(that, a, b, c);
          };
      }
      return function /* ...args */
      () {
        return fn.apply(that, arguments);
      };
    };

    /***/
  }), ( /* 67 */
  /***/function (module, exports, __webpack_require__) {
    // Thank's IE8 for his funny defineProperty
    module.exports = !__webpack_require__(68)(function () {
      return Object.defineProperty({}, 'a', {
        get: function get() {
          return 7;
        }
      }).a != 7;
    });

    /***/
  }), ( /* 68 */
  /***/function (module, exports) {
    module.exports = function (exec) {
      try {
        return !!exec();
      } catch (e) {
        return true;
      }
    };

    /***/
  }), ( /* 69 */
  /***/function (module, exports) {
    var hasOwnProperty = {}.hasOwnProperty;
    module.exports = function (it, key) {
      return hasOwnProperty.call(it, key);
    };

    /***/
  }), ( /* 70 */
  /***/function (module, exports) {
    module.exports = {};

    /***/
  }), ( /* 71 */
  /***/function (module, exports) {
    // 7.1.4 ToInteger
    var ceil = Math.ceil;
    var floor = Math.floor;
    module.exports = function (it) {
      return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
    };

    /***/
  }), ( /* 72 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _reactIs = __webpack_require__(537);
    var _createChainableTypeChecker = __webpack_require__(95);
    var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function elementType(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (_react2.default.isValidElement(propValue)) {
        return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`,expected an element type (a string ') + ', component class, or function component).');
      }
      if (!(0, _reactIs.isValidElementType)(propValue)) {
        return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + ', component class, or function component).');
      }
      return null;
    }
    exports.default = (0, _createChainableTypeChecker2.default)(elementType);
    module.exports = exports['default'];

    /***/
  }), ( /* 73 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    exports.default = function (componentOrElement) {
      return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
    };
    var _reactDom = __webpack_require__(4);
    var _reactDom2 = _interopRequireDefault(_reactDom);
    var _ownerDocument = __webpack_require__(88);
    var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    module.exports = exports['default'];

    /***/
  }), ( /* 74 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    __webpack_require__(55);
    __webpack_require__(56);
    var _isPlainObject = __webpack_require__(9);
    var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
    var _immutable = __webpack_require__(2);
    var _node = __webpack_require__(43);
    var _node2 = _interopRequireDefault(_node);
    var _modelTypes = __webpack_require__(11);
    var _modelTypes2 = _interopRequireDefault(_modelTypes);
    var _generateKey = __webpack_require__(57);
    var _generateKey2 = _interopRequireDefault(_generateKey);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    /**
     * Prevent circular dependencies.
     */

    /**
     * Dependencies.
     */

    /**
     * Default properties.
     *
     * @type {Object}
     */

    var DEFAULTS = {
      data: new _immutable.Map(),
      key: undefined,
      nodes: new _immutable.List()
    };

    /**
     * Document.
     *
     * @type {Document}
     */

    var Document = function (_Record) {
      _inherits(Document, _Record);
      function Document() {
        _classCallCheck(this, Document);
        return _possibleConstructorReturn(this, (Document.__proto__ || Object.getPrototypeOf(Document)).apply(this, arguments));
      }
      _createClass(Document, [{
        key: 'toJSON',
        /**
         * Return a JSON representation of the document.
         *
         * @param {Object} options
         * @return {Object}
         */

        value: function toJSON() {
          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var object = {
            data: this.data.toJSON(),
            key: this.key,
            kind: this.kind,
            nodes: this.nodes.toArray().map(function (n) {
              return n.toJSON(options);
            })
          };
          if (!options.preserveKeys) {
            delete object.key;
          }
          return object;
        }

        /**
         * Alias `toJS`.
         */
      }, {
        key: 'toJS',
        value: function toJS(options) {
          return this.toJSON(options);
        }
      }, {
        key: 'kind',
        /**
         * Get the node's kind.
         *
         * @return {String}
         */

        get: function get() {
          return 'document';
        }

        /**
         * Check if the document is empty.
         *
         * @return {Boolean}
         */
      }, {
        key: 'isEmpty',
        get: function get() {
          return this.text == '';
        }

        /**
         * Get the concatenated text of all the document's children.
         *
         * @return {String}
         */
      }, {
        key: 'text',
        get: function get() {
          return this.getText();
        }
      }], [{
        key: 'create',
        /**
         * Create a new `Document` with `attrs`.
         *
         * @param {Object|Array|List|Text} attrs
         * @return {Document}
         */

        value: function create() {
          var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          if (Document.isDocument(attrs)) {
            return attrs;
          }
          if (_immutable.List.isList(attrs) || Array.isArray(attrs)) {
            attrs = {
              nodes: attrs
            };
          }
          if ((0, _isPlainObject2.default)(attrs)) {
            return Document.fromJSON(attrs);
          }
          throw new Error('`Document.create` only accepts objects, arrays, lists or documents, but you passed it: ' + attrs);
        }

        /**
         * Create a `Document` from a JSON `object`.
         *
         * @param {Object|Document} object
         * @return {Document}
         */
      }, {
        key: 'fromJSON',
        value: function fromJSON(object) {
          if (Document.isDocument(object)) {
            return object;
          }
          var _object$data = object.data,
            data = _object$data === undefined ? {} : _object$data,
            _object$key = object.key,
            key = _object$key === undefined ? (0, _generateKey2.default)() : _object$key,
            _object$nodes = object.nodes,
            nodes = _object$nodes === undefined ? [] : _object$nodes;
          var document = new Document({
            key: key,
            data: new _immutable.Map(data),
            nodes: new _immutable.List(nodes.map(_node2.default.fromJSON))
          });
          return document;
        }

        /**
         * Alias `fromJS`.
         */
      }, {
        key: 'isDocument',
        /**
         * Check if a `value` is a `Document`.
         *
         * @param {Any} value
         * @return {Boolean}
         */

        value: function isDocument(value) {
          return !!(value && value[_modelTypes2.default.DOCUMENT]);
        }
      }]);
      return Document;
    }((0, _immutable.Record)(DEFAULTS));

    /**
     * Attach a pseudo-symbol for type checking.
     */

    Document.fromJS = Document.fromJSON;
    Document.prototype[_modelTypes2.default.DOCUMENT] = true;

    /**
     * Mix in `Node` methods.
     */

    Object.getOwnPropertyNames(_node2.default.prototype).forEach(function (method) {
      if (method == 'constructor') return;
      Document.prototype[method] = _node2.default.prototype[method];
    });

    /**
     * Export.
     *
     * @type {Document}
     */

    exports.default = Document;

    /***/
  }), ( /* 75 */
  /***/function (module, exports, __webpack_require__) {
    var root = __webpack_require__(25);

    /** Built-in value references. */
    var Symbol = root.Symbol;
    module.exports = Symbol;

    /***/
  }), ( /* 76 */
  /***/function (module, exports, __webpack_require__) {
    var Symbol = __webpack_require__(75),
      getRawTag = __webpack_require__(627),
      objectToString = __webpack_require__(655);

    /** `Object#toString` result references. */
    var nullTag = '[object Null]',
      undefinedTag = '[object Undefined]';

    /** Built-in value references. */
    var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    }
    module.exports = baseGetTag;

    /***/
  }), ( /* 77 */
  /***/function (module, exports, __webpack_require__) {
    var isSymbol = __webpack_require__(105);

    /** Used as references for various `Number` constants. */
    var INFINITY = 1 / 0;

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = value + '';
      return result == '0' && 1 / value == -INFINITY ? '-0' : result;
    }
    module.exports = toKey;

    /***/
  }), ( /* 78 */
  /***/function (module, exports) {
    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }
    module.exports = isObject;

    /***/
  }), ( /* 79 */
  /***/function (module, exports) {
    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }
    module.exports = isObjectLike;

    /***/
  }), ( /* 80 */
  /***/function (module, exports) {
    var g;

    // This works in non-strict mode
    g = function () {
      return this;
    }();
    try {
      // This works if eval is allowed (see CSP)
      g = g || Function("return this")() || (1, eval)("this");
    } catch (e) {
      // This works if the window reference is available
      if (typeof window === "object") g = window;
    }

    // g can still be undefined, but nothing to do about it...
    // We return undefined, instead of nothing here, so it's
    // easier to handle this case. if(!global) { ...}

    module.exports = g;

    /***/
  }), ( /* 81 */
  /***/function (module, exports) {
    module.exports = true;

    /***/
  }), ( /* 82 */
  /***/function (module, exports, __webpack_require__) {
    // 7.1.13 ToObject(argument)
    var defined = __webpack_require__(110);
    module.exports = function (it) {
      return Object(defined(it));
    };

    /***/
  }), ( /* 83 */
  /***/function (module, exports) {
    var id = 0;
    var px = Math.random();
    module.exports = function (key) {
      return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
    };

    /***/
  }), ( /* 84 */
  /***/function (module, exports, __webpack_require__) {
    // 22.1.3.31 Array.prototype[@@unscopables]
    var UNSCOPABLES = __webpack_require__(3)('unscopables');
    var ArrayProto = Array.prototype;
    if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(37)(ArrayProto, UNSCOPABLES, {});
    module.exports = function (key) {
      ArrayProto[UNSCOPABLES][key] = true;
    };

    /***/
  }), ( /* 85 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var hide = __webpack_require__(37);
    var redefine = __webpack_require__(50);
    var fails = __webpack_require__(68);
    var defined = __webpack_require__(30);
    var wks = __webpack_require__(3);
    module.exports = function (KEY, length, exec) {
      var SYMBOL = wks(KEY);
      var fns = exec(defined, SYMBOL, ''[KEY]);
      var strfn = fns[0];
      var rxfn = fns[1];
      if (fails(function () {
        var O = {};
        O[SYMBOL] = function () {
          return 7;
        };
        return ''[KEY](O) != 7;
      })) {
        redefine(String.prototype, KEY, strfn);
        hide(RegExp.prototype, SYMBOL, length == 2
        // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
        // 21.2.5.11 RegExp.prototype[@@split](string, limit)
        ? function (string, arg) {
          return rxfn.call(string, this, arg);
        }
        // 21.2.5.6 RegExp.prototype[@@match](string)
        // 21.2.5.9 RegExp.prototype[@@search](string)
        : function (string) {
          return rxfn.call(string, this);
        });
      }
    };

    /***/
  }), ( /* 86 */
  /***/function (module, exports, __webpack_require__) {
    var anObject = __webpack_require__(48);
    var IE8_DOM_DEFINE = __webpack_require__(330);
    var toPrimitive = __webpack_require__(351);
    var dP = Object.defineProperty;
    exports.f = __webpack_require__(67) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
      anObject(O);
      P = toPrimitive(P, true);
      anObject(Attributes);
      if (IE8_DOM_DEFINE) try {
        return dP(O, P, Attributes);
      } catch (e) {/* empty */}
      if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
      if ('value' in Attributes) O[P] = Attributes.value;
      return O;
    };

    /***/
  }), ( /* 87 */
  /***/function (module, exports, __webpack_require__) {
    // to indexed object, toObject with fallback for non-array-like ES3 strings
    var IObject = __webpack_require__(332);
    var defined = __webpack_require__(30);
    module.exports = function (it) {
      return IObject(defined(it));
    };

    /***/
  }), ( /* 88 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    exports.default = ownerDocument;
    function ownerDocument(node) {
      return node && node.ownerDocument || document;
    }
    module.exports = exports["default"];

    /***/
  }), ( /* 89 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var _interopRequireDefault = __webpack_require__(5);
    exports.__esModule = true;
    exports.default = void 0;
    var _inDOM = _interopRequireDefault(__webpack_require__(90));
    var _default = function () {
      // HTML DOM and SVG DOM may have different support levels,
      // so we need to check on context instead of a document root element.
      return _inDOM.default ? function (context, node) {
        if (context.contains) {
          return context.contains(node);
        } else if (context.compareDocumentPosition) {
          return context === node || !!(context.compareDocumentPosition(node) & 16);
        } else {
          return fallback(context, node);
        }
      } : fallback;
    }();
    exports.default = _default;
    function fallback(context, node) {
      if (node) do {
        if (node === context) return true;
      } while (node = node.parentNode);
      return false;
    }
    module.exports = exports["default"];

    /***/
  }), ( /* 90 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    exports.default = void 0;
    var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    exports.default = _default;
    module.exports = exports["default"];

    /***/
  }), ( /* 91 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var objToString = Object.prototype.toString,
      id = objToString.call(function () {
        return arguments;
      }());
    module.exports = function (value) {
      return objToString.call(value) === id;
    };

    /***/
  }), ( /* 92 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    module.exports = __webpack_require__(207)() ? Object.setPrototypeOf : __webpack_require__(208);

    /***/
  }), ( /* 93 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var objToString = Object.prototype.toString,
      id = objToString.call("");
    module.exports = function (value) {
      return typeof value === "string" || value && typeof value === "object" && (value instanceof String || objToString.call(value) === id) || false;
    };

    /***/
  }), ( /* 94 */
  /***/function (module, exports, __webpack_require__) {
    /**
     * Module dependencies.
     */

    var getDocument = __webpack_require__(448);

    /**
     * Module exports.
     */

    module.exports = getWindow;
    var needsIEFallback = __webpack_require__(449);

    /**
     * Returns `true` if `w` is a Window object, or `false` otherwise.
     *
     * @param {Mixed} w - Window object, maybe
     * @return {Boolean}
     * @private
     */

    function isWindow(w) {
      return w && w.window === w;
    }

    /**
     * Returns the `window` object associated with the given `node`, which may be
     * a DOM element, the Window object, a Selection, a Range. Basically any DOM
     * object that references the Window in some way, this function will find it.
     *
     * @param {Mixed} node - DOM node, selection, or range in which to find the `window` object
     * @return {Window} the `window` object associated with `node`
     * @public
     */

    function getWindow(node) {
      if (isWindow(node)) {
        return node;
      }
      var doc = getDocument(node);
      if (needsIEFallback) {
        // In IE 6-8, only the variable 'window' can be used to connect events (others
        // may be only copies).
        doc.parentWindow.execScript('document._parentWindow = window;', 'Javascript');
        var win = doc._parentWindow;
        // to prevent memory leak, unset it after use
        // another possibility is to add an onUnload handler,
        // (which seems overkill to @liucougar)
        doc._parentWindow = null;
        return win;
      } else {
        // standards-compliant and newer IE
        return doc.defaultView || doc.parentWindow;
      }
    }

    /***/
  }), ( /* 95 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = createChainableTypeChecker;
    /**
     * Copyright 2013-present, Facebook, Inc.
     * All rights reserved.
     *
     * This source code is licensed under the BSD-style license found in the
     * LICENSE file in the root directory of this source tree. An additional grant
     * of patent rights can be found in the PATENTS file in the same directory.
     */

    // Mostly taken from ReactPropTypes.

    function createChainableTypeChecker(validate) {
      function checkType(isRequired, props, propName, componentName, location, propFullName) {
        var componentNameSafe = componentName || '<<anonymous>>';
        var propFullNameSafe = propFullName || propName;
        if (props[propName] == null) {
          if (isRequired) {
            return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
          }
          return null;
        }
        for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
          args[_key - 6] = arguments[_key];
        }
        return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    module.exports = exports['default'];

    /***/
  }), ( /* 96 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    /**
     * Safe chained function
     *
     * Will only create a new function if needed,
     * otherwise will pass back existing functions or null.
     *
     * @param {function} functions to chain
     * @returns {function|null}
     */
    function createChainedFunction() {
      for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
        funcs[_key] = arguments[_key];
      }
      return funcs.filter(function (f) {
        return f != null;
      }).reduce(function (acc, f) {
        if (typeof f !== 'function') {
          throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
        }
        if (acc === null) {
          return f;
        }
        return function chainedFunction() {
          for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }
          acc.apply(this, args);
          f.apply(this, args);
        };
      }, null);
    }
    exports['default'] = createChainedFunction;
    module.exports = exports['default'];

    /***/
  }), ( /* 97 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _slate = __webpack_require__(22);
    var _isomorphicBase = __webpack_require__(454);

    /**
     * Encode a JSON `object` as base-64 `string`.
     *
     * @param {Object} object
     * @return {String}
     */

    function encode(object) {
      var string = JSON.stringify(object);
      var encoded = (0, _isomorphicBase.btoa)(encodeURIComponent(string));
      return encoded;
    }

    /**
     * Decode a base-64 `string` to a JSON `object`.
     *
     * @param {String} string
     * @return {Object}
     */

    function decode(string) {
      var decoded = decodeURIComponent((0, _isomorphicBase.atob)(string));
      var object = JSON.parse(decoded);
      return object;
    }

    /**
     * Deserialize a State `string`.
     *
     * @param {String} string
     * @return {State}
     */

    function deserialize(string, options) {
      var raw = decode(string);
      var state = _slate.State.fromJSON(raw, options);
      return state;
    }

    /**
     * Deserialize a Node `string`.
     *
     * @param {String} string
     * @return {Node}
     */

    function deserializeNode(string, options) {
      var _require = __webpack_require__(22),
        Node = _require.Node;
      var raw = decode(string);
      var node = Node.fromJSON(raw, options);
      return node;
    }

    /**
     * Serialize a `state`.
     *
     * @param {State} state
     * @return {String}
     */

    function serialize(state, options) {
      var raw = state.toJSON(options);
      var encoded = encode(raw);
      return encoded;
    }

    /**
     * Serialize a `node`.
     *
     * @param {Node} node
     * @return {String}
     */

    function serializeNode(node, options) {
      var raw = node.toJSON(options);
      var encoded = encode(raw);
      return encoded;
    }

    /**
     * Export.
     *
     * @type {Object}
     */

    exports.default = {
      deserialize: deserialize,
      deserializeNode: deserializeNode,
      serialize: serialize,
      serializeNode: serializeNode
    };

    /***/
  }), ( /* 98 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.IS_WINDOWS = exports.IS_MAC = exports.IS_IE = exports.IS_SAFARI = exports.IS_FIREFOX = exports.IS_CHROME = undefined;
    var _slicedToArray = function () {
      function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
          for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
          }
        } catch (err) {
          _d = true;
          _e = err;
        } finally {
          try {
            if (!_n && _i["return"]) _i["return"]();
          } finally {
            if (_d) throw _e;
          }
        }
        return _arr;
      }
      return function (arr, i) {
        if (Array.isArray(arr)) {
          return arr;
        } else if (Symbol.iterator in Object(arr)) {
          return sliceIterator(arr, i);
        } else {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
      };
    }();
    var _isInBrowser = __webpack_require__(452);
    var _isInBrowser2 = _interopRequireDefault(_isInBrowser);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    /**
     * Browser matching rules.
     *
     * @type {Array}
     */

    var BROWSER_RULES = [['edge', /Edge\/([0-9\._]+)/], ['chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/], ['firefox', /Firefox\/([0-9\.]+)(?:\s|$)/], ['opera', /Opera\/([0-9\.]+)(?:\s|$)/], ['opera', /OPR\/([0-9\.]+)(:?\s|$)$/], ['ie', /Trident\/7\.0.*rv\:([0-9\.]+)\).*Gecko$/], ['ie', /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/], ['ie', /MSIE\s(7\.0)/], ['android', /Android\s([0-9\.]+)/], ['safari', /Version\/([0-9\._]+).*Safari/]];

    /**
     * Operating system matching rules.
     *
     * @type {Array}
     */

    var OS_RULES = [['macos', /mac os x/i], ['ios', /os ([\.\_\d]+) like mac os/i], ['android', /android/i], ['firefoxos', /mozilla\/[a-z\.\_\d]+ \((?:mobile)|(?:tablet)/i], ['windows', /windows\s*(?:nt)?\s*([\.\_\d]+)/i]];

    /**
     * Define variables to store the result.
     */

    var BROWSER = void 0;
    var OS = void 0;

    /**
     * Run the matchers when in browser.
     */

    if (_isInBrowser2.default) {
      var userAgent = window.navigator.userAgent;
      for (var i = 0; i < BROWSER_RULES.length; i++) {
        var _BROWSER_RULES$i = _slicedToArray(BROWSER_RULES[i], 2),
          name = _BROWSER_RULES$i[0],
          regexp = _BROWSER_RULES$i[1];
        if (regexp.test(userAgent)) {
          BROWSER = name;
          break;
        }
      }
      for (var _i = 0; _i < OS_RULES.length; _i++) {
        var _OS_RULES$_i = _slicedToArray(OS_RULES[_i], 2),
          name = _OS_RULES$_i[0],
          regexp = _OS_RULES$_i[1];
        if (regexp.test(userAgent)) {
          OS = name;
          break;
        }
      }
    }

    /**
     * Export.
     *
     * @type {Object}
     */

    var IS_CHROME = exports.IS_CHROME = BROWSER === 'chrome';
    var IS_FIREFOX = exports.IS_FIREFOX = BROWSER === 'firefox';
    var IS_SAFARI = exports.IS_SAFARI = BROWSER === 'safari';
    var IS_IE = exports.IS_IE = BROWSER === 'ie';
    var IS_MAC = exports.IS_MAC = OS === 'macos';
    var IS_WINDOWS = exports.IS_WINDOWS = OS === 'windows';

    /***/
  }), ( /* 99 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _find = __webpack_require__(670);
    var _find2 = _interopRequireDefault(_find);
    var _isPlainObject = __webpack_require__(9);
    var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
    var _slateDevLogger = __webpack_require__(16);
    var _slateDevLogger2 = _interopRequireDefault(_slateDevLogger);
    var _typeOf = __webpack_require__(685);
    var _typeOf2 = _interopRequireDefault(_typeOf);
    var _immutable = __webpack_require__(2);
    var _modelTypes = __webpack_require__(11);
    var _modelTypes2 = _interopRequireDefault(_modelTypes);
    var _isReactComponent = __webpack_require__(582);
    var _isReactComponent2 = _interopRequireDefault(_isReactComponent);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    /**
     * Default properties.
     *
     * @type {Object}
     */

    var DEFAULTS = {
      rules: []
    };

    /**
     * Schema.
     *
     * @type {Schema}
     */

    var Schema = function (_Record) {
      _inherits(Schema, _Record);
      function Schema() {
        _classCallCheck(this, Schema);
        return _possibleConstructorReturn(this, (Schema.__proto__ || Object.getPrototypeOf(Schema)).apply(this, arguments));
      }
      _createClass(Schema, [{
        key: '__getComponent',
        /**
         * Return the renderer for an `object`.
         *
         * This method is private, because it should always be called on one of the
         * often-changing immutable objects instead, since it will be memoized for
         * much better performance.
         *
         * @param {Mixed} object
         * @return {Component|Void}
         */

        value: function __getComponent(object) {
          var match = (0, _find2.default)(this.rules, function (rule) {
            return rule.render && rule.match(object);
          });
          if (!match) return;
          return match.render;
        }

        /**
         * Return the decorators for an `object`.
         *
         * This method is private, because it should always be called on one of the
         * often-changing immutable objects instead, since it will be memoized for
         * much better performance.
         *
         * @param {Mixed} object
         * @return {Array}
         */
      }, {
        key: '__getDecorators',
        value: function __getDecorators(object) {
          return this.rules.filter(function (rule) {
            return rule.decorate && rule.match(object);
          }).map(function (rule) {
            return function (text) {
              return rule.decorate(text, object);
            };
          });
        }

        /**
         * Validate an `object` against the schema, returning the failing rule and
         * value if the object is invalid, or void if it's valid.
         *
         * This method is private, because it should always be called on one of the
         * often-changing immutable objects instead, since it will be memoized for
         * much better performance.
         *
         * @param {Mixed} object
         * @return {Object|Void}
         */
      }, {
        key: '__validate',
        value: function __validate(object) {
          var value = void 0;
          var match = (0, _find2.default)(this.rules, function (rule) {
            if (!rule.validate) return;
            if (!rule.match(object)) return;
            value = rule.validate(object);
            return value;
          });
          if (!value) return;
          return {
            rule: match,
            value: value
          };
        }
      }, {
        key: 'kind',
        /**
         * Get the kind.
         *
         * @return {String}
         */

        get: function get() {
          return 'schema';
        }

        /**
         * Return true if one rule can normalize the document
         *
         * @return {Boolean}
         */
      }, {
        key: 'hasValidators',
        get: function get() {
          var rules = this.rules;
          return rules.some(function (rule) {
            return rule.validate;
          });
        }

        /**
         * Return true if one rule can decorate text nodes
         *
         * @return {Boolean}
         */
      }, {
        key: 'hasDecorators',
        get: function get() {
          var rules = this.rules;
          return rules.some(function (rule) {
            return rule.decorate;
          });
        }
      }], [{
        key: 'create',
        /**
         * Create a new `Schema` with `attrs`.
         *
         * @param {Object|Schema} attrs
         * @return {Schema}
         */

        value: function create() {
          var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          if (Schema.isSchema(attrs)) {
            return attrs;
          }
          if ((0, _isPlainObject2.default)(attrs)) {
            return Schema.fromJSON(attrs);
          }
          throw new Error('`Schema.create` only accepts objects or schemas, but you passed it: ' + attrs);
        }

        /**
         * Check if a `value` is a `Schema`.
         *
         * @param {Any} value
         * @return {Boolean}
         */
      }, {
        key: 'isSchema',
        value: function isSchema(value) {
          return !!(value && value[_modelTypes2.default.SCHEMA]);
        }

        /**
         * Create a `Schema` from a JSON `object`.
         *
         * @param {Object} object
         * @return {Schema}
         */
      }, {
        key: 'fromJSON',
        value: function fromJSON(object) {
          object = normalizeProperties(object);
          var schema = new Schema(object);
          return schema;
        }

        /**
         * Alias `fromJS`.
         */
      }]);
      return Schema;
    }((0, _immutable.Record)(DEFAULTS));

    /**
     * Normalize the `properties` of a schema.
     *
     * @param {Object} properties
     * @return {Object}
     */

    Schema.fromJS = Schema.fromJSON;
    function normalizeProperties(properties) {
      var _properties$rules = properties.rules,
        rules = _properties$rules === undefined ? [] : _properties$rules,
        nodes = properties.nodes,
        marks = properties.marks;
      if (nodes) {
        var array = normalizeNodes(nodes);
        rules = rules.concat(array);
      }
      if (marks) {
        var _array = normalizeMarks(marks);
        rules = rules.concat(_array);
      }
      if (properties.transform) {
        _slateDevLogger2.default.deprecate('0.22.0', 'The `schema.transform` property has been deprecated in favor of `schema.change`.');
        properties.change = properties.transform;
        delete properties.transform;
      }
      return {
        rules: rules
      };
    }

    /**
     * Normalize a `nodes` shorthand argument.
     *
     * @param {Object} nodes
     * @return {Array}
     */

    function normalizeNodes(nodes) {
      var rules = [];
      var _loop = function _loop(key) {
        var rule = nodes[key];
        if ((0, _typeOf2.default)(rule) == 'function' || (0, _isReactComponent2.default)(rule)) {
          rule = {
            render: rule
          };
        }
        rule.match = function (object) {
          return (object.kind == 'block' || object.kind == 'inline') && object.type == key;
        };
        rules.push(rule);
      };
      for (var key in nodes) {
        _loop(key);
      }
      return rules;
    }

    /**
     * Normalize a `marks` shorthand argument.
     *
     * @param {Object} marks
     * @return {Array}
     */

    function normalizeMarks(marks) {
      var rules = [];
      var _loop2 = function _loop2(key) {
        var rule = marks[key];
        if (!rule.render && !rule.decorator && !rule.validate) {
          rule = {
            render: rule
          };
        }
        rule.render = normalizeMarkComponent(rule.render);
        rule.match = function (object) {
          return object.kind == 'mark' && object.type == key;
        };
        rules.push(rule);
      };
      for (var key in marks) {
        _loop2(key);
      }
      return rules;
    }

    /**
     * Normalize a mark `render` property.
     *
     * @param {Component|Function|Object|String} render
     * @return {Component}
     */

    function normalizeMarkComponent(render) {
      if ((0, _isReactComponent2.default)(render)) return render;
      switch ((0, _typeOf2.default)(render)) {
        case 'function':
          return render;
        case 'object':
          return function (props) {
            return _react2.default.createElement('span', {
              style: render
            }, props.children);
          };
        case 'string':
          return function (props) {
            return _react2.default.createElement('span', {
              className: render
            }, props.children);
          };
      }
    }

    /**
     * Attach a pseudo-symbol for type checking.
     */

    Schema.prototype[_modelTypes2.default.SCHEMA] = true;

    /**
     * Export.
     *
     * @type {Schema}
     */

    exports.default = Schema;

    /***/
  }), ( /* 100 */
  /***/function (module, exports, __webpack_require__) {
    var listCacheClear = __webpack_require__(641),
      listCacheDelete = __webpack_require__(642),
      listCacheGet = __webpack_require__(643),
      listCacheHas = __webpack_require__(644),
      listCacheSet = __webpack_require__(645);

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
        length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    module.exports = ListCache;

    /***/
  }), ( /* 101 */
  /***/function (module, exports, __webpack_require__) {
    var eq = __webpack_require__(157);

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }
    module.exports = assocIndexOf;

    /***/
  }), ( /* 102 */
  /***/function (module, exports, __webpack_require__) {
    var isArray = __webpack_require__(26),
      isKey = __webpack_require__(156),
      stringToPath = __webpack_require__(668),
      toString = __webpack_require__(682);

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }
    module.exports = castPath;

    /***/
  }), ( /* 103 */
  /***/function (module, exports, __webpack_require__) {
    var isKeyable = __webpack_require__(638);

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
    }
    module.exports = getMapData;

    /***/
  }), ( /* 104 */
  /***/function (module, exports, __webpack_require__) {
    var getNative = __webpack_require__(44);

    /* Built-in method references that are verified to be native. */
    var nativeCreate = getNative(Object, 'create');
    module.exports = nativeCreate;

    /***/
  }), ( /* 105 */
  /***/function (module, exports, __webpack_require__) {
    var baseGetTag = __webpack_require__(76),
      isObjectLike = __webpack_require__(79);

    /** `Object#toString` result references. */
    var symbolTag = '[object Symbol]';

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
    }
    module.exports = isSymbol;

    /***/
  }), ( /* 106 */
  /***/function (module, exports) {
    module.exports = function (module) {
      if (!module.webpackPolyfill) {
        module.deprecate = function () {};
        module.paths = [];
        // module.parent = undefined by default
        if (!module.children) module.children = [];
        Object.defineProperty(module, "loaded", {
          enumerable: true,
          get: function get() {
            return module.l;
          }
        });
        Object.defineProperty(module, "id", {
          enumerable: true,
          get: function get() {
            return module.i;
          }
        });
        module.webpackPolyfill = 1;
      }
      return module;
    };

    /***/
  }), ( /* 107 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var scrollAmount = 20;
    var getClosestElemFromClass = exports.getClosestElemFromClass = function getClosestElemFromClass(elem, className) {
      if (!elem.parentElement) {
        return null;
      }
      if (elem.parentElement.classList.contains(className)) {
        return elem.parentElement;
      }
      return getClosestElemFromClass(elem.parentElement, className);
    };
    var getSlateEditor = exports.getSlateEditor = function getSlateEditor(selection) {
      if (selection.anchorNode.parentNode && selection.anchorNode.parentNode.closest) {
        return selection.anchorNode.parentNode.closest('.react-markdown--slate-content');
      }
      return getClosestElemFromClass(selection.anchorNode.parentNode, 'react-markdown--slate-content');
    };
    var autoScrollToTop = exports.autoScrollToTop = function autoScrollToTop() {
      var selection = window.getSelection();
      if (selection.anchorNode) {
        var offsetTop = selection.anchorNode.parentNode.offsetTop;
        var editor = getSlateEditor(selection);
        if (editor && editor.scrollTop + editor.offsetHeight < offsetTop + scrollAmount) {
          editor.scrollTop = offsetTop - editor.offsetHeight + scrollAmount;
        }
      }
    };

    /***/
  }), ( /* 108 */
  /***/function (module, exports) {
    var toString = {}.toString;
    module.exports = function (it) {
      return toString.call(it).slice(8, -1);
    };

    /***/
  }), ( /* 109 */
  /***/function (module, exports, __webpack_require__) {
    // optional / simple context binding
    var aFunction = __webpack_require__(293);
    module.exports = function (fn, that, length) {
      aFunction(fn);
      if (that === undefined) return fn;
      switch (length) {
        case 1:
          return function (a) {
            return fn.call(that, a);
          };
        case 2:
          return function (a, b) {
            return fn.call(that, a, b);
          };
        case 3:
          return function (a, b, c) {
            return fn.call(that, a, b, c);
          };
      }
      return function /* ...args */
      () {
        return fn.apply(that, arguments);
      };
    };

    /***/
  }), ( /* 110 */
  /***/function (module, exports) {
    // 7.2.1 RequireObjectCoercible(argument)
    module.exports = function (it) {
      if (it == undefined) throw TypeError("Can't call method on  " + it);
      return it;
    };

    /***/
  }), ( /* 111 */
  /***/function (module, exports) {
    // IE 8- don't enum bug keys
    module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

    /***/
  }), ( /* 112 */
  /***/function (module, exports, __webpack_require__) {
    // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
    var anObject = __webpack_require__(45);
    var dPs = __webpack_require__(308);
    var enumBugKeys = __webpack_require__(111);
    var IE_PROTO = __webpack_require__(115)('IE_PROTO');
    var Empty = function Empty() {/* empty */};
    var PROTOTYPE = 'prototype';

    // Create object with fake `null` prototype: use iframe Object with cleared prototype
    var _createDict = function createDict() {
      // Thrash, waste and sodomy: IE GC bug
      var iframe = __webpack_require__(168)('iframe');
      var i = enumBugKeys.length;
      var lt = '<';
      var gt = '>';
      var iframeDocument;
      iframe.style.display = 'none';
      __webpack_require__(299).appendChild(iframe);
      iframe.src = 'javascript:'; // eslint-disable-line no-script-url
      // createDict = iframe.contentWindow.Object;
      // html.removeChild(iframe);
      iframeDocument = iframe.contentWindow.document;
      iframeDocument.open();
      iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
      iframeDocument.close();
      _createDict = iframeDocument.F;
      while (i--) {
        delete _createDict[PROTOTYPE][enumBugKeys[i]];
      }
      return _createDict();
    };
    module.exports = Object.create || function create(O, Properties) {
      var result;
      if (O !== null) {
        Empty[PROTOTYPE] = anObject(O);
        result = new Empty();
        Empty[PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[IE_PROTO] = O;
      } else result = _createDict();
      return Properties === undefined ? result : dPs(result, Properties);
    };

    /***/
  }), ( /* 113 */
  /***/function (module, exports) {
    exports.f = Object.getOwnPropertySymbols;

    /***/
  }), ( /* 114 */
  /***/function (module, exports, __webpack_require__) {
    var def = __webpack_require__(34).f;
    var has = __webpack_require__(33);
    var TAG = __webpack_require__(21)('toStringTag');
    module.exports = function (it, tag, stat) {
      if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
        configurable: true,
        value: tag
      });
    };

    /***/
  }), ( /* 115 */
  /***/function (module, exports, __webpack_require__) {
    var shared = __webpack_require__(116)('keys');
    var uid = __webpack_require__(83);
    module.exports = function (key) {
      return shared[key] || (shared[key] = uid(key));
    };

    /***/
  }), ( /* 116 */
  /***/function (module, exports, __webpack_require__) {
    var core = __webpack_require__(18);
    var global = __webpack_require__(29);
    var SHARED = '__core-js_shared__';
    var store = global[SHARED] || (global[SHARED] = {});
    (module.exports = function (key, value) {
      return store[key] || (store[key] = value !== undefined ? value : {});
    })('versions', []).push({
      version: core.version,
      mode: __webpack_require__(81) ? 'pure' : 'global',
      copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
    });

    /***/
  }), ( /* 117 */
  /***/function (module, exports) {
    // 7.1.4 ToInteger
    var ceil = Math.ceil;
    var floor = Math.floor;
    module.exports = function (it) {
      return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
    };

    /***/
  }), ( /* 118 */
  /***/function (module, exports, __webpack_require__) {
    // 7.1.1 ToPrimitive(input [, PreferredType])
    var isObject = __webpack_require__(47);
    // instead of the ES6 spec version, we didn't implement @@toPrimitive case
    // and the second argument - flag - preferred type is a string
    module.exports = function (it, S) {
      if (!isObject(it)) return it;
      var fn, val;
      if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
      if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
      if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
      throw TypeError("Can't convert object to primitive value");
    };

    /***/
  }), ( /* 119 */
  /***/function (module, exports, __webpack_require__) {
    var global = __webpack_require__(29);
    var core = __webpack_require__(18);
    var LIBRARY = __webpack_require__(81);
    var wksExt = __webpack_require__(120);
    var defineProperty = __webpack_require__(34).f;
    module.exports = function (name) {
      var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
      if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, {
        value: wksExt.f(name)
      });
    };

    /***/
  }), ( /* 120 */
  /***/function (module, exports, __webpack_require__) {
    exports.f = __webpack_require__(21);

    /***/
  }), ( /* 121 */
  /***/function (module, exports, __webpack_require__) {
    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; /*!
                                                                     Copyright (c) 2016 Jed Watson.
                                                                     Licensed under the MIT License (MIT), see
                                                                     http://jedwatson.github.io/classnames
                                                                     */
    /* global define */

    (function () {
      'use strict';

      var hasOwn = {}.hasOwnProperty;
      function classNames() {
        var classes = [];
        for (var i = 0; i < arguments.length; i++) {
          var arg = arguments[i];
          if (!arg) continue;
          var argType = typeof arg;
          if (argType === 'string' || argType === 'number') {
            classes.push(arg);
          } else if (Array.isArray(arg)) {
            classes.push(classNames.apply(null, arg));
          } else if (argType === 'object') {
            for (var key in arg) {
              if (hasOwn.call(arg, key) && arg[key]) {
                classes.push(key);
              }
            }
          }
        }
        return classes.join(' ');
      }
      if (typeof module !== 'undefined' && module.exports) {
        module.exports = classNames;
      } else if (true) {
        // register as 'classnames', consistent with npm package name
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
          return classNames;
        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      } else {
        window.classNames = classNames;
      }
    })();

    /***/
  }), ( /* 122 */
  /***/function (module, exports, __webpack_require__) {
    // getting tag from 19.1.3.6 Object.prototype.toString()
    var cof = __webpack_require__(49);
    var TAG = __webpack_require__(3)('toStringTag');
    // ES3 wrong here
    var ARG = cof(function () {
      return arguments;
    }()) == 'Arguments';

    // fallback for IE11 Script Access Denied error
    var tryGet = function tryGet(it, key) {
      try {
        return it[key];
      } catch (e) {/* empty */}
    };
    module.exports = function (it) {
      var O, T, B;
      return it === undefined ? 'Undefined' : it === null ? 'Null'
      // @@toStringTag case
      : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
      // builtinTag case
      : ARG ? cof(O)
      // ES3 arguments fallback
      : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
    };

    /***/
  }), ( /* 123 */
  /***/function (module, exports, __webpack_require__) {
    var isObject = __webpack_require__(38);
    var document = __webpack_require__(19).document;
    // typeof document.createElement is 'object' in old IE
    var is = isObject(document) && isObject(document.createElement);
    module.exports = function (it) {
      return is ? document.createElement(it) : {};
    };

    /***/
  }), ( /* 124 */
  /***/function (module, exports, __webpack_require__) {
    var MATCH = __webpack_require__(3)('match');
    module.exports = function (KEY) {
      var re = /./;
      try {
        '/./'[KEY](re);
      } catch (e) {
        try {
          re[MATCH] = false;
          return !'/./'[KEY](re);
        } catch (f) {/* empty */}
      }
      return true;
    };

    /***/
  }), ( /* 125 */
  /***/function (module, exports, __webpack_require__) {
    var def = __webpack_require__(86).f;
    var has = __webpack_require__(69);
    var TAG = __webpack_require__(3)('toStringTag');
    module.exports = function (it, tag, stat) {
      if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
        configurable: true,
        value: tag
      });
    };

    /***/
  }), ( /* 126 */
  /***/function (module, exports, __webpack_require__) {
    var shared = __webpack_require__(191)('keys');
    var uid = __webpack_require__(129);
    module.exports = function (key) {
      return shared[key] || (shared[key] = uid(key));
    };

    /***/
  }), ( /* 127 */
  /***/function (module, exports, __webpack_require__) {
    // helper for String#{startsWith, endsWith, includes}
    var isRegExp = __webpack_require__(185);
    var defined = __webpack_require__(30);
    module.exports = function (that, searchString, NAME) {
      if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
      return String(defined(that));
    };

    /***/
  }), ( /* 128 */
  /***/function (module, exports, __webpack_require__) {
    // 7.1.13 ToObject(argument)
    var defined = __webpack_require__(30);
    module.exports = function (it) {
      return Object(defined(it));
    };

    /***/
  }), ( /* 129 */
  /***/function (module, exports) {
    var id = 0;
    var px = Math.random();
    module.exports = function (key) {
      return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
    };

    /***/
  }), ( /* 130 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    exports.default = getWindow;
    function getWindow(node) {
      return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
    }
    module.exports = exports["default"];

    /***/
  }), ( /* 131 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    module.exports = __webpack_require__(416)() ? Object.assign : __webpack_require__(417);

    /***/
  }), ( /* 132 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var clear = __webpack_require__(203),
      assign = __webpack_require__(131),
      callable = __webpack_require__(40),
      value = __webpack_require__(23),
      d = __webpack_require__(39),
      autoBind = __webpack_require__(387),
      Symbol = __webpack_require__(32);
    var defineProperty = Object.defineProperty,
      defineProperties = Object.defineProperties,
      _Iterator;
    module.exports = _Iterator = function Iterator(list, context) {
      if (!(this instanceof _Iterator)) throw new TypeError("Constructor requires 'new'");
      defineProperties(this, {
        __list__: d("w", value(list)),
        __context__: d("w", context),
        __nextIndex__: d("w", 0)
      });
      if (!context) return;
      callable(context.on);
      context.on("_add", this._onAdd);
      context.on("_delete", this._onDelete);
      context.on("_clear", this._onClear);
    };

    // Internal %IteratorPrototype% doesn't expose its constructor
    delete _Iterator.prototype.constructor;
    defineProperties(_Iterator.prototype, assign({
      _next: d(function () {
        var i;
        if (!this.__list__) return undefined;
        if (this.__redo__) {
          i = this.__redo__.shift();
          if (i !== undefined) return i;
        }
        if (this.__nextIndex__ < this.__list__.length) return this.__nextIndex__++;
        this._unBind();
        return undefined;
      }),
      next: d(function () {
        return this._createResult(this._next());
      }),
      _createResult: d(function (i) {
        if (i === undefined) return {
          done: true,
          value: undefined
        };
        return {
          done: false,
          value: this._resolve(i)
        };
      }),
      _resolve: d(function (i) {
        return this.__list__[i];
      }),
      _unBind: d(function () {
        this.__list__ = null;
        delete this.__redo__;
        if (!this.__context__) return;
        this.__context__.off("_add", this._onAdd);
        this.__context__.off("_delete", this._onDelete);
        this.__context__.off("_clear", this._onClear);
        this.__context__ = null;
      }),
      toString: d(function () {
        return "[object " + (this[Symbol.toStringTag] || "Object") + "]";
      })
    }, autoBind({
      _onAdd: d(function (index) {
        if (index >= this.__nextIndex__) return;
        ++this.__nextIndex__;
        if (!this.__redo__) {
          defineProperty(this, "__redo__", d("c", [index]));
          return;
        }
        this.__redo__.forEach(function (redo, i) {
          if (redo >= index) this.__redo__[i] = ++redo;
        }, this);
        this.__redo__.push(index);
      }),
      _onDelete: d(function (index) {
        var i;
        if (index >= this.__nextIndex__) return;
        --this.__nextIndex__;
        if (!this.__redo__) return;
        i = this.__redo__.indexOf(index);
        if (i !== -1) this.__redo__.splice(i, 1);
        this.__redo__.forEach(function (redo, j) {
          if (redo > index) this.__redo__[j] = --redo;
        }, this);
      }),
      _onClear: d(function () {
        if (this.__redo__) clear.call(this.__redo__);
        this.__nextIndex__ = 0;
      })
    })));
    defineProperty(_Iterator.prototype, Symbol.iterator, d(function () {
      return this;
    }));

    /***/
  }), ( /* 133 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    /**
     * Use invariant() to assert state which your program assumes to be true.
     *
     * Provide sprintf-style format (only %s is supported) and arguments
     * to provide information about what broke and what you were
     * expecting.
     *
     * The invariant message will be stripped in production, but the invariant
     * will remain to ensure logic does not differ in production.
     */
    var invariant = function invariant(condition, format, a, b, c, d, e, f) {
      if (false) {
        if (format === undefined) {
          throw new Error('invariant requires an error message argument');
        }
      }
      if (!condition) {
        var error;
        if (format === undefined) {
          error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
        } else {
          var args = [a, b, c, d, e, f];
          var argIndex = 0;
          error = new Error(format.replace(/%s/g, function () {
            return args[argIndex++];
          }));
          error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
      }
    };
    module.exports = invariant;

    /***/
  }), ( /* 134 */
  /***/function (module, exports) {
    // Source: http://jsfiddle.net/vWx8V/
    // http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

    /**
     * Conenience method returns corresponding value for given keyName or keyCode.
     *
     * @param {Mixed} keyCode {Number} or keyName {String}
     * @return {Mixed}
     * @api public
     */

    function keyCode(searchInput) {
      // Keyboard Events
      if (searchInput && 'object' === typeof searchInput) {
        var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
        if (hasKeyCode) searchInput = hasKeyCode;
      }

      // Numbers
      if ('number' === typeof searchInput) return names[searchInput];

      // Everything else (cast to string)
      var search = String(searchInput);

      // check codes
      var foundNamedKey = codes[search.toLowerCase()];
      if (foundNamedKey) return foundNamedKey;

      // check aliases
      var foundNamedKey = aliases[search.toLowerCase()];
      if (foundNamedKey) return foundNamedKey;

      // weird character?
      if (search.length === 1) return search.charCodeAt(0);
      return undefined;
    }

    /**
     * Compares a keyboard event with a given keyCode or keyName.
     *
     * @param {Event} event Keyboard event that should be tested
     * @param {Mixed} keyCode {Number} or keyName {String}
     * @return {Boolean}
     * @api public
     */
    keyCode.isEventKey = function isEventKey(event, nameOrCode) {
      if (event && 'object' === typeof event) {
        var keyCode = event.which || event.keyCode || event.charCode;
        if (keyCode === null || keyCode === undefined) {
          return false;
        }
        if (typeof nameOrCode === 'string') {
          // check codes
          var foundNamedKey = codes[nameOrCode.toLowerCase()];
          if (foundNamedKey) {
            return foundNamedKey === keyCode;
          }

          // check aliases
          var foundNamedKey = aliases[nameOrCode.toLowerCase()];
          if (foundNamedKey) {
            return foundNamedKey === keyCode;
          }
        } else if (typeof nameOrCode === 'number') {
          return nameOrCode === keyCode;
        }
        return false;
      }
    };
    exports = module.exports = keyCode;

    /**
     * Get by name
     *
     *   exports.code['enter'] // => 13
     */

    var codes = exports.code = exports.codes = {
      'backspace': 8,
      'tab': 9,
      'enter': 13,
      'shift': 16,
      'ctrl': 17,
      'alt': 18,
      'pause/break': 19,
      'caps lock': 20,
      'esc': 27,
      'space': 32,
      'page up': 33,
      'page down': 34,
      'end': 35,
      'home': 36,
      'left': 37,
      'up': 38,
      'right': 39,
      'down': 40,
      'insert': 45,
      'delete': 46,
      'command': 91,
      'left command': 91,
      'right command': 93,
      'numpad *': 106,
      'numpad +': 107,
      'numpad -': 109,
      'numpad .': 110,
      'numpad /': 111,
      'num lock': 144,
      'scroll lock': 145,
      'my computer': 182,
      'my calculator': 183,
      ';': 186,
      '=': 187,
      ',': 188,
      '-': 189,
      '.': 190,
      '/': 191,
      '`': 192,
      '[': 219,
      '\\': 220,
      ']': 221,
      "'": 222
    };

    // Helper aliases

    var aliases = exports.aliases = {
      'windows': 91,
      '⇧': 16,
      '⌥': 18,
      '⌃': 17,
      '⌘': 91,
      'ctl': 17,
      'control': 17,
      'option': 18,
      'pause': 19,
      'break': 19,
      'caps': 20,
      'return': 13,
      'escape': 27,
      'spc': 32,
      'spacebar': 32,
      'pgup': 33,
      'pgdn': 34,
      'ins': 45,
      'del': 46,
      'cmd': 91
    };

    /*!
     * Programatically add the following
     */

    // lower case chars
    for (i = 97; i < 123; i++) {
      codes[String.fromCharCode(i)] = i - 32;
    }

    // numbers
    for (var i = 48; i < 58; i++) {
      codes[i - 48] = i;
    }

    // function keys
    for (i = 1; i < 13; i++) {
      codes['f' + i] = i + 111;
    }

    // numpad keys
    for (i = 0; i < 10; i++) {
      codes['numpad ' + i] = i + 96;
    }

    /**
     * Get by code
     *
     *   exports.name[13] // => 'Enter'
     */

    var names = exports.names = exports.title = {}; // title for backward compat

    // Create reverse mapping
    for (i in codes) {
      names[codes[i]] = i;
    }

    // Add aliases
    for (var alias in aliases) {
      codes[alias] = aliases[alias];
    }

    /***/
  }), ( /* 135 */
  /***/function (module, exports, __webpack_require__) {
    var root = __webpack_require__(465);

    /** Built-in value references. */
    var Symbol = root.Symbol;
    module.exports = Symbol;

    /***/
  }), ( /* 136 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    /**
     * class Ruler
     *
     * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
     * [[MarkdownIt#inline]] to manage sequences of functions (rules):
     *
     * - keep rules in defined order
     * - assign the name to each rule
     * - enable/disable rules
     * - add/replace rules
     * - allow assign rules to additional named chains (in the same)
     * - cacheing lists of active rules
     *
     * You will not need use this class directly until write plugins. For simple
     * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
     * [[MarkdownIt.use]].
     **/

    /**
     * new Ruler()
     **/
    function Ruler() {
      // List of added rules. Each element is:
      //
      // {
      //   name: XXX,
      //   enabled: Boolean,
      //   fn: Function(),
      //   alt: [ name2, name3 ]
      // }
      //
      this.__rules__ = [];

      // Cached rule chains.
      //
      // First level - chain name, '' for default.
      // Second level - diginal anchor for fast filtering by charcodes.
      //
      this.__cache__ = null;
    }

    ////////////////////////////////////////////////////////////////////////////////
    // Helper methods, should not be used directly

    // Find rule index by name
    //
    Ruler.prototype.__find__ = function (name) {
      for (var i = 0; i < this.__rules__.length; i++) {
        if (this.__rules__[i].name === name) {
          return i;
        }
      }
      return -1;
    };

    // Build rules lookup cache
    //
    Ruler.prototype.__compile__ = function () {
      var self = this;
      var chains = [''];

      // collect unique names
      self.__rules__.forEach(function (rule) {
        if (!rule.enabled) {
          return;
        }
        rule.alt.forEach(function (altName) {
          if (chains.indexOf(altName) < 0) {
            chains.push(altName);
          }
        });
      });
      self.__cache__ = {};
      chains.forEach(function (chain) {
        self.__cache__[chain] = [];
        self.__rules__.forEach(function (rule) {
          if (!rule.enabled) {
            return;
          }
          if (chain && rule.alt.indexOf(chain) < 0) {
            return;
          }
          self.__cache__[chain].push(rule.fn);
        });
      });
    };

    /**
     * Ruler.at(name, fn [, options])
     * - name (String): rule name to replace.
     * - fn (Function): new rule function.
     * - options (Object): new rule options (not mandatory).
     *
     * Replace rule by name with new function & options. Throws error if name not
     * found.
     *
     * ##### Options:
     *
     * - __alt__ - array with names of "alternate" chains.
     *
     * ##### Example
     *
     * Replace existing typographer replacement rule with new one:
     *
     * ```javascript
     * var md = require('markdown-it')();
     *
     * md.core.ruler.at('replacements', function replace(state) {
     *   //...
     * });
     * ```
     **/
    Ruler.prototype.at = function (name, fn, options) {
      var index = this.__find__(name);
      var opt = options || {};
      if (index === -1) {
        throw new Error('Parser rule not found: ' + name);
      }
      this.__rules__[index].fn = fn;
      this.__rules__[index].alt = opt.alt || [];
      this.__cache__ = null;
    };

    /**
     * Ruler.before(beforeName, ruleName, fn [, options])
     * - beforeName (String): new rule will be added before this one.
     * - ruleName (String): name of added rule.
     * - fn (Function): rule function.
     * - options (Object): rule options (not mandatory).
     *
     * Add new rule to chain before one with given name. See also
     * [[Ruler.after]], [[Ruler.push]].
     *
     * ##### Options:
     *
     * - __alt__ - array with names of "alternate" chains.
     *
     * ##### Example
     *
     * ```javascript
     * var md = require('markdown-it')();
     *
     * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
     *   //...
     * });
     * ```
     **/
    Ruler.prototype.before = function (beforeName, ruleName, fn, options) {
      var index = this.__find__(beforeName);
      var opt = options || {};
      if (index === -1) {
        throw new Error('Parser rule not found: ' + beforeName);
      }
      this.__rules__.splice(index, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
      });
      this.__cache__ = null;
    };

    /**
     * Ruler.after(afterName, ruleName, fn [, options])
     * - afterName (String): new rule will be added after this one.
     * - ruleName (String): name of added rule.
     * - fn (Function): rule function.
     * - options (Object): rule options (not mandatory).
     *
     * Add new rule to chain after one with given name. See also
     * [[Ruler.before]], [[Ruler.push]].
     *
     * ##### Options:
     *
     * - __alt__ - array with names of "alternate" chains.
     *
     * ##### Example
     *
     * ```javascript
     * var md = require('markdown-it')();
     *
     * md.inline.ruler.after('text', 'my_rule', function replace(state) {
     *   //...
     * });
     * ```
     **/
    Ruler.prototype.after = function (afterName, ruleName, fn, options) {
      var index = this.__find__(afterName);
      var opt = options || {};
      if (index === -1) {
        throw new Error('Parser rule not found: ' + afterName);
      }
      this.__rules__.splice(index + 1, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
      });
      this.__cache__ = null;
    };

    /**
     * Ruler.push(ruleName, fn [, options])
     * - ruleName (String): name of added rule.
     * - fn (Function): rule function.
     * - options (Object): rule options (not mandatory).
     *
     * Push new rule to the end of chain. See also
     * [[Ruler.before]], [[Ruler.after]].
     *
     * ##### Options:
     *
     * - __alt__ - array with names of "alternate" chains.
     *
     * ##### Example
     *
     * ```javascript
     * var md = require('markdown-it')();
     *
     * md.core.ruler.push('my_rule', function replace(state) {
     *   //...
     * });
     * ```
     **/
    Ruler.prototype.push = function (ruleName, fn, options) {
      var opt = options || {};
      this.__rules__.push({
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
      });
      this.__cache__ = null;
    };

    /**
     * Ruler.enable(list [, ignoreInvalid]) -> Array
     * - list (String|Array): list of rule names to enable.
     * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
     *
     * Enable rules with given names. If any rule name not found - throw Error.
     * Errors can be disabled by second param.
     *
     * Returns list of found rule names (if no exception happened).
     *
     * See also [[Ruler.disable]], [[Ruler.enableOnly]].
     **/
    Ruler.prototype.enable = function (list, ignoreInvalid) {
      if (!Array.isArray(list)) {
        list = [list];
      }
      var result = [];

      // Search by name and enable
      list.forEach(function (name) {
        var idx = this.__find__(name);
        if (idx < 0) {
          if (ignoreInvalid) {
            return;
          }
          throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = true;
        result.push(name);
      }, this);
      this.__cache__ = null;
      return result;
    };

    /**
     * Ruler.enableOnly(list [, ignoreInvalid])
     * - list (String|Array): list of rule names to enable (whitelist).
     * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
     *
     * Enable rules with given names, and disable everything else. If any rule name
     * not found - throw Error. Errors can be disabled by second param.
     *
     * See also [[Ruler.disable]], [[Ruler.enable]].
     **/
    Ruler.prototype.enableOnly = function (list, ignoreInvalid) {
      if (!Array.isArray(list)) {
        list = [list];
      }
      this.__rules__.forEach(function (rule) {
        rule.enabled = false;
      });
      this.enable(list, ignoreInvalid);
    };

    /**
     * Ruler.disable(list [, ignoreInvalid]) -> Array
     * - list (String|Array): list of rule names to disable.
     * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
     *
     * Disable rules with given names. If any rule name not found - throw Error.
     * Errors can be disabled by second param.
     *
     * Returns list of found rule names (if no exception happened).
     *
     * See also [[Ruler.enable]], [[Ruler.enableOnly]].
     **/
    Ruler.prototype.disable = function (list, ignoreInvalid) {
      if (!Array.isArray(list)) {
        list = [list];
      }
      var result = [];

      // Search by name and disable
      list.forEach(function (name) {
        var idx = this.__find__(name);
        if (idx < 0) {
          if (ignoreInvalid) {
            return;
          }
          throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = false;
        result.push(name);
      }, this);
      this.__cache__ = null;
      return result;
    };

    /**
     * Ruler.getRules(chainName) -> Array
     *
     * Return array of active functions (rules) for given chain name. It analyzes
     * rules configuration, compiles caches if not exists and returns result.
     *
     * Default chain name is `''` (empty string). It can't be skipped. That's
     * done intentionally, to keep signature monomorphic for high speed.
     **/
    Ruler.prototype.getRules = function (chainName) {
      if (this.__cache__ === null) {
        this.__compile__();
      }

      // Chain can be empty, if rules disabled. But we still have to return Array.
      return this.__cache__[chainName] || [];
    };
    module.exports = Ruler;

    /***/
  }), ( /* 137 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Token class

    /**
     * class Token
     **/

    /**
     * new Token(type, tag, nesting)
     *
     * Create new token and fill passed properties.
     **/
    function Token(type, tag, nesting) {
      /**
       * Token#type -> String
       *
       * Type of the token (string, e.g. "paragraph_open")
       **/
      this.type = type;

      /**
       * Token#tag -> String
       *
       * html tag name, e.g. "p"
       **/
      this.tag = tag;

      /**
       * Token#attrs -> Array
       *
       * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
       **/
      this.attrs = null;

      /**
       * Token#map -> Array
       *
       * Source map info. Format: `[ line_begin, line_end ]`
       **/
      this.map = null;

      /**
       * Token#nesting -> Number
       *
       * Level change (number in {-1, 0, 1} set), where:
       *
       * -  `1` means the tag is opening
       * -  `0` means the tag is self-closing
       * - `-1` means the tag is closing
       **/
      this.nesting = nesting;

      /**
       * Token#level -> Number
       *
       * nesting level, the same as `state.level`
       **/
      this.level = 0;

      /**
       * Token#children -> Array
       *
       * An array of child nodes (inline and img tokens)
       **/
      this.children = null;

      /**
       * Token#content -> String
       *
       * In a case of self-closing tag (code, html, fence, etc.),
       * it has contents of this tag.
       **/
      this.content = '';

      /**
       * Token#markup -> String
       *
       * '*' or '_' for emphasis, fence string for fence, etc.
       **/
      this.markup = '';

      /**
       * Token#info -> String
       *
       * fence infostring
       **/
      this.info = '';

      /**
       * Token#meta -> Object
       *
       * A place for plugins to store an arbitrary data
       **/
      this.meta = null;

      /**
       * Token#block -> Boolean
       *
       * True for block-level tokens, false for inline tokens.
       * Used in renderer to calculate line breaks
       **/
      this.block = false;

      /**
       * Token#hidden -> Boolean
       *
       * If it's true, ignore this element when rendering. Used for tight lists
       * to hide paragraphs.
       **/
      this.hidden = false;
    }

    /**
     * Token.attrIndex(name) -> Number
     *
     * Search attribute index by name.
     **/
    Token.prototype.attrIndex = function attrIndex(name) {
      var attrs, i, len;
      if (!this.attrs) {
        return -1;
      }
      attrs = this.attrs;
      for (i = 0, len = attrs.length; i < len; i++) {
        if (attrs[i][0] === name) {
          return i;
        }
      }
      return -1;
    };

    /**
     * Token.attrPush(attrData)
     *
     * Add `[ name, value ]` attribute to list. Init attrs if necessary
     **/
    Token.prototype.attrPush = function attrPush(attrData) {
      if (this.attrs) {
        this.attrs.push(attrData);
      } else {
        this.attrs = [attrData];
      }
    };

    /**
     * Token.attrSet(name, value)
     *
     * Set `name` attribute to `value`. Override old value if exists.
     **/
    Token.prototype.attrSet = function attrSet(name, value) {
      var idx = this.attrIndex(name),
        attrData = [name, value];
      if (idx < 0) {
        this.attrPush(attrData);
      } else {
        this.attrs[idx] = attrData;
      }
    };

    /**
     * Token.attrGet(name)
     *
     * Get the value of attribute `name`, or null if it does not exist.
     **/
    Token.prototype.attrGet = function attrGet(name) {
      var idx = this.attrIndex(name),
        value = null;
      if (idx >= 0) {
        value = this.attrs[idx][1];
      }
      return value;
    };

    /**
     * Token.attrJoin(name, value)
     *
     * Join value to existing attribute via space. Or create new attribute if not
     * exists. Useful to operate with token classes.
     **/
    Token.prototype.attrJoin = function attrJoin(name, value) {
      var idx = this.attrIndex(name);
      if (idx < 0) {
        this.attrPush([name, value]);
      } else {
        this.attrs[idx][1] = this.attrs[idx][1] + ' ' + value;
      }
    };
    module.exports = Token;

    /***/
  }), ( /* 138 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = all;
    var _createChainableTypeChecker = __webpack_require__(95);
    var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function all() {
      for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
        validators[_key] = arguments[_key];
      }
      function allPropTypes() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        var error = null;
        validators.forEach(function (validator) {
          if (error != null) {
            return;
          }
          var result = validator.apply(undefined, args);
          if (result != null) {
            error = result;
          }
        });
        return error;
      }
      return (0, _createChainableTypeChecker2.default)(allPropTypes);
    }
    module.exports = exports['default'];

    /***/
  }), ( /* 139 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _createChainableTypeChecker = __webpack_require__(95);
    var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
      if (_react2.default.isValidElement(propValue)) {
        return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
      }
      if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
        return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
      }
      return null;
    }
    exports.default = (0, _createChainableTypeChecker2.default)(validate);
    module.exports = exports['default'];

    /***/
  }), ( /* 140 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    var _extends2 = __webpack_require__(7);
    var _extends3 = _interopRequireDefault(_extends2);
    var _objectWithoutProperties2 = __webpack_require__(17);
    var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
    var _classCallCheck2 = __webpack_require__(12);
    var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
    var _possibleConstructorReturn2 = __webpack_require__(14);
    var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
    var _inherits2 = __webpack_require__(13);
    var _inherits3 = _interopRequireDefault(_inherits2);
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _propTypes = __webpack_require__(10);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _elementType = __webpack_require__(72);
    var _elementType2 = _interopRequireDefault(_elementType);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        'default': obj
      };
    }
    var propTypes = {
      href: _propTypes2['default'].string,
      onClick: _propTypes2['default'].func,
      disabled: _propTypes2['default'].bool,
      role: _propTypes2['default'].string,
      tabIndex: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
      /**
       * this is sort of silly but needed for Button
       */
      componentClass: _elementType2['default']
    };
    var defaultProps = {
      componentClass: 'a'
    };
    function isTrivialHref(href) {
      return !href || href.trim() === '#';
    }

    /**
     * There are situations due to browser quirks or Bootstrap CSS where
     * an anchor tag is needed, when semantically a button tag is the
     * better choice. SafeAnchor ensures that when an anchor is used like a
     * button its accessible. It also emulates input `disabled` behavior for
     * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
     */

    var SafeAnchor = function (_React$Component) {
      (0, _inherits3['default'])(SafeAnchor, _React$Component);
      function SafeAnchor(props, context) {
        (0, _classCallCheck3['default'])(this, SafeAnchor);
        var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
      }
      SafeAnchor.prototype.handleClick = function handleClick(event) {
        var _props = this.props,
          disabled = _props.disabled,
          href = _props.href,
          onClick = _props.onClick;
        if (disabled || isTrivialHref(href)) {
          event.preventDefault();
        }
        if (disabled) {
          event.stopPropagation();
          return;
        }
        if (onClick) {
          onClick(event);
        }
      };
      SafeAnchor.prototype.render = function render() {
        var _props2 = this.props,
          Component = _props2.componentClass,
          disabled = _props2.disabled,
          props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'disabled']);
        if (isTrivialHref(props.href)) {
          props.role = props.role || 'button';
          // we want to make sure there is a href attribute on the node
          // otherwise, the cursor incorrectly styled (except with role='button')
          props.href = props.href || '#';
        }
        if (disabled) {
          props.tabIndex = -1;
          props.style = (0, _extends3['default'])({
            pointerEvents: 'none'
          }, props.style);
        }
        return _react2['default'].createElement(Component, (0, _extends3['default'])({}, props, {
          onClick: this.handleClick
        }));
      };
      return SafeAnchor;
    }(_react2['default'].Component);
    SafeAnchor.propTypes = propTypes;
    SafeAnchor.defaultProps = defaultProps;
    exports['default'] = SafeAnchor;
    module.exports = exports['default'];

    /***/
  }), ( /* 141 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        'default': obj
      };
    }

    /**
     * Iterates through children that are typically specified as `props.children`,
     * but only maps over children that are "valid components".
     *
     * The mapFunction provided index will be normalised to the components mapped,
     * so an invalid component would not increase the index.
     *
     * @param {?*} children Children tree container.
     * @param {function(*, int)} func.
     * @param {*} context Context for func.
     * @return {object} Object containing the ordered map of results.
     */
    function map(children, func, context) {
      var index = 0;
      return _react2['default'].Children.map(children, function (child) {
        if (!_react2['default'].isValidElement(child)) {
          return child;
        }
        return func.call(context, child, index++);
      });
    }

    /**
     * Iterates through children that are "valid components".
     *
     * The provided forEachFunc(child, index) will be called for each
     * leaf child with the index reflecting the position relative to "valid components".
     *
     * @param {?*} children Children tree container.
     * @param {function(*, int)} func.
     * @param {*} context Context for context.
     */
    // TODO: This module should be ElementChildren, and should use named exports.

    function forEach(children, func, context) {
      var index = 0;
      _react2['default'].Children.forEach(children, function (child) {
        if (!_react2['default'].isValidElement(child)) {
          return;
        }
        func.call(context, child, index++);
      });
    }

    /**
     * Count the number of "valid components" in the Children container.
     *
     * @param {?*} children Children tree container.
     * @returns {number}
     */
    function count(children) {
      var result = 0;
      _react2['default'].Children.forEach(children, function (child) {
        if (!_react2['default'].isValidElement(child)) {
          return;
        }
        ++result;
      });
      return result;
    }

    /**
     * Finds children that are typically specified as `props.children`,
     * but only iterates over children that are "valid components".
     *
     * The provided forEachFunc(child, index) will be called for each
     * leaf child with the index reflecting the position relative to "valid components".
     *
     * @param {?*} children Children tree container.
     * @param {function(*, int)} func.
     * @param {*} context Context for func.
     * @returns {array} of children that meet the func return statement
     */
    function filter(children, func, context) {
      var index = 0;
      var result = [];
      _react2['default'].Children.forEach(children, function (child) {
        if (!_react2['default'].isValidElement(child)) {
          return;
        }
        if (func.call(context, child, index++)) {
          result.push(child);
        }
      });
      return result;
    }
    function find(children, func, context) {
      var index = 0;
      var result = undefined;
      _react2['default'].Children.forEach(children, function (child) {
        if (result) {
          return;
        }
        if (!_react2['default'].isValidElement(child)) {
          return;
        }
        if (func.call(context, child, index++)) {
          result = child;
        }
      });
      return result;
    }
    function every(children, func, context) {
      var index = 0;
      var result = true;
      _react2['default'].Children.forEach(children, function (child) {
        if (!result) {
          return;
        }
        if (!_react2['default'].isValidElement(child)) {
          return;
        }
        if (!func.call(context, child, index++)) {
          result = false;
        }
      });
      return result;
    }
    function some(children, func, context) {
      var index = 0;
      var result = false;
      _react2['default'].Children.forEach(children, function (child) {
        if (result) {
          return;
        }
        if (!_react2['default'].isValidElement(child)) {
          return;
        }
        if (func.call(context, child, index++)) {
          result = true;
        }
      });
      return result;
    }
    function toArray(children) {
      var result = [];
      _react2['default'].Children.forEach(children, function (child) {
        if (!_react2['default'].isValidElement(child)) {
          return;
        }
        result.push(child);
      });
      return result;
    }
    exports['default'] = {
      map: map,
      forEach: forEach,
      count: count,
      find: find,
      filter: filter,
      every: every,
      some: some,
      toArray: toArray
    };
    module.exports = exports['default'];

    /***/
  }), ( /* 142 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    exports.default = getContainer;
    var _reactDom = __webpack_require__(4);
    var _reactDom2 = _interopRequireDefault(_reactDom);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function getContainer(container, defaultContainer) {
      container = typeof container === 'function' ? container() : container;
      return _reactDom2.default.findDOMNode(container) || defaultContainer;
    }
    module.exports = exports['default'];

    /***/
  }), ( /* 143 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    /**
     * Slate-specific data transfer types.
     *
     * @type {Object}
     */

    var TYPES = {
      FRAGMENT: 'application/x-slate-fragment',
      NODE: 'application/x-slate-node'
    };

    /**
     * Export.
     *
     * @type {Object}
     */

    exports.default = TYPES;

    /***/
  }), ( /* 144 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _slicedToArray = function () {
      function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
          for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
          }
        } catch (err) {
          _d = true;
          _e = err;
        } finally {
          try {
            if (!_n && _i["return"]) _i["return"]();
          } finally {
            if (_d) throw _e;
          }
        }
        return _arr;
      }
      return function (arr, i) {
        if (Array.isArray(arr)) {
          return arr;
        } else if (Symbol.iterator in Object(arr)) {
          return sliceIterator(arr, i);
        } else {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
      };
    }();
    var _normalizeNodeAndOffset = __webpack_require__(565);
    var _normalizeNodeAndOffset2 = _interopRequireDefault(_normalizeNodeAndOffset);
    var _findClosestNode = __webpack_require__(225);
    var _findClosestNode2 = _interopRequireDefault(_findClosestNode);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    /**
     * Offset key parser regex.
     *
     * @type {RegExp}
     */

    var PARSER = /^(\w+)(?:-(\d+))?$/;

    /**
     * Offset key attribute name.
     *
     * @type {String}
     */

    var ATTRIBUTE = 'data-offset-key';

    /**
     * Offset key attribute selector.
     *
     * @type {String}
     */

    var SELECTOR = '[' + ATTRIBUTE + ']';

    /**
     * Void node selection.
     *
     * @type {String}
     */

    var VOID_SELECTOR = '[data-slate-void]';

    /**
     * Find the start and end bounds from an `offsetKey` and `ranges`.
     *
     * @param {Number} index
     * @param {List<Range>} ranges
     * @return {Object}
     */

    function findBounds(index, ranges) {
      var range = ranges.get(index);
      var start = ranges.slice(0, index).reduce(function (memo, r) {
        return memo += r.text.length;
      }, 0);
      return {
        start: start,
        end: start + range.text.length
      };
    }

    /**
     * From a DOM node, find the closest parent's offset key.
     *
     * @param {Element} rawNode
     * @param {Number} rawOffset
     * @return {Object}
     */

    function findKey(rawNode, rawOffset) {
      var _normalizeNodeAndOffs = (0, _normalizeNodeAndOffset2.default)(rawNode, rawOffset),
        node = _normalizeNodeAndOffs.node,
        offset = _normalizeNodeAndOffs.offset;
      var parentNode = node.parentNode;

      // Find the closest parent with an offset key attribute.

      var closest = (0, _findClosestNode2.default)(parentNode, SELECTOR);

      // For void nodes, the element with the offset key will be a cousin, not an
      // ancestor, so find it by going down from the nearest void parent.
      if (!closest) {
        var closestVoid = (0, _findClosestNode2.default)(parentNode, VOID_SELECTOR);
        if (!closestVoid) return null;
        closest = closestVoid.querySelector(SELECTOR);
        offset = closest.textContent.length;
      }

      // Get the string value of the offset key attribute.
      var offsetKey = closest.getAttribute(ATTRIBUTE);

      // If we still didn't find an offset key, abort.
      if (!offsetKey) return null;

      // Return the parsed the offset key.
      var parsed = parse(offsetKey);
      return {
        key: parsed.key,
        index: parsed.index,
        offset: offset
      };
    }

    /**
     * Find the selection point from an `offsetKey` and `ranges`.
     *
     * @param {Object} offsetKey
     * @param {List<Range>} ranges
     * @return {Object}
     */

    function findPoint(offsetKey, ranges) {
      var key = offsetKey.key,
        index = offsetKey.index,
        offset = offsetKey.offset;
      var _findBounds = findBounds(index, ranges),
        start = _findBounds.start,
        end = _findBounds.end;

      // Don't let the offset be outside of the start and end bounds.

      offset = start + offset;
      offset = Math.max(offset, start);
      offset = Math.min(offset, end);
      return {
        key: key,
        index: index,
        start: start,
        end: end,
        offset: offset
      };
    }

    /**
     * Parse an offset key `string`.
     *
     * @param {String} string
     * @return {Object}
     */

    function parse(string) {
      var matches = PARSER.exec(string);
      if (!matches) throw new Error('Invalid offset key string "' + string + '".');
      var _matches = _slicedToArray(matches, 3),
        original = _matches[0],
        key = _matches[1],
        index = _matches[2]; // eslint-disable-line no-unused-vars

      return {
        key: key,
        index: parseInt(index, 10)
      };
    }

    /**
     * Stringify an offset key `object`.
     *
     * @param {Object} object
     *   @property {String} key
     *   @property {Number} index
     * @return {String}
     */

    function stringify(object) {
      return object.key + '-' + object.index;
    }

    /**
     * Export.
     *
     * @type {Object}
     */

    exports.default = {
      findBounds: findBounds,
      findKey: findKey,
      findPoint: findPoint,
      parse: parse,
      stringify: stringify
    };

    /***/
  }), ( /* 145 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    var _isPlainObject = __webpack_require__(9);
    var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
    var _slateDevLogger = __webpack_require__(16);
    var _slateDevLogger2 = _interopRequireDefault(_slateDevLogger);
    var _immutable = __webpack_require__(2);
    var _modelTypes = __webpack_require__(11);
    var _modelTypes2 = _interopRequireDefault(_modelTypes);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    /**
     * Default properties.
     *
     * @type {Object}
     */

    var DEFAULTS = {
      marks: new _immutable.Set(),
      text: ''
    };

    /**
     * Character.
     *
     * @type {Character}
     */

    var Character = function (_Record) {
      _inherits(Character, _Record);
      function Character() {
        _classCallCheck(this, Character);
        return _possibleConstructorReturn(this, (Character.__proto__ || Object.getPrototypeOf(Character)).apply(this, arguments));
      }
      _createClass(Character, [{
        key: 'toJSON',
        /**
         * Return a JSON representation of the character.
         *
         * @return {Object}
         */

        value: function toJSON() {
          var object = {
            kind: this.kind,
            marks: this.marks.toArray().map(function (m) {
              return m.toJSON();
            }),
            text: this.text
          };
          return object;
        }

        /**
         * Alias `toJS`.
         */
      }, {
        key: 'toJS',
        value: function toJS() {
          return this.toJSON();
        }
      }, {
        key: 'kind',
        /**
         * Get the kind.
         *
         * @return {String}
         */

        get: function get() {
          return 'character';
        }
      }], [{
        key: 'create',
        /**
         * Create a `Character` with `attrs`.
         *
         * @param {Object|String|Character} attrs
         * @return {Character}
         */

        value: function create() {
          var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          if (Character.isCharacter(attrs)) {
            return attrs;
          }
          if (typeof attrs == 'string') {
            attrs = {
              text: attrs
            };
          }
          if ((0, _isPlainObject2.default)(attrs)) {
            return Character.fromJSON(attrs);
          }
          throw new Error('`Character.create` only accepts objects, strings or characters, but you passed it: ' + attrs);
        }

        /**
         * Create a list of `Characters` from `elements`.
         *
         * @param {String|Array<Object|Character|String>|List<Object|Character|String>} elements
         * @return {List<Character>}
         */
      }, {
        key: 'createList',
        value: function createList() {
          var elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
          if (typeof elements == 'string') {
            elements = elements.split('');
          }
          if (_immutable.List.isList(elements) || Array.isArray(elements)) {
            var list = new _immutable.List(elements.map(Character.create));
            return list;
          }
          throw new Error('`Block.createList` only accepts strings, arrays or lists, but you passed it: ' + elements);
        }

        /**
         * Create a `Character` from a JSON `object`.
         *
         * @param {Object} object
         * @return {Character}
         */
      }, {
        key: 'fromJSON',
        value: function fromJSON(object) {
          var text = object.text,
            _object$marks = object.marks,
            marks = _object$marks === undefined ? [] : _object$marks;
          if (typeof text != 'string') {
            throw new Error('`Character.fromJSON` requires a block `text` string.');
          }
          var character = new Character({
            text: text,
            marks: new _immutable.Set(marks)
          });
          return character;
        }

        /**
         * Alias `fromJS`.
         */
      }, {
        key: 'isCharacter',
        /**
         * Check if a `value` is a `Character`.
         *
         * @param {Any} value
         * @return {Boolean}
         */

        value: function isCharacter(value) {
          return !!(value && value[_modelTypes2.default.CHARACTER]);
        }

        /**
         * Check if a `value` is a character list.
         *
         * @param {Any} value
         * @return {Boolean}
         */
      }, {
        key: 'isCharacterList',
        value: function isCharacterList(value) {
          return _immutable.List.isList(value) && value.every(function (item) {
            return Character.isCharacter(item);
          });
        }

        /**
         * Deprecated.
         */
      }, {
        key: 'createListFromText',
        value: function createListFromText(string) {
          _slateDevLogger2.default.deprecate('0.22.0', 'The `Character.createListFromText(string)` method is deprecated, use `Character.createList(string)` instead.');
          return this.createList(string);
        }
      }]);
      return Character;
    }((0, _immutable.Record)(DEFAULTS));

    /**
     * Attach a pseudo-symbol for type checking.
     */

    Character.fromJS = Character.fromJSON;
    Character.prototype[_modelTypes2.default.CHARACTER] = true;

    /**
     * Export.
     *
     * @type {Character}
     */

    exports.default = Character;

    /***/
  }), ( /* 146 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    var _isPlainObject = __webpack_require__(9);
    var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
    var _immutable = __webpack_require__(2);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    /**
     * Data.
     *
     * This isn't an immutable record, it's just a thin wrapper around `Map` so that
     * we can allow for more convenient creation.
     *
     * @type {Object}
     */

    var Data = function () {
      function Data() {
        _classCallCheck(this, Data);
      }
      _createClass(Data, null, [{
        key: 'create',
        /**
         * Create a new `Data` with `attrs`.
         *
         * @param {Object|Data|Map} attrs
         * @return {Data} data
         */

        value: function create() {
          var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          if (_immutable.Map.isMap(attrs)) {
            return attrs;
          }
          if ((0, _isPlainObject2.default)(attrs)) {
            return Data.fromJSON(attrs);
          }
          throw new Error('`Data.create` only accepts objects or maps, but you passed it: ' + attrs);
        }

        /**
         * Create a `Data` from a JSON `object`.
         *
         * @param {Object} object
         * @return {Data}
         */
      }, {
        key: 'fromJSON',
        value: function fromJSON(object) {
          return new _immutable.Map(object);
        }

        /**
         * Alias `fromJS`.
         */
      }]);
      return Data;
    }();

    /**
     * Export.
     *
     * @type {Object}
     */

    Data.fromJS = Data.fromJSON;
    exports.default = Data;

    /***/
  }), ( /* 147 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _slicedToArray = function () {
      function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
          for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
          }
        } catch (err) {
          _d = true;
          _e = err;
        } finally {
          try {
            if (!_n && _i["return"]) _i["return"]();
          } finally {
            if (_d) throw _e;
          }
        }
        return _arr;
      }
      return function (arr, i) {
        if (Array.isArray(arr)) {
          return arr;
        } else if (Symbol.iterator in Object(arr)) {
          return sliceIterator(arr, i);
        } else {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
      };
    }();
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    var _isPlainObject = __webpack_require__(9);
    var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
    var _slateDevLogger = __webpack_require__(16);
    var _slateDevLogger2 = _interopRequireDefault(_slateDevLogger);
    var _immutable = __webpack_require__(2);
    var _modelTypes = __webpack_require__(11);
    var _modelTypes2 = _interopRequireDefault(_modelTypes);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    /**
     * Default properties.
     *
     * @type {Object}
     */

    var DEFAULTS = {
      anchorKey: null,
      anchorOffset: 0,
      focusKey: null,
      focusOffset: 0,
      isBackward: null,
      isFocused: false,
      marks: null
    };

    /**
     * Selection.
     *
     * @type {Selection}
     */

    var Selection = function (_Record) {
      _inherits(Selection, _Record);
      function Selection() {
        _classCallCheck(this, Selection);
        return _possibleConstructorReturn(this, (Selection.__proto__ || Object.getPrototypeOf(Selection)).apply(this, arguments));
      }
      _createClass(Selection, [{
        key: 'hasAnchorAtStartOf',
        /**
         * Check whether anchor point of the selection is at the start of a `node`.
         *
         * @param {Node} node
         * @return {Boolean}
         */

        value: function hasAnchorAtStartOf(node) {
          // PERF: Do a check for a `0` offset first since it's quickest.
          if (this.anchorOffset != 0) return false;
          var first = getFirst(node);
          return this.anchorKey == first.key;
        }

        /**
         * Check whether anchor point of the selection is at the end of a `node`.
         *
         * @param {Node} node
         * @return {Boolean}
         */
      }, {
        key: 'hasAnchorAtEndOf',
        value: function hasAnchorAtEndOf(node) {
          var last = getLast(node);
          return this.anchorKey == last.key && this.anchorOffset == last.text.length;
        }

        /**
         * Check whether the anchor edge of a selection is in a `node` and at an
         * offset between `start` and `end`.
         *
         * @param {Node} node
         * @param {Number} start
         * @param {Number} end
         * @return {Boolean}
         */
      }, {
        key: 'hasAnchorBetween',
        value: function hasAnchorBetween(node, start, end) {
          return this.anchorOffset <= end && start <= this.anchorOffset && this.hasAnchorIn(node);
        }

        /**
         * Check whether the anchor edge of a selection is in a `node`.
         *
         * @param {Node} node
         * @return {Boolean}
         */
      }, {
        key: 'hasAnchorIn',
        value: function hasAnchorIn(node) {
          return node.kind == 'text' ? node.key == this.anchorKey : this.anchorKey != null && node.hasDescendant(this.anchorKey);
        }

        /**
         * Check whether focus point of the selection is at the end of a `node`.
         *
         * @param {Node} node
         * @return {Boolean}
         */
      }, {
        key: 'hasFocusAtEndOf',
        value: function hasFocusAtEndOf(node) {
          var last = getLast(node);
          return this.focusKey == last.key && this.focusOffset == last.text.length;
        }

        /**
         * Check whether focus point of the selection is at the start of a `node`.
         *
         * @param {Node} node
         * @return {Boolean}
         */
      }, {
        key: 'hasFocusAtStartOf',
        value: function hasFocusAtStartOf(node) {
          if (this.focusOffset != 0) return false;
          var first = getFirst(node);
          return this.focusKey == first.key;
        }

        /**
         * Check whether the focus edge of a selection is in a `node` and at an
         * offset between `start` and `end`.
         *
         * @param {Node} node
         * @param {Number} start
         * @param {Number} end
         * @return {Boolean}
         */
      }, {
        key: 'hasFocusBetween',
        value: function hasFocusBetween(node, start, end) {
          return start <= this.focusOffset && this.focusOffset <= end && this.hasFocusIn(node);
        }

        /**
         * Check whether the focus edge of a selection is in a `node`.
         *
         * @param {Node} node
         * @return {Boolean}
         */
      }, {
        key: 'hasFocusIn',
        value: function hasFocusIn(node) {
          return node.kind == 'text' ? node.key == this.focusKey : this.focusKey != null && node.hasDescendant(this.focusKey);
        }

        /**
         * Check whether the selection is at the start of a `node`.
         *
         * @param {Node} node
         * @return {Boolean}
         */
      }, {
        key: 'isAtStartOf',
        value: function isAtStartOf(node) {
          return this.isCollapsed && this.hasAnchorAtStartOf(node);
        }

        /**
         * Check whether the selection is at the end of a `node`.
         *
         * @param {Node} node
         * @return {Boolean}
         */
      }, {
        key: 'isAtEndOf',
        value: function isAtEndOf(node) {
          return this.isCollapsed && this.hasAnchorAtEndOf(node);
        }

        /**
         * Focus the selection.
         *
         * @return {Selection}
         */
      }, {
        key: 'focus',
        value: function focus() {
          return this.merge({
            isFocused: true
          });
        }

        /**
         * Blur the selection.
         *
         * @return {Selection}
         */
      }, {
        key: 'blur',
        value: function blur() {
          return this.merge({
            isFocused: false
          });
        }

        /**
         * Unset the selection.
         *
         * @return {Selection}
         */
      }, {
        key: 'deselect',
        value: function deselect() {
          return this.merge({
            anchorKey: null,
            anchorOffset: 0,
            focusKey: null,
            focusOffset: 0,
            isFocused: false,
            isBackward: false
          });
        }

        /**
         * Flip the selection.
         *
         * @return {Selection}
         */
      }, {
        key: 'flip',
        value: function flip() {
          return this.merge({
            anchorKey: this.focusKey,
            anchorOffset: this.focusOffset,
            focusKey: this.anchorKey,
            focusOffset: this.anchorOffset,
            isBackward: this.isBackward == null ? null : !this.isBackward
          });
        }

        /**
         * Move the anchor offset `n` characters.
         *
         * @param {Number} n (optional)
         * @return {Selection}
         */
      }, {
        key: 'moveAnchor',
        value: function moveAnchor() {
          var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
          var anchorKey = this.anchorKey,
            focusKey = this.focusKey,
            focusOffset = this.focusOffset,
            isBackward = this.isBackward;
          var anchorOffset = this.anchorOffset + n;
          return this.merge({
            anchorOffset: anchorOffset,
            isBackward: anchorKey == focusKey ? anchorOffset > focusOffset : isBackward
          });
        }

        /**
         * Move the anchor offset `n` characters.
         *
         * @param {Number} n (optional)
         * @return {Selection}
         */
      }, {
        key: 'moveFocus',
        value: function moveFocus() {
          var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
          var anchorKey = this.anchorKey,
            anchorOffset = this.anchorOffset,
            focusKey = this.focusKey,
            isBackward = this.isBackward;
          var focusOffset = this.focusOffset + n;
          return this.merge({
            focusOffset: focusOffset,
            isBackward: focusKey == anchorKey ? anchorOffset > focusOffset : isBackward
          });
        }

        /**
         * Move the selection's anchor point to a `key` and `offset`.
         *
         * @param {String} key
         * @param {Number} offset
         * @return {Selection}
         */
      }, {
        key: 'moveAnchorTo',
        value: function moveAnchorTo(key, offset) {
          var anchorKey = this.anchorKey,
            focusKey = this.focusKey,
            focusOffset = this.focusOffset,
            isBackward = this.isBackward;
          return this.merge({
            anchorKey: key,
            anchorOffset: offset,
            isBackward: key == focusKey ? offset > focusOffset : key == anchorKey ? isBackward : null
          });
        }

        /**
         * Move the selection's focus point to a `key` and `offset`.
         *
         * @param {String} key
         * @param {Number} offset
         * @return {Selection}
         */
      }, {
        key: 'moveFocusTo',
        value: function moveFocusTo(key, offset) {
          var focusKey = this.focusKey,
            anchorKey = this.anchorKey,
            anchorOffset = this.anchorOffset,
            isBackward = this.isBackward;
          return this.merge({
            focusKey: key,
            focusOffset: offset,
            isBackward: key == anchorKey ? anchorOffset > offset : key == focusKey ? isBackward : null
          });
        }

        /**
         * Move the selection to `anchorOffset`.
         *
         * @param {Number} anchorOffset
         * @return {Selection}
         */
      }, {
        key: 'moveAnchorOffsetTo',
        value: function moveAnchorOffsetTo(anchorOffset) {
          return this.merge({
            anchorOffset: anchorOffset,
            isBackward: this.anchorKey == this.focusKey ? anchorOffset > this.focusOffset : this.isBackward
          });
        }

        /**
         * Move the selection to `focusOffset`.
         *
         * @param {Number} focusOffset
         * @return {Selection}
         */
      }, {
        key: 'moveFocusOffsetTo',
        value: function moveFocusOffsetTo(focusOffset) {
          return this.merge({
            focusOffset: focusOffset,
            isBackward: this.anchorKey == this.focusKey ? this.anchorOffset > focusOffset : this.isBackward
          });
        }

        /**
         * Move the selection to `anchorOffset` and `focusOffset`.
         *
         * @param {Number} anchorOffset
         * @param {Number} focusOffset (optional)
         * @return {Selection}
         */
      }, {
        key: 'moveOffsetsTo',
        value: function moveOffsetsTo(anchorOffset) {
          var focusOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : anchorOffset;
          return this.moveAnchorOffsetTo(anchorOffset).moveFocusOffsetTo(focusOffset);
        }

        /**
         * Move the focus point to the anchor point.
         *
         * @return {Selection}
         */
      }, {
        key: 'moveToAnchor',
        value: function moveToAnchor() {
          return this.moveFocusTo(this.anchorKey, this.anchorOffset);
        }

        /**
         * Move the anchor point to the focus point.
         *
         * @return {Selection}
         */
      }, {
        key: 'moveToFocus',
        value: function moveToFocus() {
          return this.moveAnchorTo(this.focusKey, this.focusOffset);
        }

        /**
         * Move the selection's anchor point to the start of a `node`.
         *
         * @param {Node} node
         * @return {Selection}
         */
      }, {
        key: 'moveAnchorToStartOf',
        value: function moveAnchorToStartOf(node) {
          node = getFirst(node);
          return this.moveAnchorTo(node.key, 0);
        }

        /**
         * Move the selection's anchor point to the end of a `node`.
         *
         * @param {Node} node
         * @return {Selection}
         */
      }, {
        key: 'moveAnchorToEndOf',
        value: function moveAnchorToEndOf(node) {
          node = getLast(node);
          return this.moveAnchorTo(node.key, node.text.length);
        }

        /**
         * Move the selection's focus point to the start of a `node`.
         *
         * @param {Node} node
         * @return {Selection}
         */
      }, {
        key: 'moveFocusToStartOf',
        value: function moveFocusToStartOf(node) {
          node = getFirst(node);
          return this.moveFocusTo(node.key, 0);
        }

        /**
         * Move the selection's focus point to the end of a `node`.
         *
         * @param {Node} node
         * @return {Selection}
         */
      }, {
        key: 'moveFocusToEndOf',
        value: function moveFocusToEndOf(node) {
          node = getLast(node);
          return this.moveFocusTo(node.key, node.text.length);
        }

        /**
         * Move to the entire range of `start` and `end` nodes.
         *
         * @param {Node} start
         * @param {Node} end (optional)
         * @return {Selection}
         */
      }, {
        key: 'moveToRangeOf',
        value: function moveToRangeOf(start) {
          var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : start;
          return this.moveAnchorToStartOf(start).moveFocusToEndOf(end);
        }

        /**
         * Normalize the selection, relative to a `node`, ensuring that the anchor
         * and focus nodes of the selection always refer to leaf text nodes.
         *
         * @param {Node} node
         * @return {Selection}
         */
      }, {
        key: 'normalize',
        value: function normalize(node) {
          var selection = this;
          var anchorKey = selection.anchorKey,
            anchorOffset = selection.anchorOffset,
            focusKey = selection.focusKey,
            focusOffset = selection.focusOffset,
            isBackward = selection.isBackward;

          // If the selection is unset, make sure it is properly zeroed out.

          if (anchorKey == null || focusKey == null) {
            return selection.merge({
              anchorKey: null,
              anchorOffset: 0,
              focusKey: null,
              focusOffset: 0,
              isBackward: false
            });
          }

          // Get the anchor and focus nodes.
          var anchorNode = node.getDescendant(anchorKey);
          var focusNode = node.getDescendant(focusKey);

          // If the selection is malformed, warn and zero it out.
          if (!anchorNode || !focusNode) {
            _slateDevLogger2.default.warn('The selection was invalid and was reset. The selection in question was:', selection);
            var first = node.getFirstText();
            return selection.merge({
              anchorKey: first ? first.key : null,
              anchorOffset: 0,
              focusKey: first ? first.key : null,
              focusOffset: 0,
              isBackward: false
            });
          }

          // If the anchor node isn't a text node, match it to one.
          if (anchorNode.kind != 'text') {
            _slateDevLogger2.default.warn('The selection anchor was set to a Node that is not a Text node. This should not happen and can degrade performance. The node in question was:', anchorNode);
            var anchorText = anchorNode.getTextAtOffset(anchorOffset);
            var offset = anchorNode.getOffset(anchorText.key);
            anchorOffset = anchorOffset - offset;
            anchorNode = anchorText;
          }

          // If the focus node isn't a text node, match it to one.
          if (focusNode.kind != 'text') {
            _slateDevLogger2.default.warn('The selection focus was set to a Node that is not a Text node. This should not happen and can degrade performance. The node in question was:', focusNode);
            var focusText = focusNode.getTextAtOffset(focusOffset);
            var _offset = focusNode.getOffset(focusText.key);
            focusOffset = focusOffset - _offset;
            focusNode = focusText;
          }

          // If `isBackward` is not set, derive it.
          if (isBackward == null) {
            if (anchorNode.key === focusNode.key) {
              isBackward = anchorOffset > focusOffset;
            } else {
              isBackward = !node.areDescendantsSorted(anchorNode.key, focusNode.key);
            }
          }

          // Merge in any updated properties.
          return selection.merge({
            anchorKey: anchorNode.key,
            anchorOffset: anchorOffset,
            focusKey: focusNode.key,
            focusOffset: focusOffset,
            isBackward: isBackward
          });
        }

        /**
         * Return a JSON representation of the selection.
         *
         * @return {Object}
         */
      }, {
        key: 'toJSON',
        value: function toJSON() {
          var object = {
            anchorKey: this.anchorKey,
            anchorOffset: this.anchorOffset,
            focusKey: this.focusKey,
            focusOffset: this.focusOffset,
            isBackward: this.isBackward,
            isFocused: this.isFocused,
            kind: this.kind,
            marks: this.marks == null ? null : this.marks.toArray().map(function (m) {
              return m.toJSON();
            })
          };
          return object;
        }

        /**
         * Alias `toJS`.
         */
      }, {
        key: 'toJS',
        value: function toJS() {
          return this.toJSON();
        }

        /**
         * Unset the selection.
         *
         * @return {Selection}
         */
      }, {
        key: 'unset',
        value: function unset() {
          _slateDevLogger2.default.deprecate('0.17.0', 'The `Selection.unset` method is deprecated, please switch to using `Selection.deselect` instead.');
          return this.deselect();
        }

        /**
         * Move the selection forward `n` characters.
         *
         * @param {Number} n (optional)
         * @return {Selection}
         */
      }, {
        key: 'moveForward',
        value: function moveForward() {
          var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
          _slateDevLogger2.default.deprecate('0.17.0', 'The `Selection.moveForward(n)` method is deprecated, please switch to using `Selection.move(n)` instead.');
          return this.move(n);
        }

        /**
         * Move the selection backward `n` characters.
         *
         * @param {Number} n (optional)
         * @return {Selection}
         */
      }, {
        key: 'moveBackward',
        value: function moveBackward() {
          var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
          _slateDevLogger2.default.deprecate('0.17.0', 'The `Selection.moveBackward(n)` method is deprecated, please switch to using `Selection.move(-n)` (with a negative number) instead.');
          return this.move(0 - n);
        }

        /**
         * Move the anchor offset `n` characters.
         *
         * @param {Number} n (optional)
         * @return {Selection}
         */
      }, {
        key: 'moveAnchorOffset',
        value: function moveAnchorOffset() {
          var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
          _slateDevLogger2.default.deprecate('0.17.0', 'The `Selection.moveAnchorOffset(n)` method is deprecated, please switch to using `Selection.moveAnchor(n)` instead.');
          return this.moveAnchor(n);
        }

        /**
         * Move the focus offset `n` characters.
         *
         * @param {Number} n (optional)
         * @return {Selection}
         */
      }, {
        key: 'moveFocusOffset',
        value: function moveFocusOffset() {
          var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
          _slateDevLogger2.default.deprecate('0.17.0', 'The `Selection.moveFocusOffset(n)` method is deprecated, please switch to using `Selection.moveFocus(n)` instead.');
          return this.moveFocus(n);
        }

        /**
         * Move the start offset `n` characters.
         *
         * @param {Number} n (optional)
         * @return {Selection}
         */
      }, {
        key: 'moveStartOffset',
        value: function moveStartOffset() {
          var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
          _slateDevLogger2.default.deprecate('0.17.0', 'The `Selection.moveStartOffset(n)` method is deprecated, please switch to using `Selection.moveStart(n)` instead.');
          return this.moveStart(n);
        }

        /**
         * Move the focus offset `n` characters.
         *
         * @param {Number} n (optional)
         * @return {Selection}
         */
      }, {
        key: 'moveEndOffset',
        value: function moveEndOffset() {
          var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
          _slateDevLogger2.default.deprecate('0.17.0', 'The `Selection.moveEndOffset(n)` method is deprecated, please switch to using `Selection.moveEnd(n)` instead.');
          return this.moveEnd(n);
        }

        /**
         * Extend the focus point forward `n` characters.
         *
         * @param {Number} n (optional)
         * @return {Selection}
         */
      }, {
        key: 'extendForward',
        value: function extendForward() {
          var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
          _slateDevLogger2.default.deprecate('0.17.0', 'The `Selection.extendForward(n)` method is deprecated, please switch to using `Selection.extend(n)` instead.');
          return this.extend(n);
        }

        /**
         * Extend the focus point backward `n` characters.
         *
         * @param {Number} n (optional)
         * @return {Selection}
         */
      }, {
        key: 'extendBackward',
        value: function extendBackward() {
          var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
          _slateDevLogger2.default.deprecate('0.17.0', 'The `Selection.extendBackward(n)` method is deprecated, please switch to using `Selection.extend(-n)` (with a negative number) instead.');
          return this.extend(0 - n);
        }

        /**
         * Move the selection to `anchorOffset` and `focusOffset`.
         *
         * @param {Number} anchorOffset
         * @param {Number} focusOffset (optional)
         * @return {Selection}
         */
      }, {
        key: 'moveToOffsets',
        value: function moveToOffsets(anchorOffset) {
          var focusOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : anchorOffset;
          _slateDevLogger2.default.deprecate('0.17.0', 'The `Selection.moveToOffsets` method is deprecated, please switch to using `Selection.moveOffsetsTo` instead.');
          return this.moveOffsetsTo(anchorOffset, focusOffset);
        }
      }, {
        key: 'kind',
        /**
         * Get the kind.
         *
         * @return {String}
         */

        get: function get() {
          return 'selection';
        }

        /**
         * Check whether the selection is blurred.
         *
         * @return {Boolean}
         */
      }, {
        key: 'isBlurred',
        get: function get() {
          return !this.isFocused;
        }

        /**
         * Check whether the selection is collapsed.
         *
         * @return {Boolean}
         */
      }, {
        key: 'isCollapsed',
        get: function get() {
          return this.anchorKey == this.focusKey && this.anchorOffset == this.focusOffset;
        }

        /**
         * Check whether the selection is expanded.
         *
         * @return {Boolean}
         */
      }, {
        key: 'isExpanded',
        get: function get() {
          return !this.isCollapsed;
        }

        /**
         * Check whether the selection is forward.
         *
         * @return {Boolean}
         */
      }, {
        key: 'isForward',
        get: function get() {
          return this.isBackward == null ? null : !this.isBackward;
        }

        /**
         * Check whether the selection's keys are set.
         *
         * @return {Boolean}
         */
      }, {
        key: 'isSet',
        get: function get() {
          return this.anchorKey != null && this.focusKey != null;
        }

        /**
         * Check whether the selection's keys are not set.
         *
         * @return {Boolean}
         */
      }, {
        key: 'isUnset',
        get: function get() {
          return !this.isSet;
        }

        /**
         * Get the start key.
         *
         * @return {String}
         */
      }, {
        key: 'startKey',
        get: function get() {
          return this.isBackward ? this.focusKey : this.anchorKey;
        }

        /**
         * Get the start offset.
         *
         * @return {String}
         */
      }, {
        key: 'startOffset',
        get: function get() {
          return this.isBackward ? this.focusOffset : this.anchorOffset;
        }

        /**
         * Get the end key.
         *
         * @return {String}
         */
      }, {
        key: 'endKey',
        get: function get() {
          return this.isBackward ? this.anchorKey : this.focusKey;
        }

        /**
         * Get the end offset.
         *
         * @return {String}
         */
      }, {
        key: 'endOffset',
        get: function get() {
          return this.isBackward ? this.anchorOffset : this.focusOffset;
        }
      }], [{
        key: 'create',
        /**
         * Create a new `Selection` with `attrs`.
         *
         * @param {Object|Selection} attrs
         * @return {Selection}
         */

        value: function create() {
          var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          if (Selection.isSelection(attrs)) {
            return attrs;
          }
          if ((0, _isPlainObject2.default)(attrs)) {
            return Selection.fromJSON(attrs);
          }
          throw new Error('`Selection.create` only accepts objects or selections, but you passed it: ' + attrs);
        }

        /**
         * Create a dictionary of settable selection properties from `attrs`.
         *
         * @param {Object|String|Selection} attrs
         * @return {Object}
         */
      }, {
        key: 'createProperties',
        value: function createProperties() {
          var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          if (Selection.isSelection(attrs)) {
            return {
              anchorKey: attrs.anchorKey,
              anchorOffset: attrs.anchorOffset,
              focusKey: attrs.focusKey,
              focusOffset: attrs.focusOffset,
              isBackward: attrs.isBackward,
              isFocused: attrs.isFocused,
              marks: attrs.marks
            };
          }
          if ((0, _isPlainObject2.default)(attrs)) {
            var props = {};
            if ('anchorKey' in attrs) props.anchorKey = attrs.anchorKey;
            if ('anchorOffset' in attrs) props.anchorOffset = attrs.anchorOffset;
            if ('focusKey' in attrs) props.focusKey = attrs.focusKey;
            if ('focusOffset' in attrs) props.focusOffset = attrs.focusOffset;
            if ('isBackward' in attrs) props.isBackward = attrs.isBackward;
            if ('isFocused' in attrs) props.isFocused = attrs.isFocused;
            if ('marks' in attrs) props.marks = attrs.marks;
            return props;
          }
          throw new Error('`Selection.createProperties` only accepts objects or selections, but you passed it: ' + attrs);
        }

        /**
         * Create a `Selection` from a JSON `object`.
         *
         * @param {Object} object
         * @return {Selection}
         */
      }, {
        key: 'fromJSON',
        value: function fromJSON(object) {
          var _object$anchorKey = object.anchorKey,
            anchorKey = _object$anchorKey === undefined ? null : _object$anchorKey,
            _object$anchorOffset = object.anchorOffset,
            anchorOffset = _object$anchorOffset === undefined ? 0 : _object$anchorOffset,
            _object$focusKey = object.focusKey,
            focusKey = _object$focusKey === undefined ? null : _object$focusKey,
            _object$focusOffset = object.focusOffset,
            focusOffset = _object$focusOffset === undefined ? 0 : _object$focusOffset,
            _object$isBackward = object.isBackward,
            isBackward = _object$isBackward === undefined ? null : _object$isBackward,
            _object$isFocused = object.isFocused,
            isFocused = _object$isFocused === undefined ? false : _object$isFocused,
            _object$marks = object.marks,
            marks = _object$marks === undefined ? null : _object$marks;
          var selection = new Selection({
            anchorKey: anchorKey,
            anchorOffset: anchorOffset,
            focusKey: focusKey,
            focusOffset: focusOffset,
            isBackward: isBackward,
            isFocused: isFocused,
            marks: marks
          });
          return selection;
        }

        /**
         * Alias `fromJS`.
         */
      }, {
        key: 'isSelection',
        /**
         * Check if a `value` is a `Selection`.
         *
         * @param {Any} value
         * @return {Boolean}
         */

        value: function isSelection(value) {
          return !!(value && value[_modelTypes2.default.SELECTION]);
        }
      }]);
      return Selection;
    }((0, _immutable.Record)(DEFAULTS));

    /**
     * Attach a pseudo-symbol for type checking.
     */

    Selection.fromJS = Selection.fromJSON;
    Selection.prototype[_modelTypes2.default.SELECTION] = true;

    /**
     * Mix in some "move" convenience methods.
     */

    var MOVE_METHODS = [['move', ''], ['move', 'To'], ['move', 'ToStartOf'], ['move', 'ToEndOf']];
    MOVE_METHODS.forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        p = _ref2[0],
        s = _ref2[1];
      Selection.prototype['' + p + s] = function () {
        var _ref3;
        return (_ref3 = this[p + 'Anchor' + s].apply(this, arguments))[p + 'Focus' + s].apply(_ref3, arguments);
      };
    });

    /**
     * Mix in the "start", "end" and "edge" convenience methods.
     */

    var EDGE_METHODS = [['has', 'AtStartOf', true], ['has', 'AtEndOf', true], ['has', 'Between', true], ['has', 'In', true], ['collapseTo', ''], ['move', ''], ['moveTo', ''], ['move', 'To'], ['move', 'OffsetTo']];
    EDGE_METHODS.forEach(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 3),
        p = _ref5[0],
        s = _ref5[1],
        hasEdge = _ref5[2];
      var anchor = p + 'Anchor' + s;
      var focus = p + 'Focus' + s;
      Selection.prototype[p + 'Start' + s] = function () {
        return this.isBackward ? this[focus].apply(this, arguments) : this[anchor].apply(this, arguments);
      };
      Selection.prototype[p + 'End' + s] = function () {
        return this.isBackward ? this[anchor].apply(this, arguments) : this[focus].apply(this, arguments);
      };
      if (hasEdge) {
        Selection.prototype[p + 'Edge' + s] = function () {
          return this[anchor].apply(this, arguments) || this[focus].apply(this, arguments);
        };
      }
    });

    /**
     * Mix in some aliases for convenience / parallelism with the browser APIs.
     */

    var ALIAS_METHODS = [['collapseTo', 'moveTo'], ['collapseToAnchor', 'moveToAnchor'], ['collapseToFocus', 'moveToFocus'], ['collapseToStart', 'moveToStart'], ['collapseToEnd', 'moveToEnd'], ['collapseToStartOf', 'moveToStartOf'], ['collapseToEndOf', 'moveToEndOf'], ['extend', 'moveFocus'], ['extendTo', 'moveFocusTo'], ['extendToStartOf', 'moveFocusToStartOf'], ['extendToEndOf', 'moveFocusToEndOf']];
    ALIAS_METHODS.forEach(function (_ref6) {
      var _ref7 = _slicedToArray(_ref6, 2),
        alias = _ref7[0],
        method = _ref7[1];
      Selection.prototype[alias] = function () {
        return this[method].apply(this, arguments);
      };
    });

    /**
     * Get the first text of a `node`.
     *
     * @param {Node} node
     * @return {Text}
     */

    function getFirst(node) {
      return node.kind == 'text' ? node : node.getFirstText();
    }

    /**
     * Get the last text of a `node`.
     *
     * @param {Node} node
     * @return {Text}
     */

    function getLast(node) {
      return node.kind == 'text' ? node : node.getLastText();
    }

    /**
     * Export.
     *
     * @type {Selection}
     */

    exports.default = Selection;

    /***/
  }), ( /* 148 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    var _isPlainObject = __webpack_require__(9);
    var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
    var _slateDevLogger = __webpack_require__(16);
    var _slateDevLogger2 = _interopRequireDefault(_slateDevLogger);
    var _immutable = __webpack_require__(2);
    var _character = __webpack_require__(145);
    var _character2 = _interopRequireDefault(_character);
    var _mark = __webpack_require__(42);
    var _mark2 = _interopRequireDefault(_mark);
    var _range = __webpack_require__(231);
    var _range2 = _interopRequireDefault(_range);
    var _modelTypes = __webpack_require__(11);
    var _modelTypes2 = _interopRequireDefault(_modelTypes);
    var _generateKey = __webpack_require__(57);
    var _generateKey2 = _interopRequireDefault(_generateKey);
    var _memoize = __webpack_require__(150);
    var _memoize2 = _interopRequireDefault(_memoize);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    /**
     * Default properties.
     *
     * @type {Object}
     */

    var DEFAULTS = {
      characters: new _immutable.List(),
      key: undefined
    };

    /**
     * Text.
     *
     * @type {Text}
     */

    var Text = function (_Record) {
      _inherits(Text, _Record);
      function Text() {
        _classCallCheck(this, Text);
        return _possibleConstructorReturn(this, (Text.__proto__ || Object.getPrototypeOf(Text)).apply(this, arguments));
      }
      _createClass(Text, [{
        key: 'addMark',
        /**
         * Add a `mark` at `index` and `length`.
         *
         * @param {Number} index
         * @param {Number} length
         * @param {Mark} mark
         * @return {Text}
         */

        value: function addMark(index, length, mark) {
          var characters = this.characters.map(function (char, i) {
            if (i < index) return char;
            if (i >= index + length) return char;
            var _char = char,
              marks = _char.marks;
            marks = marks.add(mark);
            char = char.set('marks', marks);
            return char;
          });
          return this.set('characters', characters);
        }

        /**
         * Derive a set of decorated characters with `decorators`.
         *
         * @param {Array} decorators
         * @return {List<Character>}
         */
      }, {
        key: 'getDecorations',
        value: function getDecorations(decorators) {
          var node = this;
          var characters = node.characters;
          if (characters.size == 0) return characters;
          for (var i = 0; i < decorators.length; i++) {
            var decorator = decorators[i];
            var decorateds = decorator(node);
            characters = characters.merge(decorateds);
          }
          return characters;
        }

        /**
         * Get the decorations for the node from a `schema`.
         *
         * @param {Schema} schema
         * @return {Array}
         */
      }, {
        key: 'getDecorators',
        value: function getDecorators(schema) {
          return schema.__getDecorators(this);
        }

        /**
         * Get all of the marks on the text.
         *
         * @return {OrderedSet<Mark>}
         */
      }, {
        key: 'getMarks',
        value: function getMarks() {
          var array = this.getMarksAsArray();
          return new _immutable.OrderedSet(array);
        }

        /**
         * Get all of the marks on the text as an array
         *
         * @return {Array}
         */
      }, {
        key: 'getMarksAsArray',
        value: function getMarksAsArray() {
          return this.characters.reduce(function (array, char) {
            return array.concat(char.marks.toArray());
          }, []);
        }

        /**
         * Get the marks on the text at `index`.
         *
         * @param {Number} index
         * @return {Set<Mark>}
         */
      }, {
        key: 'getMarksAtIndex',
        value: function getMarksAtIndex(index) {
          if (index == 0) return _mark2.default.createSet();
          var characters = this.characters;
          var char = characters.get(index - 1);
          if (!char) return _mark2.default.createSet();
          return char.marks;
        }

        /**
         * Get a node by `key`, to parallel other nodes.
         *
         * @param {String} key
         * @return {Node|Null}
         */
      }, {
        key: 'getNode',
        value: function getNode(key) {
          return this.key == key ? this : null;
        }

        /**
         * Derive the ranges for a list of `characters`.
         *
         * @param {Array|Void} decorators (optional)
         * @return {List<Range>}
         */
      }, {
        key: 'getRanges',
        value: function getRanges() {
          var decorators = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
          var characters = this.getDecorations(decorators);
          var ranges = [];

          // PERF: cache previous values for faster lookup.
          var prevChar = void 0;
          var prevRange = void 0;

          // If there are no characters, return one empty range.
          if (characters.size == 0) {
            ranges.push({});
          }

          // Otherwise, loop the characters and build the ranges...
          else {
            characters.forEach(function (char, i) {
              var marks = char.marks,
                text = char.text;

              // The first one can always just be created.

              if (i == 0) {
                prevChar = char;
                prevRange = {
                  text: text,
                  marks: marks
                };
                ranges.push(prevRange);
                return;
              }

              // Otherwise, compare the current and previous marks.
              var prevMarks = prevChar.marks;
              var isSame = (0, _immutable.is)(marks, prevMarks);

              // If the marks are the same, add the text to the previous range.
              if (isSame) {
                prevChar = char;
                prevRange.text += text;
                return;
              }

              // Otherwise, create a new range.
              prevChar = char;
              prevRange = {
                text: text,
                marks: marks
              };
              ranges.push(prevRange);
            }, []);
          }

          // PERF: convert the ranges to immutable objects after iterating.
          ranges = new _immutable.List(ranges.map(function (object) {
            return new _range2.default(object);
          }));

          // Return the ranges.
          return ranges;
        }

        /**
         * Check if the node has a node by `key`, to parallel other nodes.
         *
         * @param {String} key
         * @return {Boolean}
         */
      }, {
        key: 'hasNode',
        value: function hasNode(key) {
          return !!this.getNode(key);
        }

        /**
         * Insert `text` at `index`.
         *
         * @param {Numbder} index
         * @param {String} text
         * @param {String} marks (optional)
         * @return {Text}
         */
      }, {
        key: 'insertText',
        value: function insertText(index, text, marks) {
          var characters = this.characters;
          var chars = _character2.default.createList(text.split('').map(function (char) {
            return {
              text: char,
              marks: marks
            };
          }));
          characters = characters.slice(0, index).concat(chars).concat(characters.slice(index));
          return this.set('characters', characters);
        }

        /**
         * Regenerate the node's key.
         *
         * @return {Text}
         */
      }, {
        key: 'regenerateKey',
        value: function regenerateKey() {
          var key = (0, _generateKey2.default)();
          return this.set('key', key);
        }

        /**
         * Remove a `mark` at `index` and `length`.
         *
         * @param {Number} index
         * @param {Number} length
         * @param {Mark} mark
         * @return {Text}
         */
      }, {
        key: 'removeMark',
        value: function removeMark(index, length, mark) {
          var characters = this.characters.map(function (char, i) {
            if (i < index) return char;
            if (i >= index + length) return char;
            var _char2 = char,
              marks = _char2.marks;
            marks = marks.remove(mark);
            char = char.set('marks', marks);
            return char;
          });
          return this.set('characters', characters);
        }

        /**
         * Remove text from the text node at `index` for `length`.
         *
         * @param {Number} index
         * @param {Number} length
         * @return {Text}
         */
      }, {
        key: 'removeText',
        value: function removeText(index, length) {
          var characters = this.characters;
          var start = index;
          var end = index + length;
          characters = characters.filterNot(function (char, i) {
            return start <= i && i < end;
          });
          return this.set('characters', characters);
        }

        /**
         * Return a JSON representation of the text.
         *
         * @param {Object} options
         * @return {Object}
         */
      }, {
        key: 'toJSON',
        value: function toJSON() {
          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var object = {
            key: this.key,
            kind: this.kind,
            ranges: this.getRanges().toArray().map(function (r) {
              return r.toJSON();
            })
          };
          if (!options.preserveKeys) {
            delete object.key;
          }
          return object;
        }

        /**
         * Alias `toJS`.
         */
      }, {
        key: 'toJS',
        value: function toJS(options) {
          return this.toJSON(options);
        }

        /**
         * Update a `mark` at `index` and `length` with `properties`.
         *
         * @param {Number} index
         * @param {Number} length
         * @param {Mark} mark
         * @param {Object} properties
         * @return {Text}
         */
      }, {
        key: 'updateMark',
        value: function updateMark(index, length, mark, properties) {
          var newMark = mark.merge(properties);
          var characters = this.characters.map(function (char, i) {
            if (i < index) return char;
            if (i >= index + length) return char;
            var _char3 = char,
              marks = _char3.marks;
            if (!marks.has(mark)) return char;
            marks = marks.remove(mark);
            marks = marks.add(newMark);
            char = char.set('marks', marks);
            return char;
          });
          return this.set('characters', characters);
        }

        /**
         * Validate the text node against a `schema`.
         *
         * @param {Schema} schema
         * @return {Object|Void}
         */
      }, {
        key: 'validate',
        value: function validate(schema) {
          return schema.__validate(this);
        }
      }, {
        key: 'kind',
        /**
         * Get the node's kind.
         *
         * @return {String}
         */

        get: function get() {
          return 'text';
        }

        /**
         * Is the node empty?
         *
         * @return {Boolean}
         */
      }, {
        key: 'isEmpty',
        get: function get() {
          return this.text == '';
        }

        /**
         * Get the concatenated text of the node.
         *
         * @return {String}
         */
      }, {
        key: 'text',
        get: function get() {
          return this.characters.reduce(function (string, char) {
            return string + char.text;
          }, '');
        }
      }], [{
        key: 'create',
        /**
         * Create a new `Text` with `attrs`.
         *
         * @param {Object|Array|List|String|Text} attrs
         * @return {Text}
         */

        value: function create() {
          var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          if (Text.isText(attrs)) {
            return attrs;
          }
          if (typeof attrs == 'string') {
            attrs = {
              ranges: [{
                text: attrs
              }]
            };
          }
          if ((0, _isPlainObject2.default)(attrs)) {
            if (attrs.text) {
              var _attrs = attrs,
                text = _attrs.text,
                marks = _attrs.marks,
                key = _attrs.key;
              attrs = {
                key: key,
                ranges: [{
                  text: text,
                  marks: marks
                }]
              };
            }
            return Text.fromJSON(attrs);
          }
          throw new Error('`Text.create` only accepts objects, arrays, strings or texts, but you passed it: ' + attrs);
        }

        /**
         * Create a list of `Texts` from a `value`.
         *
         * @param {Array<Text|Object>|List<Text|Object>} value
         * @return {List<Text>}
         */
      }, {
        key: 'createList',
        value: function createList() {
          var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
          if (_immutable.List.isList(value) || Array.isArray(value)) {
            var list = new _immutable.List(value.map(Text.create));
            return list;
          }
          throw new Error('`Text.createList` only accepts arrays or lists, but you passed it: ' + value);
        }

        /**
         * Create a `Text` from a JSON `object`.
         *
         * @param {Object|Text} object
         * @return {Text}
         */
      }, {
        key: 'fromJSON',
        value: function fromJSON(object) {
          if (Text.isText(object)) {
            return object;
          }
          var _object$ranges = object.ranges,
            ranges = _object$ranges === undefined ? [] : _object$ranges,
            _object$key = object.key,
            key = _object$key === undefined ? (0, _generateKey2.default)() : _object$key;
          if (object.text) {
            _slateDevLogger2.default.deprecate('0.23.0', 'Passing `object.text` to `Text.fromJSON` has been deprecated, please use `object.ranges` instead.');
            ranges = [{
              text: object.text
            }];
          }
          var characters = ranges.map(_range2.default.fromJSON).reduce(function (l, r) {
            return l.concat(r.getCharacters());
          }, new _immutable.List());
          var node = new Text({
            characters: characters,
            key: key
          });
          return node;
        }

        /**
         * Alias `fromJS`.
         */
      }, {
        key: 'isText',
        /**
         * Check if a `value` is a `Text`.
         *
         * @param {Any} value
         * @return {Boolean}
         */

        value: function isText(value) {
          return !!(value && value[_modelTypes2.default.TEXT]);
        }

        /**
         * Check if a `value` is a list of texts.
         *
         * @param {Any} value
         * @return {Boolean}
         */
      }, {
        key: 'isTextList',
        value: function isTextList(value) {
          return _immutable.List.isList(value) && value.every(function (item) {
            return Text.isText(item);
          });
        }

        /**
         * Deprecated.
         */
      }, {
        key: 'createFromString',
        value: function createFromString(string) {
          _slateDevLogger2.default.deprecate('0.22.0', 'The `Text.createFromString(string)` method is deprecated, use `Text.create(string)` instead.');
          return Text.create(string);
        }

        /**
         * Deprecated.
         */
      }, {
        key: 'createFromRanges',
        value: function createFromRanges(ranges) {
          _slateDevLogger2.default.deprecate('0.22.0', 'The `Text.createFromRanges(ranges)` method is deprecated, use `Text.create(ranges)` instead.');
          return Text.create(ranges);
        }
      }]);
      return Text;
    }((0, _immutable.Record)(DEFAULTS));

    /**
     * Attach a pseudo-symbol for type checking.
     */

    Text.fromJS = Text.fromJSON;
    Text.prototype[_modelTypes2.default.TEXT] = true;

    /**
     * Memoize read methods.
     */

    (0, _memoize2.default)(Text.prototype, ['getMarks', 'getMarksAsArray'], {
      takesArguments: false
    });
    (0, _memoize2.default)(Text.prototype, ['getDecorations', 'getDecorators', 'getMarksAtIndex', 'getRanges', 'validate'], {
      takesArguments: true
    });

    /**
     * Export.
     *
     * @type {Text}
     */

    exports.default = Text;

    /***/
  }), ( /* 149 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _immutable = __webpack_require__(2);
    var _schema = __webpack_require__(99);
    var _schema2 = _interopRequireDefault(_schema);
    var _text = __webpack_require__(148);
    var _text2 = _interopRequireDefault(_text);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    /**
     * Options object with normalize set to `false`.
     *
     * @type {Object}
     */

    var OPTS = {
      normalize: false
    };

    /**
     * Define the core schema rules, order-sensitive.
     *
     * @type {Array}
     */

    var rules = [
    /**
     * Only allow block nodes in documents.
     *
     * @type {Object}
     */

    {
      match: function match(node) {
        return node.kind == 'document';
      },
      validate: function validate(document) {
        var invalids = document.nodes.filter(function (n) {
          return n.kind != 'block';
        });
        return invalids.size ? invalids : null;
      },
      normalize: function normalize(change, document, invalids) {
        invalids.forEach(function (node) {
          change.removeNodeByKey(node.key, OPTS);
        });
      }
    },
    /**
     * Only allow block nodes or inline and text nodes in blocks.
     *
     * @type {Object}
     */

    {
      match: function match(node) {
        return node.kind == 'block';
      },
      validate: function validate(block) {
        var first = block.nodes.first();
        if (!first) return null;
        var kinds = first.kind == 'block' ? ['block'] : ['inline', 'text'];
        var invalids = block.nodes.filter(function (n) {
          return !kinds.includes(n.kind);
        });
        return invalids.size ? invalids : null;
      },
      normalize: function normalize(change, block, invalids) {
        invalids.forEach(function (node) {
          change.removeNodeByKey(node.key, OPTS);
        });
      }
    },
    /**
     * Only allow inline and text nodes in inlines.
     *
     * @type {Object}
     */

    {
      match: function match(object) {
        return object.kind == 'inline';
      },
      validate: function validate(inline) {
        var invalids = inline.nodes.filter(function (n) {
          return n.kind != 'inline' && n.kind != 'text';
        });
        return invalids.size ? invalids : null;
      },
      normalize: function normalize(change, inline, invalids) {
        invalids.forEach(function (node) {
          change.removeNodeByKey(node.key, OPTS);
        });
      }
    },
    /**
     * Ensure that block and inline nodes have at least one text child.
     *
     * @type {Object}
     */

    {
      match: function match(object) {
        return object.kind == 'block' || object.kind == 'inline';
      },
      validate: function validate(node) {
        return node.nodes.size == 0;
      },
      normalize: function normalize(change, node) {
        var text = _text2.default.create();
        change.insertNodeByKey(node.key, 0, text, OPTS);
      }
    },
    /**
     * Ensure that void nodes contain a text node with a single space of text.
     *
     * @type {Object}
     */

    {
      match: function match(object) {
        return (object.kind == 'inline' || object.kind == 'block') && object.isVoid;
      },
      validate: function validate(node) {
        return node.text !== ' ' || node.nodes.size !== 1;
      },
      normalize: function normalize(change, node, result) {
        var text = _text2.default.create(' ');
        var index = node.nodes.size;
        change.insertNodeByKey(node.key, index, text, OPTS);
        node.nodes.forEach(function (child) {
          change.removeNodeByKey(child.key, OPTS);
        });
      }
    },
    /**
     * Ensure that inline nodes are never empty.
     *
     * This rule is applied to all blocks, because when they contain an empty
     * inline, we need to remove the inline from that parent block. If `validate`
     * was to be memoized, it should be against the parent node, not the inline
     * themselves.
     *
     * @type {Object}
     */

    {
      match: function match(object) {
        return object.kind == 'block';
      },
      validate: function validate(block) {
        var invalids = block.nodes.filter(function (n) {
          return n.kind == 'inline' && n.text == '';
        });
        return invalids.size ? invalids : null;
      },
      normalize: function normalize(change, block, invalids) {
        // If all of the block's nodes are invalid, insert an empty text node so
        // that the selection will be preserved when they are all removed.
        if (block.nodes.size == invalids.size) {
          var text = _text2.default.create();
          change.insertNodeByKey(block.key, 1, text, OPTS);
        }
        invalids.forEach(function (node) {
          change.removeNodeByKey(node.key, OPTS);
        });
      }
    },
    /**
     * Ensure that inline void nodes are surrounded by text nodes, by adding extra
     * blank text nodes if necessary.
     *
     * @type {Object}
     */

    {
      match: function match(object) {
        return object.kind == 'block' || object.kind == 'inline';
      },
      validate: function validate(node) {
        var invalids = node.nodes.reduce(function (list, child, index) {
          if (child.kind !== 'inline') return list;
          var prev = index > 0 ? node.nodes.get(index - 1) : null;
          var next = node.nodes.get(index + 1);
          // We don't test if "prev" is inline, since it has already been processed in the loop
          var insertBefore = !prev;
          var insertAfter = !next || next.kind == 'inline';
          if (insertAfter || insertBefore) {
            list = list.push({
              insertAfter: insertAfter,
              insertBefore: insertBefore,
              index: index
            });
          }
          return list;
        }, new _immutable.List());
        return invalids.size ? invalids : null;
      },
      normalize: function normalize(change, block, invalids) {
        // Shift for every text node inserted previously.
        var shift = 0;
        invalids.forEach(function (_ref) {
          var index = _ref.index,
            insertAfter = _ref.insertAfter,
            insertBefore = _ref.insertBefore;
          if (insertBefore) {
            change.insertNodeByKey(block.key, shift + index, _text2.default.create(), OPTS);
            shift++;
          }
          if (insertAfter) {
            change.insertNodeByKey(block.key, shift + index + 1, _text2.default.create(), OPTS);
            shift++;
          }
        });
      }
    },
    /**
     * Merge adjacent text nodes.
     *
     * @type {Object}
     */

    {
      match: function match(object) {
        return object.kind == 'block' || object.kind == 'inline';
      },
      validate: function validate(node) {
        var invalids = node.nodes.map(function (child, i) {
          var next = node.nodes.get(i + 1);
          if (child.kind != 'text') return;
          if (!next || next.kind != 'text') return;
          return next;
        }).filter(Boolean);
        return invalids.size ? invalids : null;
      },
      normalize: function normalize(change, node, invalids) {
        // Reverse the list to handle consecutive merges, since the earlier nodes
        // will always exist after each merge.
        invalids.reverse().forEach(function (n) {
          return change.mergeNodeByKey(n.key, OPTS);
        });
      }
    },
    /**
     * Prevent extra empty text nodes, except when adjacent to inline void nodes.
     *
     * @type {Object}
     */

    {
      match: function match(object) {
        return object.kind == 'block' || object.kind == 'inline';
      },
      validate: function validate(node) {
        var nodes = node.nodes;
        if (nodes.size <= 1) return;
        var invalids = nodes.filter(function (desc, i) {
          if (desc.kind != 'text') return;
          if (desc.text.length > 0) return;
          var prev = i > 0 ? nodes.get(i - 1) : null;
          var next = nodes.get(i + 1);

          // If it's the first node, and the next is a void, preserve it.
          if (!prev && next.kind == 'inline') return;

          // It it's the last node, and the previous is an inline, preserve it.
          if (!next && prev.kind == 'inline') return;

          // If it's surrounded by inlines, preserve it.
          if (next && prev && next.kind == 'inline' && prev.kind == 'inline') return;

          // Otherwise, remove it.
          return true;
        });
        return invalids.size ? invalids : null;
      },
      normalize: function normalize(change, node, invalids) {
        invalids.forEach(function (text) {
          change.removeNodeByKey(text.key, OPTS);
        });
      }
    }];

    /**
     * Create the core schema.
     *
     * @type {Schema}
     */

    var SCHEMA = _schema2.default.create({
      rules: rules
    });

    /**
     * Export.
     *
     * @type {Schema}
     */

    exports.default = SCHEMA;

    /***/
  }), ( /* 150 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    /* WEBPACK VAR INJECTION */
    (function (process) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.__enable = exports.__clear = exports.default = undefined;
      var _es6Map = __webpack_require__(434);
      var _es6Map2 = _interopRequireDefault(_es6Map);
      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      /**
       * Is in development?
       *
       * @type {Boolean}
       */

      var IS_DEV = typeof process !== 'undefined' && process.env && "production" !== 'production';

      /**
       * GLOBAL: True if memoization should is enabled. Only effective when `IS_DEV`.
       *
       * @type {Boolean}
       */

      var ENABLED = true;

      /**
       * GLOBAL: Changing this cache key will clear all previous cached results.
       * Only effective when `IS_DEV`.
       *
       * @type {Number}
       */

      var CACHE_KEY = 0;

      /**
       * The leaf node of a cache tree. Used to support variable argument length. A
       * unique object, so that native Maps will key it by reference.
       *
       * @type {Object}
       */

      var LEAF = {};

      /**
       * A value to represent a memoized undefined value. Allows efficient value
       * retrieval using Map.get only.
       *
       * @type {Object}
       */

      var UNDEFINED = {};

      /**
       * Default value for unset keys in native Maps
       *
       * @type {Undefined}
       */

      var UNSET = undefined;

      /**
       * Memoize all of the `properties` on a `object`.
       *
       * @param {Object} object
       * @param {Array} properties
       * @return {Record}
       */

      function memoize(object, properties) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var _options$takesArgumen = options.takesArguments,
          takesArguments = _options$takesArgumen === undefined ? true : _options$takesArgumen;
        var _loop = function _loop(i) {
          var property = properties[i];
          var original = object[property];
          if (!original) {
            throw new Error('Object does not have a property named "' + property + '".');
          }
          object[property] = function () {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            if (IS_DEV) {
              // If memoization is disabled, call into the original method.
              if (!ENABLED) return original.apply(this, args);

              // If the cache key is different, previous caches must be cleared.
              if (CACHE_KEY !== this.__cache_key) {
                this.__cache_key = CACHE_KEY;
                this.__cache = new _es6Map2.default();
              }
            }
            if (!this.__cache) {
              this.__cache = new _es6Map2.default();
            }
            var cachedValue = void 0;
            var keys = void 0;
            if (takesArguments) {
              keys = [property].concat(args);
              cachedValue = getIn(this.__cache, keys);
            } else {
              cachedValue = this.__cache.get(property);
            }

            // If we've got a result already, return it.
            if (cachedValue !== UNSET) {
              return cachedValue === UNDEFINED ? undefined : cachedValue;
            }

            // Otherwise calculate what it should be once and cache it.
            var value = original.apply(this, args);
            var v = value === undefined ? UNDEFINED : value;
            if (takesArguments) {
              this.__cache = setIn(this.__cache, keys, v);
            } else {
              this.__cache.set(property, v);
            }
            return value;
          };
        };
        for (var i = 0; i < properties.length; i++) {
          _loop(i);
        }
      }

      /**
       * Get a value at a key path in a tree of Map.
       *
       * If not set, returns UNSET.
       * If the set value is undefined, returns UNDEFINED.
       *
       * @param {Map} map
       * @param {Array} keys
       * @return {Any|UNSET|UNDEFINED}
       */

      function getIn(map, keys) {
        for (var i = 0; i < keys.length; i++) {
          var key = keys[i];
          map = map.get(key);
          if (map === UNSET) return UNSET;
        }
        return map.get(LEAF);
      }

      /**
       * Set a value at a key path in a tree of Map, creating Maps on the go.
       *
       * @param {Map} map
       * @param {Array} keys
       * @param {Any} value
       * @return {Map}
       */

      function setIn(map, keys, value) {
        var parent = map;
        var child = void 0;
        for (var i = 0; i < keys.length; i++) {
          var key = keys[i];
          child = parent.get(key);

          // If the path was not created yet...
          if (child === UNSET) {
            child = new _es6Map2.default();
            parent.set(key, child);
          }
          parent = child;
        }

        // The whole path has been created, so set the value to the bottom most map.
        child.set(LEAF, value);
        return map;
      }

      /**
       * In DEV mode, clears the previously memoized values, globally.
       *
       * @return {Void}
       */

      function __clear() {
        CACHE_KEY++;
        if (CACHE_KEY >= Number.MAX_SAFE_INTEGER) {
          CACHE_KEY = 0;
        }
      }

      /**
       * In DEV mode, enable or disable the use of memoize values, globally.
       *
       * @param {Boolean} enabled
       * @return {Void}
       */

      function __enable(enabled) {
        ENABLED = enabled;
      }

      /**
       * Export.
       *
       * @type {Object}
       */

      exports.default = memoize;
      exports.__clear = __clear;
      exports.__enable = __enable;
      /* WEBPACK VAR INJECTION */
    }).call(exports, __webpack_require__(217));

    /***/
  }), ( /* 151 */
  /***/function (module, exports, __webpack_require__) {
    var getNative = __webpack_require__(44),
      root = __webpack_require__(25);

    /* Built-in method references that are verified to be native. */
    var Map = getNative(root, 'Map');
    module.exports = Map;

    /***/
  }), ( /* 152 */
  /***/function (module, exports, __webpack_require__) {
    var mapCacheClear = __webpack_require__(646),
      mapCacheDelete = __webpack_require__(647),
      mapCacheGet = __webpack_require__(648),
      mapCacheHas = __webpack_require__(649),
      mapCacheSet = __webpack_require__(650);

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
        length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    module.exports = MapCache;

    /***/
  }), ( /* 153 */
  /***/function (module, exports, __webpack_require__) {
    var castPath = __webpack_require__(102),
      toKey = __webpack_require__(77);

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);
      var index = 0,
        length = path.length;
      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return index && index == length ? object : undefined;
    }
    module.exports = baseGet;

    /***/
  }), ( /* 154 */
  /***/function (module, exports, __webpack_require__) {
    var baseIsEqualDeep = __webpack_require__(603),
      isObjectLike = __webpack_require__(79);

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }
    module.exports = baseIsEqual;

    /***/
  }), ( /* 155 */
  /***/function (module, exports) {
    /** Used as references for various `Number` constants. */
    var MAX_SAFE_INTEGER = 9007199254740991;

    /** Used to detect unsigned integer values. */
    var reIsUint = /^(?:0|[1-9]\d*)$/;

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
    }
    module.exports = isIndex;

    /***/
  }), ( /* 156 */
  /***/function (module, exports, __webpack_require__) {
    var isArray = __webpack_require__(26),
      isSymbol = __webpack_require__(105);

    /** Used to match property names within property paths. */
    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/;

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
    }
    module.exports = isKey;

    /***/
  }), ( /* 157 */
  /***/function (module, exports) {
    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || value !== value && other !== other;
    }
    module.exports = eq;

    /***/
  }), ( /* 158 */
  /***/function (module, exports, __webpack_require__) {
    var baseIsArguments = __webpack_require__(602),
      isObjectLike = __webpack_require__(79);

    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Built-in value references. */
    var propertyIsEnumerable = objectProto.propertyIsEnumerable;

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function () {
      return arguments;
    }()) ? baseIsArguments : function (value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
    };
    module.exports = isArguments;

    /***/
  }), ( /* 159 */
  /***/function (module, exports) {
    /** Used as references for various `Number` constants. */
    var MAX_SAFE_INTEGER = 9007199254740991;

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }
    module.exports = isLength;

    /***/
  }), ( /* 160 */
  /***/function (module, exports, __webpack_require__) {
    var arrayLikeKeys = __webpack_require__(593),
      baseKeys = __webpack_require__(607),
      isArrayLike = __webpack_require__(245);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }
    module.exports = keys;

    /***/
  }), ( /* 161 */
  /***/function (module, exports, __webpack_require__) {
    var basePick = __webpack_require__(610),
      flatRest = __webpack_require__(624);

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function (object, paths) {
      return object == null ? {} : basePick(object, paths);
    });
    module.exports = pick;

    /***/
  }), ( /* 162 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var isValue = __webpack_require__(58);

    // prettier-ignore
    var possibleTypes = {
      "object": true,
      "function": true,
      "undefined": true /* document.all */
    };
    module.exports = function (value) {
      if (!isValue(value)) return false;
      return hasOwnProperty.call(possibleTypes, typeof value);
    };

    /***/
  }), ( /* 163 */
  /***/function (module, exports) {
    module.exports = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

    /***/
  }), ( /* 164 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.parse = undefined;
    var _flattenDeep2 = __webpack_require__(466);
    var _flattenDeep3 = _interopRequireDefault(_flattenDeep2);
    var _markdownIt = __webpack_require__(469);
    var _markdownIt2 = _interopRequireDefault(_markdownIt);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _toConsumableArray(arr) {
      if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
          arr2[i] = arr[i];
        }
        return arr2;
      } else {
        return Array.from(arr);
      }
    }
    var markdown = new _markdownIt2.default({
      html: false,
      // Enable HTML tags in source
      xhtmlOut: false,
      // Use '/' to close single tags (<br />).
      // This is only for full CommonMark compatibility.
      breaks: false,
      // Convert '\n' in paragraphs into <br>
      langPrefix: 'language-',
      // CSS language prefix for fenced blocks. Can be
      // useful for external highlighters.
      // Enable some language-neutral replacement + quotes beautification
      typographer: false
    });
    var EMPHASISES = {
      strong: 'bold',
      em: 'italic',
      s: 'strikethrough',
      link: 'url'
    };
    var INLINE_OPEN = ['strong_open', 's_open', 'em_open', 'link_open'];
    var TOKENS_DATA = [{
      open: 'blockquote_open',
      close: 'blockquote_close',
      tokenName: 'blockquote'
    }, {
      open: 'bullet_list_open',
      close: 'bullet_list_close',
      tokenName: 'bullet_list'
    }, {
      open: 'list_item_open',
      close: 'list_item_close',
      tokenName: 'list_item'
    }];
    function changeText(tokens) {
      var markup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      for (var i = 0; i < tokens.length; i++) {
        if (tokens[i].type === 'text') {
          tokens[i] = (i === 0 && markup !== '' ? markup + ' ' : '') + tokens[i].content; // eslint-disable-line
        } else if (tokens[i].type === 'code_inline') {
          var content = '' + tokens[i].markup + tokens[i].content + tokens[i].markup;
          var length = content.length;
          if (tokens[i].markup === '```') {
            content = [content];
          }
          tokens[i] = {
            // eslint-disable-line
            type: "code",
            content: content,
            length: length
          };
        }
      }
      return tokens;
    }

    /**
     * getTokensLength - Function calculate tokens' length
     *
     * @param tokens
     * @returns {Number}
     */

    function getTokensLength(tokens) {
      if (typeof tokens === 'string') {
        return tokens.length;
      }
      return tokens.reduce(function (acc, token) {
        return acc + (token.length ? token.length : 0);
      }, 0);
    }
    function getEmptyText() {
      return {
        "type": "text",
        "tag": "",
        "attrs": null,
        "map": null,
        "nesting": 0,
        "level": 0,
        "children": null,
        "content": "",
        "markup": "",
        "info": "",
        "meta": null,
        "block": false,
        "hidden": false
      };
    }

    /**
     * getHeaderContent - Function create content for header-token
     *
     * @param tokens
     * @param type
     * @param markup
     * @returns {{type: *, content}}
     */

    function getHeaderContent(tokens, type, markup) {
      if (tokens[1].children.length === 0) {
        tokens[1].children.push(getEmptyText());
      } else if (tokens[1].children[0].type !== 'text') {
        tokens[1].children.unshift(getEmptyText());
      }
      var content = changeText(tokens[1].children, markup);
      return {
        type: type,
        content: content,
        length: getTokensLength(content)
      };
    }

    /**
     * getBlockContent - Function returns block content
     *
     * @param tokens
     * @param type
     * @param markup
     * @param start
     * @returns {{type: *, content, markup: *}}
     */

    function getBlockContent(tokens, type, markup) {
      var start = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var content = {
        type: type,
        content: processBlockTokens(tokens.slice(1, -1)),
        // eslint-disable-line
        markup: markup
      };
      if (start) {
        content.start = start;
      }
      return content;
    }
    function joinArrString(arr) {
      var resultArr = [];
      var stringArr = [];
      for (var i = 0; i < arr.length; i++) {
        if (typeof arr[i] === 'string') {
          stringArr.push(arr[i]);
        } else {
          if (stringArr.length > 0) {
            resultArr.push(stringArr.join(''));
            stringArr = [];
          }
          resultArr.push(arr[i]);
        }
      }
      if (stringArr.length > 0) {
        resultArr.push(stringArr.join(''));
      }
      return resultArr;
    }
    function parseBlockquote(token) {
      if (token.type === 'blockquote') {
        token = parseBlockquote(token.content); // eslint-disable-line
        token.unshift('>');
      } else {
        token.unshift(' ');
      }
      return token;
    }
    function getHRToken(tokens) {
      return [{
        type: "hr",
        content: tokens[0].markup,
        length: tokens[0].markup.length
      }];
    }
    function getList(tokens, type, markup) {
      return [{
        type: type,
        content: [tokens[0].content],
        markup: markup
      }];
    }
    function parseCodeBlock(tokens) {
      var res = /^[\+\-\*](?= )/.test(tokens[0].content);
      if (res) {
        return getList(tokens, 'list', res[0]);
      }
      res = /^[\d]+(\.|\))(?= )/.test(tokens[0].content);
      if (res) {
        return getList(tokens, 'ordered-list', res[0]);
      }
      return [tokens[0].content];
    }
    function getEmphasisType(openTag) {
      return EMPHASISES[openTag.split('_')[0]];
    }
    function getCloseTag(openTag) {
      return openTag.split('_')[0] + '_close';
    }
    function getClosePos(tokens, startPos, closeTag, markup) {
      for (var i = startPos + 1; i < tokens.length; i++) {
        if (tokens[i].type === closeTag && tokens[i].markup === markup) {
          return i;
        }
      }
      return -1;
    }
    function getAttr(attrs, attrName) {
      for (var i = 0; i < attrs.length; i++) {
        if (attrs[i][0] === attrName) {
          return attrs[i][1];
        }
      }
      return false;
    }
    function getOneEmphasis(tokens, startPos, closePos) {
      var intEmphasis = parseEmphasis(tokens.slice(startPos + 1, closePos)); // eslint-disable-line
      if (Array.isArray(intEmphasis) && intEmphasis.length === 1) {
        intEmphasis = intEmphasis[0];
      }
      if (typeof intEmphasis !== 'string') {
        intEmphasis.length = getTokensLength([intEmphasis]);
      }
      return intEmphasis;
    }

    /**
     * getUrlToken - Function create url-token
     *
     * @param tokens
     * @param intEmphasis
     * @param num
     * @returns {{type: string, content: [null,null,null,null], length: *}}
     */

    function getUrlToken(_ref) {
      var tokens = _ref.tokens,
        intEmphasis = _ref.intEmphasis,
        num = _ref.num;
      var urlContent = '(' + getAttr(tokens[num].attrs, 'href') + ')';
      var urlLength = urlContent.length;
      var punctuation1 = {
        type: "punctuation",
        content: "[",
        length: 1
      };
      var punctuation2 = {
        type: "punctuation",
        content: "]",
        length: 1
      };
      var urlContentObj = {
        type: "punctuation",
        content: urlContent,
        length: urlLength
      };
      var content = Array.isArray(intEmphasis) ? [punctuation1].concat(_toConsumableArray(intEmphasis), [punctuation2, urlContentObj]) : [punctuation1, intEmphasis, punctuation2, urlContentObj];
      return {
        type: "url",
        content: content,
        length: Array.isArray(intEmphasis) ? getTokensLength(content) : 1 + intEmphasis.length + 1 + urlLength
      };
    }

    /**
     * getEmphasisToken - Function create emphasis-token
     *
     * @param tokens
     * @param intEmphasis
     * @param currTag
     * @param num
     * @returns {{type, content, length}}
     */

    function getEmphasisToken(_ref2) {
      var tokens = _ref2.tokens,
        intEmphasis = _ref2.intEmphasis,
        currTag = _ref2.currTag,
        num = _ref2.num;
      var rawContent = joinArrString((0, _flattenDeep3.default)([tokens[num].markup, intEmphasis, tokens[num].markup]));
      var contentLength = getTokensLength(rawContent);
      return {
        type: getEmphasisType(currTag),
        content: rawContent,
        length: contentLength
      };
    }

    /**
     * parseEmphasis - Function parse inline and extract emphasis-tokens
     *
     * @param tokens
     * @returns {Array}
     */

    function parseEmphasis(tokens) {
      var newTokens = [];
      var i = 0;
      while (i < tokens.length) {
        if (typeof tokens[i] === 'string') {
          if (tokens[i] !== '') {
            newTokens.push(tokens[i]);
          }
          i++;
        } else {
          var currTag = tokens[i].type;
          if (INLINE_OPEN.indexOf(currTag) !== -1) {
            var closeTag = getCloseTag(currTag);
            var closePos = getClosePos(tokens, i, closeTag, tokens[i].markup);
            if (closePos !== -1) {
              var intEmphasis = getOneEmphasis(tokens, i, closePos);
              if (Array.isArray(intEmphasis) && intEmphasis.length === 0) {
                intEmphasis = '';
              }
              if (currTag === 'link_open') {
                newTokens.push(getUrlToken({
                  tokens: tokens,
                  intEmphasis: intEmphasis,
                  num: i
                }));
              } else {
                newTokens.push(getEmphasisToken({
                  tokens: tokens,
                  intEmphasis: intEmphasis,
                  currTag: currTag,
                  num: i
                }));
              }
              i = closePos + 1;
              continue;
            }
          }
          newTokens.push(tokens[i]);
          i++;
        }
      }
      return newTokens;
    }
    function getListToken(tokens) {
      if (tokens.type === 'ordered-list') {
        tokens.content.content.unshift('' + tokens.start + tokens.markup + ' ');
      } else {
        tokens.content.content.unshift(tokens.markup + ' ');
      }
      return {
        type: tokens.type === 'ordered-list' ? 'ordered-list' : 'list',
        content: joinArrString(tokens.content.content)
      };
    }

    /* eslint-disable */
    function getBlockquoteToken(token) {
      token.content = joinArrString(parseBlockquote(token));
      token.length = getTokensLength(token.content);
      delete token.markup;
      return token;
    }
    /* eslint-enable */

    function parseBlock(tokens) {
      if (tokens.type === 'blockquote') {
        return [getBlockquoteToken(tokens)];
      } else if (tokens.type === 'bullet_list' && tokens.content.type === 'list_item' || tokens.type === 'ordered-list' && tokens.content.type === 'list_item') {
        return [getListToken(tokens)];
      }
      return tokens;
    }

    /**
     * restoreSpaces
     *
     *  Function restore starting and finishing spaces what Markdown-it was deleting
     *
     * @param {string} string - original line
     * @param {Array} tokens
     * @returns {*}
     */

    function restoreSpaces(string, tokens) {
      var result = /^\s+$/.exec(string);
      if (result) {
        return [result[0]];
      }
      result = /^[ ]+/.exec(string);
      if (result) {
        if (Array.isArray(tokens) && tokens[0] && tokens[0].content && Array.isArray(tokens[0].content) && typeof tokens[0].content[0] === 'string') {
          tokens[0].content[0] = result[0] + tokens[0].content[0]; // eslint-disable-line
        } else if (Array.isArray(tokens)) {
          tokens.unshift(result[0]);
        } else if (Array.isArray(tokens.content)) {
          tokens.content.unshift(result[0]);
        } else {
          tokens = [result[0], tokens]; // eslint-disable-line
        }
        return tokens;
      }
      result = /[ ]+$/.exec(string);
      if (result) {
        if (Array.isArray(tokens)) {
          tokens.push(result[0]);
        } else if (Array.isArray(tokens.content)) {
          tokens.content.push(result[0]);
        } else {
          tokens = [tokens, result[0]]; // eslint-disable-line
        }
      }
      return tokens;
    }
    function processEmphasis(tokens) {
      return parseEmphasis(joinArrString(tokens));
    }
    function processBlockTokens(tokens) {
      var tokensLen = tokens.length;
      if (tokensLen > 0) {
        var firstType = tokens[0].type;
        if (tokensLen === 1) {
          if (firstType === 'hr') {
            return getHRToken(tokens);
          } else if (firstType === 'code_block') {
            return parseCodeBlock(tokens);
          }
        }
        if (tokensLen > 2) {
          var lastType = tokens[tokensLen - 1].type;
          for (var i = 0; i < TOKENS_DATA.length; i++) {
            if (firstType === TOKENS_DATA[i].open && lastType === TOKENS_DATA[i].close) {
              return getBlockContent(tokens, TOKENS_DATA[i].tokenName, tokens[0].markup);
            }
          }
          if (firstType === 'ordered_list_open' && lastType === 'ordered_list_close') {
            var start = tokens[0].attrs ? getAttr(tokens[0].attrs, 'start') || 1 : 1;
            return getBlockContent(tokens, 'ordered-list', tokens[0].markup, start);
          }
          if (firstType === 'paragraph_open' && lastType === 'paragraph_close') {
            return changeText(tokens[1].children);
          }
          if (firstType === 'heading_open' && lastType === 'heading_close') {
            return [getHeaderContent(tokens, 'header', tokens[0].markup)];
          }
        }
      }
      return tokens;
    }

    /* eslint-disable */
    function processInline(tokens) {
      if (tokens[0] && (tokens[0].type === 'header' || tokens[0].type === 'list' || tokens[0].type === 'ordered-list' || tokens[0].type === 'blockquote')) {
        tokens[0].content = processEmphasis(tokens[0].content);
        tokens[0].length = getTokensLength(tokens[0].content);
        delete tokens[0].markup;
      } else if (Array.isArray(tokens)) {
        tokens = processEmphasis(tokens);
      }
      return tokens;
    }
    /* eslint-enable */

    var parse = exports.parse = function parse(string) {
      var tokens = markdown.parse(string, {});
      tokens = processBlockTokens(tokens);
      tokens = parseBlock(tokens);
      tokens = restoreSpaces(string, tokens);
      return processInline(tokens);
    };

    /***/
  }), ( /* 165 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };

    // common reg expressions
    var olRegExp = /^(\s*)([0-9]+)(\.|\))\s/;
    var ulRegExp = /^\s*(\*|\+|-)\s/;
    var h1RegExp = /^#\s/;
    var h2RegExp = /^##\s/;
    var h3RegExp = /^###\s/;
    var h4RegExp = /^####\s/;
    var h5RegExp = /^#####\s/;
    var h6RegExp = /^######\s/;
    var MATCH_SINGLE_RULE = {
      ul: ulRegExp,
      ol: olRegExp
    };
    var MATCH_RULES = {
      ul: [olRegExp, ulRegExp, h1RegExp, h2RegExp, h3RegExp, h4RegExp, h5RegExp, h6RegExp],
      ol: [olRegExp, ulRegExp, h1RegExp, h2RegExp, h3RegExp, h4RegExp, h5RegExp, h6RegExp],
      header: [null, [olRegExp, ulRegExp, h2RegExp, h3RegExp, h4RegExp, h5RegExp, h6RegExp], [olRegExp, ulRegExp, h1RegExp, h3RegExp, h4RegExp, h5RegExp, h6RegExp], [olRegExp, ulRegExp, h1RegExp, h2RegExp, h4RegExp, h5RegExp, h6RegExp], [olRegExp, ulRegExp, h1RegExp, h2RegExp, h3RegExp, h5RegExp, h6RegExp], [olRegExp, ulRegExp, h1RegExp, h2RegExp, h3RegExp, h4RegExp, h6RegExp], [olRegExp, ulRegExp, h1RegExp, h2RegExp, h3RegExp, h4RegExp, h5RegExp]]
    };
    var EMPHASIS_NAMES = ['bold', 'italic', 'strikethrough'];
    var EMPHASIS = exports.EMPHASIS = {
      bold: '**',
      italic: '_',
      strikethrough: '~~'
    };
    var EMPHASIS_ALL = {
      bold: ['**', '__'],
      italic: ['_', '*'],
      strikethrough: ['~~']
    };

    /**
     * Check is the current state selected as multi line
     *
     * @param startKey - start selection key in current editor state
     * @param endKey - end selection key in current editor state
     */
    var hasMultiLineSelection = exports.hasMultiLineSelection = function hasMultiLineSelection(_ref) {
      var _ref$selection = _ref.selection,
        startKey = _ref$selection.startKey,
        endKey = _ref$selection.endKey;
      return startKey !== endKey;
    };

    /**
     * Has the mark on a char
     *
     * @param character
     * @param mark
     * @returns {boolean}
     */
    function hasMarkOnChar(character, mark) {
      var arrChars = character.marks.toJS();
      var marksSize = arrChars.length;
      for (var i = 0; i < marksSize; i++) {
        if (arrChars[i].type === mark) {
          return true;
        }
      }
      return false;
    }

    /**
     * The text has a wrapper in emphasis
     *
     * @param mark
     * @param state
     * @returns {boolean}
     */
    function hasEmphasis(mark, state) {
      var startKey = state.startKey,
        endKey = state.endKey,
        startOffset = state.startOffset,
        endOffset = state.endOffset,
        texts = state.texts;
      if (startKey === endKey) {
        var focusText = texts.get(0).text;
        var textLength = focusText.length;
        if (texts.get(0).charsData) {
          var characters = texts.get(0).charsData.characters;
          // not selection
          if (startOffset === endOffset) {
            // string's edge
            if (startOffset === 0 || startOffset === textLength) {
              return false;
            } else {
              var prevChar = characters.get(startOffset - 1);
              var currChar = characters.get(startOffset);
              var hasPrevMark = hasMarkOnChar(prevChar, mark);
              var hasCurrMark = hasMarkOnChar(currChar, mark);
              // between character's marks
              if (hasPrevMark && hasCurrMark) {
                return true;
                // between pairs of markers
              } else if ((mark === 'bold' || mark === 'strikethrough') && startOffset > 1 && startOffset < textLength - 1) {
                var leftPart = focusText.substr(startOffset - 2, 2);
                var rightPart = focusText.substr(startOffset, 2);
                if (leftPart === rightPart && (mark === 'bold' && (leftPart === '**' || leftPart === '__') || mark === 'strikethrough' && leftPart === '~~')) {
                  return true;
                }
                // between italic markers and not bold's edge
              } else if (mark === 'italic' && prevChar.text === currChar.text && (currChar.text === '_' || currChar.text === '*') && !hasPrevMark && !hasCurrMark && !(hasMarkOnChar(prevChar, 'bold') && hasMarkOnChar(currChar, 'bold')) && (startOffset === 1 || startOffset === focusText.length - 1 || !hasMarkOnChar(characters.get(startOffset - 2), 'bold') && !hasMarkOnChar(characters.get(startOffset + 1), 'bold'))) {
                return true;
              }
            }
            // selection
          } else {
            for (var i = startOffset; i < endOffset; i++) {
              if (!hasMarkOnChar(characters.get(i), mark)) {
                return false;
              }
            }
            return true;
          }
        }
      }
      return false;
    }
    var getLeftEmphEdge = exports.getLeftEmphEdge = function getLeftEmphEdge(accent, characters, startPos) {
      var leftEdge = -1;
      for (var i = startPos - 1; i >= 0; i--) {
        if (!hasMarkOnChar(characters.get(i), accent)) {
          leftEdge = i + 1;
          break;
        }
      }
      return leftEdge < 0 ? 0 : leftEdge;
    };
    var getRightEmphEdge = exports.getRightEmphEdge = function getRightEmphEdge(accent, characters, startPos, maxPos) {
      var rightEdge = -1;
      for (var i = startPos + 1; i < maxPos; i++) {
        if (!hasMarkOnChar(characters.get(i), accent)) {
          rightEdge = i - 1;
          break;
        }
      }
      return rightEdge < 0 ? maxPos - 1 : rightEdge;
    };
    var getLeftSelectionEdgeData = exports.getLeftSelectionEdgeData = function getLeftSelectionEdgeData(_ref2) {
      var accent = _ref2.accent,
        characters = _ref2.characters,
        startOffset = _ref2.startOffset;
      var leftInChar = characters.get(startOffset);
      var hasLeftInMark = hasMarkOnChar(leftInChar, accent);
      var leftOutChar = null;
      var hasLeftOutMark = false;
      if (startOffset > 0) {
        leftOutChar = characters.get(startOffset - 1);
        hasLeftOutMark = hasMarkOnChar(leftOutChar, accent);
      }
      var hasLeftOnEmphasis = hasLeftInMark || startOffset > 0 && hasLeftOutMark;
      return {
        leftInChar: leftInChar,
        hasLeftInMark: hasLeftInMark,
        leftOutChar: leftOutChar,
        hasLeftOutMark: hasLeftOutMark,
        hasLeftOnEmphasis: hasLeftOnEmphasis
      };
    };
    var getRightSelectionEdgeData = exports.getRightSelectionEdgeData = function getRightSelectionEdgeData(_ref3) {
      var accent = _ref3.accent,
        characters = _ref3.characters,
        endOffset = _ref3.endOffset,
        text = _ref3.text;
      var rightInChar = characters.get(endOffset - 1);
      var hasRightInMark = hasMarkOnChar(rightInChar, accent);
      var rightOutChar = null;
      var hasRightOutMark = false;
      if (endOffset < text.length) {
        rightOutChar = characters.get(endOffset);
        hasRightOutMark = hasMarkOnChar(rightOutChar, accent);
      }
      var hasRightOnEmphasis = hasRightInMark || endOffset < text.length && hasRightOutMark;
      return {
        rightInChar: rightInChar,
        hasRightInMark: hasRightInMark,
        rightOutChar: rightOutChar,
        hasRightOutMark: hasRightOutMark,
        hasRightOnEmphasis: hasRightOnEmphasis
      };
    };
    function delInternalMarkers(_ref4) {
      var change = _ref4.change,
        focusKey = _ref4.focusKey,
        characters = _ref4.characters,
        accent = _ref4.accent,
        startPos = _ref4.startPos,
        endPos = _ref4.endPos;
      var marker = EMPHASIS[accent];
      var markerLength = marker.length;
      var accentEdgePositions = [];
      var hasAccents = [];
      hasAccents[startPos] = hasMarkOnChar(characters.get(startPos), accent);
      for (var i = startPos; i < endPos - 1; i++) {
        hasAccents[i + 1] = hasMarkOnChar(characters.get(i + 1), accent);
        if (hasAccents[i] !== hasAccents[i + 1]) {
          if (hasAccents[i]) {
            accentEdgePositions.push(i - markerLength + 1);
          } else {
            accentEdgePositions.push(i + 1);
          }
        }
      }
      accentEdgePositions.reverse();
      for (var _i = 0; _i < accentEdgePositions.length; _i++) {
        change.removeTextByKey(focusKey, accentEdgePositions[_i], markerLength);
      }
      return accentEdgePositions.length;
    }
    function delInternalMarkersBind(_ref5) {
      var change = _ref5.change,
        focusKey = _ref5.focusKey,
        characters = _ref5.characters,
        accent = _ref5.accent;
      return function (_ref6) {
        var startPos = _ref6.startPos,
          endPos = _ref6.endPos;
        return delInternalMarkers({
          change: change,
          focusKey: focusKey,
          characters: characters,
          accent: accent,
          startPos: startPos,
          endPos: endPos
        });
      };
    }

    /**
     * Both selection edges is on emphasis, delete all internal markers
     *
     * @param change
     * @param focusKey
     * @param characters
     * @param text
     * @param accent
     * @param startOffset
     * @param endOffset
     * @param markerLength
     */
    function unionEmphasis(_ref7) {
      var change = _ref7.change,
        focusKey = _ref7.focusKey,
        characters = _ref7.characters,
        accent = _ref7.accent,
        text = _ref7.text,
        startOffset = _ref7.startOffset,
        endOffset = _ref7.endOffset,
        markerLength = _ref7.markerLength;
      var leftEmphEdge = getLeftEmphEdge(accent, characters, startOffset);
      var rightEmphEdge = getRightEmphEdge(accent, characters, endOffset - 1, text.length);
      var leftMarker = text.substr(leftEmphEdge, markerLength);
      var rightMarkerPos = rightEmphEdge - markerLength;
      var rightMarker = text.substr(rightMarkerPos, markerLength);
      var delCount = delInternalMarkers({
        change: change,
        focusKey: focusKey,
        characters: characters,
        accent: accent,
        startPos: leftEmphEdge + markerLength,
        endPos: rightEmphEdge - markerLength
      });
      rightMarkerPos -= delCount * markerLength - 1;
      if (leftMarker !== rightMarker) {
        change.removeTextByKey(focusKey, rightMarkerPos, markerLength).insertTextByKey(focusKey, rightMarkerPos, leftMarker);
      }
      return change;
    }

    /**
     * Wrap text with accent
     *
     * @param accent
     * @param state
     */
    function wrapEmphasis(accent, state) {
      var marker = EMPHASIS[accent];
      var markerLength = marker.length;
      var startOffset = state.startOffset,
        endOffset = state.endOffset,
        focusText = state.focusText,
        texts = state.texts;
      var text = focusText.text;
      var focusKey = focusText.key;
      var change = state.change();

      // #1 no selection
      if (startOffset === endOffset) {
        change.insertText('' + marker + marker).move(-markerLength);

        // selection (this edge is selection edge)
      } else {
        var characters = texts.get(0).charsData.characters;
        var delMarkers = delInternalMarkersBind({
          change: change,
          focusKey: focusKey,
          characters: characters,
          accent: accent
        });
        var _getLeftSelectionEdge = getLeftSelectionEdgeData({
            accent: accent,
            characters: characters,
            startOffset: startOffset
          }),
          hasLeftOnEmphasis = _getLeftSelectionEdge.hasLeftOnEmphasis;
        var _getRightSelectionEdg = getRightSelectionEdgeData({
            accent: accent,
            characters: characters,
            endOffset: endOffset,
            text: text
          }),
          hasRightOnEmphasis = _getRightSelectionEdg.hasRightOnEmphasis;
        if (hasLeftOnEmphasis) {
          if (hasRightOnEmphasis) {
            // #2 both edges on emphasis, delete all internal markers
            change = unionEmphasis({
              change: change,
              focusKey: focusKey,
              characters: characters,
              text: text,
              accent: accent,
              startOffset: startOffset,
              endOffset: endOffset,
              markerLength: markerLength
            });
          } else {
            // #3 left edge on emphasis, right edge beyond markers
            var leftEmphEdge = getLeftEmphEdge(accent, characters, startOffset);
            var leftMarker = text.substr(leftEmphEdge, markerLength);
            delMarkers({
              startPos: leftEmphEdge,
              endPos: endOffset - 1
            });
            change.insertTextByKey(focusKey, endOffset - 1, leftMarker);
          }
        } else {
          if (hasRightOnEmphasis) {
            // #4 left edge beyond markers, right edge on emphasis
            var rightEmphEdge = getRightEmphEdge(accent, characters, endOffset - 1, text.length);
            var rightMarker = text.substr(rightEmphEdge - markerLength + 1, markerLength);
            delMarkers({
              startPos: startOffset,
              endPos: rightEmphEdge
            });
            change.insertTextByKey(focusKey, startOffset, rightMarker);
          } else {
            // #5 both edges beyond markers
            // delete all internal markers, wrap selection in markers
            delMarkers({
              startPos: startOffset,
              endPos: endOffset
            });
            change.wrapText(marker, marker).focus();
          }
        }
      }
      change.focus();
      return change.state;
    }

    /**
     * Unwrap text from accent
     *
     * @param {string} accent
     * @param state - editor state
     */
    function unwrapEmphasis(accent, state) {
      var markerLength = EMPHASIS[accent].length;
      var startOffset = state.startOffset,
        endOffset = state.endOffset,
        focusText = state.focusText,
        texts = state.texts;
      var change = state.change();
      var focusKey = focusText.key;
      var characters = texts.get(0).charsData.characters;
      var text = focusText.text;
      var leftEmphEdge = getLeftEmphEdge(accent, characters, startOffset);
      var rightEmphEdge = getRightEmphEdge(accent, characters, startOffset, text.length);
      var marker = text.substr(leftEmphEdge, markerLength);

      // no selection
      if (startOffset === endOffset) {
        if (startOffset > markerLength - 1 && startOffset < text.length - markerLength + 1) {
          var leftMarker = text.substr(startOffset - markerLength, markerLength);
          var rightMarker = text.substr(startOffset, markerLength);
          // #1 the cursor is wrapped in markers, delete markers
          if (leftMarker === rightMarker && EMPHASIS_ALL[accent].indexOf(leftMarker) !== -1) {
            change.removeTextByKey(focusKey, endOffset, markerLength).removeTextByKey(focusKey, startOffset - markerLength, markerLength).focus();
            return change.state;
          }
        }

        // #2 the cursor on a marker, do nothing
        if (leftEmphEdge < startOffset && startOffset <= leftEmphEdge + markerLength || rightEmphEdge - markerLength + 1 <= startOffset && startOffset < rightEmphEdge + 1) {
          return state;

          // #3 the between markers, add markers to the place of the cursor
        } else {
          change.insertText('' + marker + marker).move(-markerLength).focus();
          return change.state;
        }

        // selection
      } else {
        // #4 the selection on the left edge, do nothing
        if ((leftEmphEdge === startOffset || leftEmphEdge + 1 === startOffset) && leftEmphEdge + 1 === endOffset || leftEmphEdge + markerLength === endOffset) {
          return state;
        }

        // #5 the selection on the right edge, do nothing
        if ((rightEmphEdge - markerLength + 1 === startOffset || rightEmphEdge - markerLength + 2 === startOffset) && (rightEmphEdge === endOffset || rightEmphEdge + 1 === endOffset)) {
          return state;
        }

        // #6 the selection between markers, wrap selection in additional markers
        // (between additional markers there is no current emphasis)
        if (leftEmphEdge + markerLength < startOffset && endOffset < rightEmphEdge - markerLength + 1) {
          change.wrapText(marker, marker).focus();
          return change.state;
        }

        // #7 the selection on markers, delete markers
        if (leftEmphEdge <= startOffset && startOffset <= leftEmphEdge + markerLength && rightEmphEdge - markerLength + 1 <= endOffset && endOffset <= rightEmphEdge + 1) {
          change.removeTextByKey(focusKey, rightEmphEdge - markerLength + 1, markerLength).removeTextByKey(focusKey, leftEmphEdge, markerLength).focus();
          return change.state;
        }

        // #8 startOffset on left marker, endOffset between markers,
        // remove accent from the left part of a wrapper
        if (leftEmphEdge <= startOffset && startOffset <= leftEmphEdge + markerLength) {
          change.insertTextByKey(focusKey, endOffset, marker).removeTextByKey(focusKey, leftEmphEdge, markerLength).moveOffsetsTo(leftEmphEdge, endOffset - markerLength).focus();
          return change.state;
        }

        // #9 startOffset between markers, endOffset on right marker,
        // remove accent from the right part of a wrapper
        change.removeTextByKey(focusKey, rightEmphEdge - markerLength + 1, markerLength).insertTextByKey(focusKey, startOffset, marker).moveOffsetsTo(startOffset + markerLength, rightEmphEdge + 1).focus();
        return change.state;
      }
    }

    /**
     * Has block selected
     *
     * @param regExp - match regexp
     * @param state - editor state
     */
    function hasBlock(regExp, state) {
      var focusText = state.focusText;
      var focusedText = focusText.text;
      return regExp.test(focusedText);
    }

    /**
     * Wrap block
     *
     * @param matchRules - list of regexp
     * @param text - marker of the block
     * @param state - editor state
     */
    function wrapBlock(matchRules, text, state) {
      var startOffset = state.startOffset,
        endOffset = state.endOffset,
        focusText = state.focusText;
      var focusedText = focusText.text;
      var change = state.change();
      change.moveOffsetsTo(0);
      var length = 0;
      for (var i = 0, k = matchRules.length; i < k; i++) {
        var result = matchRules[i].exec(focusedText);
        if (result) {
          length = result[0].length;
          change.deleteForward(length);
          break;
        }
      }
      var startPos = Math.max(startOffset + text.length - length, 0);
      var endPos = Math.max(endOffset + text.length - length, 0);
      change.insertText(text).moveOffsetsTo(startPos, endPos).focus();
      return change.state;
    }

    /**
     * Wrap block
     *
     * @param matchRules - list of regexp
     * @param text - marker of the block
     * @param change - editor change
     * @returns {Object} - state
     */
    var wrapBlockForChange = function wrapBlockForChange(matchRules, text, change) {
      var _change$state = change.state,
        startOffset = _change$state.startOffset,
        endOffset = _change$state.endOffset,
        focusText = _change$state.focusText;
      var focusedText = focusText.text;
      change.moveOffsetsTo(0);
      var length = 0;
      for (var i = 0, k = matchRules.length; i < k; i++) {
        var result = matchRules[i].exec(focusedText);
        if (result) {
          length = result[0].length;
          change.deleteForward(length);
          break;
        }
      }
      var startPos = Math.max(startOffset + text.length - length, 0);
      var endPos = Math.max(endOffset + text.length - length, 0);
      change.insertText(text).moveOffsetsTo(startPos, endPos).focus();
      return change;
    };

    /**
     * Unwrap block
     *
     * @param removedLength - first length should be removed
     * @param change - editor change
     * @returns {Object} - change
     */
    var unwrapBlockForChange = function unwrapBlockForChange(removedLength, change) {
      var _change$state2 = change.state,
        startOffset = _change$state2.startOffset,
        endOffset = _change$state2.endOffset;
      var startPos = Math.max(startOffset - removedLength, 0);
      var endPos = Math.max(endOffset - removedLength, 0);
      change.moveOffsetsTo(0).deleteForward(removedLength).moveOffsetsTo(startPos, endPos).focus();
      return change;
    };

    /**
     * Unwrap block
     *
     * @param removedLength - first length should be removed
     * @param state - editor state
     */
    function unwrapBlock(removedLength, state) {
      var change = state.change();
      change = unwrapBlockForChange(removedLength, change);
      return change.state;
    }

    /**
     * Has list selected
     *
     * @param {string} accent - list type
     * @param {Object} state - editor state
     * @param {number} numLine
     */
    function hasListLine(accent, _ref8) {
      var texts = _ref8.texts;
      var numLine = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var text = texts.get(numLine).text;
      return MATCH_SINGLE_RULE[accent].test(text);
    }

    /**
     * Has list selected
     *
     * @param {string} type - list type
     * @param {Object} state - editor state
     */
    function hasList(type, state) {
      if (hasMultiLineSelection(state)) {
        for (var i = 0; i < state.texts.size; i++) {
          if (!hasListLine(type, state, i)) {
            return false;
          }
        }
        return true;
      } else {
        return hasListLine(type, state);
      }
    }
    var getUlMarker = exports.getUlMarker = function getUlMarker(text) {
      return (ulRegExp.exec(text) || [''])[0];
    };
    var getOlNum = exports.getOlNum = function getOlNum(text) {
      var res = olRegExp.exec(text);
      var pref = '';
      var itemNum = 1;
      var div = '.';
      var listMarker = '';
      if (res) {
        listMarker = res[0]; // === '   2) '
        pref = res[1]; // === '   '
        itemNum = +res[2]; // === 2
        div = res[3]; // === ')'
      }
      return {
        pref: pref,
        itemNum: itemNum,
        div: div,
        listMarker: listMarker
      };
    };
    function getTextLength(change) {
      return change.state.texts.get(0).text.length;
    }

    /**
     * Wrap text with list token
     *
     * @param {string} accent
     * @param state - editor state
     * @returns {Object} - state
     */
    var wrapList = function wrapList(accent, state) {
      var text = accent === 'ul' ? '* ' : '1. ';
      if (hasMultiLineSelection(state)) {
        var _state$selection = state.selection,
          anchorKey = _state$selection.anchorKey,
          anchorOffset = _state$selection.anchorOffset,
          focusKey = _state$selection.focusKey,
          focusOffset = _state$selection.focusOffset,
          isBackward = _state$selection.isBackward;
        var keys = [];
        var firstBefore = void 0,
          firstAfter = void 0,
          lastBefore = void 0,
          lastAfter = void 0;
        for (var i = 0; i < state.texts.size; i++) {
          keys.push(state.texts.get(i).key);
        }
        var lineText = state.texts.get(0).text;
        var pref = void 0,
          itemNum = void 0,
          div = void 0;
        if (accent === 'ul') {
          var ulMarker = getUlMarker(lineText);
          if (ulMarker) {
            text = ulMarker;
          } else {
            text = '* ';
          }
        } else {
          var _getOlNum = getOlNum(lineText);
          pref = _getOlNum.pref;
          itemNum = _getOlNum.itemNum;
          div = _getOlNum.div;
        }
        var change = state.change();
        var keysLength = keys.length;
        var lastNum = keysLength - 1;
        for (var _i2 = 0; _i2 < keysLength; _i2++) {
          moveSelectionToLine(change, keys[_i2]); // eslint-disable-line no-use-before-define
          if (_i2 === 0) {
            firstBefore = getTextLength(change);
          } else if (_i2 === lastNum) {
            lastBefore = getTextLength(change);
          }
          if (_i2 === 0 && !hasBlock(MATCH_SINGLE_RULE[accent], change.state) || _i2 > 0) {
            text = accent === 'ul' ? text : '' + pref + itemNum + div + ' ';
            change = wrapBlockForChange(MATCH_RULES[accent], text, change); // eslint-disable-line
            if (_i2 === 0) {
              firstAfter = getTextLength(change);
            } else if (_i2 === lastNum) {
              lastAfter = getTextLength(change);
            }
            itemNum++;
            continue;
          }
          if (_i2 === 0) {
            firstAfter = firstBefore;
          } else if (_i2 === lastNum) {
            lastAfter = lastBefore;
          }
          itemNum++;
        }
        change.select({
          anchorKey: anchorKey,
          anchorOffset: anchorOffset - firstBefore + firstAfter,
          focusKey: focusKey,
          focusOffset: focusOffset - lastBefore + lastAfter,
          isFocused: true,
          isBackward: isBackward
        });
        return change.state;
      } else {
        return wrapBlock(MATCH_RULES[accent], text, state);
      }
    };

    /**
     * Unwrap line with OL markdown token
     *
     * @param {string} accent
     * @param change - editor change
     * @returns {Object} - change
     */
    var unwrapListLineForChange = exports.unwrapListLineForChange = function unwrapListLineForChange(accent, change) {
      var focusText = change.state.focusText;
      var focusedText = focusText.text;
      var result = MATCH_SINGLE_RULE[accent].exec(focusedText);
      if (result) {
        var length = result[0].length;
        return unwrapBlockForChange(length, change);
      }
      return change;
    };

    /**
     * Unwrap line with OL markdown token
     *
     * @param {string} accent
     * @param state - editor state
     * @returns {Object} - state
     */
    var unwrapListLine = exports.unwrapListLine = function unwrapListLine(accent, state) {
      var change = unwrapListLineForChange(accent, state.change());
      return change.state;
    };
    var unwrapListCallbacks = {
      ul: unwrapListLine.bind(null, 'ul'),
      ol: unwrapListLine.bind(null, 'ol')
    };
    var unwrapListCallbacksForChange = {
      ul: unwrapListLineForChange.bind(null, 'ul'),
      ol: unwrapListLineForChange.bind(null, 'ol')
    };
    function moveSelectionToLine(change, key) {
      change.select({
        anchorKey: key,
        anchorOffset: 0,
        focusKey: key,
        focusOffset: 0,
        isFocused: true,
        isBackward: false
      });
    }

    /**
     * Unwrap text with list token
     *
     * @param {string} accent
     * @param state - editor state
     * @returns {Object} - state
     */
    var unwrapList = function unwrapList(accent, state) {
      if (hasMultiLineSelection(state)) {
        var _state$selection2 = state.selection,
          anchorKey = _state$selection2.anchorKey,
          anchorOffset = _state$selection2.anchorOffset,
          focusKey = _state$selection2.focusKey,
          focusOffset = _state$selection2.focusOffset,
          isBackward = _state$selection2.isBackward;
        var keys = [];
        var firstBefore = void 0,
          firstAfter = void 0,
          lastBefore = void 0,
          lastAfter = void 0;
        for (var i = 0; i < state.texts.size; i++) {
          keys.push(state.texts.get(i).key);
        }
        var change = state.change();
        var keysLength = keys.length;
        var lastNum = keysLength - 1;
        for (var _i3 = 0; _i3 < keysLength; _i3++) {
          moveSelectionToLine(change, keys[_i3]);
          if (_i3 === 0) {
            firstBefore = getTextLength(change);
          } else if (_i3 === lastNum) {
            lastBefore = getTextLength(change);
          }
          change = unwrapListCallbacksForChange[accent](change);
          if (_i3 === 0) {
            firstAfter = getTextLength(change);
          } else if (_i3 === lastNum) {
            lastAfter = getTextLength(change);
          }
        }
        var newAnchorOffset = anchorOffset - (isBackward ? lastBefore - lastAfter : firstBefore - firstAfter);
        var newFocusOffset = focusOffset - (isBackward ? firstBefore - firstAfter : lastBefore - lastAfter);
        change.select({
          anchorKey: anchorKey,
          anchorOffset: newAnchorOffset < 0 ? 0 : newAnchorOffset,
          focusKey: focusKey,
          focusOffset: newFocusOffset < 0 ? 0 : newFocusOffset,
          isFocused: true,
          isBackward: isBackward
        });
        return change.state;
      } else {
        return unwrapListCallbacks[accent](state);
      }
    };

    /**
     * Wrap text with link markdown tokens
     *
     * @param state - editor state
     */
    var wrapLink = exports.wrapLink = function wrapLink(state) {
      var startOffset = state.startOffset,
        endOffset = state.endOffset;
      var change = state.change();
      var url = 'http://example.com';
      if (startOffset === endOffset) {
        var text = '[link text](' + url + ')';
        change.insertText(text).move((text.length - 1) * -1).extend(text.length - 2);
      } else {
        change.wrapText('[', '](' + url + ')').moveOffsetsTo(endOffset + 3, endOffset + 3 + url.length);
      }
      change.focus();
      return change.state;
    };
    var activities = {
      has: {
        bold: hasEmphasis.bind(null, 'bold'),
        italic: hasEmphasis.bind(null, 'italic'),
        strikethrough: hasEmphasis.bind(null, 'strikethrough'),
        ul: hasList.bind(null, 'ul'),
        ol: hasList.bind(null, 'ol'),
        header: [null, hasBlock.bind(null, h1RegExp), hasBlock.bind(null, h2RegExp), hasBlock.bind(null, h3RegExp), hasBlock.bind(null, h4RegExp), hasBlock.bind(null, h5RegExp), hasBlock.bind(null, h6RegExp)]
      },
      unwrap: {
        bold: unwrapEmphasis.bind(null, 'bold'),
        italic: unwrapEmphasis.bind(null, 'italic'),
        strikethrough: unwrapEmphasis.bind(null, 'strikethrough'),
        ul: unwrapList.bind(null, 'ul'),
        ol: unwrapList.bind(null, 'ol'),
        header: [null, unwrapBlock.bind(null, '# '.length), unwrapBlock.bind(null, '## '.length), unwrapBlock.bind(null, '### '.length), unwrapBlock.bind(null, '#### '.length), unwrapBlock.bind(null, '##### '.length), unwrapBlock.bind(null, '###### '.length)]
      },
      wrap: {
        bold: wrapEmphasis.bind(null, 'bold'),
        italic: wrapEmphasis.bind(null, 'italic'),
        strikethrough: wrapEmphasis.bind(null, 'strikethrough'),
        ul: wrapList.bind(null, 'ul'),
        ol: wrapList.bind(null, 'ol'),
        header: [null, wrapBlock.bind(null, MATCH_RULES.header[1], '# '), wrapBlock.bind(null, MATCH_RULES.header[2], '## '), wrapBlock.bind(null, MATCH_RULES.header[3], '### '), wrapBlock.bind(null, MATCH_RULES.header[4], '#### '), wrapBlock.bind(null, MATCH_RULES.header[5], '##### '), wrapBlock.bind(null, MATCH_RULES.header[6], '###### ')]
      }
    };
    var hasAccent = exports.hasAccent = function hasAccent(state, accent) {
      return !!activities.has[accent] && activities.has[accent](state);
    };
    var getAccents = exports.getAccents = function getAccents(state) {
      var accents = [];
      for (var i = 0; i < EMPHASIS_NAMES.length; i++) {
        var accent = EMPHASIS_NAMES[i];
        if (hasAccent(state, accent)) {
          accents.push(accent);
        }
      }
      return accents;
    };
    var wrapAccent = exports.wrapAccent = function wrapAccent(state, accent) {
      if (activities.wrap[accent]) {
        return activities.wrap[accent](state);
      }
      return state;
    };
    var unwrapAccent = exports.unwrapAccent = function unwrapAccent(state, accent) {
      if (activities.unwrap[accent]) {
        return activities.unwrap[accent](state);
      }
      return state;
    };
    var hasHeader = exports.hasHeader = function hasHeader(state, level) {
      if (activities.has.header[level]) {
        return activities.has.header[level](state);
      }
      return false;
    };
    var wrapHeader = exports.wrapHeader = function wrapHeader(state, level) {
      if (activities.wrap.header[level]) {
        return activities.wrap.header[level](state);
      }
      return state;
    };
    var unwrapHeader = exports.unwrapHeader = function unwrapHeader(state, level) {
      if (activities.unwrap.header[level]) {
        return activities.unwrap.header[level](state);
      }
      return state;
    };

    /**
     * getBracketsPos - function returns positions of brackets of the next to the cursor
     *    brackets can be () or []
     *
     * @param {string} text
     * @param {number} pos
     * @returns {{leftPos: number, rightPos: number}}
     */
    var getBracketsPos = exports.getBracketsPos = function getBracketsPos(text, pos) {
      var leftPart = text.substr(0, pos);
      var rightPart = text.substr(pos);

      // find brackets of the next to the cursor
      var leftBracketPos = leftPart.lastIndexOf('(');
      var rightBracketPos = rightPart.indexOf(')');
      var leftSquareBracketPos = leftPart.lastIndexOf('[');
      var rightSquareBracketPos = rightPart.indexOf(']');

      // checks which brackets closer to the cursor: round or square
      var isBrackets = leftBracketPos >= leftSquareBracketPos && (leftBracketPos !== -1 && rightBracketPos !== -1 || leftSquareBracketPos === -1 || rightSquareBracketPos === -1) || leftBracketPos < leftSquareBracketPos && leftBracketPos !== -1 && rightBracketPos !== -1 && (leftSquareBracketPos === -1 || rightSquareBracketPos === -1);

      // calculate the positions of brackets of the next to the cursor
      var leftPos = isBrackets ? leftBracketPos : leftSquareBracketPos;
      var rightPos = isBrackets ? rightBracketPos : rightSquareBracketPos;
      leftPos = leftPos === -1 ? false : leftPos + 1;
      rightPos = rightPos === -1 ? false : rightPos;
      return {
        leftPos: leftPos,
        rightPos: rightPos
      };
    };
    var insertText = function insertText(_ref9) {
      var state = _ref9.state,
        insertedText = _ref9.insertedText,
        insertedPos = _ref9.insertedPos,
        endOffset = _ref9.endOffset;
      var change = state.change();
      change.moveOffsetsTo(insertedPos).insertText(insertedText).moveOffsetsTo(endOffset + insertedText.length).focus();
      return change.state;
    };
    var getPosAfterEmphasis = exports.getPosAfterEmphasis = function getPosAfterEmphasis(state, accents) {
      var maxPos = -1;
      var texts = state.texts,
        startOffset = state.startOffset;
      var accentsCount = accents.length;
      var characters = texts.get(0).charsData.characters;
      for (var i = 0; i < accentsCount; i++) {
        var accent = accents[i];
        var currLeftPos = getLeftEmphEdge(accent, characters, startOffset) + EMPHASIS[accent].length;
        if (maxPos < currLeftPos) {
          maxPos = currLeftPos;
        }
      }
      return maxPos;
    };
    var addSpecialCharacter = exports.addSpecialCharacter = function addSpecialCharacter(specialCharacter, state) {
      var startBlock = state.startBlock,
        startOffset = state.startOffset,
        endOffset = state.endOffset;
      var text = startBlock.text;
      var insertedPos = -1;
      var insertedText = specialCharacter;

      // get right position of the left accent closer to the cursor
      var accents = getAccents(state);
      if (accents.length > 0) {
        // this position has some accent
        var currLeftPos = getPosAfterEmphasis(state, accents);
        if (insertedPos < currLeftPos) {
          insertedPos = currLeftPos;
        }
      }

      // get the position of the left open bracket closer to the cursor

      var _getBracketsPos = getBracketsPos(text, startOffset),
        leftPos = _getBracketsPos.leftPos,
        rightPos = _getBracketsPos.rightPos;
      // this position is between brackets

      if (leftPos !== false && rightPos !== false && leftPos > insertedPos) {
        insertedPos = leftPos;
      }

      // found left emphasis or left bracket
      if (insertedPos > -1) {
        // get the position of the left space closer to the cursor
        var spacePos = text.substring(insertedPos, startOffset).lastIndexOf(' ');
        if (spacePos === -1) {
          // space not found
          return insertText({
            state: state,
            insertedText: insertedText,
            insertedPos: insertedPos,
            endOffset: endOffset
          });
        }
      }
      if (text.length === endOffset && text[text.length - 1] !== ' ') {
        insertedText = ' ' + insertedText;
        insertedPos = text.length;
      } else {
        insertedPos = text.substring(0, startOffset).lastIndexOf(' ') + 1;
      }
      return insertText({
        state: state,
        insertedText: insertedText,
        insertedPos: insertedPos,
        endOffset: endOffset
      });
    };
    var copySelection = exports.copySelection = function copySelection(state) {
      var _state$selection3 = state.selection,
        anchorKey = _state$selection3.anchorKey,
        anchorOffset = _state$selection3.anchorOffset,
        focusKey = _state$selection3.focusKey,
        focusOffset = _state$selection3.focusOffset,
        isBackward = _state$selection3.isBackward;
      return {
        anchorKey: anchorKey,
        anchorOffset: anchorOffset,
        focusKey: focusKey,
        focusOffset: focusOffset,
        isBackward: isBackward
      };
    };
    var setSelectionToState = exports.setSelectionToState = function setSelectionToState(state, selectBackup) {
      var isFocused = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var change = state.change();
      change.select(_extends({}, selectBackup, {
        isFocused: isFocused
      }));
      return change.state;
    };

    /***/
  }), ( /* 166 */
  /***/function (module, exports, __webpack_require__) {
    module.exports = {
      "default": __webpack_require__(288),
      __esModule: true
    };

    /***/
  }), ( /* 167 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    var _iterator = __webpack_require__(284);
    var _iterator2 = _interopRequireDefault(_iterator);
    var _symbol = __webpack_require__(283);
    var _symbol2 = _interopRequireDefault(_symbol);
    var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj;
    };
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof(obj);
    } : function (obj) {
      return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
    };

    /***/
  }), ( /* 168 */
  /***/function (module, exports, __webpack_require__) {
    var isObject = __webpack_require__(47);
    var document = __webpack_require__(29).document;
    // typeof document.createElement is 'object' in old IE
    var is = isObject(document) && isObject(document.createElement);
    module.exports = function (it) {
      return is ? document.createElement(it) : {};
    };

    /***/
  }), ( /* 169 */
  /***/function (module, exports, __webpack_require__) {
    module.exports = !__webpack_require__(27) && !__webpack_require__(60)(function () {
      return Object.defineProperty(__webpack_require__(168)('div'), 'a', {
        get: function get() {
          return 7;
        }
      }).a != 7;
    });

    /***/
  }), ( /* 170 */
  /***/function (module, exports, __webpack_require__) {
    // fallback for non-array-like ES3 and non-enumerable old V8 strings
    var cof = __webpack_require__(108);
    // eslint-disable-next-line no-prototype-builtins
    module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
      return cof(it) == 'String' ? it.split('') : Object(it);
    };

    /***/
  }), ( /* 171 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var LIBRARY = __webpack_require__(81);
    var $export = __webpack_require__(28);
    var redefine = __webpack_require__(176);
    var hide = __webpack_require__(46);
    var Iterators = __webpack_require__(61);
    var $iterCreate = __webpack_require__(303);
    var setToStringTag = __webpack_require__(114);
    var getPrototypeOf = __webpack_require__(310);
    var ITERATOR = __webpack_require__(21)('iterator');
    var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
    var FF_ITERATOR = '@@iterator';
    var KEYS = 'keys';
    var VALUES = 'values';
    var returnThis = function returnThis() {
      return this;
    };
    module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
      $iterCreate(Constructor, NAME, next);
      var getMethod = function getMethod(kind) {
        if (!BUGGY && kind in proto) return proto[kind];
        switch (kind) {
          case KEYS:
            return function keys() {
              return new Constructor(this, kind);
            };
          case VALUES:
            return function values() {
              return new Constructor(this, kind);
            };
        }
        return function entries() {
          return new Constructor(this, kind);
        };
      };
      var TAG = NAME + ' Iterator';
      var DEF_VALUES = DEFAULT == VALUES;
      var VALUES_BUG = false;
      var proto = Base.prototype;
      var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
      var $default = $native || getMethod(DEFAULT);
      var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
      var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
      var methods, key, IteratorPrototype;
      // Fix native
      if ($anyNative) {
        IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
          // Set @@toStringTag to native iterators
          setToStringTag(IteratorPrototype, TAG, true);
          // fix for some old engines
          if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
        }
      }
      // fix Array#{values, @@iterator}.name in V8 / FF
      if (DEF_VALUES && $native && $native.name !== VALUES) {
        VALUES_BUG = true;
        $default = function values() {
          return $native.call(this);
        };
      }
      // Define iterator
      if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
        hide(proto, ITERATOR, $default);
      }
      // Plug for library
      Iterators[NAME] = $default;
      Iterators[TAG] = returnThis;
      if (DEFAULT) {
        methods = {
          values: DEF_VALUES ? $default : getMethod(VALUES),
          keys: IS_SET ? $default : getMethod(KEYS),
          entries: $entries
        };
        if (FORCED) for (key in methods) {
          if (!(key in proto)) redefine(proto, key, methods[key]);
        } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
      }
      return methods;
    };

    /***/
  }), ( /* 172 */
  /***/function (module, exports, __webpack_require__) {
    var pIE = __webpack_require__(63);
    var createDesc = __webpack_require__(64);
    var toIObject = __webpack_require__(35);
    var toPrimitive = __webpack_require__(118);
    var has = __webpack_require__(33);
    var IE8_DOM_DEFINE = __webpack_require__(169);
    var gOPD = Object.getOwnPropertyDescriptor;
    exports.f = __webpack_require__(27) ? gOPD : function getOwnPropertyDescriptor(O, P) {
      O = toIObject(O);
      P = toPrimitive(P, true);
      if (IE8_DOM_DEFINE) try {
        return gOPD(O, P);
      } catch (e) {/* empty */}
      if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
    };

    /***/
  }), ( /* 173 */
  /***/function (module, exports, __webpack_require__) {
    // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
    var $keys = __webpack_require__(174);
    var hiddenKeys = __webpack_require__(111).concat('length', 'prototype');
    exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
      return $keys(O, hiddenKeys);
    };

    /***/
  }), ( /* 174 */
  /***/function (module, exports, __webpack_require__) {
    var has = __webpack_require__(33);
    var toIObject = __webpack_require__(35);
    var arrayIndexOf = __webpack_require__(295)(false);
    var IE_PROTO = __webpack_require__(115)('IE_PROTO');
    module.exports = function (object, names) {
      var O = toIObject(object);
      var i = 0;
      var result = [];
      var key;
      for (key in O) {
        if (key != IE_PROTO) has(O, key) && result.push(key);
      }
      // Don't enum bug & hidden keys
      while (names.length > i) {
        if (has(O, key = names[i++])) {
          ~arrayIndexOf(result, key) || result.push(key);
        }
      }
      return result;
    };

    /***/
  }), ( /* 175 */
  /***/function (module, exports, __webpack_require__) {
    var DESCRIPTORS = __webpack_require__(27);
    var getKeys = __webpack_require__(62);
    var toIObject = __webpack_require__(35);
    var isEnum = __webpack_require__(63).f;
    module.exports = function (isEntries) {
      return function (it) {
        var O = toIObject(it);
        var keys = getKeys(O);
        var length = keys.length;
        var i = 0;
        var result = [];
        var key;
        while (length > i) {
          key = keys[i++];
          if (!DESCRIPTORS || isEnum.call(O, key)) {
            result.push(isEntries ? [key, O[key]] : O[key]);
          }
        }
        return result;
      };
    };

    /***/
  }), ( /* 176 */
  /***/function (module, exports, __webpack_require__) {
    module.exports = __webpack_require__(46);

    /***/
  }), ( /* 177 */
  /***/function (module, exports, __webpack_require__) {
    // 7.1.15 ToLength
    var toInteger = __webpack_require__(117);
    var min = Math.min;
    module.exports = function (it) {
      return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
    };

    /***/
  }), ( /* 178 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var $at = __webpack_require__(312)(true);

    // 21.1.3.27 String.prototype[@@iterator]()
    __webpack_require__(171)(String, 'String', function (iterated) {
      this._t = String(iterated); // target
      this._i = 0; // next index
      // 21.1.5.2.1 %StringIteratorPrototype%.next()
    }, function () {
      var O = this._t;
      var index = this._i;
      var point;
      if (index >= O.length) return {
        value: undefined,
        done: true
      };
      point = $at(O, index);
      this._i += point.length;
      return {
        value: point,
        done: false
      };
    });

    /***/
  }), ( /* 179 */
  /***/function (module, exports, __webpack_require__) {
    // false -> Array#indexOf
    // true  -> Array#includes
    var toIObject = __webpack_require__(87);
    var toLength = __webpack_require__(31);
    var toAbsoluteIndex = __webpack_require__(194);
    module.exports = function (IS_INCLUDES) {
      return function ($this, el, fromIndex) {
        var O = toIObject($this);
        var length = toLength(O.length);
        var index = toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while (length > index) {
          value = O[index++];
          // eslint-disable-next-line no-self-compare
          if (value != value) return true;
          // Array#indexOf ignores holes, Array#includes - not
        } else for (; length > index; index++) {
          if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
          }
        }
        return !IS_INCLUDES && -1;
      };
    };

    /***/
  }), ( /* 180 */
  /***/function (module, exports, __webpack_require__) {
    // 9.4.2.3 ArraySpeciesCreate(originalArray, length)
    var speciesConstructor = __webpack_require__(328);
    module.exports = function (original, length) {
      return new (speciesConstructor(original))(length);
    };

    /***/
  }), ( /* 181 */
  /***/function (module, exports) {
    // IE 8- don't enum bug keys
    module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

    /***/
  }), ( /* 182 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
    var isArray = __webpack_require__(184);
    var isObject = __webpack_require__(38);
    var toLength = __webpack_require__(31);
    var ctx = __webpack_require__(66);
    var IS_CONCAT_SPREADABLE = __webpack_require__(3)('isConcatSpreadable');
    function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
      var targetIndex = start;
      var sourceIndex = 0;
      var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
      var element, spreadable;
      while (sourceIndex < sourceLen) {
        if (sourceIndex in source) {
          element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
          spreadable = false;
          if (isObject(element)) {
            spreadable = element[IS_CONCAT_SPREADABLE];
            spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
          }
          if (spreadable && depth > 0) {
            targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
          } else {
            if (targetIndex >= 0x1fffffffffffff) throw TypeError();
            target[targetIndex] = element;
          }
          targetIndex++;
        }
        sourceIndex++;
      }
      return targetIndex;
    }
    module.exports = flattenIntoArray;

    /***/
  }), ( /* 183 */
  /***/function (module, exports, __webpack_require__) {
    var document = __webpack_require__(19).document;
    module.exports = document && document.documentElement;

    /***/
  }), ( /* 184 */
  /***/function (module, exports, __webpack_require__) {
    // 7.2.2 IsArray(argument)
    var cof = __webpack_require__(49);
    module.exports = Array.isArray || function isArray(arg) {
      return cof(arg) == 'Array';
    };

    /***/
  }), ( /* 185 */
  /***/function (module, exports, __webpack_require__) {
    // 7.2.8 IsRegExp(argument)
    var isObject = __webpack_require__(38);
    var cof = __webpack_require__(49);
    var MATCH = __webpack_require__(3)('match');
    module.exports = function (it) {
      var isRegExp;
      return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
    };

    /***/
  }), ( /* 186 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var LIBRARY = __webpack_require__(187);
    var $export = __webpack_require__(6);
    var redefine = __webpack_require__(50);
    var hide = __webpack_require__(37);
    var has = __webpack_require__(69);
    var Iterators = __webpack_require__(70);
    var $iterCreate = __webpack_require__(335);
    var setToStringTag = __webpack_require__(125);
    var getPrototypeOf = __webpack_require__(341);
    var ITERATOR = __webpack_require__(3)('iterator');
    var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
    var FF_ITERATOR = '@@iterator';
    var KEYS = 'keys';
    var VALUES = 'values';
    var returnThis = function returnThis() {
      return this;
    };
    module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
      $iterCreate(Constructor, NAME, next);
      var getMethod = function getMethod(kind) {
        if (!BUGGY && kind in proto) return proto[kind];
        switch (kind) {
          case KEYS:
            return function keys() {
              return new Constructor(this, kind);
            };
          case VALUES:
            return function values() {
              return new Constructor(this, kind);
            };
        }
        return function entries() {
          return new Constructor(this, kind);
        };
      };
      var TAG = NAME + ' Iterator';
      var DEF_VALUES = DEFAULT == VALUES;
      var VALUES_BUG = false;
      var proto = Base.prototype;
      var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
      var $default = $native || getMethod(DEFAULT);
      var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
      var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
      var methods, key, IteratorPrototype;
      // Fix native
      if ($anyNative) {
        IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
          // Set @@toStringTag to native iterators
          setToStringTag(IteratorPrototype, TAG, true);
          // fix for some old engines
          if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
        }
      }
      // fix Array#{values, @@iterator}.name in V8 / FF
      if (DEF_VALUES && $native && $native.name !== VALUES) {
        VALUES_BUG = true;
        $default = function values() {
          return $native.call(this);
        };
      }
      // Define iterator
      if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
        hide(proto, ITERATOR, $default);
      }
      // Plug for library
      Iterators[NAME] = $default;
      Iterators[TAG] = returnThis;
      if (DEFAULT) {
        methods = {
          values: DEF_VALUES ? $default : getMethod(VALUES),
          keys: IS_SET ? $default : getMethod(KEYS),
          entries: $entries
        };
        if (FORCED) for (key in methods) {
          if (!(key in proto)) redefine(proto, key, methods[key]);
        } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
      }
      return methods;
    };

    /***/
  }), ( /* 187 */
  /***/function (module, exports) {
    module.exports = false;

    /***/
  }), ( /* 188 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // 25.4.1.5 NewPromiseCapability(C)
    var aFunction = __webpack_require__(65);
    function PromiseCapability(C) {
      var resolve, reject;
      this.promise = new C(function ($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
        resolve = $$resolve;
        reject = $$reject;
      });
      this.resolve = aFunction(resolve);
      this.reject = aFunction(reject);
    }
    module.exports.f = function (C) {
      return new PromiseCapability(C);
    };

    /***/
  }), ( /* 189 */
  /***/function (module, exports, __webpack_require__) {
    // 19.1.2.14 / 15.2.3.14 Object.keys(O)
    var $keys = __webpack_require__(342);
    var enumBugKeys = __webpack_require__(181);
    module.exports = Object.keys || function keys(O) {
      return $keys(O, enumBugKeys);
    };

    /***/
  }), ( /* 190 */
  /***/function (module, exports) {
    module.exports = function (bitmap, value) {
      return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
      };
    };

    /***/
  }), ( /* 191 */
  /***/function (module, exports, __webpack_require__) {
    var global = __webpack_require__(19);
    var SHARED = '__core-js_shared__';
    var store = global[SHARED] || (global[SHARED] = {});
    module.exports = function (key) {
      return store[key] || (store[key] = {});
    };

    /***/
  }), ( /* 192 */
  /***/function (module, exports, __webpack_require__) {
    var toInteger = __webpack_require__(71);
    var defined = __webpack_require__(30);
    // true  -> String#at
    // false -> String#codePointAt
    module.exports = function (TO_STRING) {
      return function (that, pos) {
        var s = String(defined(that));
        var i = toInteger(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
      };
    };

    /***/
  }), ( /* 193 */
  /***/function (module, exports, __webpack_require__) {
    var ctx = __webpack_require__(66);
    var invoke = __webpack_require__(331);
    var html = __webpack_require__(183);
    var cel = __webpack_require__(123);
    var global = __webpack_require__(19);
    var process = global.process;
    var setTask = global.setImmediate;
    var clearTask = global.clearImmediate;
    var MessageChannel = global.MessageChannel;
    var Dispatch = global.Dispatch;
    var counter = 0;
    var queue = {};
    var ONREADYSTATECHANGE = 'onreadystatechange';
    var defer, channel, port;
    var run = function run() {
      var id = +this;
      // eslint-disable-next-line no-prototype-builtins
      if (queue.hasOwnProperty(id)) {
        var fn = queue[id];
        delete queue[id];
        fn();
      }
    };
    var listener = function listener(event) {
      run.call(event.data);
    };
    // Node.js 0.9+ & IE10+ has setImmediate, otherwise:
    if (!setTask || !clearTask) {
      setTask = function setImmediate(fn) {
        var args = [];
        var i = 1;
        while (arguments.length > i) {
          args.push(arguments[i++]);
        }
        queue[++counter] = function () {
          // eslint-disable-next-line no-new-func
          invoke(typeof fn == 'function' ? fn : Function(fn), args);
        };
        defer(counter);
        return counter;
      };
      clearTask = function clearImmediate(id) {
        delete queue[id];
      };
      // Node.js 0.8-
      if (__webpack_require__(49)(process) == 'process') {
        defer = function defer(id) {
          process.nextTick(ctx(run, id, 1));
        };
        // Sphere (JS game engine) Dispatch API
      } else if (Dispatch && Dispatch.now) {
        defer = function defer(id) {
          Dispatch.now(ctx(run, id, 1));
        };
        // Browsers with MessageChannel, includes WebWorkers
      } else if (MessageChannel) {
        channel = new MessageChannel();
        port = channel.port2;
        channel.port1.onmessage = listener;
        defer = ctx(port.postMessage, port, 1);
        // Browsers with postMessage, skip WebWorkers
        // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
      } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
        defer = function defer(id) {
          global.postMessage(id + '', '*');
        };
        global.addEventListener('message', listener, false);
        // IE8-
      } else if (ONREADYSTATECHANGE in cel('script')) {
        defer = function defer(id) {
          html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
            html.removeChild(this);
            run.call(id);
          };
        };
        // Rest old browsers
      } else {
        defer = function defer(id) {
          setTimeout(ctx(run, id, 1), 0);
        };
      }
    }
    module.exports = {
      set: setTask,
      clear: clearTask
    };

    /***/
  }), ( /* 194 */
  /***/function (module, exports, __webpack_require__) {
    var toInteger = __webpack_require__(71);
    var max = Math.max;
    var min = Math.min;
    module.exports = function (index, length) {
      index = toInteger(index);
      return index < 0 ? max(index + length, 0) : min(index, length);
    };

    /***/
  }), ( /* 195 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var $at = __webpack_require__(192)(true);

    // 21.1.3.27 String.prototype[@@iterator]()
    __webpack_require__(186)(String, 'String', function (iterated) {
      this._t = String(iterated); // target
      this._i = 0; // next index
      // 21.1.5.2.1 %StringIteratorPrototype%.next()
    }, function () {
      var O = this._t;
      var index = this._i;
      var point;
      if (index >= O.length) return {
        value: undefined,
        done: true
      };
      point = $at(O, index);
      this._i += point.length;
      return {
        value: point,
        done: false
      };
    });

    /***/
  }), ( /* 196 */
  /***/function (module, exports) {
    /*
    	MIT License http://www.opensource.org/licenses/mit-license.php
    	Author Tobias Koppers @sokra
    */
    // css base code, injected by the css-loader
    module.exports = function () {
      var list = [];

      // return the list of modules as css string
      list.toString = function toString() {
        var result = [];
        for (var i = 0; i < this.length; i++) {
          var item = this[i];
          if (item[2]) {
            result.push("@media " + item[2] + "{" + item[1] + "}");
          } else {
            result.push(item[1]);
          }
        }
        return result.join("");
      };

      // import a list of modules into the list
      list.i = function (modules, mediaQuery) {
        if (typeof modules === "string") modules = [[null, modules, ""]];
        var alreadyImportedModules = {};
        for (var i = 0; i < this.length; i++) {
          var id = this[i][0];
          if (typeof id === "number") alreadyImportedModules[id] = true;
        }
        for (i = 0; i < modules.length; i++) {
          var item = modules[i];
          // skip already imported module
          // this implementation is not 100% perfect for weird media query combinations
          //  when a module is imported multiple times with different media queries.
          //  I hope this will never occur (Hey this way we have smaller bundles)
          if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
            if (mediaQuery && !item[2]) {
              item[2] = mediaQuery;
            } else if (mediaQuery) {
              item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
            }
            list.push(item);
          }
        }
      };
      return list;
    };

    /***/
  }), ( /* 197 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var _interopRequireDefault = __webpack_require__(5);
    exports.__esModule = true;
    exports.default = void 0;
    var _inDOM = _interopRequireDefault(__webpack_require__(90));
    var on = function on() {};
    if (_inDOM.default) {
      on = function () {
        if (document.addEventListener) return function (node, eventName, handler, capture) {
          return node.addEventListener(eventName, handler, capture || false);
        };else if (document.attachEvent) return function (node, eventName, handler) {
          return node.attachEvent('on' + eventName, function (e) {
            e = e || window.event;
            e.target = e.target || e.srcElement;
            e.currentTarget = node;
            handler.call(node, e);
          });
        };
      }();
    }
    var _default = on;
    exports.default = _default;
    module.exports = exports["default"];

    /***/
  }), ( /* 198 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var _interopRequireDefault = __webpack_require__(5);
    exports.__esModule = true;
    exports.default = offset;
    var _contains = _interopRequireDefault(__webpack_require__(89));
    var _isWindow = _interopRequireDefault(__webpack_require__(130));
    var _ownerDocument = _interopRequireDefault(__webpack_require__(88));
    function offset(node) {
      var doc = (0, _ownerDocument.default)(node),
        win = (0, _isWindow.default)(doc),
        docElem = doc && doc.documentElement,
        box = {
          top: 0,
          left: 0,
          height: 0,
          width: 0
        };
      if (!doc) return; // Make sure it's not a disconnected DOM node

      if (!(0, _contains.default)(docElem, node)) return box;
      if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect(); // IE8 getBoundingClientRect doesn't support width & height

      box = {
        top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
        left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
        width: (box.width == null ? node.offsetWidth : box.width) || 0,
        height: (box.height == null ? node.offsetHeight : box.height) || 0
      };
      return box;
    }
    module.exports = exports["default"];

    /***/
  }), ( /* 199 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var _interopRequireDefault = __webpack_require__(5);
    exports.__esModule = true;
    exports.default = scrollTop;
    var _isWindow = _interopRequireDefault(__webpack_require__(130));
    function scrollTop(node, val) {
      var win = (0, _isWindow.default)(node);
      if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
      if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
    }
    module.exports = exports["default"];

    /***/
  }), ( /* 200 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var _interopRequireDefault = __webpack_require__(5);
    exports.__esModule = true;
    exports.default = style;
    var _camelizeStyle = _interopRequireDefault(__webpack_require__(202));
    var _hyphenateStyle = _interopRequireDefault(__webpack_require__(401));
    var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(396));
    var _removeStyle = _interopRequireDefault(__webpack_require__(397));
    var _properties = __webpack_require__(201);
    var _isTransform = _interopRequireDefault(__webpack_require__(398));
    function style(node, property, value) {
      var css = '';
      var transforms = '';
      var props = property;
      if (typeof property === 'string') {
        if (value === undefined) {
          return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
        } else {
          (props = {})[property] = value;
        }
      }
      Object.keys(props).forEach(function (key) {
        var value = props[key];
        if (!value && value !== 0) {
          (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
        } else if ((0, _isTransform.default)(key)) {
          transforms += key + "(" + value + ") ";
        } else {
          css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
        }
      });
      if (transforms) {
        css += _properties.transform + ": " + transforms + ";";
      }
      node.style.cssText += ';' + css;
    }
    module.exports = exports["default"];

    /***/
  }), ( /* 201 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var _interopRequireDefault = __webpack_require__(5);
    exports.__esModule = true;
    exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;
    var _inDOM = _interopRequireDefault(__webpack_require__(90));
    var transform = 'transform';
    exports.transform = transform;
    var prefix, transitionEnd, animationEnd;
    exports.animationEnd = animationEnd;
    exports.transitionEnd = transitionEnd;
    var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
    exports.transitionDelay = transitionDelay;
    exports.transitionTiming = transitionTiming;
    exports.transitionDuration = transitionDuration;
    exports.transitionProperty = transitionProperty;
    var animationName, animationDuration, animationTiming, animationDelay;
    exports.animationDelay = animationDelay;
    exports.animationTiming = animationTiming;
    exports.animationDuration = animationDuration;
    exports.animationName = animationName;
    if (_inDOM.default) {
      var _getTransitionPropert = getTransitionProperties();
      prefix = _getTransitionPropert.prefix;
      exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
      exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
      exports.transform = transform = prefix + "-" + transform;
      exports.transitionProperty = transitionProperty = prefix + "-transition-property";
      exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
      exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
      exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
      exports.animationName = animationName = prefix + "-animation-name";
      exports.animationDuration = animationDuration = prefix + "-animation-duration";
      exports.animationTiming = animationTiming = prefix + "-animation-delay";
      exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
    }
    var _default = {
      transform: transform,
      end: transitionEnd,
      property: transitionProperty,
      timing: transitionTiming,
      delay: transitionDelay,
      duration: transitionDuration
    };
    exports.default = _default;
    function getTransitionProperties() {
      var style = document.createElement('div').style;
      var vendorMap = {
        O: function O(e) {
          return "o" + e.toLowerCase();
        },
        Moz: function Moz(e) {
          return e.toLowerCase();
        },
        Webkit: function Webkit(e) {
          return "webkit" + e;
        },
        ms: function ms(e) {
          return "MS" + e;
        }
      };
      var vendors = Object.keys(vendorMap);
      var transitionEnd, animationEnd;
      var prefix = '';
      for (var i = 0; i < vendors.length; i++) {
        var vendor = vendors[i];
        if (vendor + "TransitionProperty" in style) {
          prefix = "-" + vendor.toLowerCase();
          transitionEnd = vendorMap[vendor]('TransitionEnd');
          animationEnd = vendorMap[vendor]('AnimationEnd');
          break;
        }
      }
      if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
      if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
      style = null;
      return {
        animationEnd: animationEnd,
        transitionEnd: transitionEnd,
        prefix: prefix
      };
    }

    /***/
  }), ( /* 202 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var _interopRequireDefault = __webpack_require__(5);
    exports.__esModule = true;
    exports.default = camelizeStyleName;
    var _camelize = _interopRequireDefault(__webpack_require__(399));

    /**
     * Copyright 2014-2015, Facebook, Inc.
     * All rights reserved.
     * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
     */
    var msPattern = /^-ms-/;
    function camelizeStyleName(string) {
      return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
    }
    module.exports = exports["default"];

    /***/
  }), ( /* 203 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Inspired by Google Closure:
    // http://closure-library.googlecode.com/svn/docs/
    // closure_goog_array_array.js.html#goog.array.clear
    var value = __webpack_require__(23);
    module.exports = function () {
      value(this).length = 0;
      return this;
    };

    /***/
  }), ( /* 204 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // eslint-disable-next-line no-empty-function
    module.exports = function () {};

    /***/
  }), ( /* 205 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var toInteger = __webpack_require__(414),
      max = Math.max;
    module.exports = function (value) {
      return max(0, toInteger(value));
    };

    /***/
  }), ( /* 206 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var isValue = __webpack_require__(51);
    var forEach = Array.prototype.forEach,
      create = Object.create;
    var process = function process(src, obj) {
      var key;
      for (key in src) {
        obj[key] = src[key];
      }
    };

    // eslint-disable-next-line no-unused-vars
    module.exports = function (opts1 /*, …options*/) {
      var result = create(null);
      forEach.call(arguments, function (options) {
        if (!isValue(options)) return;
        process(Object(options), result);
      });
      return result;
    };

    /***/
  }), ( /* 207 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var create = Object.create,
      getPrototypeOf = Object.getPrototypeOf,
      plainObject = {};
    module.exports = function /* CustomCreate*/
    () {
      var setPrototypeOf = Object.setPrototypeOf,
        customCreate = arguments[0] || create;
      if (typeof setPrototypeOf !== "function") return false;
      return getPrototypeOf(setPrototypeOf(customCreate(null), plainObject)) === plainObject;
    };

    /***/
  }), ( /* 208 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    /* eslint no-proto: "off" */

    // Big thanks to @WebReflection for sorting this out
    // https://gist.github.com/WebReflection/5593554
    var isObject = __webpack_require__(421),
      value = __webpack_require__(23),
      objIsPrototypeOf = Object.prototype.isPrototypeOf,
      defineProperty = Object.defineProperty,
      nullDesc = {
        configurable: true,
        enumerable: false,
        writable: true,
        value: undefined
      },
      validate;
    validate = function validate(obj, prototype) {
      value(obj);
      if (prototype === null || isObject(prototype)) return obj;
      throw new TypeError("Prototype must be null or an object");
    };
    module.exports = function (status) {
      var fn, set;
      if (!status) return null;
      if (status.level === 2) {
        if (status.set) {
          set = status.set;
          fn = function fn(obj, prototype) {
            set.call(validate(obj, prototype), prototype);
            return obj;
          };
        } else {
          fn = function fn(obj, prototype) {
            validate(obj, prototype).__proto__ = prototype;
            return obj;
          };
        }
      } else {
        fn = function self(obj, prototype) {
          var isNullBase;
          validate(obj, prototype);
          isNullBase = objIsPrototypeOf.call(self.nullPolyfill, obj);
          if (isNullBase) delete self.nullPolyfill.__proto__;
          if (prototype === null) prototype = self.nullPolyfill;
          obj.__proto__ = prototype;
          if (isNullBase) defineProperty(self.nullPolyfill, "__proto__", nullDesc);
          return obj;
        };
      }
      return Object.defineProperty(fn, "level", {
        configurable: false,
        enumerable: false,
        writable: false,
        value: status.level
      });
    }(function () {
      var tmpObj1 = Object.create(null),
        tmpObj2 = {},
        set,
        desc = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__");
      if (desc) {
        try {
          set = desc.set; // Opera crashes at this point
          set.call(tmpObj1, tmpObj2);
        } catch (ignore) {}
        if (Object.getPrototypeOf(tmpObj1) === tmpObj2) return {
          set: set,
          level: 2
        };
      }
      tmpObj1.__proto__ = tmpObj2;
      if (Object.getPrototypeOf(tmpObj1) === tmpObj2) return {
        level: 2
      };
      tmpObj1 = {};
      tmpObj1.__proto__ = tmpObj2;
      if (Object.getPrototypeOf(tmpObj1) === tmpObj2) return {
        level: 1
      };
      return false;
    }());
    __webpack_require__(419);

    /***/
  }), ( /* 209 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    module.exports = __webpack_require__(427)() ? String.prototype.contains : __webpack_require__(428);

    /***/
  }), ( /* 210 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var isIterable = __webpack_require__(432);
    module.exports = function (value) {
      if (!isIterable(value)) throw new TypeError(value + " is not iterable");
      return value;
    };

    /***/
  }), ( /* 211 */
  /***/function (module, exports) {
    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }
    module.exports = isObjectLike;

    /***/
  }), ( /* 212 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // HTML5 entities map: { name -> utf16string }
    //

    /*eslint quotes:0*/
    module.exports = __webpack_require__(402);

    /***/
  }), ( /* 213 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Regexps to match html elements
    var attr_name = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
    var unquoted = '[^"\'=<>`\\x00-\\x20]+';
    var single_quoted = "'[^']*'";
    var double_quoted = '"[^"]*"';
    var attr_value = '(?:' + unquoted + '|' + single_quoted + '|' + double_quoted + ')';
    var attribute = '(?:\\s+' + attr_name + '(?:\\s*=\\s*' + attr_value + ')?)';
    var open_tag = '<[A-Za-z][A-Za-z0-9\\-]*' + attribute + '*\\s*\\/?>';
    var close_tag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
    var comment = '<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->';
    var processing = '<[?].*?[?]>';
    var declaration = '<![A-Z]+\\s+[^>]*>';
    var cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';
    var HTML_TAG_RE = new RegExp('^(?:' + open_tag + '|' + close_tag + '|' + comment + '|' + processing + '|' + declaration + '|' + cdata + ')');
    var HTML_OPEN_CLOSE_TAG_RE = new RegExp('^(?:' + open_tag + '|' + close_tag + ')');
    module.exports.HTML_TAG_RE = HTML_TAG_RE;
    module.exports.HTML_OPEN_CLOSE_TAG_RE = HTML_OPEN_CLOSE_TAG_RE;

    /***/
  }), ( /* 214 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Process *this* and _that_
    //

    // Insert each marker as a separate text token, and add it to delimiter list
    //
    module.exports.tokenize = function emphasis(state, silent) {
      var i,
        scanned,
        token,
        start = state.pos,
        marker = state.src.charCodeAt(start);
      if (silent) {
        return false;
      }
      if (marker !== 0x5F /* _ */ && marker !== 0x2A /* * */) {
        return false;
      }
      scanned = state.scanDelims(state.pos, marker === 0x2A);
      for (i = 0; i < scanned.length; i++) {
        token = state.push('text', '', 0);
        token.content = String.fromCharCode(marker);
        state.delimiters.push({
          // Char code of the starting marker (number).
          //
          marker: marker,
          // Total length of these series of delimiters.
          //
          length: scanned.length,
          // An amount of characters before this one that's equivalent to
          // current one. In plain English: if this delimiter does not open
          // an emphasis, neither do previous `jump` characters.
          //
          // Used to skip sequences like "*****" in one step, for 1st asterisk
          // value will be 0, for 2nd it's 1 and so on.
          //
          jump: i,
          // A position of the token this delimiter corresponds to.
          //
          token: state.tokens.length - 1,
          // Token level.
          //
          level: state.level,
          // If this delimiter is matched as a valid opener, `end` will be
          // equal to its position, otherwise it's `-1`.
          //
          end: -1,
          // Boolean flags that determine if this delimiter could open or close
          // an emphasis.
          //
          open: scanned.can_open,
          close: scanned.can_close
        });
      }
      state.pos += scanned.length;
      return true;
    };

    // Walk through delimiter list and replace text tokens with tags
    //
    module.exports.postProcess = function emphasis(state) {
      var i,
        startDelim,
        endDelim,
        token,
        ch,
        isStrong,
        delimiters = state.delimiters,
        max = state.delimiters.length;
      for (i = max - 1; i >= 0; i--) {
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x5F /* _ */ && startDelim.marker !== 0x2A /* * */) {
          continue;
        }

        // Process only opening markers
        if (startDelim.end === -1) {
          continue;
        }
        endDelim = delimiters[startDelim.end];

        // If the previous delimiter has the same marker and is adjacent to this one,
        // merge those into one strong delimiter.
        //
        // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
        //
        isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 && delimiters[i - 1].token === startDelim.token - 1 && delimiters[startDelim.end + 1].token === endDelim.token + 1 && delimiters[i - 1].marker === startDelim.marker;
        ch = String.fromCharCode(startDelim.marker);
        token = state.tokens[startDelim.token];
        token.type = isStrong ? 'strong_open' : 'em_open';
        token.tag = isStrong ? 'strong' : 'em';
        token.nesting = 1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = '';
        token = state.tokens[endDelim.token];
        token.type = isStrong ? 'strong_close' : 'em_close';
        token.tag = isStrong ? 'strong' : 'em';
        token.nesting = -1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = '';
        if (isStrong) {
          state.tokens[delimiters[i - 1].token].content = '';
          state.tokens[delimiters[startDelim.end + 1].token].content = '';
          i--;
        }
      }
    };

    /***/
  }), ( /* 215 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // ~~strike through~~
    //

    // Insert each marker as a separate text token, and add it to delimiter list
    //
    module.exports.tokenize = function strikethrough(state, silent) {
      var i,
        scanned,
        token,
        len,
        ch,
        start = state.pos,
        marker = state.src.charCodeAt(start);
      if (silent) {
        return false;
      }
      if (marker !== 0x7E /* ~ */) {
        return false;
      }
      scanned = state.scanDelims(state.pos, true);
      len = scanned.length;
      ch = String.fromCharCode(marker);
      if (len < 2) {
        return false;
      }
      if (len % 2) {
        token = state.push('text', '', 0);
        token.content = ch;
        len--;
      }
      for (i = 0; i < len; i += 2) {
        token = state.push('text', '', 0);
        token.content = ch + ch;
        state.delimiters.push({
          marker: marker,
          jump: i,
          token: state.tokens.length - 1,
          level: state.level,
          end: -1,
          open: scanned.can_open,
          close: scanned.can_close
        });
      }
      state.pos += scanned.length;
      return true;
    };

    // Walk through delimiter list and replace text tokens with tags
    //
    module.exports.postProcess = function strikethrough(state) {
      var i,
        j,
        startDelim,
        endDelim,
        token,
        loneMarkers = [],
        delimiters = state.delimiters,
        max = state.delimiters.length;
      for (i = 0; i < max; i++) {
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x7E /* ~ */) {
          continue;
        }
        if (startDelim.end === -1) {
          continue;
        }
        endDelim = delimiters[startDelim.end];
        token = state.tokens[startDelim.token];
        token.type = 's_open';
        token.tag = 's';
        token.nesting = 1;
        token.markup = '~~';
        token.content = '';
        token = state.tokens[endDelim.token];
        token.type = 's_close';
        token.tag = 's';
        token.nesting = -1;
        token.markup = '~~';
        token.content = '';
        if (state.tokens[endDelim.token - 1].type === 'text' && state.tokens[endDelim.token - 1].content === '~') {
          loneMarkers.push(endDelim.token - 1);
        }
      }

      // If a marker sequence has an odd number of characters, it's splitted
      // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
      // start of the sequence.
      //
      // So, we have to move all those markers after subsequent s_close tags.
      //
      while (loneMarkers.length) {
        i = loneMarkers.pop();
        j = i + 1;
        while (j < state.tokens.length && state.tokens[j].type === 's_close') {
          j++;
        }
        j--;
        if (i !== j) {
          token = state.tokens[j];
          state.tokens[j] = state.tokens[i];
          state.tokens[i] = token;
        }
      }
    };

    /***/
  }), ( /* 216 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    module.exports.encode = __webpack_require__(515);
    module.exports.decode = __webpack_require__(514);
    module.exports.format = __webpack_require__(516);
    module.exports.parse = __webpack_require__(517);

    /***/
  }), ( /* 217 */
  /***/function (module, exports) {
    // shim for using process in browser
    var process = module.exports = {};

    // cached from whatever global is present so that test runners that stub it
    // don't break things.  But we need to wrap it in a try catch in case it is
    // wrapped in strict mode code which doesn't define any globals.  It's inside a
    // function because try/catches deoptimize in certain engines.

    var cachedSetTimeout;
    var cachedClearTimeout;
    function defaultSetTimout() {
      throw new Error('setTimeout has not been defined');
    }
    function defaultClearTimeout() {
      throw new Error('clearTimeout has not been defined');
    }
    (function () {
      try {
        if (typeof setTimeout === 'function') {
          cachedSetTimeout = setTimeout;
        } else {
          cachedSetTimeout = defaultSetTimout;
        }
      } catch (e) {
        cachedSetTimeout = defaultSetTimout;
      }
      try {
        if (typeof clearTimeout === 'function') {
          cachedClearTimeout = clearTimeout;
        } else {
          cachedClearTimeout = defaultClearTimeout;
        }
      } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
      }
    })();
    function runTimeout(fun) {
      if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
      }
      // if setTimeout wasn't available but was latter defined
      if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
      }
      try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
      } catch (e) {
        try {
          // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
          return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
          // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
          return cachedSetTimeout.call(this, fun, 0);
        }
      }
    }
    function runClearTimeout(marker) {
      if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
      }
      // if clearTimeout wasn't available but was latter defined
      if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
      }
      try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
      } catch (e) {
        try {
          // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
          return cachedClearTimeout.call(null, marker);
        } catch (e) {
          // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
          // Some versions of I.E. have different rules for clearTimeout vs setTimeout
          return cachedClearTimeout.call(this, marker);
        }
      }
    }
    var queue = [];
    var draining = false;
    var currentQueue;
    var queueIndex = -1;
    function cleanUpNextTick() {
      if (!draining || !currentQueue) {
        return;
      }
      draining = false;
      if (currentQueue.length) {
        queue = currentQueue.concat(queue);
      } else {
        queueIndex = -1;
      }
      if (queue.length) {
        drainQueue();
      }
    }
    function drainQueue() {
      if (draining) {
        return;
      }
      var timeout = runTimeout(cleanUpNextTick);
      draining = true;
      var len = queue.length;
      while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
          if (currentQueue) {
            currentQueue[queueIndex].run();
          }
        }
        queueIndex = -1;
        len = queue.length;
      }
      currentQueue = null;
      draining = false;
      runClearTimeout(timeout);
    }
    process.nextTick = function (fun) {
      var args = new Array(arguments.length - 1);
      if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
          args[i - 1] = arguments[i];
        }
      }
      queue.push(new Item(fun, args));
      if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
      }
    };

    // v8 likes predictible objects
    function Item(fun, array) {
      this.fun = fun;
      this.array = array;
    }
    Item.prototype.run = function () {
      this.fun.apply(null, this.array);
    };
    process.title = 'browser';
    process.browser = true;
    process.env = {};
    process.argv = [];
    process.version = ''; // empty string to avoid regexp issues
    process.versions = {};
    function noop() {}
    process.on = noop;
    process.addListener = noop;
    process.once = noop;
    process.off = noop;
    process.removeListener = noop;
    process.removeAllListeners = noop;
    process.emit = noop;
    process.prependListener = noop;
    process.prependOnceListener = noop;
    process.listeners = function (name) {
      return [];
    };
    process.binding = function (name) {
      throw new Error('process.binding is not supported');
    };
    process.cwd = function () {
      return '/';
    };
    process.chdir = function (dir) {
      throw new Error('process.chdir is not supported');
    };
    process.umask = function () {
      return 0;
    };

    /***/
  }), ( /* 218 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isRequiredForA11y;
    function isRequiredForA11y(validator) {
      return function validate(props, propName, componentName, location, propFullName) {
        var componentNameSafe = componentName || '<<anonymous>>';
        var propFullNameSafe = propFullName || propName;
        if (props[propName] == null) {
          return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
        }
        for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
          args[_key - 5] = arguments[_key];
        }
        return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
      };
    }
    module.exports = exports['default'];

    /***/
  }), ( /* 219 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    var _values = __webpack_require__(282);
    var _values2 = _interopRequireDefault(_values);
    var _objectWithoutProperties2 = __webpack_require__(17);
    var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
    var _extends3 = __webpack_require__(7);
    var _extends4 = _interopRequireDefault(_extends3);
    var _classCallCheck2 = __webpack_require__(12);
    var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
    var _possibleConstructorReturn2 = __webpack_require__(14);
    var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
    var _inherits2 = __webpack_require__(13);
    var _inherits3 = _interopRequireDefault(_inherits2);
    var _classnames = __webpack_require__(24);
    var _classnames2 = _interopRequireDefault(_classnames);
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _propTypes = __webpack_require__(10);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _elementType = __webpack_require__(72);
    var _elementType2 = _interopRequireDefault(_elementType);
    var _bootstrapUtils = __webpack_require__(41);
    var _StyleConfig = __webpack_require__(220);
    var _SafeAnchor = __webpack_require__(140);
    var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        'default': obj
      };
    }
    var propTypes = {
      active: _propTypes2['default'].bool,
      disabled: _propTypes2['default'].bool,
      block: _propTypes2['default'].bool,
      onClick: _propTypes2['default'].func,
      componentClass: _elementType2['default'],
      href: _propTypes2['default'].string,
      /**
       * Defines HTML button type attribute
       * @defaultValue 'button'
       */
      type: _propTypes2['default'].oneOf(['button', 'reset', 'submit'])
    };
    var defaultProps = {
      active: false,
      block: false,
      disabled: false
    };
    var Button = function (_React$Component) {
      (0, _inherits3['default'])(Button, _React$Component);
      function Button() {
        (0, _classCallCheck3['default'])(this, Button);
        return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
      }
      Button.prototype.renderAnchor = function renderAnchor(elementProps, className) {
        return _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends4['default'])({}, elementProps, {
          className: (0, _classnames2['default'])(className, elementProps.disabled && 'disabled')
        }));
      };
      Button.prototype.renderButton = function renderButton(_ref, className) {
        var componentClass = _ref.componentClass,
          elementProps = (0, _objectWithoutProperties3['default'])(_ref, ['componentClass']);
        var Component = componentClass || 'button';
        return _react2['default'].createElement(Component, (0, _extends4['default'])({}, elementProps, {
          type: elementProps.type || 'button',
          className: className
        }));
      };
      Button.prototype.render = function render() {
        var _extends2;
        var _props = this.props,
          active = _props.active,
          block = _props.block,
          className = _props.className,
          props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'block', 'className']);
        var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
          bsProps = _splitBsProps[0],
          elementProps = _splitBsProps[1];
        var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
          active: active
        }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'block')] = block, _extends2));
        var fullClassName = (0, _classnames2['default'])(className, classes);
        if (elementProps.href) {
          return this.renderAnchor(elementProps, fullClassName);
        }
        return this.renderButton(elementProps, fullClassName);
      };
      return Button;
    }(_react2['default'].Component);
    Button.propTypes = propTypes;
    Button.defaultProps = defaultProps;
    exports['default'] = (0, _bootstrapUtils.bsClass)('btn', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL, _StyleConfig.Size.XSMALL], (0, _bootstrapUtils.bsStyles)([].concat((0, _values2['default'])(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY, _StyleConfig.Style.LINK]), _StyleConfig.Style.DEFAULT, Button)));
    module.exports = exports['default'];

    /***/
  }), ( /* 220 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    var Size = exports.Size = {
      LARGE: 'large',
      SMALL: 'small',
      XSMALL: 'xsmall'
    };
    var SIZE_MAP = exports.SIZE_MAP = {
      large: 'lg',
      medium: 'md',
      small: 'sm',
      xsmall: 'xs',
      lg: 'lg',
      md: 'md',
      sm: 'sm',
      xs: 'xs'
    };
    var DEVICE_SIZES = exports.DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];
    var State = exports.State = {
      SUCCESS: 'success',
      WARNING: 'warning',
      DANGER: 'danger',
      INFO: 'info'
    };
    var Style = exports.Style = {
      DEFAULT: 'default',
      PRIMARY: 'primary',
      LINK: 'link',
      INVERSE: 'inverse'
    };

    /***/
  }), ( /* 221 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    var _contains = __webpack_require__(89);
    var _contains2 = _interopRequireDefault(_contains);
    var _propTypes = __webpack_require__(52);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _reactDom = __webpack_require__(4);
    var _reactDom2 = _interopRequireDefault(_reactDom);
    var _addEventListener = __webpack_require__(543);
    var _addEventListener2 = _interopRequireDefault(_addEventListener);
    var _ownerDocument = __webpack_require__(73);
    var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var escapeKeyCode = 27;
    function isLeftClickEvent(event) {
      return event.button === 0;
    }
    function isModifiedEvent(event) {
      return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
    }

    /**
     * The `<RootCloseWrapper/>` component registers your callback on the document
     * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
     * style behavior where your callback is triggered when the user tries to
     * interact with the rest of the document or hits the `esc` key.
     */

    var RootCloseWrapper = function (_React$Component) {
      _inherits(RootCloseWrapper, _React$Component);
      function RootCloseWrapper(props, context) {
        _classCallCheck(this, RootCloseWrapper);
        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
        _this.addEventListeners = function () {
          var event = _this.props.event;
          var doc = (0, _ownerDocument2.default)(_this);

          // Use capture for this listener so it fires before React's listener, to
          // avoid false positives in the contains() check below if the target DOM
          // element is removed in the React mouse callback.
          _this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, _this.handleMouseCapture, true);
          _this.documentMouseListener = (0, _addEventListener2.default)(doc, event, _this.handleMouse);
          _this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this.handleKeyUp);
        };
        _this.removeEventListeners = function () {
          if (_this.documentMouseCaptureListener) {
            _this.documentMouseCaptureListener.remove();
          }
          if (_this.documentMouseListener) {
            _this.documentMouseListener.remove();
          }
          if (_this.documentKeyupListener) {
            _this.documentKeyupListener.remove();
          }
        };
        _this.handleMouseCapture = function (e) {
          _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
        };
        _this.handleMouse = function (e) {
          if (!_this.preventMouseRootClose && _this.props.onRootClose) {
            _this.props.onRootClose(e);
          }
        };
        _this.handleKeyUp = function (e) {
          if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
            _this.props.onRootClose(e);
          }
        };
        _this.preventMouseRootClose = false;
        return _this;
      }
      RootCloseWrapper.prototype.componentDidMount = function componentDidMount() {
        if (!this.props.disabled) {
          this.addEventListeners();
        }
      };
      RootCloseWrapper.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (!this.props.disabled && prevProps.disabled) {
          this.addEventListeners();
        } else if (this.props.disabled && !prevProps.disabled) {
          this.removeEventListeners();
        }
      };
      RootCloseWrapper.prototype.componentWillUnmount = function componentWillUnmount() {
        if (!this.props.disabled) {
          this.removeEventListeners();
        }
      };
      RootCloseWrapper.prototype.render = function render() {
        return this.props.children;
      };
      return RootCloseWrapper;
    }(_react2.default.Component);
    RootCloseWrapper.displayName = 'RootCloseWrapper';
    RootCloseWrapper.propTypes = {
      /**
       * Callback fired after click or mousedown. Also triggers when user hits `esc`.
       */
      onRootClose: _propTypes2.default.func,
      /**
       * Children to render.
       */
      children: _propTypes2.default.element,
      /**
       * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
       */
      disabled: _propTypes2.default.bool,
      /**
       * Choose which document mouse event to bind to.
       */
      event: _propTypes2.default.oneOf(['click', 'mousedown'])
    };
    RootCloseWrapper.defaultProps = {
      event: 'click'
    };
    exports.default = RootCloseWrapper;
    module.exports = exports['default'];

    /***/
  }), ( /* 222 */
  /***/function (module, exports, __webpack_require__) {
    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; /*!
                                                                     Copyright (c) 2017 Jed Watson.
                                                                     Licensed under the MIT License (MIT), see
                                                                     http://jedwatson.github.io/classnames
                                                                     */
    /* global define */

    (function () {
      'use strict';

      var hasOwn = {}.hasOwnProperty;
      function classNames() {
        var classes = [];
        for (var i = 0; i < arguments.length; i++) {
          var arg = arguments[i];
          if (!arg) continue;
          var argType = typeof arg;
          if (argType === 'string' || argType === 'number') {
            classes.push(arg);
          } else if (Array.isArray(arg) && arg.length) {
            var inner = classNames.apply(null, arg);
            if (inner) {
              classes.push(inner);
            }
          } else if (argType === 'object') {
            for (var key in arg) {
              if (hasOwn.call(arg, key) && arg[key]) {
                classes.push(key);
              }
            }
          }
        }
        return classes.join(' ');
      }
      if (typeof module !== 'undefined' && module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
      } else if (true) {
        // register as 'classnames', consistent with npm package name
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
          return classNames;
        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      } else {
        window.classNames = classNames;
      }
    })();

    /***/
  }), ( /* 223 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    var _debug = __webpack_require__(20);
    var _debug2 = _interopRequireDefault(_debug);
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _propTypes = __webpack_require__(54);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _slatePropTypes = __webpack_require__(53);
    var _slatePropTypes2 = _interopRequireDefault(_slatePropTypes);
    var _offsetKey = __webpack_require__(144);
    var _offsetKey2 = _interopRequireDefault(_offsetKey);
    var _environment = __webpack_require__(98);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    /**
     * Debugger.
     *
     * @type {Function}
     */

    var debug = (0, _debug2.default)('slate:leaf');

    /**
     * Leaf.
     *
     * @type {Component}
     */

    var Leaf = function (_React$Component) {
      _inherits(Leaf, _React$Component);
      function Leaf() {
        var _ref;
        var _temp, _this, _ret;
        _classCallCheck(this, Leaf);
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Leaf.__proto__ || Object.getPrototypeOf(Leaf)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
      }

      /**
       * Property types.
       *
       * @type {Object}
       */

      /**
       * Debug.
       *
       * @param {String} message
       * @param {Mixed} ...args
       */

      _createClass(Leaf, [{
        key: 'shouldComponentUpdate',
        /**
         * Should component update?
         *
         * @param {Object} props
         * @return {Boolean}
         */

        value: function shouldComponentUpdate(props) {
          // If any of the regular properties have changed, re-render.
          if (props.index != this.props.index || props.marks != this.props.marks || props.schema != this.props.schema || props.text != this.props.text) {
            return true;
          }

          // Otherwise, don't update.
          return false;
        }

        /**
         * Render the leaf.
         *
         * @return {Element}
         */
      }, {
        key: 'render',
        value: function render() {
          var props = this.props;
          var node = props.node,
            index = props.index;
          var offsetKey = _offsetKey2.default.stringify({
            key: node.key,
            index: index
          });
          this.debug('render', {
            props: props
          });
          return _react2.default.createElement('span', {
            'data-offset-key': offsetKey
          }, this.renderMarks(props));
        }

        /**
         * Render the text content of the leaf, accounting for browsers.
         *
         * @param {Object} props
         * @return {Element}
         */
      }, {
        key: 'renderText',
        value: function renderText(props) {
          var block = props.block,
            node = props.node,
            parent = props.parent,
            text = props.text,
            index = props.index,
            ranges = props.ranges;

          // COMPAT: If the text is empty and it's the only child, we need to render a
          // <br/> to get the block to have the proper height.

          if (text == '' && parent.kind == 'block' && parent.text == '') return _react2.default.createElement('br', null);

          // COMPAT: If the text is empty otherwise, it's because it's on the edge of
          // an inline void node, so we render a zero-width space so that the
          // selection can be inserted next to it still.
          if (text == '') {
            // COMPAT: In Chrome, zero-width space produces graphics glitches, so use
            // hair space in place of it. (2017/02/12)
            var space = _environment.IS_FIREFOX ? "\u200B" : "\u200A";
            return _react2.default.createElement('span', {
              'data-slate-zero-width': true
            }, space);
          }

          // COMPAT: Browsers will collapse trailing new lines at the end of blocks,
          // so we need to add an extra trailing new lines to prevent that.
          var lastText = block.getLastText();
          var lastChar = text.charAt(text.length - 1);
          var isLastText = node == lastText;
          var isLastRange = index == ranges.size - 1;
          if (isLastText && isLastRange && lastChar == '\n') return text + '\n';

          // Otherwise, just return the text.
          return text;
        }

        /**
         * Render all of the leaf's mark components.
         *
         * @param {Object} props
         * @return {Element}
         */
      }, {
        key: 'renderMarks',
        value: function renderMarks(props) {
          var marks = props.marks,
            schema = props.schema,
            node = props.node,
            offset = props.offset,
            text = props.text,
            state = props.state,
            editor = props.editor;
          var children = this.renderText(props);
          return marks.reduce(function (memo, mark) {
            var Component = mark.getComponent(schema);
            if (!Component) return memo;
            return _react2.default.createElement(Component, {
              editor: editor,
              mark: mark,
              marks: marks,
              node: node,
              offset: offset,
              schema: schema,
              state: state,
              text: text
            }, memo);
          }, children);
        }
      }]);
      return Leaf;
    }(_react2.default.Component);

    /**
     * Export.
     *
     * @type {Component}
     */

    Leaf.propTypes = {
      block: _slatePropTypes2.default.block.isRequired,
      editor: _propTypes2.default.object.isRequired,
      index: _propTypes2.default.number.isRequired,
      marks: _slatePropTypes2.default.marks.isRequired,
      node: _slatePropTypes2.default.node.isRequired,
      offset: _propTypes2.default.number.isRequired,
      parent: _slatePropTypes2.default.node.isRequired,
      ranges: _slatePropTypes2.default.ranges.isRequired,
      schema: _slatePropTypes2.default.schema.isRequired,
      state: _slatePropTypes2.default.state.isRequired,
      text: _propTypes2.default.string.isRequired
    };
    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;
      this.debug = function (message) {
        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }
        debug.apply(undefined, [message, _this2.props.node.key + '-' + _this2.props.index].concat(args));
      };
    };
    exports.default = Leaf;

    /***/
  }), ( /* 224 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _slatePropTypes = __webpack_require__(53);
    var _slatePropTypes2 = _interopRequireDefault(_slatePropTypes);
    var _propTypes = __webpack_require__(54);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    /**
     * Placeholder.
     *
     * @type {Component}
     */

    var Placeholder = function (_React$Component) {
      _inherits(Placeholder, _React$Component);
      function Placeholder() {
        var _ref;
        var _temp, _this, _ret;
        _classCallCheck(this, Placeholder);
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Placeholder.__proto__ || Object.getPrototypeOf(Placeholder)).call.apply(_ref, [this].concat(args))), _this), _this.shouldComponentUpdate = function (props, state) {
          return props.children != _this.props.children || props.className != _this.props.className || props.firstOnly != _this.props.firstOnly || props.parent != _this.props.parent || props.node != _this.props.node || props.style != _this.props.style;
        }, _this.isVisible = function () {
          var _this$props = _this.props,
            firstOnly = _this$props.firstOnly,
            node = _this$props.node,
            parent = _this$props.parent;
          if (node.text) return false;
          if (firstOnly) {
            if (parent.nodes.size > 1) return false;
            if (parent.nodes.first() === node) return true;
            return false;
          } else {
            return true;
          }
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      /**
       * Property types.
       *
       * @type {Object}
       */

      /**
       * Default properties.
       *
       * @type {Object}
       */

      /**
       * Should the placeholder update?
       *
       * @param {Object} props
       * @param {Object} state
       * @return {Boolean}
       */

      /**
       * Is the placeholder visible?
       *
       * @return {Boolean}
       */

      _createClass(Placeholder, [{
        key: 'render',
        /**
         * Render.
         *
         * If the placeholder is a string, and no `className` or `style` has been
         * passed, give it a default style of lowered opacity.
         *
         * @return {Element}
         */

        value: function render() {
          var isVisible = this.isVisible();
          if (!isVisible) return null;
          var _props = this.props,
            children = _props.children,
            className = _props.className;
          var style = this.props.style;
          if (typeof children === 'string' && style == null && className == null) {
            style = {
              opacity: '0.333'
            };
          } else if (style == null) {
            style = {};
          }
          var styles = _extends({
            position: 'absolute',
            top: '0px',
            right: '0px',
            bottom: '0px',
            left: '0px',
            pointerEvents: 'none'
          }, style);
          return _react2.default.createElement('span', {
            contentEditable: false,
            className: className,
            style: styles
          }, children);
        }
      }]);
      return Placeholder;
    }(_react2.default.Component);

    /**
     * Export.
     *
     * @type {Component}
     */

    Placeholder.propTypes = {
      children: _propTypes2.default.any.isRequired,
      className: _propTypes2.default.string,
      firstOnly: _propTypes2.default.bool,
      node: _slatePropTypes2.default.node.isRequired,
      parent: _slatePropTypes2.default.node,
      state: _slatePropTypes2.default.state.isRequired,
      style: _propTypes2.default.object
    };
    Placeholder.defaultProps = {
      firstOnly: true
    };
    exports.default = Placeholder;

    /***/
  }), ( /* 225 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    /**
     * Find the closest ancestor of a DOM `element` that matches a given selector.
     *
     * COMPAT: In IE11, the `Node.closest` method doesn't exist natively, so we
     * have to polyfill it. (2017/09/06)
     *
     * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
     *
     * @param {Element} node
     * @param {String} selector
     * @return {Element}
     */

    function findClosestNode(node, selector) {
      if (typeof node.closest === 'function') return node.closest(selector);
      var matches = (node.document || node.ownerDocument).querySelectorAll(selector);
      var parentNode = node;
      var i = void 0;
      do {
        i = matches.length;
        while (--i >= 0 && matches.item(i) !== parentNode) {}
      } while (i < 0 && (parentNode = parentNode.parentElement));
      return parentNode;
    }

    /**
     * Export.
     *
     * @type {Function}
     */

    exports.default = findClosestNode;

    /***/
  }), ( /* 226 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    /**
     * Find the DOM node for a `node`.
     *
     * @param {Node} node
     * @return {Element}
     */

    function findDOMNode(node) {
      var el = window.document.querySelector("[data-key=\"" + node.key + "\"]");
      if (!el) {
        throw new Error("Unable to find a DOM node for \"" + node.key + "\". This is often because of forgetting to add `props.attributes` to a component returned from `renderNode`.");
      }
      return el;
    }

    /**
     * Export.
     *
     * @type {Function}
     */

    exports.default = findDOMNode;

    /***/
  }), ( /* 227 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _offsetKey = __webpack_require__(144);
    var _offsetKey2 = _interopRequireDefault(_offsetKey);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    /**
     * Get a point from a native selection's DOM `element` and `offset`.
     *
     * @param {Element} element
     * @param {Number} offset
     * @param {State} state
     * @param {Editor} editor
     * @return {Object}
     */

    function getPoint(element, offset, state, editor) {
      var document = state.document;
      var schema = editor.getSchema();

      // If we can't find an offset key, we can't get a point.
      var offsetKey = _offsetKey2.default.findKey(element, offset);
      if (!offsetKey) return null;

      // COMPAT: If someone is clicking from one Slate editor into another, the
      // select event fires two, once for the old editor's `element` first, and
      // then afterwards for the correct `element`. (2017/03/03)
      var key = offsetKey.key;
      var node = document.getDescendant(key);
      if (!node) return null;
      var decorators = document.getDescendantDecorators(key, schema);
      var ranges = node.getRanges(decorators);
      var point = _offsetKey2.default.findPoint(offsetKey, ranges);
      return point;
    }

    /**
     * Export.
     *
     * @type {Function}
     */

    exports.default = getPoint;

    /***/
  }), ( /* 228 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    /**
     * Set data with `type` and `content` on a `dataTransfer` object.
     *
     * COMPAT: In Edge, custom types throw errors, so embed all non-standard
     * types in text/plain compound object. (2017/7/12)
     *
     * @param {DataTransfer} dataTransfer
     * @param {String} type
     * @param {String} content
     */

    function setTransferData(dataTransfer, type, content) {
      try {
        dataTransfer.setData(type, content);
      } catch (err) {
        var prefix = 'SLATE-DATA-EMBED::';
        var text = dataTransfer.getData('text/plain');
        var obj = {};

        // If the existing plain text data is prefixed, it's Slate JSON data.
        if (text.substring(0, prefix.length) === prefix) {
          try {
            obj = JSON.parse(text.substring(prefix.length));
          } catch (e) {
            throw new Error('Failed to parse Slate data from `DataTransfer` object.');
          }
        }

        // Otherwise, it's just set it as is.
        else {
          obj['text/plain'] = text;
        }
        obj[type] = content;
        var string = '' + prefix + JSON.stringify(obj);
        dataTransfer.setData('text/plain', string);
      }
    }

    /**
     * Export.
     *
     * @type {Function}
     */

    exports.default = setTransferData;

    /***/
  }), ( /* 229 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    var _atCurrentRange = __webpack_require__(570);
    var _atCurrentRange2 = _interopRequireDefault(_atCurrentRange);
    var _atRange = __webpack_require__(571);
    var _atRange2 = _interopRequireDefault(_atRange);
    var _byKey = __webpack_require__(572);
    var _byKey2 = _interopRequireDefault(_byKey);
    var _normalize = __webpack_require__(573);
    var _normalize2 = _interopRequireDefault(_normalize);
    var _onHistory = __webpack_require__(574);
    var _onHistory2 = _interopRequireDefault(_onHistory);
    var _onSelection = __webpack_require__(575);
    var _onSelection2 = _interopRequireDefault(_onSelection);
    var _onState = __webpack_require__(576);
    var _onState2 = _interopRequireDefault(_onState);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    /**
     * Export.
     *
     * @type {Object}
     */

    exports.default = _extends({}, _atCurrentRange2.default, _atRange2.default, _byKey2.default, _normalize2.default, _onHistory2.default, _onSelection2.default, _onState2.default);

    /***/
  }), ( /* 230 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    var _debug = __webpack_require__(20);
    var _debug2 = _interopRequireDefault(_debug);
    var _isEqual = __webpack_require__(674);
    var _isEqual2 = _interopRequireDefault(_isEqual);
    var _isPlainObject = __webpack_require__(9);
    var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
    var _immutable = __webpack_require__(2);
    var _modelTypes = __webpack_require__(11);
    var _modelTypes2 = _interopRequireDefault(_modelTypes);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    /**
     * Debug.
     *
     * @type {Function}
     */

    var debug = (0, _debug2.default)('slate:history');

    /**
     * Default properties.
     *
     * @type {Object}
     */

    var DEFAULTS = {
      redos: new _immutable.Stack(),
      undos: new _immutable.Stack()
    };

    /**
     * History.
     *
     * @type {History}
     */

    var History = function (_Record) {
      _inherits(History, _Record);
      function History() {
        _classCallCheck(this, History);
        return _possibleConstructorReturn(this, (History.__proto__ || Object.getPrototypeOf(History)).apply(this, arguments));
      }
      _createClass(History, [{
        key: 'save',
        /**
         * Save an `operation` into the history.
         *
         * @param {Object} operation
         * @param {Object} options
         * @return {History}
         */

        value: function save(operation) {
          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var history = this;
          var _history = history,
            undos = _history.undos,
            redos = _history.redos;
          var merge = options.merge,
            skip = options.skip;
          var prevBatch = undos.peek();
          var prevOperation = prevBatch && prevBatch[prevBatch.length - 1];
          if (skip == null) {
            skip = shouldSkip(operation, prevOperation);
          }
          if (skip) {
            return history;
          }
          if (merge == null) {
            merge = shouldMerge(operation, prevOperation);
          }
          debug('save', {
            operation: operation,
            merge: merge
          });

          // If the `merge` flag is true, add the operation to the previous batch.
          if (merge) {
            var batch = prevBatch.slice();
            batch.push(operation);
            undos = undos.pop();
            undos = undos.push(batch);
          }

          // Otherwise, create a new batch with the operation.
          else {
            var _batch = [operation];
            undos = undos.push(_batch);
          }

          // Constrain the history to 100 entries for memory's sake.
          if (undos.length > 100) {
            undos = undos.take(100);
          }

          // Clear the redos and update the history.
          redos = redos.clear();
          history = history.set('undos', undos).set('redos', redos);
          return history;
        }

        /**
         * Return a JSON representation of the history.
         *
         * @return {Object}
         */
      }, {
        key: 'toJSON',
        value: function toJSON() {
          var object = {
            kind: this.kind,
            redos: this.redos.toJSON(),
            undos: this.undos.toJSON()
          };
          return object;
        }

        /**
         * Alias `toJS`.
         */
      }, {
        key: 'toJS',
        value: function toJS() {
          return this.toJSON();
        }
      }, {
        key: 'kind',
        /**
         * Get the kind.
         *
         * @return {String}
         */

        get: function get() {
          return 'history';
        }
      }], [{
        key: 'create',
        /**
         * Create a new `History` with `attrs`.
         *
         * @param {Object|History} attrs
         * @return {History}
         */

        value: function create() {
          var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          if (History.isHistory(attrs)) {
            return attrs;
          }
          if ((0, _isPlainObject2.default)(attrs)) {
            return History.fromJSON(attrs);
          }
          throw new Error('`History.create` only accepts objects or histories, but you passed it: ' + attrs);
        }

        /**
         * Create a `History` from a JSON `object`.
         *
         * @param {Object} object
         * @return {History}
         */
      }, {
        key: 'fromJSON',
        value: function fromJSON(object) {
          var _object$redos = object.redos,
            redos = _object$redos === undefined ? [] : _object$redos,
            _object$undos = object.undos,
            undos = _object$undos === undefined ? [] : _object$undos;
          var history = new History({
            redos: new _immutable.Stack(redos),
            undos: new _immutable.Stack(undos)
          });
          return history;
        }

        /**
         * Alias `fromJS`.
         */
      }, {
        key: 'isHistory',
        /**
         * Check if a `value` is a `History`.
         *
         * @param {Any} value
         * @return {Boolean}
         */

        value: function isHistory(value) {
          return !!(value && value[_modelTypes2.default.HISTORY]);
        }
      }]);
      return History;
    }((0, _immutable.Record)(DEFAULTS));

    /**
     * Attach a pseudo-symbol for type checking.
     */

    History.fromJS = History.fromJSON;
    History.prototype[_modelTypes2.default.HISTORY] = true;

    /**
     * Check whether to merge a new operation `o` into the previous operation `p`.
     *
     * @param {Object} o
     * @param {Object} p
     * @return {Boolean}
     */

    function shouldMerge(o, p) {
      if (!p) return false;
      var merge = o.type == 'set_selection' && p.type == 'set_selection' || o.type == 'insert_text' && p.type == 'insert_text' && o.offset == p.offset + p.text.length && (0, _isEqual2.default)(o.path, p.path) || o.type == 'remove_text' && p.type == 'remove_text' && o.offset + o.text.length == p.offset && (0, _isEqual2.default)(o.path, p.path);
      return merge;
    }

    /**
     * Check whether to skip a new operation `o`, given previous operation `p`.
     *
     * @param {Object} o
     * @param {Object} p
     * @return {Boolean}
     */

    function shouldSkip(o, p) {
      if (!p) return false;
      var skip = o.type == 'set_selection' && p.type == 'set_selection';
      return skip;
    }

    /**
     * Export.
     *
     * @type {History}
     */

    exports.default = History;

    /***/
  }), ( /* 231 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    var _isPlainObject = __webpack_require__(9);
    var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
    var _immutable = __webpack_require__(2);
    var _modelTypes = __webpack_require__(11);
    var _modelTypes2 = _interopRequireDefault(_modelTypes);
    var _character = __webpack_require__(145);
    var _character2 = _interopRequireDefault(_character);
    var _mark = __webpack_require__(42);
    var _mark2 = _interopRequireDefault(_mark);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    /**
     * Default properties.
     *
     * @type {Object}
     */

    var DEFAULTS = {
      marks: new _immutable.Set(),
      text: ''
    };

    /**
     * Range.
     *
     * @type {Range}
     */

    var Range = function (_Record) {
      _inherits(Range, _Record);
      function Range() {
        _classCallCheck(this, Range);
        return _possibleConstructorReturn(this, (Range.__proto__ || Object.getPrototypeOf(Range)).apply(this, arguments));
      }
      _createClass(Range, [{
        key: 'getCharacters',
        /**
         * Return range as a list of characters
         *
         * @return {List<Character>}
         */

        value: function getCharacters() {
          var marks = this.marks;
          var characters = _character2.default.createList(this.text.split('').map(function (char) {
            return _character2.default.create({
              text: char,
              marks: marks
            });
          }));
          return characters;
        }

        /**
         * Return a JSON representation of the range.
         *
         * @return {Object}
         */
      }, {
        key: 'toJSON',
        value: function toJSON() {
          var object = {
            kind: this.kind,
            marks: this.marks.toArray().map(function (m) {
              return m.toJSON();
            }),
            text: this.text
          };
          return object;
        }

        /**
         * Alias `toJS`.
         */
      }, {
        key: 'toJS',
        value: function toJS() {
          return this.toJSON();
        }
      }, {
        key: 'kind',
        /**
         * Get the node's kind.
         *
         * @return {String}
         */

        get: function get() {
          return 'range';
        }
      }], [{
        key: 'create',
        /**
         * Create a new `Range` with `attrs`.
         *
         * @param {Object|Range} attrs
         * @return {Range}
         */

        value: function create() {
          var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          if (Range.isRange(attrs)) {
            return attrs;
          }
          if (typeof attrs == 'string') {
            attrs = {
              text: attrs
            };
          }
          if ((0, _isPlainObject2.default)(attrs)) {
            return Range.fromJSON(attrs);
          }
          throw new Error('`Range.create` only accepts objects, strings or ranges, but you passed it: ' + attrs);
        }

        /**
         * Create a list of `Ranges` from `value`.
         *
         * @param {Array<Range|Object>|List<Range|Object>} value
         * @return {List<Range>}
         */
      }, {
        key: 'createList',
        value: function createList() {
          var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
          if (_immutable.List.isList(value) || Array.isArray(value)) {
            var list = new _immutable.List(value.map(Range.create));
            return list;
          }
          throw new Error('`Range.createList` only accepts arrays or lists, but you passed it: ' + value);
        }

        /**
         * Create a `Range` from a JSON `object`.
         *
         * @param {Object} object
         * @return {Range}
         */
      }, {
        key: 'fromJSON',
        value: function fromJSON(object) {
          var _object$text = object.text,
            text = _object$text === undefined ? '' : _object$text,
            _object$marks = object.marks,
            marks = _object$marks === undefined ? [] : _object$marks;
          var range = new Range({
            text: text,
            marks: new _immutable.Set(marks.map(_mark2.default.fromJSON))
          });
          return range;
        }

        /**
         * Alias `fromJS`.
         */
      }, {
        key: 'isRange',
        /**
         * Check if a `value` is a `Range`.
         *
         * @param {Any} value
         * @return {Boolean}
         */

        value: function isRange(value) {
          return !!(value && value[_modelTypes2.default.RANGE]);
        }

        /**
         * Check if a `value` is a list of ranges.
         *
         * @param {Any} value
         * @return {Boolean}
         */
      }, {
        key: 'isRangeList',
        value: function isRangeList(value) {
          return _immutable.List.isList(value) && value.every(function (item) {
            return Range.isRange(item);
          });
        }
      }]);
      return Range;
    }((0, _immutable.Record)(DEFAULTS));

    /**
     * Attach a pseudo-symbol for type checking.
     */

    Range.fromJS = Range.fromJSON;
    Range.prototype[_modelTypes2.default.RANGE] = true;

    /**
     * Export.
     *
     * @type {Range}
     */

    exports.default = Range;

    /***/
  }), ( /* 232 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    var _debug = __webpack_require__(20);
    var _debug2 = _interopRequireDefault(_debug);
    var _slateDevLogger = __webpack_require__(16);
    var _slateDevLogger2 = _interopRequireDefault(_slateDevLogger);
    var _node = __webpack_require__(43);
    var _node2 = _interopRequireDefault(_node);
    var _mark = __webpack_require__(42);
    var _mark2 = _interopRequireDefault(_mark);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    /**
     * Debug.
     *
     * @type {Function}
     */

    var debug = (0, _debug2.default)('slate:operation:apply');

    /**
     * Applying functions.
     *
     * @type {Object}
     */

    var APPLIERS = {
      /**
       * Add mark to text at `offset` and `length` in node by `path`.
       *
       * @param {State} state
       * @param {Object} operation
       * @return {State}
       */

      add_mark: function add_mark(state, operation) {
        var path = operation.path,
          offset = operation.offset,
          length = operation.length;
        var mark = _mark2.default.create(operation.mark);
        var _state = state,
          document = _state.document;
        var node = document.assertPath(path);
        node = node.addMark(offset, length, mark);
        document = document.updateNode(node);
        state = state.set('document', document);
        return state;
      },
      /**
       * Insert a `node` at `index` in a node by `path`.
       *
       * @param {State} state
       * @param {Object} operation
       * @return {State}
       */

      insert_node: function insert_node(state, operation) {
        var path = operation.path;
        var node = _node2.default.create(operation.node);
        var index = path[path.length - 1];
        var rest = path.slice(0, -1);
        var _state2 = state,
          document = _state2.document;
        var parent = document.assertPath(rest);
        parent = parent.insertNode(index, node);
        document = document.updateNode(parent);
        state = state.set('document', document);
        return state;
      },
      /**
       * Insert `text` at `offset` in node by `path`.
       *
       * @param {State} state
       * @param {Object} operation
       * @return {State}
       */

      insert_text: function insert_text(state, operation) {
        var path = operation.path,
          offset = operation.offset,
          text = operation.text;
        var marks = operation.marks;
        if (Array.isArray(marks)) marks = _mark2.default.createSet(marks);
        var _state3 = state,
          document = _state3.document,
          selection = _state3.selection;
        var _selection = selection,
          anchorKey = _selection.anchorKey,
          focusKey = _selection.focusKey,
          anchorOffset = _selection.anchorOffset,
          focusOffset = _selection.focusOffset;
        var node = document.assertPath(path);

        // Update the document
        node = node.insertText(offset, text, marks);
        document = document.updateNode(node);

        // Update the selection
        if (anchorKey == node.key && anchorOffset >= offset) {
          selection = selection.moveAnchor(text.length);
        }
        if (focusKey == node.key && focusOffset >= offset) {
          selection = selection.moveFocus(text.length);
        }
        state = state.set('document', document).set('selection', selection);
        return state;
      },
      /**
       * Merge a node at `path` with the previous node.
       *
       * @param {State} state
       * @param {Object} operation
       * @return {State}
       */

      merge_node: function merge_node(state, operation) {
        var path = operation.path;
        var withPath = path.slice(0, path.length - 1).concat([path[path.length - 1] - 1]);
        var _state4 = state,
          document = _state4.document,
          selection = _state4.selection;
        var one = document.assertPath(withPath);
        var two = document.assertPath(path);
        var parent = document.getParent(one.key);
        var oneIndex = parent.nodes.indexOf(one);
        var twoIndex = parent.nodes.indexOf(two);

        // Perform the merge in the document.
        parent = parent.mergeNode(oneIndex, twoIndex);
        document = document.updateNode(parent);

        // If the nodes are text nodes and the selection is inside the second node
        // update it to refer to the first node instead.
        if (one.kind == 'text') {
          var _selection2 = selection,
            anchorKey = _selection2.anchorKey,
            anchorOffset = _selection2.anchorOffset,
            focusKey = _selection2.focusKey,
            focusOffset = _selection2.focusOffset;
          var normalize = false;
          if (anchorKey == two.key) {
            selection = selection.moveAnchorTo(one.key, one.text.length + anchorOffset);
            normalize = true;
          }
          if (focusKey == two.key) {
            selection = selection.moveFocusTo(one.key, one.text.length + focusOffset);
            normalize = true;
          }
          if (normalize) {
            selection = selection.normalize(document);
          }
        }

        // Update the document and selection.
        state = state.set('document', document).set('selection', selection);
        return state;
      },
      /**
       * Move a node by `path` to `newPath`.
       *
       * @param {State} state
       * @param {Object} operation
       * @return {State}
       */

      move_node: function move_node(state, operation) {
        var path = operation.path,
          newPath = operation.newPath;
        var newIndex = newPath[newPath.length - 1];
        var newParentPath = newPath.slice(0, -1);
        var oldParentPath = path.slice(0, -1);
        var oldIndex = path[path.length - 1];
        var _state5 = state,
          document = _state5.document;
        var node = document.assertPath(path);

        // Remove the node from its current parent.
        var parent = document.getParent(node.key);
        parent = parent.removeNode(oldIndex);
        document = document.updateNode(parent);

        // Find the new target...
        var target = void 0;

        // If the old path and the rest of the new path are the same, then the new
        // target is the old parent.
        if (oldParentPath.every(function (x, i) {
          return x === newParentPath[i];
        }) && oldParentPath.length === newParentPath.length) {
          target = parent;
        }

        // Otherwise, if the old path removal resulted in the new path being no longer
        // correct, we need to decrement the new path at the old path's last index.
        else if (oldParentPath.every(function (x, i) {
          return x === newParentPath[i];
        }) && oldIndex < newParentPath[oldParentPath.length]) {
          newParentPath[oldParentPath.length]--;
          target = document.assertPath(newParentPath);
        }

        // Otherwise, we can just grab the target normally...
        else {
          target = document.assertPath(newParentPath);
        }

        // Insert the new node to its new parent.
        target = target.insertNode(newIndex, node);
        document = document.updateNode(target);
        state = state.set('document', document);
        return state;
      },
      /**
       * Remove mark from text at `offset` and `length` in node by `path`.
       *
       * @param {State} state
       * @param {Object} operation
       * @return {State}
       */

      remove_mark: function remove_mark(state, operation) {
        var path = operation.path,
          offset = operation.offset,
          length = operation.length;
        var mark = _mark2.default.create(operation.mark);
        var _state6 = state,
          document = _state6.document;
        var node = document.assertPath(path);
        node = node.removeMark(offset, length, mark);
        document = document.updateNode(node);
        state = state.set('document', document);
        return state;
      },
      /**
       * Remove a node by `path`.
       *
       * @param {State} state
       * @param {Object} operation
       * @return {State}
       */

      remove_node: function remove_node(state, operation) {
        var path = operation.path;
        var _state7 = state,
          document = _state7.document,
          selection = _state7.selection;
        var _selection3 = selection,
          startKey = _selection3.startKey,
          endKey = _selection3.endKey;
        var node = document.assertPath(path);

        // If the selection is set, check to see if it needs to be updated.
        if (selection.isSet) {
          var hasStartNode = node.hasNode(startKey);
          var hasEndNode = node.hasNode(endKey);
          var normalize = false;

          // If one of the selection's nodes is being removed, we need to update it.
          if (hasStartNode) {
            var prev = document.getPreviousText(startKey);
            var next = document.getNextText(startKey);
            if (prev) {
              selection = selection.moveStartTo(prev.key, prev.text.length);
              normalize = true;
            } else if (next) {
              selection = selection.moveStartTo(next.key, 0);
              normalize = true;
            } else {
              selection = selection.deselect();
            }
          }
          if (hasEndNode) {
            var _prev = document.getPreviousText(endKey);
            var _next = document.getNextText(endKey);
            if (_prev) {
              selection = selection.moveEndTo(_prev.key, _prev.text.length);
              normalize = true;
            } else if (_next) {
              selection = selection.moveEndTo(_next.key, 0);
              normalize = true;
            } else {
              selection = selection.deselect();
            }
          }
          if (normalize) {
            selection = selection.normalize(document);
          }
        }

        // Remove the node from the document.
        var parent = document.getParent(node.key);
        var index = parent.nodes.indexOf(node);
        parent = parent.removeNode(index);
        document = document.updateNode(parent);

        // Update the document and selection.
        state = state.set('document', document).set('selection', selection);
        return state;
      },
      /**
       * Remove `text` at `offset` in node by `path`.
       *
       * @param {State} state
       * @param {Object} operation
       * @return {State}
       */

      remove_text: function remove_text(state, operation) {
        var path = operation.path,
          offset = operation.offset,
          text = operation.text;
        var length = text.length;
        var rangeOffset = offset + length;
        var _state8 = state,
          document = _state8.document,
          selection = _state8.selection;
        var _selection4 = selection,
          anchorKey = _selection4.anchorKey,
          focusKey = _selection4.focusKey,
          anchorOffset = _selection4.anchorOffset,
          focusOffset = _selection4.focusOffset;
        var node = document.assertPath(path);

        // Update the selection.
        if (anchorKey == node.key && anchorOffset >= rangeOffset) {
          selection = selection.moveAnchor(-length);
        }
        if (focusKey == node.key && focusOffset >= rangeOffset) {
          selection = selection.moveFocus(-length);
        }
        node = node.removeText(offset, length);
        document = document.updateNode(node);
        state = state.set('document', document).set('selection', selection);
        return state;
      },
      /**
       * Set `data` on `state`.
       *
       * @param {State} state
       * @param {Object} operation
       * @return {State}
       */

      set_data: function set_data(state, operation) {
        var properties = operation.properties;
        var _state9 = state,
          data = _state9.data;
        data = data.merge(properties);
        state = state.set('data', data);
        return state;
      },
      /**
       * Set `properties` on mark on text at `offset` and `length` in node by `path`.
       *
       * @param {State} state
       * @param {Object} operation
       * @return {State}
       */

      set_mark: function set_mark(state, operation) {
        var path = operation.path,
          offset = operation.offset,
          length = operation.length,
          properties = operation.properties;
        var mark = _mark2.default.create(operation.mark);
        var _state10 = state,
          document = _state10.document;
        var node = document.assertPath(path);
        node = node.updateMark(offset, length, mark, properties);
        document = document.updateNode(node);
        state = state.set('document', document);
        return state;
      },
      /**
       * Set `properties` on a node by `path`.
       *
       * @param {State} state
       * @param {Object} operation
       * @return {State}
       */

      set_node: function set_node(state, operation) {
        var path = operation.path,
          properties = operation.properties;
        var _state11 = state,
          document = _state11.document;
        var node = document.assertPath(path);

        // Warn when trying to overwite a node's children.
        if (properties.nodes && properties.nodes != node.nodes) {
          _slateDevLogger2.default.warn('Updating a Node\'s `nodes` property via `setNode()` is not allowed. Use the appropriate insertion and removal operations instead. The opeartion in question was:', operation);
          delete properties.nodes;
        }

        // Warn when trying to change a node's key.
        if (properties.key && properties.key != node.key) {
          _slateDevLogger2.default.warn('Updating a Node\'s `key` property via `setNode()` is not allowed. There should be no reason to do this. The opeartion in question was:', operation);
          delete properties.key;
        }
        node = node.merge(properties);
        document = document.updateNode(node);
        state = state.set('document', document);
        return state;
      },
      /**
       * Set `properties` on the selection.
       *
       * @param {State} state
       * @param {Object} operation
       * @return {State}
       */

      set_selection: function set_selection(state, operation) {
        var properties = _extends({}, operation.properties);
        var _state12 = state,
          document = _state12.document,
          selection = _state12.selection;
        if (properties.marks != null) {
          properties.marks = _mark2.default.createSet(properties.marks);
        }
        if (properties.anchorPath !== undefined) {
          properties.anchorKey = properties.anchorPath === null ? null : document.assertPath(properties.anchorPath).key;
          delete properties.anchorPath;
        }
        if (properties.focusPath !== undefined) {
          properties.focusKey = properties.focusPath === null ? null : document.assertPath(properties.focusPath).key;
          delete properties.focusPath;
        }
        selection = selection.merge(properties);
        selection = selection.normalize(document);
        state = state.set('selection', selection);
        return state;
      },
      /**
       * Split a node by `path` at `offset`.
       *
       * @param {State} state
       * @param {Object} operation
       * @return {State}
       */

      split_node: function split_node(state, operation) {
        var path = operation.path,
          position = operation.position;
        var _state13 = state,
          document = _state13.document,
          selection = _state13.selection;

        // Calculate a few things...

        var node = document.assertPath(path);
        var parent = document.getParent(node.key);
        var index = parent.nodes.indexOf(node);

        // Split the node by its parent.
        parent = parent.splitNode(index, position);
        document = document.updateNode(parent);

        // Determine whether we need to update the selection...
        var _selection5 = selection,
          startKey = _selection5.startKey,
          endKey = _selection5.endKey,
          startOffset = _selection5.startOffset,
          endOffset = _selection5.endOffset;
        var next = document.getNextText(node.key);
        var normalize = false;

        // If the start point is after or equal to the split, update it.
        if (node.key == startKey && position <= startOffset) {
          selection = selection.moveStartTo(next.key, startOffset - position);
          normalize = true;
        }

        // If the end point is after or equal to the split, update it.
        if (node.key == endKey && position <= endOffset) {
          selection = selection.moveEndTo(next.key, endOffset - position);
          normalize = true;
        }

        // Normalize the selection if we changed it, since the methods we use might
        // leave it in a non-normalized state.
        if (normalize) {
          selection = selection.normalize(document);
        }

        // Return the updated state.
        state = state.set('document', document).set('selection', selection);
        return state;
      }
    };

    /**
     * Apply an `operation` to a `state`.
     *
     * @param {State} state
     * @param {Object} operation
     * @return {State} state
     */

    function applyOperation(state, operation) {
      var type = operation.type;
      var apply = APPLIERS[type];
      if (!apply) {
        throw new Error('Unknown operation type: "' + type + '".');
      }
      debug(type, operation);
      state = apply(state, operation);
      return state;
    }

    /**
     * Export.
     *
     * @type {Function}
     */

    exports.default = applyOperation;

    /***/
  }), ( /* 233 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    var _debug = __webpack_require__(20);
    var _debug2 = _interopRequireDefault(_debug);
    var _pick = __webpack_require__(161);
    var _pick2 = _interopRequireDefault(_pick);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    /**
     * Debug.
     *
     * @type {Function}
     */

    var debug = (0, _debug2.default)('slate:operation:invert');

    /**
     * Invert an `op`.
     *
     * @param {Object} op
     * @return {Object}
     */

    function invertOperation(op) {
      var type = op.type;
      debug(type, op);

      /**
       * Insert node.
       */

      if (type == 'insert_node') {
        return _extends({}, op, {
          type: 'remove_node'
        });
      }

      /**
       * Remove node.
       */

      if (type == 'remove_node') {
        return _extends({}, op, {
          type: 'insert_node'
        });
      }

      /**
       * Move node.
       */

      if (type == 'move_node') {
        return _extends({}, op, {
          path: op.newPath,
          newPath: op.path
        });
      }

      /**
       * Merge node.
       */

      if (type == 'merge_node') {
        var path = op.path;
        var length = path.length;
        var last = length - 1;
        return _extends({}, op, {
          type: 'split_node',
          path: path.slice(0, last).concat([path[last] - 1])
        });
      }

      /**
       * Split node.
       */

      if (type == 'split_node') {
        var _path = op.path;
        var _length = _path.length;
        var _last = _length - 1;
        return _extends({}, op, {
          type: 'merge_node',
          path: _path.slice(0, _last).concat([_path[_last] + 1])
        });
      }

      /**
       * Set node.
       */

      if (type == 'set_node') {
        var properties = op.properties,
          node = op.node;
        return _extends({}, op, {
          node: node.merge(properties),
          properties: (0, _pick2.default)(node, Object.keys(properties))
        });
      }

      /**
       * Insert text.
       */

      if (type == 'insert_text') {
        return _extends({}, op, {
          type: 'remove_text'
        });
      }

      /**
       * Remove text.
       */

      if (type == 'remove_text') {
        return _extends({}, op, {
          type: 'insert_text'
        });
      }

      /**
       * Add mark.
       */

      if (type == 'add_mark') {
        return _extends({}, op, {
          type: 'remove_mark'
        });
      }

      /**
       * Remove mark.
       */

      if (type == 'remove_mark') {
        return _extends({}, op, {
          type: 'add_mark'
        });
      }

      /**
       * Set mark.
       */

      if (type == 'set_mark') {
        var _properties = op.properties,
          mark = op.mark;
        return _extends({}, op, {
          mark: mark.merge(_properties),
          properties: (0, _pick2.default)(mark, Object.keys(_properties))
        });
      }

      /**
       * Set selection.
       */

      if (type == 'set_selection') {
        var _properties2 = op.properties,
          selection = op.selection;
        var inverse = _extends({}, op, {
          selection: _extends({}, selection, _properties2),
          properties: (0, _pick2.default)(selection, Object.keys(_properties2))
        });
        return inverse;
      }

      /**
       * Set data.
       */

      if (type == 'set_data') {
        var _properties3 = op.properties,
          data = op.data;
        return _extends({}, op, {
          data: data.merge(_properties3),
          properties: (0, _pick2.default)(data, Object.keys(_properties3))
        });
      }

      /**
       * Unknown.
       */

      throw new Error('Unknown op type: "' + type + '".');
    }

    /**
     * Export.
     *
     * @type {Function}
     */

    exports.default = invertOperation;

    /***/
  }), ( /* 234 */
  /***/function (module, exports, __webpack_require__) {
    var ListCache = __webpack_require__(100),
      stackClear = __webpack_require__(663),
      stackDelete = __webpack_require__(664),
      stackGet = __webpack_require__(665),
      stackHas = __webpack_require__(666),
      stackSet = __webpack_require__(667);

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;
    module.exports = Stack;

    /***/
  }), ( /* 235 */
  /***/function (module, exports) {
    /**
     * Appends the elements of `values` to `array`.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to append.
     * @returns {Array} Returns `array`.
     */
    function arrayPush(array, values) {
      var index = -1,
        length = values.length,
        offset = array.length;
      while (++index < length) {
        array[offset + index] = values[index];
      }
      return array;
    }
    module.exports = arrayPush;

    /***/
  }), ( /* 236 */
  /***/function (module, exports, __webpack_require__) {
    var baseMatches = __webpack_require__(608),
      baseMatchesProperty = __webpack_require__(609),
      identity = __webpack_require__(244),
      isArray = __webpack_require__(26),
      property = __webpack_require__(676);

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
      }
      return property(value);
    }
    module.exports = baseIteratee;

    /***/
  }), ( /* 237 */
  /***/function (module, exports, __webpack_require__) {
    var getNative = __webpack_require__(44);
    var defineProperty = function () {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }();
    module.exports = defineProperty;

    /***/
  }), ( /* 238 */
  /***/function (module, exports, __webpack_require__) {
    var SetCache = __webpack_require__(588),
      arraySome = __webpack_require__(595),
      cacheHas = __webpack_require__(619);

    /** Used to compose bitmasks for value comparisons. */
    var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
        arrLength = array.length,
        othLength = other.length;
      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
        result = true,
        seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;
      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
          othValue = other[index];
        if (customizer) {
          var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function (othValue, othIndex) {
            if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
            result = false;
            break;
          }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }
    module.exports = equalArrays;

    /***/
  }), ( /* 239 */
  /***/function (module, exports, __webpack_require__) {
    /* WEBPACK VAR INJECTION */(function (global) {
      /** Detect free variable `global` from Node.js. */
      var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
      module.exports = freeGlobal;

      /* WEBPACK VAR INJECTION */
    }).call(exports, __webpack_require__(80));

    /***/
  }), ( /* 240 */
  /***/function (module, exports, __webpack_require__) {
    var isObject = __webpack_require__(78);

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }
    module.exports = isStrictComparable;

    /***/
  }), ( /* 241 */
  /***/function (module, exports) {
    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function (object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
      };
    }
    module.exports = matchesStrictComparable;

    /***/
  }), ( /* 242 */
  /***/function (module, exports) {
    /** Used for built-in method references. */
    var funcProto = Function.prototype;

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return func + '';
        } catch (e) {}
      }
      return '';
    }
    module.exports = toSource;

    /***/
  }), ( /* 243 */
  /***/function (module, exports, __webpack_require__) {
    var baseHasIn = __webpack_require__(601),
      hasPath = __webpack_require__(631);

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }
    module.exports = hasIn;

    /***/
  }), ( /* 244 */
  /***/function (module, exports) {
    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }
    module.exports = identity;

    /***/
  }), ( /* 245 */
  /***/function (module, exports, __webpack_require__) {
    var isFunction = __webpack_require__(247),
      isLength = __webpack_require__(159);

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }
    module.exports = isArrayLike;

    /***/
  }), ( /* 246 */
  /***/function (module, exports, __webpack_require__) {
    /* WEBPACK VAR INJECTION */(function (module) {
      var root = __webpack_require__(25),
        stubFalse = __webpack_require__(678);

      /** Detect free variable `exports`. */
      var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

      /** Detect free variable `module`. */
      var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

      /** Detect the popular CommonJS extension `module.exports`. */
      var moduleExports = freeModule && freeModule.exports === freeExports;

      /** Built-in value references. */
      var Buffer = moduleExports ? root.Buffer : undefined;

      /* Built-in method references for those with the same name as other `lodash` methods. */
      var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

      /**
       * Checks if `value` is a buffer.
       *
       * @static
       * @memberOf _
       * @since 4.3.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
       * @example
       *
       * _.isBuffer(new Buffer(2));
       * // => true
       *
       * _.isBuffer(new Uint8Array(2));
       * // => false
       */
      var isBuffer = nativeIsBuffer || stubFalse;
      module.exports = isBuffer;

      /* WEBPACK VAR INJECTION */
    }).call(exports, __webpack_require__(106)(module));

    /***/
  }), ( /* 247 */
  /***/function (module, exports, __webpack_require__) {
    var baseGetTag = __webpack_require__(76),
      isObject = __webpack_require__(78);

    /** `Object#toString` result references. */
    var asyncTag = '[object AsyncFunction]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      proxyTag = '[object Proxy]';

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }
    module.exports = isFunction;

    /***/
  }), ( /* 248 */
  /***/function (module, exports, __webpack_require__) {
    var baseIsTypedArray = __webpack_require__(606),
      baseUnary = __webpack_require__(618),
      nodeUtil = __webpack_require__(654);

    /* Node.js helper references. */
    var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
    module.exports = isTypedArray;

    /***/
  }), ( /* 249 */
  /***/function (module, exports) {
    /*
    	MIT License http://www.opensource.org/licenses/mit-license.php
    	Author Tobias Koppers @sokra
    */
    var stylesInDom = {},
      memoize = function memoize(fn) {
        var memo;
        return function () {
          if (typeof memo === "undefined") memo = fn.apply(this, arguments);
          return memo;
        };
      },
      isOldIE = memoize(function () {
        return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
      }),
      getHeadElement = memoize(function () {
        return document.head || document.getElementsByTagName("head")[0];
      }),
      singletonElement = null,
      singletonCounter = 0,
      styleElementsInsertedAtTop = [];
    module.exports = function (list, options) {
      if (typeof DEBUG !== "undefined" && DEBUG) {
        if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
      }
      options = options || {};
      // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
      // tags it will allow on a page
      if (typeof options.singleton === "undefined") options.singleton = isOldIE();

      // By default, add <style> tags to the bottom of <head>.
      if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
      var styles = listToStyles(list);
      addStylesToDom(styles, options);
      return function update(newList) {
        var mayRemove = [];
        for (var i = 0; i < styles.length; i++) {
          var item = styles[i];
          var domStyle = stylesInDom[item.id];
          domStyle.refs--;
          mayRemove.push(domStyle);
        }
        if (newList) {
          var newStyles = listToStyles(newList);
          addStylesToDom(newStyles, options);
        }
        for (var i = 0; i < mayRemove.length; i++) {
          var domStyle = mayRemove[i];
          if (domStyle.refs === 0) {
            for (var j = 0; j < domStyle.parts.length; j++) {
              domStyle.parts[j]();
            }
            delete stylesInDom[domStyle.id];
          }
        }
      };
    };
    function addStylesToDom(styles, options) {
      for (var i = 0; i < styles.length; i++) {
        var item = styles[i];
        var domStyle = stylesInDom[item.id];
        if (domStyle) {
          domStyle.refs++;
          for (var j = 0; j < domStyle.parts.length; j++) {
            domStyle.parts[j](item.parts[j]);
          }
          for (; j < item.parts.length; j++) {
            domStyle.parts.push(addStyle(item.parts[j], options));
          }
        } else {
          var parts = [];
          for (var j = 0; j < item.parts.length; j++) {
            parts.push(addStyle(item.parts[j], options));
          }
          stylesInDom[item.id] = {
            id: item.id,
            refs: 1,
            parts: parts
          };
        }
      }
    }
    function listToStyles(list) {
      var styles = [];
      var newStyles = {};
      for (var i = 0; i < list.length; i++) {
        var item = list[i];
        var id = item[0];
        var css = item[1];
        var media = item[2];
        var sourceMap = item[3];
        var part = {
          css: css,
          media: media,
          sourceMap: sourceMap
        };
        if (!newStyles[id]) styles.push(newStyles[id] = {
          id: id,
          parts: [part]
        });else newStyles[id].parts.push(part);
      }
      return styles;
    }
    function insertStyleElement(options, styleElement) {
      var head = getHeadElement();
      var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
      if (options.insertAt === "top") {
        if (!lastStyleElementInsertedAtTop) {
          head.insertBefore(styleElement, head.firstChild);
        } else if (lastStyleElementInsertedAtTop.nextSibling) {
          head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
        } else {
          head.appendChild(styleElement);
        }
        styleElementsInsertedAtTop.push(styleElement);
      } else if (options.insertAt === "bottom") {
        head.appendChild(styleElement);
      } else {
        throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
      }
    }
    function removeStyleElement(styleElement) {
      styleElement.parentNode.removeChild(styleElement);
      var idx = styleElementsInsertedAtTop.indexOf(styleElement);
      if (idx >= 0) {
        styleElementsInsertedAtTop.splice(idx, 1);
      }
    }
    function createStyleElement(options) {
      var styleElement = document.createElement("style");
      styleElement.type = "text/css";
      insertStyleElement(options, styleElement);
      return styleElement;
    }
    function createLinkElement(options) {
      var linkElement = document.createElement("link");
      linkElement.rel = "stylesheet";
      insertStyleElement(options, linkElement);
      return linkElement;
    }
    function addStyle(obj, options) {
      var styleElement, update, remove;
      if (options.singleton) {
        var styleIndex = singletonCounter++;
        styleElement = singletonElement || (singletonElement = createStyleElement(options));
        update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
        remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
      } else if (obj.sourceMap && typeof URL === "function" && typeof URL.createObjectURL === "function" && typeof URL.revokeObjectURL === "function" && typeof Blob === "function" && typeof btoa === "function") {
        styleElement = createLinkElement(options);
        update = updateLink.bind(null, styleElement);
        remove = function remove() {
          removeStyleElement(styleElement);
          if (styleElement.href) URL.revokeObjectURL(styleElement.href);
        };
      } else {
        styleElement = createStyleElement(options);
        update = applyToTag.bind(null, styleElement);
        remove = function remove() {
          removeStyleElement(styleElement);
        };
      }
      update(obj);
      return function updateStyle(newObj) {
        if (newObj) {
          if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) return;
          update(obj = newObj);
        } else {
          remove();
        }
      };
    }
    var replaceText = function () {
      var textStore = [];
      return function (index, replacement) {
        textStore[index] = replacement;
        return textStore.filter(Boolean).join('\n');
      };
    }();
    function applyToSingletonTag(styleElement, index, remove, obj) {
      var css = remove ? "" : obj.css;
      if (styleElement.styleSheet) {
        styleElement.styleSheet.cssText = replaceText(index, css);
      } else {
        var cssNode = document.createTextNode(css);
        var childNodes = styleElement.childNodes;
        if (childNodes[index]) styleElement.removeChild(childNodes[index]);
        if (childNodes.length) {
          styleElement.insertBefore(cssNode, childNodes[index]);
        } else {
          styleElement.appendChild(cssNode);
        }
      }
    }
    function applyToTag(styleElement, obj) {
      var css = obj.css;
      var media = obj.media;
      if (media) {
        styleElement.setAttribute("media", media);
      }
      if (styleElement.styleSheet) {
        styleElement.styleSheet.cssText = css;
      } else {
        while (styleElement.firstChild) {
          styleElement.removeChild(styleElement.firstChild);
        }
        styleElement.appendChild(document.createTextNode(css));
      }
    }
    function updateLink(linkElement, obj) {
      var css = obj.css;
      var sourceMap = obj.sourceMap;
      if (sourceMap) {
        // http://stackoverflow.com/a/26603875
        css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
      }
      var blob = new Blob([css], {
        type: "text/css"
      });
      var oldSrc = linkElement.href;
      linkElement.href = URL.createObjectURL(blob);
      if (oldSrc) URL.revokeObjectURL(oldSrc);
    }

    /***/
  }), ( /* 250 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var isValue = __webpack_require__(58),
      isObject = __webpack_require__(162),
      stringCoerce = __webpack_require__(691),
      toShortString = __webpack_require__(688);
    var resolveMessage = function resolveMessage(message, value) {
      return message.replace("%v", toShortString(value));
    };
    module.exports = function (value, defaultMessage, inputOptions) {
      if (!isObject(inputOptions)) throw new TypeError(resolveMessage(defaultMessage, value));
      if (!isValue(value)) {
        if ("default" in inputOptions) return inputOptions["default"];
        if (inputOptions.isOptional) return null;
      }
      var errorMessage = stringCoerce(inputOptions.errorMessage);
      if (!isValue(errorMessage)) errorMessage = defaultMessage;
      throw new TypeError(resolveMessage(errorMessage, value));
    };

    /***/
  }), ( /* 251 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var isFunction = __webpack_require__(686);
    var classRe = /^\s*class[\s{/}]/,
      functionToString = Function.prototype.toString;
    module.exports = function (value) {
      if (!isFunction(value)) return false;
      if (classRe.test(functionToString.call(value))) return false;
      return true;
    };

    /***/
  }), ( /* 252 */
  /***/function (module, exports) {
    module.exports = /[\0-\x1F\x7F-\x9F]/;

    /***/
  }), ( /* 253 */
  /***/function (module, exports) {
    module.exports = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;

    /***/
  }), ( /* 254 */
  /***/function (module, exports) {
    module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

    /***/
  }), ( /* 255 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    /**
     * Copyright 2014-2015, Facebook, Inc.
     * All rights reserved.
     *
     * This source code is licensed under the BSD-style license found in the
     * LICENSE file in the root directory of this source tree. An additional grant
     * of patent rights can be found in the PATENTS file in the same directory.
     */

    /**
     * Similar to invariant but only logs a warning if the condition is not met.
     * This can be used to log issues in development environments in critical
     * paths. Removing the logging code for production environments will keep the
     * same logic and follow the same code paths.
     */
    var warning = function warning() {};
    if (false) {
      warning = function warning(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for (var key = 2; key < len; key++) {
          args[key - 2] = arguments[key];
        }
        if (format === undefined) {
          throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
        }
        if (format.length < 10 || /^[s\W]*$/.test(format)) {
          throw new Error('The warning format should be able to uniquely identify this ' + 'warning. Please, use a more descriptive format than: ' + format);
        }
        if (!condition) {
          var argIndex = 0;
          var message = 'Warning: ' + format.replace(/%s/g, function () {
            return args[argIndex++];
          });
          if (typeof console !== 'undefined') {
            console.error(message);
          }
          try {
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
          } catch (x) {}
        }
      };
    }
    module.exports = warning;

    /***/
  }), ( /* 256 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = __webpack_require__(261).default;

    /***/
  }), ( /* 257 */
  /***/function (module, exports, __webpack_require__) {
    __webpack_require__(354);
    __webpack_require__(195);
    __webpack_require__(384);
    __webpack_require__(355);
    module.exports = __webpack_require__(36).Promise;

    /***/
  }), ( /* 258 */
  /***/function (module, exports, __webpack_require__) {
    __webpack_require__(369);
    __webpack_require__(373);
    __webpack_require__(380);
    __webpack_require__(195);
    __webpack_require__(364);
    __webpack_require__(365);
    __webpack_require__(370);
    __webpack_require__(374);
    __webpack_require__(376);
    __webpack_require__(360);
    __webpack_require__(361);
    __webpack_require__(362);
    __webpack_require__(363);
    __webpack_require__(366);
    __webpack_require__(367);
    __webpack_require__(368);
    __webpack_require__(371);
    __webpack_require__(372);
    __webpack_require__(375);
    __webpack_require__(377);
    __webpack_require__(378);
    __webpack_require__(379);
    __webpack_require__(356);
    __webpack_require__(357);
    __webpack_require__(358);
    __webpack_require__(359);
    module.exports = __webpack_require__(36).String;

    /***/
  }), ( /* 259 */
  /***/function (module, exports, __webpack_require__) {
    __webpack_require__(383);
    __webpack_require__(381);
    __webpack_require__(382);
    module.exports = __webpack_require__(36).Array;

    /***/
  }), ( /* 260 */
  /***/function (module, exports) {
    function _extends() {
      module.exports = _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
      return _extends.apply(this, arguments);
    }
    module.exports = _extends;

    /***/
  }), ( /* 261 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    var _class, _temp2;
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _propTypes = __webpack_require__(15);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _PlainMarkdownInput = __webpack_require__(270);
    var _PlainMarkdownInput2 = _interopRequireDefault(_PlainMarkdownInput);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var MarkdownInput = (_temp2 = _class = function (_React$Component) {
      _inherits(MarkdownInput, _React$Component);
      function MarkdownInput() {
        var _ref;
        var _temp, _this, _ret;
        _classCallCheck(this, MarkdownInput);
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MarkdownInput.__proto__ || Object.getPrototypeOf(MarkdownInput)).call.apply(_ref, [this].concat(args))), _this), _this.plainInputRef = function (el) {
          return _this.plainInput = el;
        }, _this.insertAtCursorPosition = function (text) {
          if (_this.plainInput) {
            _this.plainInput.insertAtCursorPosition(text);
          }
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      // make this function a part of public API

      _createClass(MarkdownInput, [{
        key: 'render',
        value: function render() {
          return _react2.default.createElement(_PlainMarkdownInput2.default, _extends({}, this.props, {
            ref: this.plainInputRef
          }));
        }
      }]);
      return MarkdownInput;
    }(_react2.default.Component), _class.propTypes = {
      value: _propTypes2.default.string,
      onChange: _propTypes2.default.func,
      onBlur: _propTypes2.default.func,
      onFullScreen: _propTypes2.default.func,
      extensions: _propTypes2.default.array,
      additionalButtons: _propTypes2.default.array,
      readOnly: _propTypes2.default.bool,
      autoFocus: _propTypes2.default.bool,
      showFullScreenButton: _propTypes2.default.bool,
      spellCheck: _propTypes2.default.bool,
      locale: _propTypes2.default.string,
      hideToolbar: _propTypes2.default.bool
    }, _class.defaultProps = {
      value: '',
      onChange: function onChange() {},
      onBlur: function onBlur() {},
      onFullScreen: function onFullScreen() {},
      extensions: [],
      additionalButtons: [],
      readOnly: false,
      autoFocus: true,
      showFullScreenButton: false,
      spellCheck: false,
      locale: 'en',
      hideToolbar: false
    }, _temp2);
    exports.default = MarkdownInput;

    /***/
  }), ( /* 262 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = undefined;
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    var _class, _temp2;
    var _react = __webpack_require__(0);
    var _reactDom = __webpack_require__(4);
    var _propTypes = __webpack_require__(15);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    /**
     * This setup is needed to create proper `blur` handler.
     * Slate-react Editor has `onBlur` prop, but if we just supply it to Editor component,
     * `blur` will fire when a user clicks buttons B, I etc. But we need `blur` to fire only when
     * component loses focus, and not when we operate with internal elements of editor.
     */
    var ProvideBlur = (_temp2 = _class = function (_PureComponent) {
      _inherits(ProvideBlur, _PureComponent);
      function ProvideBlur() {
        var _ref;
        var _temp, _this, _ret;
        _classCallCheck(this, ProvideBlur);
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProvideBlur.__proto__ || Object.getPrototypeOf(ProvideBlur)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
          isFocused: false
        }, _this.handleFocusIn = function (event) {
          // IE11 & firefox trigger focusout when you click on PlainMarkdownInput.
          // In order to eliminate it we can stop listening for focusout when focusin occurs.
          _this.el.removeEventListener('focusout', _this.handleFocusOut);
          setTimeout(function (_) {
            return _this.el && _this.el.addEventListener('focusout', _this.handleFocusOut);
          });
          return _this.setState(function (prevState) {
            return prevState.isFocused ? {} : {
              isFocused: true
            };
          });
        }, _this.timeout = null, _this.abortFocusOut = function (_) {
          clearTimeout(_this.timeout);
        }, _this.handleFocusOut = function (event) {
          _this.el.addEventListener('focusin', _this.abortFocusOut);
          _this.timeout = setTimeout(function (_) {
            if (_this.el) {
              _this.el.removeEventListener('focusin', _this.abortFocusOut);
            }
            _this.setState({
              isFocused: false
            });
          });
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }
      _createClass(ProvideBlur, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.el = (0, _reactDom.findDOMNode)(this);
          this.el.addEventListener('focusin', this.handleFocusIn);
          this.el.addEventListener('focusout', this.handleFocusOut);
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
          var prevFocused = prevState.isFocused;
          var isFocused = this.state.isFocused;
          if (isFocused && prevFocused !== isFocused) {
            this.props.onFocus();
          }
          if (!isFocused && prevFocused !== isFocused) {
            this.props.onBlur();
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this.el.removeEventListener('focusin', this.handleFocusIn);
          this.el.removeEventListener('focusout', this.handleFocusOut);
        }
      }, {
        key: 'render',
        value: function render() {
          var children = this.props.children;
          return children instanceof Function ? children() : children;
        }
      }]);
      return ProvideBlur;
    }(_react.PureComponent), _class.propTypes = {
      onBlur: _propTypes2.default.func,
      onFocus: _propTypes2.default.func
    }, _class.defaultProps = {
      onBlur: function onBlur() {},
      onFocus: function onFocus() {}
    }, _temp2);
    exports.default = ProvideBlur;

    /***/
  }), ( /* 263 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.getCopyText = undefined;
    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    var _class, _temp2;
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _reactDom = __webpack_require__(4);
    var _propTypes = __webpack_require__(15);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _classnames = __webpack_require__(121);
    var _classnames2 = _interopRequireDefault(_classnames);
    var _DropdownButton = __webpack_require__(523);
    var _DropdownButton2 = _interopRequireDefault(_DropdownButton);
    var _slateReact = __webpack_require__(557);
    var _slatePlainSerializer = __webpack_require__(552);
    var _slatePlainSerializer2 = _interopRequireDefault(_slatePlainSerializer);
    var _schema = __webpack_require__(277);
    var _schema2 = _interopRequireDefault(_schema);
    __webpack_require__(683);
    var _tokenizer = __webpack_require__(164);
    var _translations = __webpack_require__(59);
    var _translations2 = _interopRequireDefault(_translations);
    var _utils = __webpack_require__(107);
    var _plugins = __webpack_require__(271);
    var _buttons = __webpack_require__(269);
    var _transforms = __webpack_require__(165);
    var _FocusBlur = __webpack_require__(262);
    var _FocusBlur2 = _interopRequireDefault(_FocusBlur);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var ACCENTS = {
      b: 'bold',
      i: 'italic',
      s: 'strikethrough'
    };
    var getCopyText = exports.getCopyText = function getCopyText(_ref) {
      var startKey = _ref.startKey,
        startOffset = _ref.startOffset,
        endKey = _ref.endKey,
        endOffset = _ref.endOffset,
        texts = _ref.texts;
      return startKey === endKey ? texts.get(0).text.slice(startOffset, endOffset) : texts.map(function (el, i) {
        if (i === 0) {
          return el.text.slice(startOffset);
        } else if (i === texts.size - 1) {
          return el.text.slice(0, endOffset);
        } else {
          return el.text;
        }
      }).join('\n');
    };
    function copySelectionToClipboard(event, _ref2) {
      var state = _ref2.state;
      event.preventDefault();
      var copyText = getCopyText(state);
      if (window.clipboardData) {
        window.clipboardData.setData("Text", copyText);
      } else {
        event.clipboardData.setData('text/plain', copyText);
      }
    }
    var PlainMarkdownInput = (_temp2 = _class = function (_PureComponent) {
      _inherits(PlainMarkdownInput, _PureComponent);
      function PlainMarkdownInput() {
        var _ref3;
        var _temp, _this, _ret;
        _classCallCheck(this, PlainMarkdownInput);
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = PlainMarkdownInput.__proto__ || Object.getPrototypeOf(PlainMarkdownInput)).call.apply(_ref3, [this].concat(args))), _this), _this.state = {
          editorState: '',
          fullScreen: false,
          isActive: true // for fix about widget position: hide widget if editor is not focused currently
        }, _this.isAutocompleteShow = false, _this.handleNewValue = function (value) {
          var editorState = _slatePlainSerializer2.default.deserialize(value);
          var nodes = editorState.document.nodes.asMutable();
          var nodesSize = nodes.size;
          for (var i = 0; i < nodesSize; i++) {
            _this.setDataToNode(nodes, i);
          }
          editorState = _this.setNodesToState(editorState, nodes);
          _this.setState({
            editorState: editorState
          });
        }, _this.setDataToNode = function (nodes, numBlock, text) {
          var currNode = nodes.get(numBlock).asMutable();
          text = text || currNode.nodes.get(0).text; // eslint-disable-line
          currNode.data = {
            text: text,
            tokens: (0, _tokenizer.parse)(text),
            toJSON: function toJSON() {
              return text;
            }
          };
          nodes.set(numBlock, currNode.asImmutable());
        }, _this.handleAutocompleteToggle = function (flag) {
          _this.isAutocompleteShow = flag;
        }, _this.handleMouseUp = function () {
          var change = _this.state.editorState.change();
          change.focus();
          _this.setState({
            editorState: change.state
          });
        }, _this.handleChange = function (obj) {
          var isSetFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

          // XXX Slate "Editor.props.onChange" behavior changed
          // https://github.com/ianstormtaylor/slate/blob/master/packages/slate/Changelog.md#0220--september-5-2017
          var editorState = obj.state || obj;
          var selection = (0, _transforms.copySelection)(editorState);
          var numBlock = -1;
          var key = editorState.blocks.get(0).key;
          var nodesSize = editorState.document.nodes.size;
          for (var i = 0; i < nodesSize; i++) {
            if (key === editorState.document.nodes.get(i).key) {
              numBlock = i;
              break;
            }
          }
          if (numBlock !== -1) {
            var text = editorState.texts.get(0).text;
            var nodes = editorState.document.nodes.asMutable();
            _this.setDataToNode(nodes, numBlock, text);
            editorState = _this.setNodesToState(editorState, nodes);
          }

          // Slate emits onChange not only when text changes,
          // but also when caret changes position or editor gains/loses focus.
          // Slate needs this because it's inner state essentially changes,
          // (cursor position, focused status, etc), but we need to emit only real changes in text value.
          var oldValue = _slatePlainSerializer2.default.serialize(_this.state.editorState);
          var newValue = _slatePlainSerializer2.default.serialize(editorState);
          if (oldValue !== newValue) {
            _this.props.onChange(newValue);
          }
          _this.setState({
            editorState: editorState
          });
          setTimeout(function () {
            (0, _utils.autoScrollToTop)();
            if (isSetFocus) {
              var _editorState = (0, _transforms.setSelectionToState)(_this.state.editorState, selection);
              _this.setState({
                editorState: _editorState
              });
            }
          }, 0);
        }, _this.handleFullScreen = function () {
          var fullScreen = !_this.state.fullScreen;
          document.body.style.overflow = fullScreen ? 'hidden' : _this.initialBodyOverflowStyle;
          _this.setState({
            fullScreen: fullScreen
          });
          _this.props.onFullScreen(fullScreen);
        }, _this.toggleAccent = function (state, accent) {
          return _this.handleChange((0, _transforms.hasAccent)(state, accent) ? (0, _transforms.unwrapAccent)(state, accent) : (0, _transforms.wrapAccent)(state, accent), true);
        }, _this.handleKeyDown = function (event, data, change) {
          if (data.isMod && data.key === 'v') {
            return _this.handlePaste(event, change);
          }
          if (data.isMod && ACCENTS[data.key]) {
            if (data.key === 's') {
              event.preventDefault();
            }
            return _this.toggleAccent(change.state, ACCENTS[data.key]);
          }
          if (data.key === 'enter' && !_this.isAutocompleteShow) {
            var state = change.state;
            if ((0, _transforms.hasAccent)(state, 'ul')) {
              return _this.handleEnterFromListDown(change, 'ul');
            } else if ((0, _transforms.hasAccent)(state, 'ol')) {
              return _this.handleEnterFromListDown(change, 'ol');
            }
          }
          return undefined;
        }, _this.handleCopy = function (event, data, change) {
          copySelectionToClipboard(event, change);
          return change;
        }, _this.handleCut = function (event, data, change) {
          copySelectionToClipboard(event, change);
          change.deleteAtRange(change.state.selection);
          return change;
        }, _this.handleRef = function (ref) {
          _this.slateContentRef = ref;
        }, _this.focus = function () {
          if (_this.slateContentRef) {
            _this.slateContentRef.focus();
          }
        }, _this.handleScroll = function () {
          if (navigator.userAgent.match(/msie/i) || navigator.userAgent.match(/trident/i)) {
            // Works in the modal mode only in IE
            // In other browsers interception of focus does not work in the modal mode
            // (XXX: autocomplete widget loses focus after click on autocomplete scroll,
            // as a result pressing the Up Arrow and Down Arrow buttons cease to be processed)
            _this.focus();
          } else {
            // This code in case of execution in IE as a ghost effect scrolls the content of the block to the top
            (0, _reactDom.findDOMNode)(_this.slateContentRef).getElementsByClassName('react-markdown--slate-content__editor')[0].focus();
          }
        }, _this.handleActionButtonClick = function (accent) {
          return _this.toggleAccent(_this.state.editorState, accent);
        }, _this.handleHeaderButtonClick = function (level) {
          var state = _this.state.editorState;
          return _this.handleChange((0, _transforms.hasHeader)(state, level) ? (0, _transforms.unwrapHeader)(state, level) : (0, _transforms.wrapHeader)(state, level));
        }, _this.handleLinkButtonClick = function () {
          return _this.handleChange((0, _transforms.wrapLink)(_this.state.editorState));
        }, _this.getCurrentText = function () {
          return _this.state.editorState.document.nodes.toArray().map(function (block) {
            return block.text;
          }).join('\n');
        }, _this.insertAtCursorPosition = function (insertedText) {
          var change = _this.state.editorState.change();
          change.delete().insertText(insertedText).focus();
          return _this.handleChange(change.state, true);
        }, _this.handleAdditionalButtonsClick = function (handleButtonPress) {
          handleButtonPress({
            value: _this.getCurrentText(),
            insertAtCursorPosition: _this.insertAtCursorPosition
          });
        }, _this.getAccentButtons = function (_ref4) {
          var editorValue = _ref4.editorValue,
            disabled = _ref4.disabled,
            locale = _ref4.locale,
            accents = _ref4.accents;
          return _this.wrapButtonGroup(accents.map(function (accent, i) {
            return _react2.default.createElement(_buttons.ActionButton, {
              key: i,
              onClick: _this.handleActionButtonClick,
              disabled: disabled,
              locale: locale,
              accent: accent,
              active: (0, _transforms.hasAccent)(editorValue, accent)
            });
          }));
        }, _this.getLinkButton = function (_ref5) {
          var disabled = _ref5.disabled,
            locale = _ref5.locale;
          return _this.wrapButtonGroup(_react2.default.createElement(_buttons.LinkButton, {
            onClick: _this.handleLinkButtonClick,
            disabled: disabled,
            locale: locale
          }));
        }, _this.getHeaderButtons = function (_ref6) {
          var disabled = _ref6.disabled,
            locale = _ref6.locale;
          return _react2.default.createElement('div', {
            className: 'btn-group',
            title: (0, _translations2.default)(locale, 'insertHeader')
          }, _react2.default.createElement(_DropdownButton2.default, {
            id: 'oc-md--toolbar__headers-dropdown',
            title: _react2.default.createElement('i', {
              className: 'fa fa-header'
            }),
            disabled: disabled
          }, [1, 2, 3, 4, 5, 6].map(function (level, i) {
            return _react2.default.createElement(_buttons.HeaderButton, {
              key: i,
              onClick: _this.handleHeaderButtonClick,
              level: level
            });
          })));
        }, _this.getFullScreenButton = function (_ref7) {
          var readOnly = _ref7.readOnly,
            locale = _ref7.locale,
            fullScreen = _ref7.fullScreen;
          return _this.props.showFullScreenButton ? _react2.default.createElement('div', {
            className: 'btn-group react-markdown--plain-markdown-input__left-border'
          }, _react2.default.createElement(_buttons.FullScreenButton, {
            onClick: _this.handleFullScreen,
            locale: locale,
            fullScreen: fullScreen,
            disabled: readOnly
          })) : '';
        }, _this.wrapButtonGroup = function (children) {
          return _react2.default.createElement('div', {
            className: 'btn-group'
          }, children);
        }, _this.handleBlur = function (event) {
          if (event && event.persist) {
            event.persist();
          }
          _this.setState(function (prevState) {
            var change = prevState.editorState.change();
            change.blur();
            return _extends({
              editorState: change.state
            }, prevState.isActive && {
              isActive: false
            });
          }, function (_) {
            return _this.props.onBlur(event);
          });
        }, _this.handleFocus = function (_) {
          return _this.setState(function (prevState) {
            var change = prevState.editorState.change();
            change.focus();
            return _extends({
              editorState: change.state
            }, !prevState.isActive && {
              isActive: true
            });
          });
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }
      _createClass(PlainMarkdownInput, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          this.initialBodyOverflowStyle = document.body.style.overflow;
          this.handleNewValue(this.props.value);
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.setState({
            containerRef: this.container
          }); // eslint-disable-line react/no-did-mount-set-state
        }
      }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
          if (this.props.value !== nextProps.value) {
            this.handleNewValue(nextProps.value);
          }
        }

        /**
         * handleNewValue
         *
         * @param {string} value - Editor's text. The line's ends in a text editor should be \n - Unix mode(LF)
         */
      }, {
        key: 'setNodesToState',
        value: function setNodesToState(editorState, nodes) {
          var editorStateMutable = editorState.asMutable();
          editorStateMutable.document = editorStateMutable.document.asMutable();
          editorStateMutable.document.nodes = nodes.asImmutable();
          editorStateMutable.document = editorStateMutable.document.asImmutable();
          return editorStateMutable.asImmutable();
        }
      }, {
        key: 'handleEnterFromListDown',
        value: function handleEnterFromListDown(change, accent) {
          var _this2 = this;

          // eslint-disable-line
          var lineText = change.state.texts.get(0).text;
          var text = void 0,
            listMarker = void 0,
            pref = void 0,
            itemNum = void 0,
            div = void 0;
          if (accent === 'ul') {
            listMarker = (0, _transforms.getUlMarker)(lineText);
            text = listMarker || '* ';
          } else {
            var _getOlNum = (0, _transforms.getOlNum)(lineText);
            pref = _getOlNum.pref;
            itemNum = _getOlNum.itemNum;
            div = _getOlNum.div;
            listMarker = _getOlNum.listMarker;
            text = '' + pref + ++itemNum + div + ' ';
          }
          if (lineText.trim() === listMarker.trim()) {
            change.moveStart(-text.length).delete();
            return this.handleChange(change.state);
          }
          setTimeout(function () {
            var editorState = _this2.state.editorState;
            change = editorState.change(); // eslint-disable-line
            change.insertText(text);
            _this2.handleChange(change.state);
          }, 5);
        }
      }, {
        key: 'handlePaste',
        value: function handlePaste(event, change) {
          if (!window.clipboardData) {
            // for chrome and ff
            return undefined;
          }
          event.preventDefault();
          var pasteText = window.clipboardData.getData("Text");
          var txtArr = pasteText.split('\n');
          if (txtArr.length > 1) {
            // insert multiline text
            for (var i = 0; i < txtArr.length; i++) {
              change.insertText(txtArr[i]);
              if (i < txtArr.length - 1) {
                change.splitBlock(1);
              }
            }
          } else {
            change.insertText(pasteText);
          }
          change.focus();
          return this.handleChange(change.state);
        }
      }, {
        key: 'getAdditionalButtons',
        /**
         * Create additional buttons
         *
         * @param readOnly
         */
        value: function getAdditionalButtons(readOnly) {
          var _this3 = this;
          return _react2.default.createElement('div', {
            className: 'btn-group react-markdown--plain-markdown-input__right-buttons'
          }, this.props.additionalButtons.map(function (buttonData, i) {
            return _react2.default.createElement(_buttons.AdditionalButton, {
              key: i,
              onClick: _this3.handleAdditionalButtonsClick,
              settings: buttonData,
              disabled: readOnly
            });
          }));
        }

        /**
         * Create buttons' group for accents
         *
         * @param editorValue
         * @param disabled
         * @param locale
         * @param accents
         * @returns {*}
         */

        /**
         * Create buttons' group for links
         *
         * @param disabled
         * @param locale
         * @returns {*}
         */

        /**
         * Create buttons' group for headers
         *
         * @param disabled
         * @param locale
         * @returns {*}
         */

        /**
         * Create buttons' group for fullScreenButton
         *
         * @param readOnly
         * @param locale
         * @param fullScreen
         * @returns {string}
         */

        /**
         * Wrap buttons' group
         *
         * @param children
         * @returns {*}
         */
      }, {
        key: 'render',
        value: function render() {
          var _this4 = this;
          var _state = this.state,
            editorState = _state.editorState,
            fullScreen = _state.fullScreen;
          var _props = this.props,
            children = _props.children,
            extensions = _props.extensions,
            readOnly = _props.readOnly,
            locale = _props.locale,
            autoFocus = _props.autoFocus,
            hideToolbar = _props.hideToolbar,
            spellCheck = _props.spellCheck;
          var disabled = readOnly || (0, _transforms.hasMultiLineSelection)(editorState);

          // Create buttons for toolbar
          var emphasisButtons = this.getAccentButtons({
            editorValue: editorState,
            disabled: disabled,
            locale: locale,
            accents: ['bold', 'italic', 'strikethrough']
          });
          var linkButton = this.getLinkButton({
            disabled: disabled,
            locale: locale
          });
          var headerButtons = this.getHeaderButtons({
            disabled: disabled,
            locale: locale
          });
          var listButtons = this.getAccentButtons({
            editorValue: editorState,
            disabled: readOnly,
            locale: locale,
            accents: ['ol', 'ul']
          });
          var additionalButtons = this.getAdditionalButtons(readOnly);
          var fullScreenButton = this.getFullScreenButton({
            readOnly: readOnly,
            locale: locale,
            fullScreen: fullScreen
          });
          var editor = _react2.default.createElement(_slateReact.Editor, {
            spellCheck: spellCheck,
            state: editorState,
            fullScreen: fullScreen,
            autoFocus: autoFocus,
            schema: _schema2.default,
            onChange: this.handleChange,
            onCopy: this.handleCopy,
            onCut: this.handleCut,
            onKeyDown: this.handleKeyDown,
            plugins: [(0, _plugins.AutocompletePlugin)({
              extensions: extensions,
              locale: locale,
              onChange: this.handleChange,
              onScroll: this.handleScroll,
              onMouseUp: this.handleMouseUp,
              onToggle: this.handleAutocompleteToggle,
              editorIsActive: this.state.isActive,
              containerRef: this.state.containerRef
            })],
            readOnly: readOnly,
            className: 'react-markdown--slate-content__editor',
            ref: this.handleRef
          }, children);
          return _react2.default.createElement(_FocusBlur2.default, {
            onBlur: this.handleBlur,
            onFocus: this.handleFocus
          }, _react2.default.createElement('div', {
            className: (0, _classnames2.default)('react-markdown--slate-editor', {
              'react-markdown--slate-editor--fullscreen': fullScreen
            }),
            ref: function ref(el) {
              return _this4.container = el;
            }
          }, !hideToolbar && _react2.default.createElement('div', {
            className: 'react-markdown--toolbar'
          }, emphasisButtons, linkButton, headerButtons, listButtons, additionalButtons, fullScreenButton), _react2.default.createElement('div', _extends({
            className: 'react-markdown--slate-content'
          }, hideToolbar && {
            style: {
              borderTop: '0'
            }
          }), editor)));
        }
      }]);
      return PlainMarkdownInput;
    }(_react.PureComponent), _class.propTypes = {
      extensions: _propTypes2.default.array,
      additionalButtons: _propTypes2.default.array,
      value: _propTypes2.default.string,
      onChange: _propTypes2.default.func,
      onBlur: _propTypes2.default.func,
      onFullScreen: _propTypes2.default.func,
      readOnly: _propTypes2.default.bool,
      autoFocus: _propTypes2.default.bool,
      showFullScreenButton: _propTypes2.default.bool,
      spellCheck: _propTypes2.default.bool,
      locale: _propTypes2.default.string,
      hideToolbar: _propTypes2.default.bool
    }, _class.defaultProps = {
      extensions: [],
      additionalButtons: [],
      value: '',
      onFullScreen: function onFullScreen() {},
      onChange: function onChange() {},
      onBlur: function onBlur() {},
      readOnly: false,
      autoFocus: true,
      showFullScreenButton: false,
      spellCheck: false,
      locale: 'en'
    }, _temp2);
    exports.default = PlainMarkdownInput;

    /***/
  }), ( /* 264 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _propTypes = __webpack_require__(15);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _classnames = __webpack_require__(121);
    var _classnames2 = _interopRequireDefault(_classnames);
    var _translations = __webpack_require__(59);
    var _translations2 = _interopRequireDefault(_translations);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    var TITLES = {
      ul: 'bulletedList',
      ol: 'numberedList'
    };
    var CLASSNAMES = {
      ul: 'list-ul',
      ol: 'list-ol'
    };
    var ActionButton = function ActionButton(_ref) {
      var _onClick = _ref.onClick,
        disabled = _ref.disabled,
        locale = _ref.locale,
        accent = _ref.accent,
        active = _ref.active;
      return _react2.default.createElement('button', {
        className: (0, _classnames2.default)('btn btn-default', {
          active: active
        }),
        disabled: disabled,
        onClick: function onClick(e) {
          return _onClick(accent);
        },
        type: 'button',
        title: (0, _translations2.default)(locale, TITLES[accent] ? TITLES[accent] : accent)
      }, _react2.default.createElement('i', {
        className: 'fa fa-' + (CLASSNAMES[accent] ? CLASSNAMES[accent] : accent)
      }));
    };
    ActionButton.propTypes = {
      accent: _propTypes2.default.string,
      active: _propTypes2.default.bool,
      disabled: _propTypes2.default.bool,
      locale: _propTypes2.default.string,
      onClick: _propTypes2.default.func
    };
    ActionButton.defaultProps = {
      active: false,
      disabled: false,
      locale: 'en'
    };
    exports.default = ActionButton;

    /***/
  }), ( /* 265 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    var _class, _temp;
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _propTypes = __webpack_require__(15);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var AdditionalButton = (_temp = _class = function (_React$Component) {
      _inherits(AdditionalButton, _React$Component);
      function AdditionalButton() {
        _classCallCheck(this, AdditionalButton);
        return _possibleConstructorReturn(this, (AdditionalButton.__proto__ || Object.getPrototypeOf(AdditionalButton)).apply(this, arguments));
      }
      _createClass(AdditionalButton, [{
        key: 'render',
        value: function render() {
          var _props = this.props,
            settings = _props.settings,
            disabled = _props.disabled,
            _onClick = _props.onClick;
          return _react2.default.createElement('button', {
            className: 'btn btn-default',
            disabled: disabled,
            onClick: function onClick(e) {
              return settings.handleButtonPress ? _onClick(settings.handleButtonPress) : null;
            }
          }, settings.iconElement ? settings.iconElement : '', (settings.iconElement ? ' ' : '') + (settings.label ? settings.label : ''));
        }
      }]);
      return AdditionalButton;
    }(_react2.default.Component), _class.propTypes = {
      onClick: _propTypes2.default.func,
      disabled: _propTypes2.default.bool,
      settings: _propTypes2.default.object
    }, _class.defaultProps = {
      onClick: function onClick() {},
      disabled: false
    }, _temp);
    exports.default = AdditionalButton;

    /***/
  }), ( /* 266 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _classnames = __webpack_require__(121);
    var _classnames2 = _interopRequireDefault(_classnames);
    var _OverlayTrigger = __webpack_require__(529);
    var _OverlayTrigger2 = _interopRequireDefault(_OverlayTrigger);
    var _Tooltip = __webpack_require__(530);
    var _Tooltip2 = _interopRequireDefault(_Tooltip);
    var _propTypes = __webpack_require__(15);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _translations = __webpack_require__(59);
    var _translations2 = _interopRequireDefault(_translations);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    var FullScreenButton = function FullScreenButton(_ref) {
      var onClick = _ref.onClick,
        fullScreen = _ref.fullScreen,
        locale = _ref.locale;
      var msgKey = fullScreen ? 'Minimize' : 'Maximize';
      var tooltip = _react2.default.createElement(_Tooltip2.default, {
        id: 'switch-tp',
        className: 'fullscreen-tp'
      }, (0, _translations2.default)(locale, msgKey));
      return _react2.default.createElement(_OverlayTrigger2.default, {
        placement: 'bottom',
        overlay: tooltip
      }, _react2.default.createElement('button', {
        type: 'button',
        className: (0, _classnames2.default)('btn btn-default'),
        onClick: onClick
      }, _react2.default.createElement('i', {
        className: (0, _classnames2.default)('fa', {
          'fa-expand': !fullScreen,
          'fa-compress': fullScreen
        })
      })));
    };
    FullScreenButton.propTypes = {
      onClick: _propTypes2.default.func,
      fullScreen: _propTypes2.default.bool,
      locale: _propTypes2.default.string
    };
    FullScreenButton.defaultProps = {
      onClick: function onClick() {},
      fullScreen: false,
      locale: 'en'
    };
    exports.default = FullScreenButton;

    /***/
  }), ( /* 267 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _propTypes = __webpack_require__(15);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _MenuItem = __webpack_require__(527);
    var _MenuItem2 = _interopRequireDefault(_MenuItem);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    var titles = ['', 'Header 1', 'Header 2', 'Header 3', 'Header 4', 'Header 5', 'Header 6'];
    var HeaderButton = function HeaderButton(_ref) {
      var _onClick = _ref.onClick,
        level = _ref.level;
      return _react2.default.createElement(_MenuItem2.default, {
        onClick: function onClick(e) {
          return _onClick(level);
        }
      }, _react2.default.createElement('strong', null, titles[level]));
    };
    HeaderButton.propTypes = {
      onClick: _propTypes2.default.func,
      level: _propTypes2.default.number
    };
    exports.default = HeaderButton;

    /***/
  }), ( /* 268 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _propTypes = __webpack_require__(15);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _translations = __webpack_require__(59);
    var _translations2 = _interopRequireDefault(_translations);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    var LinkButton = function LinkButton(_ref) {
      var _onClick = _ref.onClick,
        disabled = _ref.disabled,
        locale = _ref.locale;
      return _react2.default.createElement('button', {
        className: 'btn btn-default',
        disabled: disabled,
        onClick: function onClick(e) {
          return _onClick();
        },
        type: 'button',
        title: (0, _translations2.default)(locale, 'insertLink')
      }, _react2.default.createElement('i', {
        className: 'fa fa-link'
      }));
    };
    LinkButton.propTypes = {
      disabled: _propTypes2.default.bool,
      onClick: _propTypes2.default.func,
      locale: _propTypes2.default.string
    };
    LinkButton.defaultProps = {
      active: false,
      disabled: false,
      locale: 'en'
    };
    exports.default = LinkButton;

    /***/
  }), ( /* 269 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.FullScreenButton = exports.LinkButton = exports.HeaderButton = exports.AdditionalButton = exports.ActionButton = undefined;
    var _ActionButton = __webpack_require__(264);
    var _ActionButton2 = _interopRequireDefault(_ActionButton);
    var _AdditionalButton = __webpack_require__(265);
    var _AdditionalButton2 = _interopRequireDefault(_AdditionalButton);
    var _HeaderButton = __webpack_require__(267);
    var _HeaderButton2 = _interopRequireDefault(_HeaderButton);
    var _LinkButton = __webpack_require__(268);
    var _LinkButton2 = _interopRequireDefault(_LinkButton);
    var _FullScreenButton = __webpack_require__(266);
    var _FullScreenButton2 = _interopRequireDefault(_FullScreenButton);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    exports.ActionButton = _ActionButton2.default;
    exports.AdditionalButton = _AdditionalButton2.default;
    exports.HeaderButton = _HeaderButton2.default;
    exports.LinkButton = _LinkButton2.default;
    exports.FullScreenButton = _FullScreenButton2.default;

    /***/
  }), ( /* 270 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = __webpack_require__(263).default;

    /***/
  }), ( /* 271 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _index = __webpack_require__(275);
    Object.keys(_index).forEach(function (key) {
      if (key === "default" || key === "__esModule") return;
      Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
          return _index[key];
        }
      });
    });

    /***/
  }), ( /* 272 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    var _class, _class2, _temp2;
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _reactDom = __webpack_require__(4);
    var _propTypes = __webpack_require__(15);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _reactClickOutside = __webpack_require__(535);
    var _reactClickOutside2 = _interopRequireDefault(_reactClickOutside);
    var _AutocompleteWidget = __webpack_require__(273);
    var _AutocompleteWidget2 = _interopRequireDefault(_AutocompleteWidget);
    var _utils = __webpack_require__(107);
    var _transforms = __webpack_require__(165);
    var _utils2 = __webpack_require__(276);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var escapeCode = 27;
    var arrowUpCode = 38;
    var arrowDownCode = 40;
    var enterCode = 13;
    var tabCode = 9;
    var AutocompleteContainer = (0, _reactClickOutside2.default)(_class = (_temp2 = _class2 = function (_PureComponent) {
      _inherits(AutocompleteContainer, _PureComponent);
      function AutocompleteContainer() {
        var _ref;
        var _temp, _this, _ret;
        _classCallCheck(this, AutocompleteContainer);
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AutocompleteContainer.__proto__ || Object.getPrototypeOf(AutocompleteContainer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
          show: false,
          selectedItem: 0,
          items: [],
          ref: null
        }, _this.componentDidMount = function () {
          _this._isMounted = true;
          _this.searchItems(_this.props);
        }, _this.componentWillReceiveProps = function (nextProps) {
          _this.searchItems(nextProps);
        }, _this.matchExtension = function (extensions, token) {
          for (var i = 0, count = extensions.length; i < count; i++) {
            var extension = extensions[i];
            if (token.match(extension.termRegex)) {
              return extension;
            }
          }
          return undefined;
        }, _this.getSymbolPos = function (term) {
          var offset = [' ', '[', '('].map(function (symbol) {
            return term.lastIndexOf(symbol);
          }).reduce(function (offset, currOffset) {
            return offset < currOffset ? currOffset : offset;
          }, -1);
          if (offset !== -1) {
            offset++;
          }
          return offset;
        }, _this.getSearchToken = function (state) {
          var text = state.focusBlock.text;
          var anchorOffset = state.selection.anchorOffset; // FIXME: works differently for different directions of selecting.

          var term = void 0;
          var offset = -1;
          if (text && anchorOffset > 0) {
            term = text.substring(0, anchorOffset);
            if (!term.endsWith(' ')) {
              // FIXME: ending with TAB should behave similarly.
              offset = term.lastIndexOf(' ');
              if (offset !== -1) {
                offset++;
              }
              var accents = (0, _transforms.getAccents)(state);
              if (accents.length > 0) {
                // this position has some accent
                var currLeftPos = (0, _transforms.getPosAfterEmphasis)(state, accents);
                if (offset < currLeftPos) {
                  offset = currLeftPos;
                }
              }
              if (offset !== -1) {
                term = term.substring(offset);
              }
            }
          }
          return {
            term: term,
            text: text,
            offset: offset
          };
        }, _this.handleClickOutside = function () {
          if (_this.state.show) {
            _this.hideWidget();
          }
        }, _this.handleKeyDown = function (e) {
          var _this$state = _this.state,
            show = _this$state.show,
            items = _this$state.items,
            selectedItem = _this$state.selectedItem; // eslint-disable-line prefer-const

          if (e.keyCode === tabCode) {
            e.preventDefault();
            e.stopPropagation();
            _this.hideWidget();
          }
          if (show) {
            if (e.keyCode === escapeCode) {
              e.preventDefault();
              e.stopPropagation();
              _this.hideWidget();
            }
          }
          if (show && items) {
            if (e.keyCode === enterCode) {
              e.preventDefault();
              _this.handleSelectItem(selectedItem, e);
              _this.hideWidget();
            } else if (e.keyCode === arrowUpCode || e.keyCode === arrowDownCode) {
              e.preventDefault();
              var length = items.length;
              selectedItem = e.keyCode === arrowDownCode ? selectedItem + 1 : selectedItem - 1;
              if (e.keyCode === arrowDownCode && selectedItem < length || e.keyCode === arrowUpCode && selectedItem >= 0) {
                _this.setState({
                  selectedItem: selectedItem
                });
              }
            }
          }
        }, _this.removeSpecialCharacter = function (state, specialCharacter) {
          var change = state.change();
          var text = state.startBlock.text;
          var charLength = specialCharacter.length;
          var specialCharPos = text.lastIndexOf(specialCharacter, state.endOffset);
          change.moveOffsetsTo(specialCharPos).deleteForward(charLength).moveOffsetsTo(state.endOffset - charLength).focus();
          _this.props.onChange(change.state);
        }, _this.handleSelectItem = function (index) {
          var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var items = _this.state.items;
          var _this$props = _this.props,
            state = _this$props.state,
            options = _this$props.options;
          var _this$getSearchToken = _this.getSearchToken(state),
            term = _this$getSearchToken.term;
          if (term) {
            var item = items[index];
            var extensions = options.extensions;
            var extension = _this.matchExtension(extensions, term);
            if (extension && item) {
              var change = state.change();
              var text = change.anchorText.text;
              var cursor = change.anchorOffset;
              var _matchUnderCursor = (0, _utils2.matchUnderCursor)({
                  text: text,
                  cursor: cursor,
                  regexp: extension.termRegex
                }),
                start = _matchUnderCursor.start,
                end = _matchUnderCursor.end;
              change.moveOffsetsTo(start, start).deleteForward(end - start).insertText(extension.markdownText(item, term)).focus();
              _this.props.onChange(change.state, true);
            }
            if (!item && event) {
              _this.removeSpecialCharacter(state, extension.specialCharacter);
            }
          }
          _this.hideWidget();
        }, _this.searchItems = function (_ref2) {
          var state = _ref2.state,
            options = _ref2.options;
          var editorIsActive = _this.props.options.editorIsActive;
          if (!editorIsActive) {
            _this.setState({
              items: [],
              show: false,
              loading: false
            });
            return;
          }
          var _this$getSearchToken2 = _this.getSearchToken(state),
            term = _this$getSearchToken2.term;
          var extension = term && _this.matchExtension(options.extensions, term);
          if (!extension) {
            _this.hideWidget();
            return;
          }
          _this.setState({
            items: [],
            loading: true
          });
          _this.toggleWidget(true);
          var request = _this.currentRequest = extension.searchItems(term).then(function (items) {
            if (_this.currentRequest === request && _this._isMounted) {
              _this.setState({
                items: items,
                selectedItem: 0,
                loading: false
              });
            }
          }).catch(function (err) {
            if (_this.currentRequest === request && _this._isMounted) {
              _this.setState({
                items: [],
                loading: false
              });
            }
          });
        }, _this.toggleWidget = function (flag) {
          _this.props.onToggle(flag);
          _this.setState({
            show: flag
          });
        }, _this.hideWidget = function () {
          _this.toggleWidget(false);
        }, _this.handleRef = function (ref) {
          _this.setState({
            ref: ref
          });
        }, _this.getItemRenderFunc = function (_) {
          var _this$props2 = _this.props,
            state = _this$props2.state,
            extensions = _this$props2.options.extensions;
          var _this$getSearchToken3 = _this.getSearchToken(state),
            term = _this$getSearchToken3.term;
          var extension = term && _this.matchExtension(extensions, term);
          return (extension || {}).renderItem;
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }
      _createClass(AutocompleteContainer, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this._isMounted = false;
        }
      }, {
        key: 'render',
        value: function render() {
          var _state = this.state,
            show = _state.show,
            selectedItem = _state.selectedItem,
            items = _state.items,
            ref = _state.ref,
            loading = _state.loading;
          var _props = this.props,
            children = _props.children,
            locale = _props.locale,
            _props$options = _props.options,
            editorIsActive = _props$options.editorIsActive,
            containerRef = _props$options.containerRef;
          var selection = window.getSelection();
          if (selection.anchorNode) {
            var slateEditor = (0, _utils.getSlateEditor)(selection);
            if (slateEditor && !show) {
              slateEditor.style.overflow = 'auto';
            }
          }
          return _react2.default.createElement('div', {
            className: 'AutocompleteContainer',
            onKeyDown: this.handleKeyDown,
            ref: this.handleRef
          }, show && editorIsActive ? (0, _reactDom.createPortal)(_react2.default.createElement(_AutocompleteWidget2.default, {
            items: items,
            itemRenderer: this.getItemRenderFunc(),
            loading: loading,
            selectedItem: selectedItem,
            locale: locale,
            onChange: this.handleSelectItem,
            restrictorRef: ref,
            containerRef: containerRef
          }), containerRef) : null, children);
        }
      }]);
      return AutocompleteContainer;
    }(_react.PureComponent), _class2.propTypes = {
      state: _propTypes2.default.object,
      locale: _propTypes2.default.string,
      options: _propTypes2.default.object,
      onChange: _propTypes2.default.func,
      onScroll: _propTypes2.default.func,
      onMouseUp: _propTypes2.default.func,
      onToggle: _propTypes2.default.func
    }, _class2.defaultProps = {
      state: {},
      locale: 'en',
      options: {},
      onChange: function onChange() {},
      onScroll: function onScroll() {},
      onMouseUp: function onMouseUp() {},
      onToggle: function onToggle() {}
    }, _temp2)) || _class;
    exports.default = AutocompleteContainer;

    /***/
  }), ( /* 273 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = undefined;
    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    var _class, _temp;
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    __webpack_require__(684);
    var _propTypes = __webpack_require__(15);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _utils = __webpack_require__(107);
    var _translations = __webpack_require__(59);
    var _translations2 = _interopRequireDefault(_translations);
    var _DefaultAutocompleteItem = __webpack_require__(274);
    var _DefaultAutocompleteItem2 = _interopRequireDefault(_DefaultAutocompleteItem);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var maxHeight = 240;
    var AutocompleteWidget = (_temp = _class = function (_PureComponent) {
      _inherits(AutocompleteWidget, _PureComponent);
      function AutocompleteWidget(props) {
        _classCallCheck(this, AutocompleteWidget);
        var _this = _possibleConstructorReturn(this, (AutocompleteWidget.__proto__ || Object.getPrototypeOf(AutocompleteWidget)).call(this, props));
        _this.componentDidMount = function () {
          _this.adjustPosition();
        };
        _this.componentWillReceiveProps = function (nextProps) {
          _this.cancelAdjustPosition();
          _this.adjustPosition();
        };
        _this.componentWillUpdate = function (nextProps) {
          var widgetRef = _this.widgetRef;
          var itemRef = _this['itemRef' + nextProps.selectedItem];
          if (widgetRef && itemRef) {
            // calculating scrolling with keyboard up and down arrows
            if (_this.props.selectedItem < nextProps.selectedItem && itemRef.offsetTop - widgetRef.scrollTop > 156) {
              widgetRef.scrollTop = itemRef.offsetTop - 156;
            }
            if (_this.props.selectedItem > nextProps.selectedItem && itemRef.offsetTop - widgetRef.scrollTop < 26) {
              widgetRef.scrollTop = itemRef.offsetTop - 26;
            }
          }
        };
        _this.componentWillUnmount = function () {
          _this.cancelAdjustPosition();
        };
        _this.cancelAdjustPosition = function () {
          if (_this._animationFrame) {
            window.cancelAnimationFrame(_this._animationFrame); // XXX
          }
        };
        _this.setPosition = function (selectedItem) {
          var _this$props = _this.props,
            restrictorRef = _this$props.restrictorRef,
            containerRef = _this$props.containerRef;
          var editorWidth = restrictorRef.offsetWidth;
          var autocompleteWidth = _this.widgetRef.offsetWidth;
          var selectionRect = selectedItem.getRangeAt(0).getBoundingClientRect(); // element with cursor
          var restrictorRect = restrictorRef.getBoundingClientRect();
          var containerRect = containerRef.getBoundingClientRect();
          var left = selectionRect.left - restrictorRect.left + restrictorRef.offsetLeft;
          left = editorWidth >= left + autocompleteWidth ? left : left - autocompleteWidth;
          left = left < 0 ? 0 : left;
          var top = selectionRect.bottom - containerRect.top;
          var slateEditor = (0, _utils.getSlateEditor)(selectedItem);
          slateEditor.style.overflow = 'hidden';
          var position = {
            left: left + 'px',
            top: top + 'px'
          };
          var positionChanged = _this.state.left !== position.left || _this.state.top !== position.top;
          if (positionChanged) {
            _this.setState(position);
          }
          _this._animationFrame = window.requestAnimationFrame(_this.adjustPosition);
        };
        _this.adjustPosition = function () {
          var restrictorRef = _this.props.restrictorRef;
          var selectedItem = window.getSelection();
          // If user clicks outside of autocomplete then selectedItem won't be in a subtree of editor.
          // We don't perform any editor-specific actions in this case.
          if (selectedItem.anchorNode && restrictorRef && (restrictorRef.contains(selectedItem.anchorNode) ||
          // Fix for IE11: Node.contains() in IE11 works only with Element nodes, not with Text nodes
          // (other browsers work with both). For IE11 we walk up the tree to find a proper element.
          restrictorRef.contains(selectedItem.anchorNode.parentNode))) {
            _this.setPosition(selectedItem);
          }
        };
        _this.handleItemMouseDown = function (index) {
          _this.props.onChange(index);
        };
        _this.saveWidgetRef = function (el) {
          return _this.widgetRef = el;
        };
        _this.state = {
          left: 0,
          top: 0,
          transform: ''
        };
        return _this;
      }
      _createClass(AutocompleteWidget, [{
        key: 'render',
        value: function render() {
          var _this2 = this;
          var _state = this.state,
            left = _state.left,
            top = _state.top,
            transform = _state.transform;
          var _props = this.props,
            items = _props.items,
            locale = _props.locale,
            selectedItem = _props.selectedItem,
            itemRenderer = _props.itemRenderer,
            loading = _props.loading;
          if (loading) {
            return _react2.default.createElement('div', {
              ref: this.saveWidgetRef,
              style: _extends({
                left: left,
                top: top,
                transform: transform,
                maxHeight: maxHeight + 'px'
              }, this.props.style),
              className: 'react-markdown--autocomplete-widget'
            }, _react2.default.createElement('div', {
              className: 'react-markdown--autocomplete-widget__item'
            }, _react2.default.createElement('span', null, (0, _translations2.default)(locale, 'searching')), _react2.default.createElement('i', {
              className: 'fa fa-spinner fa-spin pull-right',
              style: {
                marginTop: '3px'
              }
            })));
          }
          var notFoundElement = items.length === 0 && !loading ? _react2.default.createElement('div', {
            className: 'react-markdown--autocomplete-widget__item'
          }, (0, _translations2.default)(locale, 'noMatchesFound')) : null;
          var itemsElement = items.map(function (item, index) {
            var isSelected = selectedItem === index;
            return _react2.default.createElement('div', {
              key: index,
              ref: function ref(_ref) {
                return _this2['itemRef' + index] = _ref;
              },
              onMouseDown: function onMouseDown(_) {
                return _this2.handleItemMouseDown(index);
              }
            }, _react2.default.createElement('input', {
              type: 'radio',
              style: {
                display: 'none'
              },
              selected: isSelected
            }), itemRenderer({
              item: item,
              isSelected: isSelected
            }));
          });
          if (items) {
            return _react2.default.createElement('div', {
              ref: this.saveWidgetRef,
              style: _extends({
                left: left,
                top: top,
                transform: transform,
                maxHeight: maxHeight + 'px'
              }, this.props.style),
              className: 'react-markdown--autocomplete-widget'
            }, _react2.default.createElement('fieldset', null, itemsElement), notFoundElement);
          }
          return null;
        }
      }]);
      return AutocompleteWidget;
    }(_react.PureComponent), _class.propTypes = {
      items: _propTypes2.default.array,
      loading: _propTypes2.default.bool,
      locale: _propTypes2.default.string,
      onChange: _propTypes2.default.func,
      itemRenderer: _propTypes2.default.func,
      restrictorRef: _propTypes2.default.object,
      containerRef: _propTypes2.default.object,
      selectedItem: _propTypes2.default.number,
      style: _propTypes2.default.object
    }, _class.defaultProps = {
      items: [],
      loading: false,
      locale: 'en',
      onChange: function onChange() {},
      itemRenderer: _DefaultAutocompleteItem2.default,
      restrictorRef: null,
      selectedItem: null,
      style: {}
    }, _temp);
    exports.default = AutocompleteWidget;

    /***/
  }), ( /* 274 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = DefaultAutocompleteItem;
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _propTypes = __webpack_require__(15);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    var maxItemLength = 15;
    function DefaultAutocompleteItem(_ref) {
      var item = _ref.item,
        isSelected = _ref.isSelected;
      var itemLabel = item._objectLabel;
      var itemLength = itemLabel.length;
      return _react2.default.createElement('div', {
        className: '\n        react-markdown--autocomplete-widget__item\n        ' + (isSelected ? 'react-markdown--autocomplete-widget__item--active' : '') + '\n      ',
        title: itemLength > maxItemLength ? itemLabel : ''
      }, itemLength > maxItemLength ? itemLabel.substr(0, maxItemLength) + "\u2026" : itemLabel);
    }
    DefaultAutocompleteItem.propTypes = {
      item: _propTypes2.default.object.isRequired,
      isSelected: _propTypes2.default.bool.isRequired
    };

    /***/
  }), ( /* 275 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.AutocompletePlugin = undefined;
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _AutocompleteContainer = __webpack_require__(272);
    var _AutocompleteContainer2 = _interopRequireDefault(_AutocompleteContainer);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    var AutocompletePlugin = function AutocompletePlugin(options) {
      return {
        render: function render(props, state) {
          var children = props.children;
          return _react2.default.createElement(_AutocompleteContainer2.default, {
            state: state,
            options: options,
            locale: options.locale,
            onChange: options.onChange // eslint-disable-line react/jsx-handler-names
            ,
            onScroll: options.onScroll // eslint-disable-line react/jsx-handler-names
            ,
            onMouseUp: options.onMouseUp // eslint-disable-line react/jsx-handler-names
            ,
            onToggle: options.onToggle // eslint-disable-line react/jsx-handler-names
          }, children);
        }
      };
    };
    exports.AutocompletePlugin = AutocompletePlugin;

    /***/
  }), ( /* 276 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var matchUnderCursor = exports.matchUnderCursor = function matchUnderCursor(_ref) {
      var text = _ref.text,
        regexp = _ref.regexp,
        cursor = _ref.cursor;
      var result = {
        match: '',
        start: cursor,
        end: cursor
      };
      for (var start = cursor; start >= 0; start--) {
        for (var end = cursor; end <= text.length; end++) {
          var chunk = text.slice(start, end);
          if (regexp.test(chunk) && chunk.length > result.match.length) {
            result.match = chunk;
            result.start = start;
            result.end = end;
          }
        }
      }
      return result;
    };

    /***/
  }), ( /* 277 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.addMarks = undefined;
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _propTypes = __webpack_require__(15);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _slate = __webpack_require__(22);
    var _tokenizer = __webpack_require__(164);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    /**
     * Define a decorator for markdown styles.
     */

    var addMarks = exports.addMarks = function addMarks(characters, tokens, offset) {
      var updatedOffset = offset;
      for (var i = 0; i < tokens.length; i++) {
        var token = tokens[i];
        if (typeof token === 'string') {
          updatedOffset += token.length;
          continue;
        }
        var content = token.content,
          length = token.length,
          type = token.type;
        addMarks(characters, content, updatedOffset);
        var mark = _slate.Mark.create({
          type: type
        });
        for (var pos = updatedOffset; pos < updatedOffset + length && pos < characters.size; pos++) {
          var char = characters.get(pos);
          var _char = char,
            marks = _char.marks;
          marks = marks.add(mark);
          char = char.set('marks', marks);
          characters.set(pos, char);
        }
        updatedOffset += length;
      }
    };
    function markdownDecorator(text, block) {
      if (text.charsData && text.charsData.text === text.text) {
        return text.charsData.characters;
      }
      if (block.data) {
        if (block.data.text !== text.text) {
          // when several lines are inserted
          block.data.text = text.text; // eslint-disable-line
          block.data.tokens = (0, _tokenizer.parse)(text.text); // eslint-disable-line
        }
        var characters = text.characters.asMutable();
        addMarks(characters, block.data.tokens, 0); // Add marks to characters
        text.charsData = {
          // eslint-disable-line
          text: text.text,
          characters: characters.asImmutable()
        };
        return text.charsData.characters;
      }
      return text.characters;
    }
    var rendererComponent = function rendererComponent(_ref) {
      var node = _ref.node,
        mark = _ref.mark,
        children = _ref.children;
      if (node.type === 'line') {
        return _react2.default.createElement('div', {
          className: 'oc-md-hl-block'
        }, children);
      }
      if (mark) {
        return _react2.default.createElement('span', {
          className: mark.type ? 'oc-md-hl-' + mark.type : ''
        }, children);
      }
      return null;
    };
    rendererComponent.propTypes = {
      node: _propTypes2.default.object,
      mark: _propTypes2.default.object
    };
    var schema = {
      rules: [{
        match: function match() {
          return true;
        },
        decorate: markdownDecorator,
        render: rendererComponent
      }]
    };
    exports.default = schema;

    /***/
  }), ( /* 278 */
  /***/function (module, exports, __webpack_require__) {
    module.exports = {
      "default": __webpack_require__(285),
      __esModule: true
    };

    /***/
  }), ( /* 279 */
  /***/function (module, exports, __webpack_require__) {
    module.exports = {
      "default": __webpack_require__(286),
      __esModule: true
    };

    /***/
  }), ( /* 280 */
  /***/function (module, exports, __webpack_require__) {
    module.exports = {
      "default": __webpack_require__(287),
      __esModule: true
    };

    /***/
  }), ( /* 281 */
  /***/function (module, exports, __webpack_require__) {
    module.exports = {
      "default": __webpack_require__(289),
      __esModule: true
    };

    /***/
  }), ( /* 282 */
  /***/function (module, exports, __webpack_require__) {
    module.exports = {
      "default": __webpack_require__(290),
      __esModule: true
    };

    /***/
  }), ( /* 283 */
  /***/function (module, exports, __webpack_require__) {
    module.exports = {
      "default": __webpack_require__(291),
      __esModule: true
    };

    /***/
  }), ( /* 284 */
  /***/function (module, exports, __webpack_require__) {
    module.exports = {
      "default": __webpack_require__(292),
      __esModule: true
    };

    /***/
  }), ( /* 285 */
  /***/function (module, exports, __webpack_require__) {
    __webpack_require__(178);
    __webpack_require__(315);
    module.exports = __webpack_require__(18).Array.from;

    /***/
  }), ( /* 286 */
  /***/function (module, exports, __webpack_require__) {
    __webpack_require__(317);
    module.exports = __webpack_require__(18).Object.assign;

    /***/
  }), ( /* 287 */
  /***/function (module, exports, __webpack_require__) {
    __webpack_require__(318);
    var $Object = __webpack_require__(18).Object;
    module.exports = function create(P, D) {
      return $Object.create(P, D);
    };

    /***/
  }), ( /* 288 */
  /***/function (module, exports, __webpack_require__) {
    __webpack_require__(322);
    module.exports = __webpack_require__(18).Object.entries;

    /***/
  }), ( /* 289 */
  /***/function (module, exports, __webpack_require__) {
    __webpack_require__(319);
    module.exports = __webpack_require__(18).Object.setPrototypeOf;

    /***/
  }), ( /* 290 */
  /***/function (module, exports, __webpack_require__) {
    __webpack_require__(323);
    module.exports = __webpack_require__(18).Object.values;

    /***/
  }), ( /* 291 */
  /***/function (module, exports, __webpack_require__) {
    __webpack_require__(321);
    __webpack_require__(320);
    __webpack_require__(324);
    __webpack_require__(325);
    module.exports = __webpack_require__(18).Symbol;

    /***/
  }), ( /* 292 */
  /***/function (module, exports, __webpack_require__) {
    __webpack_require__(178);
    __webpack_require__(326);
    module.exports = __webpack_require__(120).f('iterator');

    /***/
  }), ( /* 293 */
  /***/function (module, exports) {
    module.exports = function (it) {
      if (typeof it != 'function') throw TypeError(it + ' is not a function!');
      return it;
    };

    /***/
  }), ( /* 294 */
  /***/function (module, exports) {
    module.exports = function () {/* empty */};

    /***/
  }), ( /* 295 */
  /***/function (module, exports, __webpack_require__) {
    // false -> Array#indexOf
    // true  -> Array#includes
    var toIObject = __webpack_require__(35);
    var toLength = __webpack_require__(177);
    var toAbsoluteIndex = __webpack_require__(313);
    module.exports = function (IS_INCLUDES) {
      return function ($this, el, fromIndex) {
        var O = toIObject($this);
        var length = toLength(O.length);
        var index = toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while (length > index) {
          value = O[index++];
          // eslint-disable-next-line no-self-compare
          if (value != value) return true;
          // Array#indexOf ignores holes, Array#includes - not
        } else for (; length > index; index++) {
          if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
          }
        }
        return !IS_INCLUDES && -1;
      };
    };

    /***/
  }), ( /* 296 */
  /***/function (module, exports, __webpack_require__) {
    // getting tag from 19.1.3.6 Object.prototype.toString()
    var cof = __webpack_require__(108);
    var TAG = __webpack_require__(21)('toStringTag');
    // ES3 wrong here
    var ARG = cof(function () {
      return arguments;
    }()) == 'Arguments';

    // fallback for IE11 Script Access Denied error
    var tryGet = function tryGet(it, key) {
      try {
        return it[key];
      } catch (e) {/* empty */}
    };
    module.exports = function (it) {
      var O, T, B;
      return it === undefined ? 'Undefined' : it === null ? 'Null'
      // @@toStringTag case
      : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
      // builtinTag case
      : ARG ? cof(O)
      // ES3 arguments fallback
      : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
    };

    /***/
  }), ( /* 297 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var $defineProperty = __webpack_require__(34);
    var createDesc = __webpack_require__(64);
    module.exports = function (object, index, value) {
      if (index in object) $defineProperty.f(object, index, createDesc(0, value));else object[index] = value;
    };

    /***/
  }), ( /* 298 */
  /***/function (module, exports, __webpack_require__) {
    // all enumerable object keys, includes symbols
    var getKeys = __webpack_require__(62);
    var gOPS = __webpack_require__(113);
    var pIE = __webpack_require__(63);
    module.exports = function (it) {
      var result = getKeys(it);
      var getSymbols = gOPS.f;
      if (getSymbols) {
        var symbols = getSymbols(it);
        var isEnum = pIE.f;
        var i = 0;
        var key;
        while (symbols.length > i) {
          if (isEnum.call(it, key = symbols[i++])) result.push(key);
        }
      }
      return result;
    };

    /***/
  }), ( /* 299 */
  /***/function (module, exports, __webpack_require__) {
    var document = __webpack_require__(29).document;
    module.exports = document && document.documentElement;

    /***/
  }), ( /* 300 */
  /***/function (module, exports, __webpack_require__) {
    // check on default Array iterator
    var Iterators = __webpack_require__(61);
    var ITERATOR = __webpack_require__(21)('iterator');
    var ArrayProto = Array.prototype;
    module.exports = function (it) {
      return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
    };

    /***/
  }), ( /* 301 */
  /***/function (module, exports, __webpack_require__) {
    // 7.2.2 IsArray(argument)
    var cof = __webpack_require__(108);
    module.exports = Array.isArray || function isArray(arg) {
      return cof(arg) == 'Array';
    };

    /***/
  }), ( /* 302 */
  /***/function (module, exports, __webpack_require__) {
    // call something on iterator step with safe closing on error
    var anObject = __webpack_require__(45);
    module.exports = function (iterator, fn, value, entries) {
      try {
        return entries ? fn(anObject(value)[0], value[1]) : fn(value);
        // 7.4.6 IteratorClose(iterator, completion)
      } catch (e) {
        var ret = iterator['return'];
        if (ret !== undefined) anObject(ret.call(iterator));
        throw e;
      }
    };

    /***/
  }), ( /* 303 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var create = __webpack_require__(112);
    var descriptor = __webpack_require__(64);
    var setToStringTag = __webpack_require__(114);
    var IteratorPrototype = {};

    // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
    __webpack_require__(46)(IteratorPrototype, __webpack_require__(21)('iterator'), function () {
      return this;
    });
    module.exports = function (Constructor, NAME, next) {
      Constructor.prototype = create(IteratorPrototype, {
        next: descriptor(1, next)
      });
      setToStringTag(Constructor, NAME + ' Iterator');
    };

    /***/
  }), ( /* 304 */
  /***/function (module, exports, __webpack_require__) {
    var ITERATOR = __webpack_require__(21)('iterator');
    var SAFE_CLOSING = false;
    try {
      var riter = [7][ITERATOR]();
      riter['return'] = function () {
        SAFE_CLOSING = true;
      };
      // eslint-disable-next-line no-throw-literal
      Array.from(riter, function () {
        throw 2;
      });
    } catch (e) {/* empty */}
    module.exports = function (exec, skipClosing) {
      if (!skipClosing && !SAFE_CLOSING) return false;
      var safe = false;
      try {
        var arr = [7];
        var iter = arr[ITERATOR]();
        iter.next = function () {
          return {
            done: safe = true
          };
        };
        arr[ITERATOR] = function () {
          return iter;
        };
        exec(arr);
      } catch (e) {/* empty */}
      return safe;
    };

    /***/
  }), ( /* 305 */
  /***/function (module, exports) {
    module.exports = function (done, value) {
      return {
        value: value,
        done: !!done
      };
    };

    /***/
  }), ( /* 306 */
  /***/function (module, exports, __webpack_require__) {
    var META = __webpack_require__(83)('meta');
    var isObject = __webpack_require__(47);
    var has = __webpack_require__(33);
    var setDesc = __webpack_require__(34).f;
    var id = 0;
    var isExtensible = Object.isExtensible || function () {
      return true;
    };
    var FREEZE = !__webpack_require__(60)(function () {
      return isExtensible(Object.preventExtensions({}));
    });
    var setMeta = function setMeta(it) {
      setDesc(it, META, {
        value: {
          i: 'O' + ++id,
          // object ID
          w: {} // weak collections IDs
        }
      });
    };
    var fastKey = function fastKey(it, create) {
      // return primitive with prefix
      if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
      if (!has(it, META)) {
        // can't set metadata to uncaught frozen object
        if (!isExtensible(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        setMeta(it);
        // return object ID
      }
      return it[META].i;
    };
    var getWeak = function getWeak(it, create) {
      if (!has(it, META)) {
        // can't set metadata to uncaught frozen object
        if (!isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        setMeta(it);
        // return hash weak collections IDs
      }
      return it[META].w;
    };
    // add metadata on freeze-family methods calling
    var onFreeze = function onFreeze(it) {
      if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
      return it;
    };
    var meta = module.exports = {
      KEY: META,
      NEED: false,
      fastKey: fastKey,
      getWeak: getWeak,
      onFreeze: onFreeze
    };

    /***/
  }), ( /* 307 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // 19.1.2.1 Object.assign(target, source, ...)
    var DESCRIPTORS = __webpack_require__(27);
    var getKeys = __webpack_require__(62);
    var gOPS = __webpack_require__(113);
    var pIE = __webpack_require__(63);
    var toObject = __webpack_require__(82);
    var IObject = __webpack_require__(170);
    var $assign = Object.assign;

    // should work with symbols and should have deterministic property order (V8 bug)
    module.exports = !$assign || __webpack_require__(60)(function () {
      var A = {};
      var B = {};
      // eslint-disable-next-line no-undef
      var S = Symbol();
      var K = 'abcdefghijklmnopqrst';
      A[S] = 7;
      K.split('').forEach(function (k) {
        B[k] = k;
      });
      return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
    }) ? function assign(target, source) {
      // eslint-disable-line no-unused-vars
      var T = toObject(target);
      var aLen = arguments.length;
      var index = 1;
      var getSymbols = gOPS.f;
      var isEnum = pIE.f;
      while (aLen > index) {
        var S = IObject(arguments[index++]);
        var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
        var length = keys.length;
        var j = 0;
        var key;
        while (length > j) {
          key = keys[j++];
          if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
        }
      }
      return T;
    } : $assign;

    /***/
  }), ( /* 308 */
  /***/function (module, exports, __webpack_require__) {
    var dP = __webpack_require__(34);
    var anObject = __webpack_require__(45);
    var getKeys = __webpack_require__(62);
    module.exports = __webpack_require__(27) ? Object.defineProperties : function defineProperties(O, Properties) {
      anObject(O);
      var keys = getKeys(Properties);
      var length = keys.length;
      var i = 0;
      var P;
      while (length > i) {
        dP.f(O, P = keys[i++], Properties[P]);
      }
      return O;
    };

    /***/
  }), ( /* 309 */
  /***/function (module, exports, __webpack_require__) {
    // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
    var toIObject = __webpack_require__(35);
    var gOPN = __webpack_require__(173).f;
    var toString = {}.toString;
    var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
    var getWindowNames = function getWindowNames(it) {
      try {
        return gOPN(it);
      } catch (e) {
        return windowNames.slice();
      }
    };
    module.exports.f = function getOwnPropertyNames(it) {
      return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
    };

    /***/
  }), ( /* 310 */
  /***/function (module, exports, __webpack_require__) {
    // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
    var has = __webpack_require__(33);
    var toObject = __webpack_require__(82);
    var IE_PROTO = __webpack_require__(115)('IE_PROTO');
    var ObjectProto = Object.prototype;
    module.exports = Object.getPrototypeOf || function (O) {
      O = toObject(O);
      if (has(O, IE_PROTO)) return O[IE_PROTO];
      if (typeof O.constructor == 'function' && O instanceof O.constructor) {
        return O.constructor.prototype;
      }
      return O instanceof Object ? ObjectProto : null;
    };

    /***/
  }), ( /* 311 */
  /***/function (module, exports, __webpack_require__) {
    // Works with __proto__ only. Old v8 can't work with null proto objects.
    /* eslint-disable no-proto */
    var isObject = __webpack_require__(47);
    var anObject = __webpack_require__(45);
    var check = function check(O, proto) {
      anObject(O);
      if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
    };
    module.exports = {
      set: Object.setPrototypeOf || ('__proto__' in {} ?
      // eslint-disable-line
      function (test, buggy, set) {
        try {
          set = __webpack_require__(109)(Function.call, __webpack_require__(172).f(Object.prototype, '__proto__').set, 2);
          set(test, []);
          buggy = !(test instanceof Array);
        } catch (e) {
          buggy = true;
        }
        return function setPrototypeOf(O, proto) {
          check(O, proto);
          if (buggy) O.__proto__ = proto;else set(O, proto);
          return O;
        };
      }({}, false) : undefined),
      check: check
    };

    /***/
  }), ( /* 312 */
  /***/function (module, exports, __webpack_require__) {
    var toInteger = __webpack_require__(117);
    var defined = __webpack_require__(110);
    // true  -> String#at
    // false -> String#codePointAt
    module.exports = function (TO_STRING) {
      return function (that, pos) {
        var s = String(defined(that));
        var i = toInteger(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
      };
    };

    /***/
  }), ( /* 313 */
  /***/function (module, exports, __webpack_require__) {
    var toInteger = __webpack_require__(117);
    var max = Math.max;
    var min = Math.min;
    module.exports = function (index, length) {
      index = toInteger(index);
      return index < 0 ? max(index + length, 0) : min(index, length);
    };

    /***/
  }), ( /* 314 */
  /***/function (module, exports, __webpack_require__) {
    var classof = __webpack_require__(296);
    var ITERATOR = __webpack_require__(21)('iterator');
    var Iterators = __webpack_require__(61);
    module.exports = __webpack_require__(18).getIteratorMethod = function (it) {
      if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
    };

    /***/
  }), ( /* 315 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var ctx = __webpack_require__(109);
    var $export = __webpack_require__(28);
    var toObject = __webpack_require__(82);
    var call = __webpack_require__(302);
    var isArrayIter = __webpack_require__(300);
    var toLength = __webpack_require__(177);
    var createProperty = __webpack_require__(297);
    var getIterFn = __webpack_require__(314);
    $export($export.S + $export.F * !__webpack_require__(304)(function (iter) {
      Array.from(iter);
    }), 'Array', {
      // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
      from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
        var O = toObject(arrayLike);
        var C = typeof this == 'function' ? this : Array;
        var aLen = arguments.length;
        var mapfn = aLen > 1 ? arguments[1] : undefined;
        var mapping = mapfn !== undefined;
        var index = 0;
        var iterFn = getIterFn(O);
        var length, result, step, iterator;
        if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
        // if object isn't iterable or it's array with default iterator - use simple case
        if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
          for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
            createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
          }
        } else {
          length = toLength(O.length);
          for (result = new C(length); length > index; index++) {
            createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
          }
        }
        result.length = index;
        return result;
      }
    });

    /***/
  }), ( /* 316 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var addToUnscopables = __webpack_require__(294);
    var step = __webpack_require__(305);
    var Iterators = __webpack_require__(61);
    var toIObject = __webpack_require__(35);

    // 22.1.3.4 Array.prototype.entries()
    // 22.1.3.13 Array.prototype.keys()
    // 22.1.3.29 Array.prototype.values()
    // 22.1.3.30 Array.prototype[@@iterator]()
    module.exports = __webpack_require__(171)(Array, 'Array', function (iterated, kind) {
      this._t = toIObject(iterated); // target
      this._i = 0; // next index
      this._k = kind; // kind
      // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
    }, function () {
      var O = this._t;
      var kind = this._k;
      var index = this._i++;
      if (!O || index >= O.length) {
        this._t = undefined;
        return step(1);
      }
      if (kind == 'keys') return step(0, index);
      if (kind == 'values') return step(0, O[index]);
      return step(0, [index, O[index]]);
    }, 'values');

    // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
    Iterators.Arguments = Iterators.Array;
    addToUnscopables('keys');
    addToUnscopables('values');
    addToUnscopables('entries');

    /***/
  }), ( /* 317 */
  /***/function (module, exports, __webpack_require__) {
    // 19.1.3.1 Object.assign(target, source)
    var $export = __webpack_require__(28);
    $export($export.S + $export.F, 'Object', {
      assign: __webpack_require__(307)
    });

    /***/
  }), ( /* 318 */
  /***/function (module, exports, __webpack_require__) {
    var $export = __webpack_require__(28);
    // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
    $export($export.S, 'Object', {
      create: __webpack_require__(112)
    });

    /***/
  }), ( /* 319 */
  /***/function (module, exports, __webpack_require__) {
    // 19.1.3.19 Object.setPrototypeOf(O, proto)
    var $export = __webpack_require__(28);
    $export($export.S, 'Object', {
      setPrototypeOf: __webpack_require__(311).set
    });

    /***/
  }), ( /* 320 */
  /***/function (module, exports) {

    /***/}), ( /* 321 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // ECMAScript 6 symbols shim
    var global = __webpack_require__(29);
    var has = __webpack_require__(33);
    var DESCRIPTORS = __webpack_require__(27);
    var $export = __webpack_require__(28);
    var redefine = __webpack_require__(176);
    var META = __webpack_require__(306).KEY;
    var $fails = __webpack_require__(60);
    var shared = __webpack_require__(116);
    var setToStringTag = __webpack_require__(114);
    var uid = __webpack_require__(83);
    var wks = __webpack_require__(21);
    var wksExt = __webpack_require__(120);
    var wksDefine = __webpack_require__(119);
    var enumKeys = __webpack_require__(298);
    var isArray = __webpack_require__(301);
    var anObject = __webpack_require__(45);
    var isObject = __webpack_require__(47);
    var toObject = __webpack_require__(82);
    var toIObject = __webpack_require__(35);
    var toPrimitive = __webpack_require__(118);
    var createDesc = __webpack_require__(64);
    var _create = __webpack_require__(112);
    var gOPNExt = __webpack_require__(309);
    var $GOPD = __webpack_require__(172);
    var $GOPS = __webpack_require__(113);
    var $DP = __webpack_require__(34);
    var $keys = __webpack_require__(62);
    var gOPD = $GOPD.f;
    var dP = $DP.f;
    var gOPN = gOPNExt.f;
    var $Symbol = global.Symbol;
    var $JSON = global.JSON;
    var _stringify = $JSON && $JSON.stringify;
    var PROTOTYPE = 'prototype';
    var HIDDEN = wks('_hidden');
    var TO_PRIMITIVE = wks('toPrimitive');
    var isEnum = {}.propertyIsEnumerable;
    var SymbolRegistry = shared('symbol-registry');
    var AllSymbols = shared('symbols');
    var OPSymbols = shared('op-symbols');
    var ObjectProto = Object[PROTOTYPE];
    var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
    var QObject = global.QObject;
    // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
    var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

    // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
    var setSymbolDesc = DESCRIPTORS && $fails(function () {
      return _create(dP({}, 'a', {
        get: function get() {
          return dP(this, 'a', {
            value: 7
          }).a;
        }
      })).a != 7;
    }) ? function (it, key, D) {
      var protoDesc = gOPD(ObjectProto, key);
      if (protoDesc) delete ObjectProto[key];
      dP(it, key, D);
      if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
    } : dP;
    var wrap = function wrap(tag) {
      var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
      sym._k = tag;
      return sym;
    };
    var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
      return typeof it == 'symbol';
    } : function (it) {
      return it instanceof $Symbol;
    };
    var $defineProperty = function defineProperty(it, key, D) {
      if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
      anObject(it);
      key = toPrimitive(key, true);
      anObject(D);
      if (has(AllSymbols, key)) {
        if (!D.enumerable) {
          if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
          it[HIDDEN][key] = true;
        } else {
          if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
          D = _create(D, {
            enumerable: createDesc(0, false)
          });
        }
        return setSymbolDesc(it, key, D);
      }
      return dP(it, key, D);
    };
    var $defineProperties = function defineProperties(it, P) {
      anObject(it);
      var keys = enumKeys(P = toIObject(P));
      var i = 0;
      var l = keys.length;
      var key;
      while (l > i) {
        $defineProperty(it, key = keys[i++], P[key]);
      }
      return it;
    };
    var $create = function create(it, P) {
      return P === undefined ? _create(it) : $defineProperties(_create(it), P);
    };
    var $propertyIsEnumerable = function propertyIsEnumerable(key) {
      var E = isEnum.call(this, key = toPrimitive(key, true));
      if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
      return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
    };
    var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
      it = toIObject(it);
      key = toPrimitive(key, true);
      if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
      var D = gOPD(it, key);
      if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
      return D;
    };
    var $getOwnPropertyNames = function getOwnPropertyNames(it) {
      var names = gOPN(toIObject(it));
      var result = [];
      var i = 0;
      var key;
      while (names.length > i) {
        if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
      }
      return result;
    };
    var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
      var IS_OP = it === ObjectProto;
      var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
      var result = [];
      var i = 0;
      var key;
      while (names.length > i) {
        if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
      }
      return result;
    };

    // 19.4.1.1 Symbol([description])
    if (!USE_NATIVE) {
      $Symbol = function Symbol() {
        if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
        var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
        var $set = function $set(value) {
          if (this === ObjectProto) $set.call(OPSymbols, value);
          if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
          setSymbolDesc(this, tag, createDesc(1, value));
        };
        if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, {
          configurable: true,
          set: $set
        });
        return wrap(tag);
      };
      redefine($Symbol[PROTOTYPE], 'toString', function toString() {
        return this._k;
      });
      $GOPD.f = $getOwnPropertyDescriptor;
      $DP.f = $defineProperty;
      __webpack_require__(173).f = gOPNExt.f = $getOwnPropertyNames;
      __webpack_require__(63).f = $propertyIsEnumerable;
      $GOPS.f = $getOwnPropertySymbols;
      if (DESCRIPTORS && !__webpack_require__(81)) {
        redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
      }
      wksExt.f = function (name) {
        return wrap(wks(name));
      };
    }
    $export($export.G + $export.W + $export.F * !USE_NATIVE, {
      Symbol: $Symbol
    });
    for (var es6Symbols =
      // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
      'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) {
      wks(es6Symbols[j++]);
    }
    for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) {
      wksDefine(wellKnownSymbols[k++]);
    }
    $export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
      // 19.4.2.1 Symbol.for(key)
      'for': function _for(key) {
        return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
      },
      // 19.4.2.5 Symbol.keyFor(sym)
      keyFor: function keyFor(sym) {
        if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
        for (var key in SymbolRegistry) {
          if (SymbolRegistry[key] === sym) return key;
        }
      },
      useSetter: function useSetter() {
        setter = true;
      },
      useSimple: function useSimple() {
        setter = false;
      }
    });
    $export($export.S + $export.F * !USE_NATIVE, 'Object', {
      // 19.1.2.2 Object.create(O [, Properties])
      create: $create,
      // 19.1.2.4 Object.defineProperty(O, P, Attributes)
      defineProperty: $defineProperty,
      // 19.1.2.3 Object.defineProperties(O, Properties)
      defineProperties: $defineProperties,
      // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
      getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
      // 19.1.2.7 Object.getOwnPropertyNames(O)
      getOwnPropertyNames: $getOwnPropertyNames,
      // 19.1.2.8 Object.getOwnPropertySymbols(O)
      getOwnPropertySymbols: $getOwnPropertySymbols
    });

    // Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
    // https://bugs.chromium.org/p/v8/issues/detail?id=3443
    var FAILS_ON_PRIMITIVES = $fails(function () {
      $GOPS.f(1);
    });
    $export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
      getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        return $GOPS.f(toObject(it));
      }
    });

    // 24.3.2 JSON.stringify(value [, replacer [, space]])
    $JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
      var S = $Symbol();
      // MS Edge converts symbol values to JSON as {}
      // WebKit converts symbol values to JSON as null
      // V8 throws on boxed symbols
      return _stringify([S]) != '[null]' || _stringify({
        a: S
      }) != '{}' || _stringify(Object(S)) != '{}';
    })), 'JSON', {
      stringify: function stringify(it) {
        var args = [it];
        var i = 1;
        var replacer, $replacer;
        while (arguments.length > i) {
          args.push(arguments[i++]);
        }
        $replacer = replacer = args[1];
        if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
        if (!isArray(replacer)) replacer = function replacer(key, value) {
          if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
          if (!isSymbol(value)) return value;
        };
        args[1] = replacer;
        return _stringify.apply($JSON, args);
      }
    });

    // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
    $Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(46)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
    // 19.4.3.5 Symbol.prototype[@@toStringTag]
    setToStringTag($Symbol, 'Symbol');
    // 20.2.1.9 Math[@@toStringTag]
    setToStringTag(Math, 'Math', true);
    // 24.3.3 JSON[@@toStringTag]
    setToStringTag(global.JSON, 'JSON', true);

    /***/
  }), ( /* 322 */
  /***/function (module, exports, __webpack_require__) {
    // https://github.com/tc39/proposal-object-values-entries
    var $export = __webpack_require__(28);
    var $entries = __webpack_require__(175)(true);
    $export($export.S, 'Object', {
      entries: function entries(it) {
        return $entries(it);
      }
    });

    /***/
  }), ( /* 323 */
  /***/function (module, exports, __webpack_require__) {
    // https://github.com/tc39/proposal-object-values-entries
    var $export = __webpack_require__(28);
    var $values = __webpack_require__(175)(false);
    $export($export.S, 'Object', {
      values: function values(it) {
        return $values(it);
      }
    });

    /***/
  }), ( /* 324 */
  /***/function (module, exports, __webpack_require__) {
    __webpack_require__(119)('asyncIterator');

    /***/
  }), ( /* 325 */
  /***/function (module, exports, __webpack_require__) {
    __webpack_require__(119)('observable');

    /***/
  }), ( /* 326 */
  /***/function (module, exports, __webpack_require__) {
    __webpack_require__(316);
    var global = __webpack_require__(29);
    var hide = __webpack_require__(46);
    var Iterators = __webpack_require__(61);
    var TO_STRING_TAG = __webpack_require__(21)('toStringTag');
    var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' + 'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' + 'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' + 'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' + 'TextTrackList,TouchList').split(',');
    for (var i = 0; i < DOMIterables.length; i++) {
      var NAME = DOMIterables[i];
      var Collection = global[NAME];
      var proto = Collection && Collection.prototype;
      if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
      Iterators[NAME] = Iterators.Array;
    }

    /***/
  }), ( /* 327 */
  /***/function (module, exports) {
    module.exports = function (it, Constructor, name, forbiddenField) {
      if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
        throw TypeError(name + ': incorrect invocation!');
      }
      return it;
    };

    /***/
  }), ( /* 328 */
  /***/function (module, exports, __webpack_require__) {
    var isObject = __webpack_require__(38);
    var isArray = __webpack_require__(184);
    var SPECIES = __webpack_require__(3)('species');
    module.exports = function (original) {
      var C;
      if (isArray(original)) {
        C = original.constructor;
        // cross-realm fallback
        if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
        if (isObject(C)) {
          C = C[SPECIES];
          if (C === null) C = undefined;
        }
      }
      return C === undefined ? Array : C;
    };

    /***/
  }), ( /* 329 */
  /***/function (module, exports, __webpack_require__) {
    var ctx = __webpack_require__(66);
    var call = __webpack_require__(334);
    var isArrayIter = __webpack_require__(333);
    var anObject = __webpack_require__(48);
    var toLength = __webpack_require__(31);
    var getIterFn = __webpack_require__(352);
    var BREAK = {};
    var RETURN = {};
    var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
      var iterFn = ITERATOR ? function () {
        return iterable;
      } : getIterFn(iterable);
      var f = ctx(fn, that, entries ? 2 : 1);
      var index = 0;
      var length, step, iterator, result;
      if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
      // fast case for arrays with default iterator
      if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
        result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
        if (result === BREAK || result === RETURN) return result;
      } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
        result = call(iterator, f, step.value, entries);
        if (result === BREAK || result === RETURN) return result;
      }
    };
    exports.BREAK = BREAK;
    exports.RETURN = RETURN;

    /***/
  }), ( /* 330 */
  /***/function (module, exports, __webpack_require__) {
    module.exports = !__webpack_require__(67) && !__webpack_require__(68)(function () {
      return Object.defineProperty(__webpack_require__(123)('div'), 'a', {
        get: function get() {
          return 7;
        }
      }).a != 7;
    });

    /***/
  }), ( /* 331 */
  /***/function (module, exports) {
    // fast apply, http://jsperf.lnkit.com/fast-apply/5
    module.exports = function (fn, args, that) {
      var un = that === undefined;
      switch (args.length) {
        case 0:
          return un ? fn() : fn.call(that);
        case 1:
          return un ? fn(args[0]) : fn.call(that, args[0]);
        case 2:
          return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
        case 3:
          return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
        case 4:
          return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
      }
      return fn.apply(that, args);
    };

    /***/
  }), ( /* 332 */
  /***/function (module, exports, __webpack_require__) {
    // fallback for non-array-like ES3 and non-enumerable old V8 strings
    var cof = __webpack_require__(49);
    // eslint-disable-next-line no-prototype-builtins
    module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
      return cof(it) == 'String' ? it.split('') : Object(it);
    };

    /***/
  }), ( /* 333 */
  /***/function (module, exports, __webpack_require__) {
    // check on default Array iterator
    var Iterators = __webpack_require__(70);
    var ITERATOR = __webpack_require__(3)('iterator');
    var ArrayProto = Array.prototype;
    module.exports = function (it) {
      return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
    };

    /***/
  }), ( /* 334 */
  /***/function (module, exports, __webpack_require__) {
    // call something on iterator step with safe closing on error
    var anObject = __webpack_require__(48);
    module.exports = function (iterator, fn, value, entries) {
      try {
        return entries ? fn(anObject(value)[0], value[1]) : fn(value);
        // 7.4.6 IteratorClose(iterator, completion)
      } catch (e) {
        var ret = iterator['return'];
        if (ret !== undefined) anObject(ret.call(iterator));
        throw e;
      }
    };

    /***/
  }), ( /* 335 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var create = __webpack_require__(339);
    var descriptor = __webpack_require__(190);
    var setToStringTag = __webpack_require__(125);
    var IteratorPrototype = {};

    // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
    __webpack_require__(37)(IteratorPrototype, __webpack_require__(3)('iterator'), function () {
      return this;
    });
    module.exports = function (Constructor, NAME, next) {
      Constructor.prototype = create(IteratorPrototype, {
        next: descriptor(1, next)
      });
      setToStringTag(Constructor, NAME + ' Iterator');
    };

    /***/
  }), ( /* 336 */
  /***/function (module, exports, __webpack_require__) {
    var ITERATOR = __webpack_require__(3)('iterator');
    var SAFE_CLOSING = false;
    try {
      var riter = [7][ITERATOR]();
      riter['return'] = function () {
        SAFE_CLOSING = true;
      };
      // eslint-disable-next-line no-throw-literal
      Array.from(riter, function () {
        throw 2;
      });
    } catch (e) {/* empty */}
    module.exports = function (exec, skipClosing) {
      if (!skipClosing && !SAFE_CLOSING) return false;
      var safe = false;
      try {
        var arr = [7];
        var iter = arr[ITERATOR]();
        iter.next = function () {
          return {
            done: safe = true
          };
        };
        arr[ITERATOR] = function () {
          return iter;
        };
        exec(arr);
      } catch (e) {/* empty */}
      return safe;
    };

    /***/
  }), ( /* 337 */
  /***/function (module, exports) {
    module.exports = function (done, value) {
      return {
        value: value,
        done: !!done
      };
    };

    /***/
  }), ( /* 338 */
  /***/function (module, exports, __webpack_require__) {
    var global = __webpack_require__(19);
    var macrotask = __webpack_require__(193).set;
    var Observer = global.MutationObserver || global.WebKitMutationObserver;
    var process = global.process;
    var Promise = global.Promise;
    var isNode = __webpack_require__(49)(process) == 'process';
    module.exports = function () {
      var head, last, notify;
      var flush = function flush() {
        var parent, fn;
        if (isNode && (parent = process.domain)) parent.exit();
        while (head) {
          fn = head.fn;
          head = head.next;
          try {
            fn();
          } catch (e) {
            if (head) notify();else last = undefined;
            throw e;
          }
        }
        last = undefined;
        if (parent) parent.enter();
      };

      // Node.js
      if (isNode) {
        notify = function notify() {
          process.nextTick(flush);
        };
        // browsers with MutationObserver
      } else if (Observer) {
        var toggle = true;
        var node = document.createTextNode('');
        new Observer(flush).observe(node, {
          characterData: true
        }); // eslint-disable-line no-new
        notify = function notify() {
          node.data = toggle = !toggle;
        };
        // environments with maybe non-completely correct, but existent Promise
      } else if (Promise && Promise.resolve) {
        var promise = Promise.resolve();
        notify = function notify() {
          promise.then(flush);
        };
        // for other environments - macrotask based on:
        // - setImmediate
        // - MessageChannel
        // - window.postMessag
        // - onreadystatechange
        // - setTimeout
      } else {
        notify = function notify() {
          // strange IE + webpack dev server bug - use .call(global)
          macrotask.call(global, flush);
        };
      }
      return function (fn) {
        var task = {
          fn: fn,
          next: undefined
        };
        if (last) last.next = task;
        if (!head) {
          head = task;
          notify();
        }
        last = task;
      };
    };

    /***/
  }), ( /* 339 */
  /***/function (module, exports, __webpack_require__) {
    // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
    var anObject = __webpack_require__(48);
    var dPs = __webpack_require__(340);
    var enumBugKeys = __webpack_require__(181);
    var IE_PROTO = __webpack_require__(126)('IE_PROTO');
    var Empty = function Empty() {/* empty */};
    var PROTOTYPE = 'prototype';

    // Create object with fake `null` prototype: use iframe Object with cleared prototype
    var _createDict2 = function createDict() {
      // Thrash, waste and sodomy: IE GC bug
      var iframe = __webpack_require__(123)('iframe');
      var i = enumBugKeys.length;
      var lt = '<';
      var gt = '>';
      var iframeDocument;
      iframe.style.display = 'none';
      __webpack_require__(183).appendChild(iframe);
      iframe.src = 'javascript:'; // eslint-disable-line no-script-url
      // createDict = iframe.contentWindow.Object;
      // html.removeChild(iframe);
      iframeDocument = iframe.contentWindow.document;
      iframeDocument.open();
      iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
      iframeDocument.close();
      _createDict2 = iframeDocument.F;
      while (i--) {
        delete _createDict2[PROTOTYPE][enumBugKeys[i]];
      }
      return _createDict2();
    };
    module.exports = Object.create || function create(O, Properties) {
      var result;
      if (O !== null) {
        Empty[PROTOTYPE] = anObject(O);
        result = new Empty();
        Empty[PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[IE_PROTO] = O;
      } else result = _createDict2();
      return Properties === undefined ? result : dPs(result, Properties);
    };

    /***/
  }), ( /* 340 */
  /***/function (module, exports, __webpack_require__) {
    var dP = __webpack_require__(86);
    var anObject = __webpack_require__(48);
    var getKeys = __webpack_require__(189);
    module.exports = __webpack_require__(67) ? Object.defineProperties : function defineProperties(O, Properties) {
      anObject(O);
      var keys = getKeys(Properties);
      var length = keys.length;
      var i = 0;
      var P;
      while (length > i) {
        dP.f(O, P = keys[i++], Properties[P]);
      }
      return O;
    };

    /***/
  }), ( /* 341 */
  /***/function (module, exports, __webpack_require__) {
    // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
    var has = __webpack_require__(69);
    var toObject = __webpack_require__(128);
    var IE_PROTO = __webpack_require__(126)('IE_PROTO');
    var ObjectProto = Object.prototype;
    module.exports = Object.getPrototypeOf || function (O) {
      O = toObject(O);
      if (has(O, IE_PROTO)) return O[IE_PROTO];
      if (typeof O.constructor == 'function' && O instanceof O.constructor) {
        return O.constructor.prototype;
      }
      return O instanceof Object ? ObjectProto : null;
    };

    /***/
  }), ( /* 342 */
  /***/function (module, exports, __webpack_require__) {
    var has = __webpack_require__(69);
    var toIObject = __webpack_require__(87);
    var arrayIndexOf = __webpack_require__(179)(false);
    var IE_PROTO = __webpack_require__(126)('IE_PROTO');
    module.exports = function (object, names) {
      var O = toIObject(object);
      var i = 0;
      var result = [];
      var key;
      for (key in O) {
        if (key != IE_PROTO) has(O, key) && result.push(key);
      }
      // Don't enum bug & hidden keys
      while (names.length > i) {
        if (has(O, key = names[i++])) {
          ~arrayIndexOf(result, key) || result.push(key);
        }
      }
      return result;
    };

    /***/
  }), ( /* 343 */
  /***/function (module, exports) {
    module.exports = function (exec) {
      try {
        return {
          e: false,
          v: exec()
        };
      } catch (e) {
        return {
          e: true,
          v: e
        };
      }
    };

    /***/
  }), ( /* 344 */
  /***/function (module, exports, __webpack_require__) {
    var newPromiseCapability = __webpack_require__(188);
    module.exports = function (C, x) {
      var promiseCapability = newPromiseCapability.f(C);
      var resolve = promiseCapability.resolve;
      resolve(x);
      return promiseCapability.promise;
    };

    /***/
  }), ( /* 345 */
  /***/function (module, exports, __webpack_require__) {
    var redefine = __webpack_require__(50);
    module.exports = function (target, src, safe) {
      for (var key in src) {
        redefine(target, key, src[key], safe);
      }
      return target;
    };

    /***/
  }), ( /* 346 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var global = __webpack_require__(19);
    var dP = __webpack_require__(86);
    var DESCRIPTORS = __webpack_require__(67);
    var SPECIES = __webpack_require__(3)('species');
    module.exports = function (KEY) {
      var C = global[KEY];
      if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
        configurable: true,
        get: function get() {
          return this;
        }
      });
    };

    /***/
  }), ( /* 347 */
  /***/function (module, exports, __webpack_require__) {
    // 7.3.20 SpeciesConstructor(O, defaultConstructor)
    var anObject = __webpack_require__(48);
    var aFunction = __webpack_require__(65);
    var SPECIES = __webpack_require__(3)('species');
    module.exports = function (O, D) {
      var C = anObject(O).constructor;
      var S;
      return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
    };

    /***/
  }), ( /* 348 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var toInteger = __webpack_require__(71);
    var defined = __webpack_require__(30);
    module.exports = function repeat(count) {
      var str = String(defined(this));
      var res = '';
      var n = toInteger(count);
      if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
      for (; n > 0; (n >>>= 1) && (str += str)) {
        if (n & 1) res += str;
      }
      return res;
    };

    /***/
  }), ( /* 349 */
  /***/function (module, exports, __webpack_require__) {
    var $export = __webpack_require__(6);
    var defined = __webpack_require__(30);
    var fails = __webpack_require__(68);
    var spaces = __webpack_require__(350);
    var space = '[' + spaces + ']';
    var non = "\u200B\x85";
    var ltrim = RegExp('^' + space + space + '*');
    var rtrim = RegExp(space + space + '*$');
    var exporter = function exporter(KEY, exec, ALIAS) {
      var exp = {};
      var FORCE = fails(function () {
        return !!spaces[KEY]() || non[KEY]() != non;
      });
      var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
      if (ALIAS) exp[ALIAS] = fn;
      $export($export.P + $export.F * FORCE, 'String', exp);
    };

    // 1 -> String#trimLeft
    // 2 -> String#trimRight
    // 3 -> String#trim
    var trim = exporter.trim = function (string, TYPE) {
      string = String(defined(string));
      if (TYPE & 1) string = string.replace(ltrim, '');
      if (TYPE & 2) string = string.replace(rtrim, '');
      return string;
    };
    module.exports = exporter;

    /***/
  }), ( /* 350 */
  /***/function (module, exports) {
    module.exports = "\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003" + "\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";

    /***/
  }), ( /* 351 */
  /***/function (module, exports, __webpack_require__) {
    // 7.1.1 ToPrimitive(input [, PreferredType])
    var isObject = __webpack_require__(38);
    // instead of the ES6 spec version, we didn't implement @@toPrimitive case
    // and the second argument - flag - preferred type is a string
    module.exports = function (it, S) {
      if (!isObject(it)) return it;
      var fn, val;
      if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
      if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
      if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
      throw TypeError("Can't convert object to primitive value");
    };

    /***/
  }), ( /* 352 */
  /***/function (module, exports, __webpack_require__) {
    var classof = __webpack_require__(122);
    var ITERATOR = __webpack_require__(3)('iterator');
    var Iterators = __webpack_require__(70);
    module.exports = __webpack_require__(36).getIteratorMethod = function (it) {
      if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
    };

    /***/
  }), ( /* 353 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var addToUnscopables = __webpack_require__(84);
    var step = __webpack_require__(337);
    var Iterators = __webpack_require__(70);
    var toIObject = __webpack_require__(87);

    // 22.1.3.4 Array.prototype.entries()
    // 22.1.3.13 Array.prototype.keys()
    // 22.1.3.29 Array.prototype.values()
    // 22.1.3.30 Array.prototype[@@iterator]()
    module.exports = __webpack_require__(186)(Array, 'Array', function (iterated, kind) {
      this._t = toIObject(iterated); // target
      this._i = 0; // next index
      this._k = kind; // kind
      // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
    }, function () {
      var O = this._t;
      var kind = this._k;
      var index = this._i++;
      if (!O || index >= O.length) {
        this._t = undefined;
        return step(1);
      }
      if (kind == 'keys') return step(0, index);
      if (kind == 'values') return step(0, O[index]);
      return step(0, [index, O[index]]);
    }, 'values');

    // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
    Iterators.Arguments = Iterators.Array;
    addToUnscopables('keys');
    addToUnscopables('values');
    addToUnscopables('entries');

    /***/
  }), ( /* 354 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // 19.1.3.6 Object.prototype.toString()
    var classof = __webpack_require__(122);
    var test = {};
    test[__webpack_require__(3)('toStringTag')] = 'z';
    if (test + '' != '[object z]') {
      __webpack_require__(50)(Object.prototype, 'toString', function toString() {
        return '[object ' + classof(this) + ']';
      }, true);
    }

    /***/
  }), ( /* 355 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var LIBRARY = __webpack_require__(187);
    var global = __webpack_require__(19);
    var ctx = __webpack_require__(66);
    var classof = __webpack_require__(122);
    var $export = __webpack_require__(6);
    var isObject = __webpack_require__(38);
    var aFunction = __webpack_require__(65);
    var anInstance = __webpack_require__(327);
    var forOf = __webpack_require__(329);
    var speciesConstructor = __webpack_require__(347);
    var task = __webpack_require__(193).set;
    var microtask = __webpack_require__(338)();
    var newPromiseCapabilityModule = __webpack_require__(188);
    var perform = __webpack_require__(343);
    var promiseResolve = __webpack_require__(344);
    var PROMISE = 'Promise';
    var TypeError = global.TypeError;
    var process = global.process;
    var $Promise = global[PROMISE];
    var isNode = classof(process) == 'process';
    var empty = function empty() {/* empty */};
    var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
    var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
    var USE_NATIVE = !!function () {
      try {
        // correct subclassing with @@species support
        var promise = $Promise.resolve(1);
        var FakePromise = (promise.constructor = {})[__webpack_require__(3)('species')] = function (exec) {
          exec(empty, empty);
        };
        // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
        return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
      } catch (e) {/* empty */}
    }();

    // helpers
    var sameConstructor = LIBRARY ? function (a, b) {
      // with library wrapper special case
      return a === b || a === $Promise && b === Wrapper;
    } : function (a, b) {
      return a === b;
    };
    var isThenable = function isThenable(it) {
      var then;
      return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
    };
    var notify = function notify(promise, isReject) {
      if (promise._n) return;
      promise._n = true;
      var chain = promise._c;
      microtask(function () {
        var value = promise._v;
        var ok = promise._s == 1;
        var i = 0;
        var run = function run(reaction) {
          var handler = ok ? reaction.ok : reaction.fail;
          var resolve = reaction.resolve;
          var reject = reaction.reject;
          var domain = reaction.domain;
          var result, then;
          try {
            if (handler) {
              if (!ok) {
                if (promise._h == 2) onHandleUnhandled(promise);
                promise._h = 1;
              }
              if (handler === true) result = value;else {
                if (domain) domain.enter();
                result = handler(value);
                if (domain) domain.exit();
              }
              if (result === reaction.promise) {
                reject(TypeError('Promise-chain cycle'));
              } else if (then = isThenable(result)) {
                then.call(result, resolve, reject);
              } else resolve(result);
            } else reject(value);
          } catch (e) {
            reject(e);
          }
        };
        while (chain.length > i) {
          run(chain[i++]);
        } // variable length - can't use forEach
        promise._c = [];
        promise._n = false;
        if (isReject && !promise._h) onUnhandled(promise);
      });
    };
    var onUnhandled = function onUnhandled(promise) {
      task.call(global, function () {
        var value = promise._v;
        var unhandled = isUnhandled(promise);
        var result, handler, console;
        if (unhandled) {
          result = perform(function () {
            if (isNode) {
              process.emit('unhandledRejection', value, promise);
            } else if (handler = global.onunhandledrejection) {
              handler({
                promise: promise,
                reason: value
              });
            } else if ((console = global.console) && console.error) {
              console.error('Unhandled promise rejection', value);
            }
          });
          // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
          promise._h = isNode || isUnhandled(promise) ? 2 : 1;
        }
        promise._a = undefined;
        if (unhandled && result.e) throw result.v;
      });
    };
    var isUnhandled = function isUnhandled(promise) {
      if (promise._h == 1) return false;
      var chain = promise._a || promise._c;
      var i = 0;
      var reaction;
      while (chain.length > i) {
        reaction = chain[i++];
        if (reaction.fail || !isUnhandled(reaction.promise)) return false;
      }
      return true;
    };
    var onHandleUnhandled = function onHandleUnhandled(promise) {
      task.call(global, function () {
        var handler;
        if (isNode) {
          process.emit('rejectionHandled', promise);
        } else if (handler = global.onrejectionhandled) {
          handler({
            promise: promise,
            reason: promise._v
          });
        }
      });
    };
    var $reject = function $reject(value) {
      var promise = this;
      if (promise._d) return;
      promise._d = true;
      promise = promise._w || promise; // unwrap
      promise._v = value;
      promise._s = 2;
      if (!promise._a) promise._a = promise._c.slice();
      notify(promise, true);
    };
    var $resolve = function $resolve(value) {
      var promise = this;
      var then;
      if (promise._d) return;
      promise._d = true;
      promise = promise._w || promise; // unwrap
      try {
        if (promise === value) throw TypeError("Promise can't be resolved itself");
        if (then = isThenable(value)) {
          microtask(function () {
            var wrapper = {
              _w: promise,
              _d: false
            }; // wrap
            try {
              then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
            } catch (e) {
              $reject.call(wrapper, e);
            }
          });
        } else {
          promise._v = value;
          promise._s = 1;
          notify(promise, false);
        }
      } catch (e) {
        $reject.call({
          _w: promise,
          _d: false
        }, e); // wrap
      }
    };

    // constructor polyfill
    if (!USE_NATIVE) {
      // 25.4.3.1 Promise(executor)
      $Promise = function Promise(executor) {
        anInstance(this, $Promise, PROMISE, '_h');
        aFunction(executor);
        Internal.call(this);
        try {
          executor(ctx($resolve, this, 1), ctx($reject, this, 1));
        } catch (err) {
          $reject.call(this, err);
        }
      };
      // eslint-disable-next-line no-unused-vars
      Internal = function Promise(executor) {
        this._c = []; // <- awaiting reactions
        this._a = undefined; // <- checked in isUnhandled reactions
        this._s = 0; // <- state
        this._d = false; // <- done
        this._v = undefined; // <- value
        this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
        this._n = false; // <- notify
      };
      Internal.prototype = __webpack_require__(345)($Promise.prototype, {
        // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
        then: function then(onFulfilled, onRejected) {
          var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
          reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
          reaction.fail = typeof onRejected == 'function' && onRejected;
          reaction.domain = isNode ? process.domain : undefined;
          this._c.push(reaction);
          if (this._a) this._a.push(reaction);
          if (this._s) notify(this, false);
          return reaction.promise;
        },
        // 25.4.5.1 Promise.prototype.catch(onRejected)
        'catch': function _catch(onRejected) {
          return this.then(undefined, onRejected);
        }
      });
      OwnPromiseCapability = function OwnPromiseCapability() {
        var promise = new Internal();
        this.promise = promise;
        this.resolve = ctx($resolve, promise, 1);
        this.reject = ctx($reject, promise, 1);
      };
      newPromiseCapabilityModule.f = newPromiseCapability = function newPromiseCapability(C) {
        return sameConstructor($Promise, C) ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
      };
    }
    $export($export.G + $export.W + $export.F * !USE_NATIVE, {
      Promise: $Promise
    });
    __webpack_require__(125)($Promise, PROMISE);
    __webpack_require__(346)(PROMISE);
    Wrapper = __webpack_require__(36)[PROMISE];

    // statics
    $export($export.S + $export.F * !USE_NATIVE, PROMISE, {
      // 25.4.4.5 Promise.reject(r)
      reject: function reject(r) {
        var capability = newPromiseCapability(this);
        var $$reject = capability.reject;
        $$reject(r);
        return capability.promise;
      }
    });
    $export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
      // 25.4.4.6 Promise.resolve(x)
      resolve: function resolve(x) {
        // instanceof instead of internal slot check because we should fix it without replacement native Promise core
        if (x instanceof $Promise && sameConstructor(x.constructor, this)) return x;
        return promiseResolve(this, x);
      }
    });
    $export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(336)(function (iter) {
      $Promise.all(iter)['catch'](empty);
    })), PROMISE, {
      // 25.4.4.1 Promise.all(iterable)
      all: function all(iterable) {
        var C = this;
        var capability = newPromiseCapability(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = perform(function () {
          var values = [];
          var index = 0;
          var remaining = 1;
          forOf(iterable, false, function (promise) {
            var $index = index++;
            var alreadyCalled = false;
            values.push(undefined);
            remaining++;
            C.resolve(promise).then(function (value) {
              if (alreadyCalled) return;
              alreadyCalled = true;
              values[$index] = value;
              --remaining || resolve(values);
            }, reject);
          });
          --remaining || resolve(values);
        });
        if (result.e) reject(result.v);
        return capability.promise;
      },
      // 25.4.4.4 Promise.race(iterable)
      race: function race(iterable) {
        var C = this;
        var capability = newPromiseCapability(C);
        var reject = capability.reject;
        var result = perform(function () {
          forOf(iterable, false, function (promise) {
            C.resolve(promise).then(capability.resolve, reject);
          });
        });
        if (result.e) reject(result.v);
        return capability.promise;
      }
    });

    /***/
  }), ( /* 356 */
  /***/function (module, exports, __webpack_require__) {
    // @@match logic
    __webpack_require__(85)('match', 1, function (defined, MATCH, $match) {
      // 21.1.3.11 String.prototype.match(regexp)
      return [function match(regexp) {
        'use strict';

        var O = defined(this);
        var fn = regexp == undefined ? undefined : regexp[MATCH];
        return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
      }, $match];
    });

    /***/
  }), ( /* 357 */
  /***/function (module, exports, __webpack_require__) {
    // @@replace logic
    __webpack_require__(85)('replace', 2, function (defined, REPLACE, $replace) {
      // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
      return [function replace(searchValue, replaceValue) {
        'use strict';

        var O = defined(this);
        var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
        return fn !== undefined ? fn.call(searchValue, O, replaceValue) : $replace.call(String(O), searchValue, replaceValue);
      }, $replace];
    });

    /***/
  }), ( /* 358 */
  /***/function (module, exports, __webpack_require__) {
    // @@search logic
    __webpack_require__(85)('search', 1, function (defined, SEARCH, $search) {
      // 21.1.3.15 String.prototype.search(regexp)
      return [function search(regexp) {
        'use strict';

        var O = defined(this);
        var fn = regexp == undefined ? undefined : regexp[SEARCH];
        return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
      }, $search];
    });

    /***/
  }), ( /* 359 */
  /***/function (module, exports, __webpack_require__) {
    // @@split logic
    __webpack_require__(85)('split', 2, function (defined, SPLIT, $split) {
      'use strict';

      var isRegExp = __webpack_require__(185);
      var _split = $split;
      var $push = [].push;
      var $SPLIT = 'split';
      var LENGTH = 'length';
      var LAST_INDEX = 'lastIndex';
      if ('abbc'[$SPLIT](/(b)*/)[1] == 'c' || 'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 || 'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 || '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 || '.'[$SPLIT](/()()/)[LENGTH] > 1 || ''[$SPLIT](/.?/)[LENGTH]) {
        var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
        // based on es5-shim implementation, need to rework it
        $split = function $split(separator, limit) {
          var string = String(this);
          if (separator === undefined && limit === 0) return [];
          // If `separator` is not a regex, use native split
          if (!isRegExp(separator)) return _split.call(string, separator, limit);
          var output = [];
          var flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.unicode ? 'u' : '') + (separator.sticky ? 'y' : '');
          var lastLastIndex = 0;
          var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
          // Make `global` and avoid `lastIndex` issues by working with a copy
          var separatorCopy = new RegExp(separator.source, flags + 'g');
          var separator2, match, lastIndex, lastLength, i;
          // Doesn't need flags gy, but they don't hurt
          if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
          while (match = separatorCopy.exec(string)) {
            // `separatorCopy.lastIndex` is not reliable cross-browser
            lastIndex = match.index + match[0][LENGTH];
            if (lastIndex > lastLastIndex) {
              output.push(string.slice(lastLastIndex, match.index));
              // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
              // eslint-disable-next-line no-loop-func
              if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
                for (i = 1; i < arguments[LENGTH] - 2; i++) {
                  if (arguments[i] === undefined) match[i] = undefined;
                }
              });
              if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
              lastLength = match[0][LENGTH];
              lastLastIndex = lastIndex;
              if (output[LENGTH] >= splitLimit) break;
            }
            if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
          }
          if (lastLastIndex === string[LENGTH]) {
            if (lastLength || !separatorCopy.test('')) output.push('');
          } else output.push(string.slice(lastLastIndex));
          return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
        };
        // Chakra, V8
      } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
        $split = function $split(separator, limit) {
          return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
        };
      }
      // 21.1.3.17 String.prototype.split(separator, limit)
      return [function split(separator, limit) {
        var O = defined(this);
        var fn = separator == undefined ? undefined : separator[SPLIT];
        return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
      }, $split];
    });

    /***/
  }), ( /* 360 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // B.2.3.2 String.prototype.anchor(name)
    __webpack_require__(8)('anchor', function (createHTML) {
      return function anchor(name) {
        return createHTML(this, 'a', 'name', name);
      };
    });

    /***/
  }), ( /* 361 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // B.2.3.3 String.prototype.big()
    __webpack_require__(8)('big', function (createHTML) {
      return function big() {
        return createHTML(this, 'big', '', '');
      };
    });

    /***/
  }), ( /* 362 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // B.2.3.4 String.prototype.blink()
    __webpack_require__(8)('blink', function (createHTML) {
      return function blink() {
        return createHTML(this, 'blink', '', '');
      };
    });

    /***/
  }), ( /* 363 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // B.2.3.5 String.prototype.bold()
    __webpack_require__(8)('bold', function (createHTML) {
      return function bold() {
        return createHTML(this, 'b', '', '');
      };
    });

    /***/
  }), ( /* 364 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var $export = __webpack_require__(6);
    var $at = __webpack_require__(192)(false);
    $export($export.P, 'String', {
      // 21.1.3.3 String.prototype.codePointAt(pos)
      codePointAt: function codePointAt(pos) {
        return $at(this, pos);
      }
    });

    /***/
  }), ( /* 365 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
    var $export = __webpack_require__(6);
    var toLength = __webpack_require__(31);
    var context = __webpack_require__(127);
    var ENDS_WITH = 'endsWith';
    var $endsWith = ''[ENDS_WITH];
    $export($export.P + $export.F * __webpack_require__(124)(ENDS_WITH), 'String', {
      endsWith: function endsWith(searchString /* , endPosition = @length */) {
        var that = context(this, searchString, ENDS_WITH);
        var endPosition = arguments.length > 1 ? arguments[1] : undefined;
        var len = toLength(that.length);
        var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
        var search = String(searchString);
        return $endsWith ? $endsWith.call(that, search, end) : that.slice(end - search.length, end) === search;
      }
    });

    /***/
  }), ( /* 366 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // B.2.3.6 String.prototype.fixed()
    __webpack_require__(8)('fixed', function (createHTML) {
      return function fixed() {
        return createHTML(this, 'tt', '', '');
      };
    });

    /***/
  }), ( /* 367 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // B.2.3.7 String.prototype.fontcolor(color)
    __webpack_require__(8)('fontcolor', function (createHTML) {
      return function fontcolor(color) {
        return createHTML(this, 'font', 'color', color);
      };
    });

    /***/
  }), ( /* 368 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // B.2.3.8 String.prototype.fontsize(size)
    __webpack_require__(8)('fontsize', function (createHTML) {
      return function fontsize(size) {
        return createHTML(this, 'font', 'size', size);
      };
    });

    /***/
  }), ( /* 369 */
  /***/function (module, exports, __webpack_require__) {
    var $export = __webpack_require__(6);
    var toAbsoluteIndex = __webpack_require__(194);
    var fromCharCode = String.fromCharCode;
    var $fromCodePoint = String.fromCodePoint;

    // length should be 1, old FF problem
    $export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
      // 21.1.2.2 String.fromCodePoint(...codePoints)
      fromCodePoint: function fromCodePoint(x) {
        // eslint-disable-line no-unused-vars
        var res = [];
        var aLen = arguments.length;
        var i = 0;
        var code;
        while (aLen > i) {
          code = +arguments[i++];
          if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
          res.push(code < 0x10000 ? fromCharCode(code) : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00));
        }
        return res.join('');
      }
    });

    /***/
  }), ( /* 370 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // 21.1.3.7 String.prototype.includes(searchString, position = 0)
    var $export = __webpack_require__(6);
    var context = __webpack_require__(127);
    var INCLUDES = 'includes';
    $export($export.P + $export.F * __webpack_require__(124)(INCLUDES), 'String', {
      includes: function includes(searchString /* , position = 0 */) {
        return !!~context(this, searchString, INCLUDES).indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
      }
    });

    /***/
  }), ( /* 371 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // B.2.3.9 String.prototype.italics()
    __webpack_require__(8)('italics', function (createHTML) {
      return function italics() {
        return createHTML(this, 'i', '', '');
      };
    });

    /***/
  }), ( /* 372 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // B.2.3.10 String.prototype.link(url)
    __webpack_require__(8)('link', function (createHTML) {
      return function link(url) {
        return createHTML(this, 'a', 'href', url);
      };
    });

    /***/
  }), ( /* 373 */
  /***/function (module, exports, __webpack_require__) {
    var $export = __webpack_require__(6);
    var toIObject = __webpack_require__(87);
    var toLength = __webpack_require__(31);
    $export($export.S, 'String', {
      // 21.1.2.4 String.raw(callSite, ...substitutions)
      raw: function raw(callSite) {
        var tpl = toIObject(callSite.raw);
        var len = toLength(tpl.length);
        var aLen = arguments.length;
        var res = [];
        var i = 0;
        while (len > i) {
          res.push(String(tpl[i++]));
          if (i < aLen) res.push(String(arguments[i]));
        }
        return res.join('');
      }
    });

    /***/
  }), ( /* 374 */
  /***/function (module, exports, __webpack_require__) {
    var $export = __webpack_require__(6);
    $export($export.P, 'String', {
      // 21.1.3.13 String.prototype.repeat(count)
      repeat: __webpack_require__(348)
    });

    /***/
  }), ( /* 375 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // B.2.3.11 String.prototype.small()
    __webpack_require__(8)('small', function (createHTML) {
      return function small() {
        return createHTML(this, 'small', '', '');
      };
    });

    /***/
  }), ( /* 376 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // 21.1.3.18 String.prototype.startsWith(searchString [, position ])
    var $export = __webpack_require__(6);
    var toLength = __webpack_require__(31);
    var context = __webpack_require__(127);
    var STARTS_WITH = 'startsWith';
    var $startsWith = ''[STARTS_WITH];
    $export($export.P + $export.F * __webpack_require__(124)(STARTS_WITH), 'String', {
      startsWith: function startsWith(searchString /* , position = 0 */) {
        var that = context(this, searchString, STARTS_WITH);
        var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
        var search = String(searchString);
        return $startsWith ? $startsWith.call(that, search, index) : that.slice(index, index + search.length) === search;
      }
    });

    /***/
  }), ( /* 377 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // B.2.3.12 String.prototype.strike()
    __webpack_require__(8)('strike', function (createHTML) {
      return function strike() {
        return createHTML(this, 'strike', '', '');
      };
    });

    /***/
  }), ( /* 378 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // B.2.3.13 String.prototype.sub()
    __webpack_require__(8)('sub', function (createHTML) {
      return function sub() {
        return createHTML(this, 'sub', '', '');
      };
    });

    /***/
  }), ( /* 379 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // B.2.3.14 String.prototype.sup()
    __webpack_require__(8)('sup', function (createHTML) {
      return function sup() {
        return createHTML(this, 'sup', '', '');
      };
    });

    /***/
  }), ( /* 380 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // 21.1.3.25 String.prototype.trim()
    __webpack_require__(349)('trim', function ($trim) {
      return function trim() {
        return $trim(this, 3);
      };
    });

    /***/
  }), ( /* 381 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
    var $export = __webpack_require__(6);
    var flattenIntoArray = __webpack_require__(182);
    var toObject = __webpack_require__(128);
    var toLength = __webpack_require__(31);
    var aFunction = __webpack_require__(65);
    var arraySpeciesCreate = __webpack_require__(180);
    $export($export.P, 'Array', {
      flatMap: function flatMap(callbackfn /* , thisArg */) {
        var O = toObject(this);
        var sourceLen, A;
        aFunction(callbackfn);
        sourceLen = toLength(O.length);
        A = arraySpeciesCreate(O, 0);
        flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
        return A;
      }
    });
    __webpack_require__(84)('flatMap');

    /***/
  }), ( /* 382 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
    var $export = __webpack_require__(6);
    var flattenIntoArray = __webpack_require__(182);
    var toObject = __webpack_require__(128);
    var toLength = __webpack_require__(31);
    var toInteger = __webpack_require__(71);
    var arraySpeciesCreate = __webpack_require__(180);
    $export($export.P, 'Array', {
      flatten: function flatten( /* depthArg = 1 */
      ) {
        var depthArg = arguments[0];
        var O = toObject(this);
        var sourceLen = toLength(O.length);
        var A = arraySpeciesCreate(O, 0);
        flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
        return A;
      }
    });
    __webpack_require__(84)('flatten');

    /***/
  }), ( /* 383 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // https://github.com/tc39/Array.prototype.includes
    var $export = __webpack_require__(6);
    var $includes = __webpack_require__(179)(true);
    $export($export.P, 'Array', {
      includes: function includes(el /* , fromIndex = 0 */) {
        return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
      }
    });
    __webpack_require__(84)('includes');

    /***/
  }), ( /* 384 */
  /***/function (module, exports, __webpack_require__) {
    var $iterators = __webpack_require__(353);
    var getKeys = __webpack_require__(189);
    var redefine = __webpack_require__(50);
    var global = __webpack_require__(19);
    var hide = __webpack_require__(37);
    var Iterators = __webpack_require__(70);
    var wks = __webpack_require__(3);
    var ITERATOR = wks('iterator');
    var TO_STRING_TAG = wks('toStringTag');
    var ArrayValues = Iterators.Array;
    var DOMIterables = {
      CSSRuleList: true,
      // TODO: Not spec compliant, should be false.
      CSSStyleDeclaration: false,
      CSSValueList: false,
      ClientRectList: false,
      DOMRectList: false,
      DOMStringList: false,
      DOMTokenList: true,
      DataTransferItemList: false,
      FileList: false,
      HTMLAllCollection: false,
      HTMLCollection: false,
      HTMLFormElement: false,
      HTMLSelectElement: false,
      MediaList: true,
      // TODO: Not spec compliant, should be false.
      MimeTypeArray: false,
      NamedNodeMap: false,
      NodeList: true,
      PaintRequestList: false,
      Plugin: false,
      PluginArray: false,
      SVGLengthList: false,
      SVGNumberList: false,
      SVGPathSegList: false,
      SVGPointList: false,
      SVGStringList: false,
      SVGTransformList: false,
      SourceBufferList: false,
      StyleSheetList: true,
      // TODO: Not spec compliant, should be false.
      TextTrackCueList: false,
      TextTrackList: false,
      TouchList: false
    };
    for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
      var NAME = collections[i];
      var explicit = DOMIterables[NAME];
      var Collection = global[NAME];
      var proto = Collection && Collection.prototype;
      var key;
      if (proto) {
        if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
        if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
        Iterators[NAME] = ArrayValues;
        if (explicit) for (key in $iterators) {
          if (!proto[key]) redefine(proto, key, $iterators[key], true);
        }
      }
    }

    /***/
  }), ( /* 385 */
  /***/function (module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(196)();
    // imports

    // module
    exports.push([module.i, ".oc-md-hl-header {\n  font-weight: bold;\n}\n.oc-md-hl-code {\n  background-color: #f5f5f5;\n}\n.oc-md-hl-bold {\n  font-weight: bold;\n}\n.oc-md-hl-italic {\n  font-style: italic;\n}\n.oc-md-hl-punctuation {\n  color: #777;\n}\n.oc-md-hl-strikethrough {\n  text-decoration: line-through;\n}\n.react-markdown--plain-markdown-input__right-buttons {\n  margin-left: auto !important;\n}\n.react-markdown--toolbar .react-markdown--plain-markdown-input__right-buttons .btn,\n.react-markdown--toolbar .react-markdown--plain-markdown-input__left-border .btn {\n  border-left: 1px solid #ccc;\n}\n.react-markdown--slate-editor {\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  height: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  position: relative;\n}\n.react-markdown--slate-editor--fullscreen {\n  bottom: 0;\n  left: 0;\n  margin: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n  width: auto;\n  z-index: 999;\n  background-color: white;\n}\n.react-markdown--toolbar {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -ms-flex: 1 0 auto;\n      flex: 1 0 auto;\n  position: relative;\n}\n.react-markdown--toolbar .btn {\n  border: 0;\n  box-shadow: none;\n}\n.react-markdown--toolbar .btn-group {\n  margin-left: 0;\n}\n.react-markdown--slate-content {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: stretch;\n      justify-content: stretch;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n  padding: 5px;\n  overflow: auto;\n  height: 100%;\n  position: relative;\n  font-size: 14px;\n  font-family: Ubuntu Mono, Monaco, monospace;\n}\n.react-markdown--slate-content > div {\n  -ms-flex: 1 0;\n      flex: 1 0;\n}\n.react-markdown--slate-content__editor {\n  min-height: 100%;\n}\n.fullscreen-tp {\n  z-index: 2000;\n}\n", ""]);

    // exports

    /***/
  }), ( /* 386 */
  /***/function (module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(196)();
    // imports

    // module
    exports.push([module.i, ".react-markdown--autocomplete-widget {\n  position: absolute;\n  background-color: #fff;\n  overflow-y: auto;\n  min-width: 160px;\n  max-width: 320px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);\n  z-index: 10;\n}\n.react-markdown--autocomplete-widget__item {\n  -ms-flex: 1 0 auto;\n      flex: 1 0 auto;\n  padding: 4px 12px;\n}\n.react-markdown--autocomplete-widget__item:hover {\n  cursor: default;\n  background-color: #f5f5f5;\n}\n.react-markdown--autocomplete-widget__item--active {\n  background-color: #067!important;\n  color: #fff!important;\n}\n", ""]);

    // exports

    /***/
  }), ( /* 387 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var isValue = __webpack_require__(58),
      ensureValue = __webpack_require__(692),
      ensurePlainFunction = __webpack_require__(689),
      copy = __webpack_require__(418),
      normalizeOptions = __webpack_require__(206),
      map = __webpack_require__(425);
    var bind = Function.prototype.bind,
      defineProperty = Object.defineProperty,
      hasOwnProperty = Object.prototype.hasOwnProperty,
      define;
    define = function define(name, desc, options) {
      var value = ensureValue(desc) && ensurePlainFunction(desc.value),
        dgs;
      dgs = copy(desc);
      delete dgs.writable;
      delete dgs.value;
      dgs.get = function () {
        if (!options.overwriteDefinition && hasOwnProperty.call(this, name)) return value;
        desc.value = bind.call(value, options.resolveContext ? options.resolveContext(this) : this);
        defineProperty(this, name, desc);
        return this[name];
      };
      return dgs;
    };
    module.exports = function (props /*, options*/) {
      var options = normalizeOptions(arguments[1]);
      if (isValue(options.resolveContext)) ensurePlainFunction(options.resolveContext);
      return map(props, function (desc, name) {
        return define(name, desc, options);
      });
    };

    /***/
  }), ( /* 388 */
  /***/function (module, exports) {
    /**
     * Helpers.
     */

    var s = 1000;
    var m = s * 60;
    var h = m * 60;
    var d = h * 24;
    var y = d * 365.25;

    /**
     * Parse or format the given `val`.
     *
     * Options:
     *
     *  - `long` verbose formatting [false]
     *
     * @param {String|Number} val
     * @param {Object} [options]
     * @throws {Error} throw an error if val is not a non-empty string or a number
     * @return {String|Number}
     * @api public
     */

    module.exports = function (val, options) {
      options = options || {};
      var type = typeof val;
      if (type === 'string' && val.length > 0) {
        return parse(val);
      } else if (type === 'number' && isNaN(val) === false) {
        return options.long ? fmtLong(val) : fmtShort(val);
      }
      throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
    };

    /**
     * Parse the given `str` and return milliseconds.
     *
     * @param {String} str
     * @return {Number}
     * @api private
     */

    function parse(str) {
      str = String(str);
      if (str.length > 100) {
        return;
      }
      var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
      if (!match) {
        return;
      }
      var n = parseFloat(match[1]);
      var type = (match[2] || 'ms').toLowerCase();
      switch (type) {
        case 'years':
        case 'year':
        case 'yrs':
        case 'yr':
        case 'y':
          return n * y;
        case 'days':
        case 'day':
        case 'd':
          return n * d;
        case 'hours':
        case 'hour':
        case 'hrs':
        case 'hr':
        case 'h':
          return n * h;
        case 'minutes':
        case 'minute':
        case 'mins':
        case 'min':
        case 'm':
          return n * m;
        case 'seconds':
        case 'second':
        case 'secs':
        case 'sec':
        case 's':
          return n * s;
        case 'milliseconds':
        case 'millisecond':
        case 'msecs':
        case 'msec':
        case 'ms':
          return n;
        default:
          return undefined;
      }
    }

    /**
     * Short format for `ms`.
     *
     * @param {Number} ms
     * @return {String}
     * @api private
     */

    function fmtShort(ms) {
      if (ms >= d) {
        return Math.round(ms / d) + 'd';
      }
      if (ms >= h) {
        return Math.round(ms / h) + 'h';
      }
      if (ms >= m) {
        return Math.round(ms / m) + 'm';
      }
      if (ms >= s) {
        return Math.round(ms / s) + 's';
      }
      return ms + 'ms';
    }

    /**
     * Long format for `ms`.
     *
     * @param {Number} ms
     * @return {String}
     * @api private
     */

    function fmtLong(ms) {
      return plural(ms, d, 'day') || plural(ms, h, 'hour') || plural(ms, m, 'minute') || plural(ms, s, 'second') || ms + ' ms';
    }

    /**
     * Pluralization helper.
     */

    function plural(ms, n, name) {
      if (ms < n) {
        return;
      }
      if (ms < n * 1.5) {
        return Math.floor(ms / n) + ' ' + name;
      }
      return Math.ceil(ms / n) + ' ' + name + 's';
    }

    /***/
  }), ( /* 389 */
  /***/function (module, exports, __webpack_require__) {
    /**
     * This is the common logic for both the Node.js and web browser
     * implementations of `debug()`.
     *
     * Expose `debug()` as the module.
     */

    exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
    exports.coerce = coerce;
    exports.disable = disable;
    exports.enable = enable;
    exports.enabled = enabled;
    exports.humanize = __webpack_require__(388);

    /**
     * The currently active debug mode names, and names to skip.
     */

    exports.names = [];
    exports.skips = [];

    /**
     * Map of special "%n" handling functions, for the debug "format" argument.
     *
     * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
     */

    exports.formatters = {};

    /**
     * Previous log timestamp.
     */

    var prevTime;

    /**
     * Select a color.
     * @param {String} namespace
     * @return {Number}
     * @api private
     */

    function selectColor(namespace) {
      var hash = 0,
        i;
      for (i in namespace) {
        hash = (hash << 5) - hash + namespace.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
      }
      return exports.colors[Math.abs(hash) % exports.colors.length];
    }

    /**
     * Create a debugger with the given `namespace`.
     *
     * @param {String} namespace
     * @return {Function}
     * @api public
     */

    function createDebug(namespace) {
      function debug() {
        // disabled?
        if (!debug.enabled) return;
        var self = debug;

        // set `diff` timestamp
        var curr = +new Date();
        var ms = curr - (prevTime || curr);
        self.diff = ms;
        self.prev = prevTime;
        self.curr = curr;
        prevTime = curr;

        // turn the `arguments` into a proper Array
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i];
        }
        args[0] = exports.coerce(args[0]);
        if ('string' !== typeof args[0]) {
          // anything else let's inspect with %O
          args.unshift('%O');
        }

        // apply any `formatters` transformations
        var index = 0;
        args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
          // if we encounter an escaped % then don't increase the array index
          if (match === '%%') return match;
          index++;
          var formatter = exports.formatters[format];
          if ('function' === typeof formatter) {
            var val = args[index];
            match = formatter.call(self, val);

            // now we need to remove `args[index]` since it's inlined in the `format`
            args.splice(index, 1);
            index--;
          }
          return match;
        });

        // apply env-specific formatting (colors, etc.)
        exports.formatArgs.call(self, args);
        var logFn = debug.log || exports.log || console.log.bind(console);
        logFn.apply(self, args);
      }
      debug.namespace = namespace;
      debug.enabled = exports.enabled(namespace);
      debug.useColors = exports.useColors();
      debug.color = selectColor(namespace);

      // env-specific initialization logic for debug instances
      if ('function' === typeof exports.init) {
        exports.init(debug);
      }
      return debug;
    }

    /**
     * Enables a debug mode by namespaces. This can include modes
     * separated by a colon and wildcards.
     *
     * @param {String} namespaces
     * @api public
     */

    function enable(namespaces) {
      exports.save(namespaces);
      exports.names = [];
      exports.skips = [];
      var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
      var len = split.length;
      for (var i = 0; i < len; i++) {
        if (!split[i]) continue; // ignore empty strings
        namespaces = split[i].replace(/\*/g, '.*?');
        if (namespaces[0] === '-') {
          exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
        } else {
          exports.names.push(new RegExp('^' + namespaces + '$'));
        }
      }
    }

    /**
     * Disable debug output.
     *
     * @api public
     */

    function disable() {
      exports.enable('');
    }

    /**
     * Returns true if the given mode name is enabled, false otherwise.
     *
     * @param {String} name
     * @return {Boolean}
     * @api public
     */

    function enabled(name) {
      var i, len;
      for (i = 0, len = exports.skips.length; i < len; i++) {
        if (exports.skips[i].test(name)) {
          return false;
        }
      }
      for (i = 0, len = exports.names.length; i < len; i++) {
        if (exports.names[i].test(name)) {
          return true;
        }
      }
      return false;
    }

    /**
     * Coerce `val`.
     *
     * @param {Mixed} val
     * @return {Mixed}
     * @api private
     */

    function coerce(val) {
      if (val instanceof Error) return val.stack || val.message;
      return val;
    }

    /***/
  }), ( /* 390 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var GROUP_LEFT_TO_RIGHT, GROUP_RIGHT_TO_LEFT, EXPRESSION_LEFT_TO_RIGHT, EXPRESSION_RIGHT_TO_LEFT;

    /*
     * Character ranges of left-to-right characters.
     */

    GROUP_LEFT_TO_RIGHT = "A-Za-z\xC0-\xD6\xD8-\xF6" + "\xF8-\u02B8\u0300-\u0590\u0800-\u1FFF\u200E\u2C00-\uFB1C" + "\uFE00-\uFE6F\uFEFD-\uFFFF";

    /*
     * Character ranges of right-to-left characters.
     */

    GROUP_RIGHT_TO_LEFT = "\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC";

    /*
     * Expression to match a left-to-right string.
     *
     * Matches the start of a string, followed by zero or
     * more non-right-to-left characters, followed by a
     * left-to-right character.
     */

    EXPRESSION_LEFT_TO_RIGHT = new RegExp('^[^' + GROUP_RIGHT_TO_LEFT + ']*[' + GROUP_LEFT_TO_RIGHT + ']');

    /*
     * Expression to match a right-to-left string.
     *
     * Matches the start of a string, followed by zero or
     * more non-left-to-right characters, followed by a
     * right-to-left character.
     */

    EXPRESSION_RIGHT_TO_LEFT = new RegExp('^[^' + GROUP_LEFT_TO_RIGHT + ']*[' + GROUP_RIGHT_TO_LEFT + ']');

    /**
     * Detect the direction of text.
     *
     * @param {string} value - value to stringify and check.
     * @return {string} - One of `"rtl"`, `"ltr"`, or
     *   `"neutral"`.
     */
    function direction(value) {
      value = value.toString();
      if (EXPRESSION_RIGHT_TO_LEFT.test(value)) {
        return 'rtl';
      }
      if (EXPRESSION_LEFT_TO_RIGHT.test(value)) {
        return 'ltr';
      }
      return 'neutral';
    }

    /*
     * Expose `direction`.
     */

    module.exports = direction;

    /***/
  }), ( /* 391 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var _interopRequireDefault = __webpack_require__(5);
    exports.__esModule = true;
    exports.default = activeElement;
    var _ownerDocument = _interopRequireDefault(__webpack_require__(88));
    function activeElement(doc) {
      if (doc === void 0) {
        doc = (0, _ownerDocument.default)();
      }
      try {
        return doc.activeElement;
      } catch (e) {
        /* ie throws if no active element */
      }
    }
    module.exports = exports["default"];

    /***/
  }), ( /* 392 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var _interopRequireDefault = __webpack_require__(5);
    exports.__esModule = true;
    exports.default = void 0;
    var _inDOM = _interopRequireDefault(__webpack_require__(90));
    var off = function off() {};
    if (_inDOM.default) {
      off = function () {
        if (document.addEventListener) return function (node, eventName, handler, capture) {
          return node.removeEventListener(eventName, handler, capture || false);
        };else if (document.attachEvent) return function (node, eventName, handler) {
          return node.detachEvent('on' + eventName, handler);
        };
      }();
    }
    var _default = off;
    exports.default = _default;
    module.exports = exports["default"];

    /***/
  }), ( /* 393 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var _interopRequireDefault = __webpack_require__(5);
    exports.__esModule = true;
    exports.default = offsetParent;
    var _ownerDocument = _interopRequireDefault(__webpack_require__(88));
    var _style = _interopRequireDefault(__webpack_require__(200));
    function nodeName(node) {
      return node.nodeName && node.nodeName.toLowerCase();
    }
    function offsetParent(node) {
      var doc = (0, _ownerDocument.default)(node),
        offsetParent = node && node.offsetParent;
      while (offsetParent && nodeName(node) !== 'html' && (0, _style.default)(offsetParent, 'position') === 'static') {
        offsetParent = offsetParent.offsetParent;
      }
      return offsetParent || doc.documentElement;
    }
    module.exports = exports["default"];

    /***/
  }), ( /* 394 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var _interopRequireDefault = __webpack_require__(5);
    exports.__esModule = true;
    exports.default = position;
    var _extends2 = _interopRequireDefault(__webpack_require__(260));
    var _offset = _interopRequireDefault(__webpack_require__(198));
    var _offsetParent = _interopRequireDefault(__webpack_require__(393));
    var _scrollTop = _interopRequireDefault(__webpack_require__(199));
    var _scrollLeft = _interopRequireDefault(__webpack_require__(395));
    var _style = _interopRequireDefault(__webpack_require__(200));
    function nodeName(node) {
      return node.nodeName && node.nodeName.toLowerCase();
    }
    function position(node, offsetParent) {
      var parentOffset = {
          top: 0,
          left: 0
        },
        offset; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
      // because it is its only offset parent

      if ((0, _style.default)(node, 'position') === 'fixed') {
        offset = node.getBoundingClientRect();
      } else {
        offsetParent = offsetParent || (0, _offsetParent.default)(node);
        offset = (0, _offset.default)(node);
        if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset.default)(offsetParent);
        parentOffset.top += parseInt((0, _style.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop.default)(offsetParent) || 0;
        parentOffset.left += parseInt((0, _style.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft.default)(offsetParent) || 0;
      } // Subtract parent offsets and node margins

      return (0, _extends2.default)({}, offset, {
        top: offset.top - parentOffset.top - (parseInt((0, _style.default)(node, 'marginTop'), 10) || 0),
        left: offset.left - parentOffset.left - (parseInt((0, _style.default)(node, 'marginLeft'), 10) || 0)
      });
    }
    module.exports = exports["default"];

    /***/
  }), ( /* 395 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var _interopRequireDefault = __webpack_require__(5);
    exports.__esModule = true;
    exports.default = scrollTop;
    var _isWindow = _interopRequireDefault(__webpack_require__(130));
    function scrollTop(node, val) {
      var win = (0, _isWindow.default)(node);
      if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
      if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
    }
    module.exports = exports["default"];

    /***/
  }), ( /* 396 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var _interopRequireDefault = __webpack_require__(5);
    exports.__esModule = true;
    exports.default = _getComputedStyle;
    var _camelizeStyle = _interopRequireDefault(__webpack_require__(202));
    var rposition = /^(top|right|bottom|left)$/;
    var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
    function _getComputedStyle(node) {
      if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
      var doc = node.ownerDocument;
      return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
        //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
        getPropertyValue: function getPropertyValue(prop) {
          var style = node.style;
          prop = (0, _camelizeStyle.default)(prop);
          if (prop == 'float') prop = 'styleFloat';
          var current = node.currentStyle[prop] || null;
          if (current == null && style && style[prop]) current = style[prop];
          if (rnumnonpx.test(current) && !rposition.test(prop)) {
            // Remember the original values
            var left = style.left;
            var runStyle = node.runtimeStyle;
            var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out

            if (rsLeft) runStyle.left = node.currentStyle.left;
            style.left = prop === 'fontSize' ? '1em' : current;
            current = style.pixelLeft + 'px'; // Revert the changed values

            style.left = left;
            if (rsLeft) runStyle.left = rsLeft;
          }
          return current;
        }
      };
    }
    module.exports = exports["default"];

    /***/
  }), ( /* 397 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    exports.default = removeStyle;
    function removeStyle(node, key) {
      return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
    }
    module.exports = exports["default"];

    /***/
  }), ( /* 398 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    exports.default = isTransform;
    var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
    function isTransform(property) {
      return !!(property && supportedTransforms.test(property));
    }
    module.exports = exports["default"];

    /***/
  }), ( /* 399 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    exports.default = camelize;
    var rHyphen = /-(.)/g;
    function camelize(string) {
      return string.replace(rHyphen, function (_, chr) {
        return chr.toUpperCase();
      });
    }
    module.exports = exports["default"];

    /***/
  }), ( /* 400 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    exports.default = hyphenate;
    var rUpper = /([A-Z])/g;
    function hyphenate(string) {
      return string.replace(rUpper, '-$1').toLowerCase();
    }
    module.exports = exports["default"];

    /***/
  }), ( /* 401 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var _interopRequireDefault = __webpack_require__(5);
    exports.__esModule = true;
    exports.default = hyphenateStyleName;
    var _hyphenate = _interopRequireDefault(__webpack_require__(400));

    /**
     * Copyright 2013-2014, Facebook, Inc.
     * All rights reserved.
     * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
     */
    var msPattern = /^ms-/;
    function hyphenateStyleName(string) {
      return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
    }
    module.exports = exports["default"];

    /***/
  }), ( /* 402 */
  /***/function (module, exports) {
    module.exports = {
      "Aacute": "Á",
      "aacute": "á",
      "Abreve": "Ă",
      "abreve": "ă",
      "ac": "∾",
      "acd": "∿",
      "acE": "∾̳",
      "Acirc": "Â",
      "acirc": "â",
      "acute": "´",
      "Acy": "А",
      "acy": "а",
      "AElig": "Æ",
      "aelig": "æ",
      "af": "⁡",
      "Afr": "𝔄",
      "afr": "𝔞",
      "Agrave": "À",
      "agrave": "à",
      "alefsym": "ℵ",
      "aleph": "ℵ",
      "Alpha": "Α",
      "alpha": "α",
      "Amacr": "Ā",
      "amacr": "ā",
      "amalg": "⨿",
      "amp": "&",
      "AMP": "&",
      "andand": "⩕",
      "And": "⩓",
      "and": "∧",
      "andd": "⩜",
      "andslope": "⩘",
      "andv": "⩚",
      "ang": "∠",
      "ange": "⦤",
      "angle": "∠",
      "angmsdaa": "⦨",
      "angmsdab": "⦩",
      "angmsdac": "⦪",
      "angmsdad": "⦫",
      "angmsdae": "⦬",
      "angmsdaf": "⦭",
      "angmsdag": "⦮",
      "angmsdah": "⦯",
      "angmsd": "∡",
      "angrt": "∟",
      "angrtvb": "⊾",
      "angrtvbd": "⦝",
      "angsph": "∢",
      "angst": "Å",
      "angzarr": "⍼",
      "Aogon": "Ą",
      "aogon": "ą",
      "Aopf": "𝔸",
      "aopf": "𝕒",
      "apacir": "⩯",
      "ap": "≈",
      "apE": "⩰",
      "ape": "≊",
      "apid": "≋",
      "apos": "'",
      "ApplyFunction": "⁡",
      "approx": "≈",
      "approxeq": "≊",
      "Aring": "Å",
      "aring": "å",
      "Ascr": "𝒜",
      "ascr": "𝒶",
      "Assign": "≔",
      "ast": "*",
      "asymp": "≈",
      "asympeq": "≍",
      "Atilde": "Ã",
      "atilde": "ã",
      "Auml": "Ä",
      "auml": "ä",
      "awconint": "∳",
      "awint": "⨑",
      "backcong": "≌",
      "backepsilon": "϶",
      "backprime": "‵",
      "backsim": "∽",
      "backsimeq": "⋍",
      "Backslash": "∖",
      "Barv": "⫧",
      "barvee": "⊽",
      "barwed": "⌅",
      "Barwed": "⌆",
      "barwedge": "⌅",
      "bbrk": "⎵",
      "bbrktbrk": "⎶",
      "bcong": "≌",
      "Bcy": "Б",
      "bcy": "б",
      "bdquo": "„",
      "becaus": "∵",
      "because": "∵",
      "Because": "∵",
      "bemptyv": "⦰",
      "bepsi": "϶",
      "bernou": "ℬ",
      "Bernoullis": "ℬ",
      "Beta": "Β",
      "beta": "β",
      "beth": "ℶ",
      "between": "≬",
      "Bfr": "𝔅",
      "bfr": "𝔟",
      "bigcap": "⋂",
      "bigcirc": "◯",
      "bigcup": "⋃",
      "bigodot": "⨀",
      "bigoplus": "⨁",
      "bigotimes": "⨂",
      "bigsqcup": "⨆",
      "bigstar": "★",
      "bigtriangledown": "▽",
      "bigtriangleup": "△",
      "biguplus": "⨄",
      "bigvee": "⋁",
      "bigwedge": "⋀",
      "bkarow": "⤍",
      "blacklozenge": "⧫",
      "blacksquare": "▪",
      "blacktriangle": "▴",
      "blacktriangledown": "▾",
      "blacktriangleleft": "◂",
      "blacktriangleright": "▸",
      "blank": "␣",
      "blk12": "▒",
      "blk14": "░",
      "blk34": "▓",
      "block": "█",
      "bne": "=⃥",
      "bnequiv": "≡⃥",
      "bNot": "⫭",
      "bnot": "⌐",
      "Bopf": "𝔹",
      "bopf": "𝕓",
      "bot": "⊥",
      "bottom": "⊥",
      "bowtie": "⋈",
      "boxbox": "⧉",
      "boxdl": "┐",
      "boxdL": "╕",
      "boxDl": "╖",
      "boxDL": "╗",
      "boxdr": "┌",
      "boxdR": "╒",
      "boxDr": "╓",
      "boxDR": "╔",
      "boxh": "─",
      "boxH": "═",
      "boxhd": "┬",
      "boxHd": "╤",
      "boxhD": "╥",
      "boxHD": "╦",
      "boxhu": "┴",
      "boxHu": "╧",
      "boxhU": "╨",
      "boxHU": "╩",
      "boxminus": "⊟",
      "boxplus": "⊞",
      "boxtimes": "⊠",
      "boxul": "┘",
      "boxuL": "╛",
      "boxUl": "╜",
      "boxUL": "╝",
      "boxur": "└",
      "boxuR": "╘",
      "boxUr": "╙",
      "boxUR": "╚",
      "boxv": "│",
      "boxV": "║",
      "boxvh": "┼",
      "boxvH": "╪",
      "boxVh": "╫",
      "boxVH": "╬",
      "boxvl": "┤",
      "boxvL": "╡",
      "boxVl": "╢",
      "boxVL": "╣",
      "boxvr": "├",
      "boxvR": "╞",
      "boxVr": "╟",
      "boxVR": "╠",
      "bprime": "‵",
      "breve": "˘",
      "Breve": "˘",
      "brvbar": "¦",
      "bscr": "𝒷",
      "Bscr": "ℬ",
      "bsemi": "⁏",
      "bsim": "∽",
      "bsime": "⋍",
      "bsolb": "⧅",
      "bsol": "\\",
      "bsolhsub": "⟈",
      "bull": "•",
      "bullet": "•",
      "bump": "≎",
      "bumpE": "⪮",
      "bumpe": "≏",
      "Bumpeq": "≎",
      "bumpeq": "≏",
      "Cacute": "Ć",
      "cacute": "ć",
      "capand": "⩄",
      "capbrcup": "⩉",
      "capcap": "⩋",
      "cap": "∩",
      "Cap": "⋒",
      "capcup": "⩇",
      "capdot": "⩀",
      "CapitalDifferentialD": "ⅅ",
      "caps": "∩︀",
      "caret": "⁁",
      "caron": "ˇ",
      "Cayleys": "ℭ",
      "ccaps": "⩍",
      "Ccaron": "Č",
      "ccaron": "č",
      "Ccedil": "Ç",
      "ccedil": "ç",
      "Ccirc": "Ĉ",
      "ccirc": "ĉ",
      "Cconint": "∰",
      "ccups": "⩌",
      "ccupssm": "⩐",
      "Cdot": "Ċ",
      "cdot": "ċ",
      "cedil": "¸",
      "Cedilla": "¸",
      "cemptyv": "⦲",
      "cent": "¢",
      "centerdot": "·",
      "CenterDot": "·",
      "cfr": "𝔠",
      "Cfr": "ℭ",
      "CHcy": "Ч",
      "chcy": "ч",
      "check": "✓",
      "checkmark": "✓",
      "Chi": "Χ",
      "chi": "χ",
      "circ": "ˆ",
      "circeq": "≗",
      "circlearrowleft": "↺",
      "circlearrowright": "↻",
      "circledast": "⊛",
      "circledcirc": "⊚",
      "circleddash": "⊝",
      "CircleDot": "⊙",
      "circledR": "®",
      "circledS": "Ⓢ",
      "CircleMinus": "⊖",
      "CirclePlus": "⊕",
      "CircleTimes": "⊗",
      "cir": "○",
      "cirE": "⧃",
      "cire": "≗",
      "cirfnint": "⨐",
      "cirmid": "⫯",
      "cirscir": "⧂",
      "ClockwiseContourIntegral": "∲",
      "CloseCurlyDoubleQuote": "”",
      "CloseCurlyQuote": "’",
      "clubs": "♣",
      "clubsuit": "♣",
      "colon": ":",
      "Colon": "∷",
      "Colone": "⩴",
      "colone": "≔",
      "coloneq": "≔",
      "comma": ",",
      "commat": "@",
      "comp": "∁",
      "compfn": "∘",
      "complement": "∁",
      "complexes": "ℂ",
      "cong": "≅",
      "congdot": "⩭",
      "Congruent": "≡",
      "conint": "∮",
      "Conint": "∯",
      "ContourIntegral": "∮",
      "copf": "𝕔",
      "Copf": "ℂ",
      "coprod": "∐",
      "Coproduct": "∐",
      "copy": "©",
      "COPY": "©",
      "copysr": "℗",
      "CounterClockwiseContourIntegral": "∳",
      "crarr": "↵",
      "cross": "✗",
      "Cross": "⨯",
      "Cscr": "𝒞",
      "cscr": "𝒸",
      "csub": "⫏",
      "csube": "⫑",
      "csup": "⫐",
      "csupe": "⫒",
      "ctdot": "⋯",
      "cudarrl": "⤸",
      "cudarrr": "⤵",
      "cuepr": "⋞",
      "cuesc": "⋟",
      "cularr": "↶",
      "cularrp": "⤽",
      "cupbrcap": "⩈",
      "cupcap": "⩆",
      "CupCap": "≍",
      "cup": "∪",
      "Cup": "⋓",
      "cupcup": "⩊",
      "cupdot": "⊍",
      "cupor": "⩅",
      "cups": "∪︀",
      "curarr": "↷",
      "curarrm": "⤼",
      "curlyeqprec": "⋞",
      "curlyeqsucc": "⋟",
      "curlyvee": "⋎",
      "curlywedge": "⋏",
      "curren": "¤",
      "curvearrowleft": "↶",
      "curvearrowright": "↷",
      "cuvee": "⋎",
      "cuwed": "⋏",
      "cwconint": "∲",
      "cwint": "∱",
      "cylcty": "⌭",
      "dagger": "†",
      "Dagger": "‡",
      "daleth": "ℸ",
      "darr": "↓",
      "Darr": "↡",
      "dArr": "⇓",
      "dash": "‐",
      "Dashv": "⫤",
      "dashv": "⊣",
      "dbkarow": "⤏",
      "dblac": "˝",
      "Dcaron": "Ď",
      "dcaron": "ď",
      "Dcy": "Д",
      "dcy": "д",
      "ddagger": "‡",
      "ddarr": "⇊",
      "DD": "ⅅ",
      "dd": "ⅆ",
      "DDotrahd": "⤑",
      "ddotseq": "⩷",
      "deg": "°",
      "Del": "∇",
      "Delta": "Δ",
      "delta": "δ",
      "demptyv": "⦱",
      "dfisht": "⥿",
      "Dfr": "𝔇",
      "dfr": "𝔡",
      "dHar": "⥥",
      "dharl": "⇃",
      "dharr": "⇂",
      "DiacriticalAcute": "´",
      "DiacriticalDot": "˙",
      "DiacriticalDoubleAcute": "˝",
      "DiacriticalGrave": "`",
      "DiacriticalTilde": "˜",
      "diam": "⋄",
      "diamond": "⋄",
      "Diamond": "⋄",
      "diamondsuit": "♦",
      "diams": "♦",
      "die": "¨",
      "DifferentialD": "ⅆ",
      "digamma": "ϝ",
      "disin": "⋲",
      "div": "÷",
      "divide": "÷",
      "divideontimes": "⋇",
      "divonx": "⋇",
      "DJcy": "Ђ",
      "djcy": "ђ",
      "dlcorn": "⌞",
      "dlcrop": "⌍",
      "dollar": "$",
      "Dopf": "𝔻",
      "dopf": "𝕕",
      "Dot": "¨",
      "dot": "˙",
      "DotDot": "⃜",
      "doteq": "≐",
      "doteqdot": "≑",
      "DotEqual": "≐",
      "dotminus": "∸",
      "dotplus": "∔",
      "dotsquare": "⊡",
      "doublebarwedge": "⌆",
      "DoubleContourIntegral": "∯",
      "DoubleDot": "¨",
      "DoubleDownArrow": "⇓",
      "DoubleLeftArrow": "⇐",
      "DoubleLeftRightArrow": "⇔",
      "DoubleLeftTee": "⫤",
      "DoubleLongLeftArrow": "⟸",
      "DoubleLongLeftRightArrow": "⟺",
      "DoubleLongRightArrow": "⟹",
      "DoubleRightArrow": "⇒",
      "DoubleRightTee": "⊨",
      "DoubleUpArrow": "⇑",
      "DoubleUpDownArrow": "⇕",
      "DoubleVerticalBar": "∥",
      "DownArrowBar": "⤓",
      "downarrow": "↓",
      "DownArrow": "↓",
      "Downarrow": "⇓",
      "DownArrowUpArrow": "⇵",
      "DownBreve": "̑",
      "downdownarrows": "⇊",
      "downharpoonleft": "⇃",
      "downharpoonright": "⇂",
      "DownLeftRightVector": "⥐",
      "DownLeftTeeVector": "⥞",
      "DownLeftVectorBar": "⥖",
      "DownLeftVector": "↽",
      "DownRightTeeVector": "⥟",
      "DownRightVectorBar": "⥗",
      "DownRightVector": "⇁",
      "DownTeeArrow": "↧",
      "DownTee": "⊤",
      "drbkarow": "⤐",
      "drcorn": "⌟",
      "drcrop": "⌌",
      "Dscr": "𝒟",
      "dscr": "𝒹",
      "DScy": "Ѕ",
      "dscy": "ѕ",
      "dsol": "⧶",
      "Dstrok": "Đ",
      "dstrok": "đ",
      "dtdot": "⋱",
      "dtri": "▿",
      "dtrif": "▾",
      "duarr": "⇵",
      "duhar": "⥯",
      "dwangle": "⦦",
      "DZcy": "Џ",
      "dzcy": "џ",
      "dzigrarr": "⟿",
      "Eacute": "É",
      "eacute": "é",
      "easter": "⩮",
      "Ecaron": "Ě",
      "ecaron": "ě",
      "Ecirc": "Ê",
      "ecirc": "ê",
      "ecir": "≖",
      "ecolon": "≕",
      "Ecy": "Э",
      "ecy": "э",
      "eDDot": "⩷",
      "Edot": "Ė",
      "edot": "ė",
      "eDot": "≑",
      "ee": "ⅇ",
      "efDot": "≒",
      "Efr": "𝔈",
      "efr": "𝔢",
      "eg": "⪚",
      "Egrave": "È",
      "egrave": "è",
      "egs": "⪖",
      "egsdot": "⪘",
      "el": "⪙",
      "Element": "∈",
      "elinters": "⏧",
      "ell": "ℓ",
      "els": "⪕",
      "elsdot": "⪗",
      "Emacr": "Ē",
      "emacr": "ē",
      "empty": "∅",
      "emptyset": "∅",
      "EmptySmallSquare": "◻",
      "emptyv": "∅",
      "EmptyVerySmallSquare": "▫",
      "emsp13": " ",
      "emsp14": " ",
      "emsp": " ",
      "ENG": "Ŋ",
      "eng": "ŋ",
      "ensp": " ",
      "Eogon": "Ę",
      "eogon": "ę",
      "Eopf": "𝔼",
      "eopf": "𝕖",
      "epar": "⋕",
      "eparsl": "⧣",
      "eplus": "⩱",
      "epsi": "ε",
      "Epsilon": "Ε",
      "epsilon": "ε",
      "epsiv": "ϵ",
      "eqcirc": "≖",
      "eqcolon": "≕",
      "eqsim": "≂",
      "eqslantgtr": "⪖",
      "eqslantless": "⪕",
      "Equal": "⩵",
      "equals": "=",
      "EqualTilde": "≂",
      "equest": "≟",
      "Equilibrium": "⇌",
      "equiv": "≡",
      "equivDD": "⩸",
      "eqvparsl": "⧥",
      "erarr": "⥱",
      "erDot": "≓",
      "escr": "ℯ",
      "Escr": "ℰ",
      "esdot": "≐",
      "Esim": "⩳",
      "esim": "≂",
      "Eta": "Η",
      "eta": "η",
      "ETH": "Ð",
      "eth": "ð",
      "Euml": "Ë",
      "euml": "ë",
      "euro": "€",
      "excl": "!",
      "exist": "∃",
      "Exists": "∃",
      "expectation": "ℰ",
      "exponentiale": "ⅇ",
      "ExponentialE": "ⅇ",
      "fallingdotseq": "≒",
      "Fcy": "Ф",
      "fcy": "ф",
      "female": "♀",
      "ffilig": "ﬃ",
      "fflig": "ﬀ",
      "ffllig": "ﬄ",
      "Ffr": "𝔉",
      "ffr": "𝔣",
      "filig": "ﬁ",
      "FilledSmallSquare": "◼",
      "FilledVerySmallSquare": "▪",
      "fjlig": "fj",
      "flat": "♭",
      "fllig": "ﬂ",
      "fltns": "▱",
      "fnof": "ƒ",
      "Fopf": "𝔽",
      "fopf": "𝕗",
      "forall": "∀",
      "ForAll": "∀",
      "fork": "⋔",
      "forkv": "⫙",
      "Fouriertrf": "ℱ",
      "fpartint": "⨍",
      "frac12": "½",
      "frac13": "⅓",
      "frac14": "¼",
      "frac15": "⅕",
      "frac16": "⅙",
      "frac18": "⅛",
      "frac23": "⅔",
      "frac25": "⅖",
      "frac34": "¾",
      "frac35": "⅗",
      "frac38": "⅜",
      "frac45": "⅘",
      "frac56": "⅚",
      "frac58": "⅝",
      "frac78": "⅞",
      "frasl": "⁄",
      "frown": "⌢",
      "fscr": "𝒻",
      "Fscr": "ℱ",
      "gacute": "ǵ",
      "Gamma": "Γ",
      "gamma": "γ",
      "Gammad": "Ϝ",
      "gammad": "ϝ",
      "gap": "⪆",
      "Gbreve": "Ğ",
      "gbreve": "ğ",
      "Gcedil": "Ģ",
      "Gcirc": "Ĝ",
      "gcirc": "ĝ",
      "Gcy": "Г",
      "gcy": "г",
      "Gdot": "Ġ",
      "gdot": "ġ",
      "ge": "≥",
      "gE": "≧",
      "gEl": "⪌",
      "gel": "⋛",
      "geq": "≥",
      "geqq": "≧",
      "geqslant": "⩾",
      "gescc": "⪩",
      "ges": "⩾",
      "gesdot": "⪀",
      "gesdoto": "⪂",
      "gesdotol": "⪄",
      "gesl": "⋛︀",
      "gesles": "⪔",
      "Gfr": "𝔊",
      "gfr": "𝔤",
      "gg": "≫",
      "Gg": "⋙",
      "ggg": "⋙",
      "gimel": "ℷ",
      "GJcy": "Ѓ",
      "gjcy": "ѓ",
      "gla": "⪥",
      "gl": "≷",
      "glE": "⪒",
      "glj": "⪤",
      "gnap": "⪊",
      "gnapprox": "⪊",
      "gne": "⪈",
      "gnE": "≩",
      "gneq": "⪈",
      "gneqq": "≩",
      "gnsim": "⋧",
      "Gopf": "𝔾",
      "gopf": "𝕘",
      "grave": "`",
      "GreaterEqual": "≥",
      "GreaterEqualLess": "⋛",
      "GreaterFullEqual": "≧",
      "GreaterGreater": "⪢",
      "GreaterLess": "≷",
      "GreaterSlantEqual": "⩾",
      "GreaterTilde": "≳",
      "Gscr": "𝒢",
      "gscr": "ℊ",
      "gsim": "≳",
      "gsime": "⪎",
      "gsiml": "⪐",
      "gtcc": "⪧",
      "gtcir": "⩺",
      "gt": ">",
      "GT": ">",
      "Gt": "≫",
      "gtdot": "⋗",
      "gtlPar": "⦕",
      "gtquest": "⩼",
      "gtrapprox": "⪆",
      "gtrarr": "⥸",
      "gtrdot": "⋗",
      "gtreqless": "⋛",
      "gtreqqless": "⪌",
      "gtrless": "≷",
      "gtrsim": "≳",
      "gvertneqq": "≩︀",
      "gvnE": "≩︀",
      "Hacek": "ˇ",
      "hairsp": " ",
      "half": "½",
      "hamilt": "ℋ",
      "HARDcy": "Ъ",
      "hardcy": "ъ",
      "harrcir": "⥈",
      "harr": "↔",
      "hArr": "⇔",
      "harrw": "↭",
      "Hat": "^",
      "hbar": "ℏ",
      "Hcirc": "Ĥ",
      "hcirc": "ĥ",
      "hearts": "♥",
      "heartsuit": "♥",
      "hellip": "…",
      "hercon": "⊹",
      "hfr": "𝔥",
      "Hfr": "ℌ",
      "HilbertSpace": "ℋ",
      "hksearow": "⤥",
      "hkswarow": "⤦",
      "hoarr": "⇿",
      "homtht": "∻",
      "hookleftarrow": "↩",
      "hookrightarrow": "↪",
      "hopf": "𝕙",
      "Hopf": "ℍ",
      "horbar": "―",
      "HorizontalLine": "─",
      "hscr": "𝒽",
      "Hscr": "ℋ",
      "hslash": "ℏ",
      "Hstrok": "Ħ",
      "hstrok": "ħ",
      "HumpDownHump": "≎",
      "HumpEqual": "≏",
      "hybull": "⁃",
      "hyphen": "‐",
      "Iacute": "Í",
      "iacute": "í",
      "ic": "⁣",
      "Icirc": "Î",
      "icirc": "î",
      "Icy": "И",
      "icy": "и",
      "Idot": "İ",
      "IEcy": "Е",
      "iecy": "е",
      "iexcl": "¡",
      "iff": "⇔",
      "ifr": "𝔦",
      "Ifr": "ℑ",
      "Igrave": "Ì",
      "igrave": "ì",
      "ii": "ⅈ",
      "iiiint": "⨌",
      "iiint": "∭",
      "iinfin": "⧜",
      "iiota": "℩",
      "IJlig": "Ĳ",
      "ijlig": "ĳ",
      "Imacr": "Ī",
      "imacr": "ī",
      "image": "ℑ",
      "ImaginaryI": "ⅈ",
      "imagline": "ℐ",
      "imagpart": "ℑ",
      "imath": "ı",
      "Im": "ℑ",
      "imof": "⊷",
      "imped": "Ƶ",
      "Implies": "⇒",
      "incare": "℅",
      "in": "∈",
      "infin": "∞",
      "infintie": "⧝",
      "inodot": "ı",
      "intcal": "⊺",
      "int": "∫",
      "Int": "∬",
      "integers": "ℤ",
      "Integral": "∫",
      "intercal": "⊺",
      "Intersection": "⋂",
      "intlarhk": "⨗",
      "intprod": "⨼",
      "InvisibleComma": "⁣",
      "InvisibleTimes": "⁢",
      "IOcy": "Ё",
      "iocy": "ё",
      "Iogon": "Į",
      "iogon": "į",
      "Iopf": "𝕀",
      "iopf": "𝕚",
      "Iota": "Ι",
      "iota": "ι",
      "iprod": "⨼",
      "iquest": "¿",
      "iscr": "𝒾",
      "Iscr": "ℐ",
      "isin": "∈",
      "isindot": "⋵",
      "isinE": "⋹",
      "isins": "⋴",
      "isinsv": "⋳",
      "isinv": "∈",
      "it": "⁢",
      "Itilde": "Ĩ",
      "itilde": "ĩ",
      "Iukcy": "І",
      "iukcy": "і",
      "Iuml": "Ï",
      "iuml": "ï",
      "Jcirc": "Ĵ",
      "jcirc": "ĵ",
      "Jcy": "Й",
      "jcy": "й",
      "Jfr": "𝔍",
      "jfr": "𝔧",
      "jmath": "ȷ",
      "Jopf": "𝕁",
      "jopf": "𝕛",
      "Jscr": "𝒥",
      "jscr": "𝒿",
      "Jsercy": "Ј",
      "jsercy": "ј",
      "Jukcy": "Є",
      "jukcy": "є",
      "Kappa": "Κ",
      "kappa": "κ",
      "kappav": "ϰ",
      "Kcedil": "Ķ",
      "kcedil": "ķ",
      "Kcy": "К",
      "kcy": "к",
      "Kfr": "𝔎",
      "kfr": "𝔨",
      "kgreen": "ĸ",
      "KHcy": "Х",
      "khcy": "х",
      "KJcy": "Ќ",
      "kjcy": "ќ",
      "Kopf": "𝕂",
      "kopf": "𝕜",
      "Kscr": "𝒦",
      "kscr": "𝓀",
      "lAarr": "⇚",
      "Lacute": "Ĺ",
      "lacute": "ĺ",
      "laemptyv": "⦴",
      "lagran": "ℒ",
      "Lambda": "Λ",
      "lambda": "λ",
      "lang": "⟨",
      "Lang": "⟪",
      "langd": "⦑",
      "langle": "⟨",
      "lap": "⪅",
      "Laplacetrf": "ℒ",
      "laquo": "«",
      "larrb": "⇤",
      "larrbfs": "⤟",
      "larr": "←",
      "Larr": "↞",
      "lArr": "⇐",
      "larrfs": "⤝",
      "larrhk": "↩",
      "larrlp": "↫",
      "larrpl": "⤹",
      "larrsim": "⥳",
      "larrtl": "↢",
      "latail": "⤙",
      "lAtail": "⤛",
      "lat": "⪫",
      "late": "⪭",
      "lates": "⪭︀",
      "lbarr": "⤌",
      "lBarr": "⤎",
      "lbbrk": "❲",
      "lbrace": "{",
      "lbrack": "[",
      "lbrke": "⦋",
      "lbrksld": "⦏",
      "lbrkslu": "⦍",
      "Lcaron": "Ľ",
      "lcaron": "ľ",
      "Lcedil": "Ļ",
      "lcedil": "ļ",
      "lceil": "⌈",
      "lcub": "{",
      "Lcy": "Л",
      "lcy": "л",
      "ldca": "⤶",
      "ldquo": "“",
      "ldquor": "„",
      "ldrdhar": "⥧",
      "ldrushar": "⥋",
      "ldsh": "↲",
      "le": "≤",
      "lE": "≦",
      "LeftAngleBracket": "⟨",
      "LeftArrowBar": "⇤",
      "leftarrow": "←",
      "LeftArrow": "←",
      "Leftarrow": "⇐",
      "LeftArrowRightArrow": "⇆",
      "leftarrowtail": "↢",
      "LeftCeiling": "⌈",
      "LeftDoubleBracket": "⟦",
      "LeftDownTeeVector": "⥡",
      "LeftDownVectorBar": "⥙",
      "LeftDownVector": "⇃",
      "LeftFloor": "⌊",
      "leftharpoondown": "↽",
      "leftharpoonup": "↼",
      "leftleftarrows": "⇇",
      "leftrightarrow": "↔",
      "LeftRightArrow": "↔",
      "Leftrightarrow": "⇔",
      "leftrightarrows": "⇆",
      "leftrightharpoons": "⇋",
      "leftrightsquigarrow": "↭",
      "LeftRightVector": "⥎",
      "LeftTeeArrow": "↤",
      "LeftTee": "⊣",
      "LeftTeeVector": "⥚",
      "leftthreetimes": "⋋",
      "LeftTriangleBar": "⧏",
      "LeftTriangle": "⊲",
      "LeftTriangleEqual": "⊴",
      "LeftUpDownVector": "⥑",
      "LeftUpTeeVector": "⥠",
      "LeftUpVectorBar": "⥘",
      "LeftUpVector": "↿",
      "LeftVectorBar": "⥒",
      "LeftVector": "↼",
      "lEg": "⪋",
      "leg": "⋚",
      "leq": "≤",
      "leqq": "≦",
      "leqslant": "⩽",
      "lescc": "⪨",
      "les": "⩽",
      "lesdot": "⩿",
      "lesdoto": "⪁",
      "lesdotor": "⪃",
      "lesg": "⋚︀",
      "lesges": "⪓",
      "lessapprox": "⪅",
      "lessdot": "⋖",
      "lesseqgtr": "⋚",
      "lesseqqgtr": "⪋",
      "LessEqualGreater": "⋚",
      "LessFullEqual": "≦",
      "LessGreater": "≶",
      "lessgtr": "≶",
      "LessLess": "⪡",
      "lesssim": "≲",
      "LessSlantEqual": "⩽",
      "LessTilde": "≲",
      "lfisht": "⥼",
      "lfloor": "⌊",
      "Lfr": "𝔏",
      "lfr": "𝔩",
      "lg": "≶",
      "lgE": "⪑",
      "lHar": "⥢",
      "lhard": "↽",
      "lharu": "↼",
      "lharul": "⥪",
      "lhblk": "▄",
      "LJcy": "Љ",
      "ljcy": "љ",
      "llarr": "⇇",
      "ll": "≪",
      "Ll": "⋘",
      "llcorner": "⌞",
      "Lleftarrow": "⇚",
      "llhard": "⥫",
      "lltri": "◺",
      "Lmidot": "Ŀ",
      "lmidot": "ŀ",
      "lmoustache": "⎰",
      "lmoust": "⎰",
      "lnap": "⪉",
      "lnapprox": "⪉",
      "lne": "⪇",
      "lnE": "≨",
      "lneq": "⪇",
      "lneqq": "≨",
      "lnsim": "⋦",
      "loang": "⟬",
      "loarr": "⇽",
      "lobrk": "⟦",
      "longleftarrow": "⟵",
      "LongLeftArrow": "⟵",
      "Longleftarrow": "⟸",
      "longleftrightarrow": "⟷",
      "LongLeftRightArrow": "⟷",
      "Longleftrightarrow": "⟺",
      "longmapsto": "⟼",
      "longrightarrow": "⟶",
      "LongRightArrow": "⟶",
      "Longrightarrow": "⟹",
      "looparrowleft": "↫",
      "looparrowright": "↬",
      "lopar": "⦅",
      "Lopf": "𝕃",
      "lopf": "𝕝",
      "loplus": "⨭",
      "lotimes": "⨴",
      "lowast": "∗",
      "lowbar": "_",
      "LowerLeftArrow": "↙",
      "LowerRightArrow": "↘",
      "loz": "◊",
      "lozenge": "◊",
      "lozf": "⧫",
      "lpar": "(",
      "lparlt": "⦓",
      "lrarr": "⇆",
      "lrcorner": "⌟",
      "lrhar": "⇋",
      "lrhard": "⥭",
      "lrm": "‎",
      "lrtri": "⊿",
      "lsaquo": "‹",
      "lscr": "𝓁",
      "Lscr": "ℒ",
      "lsh": "↰",
      "Lsh": "↰",
      "lsim": "≲",
      "lsime": "⪍",
      "lsimg": "⪏",
      "lsqb": "[",
      "lsquo": "‘",
      "lsquor": "‚",
      "Lstrok": "Ł",
      "lstrok": "ł",
      "ltcc": "⪦",
      "ltcir": "⩹",
      "lt": "<",
      "LT": "<",
      "Lt": "≪",
      "ltdot": "⋖",
      "lthree": "⋋",
      "ltimes": "⋉",
      "ltlarr": "⥶",
      "ltquest": "⩻",
      "ltri": "◃",
      "ltrie": "⊴",
      "ltrif": "◂",
      "ltrPar": "⦖",
      "lurdshar": "⥊",
      "luruhar": "⥦",
      "lvertneqq": "≨︀",
      "lvnE": "≨︀",
      "macr": "¯",
      "male": "♂",
      "malt": "✠",
      "maltese": "✠",
      "Map": "⤅",
      "map": "↦",
      "mapsto": "↦",
      "mapstodown": "↧",
      "mapstoleft": "↤",
      "mapstoup": "↥",
      "marker": "▮",
      "mcomma": "⨩",
      "Mcy": "М",
      "mcy": "м",
      "mdash": "—",
      "mDDot": "∺",
      "measuredangle": "∡",
      "MediumSpace": " ",
      "Mellintrf": "ℳ",
      "Mfr": "𝔐",
      "mfr": "𝔪",
      "mho": "℧",
      "micro": "µ",
      "midast": "*",
      "midcir": "⫰",
      "mid": "∣",
      "middot": "·",
      "minusb": "⊟",
      "minus": "−",
      "minusd": "∸",
      "minusdu": "⨪",
      "MinusPlus": "∓",
      "mlcp": "⫛",
      "mldr": "…",
      "mnplus": "∓",
      "models": "⊧",
      "Mopf": "𝕄",
      "mopf": "𝕞",
      "mp": "∓",
      "mscr": "𝓂",
      "Mscr": "ℳ",
      "mstpos": "∾",
      "Mu": "Μ",
      "mu": "μ",
      "multimap": "⊸",
      "mumap": "⊸",
      "nabla": "∇",
      "Nacute": "Ń",
      "nacute": "ń",
      "nang": "∠⃒",
      "nap": "≉",
      "napE": "⩰̸",
      "napid": "≋̸",
      "napos": "ŉ",
      "napprox": "≉",
      "natural": "♮",
      "naturals": "ℕ",
      "natur": "♮",
      "nbsp": " ",
      "nbump": "≎̸",
      "nbumpe": "≏̸",
      "ncap": "⩃",
      "Ncaron": "Ň",
      "ncaron": "ň",
      "Ncedil": "Ņ",
      "ncedil": "ņ",
      "ncong": "≇",
      "ncongdot": "⩭̸",
      "ncup": "⩂",
      "Ncy": "Н",
      "ncy": "н",
      "ndash": "–",
      "nearhk": "⤤",
      "nearr": "↗",
      "neArr": "⇗",
      "nearrow": "↗",
      "ne": "≠",
      "nedot": "≐̸",
      "NegativeMediumSpace": "​",
      "NegativeThickSpace": "​",
      "NegativeThinSpace": "​",
      "NegativeVeryThinSpace": "​",
      "nequiv": "≢",
      "nesear": "⤨",
      "nesim": "≂̸",
      "NestedGreaterGreater": "≫",
      "NestedLessLess": "≪",
      "NewLine": "\n",
      "nexist": "∄",
      "nexists": "∄",
      "Nfr": "𝔑",
      "nfr": "𝔫",
      "ngE": "≧̸",
      "nge": "≱",
      "ngeq": "≱",
      "ngeqq": "≧̸",
      "ngeqslant": "⩾̸",
      "nges": "⩾̸",
      "nGg": "⋙̸",
      "ngsim": "≵",
      "nGt": "≫⃒",
      "ngt": "≯",
      "ngtr": "≯",
      "nGtv": "≫̸",
      "nharr": "↮",
      "nhArr": "⇎",
      "nhpar": "⫲",
      "ni": "∋",
      "nis": "⋼",
      "nisd": "⋺",
      "niv": "∋",
      "NJcy": "Њ",
      "njcy": "њ",
      "nlarr": "↚",
      "nlArr": "⇍",
      "nldr": "‥",
      "nlE": "≦̸",
      "nle": "≰",
      "nleftarrow": "↚",
      "nLeftarrow": "⇍",
      "nleftrightarrow": "↮",
      "nLeftrightarrow": "⇎",
      "nleq": "≰",
      "nleqq": "≦̸",
      "nleqslant": "⩽̸",
      "nles": "⩽̸",
      "nless": "≮",
      "nLl": "⋘̸",
      "nlsim": "≴",
      "nLt": "≪⃒",
      "nlt": "≮",
      "nltri": "⋪",
      "nltrie": "⋬",
      "nLtv": "≪̸",
      "nmid": "∤",
      "NoBreak": "⁠",
      "NonBreakingSpace": " ",
      "nopf": "𝕟",
      "Nopf": "ℕ",
      "Not": "⫬",
      "not": "¬",
      "NotCongruent": "≢",
      "NotCupCap": "≭",
      "NotDoubleVerticalBar": "∦",
      "NotElement": "∉",
      "NotEqual": "≠",
      "NotEqualTilde": "≂̸",
      "NotExists": "∄",
      "NotGreater": "≯",
      "NotGreaterEqual": "≱",
      "NotGreaterFullEqual": "≧̸",
      "NotGreaterGreater": "≫̸",
      "NotGreaterLess": "≹",
      "NotGreaterSlantEqual": "⩾̸",
      "NotGreaterTilde": "≵",
      "NotHumpDownHump": "≎̸",
      "NotHumpEqual": "≏̸",
      "notin": "∉",
      "notindot": "⋵̸",
      "notinE": "⋹̸",
      "notinva": "∉",
      "notinvb": "⋷",
      "notinvc": "⋶",
      "NotLeftTriangleBar": "⧏̸",
      "NotLeftTriangle": "⋪",
      "NotLeftTriangleEqual": "⋬",
      "NotLess": "≮",
      "NotLessEqual": "≰",
      "NotLessGreater": "≸",
      "NotLessLess": "≪̸",
      "NotLessSlantEqual": "⩽̸",
      "NotLessTilde": "≴",
      "NotNestedGreaterGreater": "⪢̸",
      "NotNestedLessLess": "⪡̸",
      "notni": "∌",
      "notniva": "∌",
      "notnivb": "⋾",
      "notnivc": "⋽",
      "NotPrecedes": "⊀",
      "NotPrecedesEqual": "⪯̸",
      "NotPrecedesSlantEqual": "⋠",
      "NotReverseElement": "∌",
      "NotRightTriangleBar": "⧐̸",
      "NotRightTriangle": "⋫",
      "NotRightTriangleEqual": "⋭",
      "NotSquareSubset": "⊏̸",
      "NotSquareSubsetEqual": "⋢",
      "NotSquareSuperset": "⊐̸",
      "NotSquareSupersetEqual": "⋣",
      "NotSubset": "⊂⃒",
      "NotSubsetEqual": "⊈",
      "NotSucceeds": "⊁",
      "NotSucceedsEqual": "⪰̸",
      "NotSucceedsSlantEqual": "⋡",
      "NotSucceedsTilde": "≿̸",
      "NotSuperset": "⊃⃒",
      "NotSupersetEqual": "⊉",
      "NotTilde": "≁",
      "NotTildeEqual": "≄",
      "NotTildeFullEqual": "≇",
      "NotTildeTilde": "≉",
      "NotVerticalBar": "∤",
      "nparallel": "∦",
      "npar": "∦",
      "nparsl": "⫽⃥",
      "npart": "∂̸",
      "npolint": "⨔",
      "npr": "⊀",
      "nprcue": "⋠",
      "nprec": "⊀",
      "npreceq": "⪯̸",
      "npre": "⪯̸",
      "nrarrc": "⤳̸",
      "nrarr": "↛",
      "nrArr": "⇏",
      "nrarrw": "↝̸",
      "nrightarrow": "↛",
      "nRightarrow": "⇏",
      "nrtri": "⋫",
      "nrtrie": "⋭",
      "nsc": "⊁",
      "nsccue": "⋡",
      "nsce": "⪰̸",
      "Nscr": "𝒩",
      "nscr": "𝓃",
      "nshortmid": "∤",
      "nshortparallel": "∦",
      "nsim": "≁",
      "nsime": "≄",
      "nsimeq": "≄",
      "nsmid": "∤",
      "nspar": "∦",
      "nsqsube": "⋢",
      "nsqsupe": "⋣",
      "nsub": "⊄",
      "nsubE": "⫅̸",
      "nsube": "⊈",
      "nsubset": "⊂⃒",
      "nsubseteq": "⊈",
      "nsubseteqq": "⫅̸",
      "nsucc": "⊁",
      "nsucceq": "⪰̸",
      "nsup": "⊅",
      "nsupE": "⫆̸",
      "nsupe": "⊉",
      "nsupset": "⊃⃒",
      "nsupseteq": "⊉",
      "nsupseteqq": "⫆̸",
      "ntgl": "≹",
      "Ntilde": "Ñ",
      "ntilde": "ñ",
      "ntlg": "≸",
      "ntriangleleft": "⋪",
      "ntrianglelefteq": "⋬",
      "ntriangleright": "⋫",
      "ntrianglerighteq": "⋭",
      "Nu": "Ν",
      "nu": "ν",
      "num": "#",
      "numero": "№",
      "numsp": " ",
      "nvap": "≍⃒",
      "nvdash": "⊬",
      "nvDash": "⊭",
      "nVdash": "⊮",
      "nVDash": "⊯",
      "nvge": "≥⃒",
      "nvgt": ">⃒",
      "nvHarr": "⤄",
      "nvinfin": "⧞",
      "nvlArr": "⤂",
      "nvle": "≤⃒",
      "nvlt": "<⃒",
      "nvltrie": "⊴⃒",
      "nvrArr": "⤃",
      "nvrtrie": "⊵⃒",
      "nvsim": "∼⃒",
      "nwarhk": "⤣",
      "nwarr": "↖",
      "nwArr": "⇖",
      "nwarrow": "↖",
      "nwnear": "⤧",
      "Oacute": "Ó",
      "oacute": "ó",
      "oast": "⊛",
      "Ocirc": "Ô",
      "ocirc": "ô",
      "ocir": "⊚",
      "Ocy": "О",
      "ocy": "о",
      "odash": "⊝",
      "Odblac": "Ő",
      "odblac": "ő",
      "odiv": "⨸",
      "odot": "⊙",
      "odsold": "⦼",
      "OElig": "Œ",
      "oelig": "œ",
      "ofcir": "⦿",
      "Ofr": "𝔒",
      "ofr": "𝔬",
      "ogon": "˛",
      "Ograve": "Ò",
      "ograve": "ò",
      "ogt": "⧁",
      "ohbar": "⦵",
      "ohm": "Ω",
      "oint": "∮",
      "olarr": "↺",
      "olcir": "⦾",
      "olcross": "⦻",
      "oline": "‾",
      "olt": "⧀",
      "Omacr": "Ō",
      "omacr": "ō",
      "Omega": "Ω",
      "omega": "ω",
      "Omicron": "Ο",
      "omicron": "ο",
      "omid": "⦶",
      "ominus": "⊖",
      "Oopf": "𝕆",
      "oopf": "𝕠",
      "opar": "⦷",
      "OpenCurlyDoubleQuote": "“",
      "OpenCurlyQuote": "‘",
      "operp": "⦹",
      "oplus": "⊕",
      "orarr": "↻",
      "Or": "⩔",
      "or": "∨",
      "ord": "⩝",
      "order": "ℴ",
      "orderof": "ℴ",
      "ordf": "ª",
      "ordm": "º",
      "origof": "⊶",
      "oror": "⩖",
      "orslope": "⩗",
      "orv": "⩛",
      "oS": "Ⓢ",
      "Oscr": "𝒪",
      "oscr": "ℴ",
      "Oslash": "Ø",
      "oslash": "ø",
      "osol": "⊘",
      "Otilde": "Õ",
      "otilde": "õ",
      "otimesas": "⨶",
      "Otimes": "⨷",
      "otimes": "⊗",
      "Ouml": "Ö",
      "ouml": "ö",
      "ovbar": "⌽",
      "OverBar": "‾",
      "OverBrace": "⏞",
      "OverBracket": "⎴",
      "OverParenthesis": "⏜",
      "para": "¶",
      "parallel": "∥",
      "par": "∥",
      "parsim": "⫳",
      "parsl": "⫽",
      "part": "∂",
      "PartialD": "∂",
      "Pcy": "П",
      "pcy": "п",
      "percnt": "%",
      "period": ".",
      "permil": "‰",
      "perp": "⊥",
      "pertenk": "‱",
      "Pfr": "𝔓",
      "pfr": "𝔭",
      "Phi": "Φ",
      "phi": "φ",
      "phiv": "ϕ",
      "phmmat": "ℳ",
      "phone": "☎",
      "Pi": "Π",
      "pi": "π",
      "pitchfork": "⋔",
      "piv": "ϖ",
      "planck": "ℏ",
      "planckh": "ℎ",
      "plankv": "ℏ",
      "plusacir": "⨣",
      "plusb": "⊞",
      "pluscir": "⨢",
      "plus": "+",
      "plusdo": "∔",
      "plusdu": "⨥",
      "pluse": "⩲",
      "PlusMinus": "±",
      "plusmn": "±",
      "plussim": "⨦",
      "plustwo": "⨧",
      "pm": "±",
      "Poincareplane": "ℌ",
      "pointint": "⨕",
      "popf": "𝕡",
      "Popf": "ℙ",
      "pound": "£",
      "prap": "⪷",
      "Pr": "⪻",
      "pr": "≺",
      "prcue": "≼",
      "precapprox": "⪷",
      "prec": "≺",
      "preccurlyeq": "≼",
      "Precedes": "≺",
      "PrecedesEqual": "⪯",
      "PrecedesSlantEqual": "≼",
      "PrecedesTilde": "≾",
      "preceq": "⪯",
      "precnapprox": "⪹",
      "precneqq": "⪵",
      "precnsim": "⋨",
      "pre": "⪯",
      "prE": "⪳",
      "precsim": "≾",
      "prime": "′",
      "Prime": "″",
      "primes": "ℙ",
      "prnap": "⪹",
      "prnE": "⪵",
      "prnsim": "⋨",
      "prod": "∏",
      "Product": "∏",
      "profalar": "⌮",
      "profline": "⌒",
      "profsurf": "⌓",
      "prop": "∝",
      "Proportional": "∝",
      "Proportion": "∷",
      "propto": "∝",
      "prsim": "≾",
      "prurel": "⊰",
      "Pscr": "𝒫",
      "pscr": "𝓅",
      "Psi": "Ψ",
      "psi": "ψ",
      "puncsp": " ",
      "Qfr": "𝔔",
      "qfr": "𝔮",
      "qint": "⨌",
      "qopf": "𝕢",
      "Qopf": "ℚ",
      "qprime": "⁗",
      "Qscr": "𝒬",
      "qscr": "𝓆",
      "quaternions": "ℍ",
      "quatint": "⨖",
      "quest": "?",
      "questeq": "≟",
      "quot": "\"",
      "QUOT": "\"",
      "rAarr": "⇛",
      "race": "∽̱",
      "Racute": "Ŕ",
      "racute": "ŕ",
      "radic": "√",
      "raemptyv": "⦳",
      "rang": "⟩",
      "Rang": "⟫",
      "rangd": "⦒",
      "range": "⦥",
      "rangle": "⟩",
      "raquo": "»",
      "rarrap": "⥵",
      "rarrb": "⇥",
      "rarrbfs": "⤠",
      "rarrc": "⤳",
      "rarr": "→",
      "Rarr": "↠",
      "rArr": "⇒",
      "rarrfs": "⤞",
      "rarrhk": "↪",
      "rarrlp": "↬",
      "rarrpl": "⥅",
      "rarrsim": "⥴",
      "Rarrtl": "⤖",
      "rarrtl": "↣",
      "rarrw": "↝",
      "ratail": "⤚",
      "rAtail": "⤜",
      "ratio": "∶",
      "rationals": "ℚ",
      "rbarr": "⤍",
      "rBarr": "⤏",
      "RBarr": "⤐",
      "rbbrk": "❳",
      "rbrace": "}",
      "rbrack": "]",
      "rbrke": "⦌",
      "rbrksld": "⦎",
      "rbrkslu": "⦐",
      "Rcaron": "Ř",
      "rcaron": "ř",
      "Rcedil": "Ŗ",
      "rcedil": "ŗ",
      "rceil": "⌉",
      "rcub": "}",
      "Rcy": "Р",
      "rcy": "р",
      "rdca": "⤷",
      "rdldhar": "⥩",
      "rdquo": "”",
      "rdquor": "”",
      "rdsh": "↳",
      "real": "ℜ",
      "realine": "ℛ",
      "realpart": "ℜ",
      "reals": "ℝ",
      "Re": "ℜ",
      "rect": "▭",
      "reg": "®",
      "REG": "®",
      "ReverseElement": "∋",
      "ReverseEquilibrium": "⇋",
      "ReverseUpEquilibrium": "⥯",
      "rfisht": "⥽",
      "rfloor": "⌋",
      "rfr": "𝔯",
      "Rfr": "ℜ",
      "rHar": "⥤",
      "rhard": "⇁",
      "rharu": "⇀",
      "rharul": "⥬",
      "Rho": "Ρ",
      "rho": "ρ",
      "rhov": "ϱ",
      "RightAngleBracket": "⟩",
      "RightArrowBar": "⇥",
      "rightarrow": "→",
      "RightArrow": "→",
      "Rightarrow": "⇒",
      "RightArrowLeftArrow": "⇄",
      "rightarrowtail": "↣",
      "RightCeiling": "⌉",
      "RightDoubleBracket": "⟧",
      "RightDownTeeVector": "⥝",
      "RightDownVectorBar": "⥕",
      "RightDownVector": "⇂",
      "RightFloor": "⌋",
      "rightharpoondown": "⇁",
      "rightharpoonup": "⇀",
      "rightleftarrows": "⇄",
      "rightleftharpoons": "⇌",
      "rightrightarrows": "⇉",
      "rightsquigarrow": "↝",
      "RightTeeArrow": "↦",
      "RightTee": "⊢",
      "RightTeeVector": "⥛",
      "rightthreetimes": "⋌",
      "RightTriangleBar": "⧐",
      "RightTriangle": "⊳",
      "RightTriangleEqual": "⊵",
      "RightUpDownVector": "⥏",
      "RightUpTeeVector": "⥜",
      "RightUpVectorBar": "⥔",
      "RightUpVector": "↾",
      "RightVectorBar": "⥓",
      "RightVector": "⇀",
      "ring": "˚",
      "risingdotseq": "≓",
      "rlarr": "⇄",
      "rlhar": "⇌",
      "rlm": "‏",
      "rmoustache": "⎱",
      "rmoust": "⎱",
      "rnmid": "⫮",
      "roang": "⟭",
      "roarr": "⇾",
      "robrk": "⟧",
      "ropar": "⦆",
      "ropf": "𝕣",
      "Ropf": "ℝ",
      "roplus": "⨮",
      "rotimes": "⨵",
      "RoundImplies": "⥰",
      "rpar": ")",
      "rpargt": "⦔",
      "rppolint": "⨒",
      "rrarr": "⇉",
      "Rrightarrow": "⇛",
      "rsaquo": "›",
      "rscr": "𝓇",
      "Rscr": "ℛ",
      "rsh": "↱",
      "Rsh": "↱",
      "rsqb": "]",
      "rsquo": "’",
      "rsquor": "’",
      "rthree": "⋌",
      "rtimes": "⋊",
      "rtri": "▹",
      "rtrie": "⊵",
      "rtrif": "▸",
      "rtriltri": "⧎",
      "RuleDelayed": "⧴",
      "ruluhar": "⥨",
      "rx": "℞",
      "Sacute": "Ś",
      "sacute": "ś",
      "sbquo": "‚",
      "scap": "⪸",
      "Scaron": "Š",
      "scaron": "š",
      "Sc": "⪼",
      "sc": "≻",
      "sccue": "≽",
      "sce": "⪰",
      "scE": "⪴",
      "Scedil": "Ş",
      "scedil": "ş",
      "Scirc": "Ŝ",
      "scirc": "ŝ",
      "scnap": "⪺",
      "scnE": "⪶",
      "scnsim": "⋩",
      "scpolint": "⨓",
      "scsim": "≿",
      "Scy": "С",
      "scy": "с",
      "sdotb": "⊡",
      "sdot": "⋅",
      "sdote": "⩦",
      "searhk": "⤥",
      "searr": "↘",
      "seArr": "⇘",
      "searrow": "↘",
      "sect": "§",
      "semi": ";",
      "seswar": "⤩",
      "setminus": "∖",
      "setmn": "∖",
      "sext": "✶",
      "Sfr": "𝔖",
      "sfr": "𝔰",
      "sfrown": "⌢",
      "sharp": "♯",
      "SHCHcy": "Щ",
      "shchcy": "щ",
      "SHcy": "Ш",
      "shcy": "ш",
      "ShortDownArrow": "↓",
      "ShortLeftArrow": "←",
      "shortmid": "∣",
      "shortparallel": "∥",
      "ShortRightArrow": "→",
      "ShortUpArrow": "↑",
      "shy": "­",
      "Sigma": "Σ",
      "sigma": "σ",
      "sigmaf": "ς",
      "sigmav": "ς",
      "sim": "∼",
      "simdot": "⩪",
      "sime": "≃",
      "simeq": "≃",
      "simg": "⪞",
      "simgE": "⪠",
      "siml": "⪝",
      "simlE": "⪟",
      "simne": "≆",
      "simplus": "⨤",
      "simrarr": "⥲",
      "slarr": "←",
      "SmallCircle": "∘",
      "smallsetminus": "∖",
      "smashp": "⨳",
      "smeparsl": "⧤",
      "smid": "∣",
      "smile": "⌣",
      "smt": "⪪",
      "smte": "⪬",
      "smtes": "⪬︀",
      "SOFTcy": "Ь",
      "softcy": "ь",
      "solbar": "⌿",
      "solb": "⧄",
      "sol": "/",
      "Sopf": "𝕊",
      "sopf": "𝕤",
      "spades": "♠",
      "spadesuit": "♠",
      "spar": "∥",
      "sqcap": "⊓",
      "sqcaps": "⊓︀",
      "sqcup": "⊔",
      "sqcups": "⊔︀",
      "Sqrt": "√",
      "sqsub": "⊏",
      "sqsube": "⊑",
      "sqsubset": "⊏",
      "sqsubseteq": "⊑",
      "sqsup": "⊐",
      "sqsupe": "⊒",
      "sqsupset": "⊐",
      "sqsupseteq": "⊒",
      "square": "□",
      "Square": "□",
      "SquareIntersection": "⊓",
      "SquareSubset": "⊏",
      "SquareSubsetEqual": "⊑",
      "SquareSuperset": "⊐",
      "SquareSupersetEqual": "⊒",
      "SquareUnion": "⊔",
      "squarf": "▪",
      "squ": "□",
      "squf": "▪",
      "srarr": "→",
      "Sscr": "𝒮",
      "sscr": "𝓈",
      "ssetmn": "∖",
      "ssmile": "⌣",
      "sstarf": "⋆",
      "Star": "⋆",
      "star": "☆",
      "starf": "★",
      "straightepsilon": "ϵ",
      "straightphi": "ϕ",
      "strns": "¯",
      "sub": "⊂",
      "Sub": "⋐",
      "subdot": "⪽",
      "subE": "⫅",
      "sube": "⊆",
      "subedot": "⫃",
      "submult": "⫁",
      "subnE": "⫋",
      "subne": "⊊",
      "subplus": "⪿",
      "subrarr": "⥹",
      "subset": "⊂",
      "Subset": "⋐",
      "subseteq": "⊆",
      "subseteqq": "⫅",
      "SubsetEqual": "⊆",
      "subsetneq": "⊊",
      "subsetneqq": "⫋",
      "subsim": "⫇",
      "subsub": "⫕",
      "subsup": "⫓",
      "succapprox": "⪸",
      "succ": "≻",
      "succcurlyeq": "≽",
      "Succeeds": "≻",
      "SucceedsEqual": "⪰",
      "SucceedsSlantEqual": "≽",
      "SucceedsTilde": "≿",
      "succeq": "⪰",
      "succnapprox": "⪺",
      "succneqq": "⪶",
      "succnsim": "⋩",
      "succsim": "≿",
      "SuchThat": "∋",
      "sum": "∑",
      "Sum": "∑",
      "sung": "♪",
      "sup1": "¹",
      "sup2": "²",
      "sup3": "³",
      "sup": "⊃",
      "Sup": "⋑",
      "supdot": "⪾",
      "supdsub": "⫘",
      "supE": "⫆",
      "supe": "⊇",
      "supedot": "⫄",
      "Superset": "⊃",
      "SupersetEqual": "⊇",
      "suphsol": "⟉",
      "suphsub": "⫗",
      "suplarr": "⥻",
      "supmult": "⫂",
      "supnE": "⫌",
      "supne": "⊋",
      "supplus": "⫀",
      "supset": "⊃",
      "Supset": "⋑",
      "supseteq": "⊇",
      "supseteqq": "⫆",
      "supsetneq": "⊋",
      "supsetneqq": "⫌",
      "supsim": "⫈",
      "supsub": "⫔",
      "supsup": "⫖",
      "swarhk": "⤦",
      "swarr": "↙",
      "swArr": "⇙",
      "swarrow": "↙",
      "swnwar": "⤪",
      "szlig": "ß",
      "Tab": "\t",
      "target": "⌖",
      "Tau": "Τ",
      "tau": "τ",
      "tbrk": "⎴",
      "Tcaron": "Ť",
      "tcaron": "ť",
      "Tcedil": "Ţ",
      "tcedil": "ţ",
      "Tcy": "Т",
      "tcy": "т",
      "tdot": "⃛",
      "telrec": "⌕",
      "Tfr": "𝔗",
      "tfr": "𝔱",
      "there4": "∴",
      "therefore": "∴",
      "Therefore": "∴",
      "Theta": "Θ",
      "theta": "θ",
      "thetasym": "ϑ",
      "thetav": "ϑ",
      "thickapprox": "≈",
      "thicksim": "∼",
      "ThickSpace": "  ",
      "ThinSpace": " ",
      "thinsp": " ",
      "thkap": "≈",
      "thksim": "∼",
      "THORN": "Þ",
      "thorn": "þ",
      "tilde": "˜",
      "Tilde": "∼",
      "TildeEqual": "≃",
      "TildeFullEqual": "≅",
      "TildeTilde": "≈",
      "timesbar": "⨱",
      "timesb": "⊠",
      "times": "×",
      "timesd": "⨰",
      "tint": "∭",
      "toea": "⤨",
      "topbot": "⌶",
      "topcir": "⫱",
      "top": "⊤",
      "Topf": "𝕋",
      "topf": "𝕥",
      "topfork": "⫚",
      "tosa": "⤩",
      "tprime": "‴",
      "trade": "™",
      "TRADE": "™",
      "triangle": "▵",
      "triangledown": "▿",
      "triangleleft": "◃",
      "trianglelefteq": "⊴",
      "triangleq": "≜",
      "triangleright": "▹",
      "trianglerighteq": "⊵",
      "tridot": "◬",
      "trie": "≜",
      "triminus": "⨺",
      "TripleDot": "⃛",
      "triplus": "⨹",
      "trisb": "⧍",
      "tritime": "⨻",
      "trpezium": "⏢",
      "Tscr": "𝒯",
      "tscr": "𝓉",
      "TScy": "Ц",
      "tscy": "ц",
      "TSHcy": "Ћ",
      "tshcy": "ћ",
      "Tstrok": "Ŧ",
      "tstrok": "ŧ",
      "twixt": "≬",
      "twoheadleftarrow": "↞",
      "twoheadrightarrow": "↠",
      "Uacute": "Ú",
      "uacute": "ú",
      "uarr": "↑",
      "Uarr": "↟",
      "uArr": "⇑",
      "Uarrocir": "⥉",
      "Ubrcy": "Ў",
      "ubrcy": "ў",
      "Ubreve": "Ŭ",
      "ubreve": "ŭ",
      "Ucirc": "Û",
      "ucirc": "û",
      "Ucy": "У",
      "ucy": "у",
      "udarr": "⇅",
      "Udblac": "Ű",
      "udblac": "ű",
      "udhar": "⥮",
      "ufisht": "⥾",
      "Ufr": "𝔘",
      "ufr": "𝔲",
      "Ugrave": "Ù",
      "ugrave": "ù",
      "uHar": "⥣",
      "uharl": "↿",
      "uharr": "↾",
      "uhblk": "▀",
      "ulcorn": "⌜",
      "ulcorner": "⌜",
      "ulcrop": "⌏",
      "ultri": "◸",
      "Umacr": "Ū",
      "umacr": "ū",
      "uml": "¨",
      "UnderBar": "_",
      "UnderBrace": "⏟",
      "UnderBracket": "⎵",
      "UnderParenthesis": "⏝",
      "Union": "⋃",
      "UnionPlus": "⊎",
      "Uogon": "Ų",
      "uogon": "ų",
      "Uopf": "𝕌",
      "uopf": "𝕦",
      "UpArrowBar": "⤒",
      "uparrow": "↑",
      "UpArrow": "↑",
      "Uparrow": "⇑",
      "UpArrowDownArrow": "⇅",
      "updownarrow": "↕",
      "UpDownArrow": "↕",
      "Updownarrow": "⇕",
      "UpEquilibrium": "⥮",
      "upharpoonleft": "↿",
      "upharpoonright": "↾",
      "uplus": "⊎",
      "UpperLeftArrow": "↖",
      "UpperRightArrow": "↗",
      "upsi": "υ",
      "Upsi": "ϒ",
      "upsih": "ϒ",
      "Upsilon": "Υ",
      "upsilon": "υ",
      "UpTeeArrow": "↥",
      "UpTee": "⊥",
      "upuparrows": "⇈",
      "urcorn": "⌝",
      "urcorner": "⌝",
      "urcrop": "⌎",
      "Uring": "Ů",
      "uring": "ů",
      "urtri": "◹",
      "Uscr": "𝒰",
      "uscr": "𝓊",
      "utdot": "⋰",
      "Utilde": "Ũ",
      "utilde": "ũ",
      "utri": "▵",
      "utrif": "▴",
      "uuarr": "⇈",
      "Uuml": "Ü",
      "uuml": "ü",
      "uwangle": "⦧",
      "vangrt": "⦜",
      "varepsilon": "ϵ",
      "varkappa": "ϰ",
      "varnothing": "∅",
      "varphi": "ϕ",
      "varpi": "ϖ",
      "varpropto": "∝",
      "varr": "↕",
      "vArr": "⇕",
      "varrho": "ϱ",
      "varsigma": "ς",
      "varsubsetneq": "⊊︀",
      "varsubsetneqq": "⫋︀",
      "varsupsetneq": "⊋︀",
      "varsupsetneqq": "⫌︀",
      "vartheta": "ϑ",
      "vartriangleleft": "⊲",
      "vartriangleright": "⊳",
      "vBar": "⫨",
      "Vbar": "⫫",
      "vBarv": "⫩",
      "Vcy": "В",
      "vcy": "в",
      "vdash": "⊢",
      "vDash": "⊨",
      "Vdash": "⊩",
      "VDash": "⊫",
      "Vdashl": "⫦",
      "veebar": "⊻",
      "vee": "∨",
      "Vee": "⋁",
      "veeeq": "≚",
      "vellip": "⋮",
      "verbar": "|",
      "Verbar": "‖",
      "vert": "|",
      "Vert": "‖",
      "VerticalBar": "∣",
      "VerticalLine": "|",
      "VerticalSeparator": "❘",
      "VerticalTilde": "≀",
      "VeryThinSpace": " ",
      "Vfr": "𝔙",
      "vfr": "𝔳",
      "vltri": "⊲",
      "vnsub": "⊂⃒",
      "vnsup": "⊃⃒",
      "Vopf": "𝕍",
      "vopf": "𝕧",
      "vprop": "∝",
      "vrtri": "⊳",
      "Vscr": "𝒱",
      "vscr": "𝓋",
      "vsubnE": "⫋︀",
      "vsubne": "⊊︀",
      "vsupnE": "⫌︀",
      "vsupne": "⊋︀",
      "Vvdash": "⊪",
      "vzigzag": "⦚",
      "Wcirc": "Ŵ",
      "wcirc": "ŵ",
      "wedbar": "⩟",
      "wedge": "∧",
      "Wedge": "⋀",
      "wedgeq": "≙",
      "weierp": "℘",
      "Wfr": "𝔚",
      "wfr": "𝔴",
      "Wopf": "𝕎",
      "wopf": "𝕨",
      "wp": "℘",
      "wr": "≀",
      "wreath": "≀",
      "Wscr": "𝒲",
      "wscr": "𝓌",
      "xcap": "⋂",
      "xcirc": "◯",
      "xcup": "⋃",
      "xdtri": "▽",
      "Xfr": "𝔛",
      "xfr": "𝔵",
      "xharr": "⟷",
      "xhArr": "⟺",
      "Xi": "Ξ",
      "xi": "ξ",
      "xlarr": "⟵",
      "xlArr": "⟸",
      "xmap": "⟼",
      "xnis": "⋻",
      "xodot": "⨀",
      "Xopf": "𝕏",
      "xopf": "𝕩",
      "xoplus": "⨁",
      "xotime": "⨂",
      "xrarr": "⟶",
      "xrArr": "⟹",
      "Xscr": "𝒳",
      "xscr": "𝓍",
      "xsqcup": "⨆",
      "xuplus": "⨄",
      "xutri": "△",
      "xvee": "⋁",
      "xwedge": "⋀",
      "Yacute": "Ý",
      "yacute": "ý",
      "YAcy": "Я",
      "yacy": "я",
      "Ycirc": "Ŷ",
      "ycirc": "ŷ",
      "Ycy": "Ы",
      "ycy": "ы",
      "yen": "¥",
      "Yfr": "𝔜",
      "yfr": "𝔶",
      "YIcy": "Ї",
      "yicy": "ї",
      "Yopf": "𝕐",
      "yopf": "𝕪",
      "Yscr": "𝒴",
      "yscr": "𝓎",
      "YUcy": "Ю",
      "yucy": "ю",
      "yuml": "ÿ",
      "Yuml": "Ÿ",
      "Zacute": "Ź",
      "zacute": "ź",
      "Zcaron": "Ž",
      "zcaron": "ž",
      "Zcy": "З",
      "zcy": "з",
      "Zdot": "Ż",
      "zdot": "ż",
      "zeetrf": "ℨ",
      "ZeroWidthSpace": "​",
      "Zeta": "Ζ",
      "zeta": "ζ",
      "zfr": "𝔷",
      "Zfr": "ℨ",
      "ZHcy": "Ж",
      "zhcy": "ж",
      "zigrarr": "⇝",
      "zopf": "𝕫",
      "Zopf": "ℤ",
      "Zscr": "𝒵",
      "zscr": "𝓏",
      "zwj": "‍",
      "zwnj": "‌"
    };

    /***/
  }), ( /* 403 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var numberIsNaN = __webpack_require__(411),
      toPosInt = __webpack_require__(205),
      value = __webpack_require__(23),
      indexOf = Array.prototype.indexOf,
      objHasOwnProperty = Object.prototype.hasOwnProperty,
      abs = Math.abs,
      floor = Math.floor;
    module.exports = function (searchElement /*, fromIndex*/) {
      var i, length, fromIndex, val;
      if (!numberIsNaN(searchElement)) return indexOf.apply(this, arguments);
      length = toPosInt(value(this).length);
      fromIndex = arguments[1];
      if (isNaN(fromIndex)) fromIndex = 0;else if (fromIndex >= 0) fromIndex = floor(fromIndex);else fromIndex = toPosInt(this.length) - floor(abs(fromIndex));
      for (i = fromIndex; i < length; ++i) {
        if (objHasOwnProperty.call(this, i)) {
          val = this[i];
          if (numberIsNaN(val)) return i; // Jslint: ignore
        }
      }
      return -1;
    };

    /***/
  }), ( /* 404 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    module.exports = __webpack_require__(405)() ? Array.from : __webpack_require__(406);

    /***/
  }), ( /* 405 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    module.exports = function () {
      var from = Array.from,
        arr,
        result;
      if (typeof from !== "function") return false;
      arr = ["raz", "dwa"];
      result = from(arr);
      return Boolean(result && result !== arr && result[1] === "dwa");
    };

    /***/
  }), ( /* 406 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var iteratorSymbol = __webpack_require__(32).iterator,
      isArguments = __webpack_require__(91),
      isFunction = __webpack_require__(407),
      toPosInt = __webpack_require__(205),
      callable = __webpack_require__(40),
      validValue = __webpack_require__(23),
      isValue = __webpack_require__(51),
      isString = __webpack_require__(93),
      isArray = Array.isArray,
      call = Function.prototype.call,
      desc = {
        configurable: true,
        enumerable: true,
        writable: true,
        value: null
      },
      defineProperty = Object.defineProperty;

    // eslint-disable-next-line complexity, max-lines-per-function
    module.exports = function (arrayLike /*, mapFn, thisArg*/) {
      var mapFn = arguments[1],
        thisArg = arguments[2],
        Context,
        i,
        j,
        arr,
        length,
        code,
        iterator,
        result,
        getIterator,
        value;
      arrayLike = Object(validValue(arrayLike));
      if (isValue(mapFn)) callable(mapFn);
      if (!this || this === Array || !isFunction(this)) {
        // Result: Plain array
        if (!mapFn) {
          if (isArguments(arrayLike)) {
            // Source: Arguments
            length = arrayLike.length;
            if (length !== 1) return Array.apply(null, arrayLike);
            arr = new Array(1);
            arr[0] = arrayLike[0];
            return arr;
          }
          if (isArray(arrayLike)) {
            // Source: Array
            arr = new Array(length = arrayLike.length);
            for (i = 0; i < length; ++i) {
              arr[i] = arrayLike[i];
            }
            return arr;
          }
        }
        arr = [];
      } else {
        // Result: Non plain array
        Context = this;
      }
      if (!isArray(arrayLike)) {
        if ((getIterator = arrayLike[iteratorSymbol]) !== undefined) {
          // Source: Iterator
          iterator = callable(getIterator).call(arrayLike);
          if (Context) arr = new Context();
          result = iterator.next();
          i = 0;
          while (!result.done) {
            value = mapFn ? call.call(mapFn, thisArg, result.value, i) : result.value;
            if (Context) {
              desc.value = value;
              defineProperty(arr, i, desc);
            } else {
              arr[i] = value;
            }
            result = iterator.next();
            ++i;
          }
          length = i;
        } else if (isString(arrayLike)) {
          // Source: String
          length = arrayLike.length;
          if (Context) arr = new Context();
          for (i = 0, j = 0; i < length; ++i) {
            value = arrayLike[i];
            if (i + 1 < length) {
              code = value.charCodeAt(0);
              // eslint-disable-next-line max-depth
              if (code >= 0xd800 && code <= 0xdbff) value += arrayLike[++i];
            }
            value = mapFn ? call.call(mapFn, thisArg, value, j) : value;
            if (Context) {
              desc.value = value;
              defineProperty(arr, j, desc);
            } else {
              arr[j] = value;
            }
            ++j;
          }
          length = j;
        }
      }
      if (length === undefined) {
        // Source: array or array-like
        length = toPosInt(arrayLike.length);
        if (Context) arr = new Context(length);
        for (i = 0; i < length; ++i) {
          value = mapFn ? call.call(mapFn, thisArg, arrayLike[i], i) : arrayLike[i];
          if (Context) {
            desc.value = value;
            defineProperty(arr, i, desc);
          } else {
            arr[i] = value;
          }
        }
      }
      if (Context) {
        desc.value = null;
        arr.length = length;
      }
      return arr;
    };

    /***/
  }), ( /* 407 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var objToString = Object.prototype.toString,
      id = objToString.call(__webpack_require__(204));
    module.exports = function (value) {
      return typeof value === "function" && objToString.call(value) === id;
    };

    /***/
  }), ( /* 408 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    module.exports = __webpack_require__(409)() ? Math.sign : __webpack_require__(410);

    /***/
  }), ( /* 409 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    module.exports = function () {
      var sign = Math.sign;
      if (typeof sign !== "function") return false;
      return sign(10) === 1 && sign(-20) === -1;
    };

    /***/
  }), ( /* 410 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    module.exports = function (value) {
      value = Number(value);
      if (isNaN(value) || value === 0) return value;
      return value > 0 ? 1 : -1;
    };

    /***/
  }), ( /* 411 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    module.exports = __webpack_require__(412)() ? Number.isNaN : __webpack_require__(413);

    /***/
  }), ( /* 412 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    module.exports = function () {
      var numberIsNaN = Number.isNaN;
      if (typeof numberIsNaN !== "function") return false;
      return !numberIsNaN({}) && numberIsNaN(NaN) && !numberIsNaN(34);
    };

    /***/
  }), ( /* 413 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    module.exports = function (value) {
      // eslint-disable-next-line no-self-compare
      return value !== value;
    };

    /***/
  }), ( /* 414 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var sign = __webpack_require__(408),
      abs = Math.abs,
      floor = Math.floor;
    module.exports = function (value) {
      if (isNaN(value)) return 0;
      value = Number(value);
      if (value === 0 || !isFinite(value)) return value;
      return sign(value) * floor(abs(value));
    };

    /***/
  }), ( /* 415 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Internal method, used by iteration functions.
    // Calls a function for each key-value pair found in object
    // Optionally takes compareFn to iterate object in specific order
    var callable = __webpack_require__(40),
      value = __webpack_require__(23),
      bind = Function.prototype.bind,
      call = Function.prototype.call,
      keys = Object.keys,
      objPropertyIsEnumerable = Object.prototype.propertyIsEnumerable;
    module.exports = function (method, defVal) {
      return function (obj, cb /*, thisArg, compareFn*/) {
        var list,
          thisArg = arguments[2],
          compareFn = arguments[3];
        obj = Object(value(obj));
        callable(cb);
        list = keys(obj);
        if (compareFn) {
          list.sort(typeof compareFn === "function" ? bind.call(compareFn, obj) : undefined);
        }
        if (typeof method !== "function") method = list[method];
        return call.call(method, list, function (key, index) {
          if (!objPropertyIsEnumerable.call(obj, key)) return defVal;
          return call.call(cb, thisArg, obj[key], key, obj, index);
        });
      };
    };

    /***/
  }), ( /* 416 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    module.exports = function () {
      var assign = Object.assign,
        obj;
      if (typeof assign !== "function") return false;
      obj = {
        foo: "raz"
      };
      assign(obj, {
        bar: "dwa"
      }, {
        trzy: "trzy"
      });
      return obj.foo + obj.bar + obj.trzy === "razdwatrzy";
    };

    /***/
  }), ( /* 417 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var keys = __webpack_require__(422),
      value = __webpack_require__(23),
      max = Math.max;
    module.exports = function (dest, src /*, …srcn*/) {
      var error,
        i,
        length = max(arguments.length, 2),
        assign;
      dest = Object(value(dest));
      assign = function assign(key) {
        try {
          dest[key] = src[key];
        } catch (e) {
          if (!error) error = e;
        }
      };
      for (i = 1; i < length; ++i) {
        src = arguments[i];
        keys(src).forEach(assign);
      }
      if (error !== undefined) throw error;
      return dest;
    };

    /***/
  }), ( /* 418 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var aFrom = __webpack_require__(404),
      assign = __webpack_require__(131),
      value = __webpack_require__(23);
    module.exports = function (obj /*, propertyNames, options*/) {
      var copy = Object(value(obj)),
        propertyNames = arguments[1],
        options = Object(arguments[2]);
      if (copy !== obj && !propertyNames) return copy;
      var result = {};
      if (propertyNames) {
        aFrom(propertyNames, function (propertyName) {
          if (options.ensure || propertyName in obj) result[propertyName] = obj[propertyName];
        });
      } else {
        assign(result, obj);
      }
      return result;
    };

    /***/
  }), ( /* 419 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Workaround for http://code.google.com/p/v8/issues/detail?id=2804
    var create = Object.create,
      shim;
    if (!__webpack_require__(207)()) {
      shim = __webpack_require__(208);
    }
    module.exports = function () {
      var nullObject, polyProps, desc;
      if (!shim) return create;
      if (shim.level !== 1) return create;
      nullObject = {};
      polyProps = {};
      desc = {
        configurable: false,
        enumerable: false,
        writable: true,
        value: undefined
      };
      Object.getOwnPropertyNames(Object.prototype).forEach(function (name) {
        if (name === "__proto__") {
          polyProps[name] = {
            configurable: true,
            enumerable: false,
            writable: true,
            value: undefined
          };
          return;
        }
        polyProps[name] = desc;
      });
      Object.defineProperties(nullObject, polyProps);
      Object.defineProperty(shim, "nullPolyfill", {
        configurable: false,
        enumerable: false,
        writable: false,
        value: nullObject
      });
      return function (prototype, props) {
        return create(prototype === null ? nullObject : prototype, props);
      };
    }();

    /***/
  }), ( /* 420 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    module.exports = __webpack_require__(415)("forEach");

    /***/
  }), ( /* 421 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var isValue = __webpack_require__(51);
    var map = {
      function: true,
      object: true
    };
    module.exports = function (value) {
      return isValue(value) && map[typeof value] || false;
    };

    /***/
  }), ( /* 422 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    module.exports = __webpack_require__(423)() ? Object.keys : __webpack_require__(424);

    /***/
  }), ( /* 423 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    module.exports = function () {
      try {
        Object.keys("primitive");
        return true;
      } catch (e) {
        return false;
      }
    };

    /***/
  }), ( /* 424 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var isValue = __webpack_require__(51);
    var keys = Object.keys;
    module.exports = function (object) {
      return keys(isValue(object) ? Object(object) : object);
    };

    /***/
  }), ( /* 425 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var callable = __webpack_require__(40),
      forEach = __webpack_require__(420),
      call = Function.prototype.call;
    module.exports = function (obj, cb /*, thisArg*/) {
      var result = {},
        thisArg = arguments[2];
      callable(cb);
      forEach(obj, function (value, key, targetObj, index) {
        result[key] = call.call(cb, thisArg, value, key, targetObj, index);
      });
      return result;
    };

    /***/
  }), ( /* 426 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var forEach = Array.prototype.forEach,
      create = Object.create;

    // eslint-disable-next-line no-unused-vars
    module.exports = function (arg /*, …args*/) {
      var set = create(null);
      forEach.call(arguments, function (name) {
        set[name] = true;
      });
      return set;
    };

    /***/
  }), ( /* 427 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var str = "razdwatrzy";
    module.exports = function () {
      if (typeof str.contains !== "function") return false;
      return str.contains("dwa") === true && str.contains("foo") === false;
    };

    /***/
  }), ( /* 428 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var indexOf = String.prototype.indexOf;
    module.exports = function (searchString /*, position*/) {
      return indexOf.call(this, searchString, arguments[1]) > -1;
    };

    /***/
  }), ( /* 429 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var setPrototypeOf = __webpack_require__(92),
      contains = __webpack_require__(209),
      d = __webpack_require__(39),
      Symbol = __webpack_require__(32),
      Iterator = __webpack_require__(132);
    var defineProperty = Object.defineProperty,
      ArrayIterator;
    ArrayIterator = module.exports = function (arr, kind) {
      if (!(this instanceof ArrayIterator)) throw new TypeError("Constructor requires 'new'");
      Iterator.call(this, arr);
      if (!kind) kind = "value";else if (contains.call(kind, "key+value")) kind = "key+value";else if (contains.call(kind, "key")) kind = "key";else kind = "value";
      defineProperty(this, "__kind__", d("", kind));
    };
    if (setPrototypeOf) setPrototypeOf(ArrayIterator, Iterator);

    // Internal %ArrayIteratorPrototype% doesn't expose its constructor
    delete ArrayIterator.prototype.constructor;
    ArrayIterator.prototype = Object.create(Iterator.prototype, {
      _resolve: d(function (i) {
        if (this.__kind__ === "value") return this.__list__[i];
        if (this.__kind__ === "key+value") return [i, this.__list__[i]];
        return i;
      })
    });
    defineProperty(ArrayIterator.prototype, Symbol.toStringTag, d("c", "Array Iterator"));

    /***/
  }), ( /* 430 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var isArguments = __webpack_require__(91),
      callable = __webpack_require__(40),
      isString = __webpack_require__(93),
      get = __webpack_require__(431);
    var isArray = Array.isArray,
      call = Function.prototype.call,
      some = Array.prototype.some;
    module.exports = function (iterable, cb /*, thisArg*/) {
      var mode,
        thisArg = arguments[2],
        result,
        doBreak,
        broken,
        i,
        length,
        char,
        code;
      if (isArray(iterable) || isArguments(iterable)) mode = "array";else if (isString(iterable)) mode = "string";else iterable = get(iterable);
      callable(cb);
      doBreak = function doBreak() {
        broken = true;
      };
      if (mode === "array") {
        some.call(iterable, function (value) {
          call.call(cb, thisArg, value, doBreak);
          return broken;
        });
        return;
      }
      if (mode === "string") {
        length = iterable.length;
        for (i = 0; i < length; ++i) {
          char = iterable[i];
          if (i + 1 < length) {
            code = char.charCodeAt(0);
            if (code >= 0xd800 && code <= 0xdbff) char += iterable[++i];
          }
          call.call(cb, thisArg, char, doBreak);
          if (broken) break;
        }
        return;
      }
      result = iterable.next();
      while (!result.done) {
        call.call(cb, thisArg, result.value, doBreak);
        if (broken) return;
        result = iterable.next();
      }
    };

    /***/
  }), ( /* 431 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var isArguments = __webpack_require__(91),
      isString = __webpack_require__(93),
      ArrayIterator = __webpack_require__(429),
      StringIterator = __webpack_require__(433),
      iterable = __webpack_require__(210),
      iteratorSymbol = __webpack_require__(32).iterator;
    module.exports = function (obj) {
      if (typeof iterable(obj)[iteratorSymbol] === "function") return obj[iteratorSymbol]();
      if (isArguments(obj)) return new ArrayIterator(obj);
      if (isString(obj)) return new StringIterator(obj);
      return new ArrayIterator(obj);
    };

    /***/
  }), ( /* 432 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var isArguments = __webpack_require__(91),
      isValue = __webpack_require__(51),
      isString = __webpack_require__(93);
    var iteratorSymbol = __webpack_require__(32).iterator,
      isArray = Array.isArray;
    module.exports = function (value) {
      if (!isValue(value)) return false;
      if (isArray(value)) return true;
      if (isString(value)) return true;
      if (isArguments(value)) return true;
      return typeof value[iteratorSymbol] === "function";
    };

    /***/
  }), ( /* 433 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Thanks @mathiasbynens
    // http://mathiasbynens.be/notes/javascript-unicode#iterating-over-symbols
    var setPrototypeOf = __webpack_require__(92),
      d = __webpack_require__(39),
      Symbol = __webpack_require__(32),
      Iterator = __webpack_require__(132);
    var defineProperty = Object.defineProperty,
      StringIterator;
    StringIterator = module.exports = function (str) {
      if (!(this instanceof StringIterator)) throw new TypeError("Constructor requires 'new'");
      str = String(str);
      Iterator.call(this, str);
      defineProperty(this, "__length__", d("", str.length));
    };
    if (setPrototypeOf) setPrototypeOf(StringIterator, Iterator);

    // Internal %ArrayIteratorPrototype% doesn't expose its constructor
    delete StringIterator.prototype.constructor;
    StringIterator.prototype = Object.create(Iterator.prototype, {
      _next: d(function () {
        if (!this.__list__) return undefined;
        if (this.__nextIndex__ < this.__length__) return this.__nextIndex__++;
        this._unBind();
        return undefined;
      }),
      _resolve: d(function (i) {
        var char = this.__list__[i],
          code;
        if (this.__nextIndex__ === this.__length__) return char;
        code = char.charCodeAt(0);
        if (code >= 0xd800 && code <= 0xdbff) return char + this.__list__[this.__nextIndex__++];
        return char;
      })
    });
    defineProperty(StringIterator.prototype, Symbol.toStringTag, d("c", "String Iterator"));

    /***/
  }), ( /* 434 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    module.exports = __webpack_require__(435)() ? Map : __webpack_require__(439);

    /***/
  }), ( /* 435 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    module.exports = function () {
      var map, iterator, result;
      if (typeof Map !== 'function') return false;
      try {
        // WebKit doesn't support arguments and crashes
        map = new Map([['raz', 'one'], ['dwa', 'two'], ['trzy', 'three']]);
      } catch (e) {
        return false;
      }
      if (String(map) !== '[object Map]') return false;
      if (map.size !== 3) return false;
      if (typeof map.clear !== 'function') return false;
      if (typeof map.delete !== 'function') return false;
      if (typeof map.entries !== 'function') return false;
      if (typeof map.forEach !== 'function') return false;
      if (typeof map.get !== 'function') return false;
      if (typeof map.has !== 'function') return false;
      if (typeof map.keys !== 'function') return false;
      if (typeof map.set !== 'function') return false;
      if (typeof map.values !== 'function') return false;
      iterator = map.entries();
      result = iterator.next();
      if (result.done !== false) return false;
      if (!result.value) return false;
      if (result.value[0] !== 'raz') return false;
      if (result.value[1] !== 'one') return false;
      return true;
    };

    /***/
  }), ( /* 436 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Exports true if environment provides native `Map` implementation,
    // whatever that is.
    module.exports = function () {
      if (typeof Map === 'undefined') return false;
      return Object.prototype.toString.call(new Map()) === '[object Map]';
    }();

    /***/
  }), ( /* 437 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    module.exports = __webpack_require__(426)('key', 'value', 'key+value');

    /***/
  }), ( /* 438 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var setPrototypeOf = __webpack_require__(92),
      d = __webpack_require__(39),
      Iterator = __webpack_require__(132),
      toStringTagSymbol = __webpack_require__(32).toStringTag,
      kinds = __webpack_require__(437),
      defineProperties = Object.defineProperties,
      unBind = Iterator.prototype._unBind,
      MapIterator;
    MapIterator = module.exports = function (map, kind) {
      if (!(this instanceof MapIterator)) return new MapIterator(map, kind);
      Iterator.call(this, map.__mapKeysData__, map);
      if (!kind || !kinds[kind]) kind = 'key+value';
      defineProperties(this, {
        __kind__: d('', kind),
        __values__: d('w', map.__mapValuesData__)
      });
    };
    if (setPrototypeOf) setPrototypeOf(MapIterator, Iterator);
    MapIterator.prototype = Object.create(Iterator.prototype, {
      constructor: d(MapIterator),
      _resolve: d(function (i) {
        if (this.__kind__ === 'value') return this.__values__[i];
        if (this.__kind__ === 'key') return this.__list__[i];
        return [this.__list__[i], this.__values__[i]];
      }),
      _unBind: d(function () {
        this.__values__ = null;
        unBind.call(this);
      }),
      toString: d(function () {
        return '[object Map Iterator]';
      })
    });
    Object.defineProperty(MapIterator.prototype, toStringTagSymbol, d('c', 'Map Iterator'));

    /***/
  }), ( /* 439 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var clear = __webpack_require__(203),
      eIndexOf = __webpack_require__(403),
      setPrototypeOf = __webpack_require__(92),
      callable = __webpack_require__(40),
      validValue = __webpack_require__(23),
      d = __webpack_require__(39),
      ee = __webpack_require__(445),
      Symbol = __webpack_require__(32),
      iterator = __webpack_require__(210),
      forOf = __webpack_require__(430),
      Iterator = __webpack_require__(438),
      isNative = __webpack_require__(436),
      call = Function.prototype.call,
      defineProperties = Object.defineProperties,
      getPrototypeOf = Object.getPrototypeOf,
      _MapPoly;
    module.exports = _MapPoly = function MapPoly( /*iterable*/
    ) {
      var iterable = arguments[0],
        keys,
        values,
        self;
      if (!(this instanceof _MapPoly)) throw new TypeError('Constructor requires \'new\'');
      if (isNative && setPrototypeOf && Map !== _MapPoly) {
        self = setPrototypeOf(new Map(), getPrototypeOf(this));
      } else {
        self = this;
      }
      if (iterable != null) iterator(iterable);
      defineProperties(self, {
        __mapKeysData__: d('c', keys = []),
        __mapValuesData__: d('c', values = [])
      });
      if (!iterable) return self;
      forOf(iterable, function (value) {
        var key = validValue(value)[0];
        value = value[1];
        if (eIndexOf.call(keys, key) !== -1) return;
        keys.push(key);
        values.push(value);
      }, self);
      return self;
    };
    if (isNative) {
      if (setPrototypeOf) setPrototypeOf(_MapPoly, Map);
      _MapPoly.prototype = Object.create(Map.prototype, {
        constructor: d(_MapPoly)
      });
    }
    ee(defineProperties(_MapPoly.prototype, {
      clear: d(function () {
        if (!this.__mapKeysData__.length) return;
        clear.call(this.__mapKeysData__);
        clear.call(this.__mapValuesData__);
        this.emit('_clear');
      }),
      delete: d(function (key) {
        var index = eIndexOf.call(this.__mapKeysData__, key);
        if (index === -1) return false;
        this.__mapKeysData__.splice(index, 1);
        this.__mapValuesData__.splice(index, 1);
        this.emit('_delete', index, key);
        return true;
      }),
      entries: d(function () {
        return new Iterator(this, 'key+value');
      }),
      forEach: d(function (cb /*, thisArg*/) {
        var thisArg = arguments[1],
          iterator,
          result;
        callable(cb);
        iterator = this.entries();
        result = iterator._next();
        while (result !== undefined) {
          call.call(cb, thisArg, this.__mapValuesData__[result], this.__mapKeysData__[result], this);
          result = iterator._next();
        }
      }),
      get: d(function (key) {
        var index = eIndexOf.call(this.__mapKeysData__, key);
        if (index === -1) return;
        return this.__mapValuesData__[index];
      }),
      has: d(function (key) {
        return eIndexOf.call(this.__mapKeysData__, key) !== -1;
      }),
      keys: d(function () {
        return new Iterator(this, 'key');
      }),
      set: d(function (key, value) {
        var index = eIndexOf.call(this.__mapKeysData__, key),
          emit;
        if (index === -1) {
          index = this.__mapKeysData__.push(key) - 1;
          emit = true;
        }
        this.__mapValuesData__[index] = value;
        if (emit) this.emit('_add', index, key);
        return this;
      }),
      size: d.gs(function () {
        return this.__mapKeysData__.length;
      }),
      values: d(function () {
        return new Iterator(this, 'value');
      }),
      toString: d(function () {
        return '[object Map]';
      })
    }));
    Object.defineProperty(_MapPoly.prototype, Symbol.iterator, d(function () {
      return this.entries();
    }));
    Object.defineProperty(_MapPoly.prototype, Symbol.toStringTag, d('c', 'Map'));

    /***/
  }), ( /* 440 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var validTypes = {
      object: true,
      symbol: true
    };
    module.exports = function () {
      var symbol;
      if (typeof Symbol !== 'function') return false;
      symbol = Symbol('test symbol');
      try {
        String(symbol);
      } catch (e) {
        return false;
      }

      // Return 'true' also for polyfills
      if (!validTypes[typeof Symbol.iterator]) return false;
      if (!validTypes[typeof Symbol.toPrimitive]) return false;
      if (!validTypes[typeof Symbol.toStringTag]) return false;
      return true;
    };

    /***/
  }), ( /* 441 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    module.exports = function (x) {
      if (!x) return false;
      if (typeof x === 'symbol') return true;
      if (!x.constructor) return false;
      if (x.constructor.name !== 'Symbol') return false;
      return x[x.constructor.toStringTag] === 'Symbol';
    };

    /***/
  }), ( /* 442 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // ES2015 Symbol polyfill for environments that do not (or partially) support it
    var d = __webpack_require__(39),
      validateSymbol = __webpack_require__(443),
      create = Object.create,
      defineProperties = Object.defineProperties,
      defineProperty = Object.defineProperty,
      objPrototype = Object.prototype,
      NativeSymbol,
      SymbolPolyfill,
      HiddenSymbol,
      globalSymbols = create(null),
      isNativeSafe;
    if (typeof Symbol === 'function') {
      NativeSymbol = Symbol;
      try {
        String(NativeSymbol());
        isNativeSafe = true;
      } catch (ignore) {}
    }
    var generateName = function () {
      var created = create(null);
      return function (desc) {
        var postfix = 0,
          name,
          ie11BugWorkaround;
        while (created[desc + (postfix || '')]) {
          ++postfix;
        }
        desc += postfix || '';
        created[desc] = true;
        name = '@@' + desc;
        defineProperty(objPrototype, name, d.gs(null, function (value) {
          // For IE11 issue see:
          // https://connect.microsoft.com/IE/feedbackdetail/view/1928508/
          //    ie11-broken-getters-on-dom-objects
          // https://github.com/medikoo/es6-symbol/issues/12
          if (ie11BugWorkaround) return;
          ie11BugWorkaround = true;
          defineProperty(this, name, d(value));
          ie11BugWorkaround = false;
        }));
        return name;
      };
    }();

    // Internal constructor (not one exposed) for creating Symbol instances.
    // This one is used to ensure that `someSymbol instanceof Symbol` always return false
    HiddenSymbol = function Symbol(description) {
      if (this instanceof HiddenSymbol) throw new TypeError('Symbol is not a constructor');
      return SymbolPolyfill(description);
    };

    // Exposed `Symbol` constructor
    // (returns instances of HiddenSymbol)
    module.exports = SymbolPolyfill = function Symbol(description) {
      var symbol;
      if (this instanceof Symbol) throw new TypeError('Symbol is not a constructor');
      if (isNativeSafe) return NativeSymbol(description);
      symbol = create(HiddenSymbol.prototype);
      description = description === undefined ? '' : String(description);
      return defineProperties(symbol, {
        __description__: d('', description),
        __name__: d('', generateName(description))
      });
    };
    defineProperties(SymbolPolyfill, {
      for: d(function (key) {
        if (globalSymbols[key]) return globalSymbols[key];
        return globalSymbols[key] = SymbolPolyfill(String(key));
      }),
      keyFor: d(function (s) {
        var key;
        validateSymbol(s);
        for (key in globalSymbols) {
          if (globalSymbols[key] === s) return key;
        }
      }),
      // To ensure proper interoperability with other native functions (e.g. Array.from)
      // fallback to eventual native implementation of given symbol
      hasInstance: d('', NativeSymbol && NativeSymbol.hasInstance || SymbolPolyfill('hasInstance')),
      isConcatSpreadable: d('', NativeSymbol && NativeSymbol.isConcatSpreadable || SymbolPolyfill('isConcatSpreadable')),
      iterator: d('', NativeSymbol && NativeSymbol.iterator || SymbolPolyfill('iterator')),
      match: d('', NativeSymbol && NativeSymbol.match || SymbolPolyfill('match')),
      replace: d('', NativeSymbol && NativeSymbol.replace || SymbolPolyfill('replace')),
      search: d('', NativeSymbol && NativeSymbol.search || SymbolPolyfill('search')),
      species: d('', NativeSymbol && NativeSymbol.species || SymbolPolyfill('species')),
      split: d('', NativeSymbol && NativeSymbol.split || SymbolPolyfill('split')),
      toPrimitive: d('', NativeSymbol && NativeSymbol.toPrimitive || SymbolPolyfill('toPrimitive')),
      toStringTag: d('', NativeSymbol && NativeSymbol.toStringTag || SymbolPolyfill('toStringTag')),
      unscopables: d('', NativeSymbol && NativeSymbol.unscopables || SymbolPolyfill('unscopables'))
    });

    // Internal tweaks for real symbol producer
    defineProperties(HiddenSymbol.prototype, {
      constructor: d(SymbolPolyfill),
      toString: d('', function () {
        return this.__name__;
      })
    });

    // Proper implementation of methods exposed on Symbol.prototype
    // They won't be accessible on produced symbol instances as they derive from HiddenSymbol.prototype
    defineProperties(SymbolPolyfill.prototype, {
      toString: d(function () {
        return 'Symbol (' + validateSymbol(this).__description__ + ')';
      }),
      valueOf: d(function () {
        return validateSymbol(this);
      })
    });
    defineProperty(SymbolPolyfill.prototype, SymbolPolyfill.toPrimitive, d('', function () {
      var symbol = validateSymbol(this);
      if (typeof symbol === 'symbol') return symbol;
      return symbol.toString();
    }));
    defineProperty(SymbolPolyfill.prototype, SymbolPolyfill.toStringTag, d('c', 'Symbol'));

    // Proper implementaton of toPrimitive and toStringTag for returned symbol instances
    defineProperty(HiddenSymbol.prototype, SymbolPolyfill.toStringTag, d('c', SymbolPolyfill.prototype[SymbolPolyfill.toStringTag]));

    // Note: It's important to define `toPrimitive` as last one, as some implementations
    // implement `toPrimitive` natively without implementing `toStringTag` (or other specified symbols)
    // And that may invoke error in definition flow:
    // See: https://github.com/medikoo/es6-symbol/issues/13#issuecomment-164146149
    defineProperty(HiddenSymbol.prototype, SymbolPolyfill.toPrimitive, d('c', SymbolPolyfill.prototype[SymbolPolyfill.toPrimitive]));

    /***/
  }), ( /* 443 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var isSymbol = __webpack_require__(441);
    module.exports = function (value) {
      if (!isSymbol(value)) throw new TypeError(value + " is not a symbol");
      return value;
    };

    /***/
  }), ( /* 444 */
  /***/function (module, exports, __webpack_require__) {
    /* WEBPACK VAR INJECTION */(function (module, global) {
      var __WEBPACK_AMD_DEFINE_RESULT__; /*! https://mths.be/esrever v0.2.0 by @mathias */
      ;
      (function (root) {
        // Detect free variables `exports`
        var freeExports = typeof exports == 'object' && exports;

        // Detect free variable `module`
        var freeModule = typeof module == 'object' && module && module.exports == freeExports && module;

        // Detect free variable `global`, from Node.js or Browserified code,
        // and use it as `root`
        var freeGlobal = typeof global == 'object' && global;
        if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
          root = freeGlobal;
        }

        /*--------------------------------------------------------------------------*/

        var regexSymbolWithCombiningMarks = /([\0-\u02FF\u0370-\u1AAF\u1B00-\u1DBF\u1E00-\u20CF\u2100-\uD7FF\uE000-\uFE1F\uFE30-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])([\u0300-\u036F\u1AB0-\u1AFF\u1DC0-\u1DFF\u20D0-\u20FF\uFE20-\uFE2F]+)/g;
        var regexSurrogatePair = /([\uD800-\uDBFF])([\uDC00-\uDFFF])/g;
        var reverse = function reverse(string) {
          // Step 1: deal with combining marks and astral symbols (surrogate pairs)
          string = string
          // Swap symbols with their combining marks so the combining marks go first
          .replace(regexSymbolWithCombiningMarks, function ($0, $1, $2) {
            // Reverse the combining marks so they will end up in the same order
            // later on (after another round of reversing)
            return reverse($2) + $1;
          })
          // Swap high and low surrogates so the low surrogates go first
          .replace(regexSurrogatePair, '$2$1');
          // Step 2: reverse the code units in the string
          var result = '';
          var index = string.length;
          while (index--) {
            result += string.charAt(index);
          }
          return result;
        };

        /*--------------------------------------------------------------------------*/

        var esrever = {
          'version': '0.2.0',
          'reverse': reverse
        };

        // Some AMD build optimizers, like r.js, check for specific condition patterns
        // like the following:
        if (true) {
          !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
            return esrever;
          }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (freeExports && !freeExports.nodeType) {
          if (freeModule) {
            // in Node.js, io.js, or RingoJS v0.8.0+
            freeModule.exports = esrever;
          } else {
            // in Narwhal or RingoJS v0.7.0-
            for (var key in esrever) {
              esrever.hasOwnProperty(key) && (freeExports[key] = esrever[key]);
            }
          }
        } else {
          // in Rhino or a web browser
          root.esrever = esrever;
        }
      })(this);

      /* WEBPACK VAR INJECTION */
    }).call(exports, __webpack_require__(106)(module), __webpack_require__(80));

    /***/
  }), ( /* 445 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var d = __webpack_require__(39),
      callable = __webpack_require__(40),
      apply = Function.prototype.apply,
      call = Function.prototype.call,
      create = Object.create,
      defineProperty = Object.defineProperty,
      defineProperties = Object.defineProperties,
      hasOwnProperty = Object.prototype.hasOwnProperty,
      descriptor = {
        configurable: true,
        enumerable: false,
        writable: true
      },
      on,
      _once2,
      off,
      emit,
      methods,
      descriptors,
      base;
    on = function on(type, listener) {
      var data;
      callable(listener);
      if (!hasOwnProperty.call(this, '__ee__')) {
        data = descriptor.value = create(null);
        defineProperty(this, '__ee__', descriptor);
        descriptor.value = null;
      } else {
        data = this.__ee__;
      }
      if (!data[type]) data[type] = listener;else if (typeof data[type] === 'object') data[type].push(listener);else data[type] = [data[type], listener];
      return this;
    };
    _once2 = function once(type, listener) {
      var _once, self;
      callable(listener);
      self = this;
      on.call(this, type, _once = function once() {
        off.call(self, type, _once);
        apply.call(listener, this, arguments);
      });
      _once.__eeOnceListener__ = listener;
      return this;
    };
    off = function off(type, listener) {
      var data, listeners, candidate, i;
      callable(listener);
      if (!hasOwnProperty.call(this, '__ee__')) return this;
      data = this.__ee__;
      if (!data[type]) return this;
      listeners = data[type];
      if (typeof listeners === 'object') {
        for (i = 0; candidate = listeners[i]; ++i) {
          if (candidate === listener || candidate.__eeOnceListener__ === listener) {
            if (listeners.length === 2) data[type] = listeners[i ? 0 : 1];else listeners.splice(i, 1);
          }
        }
      } else {
        if (listeners === listener || listeners.__eeOnceListener__ === listener) {
          delete data[type];
        }
      }
      return this;
    };
    emit = function emit(type) {
      var i, l, listener, listeners, args;
      if (!hasOwnProperty.call(this, '__ee__')) return;
      listeners = this.__ee__[type];
      if (!listeners) return;
      if (typeof listeners === 'object') {
        l = arguments.length;
        args = new Array(l - 1);
        for (i = 1; i < l; ++i) {
          args[i - 1] = arguments[i];
        }
        listeners = listeners.slice();
        for (i = 0; listener = listeners[i]; ++i) {
          apply.call(listener, this, args);
        }
      } else {
        switch (arguments.length) {
          case 1:
            call.call(listeners, this);
            break;
          case 2:
            call.call(listeners, this, arguments[1]);
            break;
          case 3:
            call.call(listeners, this, arguments[1], arguments[2]);
            break;
          default:
            l = arguments.length;
            args = new Array(l - 1);
            for (i = 1; i < l; ++i) {
              args[i - 1] = arguments[i];
            }
            apply.call(listeners, this, args);
        }
      }
    };
    methods = {
      on: on,
      once: _once2,
      off: off,
      emit: emit
    };
    descriptors = {
      on: d(on),
      once: d(_once2),
      off: d(off),
      emit: d(emit)
    };
    base = defineProperties({}, descriptors);
    module.exports = exports = function exports(o) {
      return o == null ? create(base) : defineProperties(Object(o), descriptors);
    };
    exports.methods = methods;

    /***/
  }), ( /* 446 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     *
     * 
     */
    function makeEmptyFunction(arg) {
      return function () {
        return arg;
      };
    }

    /**
     * This function accepts and discards inputs; it has no side effects. This is
     * primarily useful idiomatically for overridable function endpoints which
     * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
     */
    var emptyFunction = function emptyFunction() {};
    emptyFunction.thatReturns = makeEmptyFunction;
    emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
    emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
    emptyFunction.thatReturnsNull = makeEmptyFunction(null);
    emptyFunction.thatReturnsThis = function () {
      return this;
    };
    emptyFunction.thatReturnsArgument = function (arg) {
      return arg;
    };
    module.exports = emptyFunction;

    /***/
  }), ( /* 447 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     *
     */

    /**
     * Use invariant() to assert state which your program assumes to be true.
     *
     * Provide sprintf-style format (only %s is supported) and arguments
     * to provide information about what broke and what you were
     * expecting.
     *
     * The invariant message will be stripped in production, but the invariant
     * will remain to ensure logic does not differ in production.
     */
    var validateFormat = function validateFormat(format) {};
    if (false) {
      validateFormat = function validateFormat(format) {
        if (format === undefined) {
          throw new Error('invariant requires an error message argument');
        }
      };
    }
    function invariant(condition, format, a, b, c, d, e, f) {
      validateFormat(format);
      if (!condition) {
        var error;
        if (format === undefined) {
          error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
        } else {
          var args = [a, b, c, d, e, f];
          var argIndex = 0;
          error = new Error(format.replace(/%s/g, function () {
            return args[argIndex++];
          }));
          error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
      }
    }
    module.exports = invariant;

    /***/
  }), ( /* 448 */
  /***/function (module, exports) {
    /**
     * Module exports.
     */

    module.exports = getDocument;

    // defined by w3c
    var DOCUMENT_NODE = 9;

    /**
     * Returns `true` if `w` is a Document object, or `false` otherwise.
     *
     * @param {?} d - Document object, maybe
     * @return {Boolean}
     * @private
     */

    function isDocument(d) {
      return d && d.nodeType === DOCUMENT_NODE;
    }

    /**
     * Returns the `document` object associated with the given `node`, which may be
     * a DOM element, the Window object, a Selection, a Range. Basically any DOM
     * object that references the Document in some way, this function will find it.
     *
     * @param {Mixed} node - DOM node, selection, or range in which to find the `document` object
     * @return {Document} the `document` object associated with `node`
     * @public
     */

    function getDocument(node) {
      if (isDocument(node)) {
        return node;
      } else if (isDocument(node.ownerDocument)) {
        return node.ownerDocument;
      } else if (isDocument(node.document)) {
        return node.document;
      } else if (node.parentNode) {
        return getDocument(node.parentNode);

        // Range support
      } else if (node.commonAncestorContainer) {
        return getDocument(node.commonAncestorContainer);
      } else if (node.startContainer) {
        return getDocument(node.startContainer);

        // Selection support
      } else if (node.anchorNode) {
        return getDocument(node.anchorNode);
      }
    }

    /***/
  }), ( /* 449 */
  /***/function (module, exports) {
    // this is a browser-only module. There is a non-browser equivalent in the same
    // directory. This is done using a `package.json` browser field.
    // old-IE fallback logic: http://stackoverflow.com/a/10260692
    module.exports = !!document.attachEvent && window !== document.parentWindow;

    /***/
  }), ( /* 450 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    /**
     * Copyright 2015, Yahoo! Inc.
     * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
     */
    var REACT_STATICS = {
      childContextTypes: true,
      contextTypes: true,
      defaultProps: true,
      displayName: true,
      getDefaultProps: true,
      getDerivedStateFromProps: true,
      mixins: true,
      propTypes: true,
      type: true
    };
    var KNOWN_STATICS = {
      name: true,
      length: true,
      prototype: true,
      caller: true,
      callee: true,
      arguments: true,
      arity: true
    };
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
    function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
      if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
          var inheritedComponent = getPrototypeOf(sourceComponent);
          if (inheritedComponent && inheritedComponent !== objectPrototype) {
            hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
          }
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) {
          keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }
        for (var i = 0; i < keys.length; ++i) {
          var key = keys[i];
          if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
            var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
            try {
              // Avoid failures from read-only properties
              defineProperty(targetComponent, key, descriptor);
            } catch (e) {}
          }
        }
        return targetComponent;
      }
      return targetComponent;
    }
    module.exports = hoistNonReactStatics;

    /***/
  }), ( /* 451 */
  /***/function (module, exports) {
    /**
     * Has own property.
     *
     * @type {Function}
     */

    var has = Object.prototype.hasOwnProperty;

    /**
     * To string.
     *
     * @type {Function}
     */

    var toString = Object.prototype.toString;

    /**
     * Test whether a value is "empty".
     *
     * @param {Mixed} val
     * @return {Boolean}
     */

    function isEmpty(val) {
      // Null and Undefined...
      if (val == null) return true;

      // Booleans...
      if ('boolean' == typeof val) return false;

      // Numbers...
      if ('number' == typeof val) return val === 0;

      // Strings...
      if ('string' == typeof val) return val.length === 0;

      // Functions...
      if ('function' == typeof val) return val.length === 0;

      // Arrays...
      if (Array.isArray(val)) return val.length === 0;

      // Errors...
      if (val instanceof Error) return val.message === '';

      // Objects...
      if (val.toString == toString) {
        switch (val.toString()) {
          // Maps, Sets, Files and Errors...
          case '[object File]':
          case '[object Map]':
          case '[object Set]':
            {
              return val.size === 0;
            }

          // Plain objects...
          case '[object Object]':
            {
              for (var key in val) {
                if (has.call(val, key)) return false;
              }
              return true;
            }
        }
      }

      // Anything else...
      return false;
    }

    /**
     * Export `isEmpty`.
     *
     * @type {Function}
     */

    module.exports = isEmpty;

    /***/
  }), ( /* 452 */
  /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    Object.defineProperty(__webpack_exports__, "__esModule", {
      value: true
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "isBrowser", function () {
      return isBrowser;
    });
    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

    /* harmony default export */
    __webpack_exports__["default"] = isBrowser;

    /***/
  }), ( /* 453 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    /*!
     * isobject <https://github.com/jonschlinkert/isobject>
     *
     * Copyright (c) 2014-2017, Jon Schlinkert.
     * Released under the MIT License.
     */
    module.exports = function isObject(val) {
      return val != null && typeof val === 'object' && Array.isArray(val) === false;
    };

    /***/
  }), ( /* 454 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.atob = self.atob.bind(self);
    exports.btoa = self.btoa.bind(self);

    /***/
  }), ( /* 455 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    ////////////////////////////////////////////////////////////////////////////////
    // Helpers

    // Merge objects
    //
    function assign(obj /*from1, from2, from3, ...*/) {
      var sources = Array.prototype.slice.call(arguments, 1);
      sources.forEach(function (source) {
        if (!source) {
          return;
        }
        Object.keys(source).forEach(function (key) {
          obj[key] = source[key];
        });
      });
      return obj;
    }
    function _class(obj) {
      return Object.prototype.toString.call(obj);
    }
    function isString(obj) {
      return _class(obj) === '[object String]';
    }
    function isObject(obj) {
      return _class(obj) === '[object Object]';
    }
    function isRegExp(obj) {
      return _class(obj) === '[object RegExp]';
    }
    function isFunction(obj) {
      return _class(obj) === '[object Function]';
    }
    function escapeRE(str) {
      return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
    }

    ////////////////////////////////////////////////////////////////////////////////

    var defaultOptions = {
      fuzzyLink: true,
      fuzzyEmail: true,
      fuzzyIP: false
    };
    function isOptionsObj(obj) {
      return Object.keys(obj || {}).reduce(function (acc, k) {
        return acc || defaultOptions.hasOwnProperty(k);
      }, false);
    }
    var defaultSchemas = {
      'http:': {
        validate: function validate(text, pos, self) {
          var tail = text.slice(pos);
          if (!self.re.http) {
            // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
          }
          if (self.re.http.test(tail)) {
            return tail.match(self.re.http)[0].length;
          }
          return 0;
        }
      },
      'https:': 'http:',
      'ftp:': 'http:',
      '//': {
        validate: function validate(text, pos, self) {
          var tail = text.slice(pos);
          if (!self.re.no_http) {
            // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth +
            // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
          }
          if (self.re.no_http.test(tail)) {
            // should not be `://` & `///`, that protects from errors in protocol name
            if (pos >= 3 && text[pos - 3] === ':') {
              return 0;
            }
            if (pos >= 3 && text[pos - 3] === '/') {
              return 0;
            }
            return tail.match(self.re.no_http)[0].length;
          }
          return 0;
        }
      },
      'mailto:': {
        validate: function validate(text, pos, self) {
          var tail = text.slice(pos);
          if (!self.re.mailto) {
            self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
          }
          if (self.re.mailto.test(tail)) {
            return tail.match(self.re.mailto)[0].length;
          }
          return 0;
        }
      }
    };

    /*eslint-disable max-len*/

    // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
    var tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';

    // DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
    var tlds_default = 'biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф'.split('|');

    /*eslint-enable max-len*/

    ////////////////////////////////////////////////////////////////////////////////

    function resetScanCache(self) {
      self.__index__ = -1;
      self.__text_cache__ = '';
    }
    function createValidator(re) {
      return function (text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) {
          return tail.match(re)[0].length;
        }
        return 0;
      };
    }
    function createNormalizer() {
      return function (match, self) {
        self.normalize(match);
      };
    }

    // Schemas compiler. Build regexps.
    //
    function compile(self) {
      // Load & clone RE patterns.
      var re = self.re = __webpack_require__(456)(self.__opts__);

      // Define dynamic patterns
      var tlds = self.__tlds__.slice();
      self.onCompile();
      if (!self.__tlds_replaced__) {
        tlds.push(tlds_2ch_src_re);
      }
      tlds.push(re.src_xn);
      re.src_tlds = tlds.join('|');
      function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
      }
      re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
      re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
      re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
      re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');

      //
      // Compile each schema
      //

      var aliases = [];
      self.__compiled__ = {}; // Reset compiled data

      function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
      }
      Object.keys(self.__schemas__).forEach(function (name) {
        var val = self.__schemas__[name];

        // skip disabled methods
        if (val === null) {
          return;
        }
        var compiled = {
          validate: null,
          link: null
        };
        self.__compiled__[name] = compiled;
        if (isObject(val)) {
          if (isRegExp(val.validate)) {
            compiled.validate = createValidator(val.validate);
          } else if (isFunction(val.validate)) {
            compiled.validate = val.validate;
          } else {
            schemaError(name, val);
          }
          if (isFunction(val.normalize)) {
            compiled.normalize = val.normalize;
          } else if (!val.normalize) {
            compiled.normalize = createNormalizer();
          } else {
            schemaError(name, val);
          }
          return;
        }
        if (isString(val)) {
          aliases.push(name);
          return;
        }
        schemaError(name, val);
      });

      //
      // Compile postponed aliases
      //

      aliases.forEach(function (alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) {
          // Silently fail on missed schemas to avoid errons on disable.
          // schemaError(alias, self.__schemas__[alias]);
          return;
        }
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
      });

      //
      // Fake record for guessed links
      //
      self.__compiled__[''] = {
        validate: null,
        normalize: createNormalizer()
      };

      //
      // Build schema condition
      //
      var slist = Object.keys(self.__compiled__).filter(function (name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
      }).map(escapeRE).join('|');
      // (?!_) cause 1.5x slowdown
      self.re.schema_test = RegExp("(^|(?!_)(?:[><\uFF5C]|" + re.src_ZPCc + '))(' + slist + ')', 'i');
      self.re.schema_search = RegExp("(^|(?!_)(?:[><\uFF5C]|" + re.src_ZPCc + '))(' + slist + ')', 'ig');
      self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');

      //
      // Cleanup
      //

      resetScanCache(self);
    }

    /**
     * class Match
     *
     * Match result. Single element of array, returned by [[LinkifyIt#match]]
     **/
    function Match(self, shift) {
      var start = self.__index__,
        end = self.__last_index__,
        text = self.__text_cache__.slice(start, end);

      /**
       * Match#schema -> String
       *
       * Prefix (protocol) for matched string.
       **/
      this.schema = self.__schema__.toLowerCase();
      /**
       * Match#index -> Number
       *
       * First position of matched string.
       **/
      this.index = start + shift;
      /**
       * Match#lastIndex -> Number
       *
       * Next position after matched string.
       **/
      this.lastIndex = end + shift;
      /**
       * Match#raw -> String
       *
       * Matched string.
       **/
      this.raw = text;
      /**
       * Match#text -> String
       *
       * Notmalized text of matched string.
       **/
      this.text = text;
      /**
       * Match#url -> String
       *
       * Normalized url of matched string.
       **/
      this.url = text;
    }
    function createMatch(self, shift) {
      var match = new Match(self, shift);
      self.__compiled__[match.schema].normalize(match, self);
      return match;
    }

    /**
     * class LinkifyIt
     **/

    /**
     * new LinkifyIt(schemas, options)
     * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
     * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
     *
     * Creates new linkifier instance with optional additional schemas.
     * Can be called without `new` keyword for convenience.
     *
     * By default understands:
     *
     * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
     * - "fuzzy" links and emails (example.com, foo@bar.com).
     *
     * `schemas` is an object, where each key/value describes protocol/rule:
     *
     * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
     *   for example). `linkify-it` makes shure that prefix is not preceeded with
     *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
     * - __value__ - rule to check tail after link prefix
     *   - _String_ - just alias to existing rule
     *   - _Object_
     *     - _validate_ - validator function (should return matched length on success),
     *       or `RegExp`.
     *     - _normalize_ - optional function to normalize text & url of matched result
     *       (for example, for @twitter mentions).
     *
     * `options`:
     *
     * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
     * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
     *   like version numbers. Default `false`.
     * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
     *
     **/
    function LinkifyIt(schemas, options) {
      if (!(this instanceof LinkifyIt)) {
        return new LinkifyIt(schemas, options);
      }
      if (!options) {
        if (isOptionsObj(schemas)) {
          options = schemas;
          schemas = {};
        }
      }
      this.__opts__ = assign({}, defaultOptions, options);

      // Cache last tested result. Used to skip repeating steps on next `match` call.
      this.__index__ = -1;
      this.__last_index__ = -1; // Next scan position
      this.__schema__ = '';
      this.__text_cache__ = '';
      this.__schemas__ = assign({}, defaultSchemas, schemas);
      this.__compiled__ = {};
      this.__tlds__ = tlds_default;
      this.__tlds_replaced__ = false;
      this.re = {};
      compile(this);
    }

    /** chainable
     * LinkifyIt#add(schema, definition)
     * - schema (String): rule name (fixed pattern prefix)
     * - definition (String|RegExp|Object): schema definition
     *
     * Add new rule definition. See constructor description for details.
     **/
    LinkifyIt.prototype.add = function add(schema, definition) {
      this.__schemas__[schema] = definition;
      compile(this);
      return this;
    };

    /** chainable
     * LinkifyIt#set(options)
     * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
     *
     * Set recognition options for links without schema.
     **/
    LinkifyIt.prototype.set = function set(options) {
      this.__opts__ = assign(this.__opts__, options);
      return this;
    };

    /**
     * LinkifyIt#test(text) -> Boolean
     *
     * Searches linkifiable pattern and returns `true` on success or `false` on fail.
     **/
    LinkifyIt.prototype.test = function test(text) {
      // Reset scan cache
      this.__text_cache__ = text;
      this.__index__ = -1;
      if (!text.length) {
        return false;
      }
      var m, ml, me, len, shift, next, re, tld_pos, at_pos;

      // try to scan for link with schema - that's the most simple rule
      if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while ((m = re.exec(text)) !== null) {
          len = this.testSchemaAt(text, m[2], re.lastIndex);
          if (len) {
            this.__schema__ = m[2];
            this.__index__ = m.index + m[1].length;
            this.__last_index__ = m.index + m[0].length + len;
            break;
          }
        }
      }
      if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
          // if tld is located after found link - no need to check fuzzy pattern
          if (this.__index__ < 0 || tld_pos < this.__index__) {
            if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
              shift = ml.index + ml[1].length;
              if (this.__index__ < 0 || shift < this.__index__) {
                this.__schema__ = '';
                this.__index__ = shift;
                this.__last_index__ = ml.index + ml[0].length;
              }
            }
          }
        }
      }
      if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) {
          // We can't skip this check, because this cases are possible:
          // 192.168.1.1@gmail.com, my.in@example.com
          if ((me = text.match(this.re.email_fuzzy)) !== null) {
            shift = me.index + me[1].length;
            next = me.index + me[0].length;
            if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
              this.__schema__ = 'mailto:';
              this.__index__ = shift;
              this.__last_index__ = next;
            }
          }
        }
      }
      return this.__index__ >= 0;
    };

    /**
     * LinkifyIt#pretest(text) -> Boolean
     *
     * Very quick check, that can give false positives. Returns true if link MAY BE
     * can exists. Can be used for speed optimization, when you need to check that
     * link NOT exists.
     **/
    LinkifyIt.prototype.pretest = function pretest(text) {
      return this.re.pretest.test(text);
    };

    /**
     * LinkifyIt#testSchemaAt(text, name, position) -> Number
     * - text (String): text to scan
     * - name (String): rule (schema) name
     * - position (Number): text offset to check from
     *
     * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
     * at given position. Returns length of found pattern (0 on fail).
     **/
    LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
      // If not supported schema check requested - terminate
      if (!this.__compiled__[schema.toLowerCase()]) {
        return 0;
      }
      return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
    };

    /**
     * LinkifyIt#match(text) -> Array|null
     *
     * Returns array of found link descriptions or `null` on fail. We strongly
     * recommend to use [[LinkifyIt#test]] first, for best speed.
     *
     * ##### Result match description
     *
     * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
     *   protocol-neutral  links.
     * - __index__ - offset of matched text
     * - __lastIndex__ - index of next char after mathch end
     * - __raw__ - matched text
     * - __text__ - normalized text
     * - __url__ - link, generated from matched text
     **/
    LinkifyIt.prototype.match = function match(text) {
      var shift = 0,
        result = [];

      // Try to take previous element from cache, if .test() called before
      if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push(createMatch(this, shift));
        shift = this.__last_index__;
      }

      // Cut head if cache was used
      var tail = shift ? text.slice(shift) : text;

      // Scan string until end reached
      while (this.test(tail)) {
        result.push(createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
      }
      if (result.length) {
        return result;
      }
      return null;
    };

    /** chainable
     * LinkifyIt#tlds(list [, keepOld]) -> this
     * - list (Array): list of tlds
     * - keepOld (Boolean): merge with current list if `true` (`false` by default)
     *
     * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
     * to avoid false positives. By default this algorythm used:
     *
     * - hostname with any 2-letter root zones are ok.
     * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
     *   are ok.
     * - encoded (`xn--...`) root zones are ok.
     *
     * If list is replaced, then exact match for 2-chars root zones will be checked.
     **/
    LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
      list = Array.isArray(list) ? list : [list];
      if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        compile(this);
        return this;
      }
      this.__tlds__ = this.__tlds__.concat(list).sort().filter(function (el, idx, arr) {
        return el !== arr[idx - 1];
      }).reverse();
      compile(this);
      return this;
    };

    /**
     * LinkifyIt#normalize(match)
     *
     * Default normalizer (if schema does not define it's own).
     **/
    LinkifyIt.prototype.normalize = function normalize(match) {
      // Do minimal possible changes by default. Need to collect feedback prior
      // to move forward https://github.com/markdown-it/linkify-it/issues/1

      if (!match.schema) {
        match.url = 'http://' + match.url;
      }
      if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) {
        match.url = 'mailto:' + match.url;
      }
    };

    /**
     * LinkifyIt#onCompile()
     *
     * Override to modify basic RegExp-s.
     **/
    LinkifyIt.prototype.onCompile = function onCompile() {};
    module.exports = LinkifyIt;

    /***/
  }), ( /* 456 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    module.exports = function (opts) {
      var re = {};

      // Use direct extract instead of `regenerate` to reduse browserified size
      re.src_Any = __webpack_require__(254).source;
      re.src_Cc = __webpack_require__(252).source;
      re.src_Z = __webpack_require__(253).source;
      re.src_P = __webpack_require__(163).source;

      // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
      re.src_ZPCc = [re.src_Z, re.src_P, re.src_Cc].join('|');

      // \p{\Z\Cc} (white spaces + control)
      re.src_ZCc = [re.src_Z, re.src_Cc].join('|');

      // Experimental. List of chars, completely prohibited in links
      // because can separate it from other part of text
      var text_separators = "[><\uFF5C]";

      // All possible word characters (everything without punctuation, spaces & controls)
      // Defined via punctuation & spaces to save space
      // Should be something like \p{\L\N\S\M} (\w but without `_`)
      re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
      // The same as abothe but without [0-9]
      // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';

      ////////////////////////////////////////////////////////////////////////////////

      re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';

      // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
      re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
      re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
      re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
      re.src_path = '(?:' + '[/?#]' + '(?:' + '(?!' + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' +
      // allow `I'm_king` if no pair found
      '\\.{2,4}[a-zA-Z0-9%/]|' +
      // github has ... in commit range links,
      // google has .... in links (issue #66)
      // Restrict to
      // - english
      // - percent-encoded
      // - parts of file path
      // until more examples found.
      '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
      : '\\-+|') + '\\,(?!' + re.src_ZCc + ').|' +
      // allow `,,,` in paths
      '\\!(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';

      // Allow anything in markdown spec, forbid quote (") at the first position
      // because emails enclosed in quotes are far more common
      re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
      re.src_xn = 'xn--[a-z0-9\\-]{1,59}';

      // More to read about domain names
      // http://serverfault.com/questions/638260/

      re.src_domain_root =
      // Allow letters & digits (http://test1)
      '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
      re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
      re.src_host = '(?:' +
      // Don't need IP check, because digits are already allowed in normal domain names
      //   src_ip4 +
      // '|' +
      '(?:(?:(?:' + re.src_domain + ')\\.)*' + re.src_domain /*_root*/ + ')' + ')';
      re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
      re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
      re.src_host_strict = re.src_host + re.src_host_terminator;
      re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
      re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
      re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
      re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;

      ////////////////////////////////////////////////////////////////////////////////
      // Main rules

      // Rude test fuzzy links by host, for quick deny
      re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
      re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
      re.tpl_link_fuzzy =
      // Fuzzy link can't be prepended with .:/\- and non punctuation.
      // but can start with > (markdown blockquote)
      "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + re.src_ZPCc + '))' + "((?![$+<=>^`|\uFF5C])" + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
      re.tpl_link_no_ip_fuzzy =
      // Fuzzy link can't be prepended with .:/\- and non punctuation.
      // but can start with > (markdown blockquote)
      "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + re.src_ZPCc + '))' + "((?![$+<=>^`|\uFF5C])" + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
      return re;
    };

    /***/
  }), ( /* 457 */
  /***/function (module, exports) {
    /**
     * Appends the elements of `values` to `array`.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to append.
     * @returns {Array} Returns `array`.
     */
    function arrayPush(array, values) {
      var index = -1,
        length = values.length,
        offset = array.length;
      while (++index < length) {
        array[offset + index] = values[index];
      }
      return array;
    }
    module.exports = arrayPush;

    /***/
  }), ( /* 458 */
  /***/function (module, exports, __webpack_require__) {
    var arrayPush = __webpack_require__(457),
      isFlattenable = __webpack_require__(463);

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
        length = array.length;
      predicate || (predicate = isFlattenable);
      result || (result = []);
      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }
    module.exports = baseFlatten;

    /***/
  }), ( /* 459 */
  /***/function (module, exports, __webpack_require__) {
    var Symbol = __webpack_require__(135),
      getRawTag = __webpack_require__(462),
      objectToString = __webpack_require__(464);

    /** `Object#toString` result references. */
    var nullTag = '[object Null]',
      undefinedTag = '[object Undefined]';

    /** Built-in value references. */
    var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    }
    module.exports = baseGetTag;

    /***/
  }), ( /* 460 */
  /***/function (module, exports, __webpack_require__) {
    var baseGetTag = __webpack_require__(459),
      isObjectLike = __webpack_require__(211);

    /** `Object#toString` result references. */
    var argsTag = '[object Arguments]';

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }
    module.exports = baseIsArguments;

    /***/
  }), ( /* 461 */
  /***/function (module, exports, __webpack_require__) {
    /* WEBPACK VAR INJECTION */(function (global) {
      /** Detect free variable `global` from Node.js. */
      var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
      module.exports = freeGlobal;

      /* WEBPACK VAR INJECTION */
    }).call(exports, __webpack_require__(80));

    /***/
  }), ( /* 462 */
  /***/function (module, exports, __webpack_require__) {
    var Symbol = __webpack_require__(135);

    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Built-in value references. */
    var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
        tag = value[symToStringTag];
      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}
      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }
    module.exports = getRawTag;

    /***/
  }), ( /* 463 */
  /***/function (module, exports, __webpack_require__) {
    var Symbol = __webpack_require__(135),
      isArguments = __webpack_require__(467),
      isArray = __webpack_require__(468);

    /** Built-in value references. */
    var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
    }
    module.exports = isFlattenable;

    /***/
  }), ( /* 464 */
  /***/function (module, exports) {
    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }
    module.exports = objectToString;

    /***/
  }), ( /* 465 */
  /***/function (module, exports, __webpack_require__) {
    var freeGlobal = __webpack_require__(461);

    /** Detect free variable `self`. */
    var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

    /** Used as a reference to the global object. */
    var root = freeGlobal || freeSelf || Function('return this')();
    module.exports = root;

    /***/
  }), ( /* 466 */
  /***/function (module, exports, __webpack_require__) {
    var baseFlatten = __webpack_require__(458);

    /** Used as references for various `Number` constants. */
    var INFINITY = 1 / 0;

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }
    module.exports = flattenDeep;

    /***/
  }), ( /* 467 */
  /***/function (module, exports, __webpack_require__) {
    var baseIsArguments = __webpack_require__(460),
      isObjectLike = __webpack_require__(211);

    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Built-in value references. */
    var propertyIsEnumerable = objectProto.propertyIsEnumerable;

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function () {
      return arguments;
    }()) ? baseIsArguments : function (value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
    };
    module.exports = isArguments;

    /***/
  }), ( /* 468 */
  /***/function (module, exports) {
    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;
    module.exports = isArray;

    /***/
  }), ( /* 469 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    module.exports = __webpack_require__(475);

    /***/
  }), ( /* 470 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // List of valid html blocks names, accorting to commonmark spec
    // http://jgm.github.io/CommonMark/spec.html#html-blocks
    module.exports = ['address', 'article', 'aside', 'base', 'basefont', 'blockquote', 'body', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dialog', 'dir', 'div', 'dl', 'dt', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hr', 'html', 'iframe', 'legend', 'li', 'link', 'main', 'menu', 'menuitem', 'meta', 'nav', 'noframes', 'ol', 'optgroup', 'option', 'p', 'param', 'section', 'source', 'summary', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul'];

    /***/
  }), ( /* 471 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Just a shortcut for bulk export
    exports.parseLinkLabel = __webpack_require__(473);
    exports.parseLinkDestination = __webpack_require__(472);
    exports.parseLinkTitle = __webpack_require__(474);

    /***/
  }), ( /* 472 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Parse link destination
    //
    var isSpace = __webpack_require__(1).isSpace;
    var unescapeAll = __webpack_require__(1).unescapeAll;
    module.exports = function parseLinkDestination(str, pos, max) {
      var code,
        level,
        lines = 0,
        start = pos,
        result = {
          ok: false,
          pos: 0,
          lines: 0,
          str: ''
        };
      if (str.charCodeAt(pos) === 0x3C /* < */) {
        pos++;
        while (pos < max) {
          code = str.charCodeAt(pos);
          if (code === 0x0A /* \n */ || isSpace(code)) {
            return result;
          }
          if (code === 0x3E /* > */) {
            result.pos = pos + 1;
            result.str = unescapeAll(str.slice(start + 1, pos));
            result.ok = true;
            return result;
          }
          if (code === 0x5C /* \ */ && pos + 1 < max) {
            pos += 2;
            continue;
          }
          pos++;
        }

        // no closing '>'
        return result;
      }

      // this should be ... } else { ... branch

      level = 0;
      while (pos < max) {
        code = str.charCodeAt(pos);
        if (code === 0x20) {
          break;
        }

        // ascii control characters
        if (code < 0x20 || code === 0x7F) {
          break;
        }
        if (code === 0x5C /* \ */ && pos + 1 < max) {
          pos += 2;
          continue;
        }
        if (code === 0x28 /* ( */) {
          level++;
        }
        if (code === 0x29 /* ) */) {
          if (level === 0) {
            break;
          }
          level--;
        }
        pos++;
      }
      if (start === pos) {
        return result;
      }
      if (level !== 0) {
        return result;
      }
      result.str = unescapeAll(str.slice(start, pos));
      result.lines = lines;
      result.pos = pos;
      result.ok = true;
      return result;
    };

    /***/
  }), ( /* 473 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Parse link label
    //
    // this function assumes that first character ("[") already matches;
    // returns the end of the label
    //
    module.exports = function parseLinkLabel(state, start, disableNested) {
      var level,
        found,
        marker,
        prevPos,
        labelEnd = -1,
        max = state.posMax,
        oldPos = state.pos;
      state.pos = start + 1;
      level = 1;
      while (state.pos < max) {
        marker = state.src.charCodeAt(state.pos);
        if (marker === 0x5D /* ] */) {
          level--;
          if (level === 0) {
            found = true;
            break;
          }
        }
        prevPos = state.pos;
        state.md.inline.skipToken(state);
        if (marker === 0x5B /* [ */) {
          if (prevPos === state.pos - 1) {
            // increase level if we find text `[`, which is not a part of any token
            level++;
          } else if (disableNested) {
            state.pos = oldPos;
            return -1;
          }
        }
      }
      if (found) {
        labelEnd = state.pos;
      }

      // restore old state
      state.pos = oldPos;
      return labelEnd;
    };

    /***/
  }), ( /* 474 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Parse link title
    //
    var unescapeAll = __webpack_require__(1).unescapeAll;
    module.exports = function parseLinkTitle(str, pos, max) {
      var code,
        marker,
        lines = 0,
        start = pos,
        result = {
          ok: false,
          pos: 0,
          lines: 0,
          str: ''
        };
      if (pos >= max) {
        return result;
      }
      marker = str.charCodeAt(pos);
      if (marker !== 0x22 /* " */ && marker !== 0x27 /* ' */ && marker !== 0x28 /* ( */) {
        return result;
      }
      pos++;

      // if opening marker is "(", switch it to closing marker ")"
      if (marker === 0x28) {
        marker = 0x29;
      }
      while (pos < max) {
        code = str.charCodeAt(pos);
        if (code === marker) {
          result.pos = pos + 1;
          result.lines = lines;
          result.str = unescapeAll(str.slice(start + 1, pos));
          result.ok = true;
          return result;
        } else if (code === 0x0A) {
          lines++;
        } else if (code === 0x5C /* \ */ && pos + 1 < max) {
          pos++;
          if (str.charCodeAt(pos) === 0x0A) {
            lines++;
          }
        }
        pos++;
      }
      return result;
    };

    /***/
  }), ( /* 475 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Main parser class
    var utils = __webpack_require__(1);
    var helpers = __webpack_require__(471);
    var Renderer = __webpack_require__(482);
    var ParserCore = __webpack_require__(477);
    var ParserBlock = __webpack_require__(476);
    var ParserInline = __webpack_require__(478);
    var LinkifyIt = __webpack_require__(455);
    var mdurl = __webpack_require__(216);
    var punycode = __webpack_require__(520);
    var config = {
      'default': __webpack_require__(480),
      zero: __webpack_require__(481),
      commonmark: __webpack_require__(479)
    };

    ////////////////////////////////////////////////////////////////////////////////
    //
    // This validator can prohibit more than really needed to prevent XSS. It's a
    // tradeoff to keep code simple and to be secure by default.
    //
    // If you need different setup - override validator method as you wish. Or
    // replace it with dummy function and use external sanitizer.
    //

    var BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
    var GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;
    function validateLink(url) {
      // url should be normalized at this point, and existing entities are decoded
      var str = url.trim().toLowerCase();
      return BAD_PROTO_RE.test(str) ? GOOD_DATA_RE.test(str) ? true : false : true;
    }

    ////////////////////////////////////////////////////////////////////////////////

    var RECODE_HOSTNAME_FOR = ['http:', 'https:', 'mailto:'];
    function normalizeLink(url) {
      var parsed = mdurl.parse(url, true);
      if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) {
          try {
            parsed.hostname = punycode.toASCII(parsed.hostname);
          } catch (er) {/**/}
        }
      }
      return mdurl.encode(mdurl.format(parsed));
    }
    function normalizeLinkText(url) {
      var parsed = mdurl.parse(url, true);
      if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) {
          try {
            parsed.hostname = punycode.toUnicode(parsed.hostname);
          } catch (er) {/**/}
        }
      }
      return mdurl.decode(mdurl.format(parsed));
    }

    /**
     * class MarkdownIt
     *
     * Main parser/renderer class.
     *
     * ##### Usage
     *
     * ```javascript
     * // node.js, "classic" way:
     * var MarkdownIt = require('markdown-it'),
     *     md = new MarkdownIt();
     * var result = md.render('# markdown-it rulezz!');
     *
     * // node.js, the same, but with sugar:
     * var md = require('markdown-it')();
     * var result = md.render('# markdown-it rulezz!');
     *
     * // browser without AMD, added to "window" on script load
     * // Note, there are no dash.
     * var md = window.markdownit();
     * var result = md.render('# markdown-it rulezz!');
     * ```
     *
     * Single line rendering, without paragraph wrap:
     *
     * ```javascript
     * var md = require('markdown-it')();
     * var result = md.renderInline('__markdown-it__ rulezz!');
     * ```
     **/

    /**
     * new MarkdownIt([presetName, options])
     * - presetName (String): optional, `commonmark` / `zero`
     * - options (Object)
     *
     * Creates parser instanse with given config. Can be called without `new`.
     *
     * ##### presetName
     *
     * MarkdownIt provides named presets as a convenience to quickly
     * enable/disable active syntax rules and options for common use cases.
     *
     * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.js) -
     *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
     * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.js) -
     *   similar to GFM, used when no preset name given. Enables all available rules,
     *   but still without html, typographer & autolinker.
     * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.js) -
     *   all rules disabled. Useful to quickly setup your config via `.enable()`.
     *   For example, when you need only `bold` and `italic` markup and nothing else.
     *
     * ##### options:
     *
     * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
     *   That's not safe! You may need external sanitizer to protect output from XSS.
     *   It's better to extend features via plugins, instead of enabling HTML.
     * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
     *   (`<br />`). This is needed only for full CommonMark compatibility. In real
     *   world you will need HTML output.
     * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
     * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
     *   Can be useful for external highlighters.
     * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
     * - __typographer__  - `false`. Set `true` to enable [some language-neutral
     *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.js) +
     *   quotes beautification (smartquotes).
     * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
     *   pairs, when typographer enabled and smartquotes on. For example, you can
     *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
     *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
     * - __highlight__ - `null`. Highlighter function for fenced code blocks.
     *   Highlighter `function (str, lang)` should return escaped HTML. It can also
     *   return empty string if the source was not changed and should be escaped
     *   externaly. If result starts with <pre... internal wrapper is skipped.
     *
     * ##### Example
     *
     * ```javascript
     * // commonmark mode
     * var md = require('markdown-it')('commonmark');
     *
     * // default mode
     * var md = require('markdown-it')();
     *
     * // enable everything
     * var md = require('markdown-it')({
     *   html: true,
     *   linkify: true,
     *   typographer: true
     * });
     * ```
     *
     * ##### Syntax highlighting
     *
     * ```js
     * var hljs = require('highlight.js') // https://highlightjs.org/
     *
     * var md = require('markdown-it')({
     *   highlight: function (str, lang) {
     *     if (lang && hljs.getLanguage(lang)) {
     *       try {
     *         return hljs.highlight(lang, str, true).value;
     *       } catch (__) {}
     *     }
     *
     *     return ''; // use external default escaping
     *   }
     * });
     * ```
     *
     * Or with full wrapper override (if you need assign class to `<pre>`):
     *
     * ```javascript
     * var hljs = require('highlight.js') // https://highlightjs.org/
     *
     * // Actual default values
     * var md = require('markdown-it')({
     *   highlight: function (str, lang) {
     *     if (lang && hljs.getLanguage(lang)) {
     *       try {
     *         return '<pre class="hljs"><code>' +
     *                hljs.highlight(lang, str, true).value +
     *                '</code></pre>';
     *       } catch (__) {}
     *     }
     *
     *     return '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + '</code></pre>';
     *   }
     * });
     * ```
     *
     **/
    function MarkdownIt(presetName, options) {
      if (!(this instanceof MarkdownIt)) {
        return new MarkdownIt(presetName, options);
      }
      if (!options) {
        if (!utils.isString(presetName)) {
          options = presetName || {};
          presetName = 'default';
        }
      }

      /**
       * MarkdownIt#inline -> ParserInline
       *
       * Instance of [[ParserInline]]. You may need it to add new rules when
       * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
       * [[MarkdownIt.enable]].
       **/
      this.inline = new ParserInline();

      /**
       * MarkdownIt#block -> ParserBlock
       *
       * Instance of [[ParserBlock]]. You may need it to add new rules when
       * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
       * [[MarkdownIt.enable]].
       **/
      this.block = new ParserBlock();

      /**
       * MarkdownIt#core -> Core
       *
       * Instance of [[Core]] chain executor. You may need it to add new rules when
       * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
       * [[MarkdownIt.enable]].
       **/
      this.core = new ParserCore();

      /**
       * MarkdownIt#renderer -> Renderer
       *
       * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
       * rules for new token types, generated by plugins.
       *
       * ##### Example
       *
       * ```javascript
       * var md = require('markdown-it')();
       *
       * function myToken(tokens, idx, options, env, self) {
       *   //...
       *   return result;
       * };
       *
       * md.renderer.rules['my_token'] = myToken
       * ```
       *
       * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js).
       **/
      this.renderer = new Renderer();

      /**
       * MarkdownIt#linkify -> LinkifyIt
       *
       * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
       * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js)
       * rule.
       **/
      this.linkify = new LinkifyIt();

      /**
       * MarkdownIt#validateLink(url) -> Boolean
       *
       * Link validation function. CommonMark allows too much in links. By default
       * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
       * except some embedded image types.
       *
       * You can change this behaviour:
       *
       * ```javascript
       * var md = require('markdown-it')();
       * // enable everything
       * md.validateLink = function () { return true; }
       * ```
       **/
      this.validateLink = validateLink;

      /**
       * MarkdownIt#normalizeLink(url) -> String
       *
       * Function used to encode link url to a machine-readable format,
       * which includes url-encoding, punycode, etc.
       **/
      this.normalizeLink = normalizeLink;

      /**
       * MarkdownIt#normalizeLinkText(url) -> String
       *
       * Function used to decode link url to a human-readable format`
       **/
      this.normalizeLinkText = normalizeLinkText;

      // Expose utils & helpers for easy acces from plugins

      /**
       * MarkdownIt#utils -> utils
       *
       * Assorted utility functions, useful to write plugins. See details
       * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.js).
       **/
      this.utils = utils;

      /**
       * MarkdownIt#helpers -> helpers
       *
       * Link components parser functions, useful to write plugins. See details
       * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
       **/
      this.helpers = utils.assign({}, helpers);
      this.options = {};
      this.configure(presetName);
      if (options) {
        this.set(options);
      }
    }

    /** chainable
     * MarkdownIt.set(options)
     *
     * Set parser options (in the same format as in constructor). Probably, you
     * will never need it, but you can change options after constructor call.
     *
     * ##### Example
     *
     * ```javascript
     * var md = require('markdown-it')()
     *             .set({ html: true, breaks: true })
     *             .set({ typographer, true });
     * ```
     *
     * __Note:__ To achieve the best possible performance, don't modify a
     * `markdown-it` instance options on the fly. If you need multiple configurations
     * it's best to create multiple instances and initialize each with separate
     * config.
     **/
    MarkdownIt.prototype.set = function (options) {
      utils.assign(this.options, options);
      return this;
    };

    /** chainable, internal
     * MarkdownIt.configure(presets)
     *
     * Batch load of all options and compenent settings. This is internal method,
     * and you probably will not need it. But if you with - see available presets
     * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
     *
     * We strongly recommend to use presets instead of direct config loads. That
     * will give better compatibility with next versions.
     **/
    MarkdownIt.prototype.configure = function (presets) {
      var self = this,
        presetName;
      if (utils.isString(presets)) {
        presetName = presets;
        presets = config[presetName];
        if (!presets) {
          throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name');
        }
      }
      if (!presets) {
        throw new Error('Wrong `markdown-it` preset, can\'t be empty');
      }
      if (presets.options) {
        self.set(presets.options);
      }
      if (presets.components) {
        Object.keys(presets.components).forEach(function (name) {
          if (presets.components[name].rules) {
            self[name].ruler.enableOnly(presets.components[name].rules);
          }
          if (presets.components[name].rules2) {
            self[name].ruler2.enableOnly(presets.components[name].rules2);
          }
        });
      }
      return this;
    };

    /** chainable
     * MarkdownIt.enable(list, ignoreInvalid)
     * - list (String|Array): rule name or list of rule names to enable
     * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
     *
     * Enable list or rules. It will automatically find appropriate components,
     * containing rules with given names. If rule not found, and `ignoreInvalid`
     * not set - throws exception.
     *
     * ##### Example
     *
     * ```javascript
     * var md = require('markdown-it')()
     *             .enable(['sub', 'sup'])
     *             .disable('smartquotes');
     * ```
     **/
    MarkdownIt.prototype.enable = function (list, ignoreInvalid) {
      var result = [];
      if (!Array.isArray(list)) {
        list = [list];
      }
      ['core', 'block', 'inline'].forEach(function (chain) {
        result = result.concat(this[chain].ruler.enable(list, true));
      }, this);
      result = result.concat(this.inline.ruler2.enable(list, true));
      var missed = list.filter(function (name) {
        return result.indexOf(name) < 0;
      });
      if (missed.length && !ignoreInvalid) {
        throw new Error('MarkdownIt. Failed to enable unknown rule(s): ' + missed);
      }
      return this;
    };

    /** chainable
     * MarkdownIt.disable(list, ignoreInvalid)
     * - list (String|Array): rule name or list of rule names to disable.
     * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
     *
     * The same as [[MarkdownIt.enable]], but turn specified rules off.
     **/
    MarkdownIt.prototype.disable = function (list, ignoreInvalid) {
      var result = [];
      if (!Array.isArray(list)) {
        list = [list];
      }
      ['core', 'block', 'inline'].forEach(function (chain) {
        result = result.concat(this[chain].ruler.disable(list, true));
      }, this);
      result = result.concat(this.inline.ruler2.disable(list, true));
      var missed = list.filter(function (name) {
        return result.indexOf(name) < 0;
      });
      if (missed.length && !ignoreInvalid) {
        throw new Error('MarkdownIt. Failed to disable unknown rule(s): ' + missed);
      }
      return this;
    };

    /** chainable
     * MarkdownIt.use(plugin, params)
     *
     * Load specified plugin with given params into current parser instance.
     * It's just a sugar to call `plugin(md, params)` with curring.
     *
     * ##### Example
     *
     * ```javascript
     * var iterator = require('markdown-it-for-inline');
     * var md = require('markdown-it')()
     *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
     *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
     *             });
     * ```
     **/
    MarkdownIt.prototype.use = function (plugin /*, params, ... */) {
      var args = [this].concat(Array.prototype.slice.call(arguments, 1));
      plugin.apply(plugin, args);
      return this;
    };

    /** internal
     * MarkdownIt.parse(src, env) -> Array
     * - src (String): source string
     * - env (Object): environment sandbox
     *
     * Parse input string and returns list of block tokens (special token type
     * "inline" will contain list of inline tokens). You should not call this
     * method directly, until you write custom renderer (for example, to produce
     * AST).
     *
     * `env` is used to pass data between "distributed" rules and return additional
     * metadata like reference info, needed for the renderer. It also can be used to
     * inject data in specific cases. Usually, you will be ok to pass `{}`,
     * and then pass updated object to renderer.
     **/
    MarkdownIt.prototype.parse = function (src, env) {
      if (typeof src !== 'string') {
        throw new Error('Input data should be a String');
      }
      var state = new this.core.State(src, this, env);
      this.core.process(state);
      return state.tokens;
    };

    /**
     * MarkdownIt.render(src [, env]) -> String
     * - src (String): source string
     * - env (Object): environment sandbox
     *
     * Render markdown string into html. It does all magic for you :).
     *
     * `env` can be used to inject additional metadata (`{}` by default).
     * But you will not need it with high probability. See also comment
     * in [[MarkdownIt.parse]].
     **/
    MarkdownIt.prototype.render = function (src, env) {
      env = env || {};
      return this.renderer.render(this.parse(src, env), this.options, env);
    };

    /** internal
     * MarkdownIt.parseInline(src, env) -> Array
     * - src (String): source string
     * - env (Object): environment sandbox
     *
     * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
     * block tokens list with the single `inline` element, containing parsed inline
     * tokens in `children` property. Also updates `env` object.
     **/
    MarkdownIt.prototype.parseInline = function (src, env) {
      var state = new this.core.State(src, this, env);
      state.inlineMode = true;
      this.core.process(state);
      return state.tokens;
    };

    /**
     * MarkdownIt.renderInline(src [, env]) -> String
     * - src (String): source string
     * - env (Object): environment sandbox
     *
     * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
     * will NOT be wrapped into `<p>` tags.
     **/
    MarkdownIt.prototype.renderInline = function (src, env) {
      env = env || {};
      return this.renderer.render(this.parseInline(src, env), this.options, env);
    };
    module.exports = MarkdownIt;

    /***/
  }), ( /* 476 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    /** internal
     * class ParserBlock
     *
     * Block-level tokenizer.
     **/
    var Ruler = __webpack_require__(136);
    var _rules = [
    // First 2 params - rule name & source. Secondary array - list of rules,
    // which can be terminated by this one.
    ['table', __webpack_require__(494), ['paragraph', 'reference']], ['code', __webpack_require__(484)], ['fence', __webpack_require__(485), ['paragraph', 'reference', 'blockquote', 'list']], ['blockquote', __webpack_require__(483), ['paragraph', 'reference', 'blockquote', 'list']], ['hr', __webpack_require__(487), ['paragraph', 'reference', 'blockquote', 'list']], ['list', __webpack_require__(490), ['paragraph', 'reference', 'blockquote']], ['reference', __webpack_require__(492)], ['heading', __webpack_require__(486), ['paragraph', 'reference', 'blockquote']], ['lheading', __webpack_require__(489)], ['html_block', __webpack_require__(488), ['paragraph', 'reference', 'blockquote']], ['paragraph', __webpack_require__(491)]];

    /**
     * new ParserBlock()
     **/
    function ParserBlock() {
      /**
       * ParserBlock#ruler -> Ruler
       *
       * [[Ruler]] instance. Keep configuration of block rules.
       **/
      this.ruler = new Ruler();
      for (var i = 0; i < _rules.length; i++) {
        this.ruler.push(_rules[i][0], _rules[i][1], {
          alt: (_rules[i][2] || []).slice()
        });
      }
    }

    // Generate tokens for input range
    //
    ParserBlock.prototype.tokenize = function (state, startLine, endLine) {
      var ok,
        i,
        rules = this.ruler.getRules(''),
        len = rules.length,
        line = startLine,
        hasEmptyLines = false,
        maxNesting = state.md.options.maxNesting;
      while (line < endLine) {
        state.line = line = state.skipEmptyLines(line);
        if (line >= endLine) {
          break;
        }

        // Termination condition for nested calls.
        // Nested calls currently used for blockquotes & lists
        if (state.sCount[line] < state.blkIndent) {
          break;
        }

        // If nesting level exceeded - skip tail to the end. That's not ordinary
        // situation and we should not care about content.
        if (state.level >= maxNesting) {
          state.line = endLine;
          break;
        }

        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.line`
        // - update `state.tokens`
        // - return true

        for (i = 0; i < len; i++) {
          ok = rules[i](state, line, endLine, false);
          if (ok) {
            break;
          }
        }

        // set state.tight if we had an empty line before current tag
        // i.e. latest empty line should not count
        state.tight = !hasEmptyLines;

        // paragraph might "eat" one newline after it in nested lists
        if (state.isEmpty(state.line - 1)) {
          hasEmptyLines = true;
        }
        line = state.line;
        if (line < endLine && state.isEmpty(line)) {
          hasEmptyLines = true;
          line++;
          state.line = line;
        }
      }
    };

    /**
     * ParserBlock.parse(str, md, env, outTokens)
     *
     * Process input string and push block tokens into `outTokens`
     **/
    ParserBlock.prototype.parse = function (src, md, env, outTokens) {
      var state;
      if (!src) {
        return;
      }
      state = new this.State(src, md, env, outTokens);
      this.tokenize(state, state.line, state.lineMax);
    };
    ParserBlock.prototype.State = __webpack_require__(493);
    module.exports = ParserBlock;

    /***/
  }), ( /* 477 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    /** internal
     * class Core
     *
     * Top-level rules executor. Glues block/inline parsers and does intermediate
     * transformations.
     **/
    var Ruler = __webpack_require__(136);
    var _rules = [['normalize', __webpack_require__(498)], ['block', __webpack_require__(495)], ['inline', __webpack_require__(496)], ['linkify', __webpack_require__(497)], ['replacements', __webpack_require__(499)], ['smartquotes', __webpack_require__(500)]];

    /**
     * new Core()
     **/
    function Core() {
      /**
       * Core#ruler -> Ruler
       *
       * [[Ruler]] instance. Keep configuration of core rules.
       **/
      this.ruler = new Ruler();
      for (var i = 0; i < _rules.length; i++) {
        this.ruler.push(_rules[i][0], _rules[i][1]);
      }
    }

    /**
     * Core.process(state)
     *
     * Executes core chain rules.
     **/
    Core.prototype.process = function (state) {
      var i, l, rules;
      rules = this.ruler.getRules('');
      for (i = 0, l = rules.length; i < l; i++) {
        rules[i](state);
      }
    };
    Core.prototype.State = __webpack_require__(501);
    module.exports = Core;

    /***/
  }), ( /* 478 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    /** internal
     * class ParserInline
     *
     * Tokenizes paragraph content.
     **/
    var Ruler = __webpack_require__(136);

    ////////////////////////////////////////////////////////////////////////////////
    // Parser rules

    var _rules = [['text', __webpack_require__(512)], ['newline', __webpack_require__(510)], ['escape', __webpack_require__(506)], ['backticks', __webpack_require__(503)], ['strikethrough', __webpack_require__(215).tokenize], ['emphasis', __webpack_require__(214).tokenize], ['link', __webpack_require__(509)], ['image', __webpack_require__(508)], ['autolink', __webpack_require__(502)], ['html_inline', __webpack_require__(507)], ['entity', __webpack_require__(505)]];
    var _rules2 = [['balance_pairs', __webpack_require__(504)], ['strikethrough', __webpack_require__(215).postProcess], ['emphasis', __webpack_require__(214).postProcess], ['text_collapse', __webpack_require__(513)]];

    /**
     * new ParserInline()
     **/
    function ParserInline() {
      var i;

      /**
       * ParserInline#ruler -> Ruler
       *
       * [[Ruler]] instance. Keep configuration of inline rules.
       **/
      this.ruler = new Ruler();
      for (i = 0; i < _rules.length; i++) {
        this.ruler.push(_rules[i][0], _rules[i][1]);
      }

      /**
       * ParserInline#ruler2 -> Ruler
       *
       * [[Ruler]] instance. Second ruler used for post-processing
       * (e.g. in emphasis-like rules).
       **/
      this.ruler2 = new Ruler();
      for (i = 0; i < _rules2.length; i++) {
        this.ruler2.push(_rules2[i][0], _rules2[i][1]);
      }
    }

    // Skip single token by running all rules in validation mode;
    // returns `true` if any rule reported success
    //
    ParserInline.prototype.skipToken = function (state) {
      var ok,
        i,
        pos = state.pos,
        rules = this.ruler.getRules(''),
        len = rules.length,
        maxNesting = state.md.options.maxNesting,
        cache = state.cache;
      if (typeof cache[pos] !== 'undefined') {
        state.pos = cache[pos];
        return;
      }
      if (state.level < maxNesting) {
        for (i = 0; i < len; i++) {
          // Increment state.level and decrement it later to limit recursion.
          // It's harmless to do here, because no tokens are created. But ideally,
          // we'd need a separate private state variable for this purpose.
          //
          state.level++;
          ok = rules[i](state, true);
          state.level--;
          if (ok) {
            break;
          }
        }
      } else {
        // Too much nesting, just skip until the end of the paragraph.
        //
        // NOTE: this will cause links to behave incorrectly in the following case,
        //       when an amount of `[` is exactly equal to `maxNesting + 1`:
        //
        //       [[[[[[[[[[[[[[[[[[[[[foo]()
        //
        // TODO: remove this workaround when CM standard will allow nested links
        //       (we can replace it by preventing links from being parsed in
        //       validation mode)
        //
        state.pos = state.posMax;
      }
      if (!ok) {
        state.pos++;
      }
      cache[pos] = state.pos;
    };

    // Generate tokens for input range
    //
    ParserInline.prototype.tokenize = function (state) {
      var ok,
        i,
        rules = this.ruler.getRules(''),
        len = rules.length,
        end = state.posMax,
        maxNesting = state.md.options.maxNesting;
      while (state.pos < end) {
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.pos`
        // - update `state.tokens`
        // - return true

        if (state.level < maxNesting) {
          for (i = 0; i < len; i++) {
            ok = rules[i](state, false);
            if (ok) {
              break;
            }
          }
        }
        if (ok) {
          if (state.pos >= end) {
            break;
          }
          continue;
        }
        state.pending += state.src[state.pos++];
      }
      if (state.pending) {
        state.pushPending();
      }
    };

    /**
     * ParserInline.parse(str, md, env, outTokens)
     *
     * Process input string and push inline tokens into `outTokens`
     **/
    ParserInline.prototype.parse = function (str, md, env, outTokens) {
      var i, rules, len;
      var state = new this.State(str, md, env, outTokens);
      this.tokenize(state);
      rules = this.ruler2.getRules('');
      len = rules.length;
      for (i = 0; i < len; i++) {
        rules[i](state);
      }
    };
    ParserInline.prototype.State = __webpack_require__(511);
    module.exports = ParserInline;

    /***/
  }), ( /* 479 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Commonmark default options
    module.exports = {
      options: {
        html: true,
        // Enable HTML tags in source
        xhtmlOut: true,
        // Use '/' to close single tags (<br />)
        breaks: false,
        // Convert '\n' in paragraphs into <br>
        langPrefix: 'language-',
        // CSS language prefix for fenced blocks
        linkify: false,
        // autoconvert URL-like texts to links

        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "\u201C\u201D\u2018\u2019",
        /* “”‘’ */

        // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
      },
      components: {
        core: {
          rules: ['normalize', 'block', 'inline']
        },
        block: {
          rules: ['blockquote', 'code', 'fence', 'heading', 'hr', 'html_block', 'lheading', 'list', 'reference', 'paragraph']
        },
        inline: {
          rules: ['autolink', 'backticks', 'emphasis', 'entity', 'escape', 'html_inline', 'image', 'link', 'newline', 'text'],
          rules2: ['balance_pairs', 'emphasis', 'text_collapse']
        }
      }
    };

    /***/
  }), ( /* 480 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // markdown-it default options
    module.exports = {
      options: {
        html: false,
        // Enable HTML tags in source
        xhtmlOut: false,
        // Use '/' to close single tags (<br />)
        breaks: false,
        // Convert '\n' in paragraphs into <br>
        langPrefix: 'language-',
        // CSS language prefix for fenced blocks
        linkify: false,
        // autoconvert URL-like texts to links

        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "\u201C\u201D\u2018\u2019",
        /* “”‘’ */

        // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 100 // Internal protection, recursion limit
      },
      components: {
        core: {},
        block: {},
        inline: {}
      }
    };

    /***/
  }), ( /* 481 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // "Zero" preset, with nothing enabled. Useful for manual configuring of simple
    // modes. For example, to parse bold/italic only.
    module.exports = {
      options: {
        html: false,
        // Enable HTML tags in source
        xhtmlOut: false,
        // Use '/' to close single tags (<br />)
        breaks: false,
        // Convert '\n' in paragraphs into <br>
        langPrefix: 'language-',
        // CSS language prefix for fenced blocks
        linkify: false,
        // autoconvert URL-like texts to links

        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "\u201C\u201D\u2018\u2019",
        /* “”‘’ */

        // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
      },
      components: {
        core: {
          rules: ['normalize', 'block', 'inline']
        },
        block: {
          rules: ['paragraph']
        },
        inline: {
          rules: ['text'],
          rules2: ['balance_pairs', 'text_collapse']
        }
      }
    };

    /***/
  }), ( /* 482 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    /**
     * class Renderer
     *
     * Generates HTML from parsed token stream. Each instance has independent
     * copy of rules. Those can be rewritten with ease. Also, you can add new
     * rules if you create plugin and adds new token types.
     **/
    var assign = __webpack_require__(1).assign;
    var unescapeAll = __webpack_require__(1).unescapeAll;
    var escapeHtml = __webpack_require__(1).escapeHtml;

    ////////////////////////////////////////////////////////////////////////////////

    var default_rules = {};
    default_rules.code_inline = function (tokens, idx, options, env, slf) {
      var token = tokens[idx];
      return '<code' + slf.renderAttrs(token) + '>' + escapeHtml(tokens[idx].content) + '</code>';
    };
    default_rules.code_block = function (tokens, idx, options, env, slf) {
      var token = tokens[idx];
      return '<pre' + slf.renderAttrs(token) + '><code>' + escapeHtml(tokens[idx].content) + '</code></pre>\n';
    };
    default_rules.fence = function (tokens, idx, options, env, slf) {
      var token = tokens[idx],
        info = token.info ? unescapeAll(token.info).trim() : '',
        langName = '',
        highlighted,
        i,
        tmpAttrs,
        tmpToken;
      if (info) {
        langName = info.split(/\s+/g)[0];
      }
      if (options.highlight) {
        highlighted = options.highlight(token.content, langName) || escapeHtml(token.content);
      } else {
        highlighted = escapeHtml(token.content);
      }
      if (highlighted.indexOf('<pre') === 0) {
        return highlighted + '\n';
      }

      // If language exists, inject class gently, without modifying original token.
      // May be, one day we will add .clone() for token and simplify this part, but
      // now we prefer to keep things local.
      if (info) {
        i = token.attrIndex('class');
        tmpAttrs = token.attrs ? token.attrs.slice() : [];
        if (i < 0) {
          tmpAttrs.push(['class', options.langPrefix + langName]);
        } else {
          tmpAttrs[i][1] += ' ' + options.langPrefix + langName;
        }

        // Fake token just to render attributes
        tmpToken = {
          attrs: tmpAttrs
        };
        return '<pre><code' + slf.renderAttrs(tmpToken) + '>' + highlighted + '</code></pre>\n';
      }
      return '<pre><code' + slf.renderAttrs(token) + '>' + highlighted + '</code></pre>\n';
    };
    default_rules.image = function (tokens, idx, options, env, slf) {
      var token = tokens[idx];

      // "alt" attr MUST be set, even if empty. Because it's mandatory and
      // should be placed on proper position for tests.
      //
      // Replace content with actual value

      token.attrs[token.attrIndex('alt')][1] = slf.renderInlineAsText(token.children, options, env);
      return slf.renderToken(tokens, idx, options);
    };
    default_rules.hardbreak = function (tokens, idx, options /*, env */) {
      return options.xhtmlOut ? '<br />\n' : '<br>\n';
    };
    default_rules.softbreak = function (tokens, idx, options /*, env */) {
      return options.breaks ? options.xhtmlOut ? '<br />\n' : '<br>\n' : '\n';
    };
    default_rules.text = function (tokens, idx /*, options, env */) {
      return escapeHtml(tokens[idx].content);
    };
    default_rules.html_block = function (tokens, idx /*, options, env */) {
      return tokens[idx].content;
    };
    default_rules.html_inline = function (tokens, idx /*, options, env */) {
      return tokens[idx].content;
    };

    /**
     * new Renderer()
     *
     * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
     **/
    function Renderer() {
      /**
       * Renderer#rules -> Object
       *
       * Contains render rules for tokens. Can be updated and extended.
       *
       * ##### Example
       *
       * ```javascript
       * var md = require('markdown-it')();
       *
       * md.renderer.rules.strong_open  = function () { return '<b>'; };
       * md.renderer.rules.strong_close = function () { return '</b>'; };
       *
       * var result = md.renderInline(...);
       * ```
       *
       * Each rule is called as independent static function with fixed signature:
       *
       * ```javascript
       * function my_token_render(tokens, idx, options, env, renderer) {
       *   // ...
       *   return renderedHTML;
       * }
       * ```
       *
       * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js)
       * for more details and examples.
       **/
      this.rules = assign({}, default_rules);
    }

    /**
     * Renderer.renderAttrs(token) -> String
     *
     * Render token attributes to string.
     **/
    Renderer.prototype.renderAttrs = function renderAttrs(token) {
      var i, l, result;
      if (!token.attrs) {
        return '';
      }
      result = '';
      for (i = 0, l = token.attrs.length; i < l; i++) {
        result += ' ' + escapeHtml(token.attrs[i][0]) + '="' + escapeHtml(token.attrs[i][1]) + '"';
      }
      return result;
    };

    /**
     * Renderer.renderToken(tokens, idx, options) -> String
     * - tokens (Array): list of tokens
     * - idx (Numbed): token index to render
     * - options (Object): params of parser instance
     *
     * Default token renderer. Can be overriden by custom function
     * in [[Renderer#rules]].
     **/
    Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
      var nextToken,
        result = '',
        needLf = false,
        token = tokens[idx];

      // Tight list paragraphs
      if (token.hidden) {
        return '';
      }

      // Insert a newline between hidden paragraph and subsequent opening
      // block-level tag.
      //
      // For example, here we should insert a newline before blockquote:
      //  - a
      //    >
      //
      if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) {
        result += '\n';
      }

      // Add token name, e.g. `<img`
      result += (token.nesting === -1 ? '</' : '<') + token.tag;

      // Encode attributes, e.g. `<img src="foo"`
      result += this.renderAttrs(token);

      // Add a slash for self-closing tags, e.g. `<img src="foo" /`
      if (token.nesting === 0 && options.xhtmlOut) {
        result += ' /';
      }

      // Check if we need to add a newline after this tag
      if (token.block) {
        needLf = true;
        if (token.nesting === 1) {
          if (idx + 1 < tokens.length) {
            nextToken = tokens[idx + 1];
            if (nextToken.type === 'inline' || nextToken.hidden) {
              // Block-level tag containing an inline tag.
              //
              needLf = false;
            } else if (nextToken.nesting === -1 && nextToken.tag === token.tag) {
              // Opening tag + closing tag of the same type. E.g. `<li></li>`.
              //
              needLf = false;
            }
          }
        }
      }
      result += needLf ? '>\n' : '>';
      return result;
    };

    /**
     * Renderer.renderInline(tokens, options, env) -> String
     * - tokens (Array): list on block tokens to renter
     * - options (Object): params of parser instance
     * - env (Object): additional data from parsed input (references, for example)
     *
     * The same as [[Renderer.render]], but for single token of `inline` type.
     **/
    Renderer.prototype.renderInline = function (tokens, options, env) {
      var type,
        result = '',
        rules = this.rules;
      for (var i = 0, len = tokens.length; i < len; i++) {
        type = tokens[i].type;
        if (typeof rules[type] !== 'undefined') {
          result += rules[type](tokens, i, options, env, this);
        } else {
          result += this.renderToken(tokens, i, options);
        }
      }
      return result;
    };

    /** internal
     * Renderer.renderInlineAsText(tokens, options, env) -> String
     * - tokens (Array): list on block tokens to renter
     * - options (Object): params of parser instance
     * - env (Object): additional data from parsed input (references, for example)
     *
     * Special kludge for image `alt` attributes to conform CommonMark spec.
     * Don't try to use it! Spec requires to show `alt` content with stripped markup,
     * instead of simple escaping.
     **/
    Renderer.prototype.renderInlineAsText = function (tokens, options, env) {
      var result = '';
      for (var i = 0, len = tokens.length; i < len; i++) {
        if (tokens[i].type === 'text') {
          result += tokens[i].content;
        } else if (tokens[i].type === 'image') {
          result += this.renderInlineAsText(tokens[i].children, options, env);
        }
      }
      return result;
    };

    /**
     * Renderer.render(tokens, options, env) -> String
     * - tokens (Array): list on block tokens to renter
     * - options (Object): params of parser instance
     * - env (Object): additional data from parsed input (references, for example)
     *
     * Takes token stream and generates HTML. Probably, you will never need to call
     * this method directly.
     **/
    Renderer.prototype.render = function (tokens, options, env) {
      var i,
        len,
        type,
        result = '',
        rules = this.rules;
      for (i = 0, len = tokens.length; i < len; i++) {
        type = tokens[i].type;
        if (type === 'inline') {
          result += this.renderInline(tokens[i].children, options, env);
        } else if (typeof rules[type] !== 'undefined') {
          result += rules[tokens[i].type](tokens, i, options, env, this);
        } else {
          result += this.renderToken(tokens, i, options, env);
        }
      }
      return result;
    };
    module.exports = Renderer;

    /***/
  }), ( /* 483 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Block quotes
    var isSpace = __webpack_require__(1).isSpace;
    module.exports = function blockquote(state, startLine, endLine, silent) {
      var adjustTab,
        ch,
        i,
        initial,
        l,
        lastLineEmpty,
        lines,
        nextLine,
        offset,
        oldBMarks,
        oldBSCount,
        oldIndent,
        oldParentType,
        oldSCount,
        oldTShift,
        spaceAfterMarker,
        terminate,
        terminatorRules,
        token,
        wasOutdented,
        oldLineMax = state.lineMax,
        pos = state.bMarks[startLine] + state.tShift[startLine],
        max = state.eMarks[startLine];

      // if it's indented more than 3 spaces, it should be a code block
      if (state.sCount[startLine] - state.blkIndent >= 4) {
        return false;
      }

      // check the block quote marker
      if (state.src.charCodeAt(pos++) !== 0x3E /* > */) {
        return false;
      }

      // we know that it's going to be a valid blockquote,
      // so no point trying to find the end of it in silent mode
      if (silent) {
        return true;
      }

      // skip spaces after ">" and re-calculate offset
      initial = offset = state.sCount[startLine] + pos - (state.bMarks[startLine] + state.tShift[startLine]);

      // skip one optional space after '>'
      if (state.src.charCodeAt(pos) === 0x20 /* space */) {
        // ' >   test '
        //     ^ -- position start of line here:
        pos++;
        initial++;
        offset++;
        adjustTab = false;
        spaceAfterMarker = true;
      } else if (state.src.charCodeAt(pos) === 0x09 /* tab */) {
        spaceAfterMarker = true;
        if ((state.bsCount[startLine] + offset) % 4 === 3) {
          // '  >\t  test '
          //       ^ -- position start of line here (tab has width===1)
          pos++;
          initial++;
          offset++;
          adjustTab = false;
        } else {
          // ' >\t  test '
          //    ^ -- position start of line here + shift bsCount slightly
          //         to make extra space appear
          adjustTab = true;
        }
      } else {
        spaceAfterMarker = false;
      }
      oldBMarks = [state.bMarks[startLine]];
      state.bMarks[startLine] = pos;
      while (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (isSpace(ch)) {
          if (ch === 0x09) {
            offset += 4 - (offset + state.bsCount[startLine] + (adjustTab ? 1 : 0)) % 4;
          } else {
            offset++;
          }
        } else {
          break;
        }
        pos++;
      }
      oldBSCount = [state.bsCount[startLine]];
      state.bsCount[startLine] = state.sCount[startLine] + 1 + (spaceAfterMarker ? 1 : 0);
      lastLineEmpty = pos >= max;
      oldSCount = [state.sCount[startLine]];
      state.sCount[startLine] = offset - initial;
      oldTShift = [state.tShift[startLine]];
      state.tShift[startLine] = pos - state.bMarks[startLine];
      terminatorRules = state.md.block.ruler.getRules('blockquote');
      oldParentType = state.parentType;
      state.parentType = 'blockquote';
      wasOutdented = false;

      // Search the end of the block
      //
      // Block ends with either:
      //  1. an empty line outside:
      //     ```
      //     > test
      //
      //     ```
      //  2. an empty line inside:
      //     ```
      //     >
      //     test
      //     ```
      //  3. another tag:
      //     ```
      //     > test
      //      - - -
      //     ```
      for (nextLine = startLine + 1; nextLine < endLine; nextLine++) {
        // check if it's outdented, i.e. it's inside list item and indented
        // less than said list item:
        //
        // ```
        // 1. anything
        //    > current blockquote
        // 2. checking this line
        // ```
        if (state.sCount[nextLine] < state.blkIndent) wasOutdented = true;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos >= max) {
          // Case 1: line is not inside the blockquote, and this line is empty.
          break;
        }
        if (state.src.charCodeAt(pos++) === 0x3E /* > */ && !wasOutdented) {
          // This line is inside the blockquote.

          // skip spaces after ">" and re-calculate offset
          initial = offset = state.sCount[nextLine] + pos - (state.bMarks[nextLine] + state.tShift[nextLine]);

          // skip one optional space after '>'
          if (state.src.charCodeAt(pos) === 0x20 /* space */) {
            // ' >   test '
            //     ^ -- position start of line here:
            pos++;
            initial++;
            offset++;
            adjustTab = false;
            spaceAfterMarker = true;
          } else if (state.src.charCodeAt(pos) === 0x09 /* tab */) {
            spaceAfterMarker = true;
            if ((state.bsCount[nextLine] + offset) % 4 === 3) {
              // '  >\t  test '
              //       ^ -- position start of line here (tab has width===1)
              pos++;
              initial++;
              offset++;
              adjustTab = false;
            } else {
              // ' >\t  test '
              //    ^ -- position start of line here + shift bsCount slightly
              //         to make extra space appear
              adjustTab = true;
            }
          } else {
            spaceAfterMarker = false;
          }
          oldBMarks.push(state.bMarks[nextLine]);
          state.bMarks[nextLine] = pos;
          while (pos < max) {
            ch = state.src.charCodeAt(pos);
            if (isSpace(ch)) {
              if (ch === 0x09) {
                offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
              } else {
                offset++;
              }
            } else {
              break;
            }
            pos++;
          }
          lastLineEmpty = pos >= max;
          oldBSCount.push(state.bsCount[nextLine]);
          state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);
          oldSCount.push(state.sCount[nextLine]);
          state.sCount[nextLine] = offset - initial;
          oldTShift.push(state.tShift[nextLine]);
          state.tShift[nextLine] = pos - state.bMarks[nextLine];
          continue;
        }

        // Case 2: line is not inside the blockquote, and the last line was empty.
        if (lastLineEmpty) {
          break;
        }

        // Case 3: another tag found.
        terminate = false;
        for (i = 0, l = terminatorRules.length; i < l; i++) {
          if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
          }
        }
        if (terminate) {
          // Quirk to enforce "hard termination mode" for paragraphs;
          // normally if you call `tokenize(state, startLine, nextLine)`,
          // paragraphs will look below nextLine for paragraph continuation,
          // but if blockquote is terminated by another tag, they shouldn't
          state.lineMax = nextLine;
          if (state.blkIndent !== 0) {
            // state.blkIndent was non-zero, we now set it to zero,
            // so we need to re-calculate all offsets to appear as
            // if indent wasn't changed
            oldBMarks.push(state.bMarks[nextLine]);
            oldBSCount.push(state.bsCount[nextLine]);
            oldTShift.push(state.tShift[nextLine]);
            oldSCount.push(state.sCount[nextLine]);
            state.sCount[nextLine] -= state.blkIndent;
          }
          break;
        }
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);

        // A negative indentation means that this is a paragraph continuation
        //
        state.sCount[nextLine] = -1;
      }
      oldIndent = state.blkIndent;
      state.blkIndent = 0;
      token = state.push('blockquote_open', 'blockquote', 1);
      token.markup = '>';
      token.map = lines = [startLine, 0];
      state.md.block.tokenize(state, startLine, nextLine);
      token = state.push('blockquote_close', 'blockquote', -1);
      token.markup = '>';
      state.lineMax = oldLineMax;
      state.parentType = oldParentType;
      lines[1] = state.line;

      // Restore original tShift; this might not be necessary since the parser
      // has already been here, but just to make sure we can do that.
      for (i = 0; i < oldTShift.length; i++) {
        state.bMarks[i + startLine] = oldBMarks[i];
        state.tShift[i + startLine] = oldTShift[i];
        state.sCount[i + startLine] = oldSCount[i];
        state.bsCount[i + startLine] = oldBSCount[i];
      }
      state.blkIndent = oldIndent;
      return true;
    };

    /***/
  }), ( /* 484 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Code block (4 spaces padded)
    module.exports = function code(state, startLine, endLine /*, silent*/) {
      var nextLine, last, token;
      if (state.sCount[startLine] - state.blkIndent < 4) {
        return false;
      }
      last = nextLine = startLine + 1;
      while (nextLine < endLine) {
        if (state.isEmpty(nextLine)) {
          nextLine++;
          continue;
        }
        if (state.sCount[nextLine] - state.blkIndent >= 4) {
          nextLine++;
          last = nextLine;
          continue;
        }
        break;
      }
      state.line = last;
      token = state.push('code_block', 'code', 0);
      token.content = state.getLines(startLine, last, 4 + state.blkIndent, true);
      token.map = [startLine, state.line];
      return true;
    };

    /***/
  }), ( /* 485 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // fences (``` lang, ~~~ lang)
    module.exports = function fence(state, startLine, endLine, silent) {
      var marker,
        len,
        params,
        nextLine,
        mem,
        token,
        markup,
        haveEndMarker = false,
        pos = state.bMarks[startLine] + state.tShift[startLine],
        max = state.eMarks[startLine];

      // if it's indented more than 3 spaces, it should be a code block
      if (state.sCount[startLine] - state.blkIndent >= 4) {
        return false;
      }
      if (pos + 3 > max) {
        return false;
      }
      marker = state.src.charCodeAt(pos);
      if (marker !== 0x7E /* ~ */ && marker !== 0x60 /* ` */) {
        return false;
      }

      // scan marker length
      mem = pos;
      pos = state.skipChars(pos, marker);
      len = pos - mem;
      if (len < 3) {
        return false;
      }
      markup = state.src.slice(mem, pos);
      params = state.src.slice(pos, max);
      if (params.indexOf(String.fromCharCode(marker)) >= 0) {
        return false;
      }

      // Since start is found, we can report success here in validation mode
      if (silent) {
        return true;
      }

      // search end of block
      nextLine = startLine;
      for (;;) {
        nextLine++;
        if (nextLine >= endLine) {
          // unclosed block should be autoclosed by end of document.
          // also block seems to be autoclosed by end of parent
          break;
        }
        pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos < max && state.sCount[nextLine] < state.blkIndent) {
          // non-empty line with negative indent should stop the list:
          // - ```
          //  test
          break;
        }
        if (state.src.charCodeAt(pos) !== marker) {
          continue;
        }
        if (state.sCount[nextLine] - state.blkIndent >= 4) {
          // closing fence should be indented less than 4 spaces
          continue;
        }
        pos = state.skipChars(pos, marker);

        // closing code fence must be at least as long as the opening one
        if (pos - mem < len) {
          continue;
        }

        // make sure tail has spaces only
        pos = state.skipSpaces(pos);
        if (pos < max) {
          continue;
        }
        haveEndMarker = true;
        // found!
        break;
      }

      // If a fence has heading spaces, they should be removed from its inner block
      len = state.sCount[startLine];
      state.line = nextLine + (haveEndMarker ? 1 : 0);
      token = state.push('fence', 'code', 0);
      token.info = params;
      token.content = state.getLines(startLine + 1, nextLine, len, true);
      token.markup = markup;
      token.map = [startLine, state.line];
      return true;
    };

    /***/
  }), ( /* 486 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // heading (#, ##, ...)
    var isSpace = __webpack_require__(1).isSpace;
    module.exports = function heading(state, startLine, endLine, silent) {
      var ch,
        level,
        tmp,
        token,
        pos = state.bMarks[startLine] + state.tShift[startLine],
        max = state.eMarks[startLine];

      // if it's indented more than 3 spaces, it should be a code block
      if (state.sCount[startLine] - state.blkIndent >= 4) {
        return false;
      }
      ch = state.src.charCodeAt(pos);
      if (ch !== 0x23 /* # */ || pos >= max) {
        return false;
      }

      // count heading level
      level = 1;
      ch = state.src.charCodeAt(++pos);
      while (ch === 0x23 /* # */ && pos < max && level <= 6) {
        level++;
        ch = state.src.charCodeAt(++pos);
      }
      if (level > 6 || pos < max && !isSpace(ch)) {
        return false;
      }
      if (silent) {
        return true;
      }

      // Let's cut tails like '    ###  ' from the end of string

      max = state.skipSpacesBack(max, pos);
      tmp = state.skipCharsBack(max, 0x23, pos); // #
      if (tmp > pos && isSpace(state.src.charCodeAt(tmp - 1))) {
        max = tmp;
      }
      state.line = startLine + 1;
      token = state.push('heading_open', 'h' + String(level), 1);
      token.markup = '########'.slice(0, level);
      token.map = [startLine, state.line];
      token = state.push('inline', '', 0);
      token.content = state.src.slice(pos, max).trim();
      token.map = [startLine, state.line];
      token.children = [];
      token = state.push('heading_close', 'h' + String(level), -1);
      token.markup = '########'.slice(0, level);
      return true;
    };

    /***/
  }), ( /* 487 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Horizontal rule
    var isSpace = __webpack_require__(1).isSpace;
    module.exports = function hr(state, startLine, endLine, silent) {
      var marker,
        cnt,
        ch,
        token,
        pos = state.bMarks[startLine] + state.tShift[startLine],
        max = state.eMarks[startLine];

      // if it's indented more than 3 spaces, it should be a code block
      if (state.sCount[startLine] - state.blkIndent >= 4) {
        return false;
      }
      marker = state.src.charCodeAt(pos++);

      // Check hr marker
      if (marker !== 0x2A /* * */ && marker !== 0x2D /* - */ && marker !== 0x5F /* _ */) {
        return false;
      }

      // markers can be mixed with spaces, but there should be at least 3 of them

      cnt = 1;
      while (pos < max) {
        ch = state.src.charCodeAt(pos++);
        if (ch !== marker && !isSpace(ch)) {
          return false;
        }
        if (ch === marker) {
          cnt++;
        }
      }
      if (cnt < 3) {
        return false;
      }
      if (silent) {
        return true;
      }
      state.line = startLine + 1;
      token = state.push('hr', 'hr', 0);
      token.map = [startLine, state.line];
      token.markup = Array(cnt + 1).join(String.fromCharCode(marker));
      return true;
    };

    /***/
  }), ( /* 488 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // HTML block
    var block_names = __webpack_require__(470);
    var HTML_OPEN_CLOSE_TAG_RE = __webpack_require__(213).HTML_OPEN_CLOSE_TAG_RE;

    // An array of opening and corresponding closing sequences for html tags,
    // last argument defines whether it can terminate a paragraph or not
    //
    var HTML_SEQUENCES = [[/^<(script|pre|style)(?=(\s|>|$))/i, /<\/(script|pre|style)>/i, true], [/^<!--/, /-->/, true], [/^<\?/, /\?>/, true], [/^<![A-Z]/, />/, true], [/^<!\[CDATA\[/, /\]\]>/, true], [new RegExp('^</?(' + block_names.join('|') + ')(?=(\\s|/?>|$))', 'i'), /^$/, true], [new RegExp(HTML_OPEN_CLOSE_TAG_RE.source + '\\s*$'), /^$/, false]];
    module.exports = function html_block(state, startLine, endLine, silent) {
      var i,
        nextLine,
        token,
        lineText,
        pos = state.bMarks[startLine] + state.tShift[startLine],
        max = state.eMarks[startLine];

      // if it's indented more than 3 spaces, it should be a code block
      if (state.sCount[startLine] - state.blkIndent >= 4) {
        return false;
      }
      if (!state.md.options.html) {
        return false;
      }
      if (state.src.charCodeAt(pos) !== 0x3C /* < */) {
        return false;
      }
      lineText = state.src.slice(pos, max);
      for (i = 0; i < HTML_SEQUENCES.length; i++) {
        if (HTML_SEQUENCES[i][0].test(lineText)) {
          break;
        }
      }
      if (i === HTML_SEQUENCES.length) {
        return false;
      }
      if (silent) {
        // true if this sequence can be a terminator, false otherwise
        return HTML_SEQUENCES[i][2];
      }
      nextLine = startLine + 1;

      // If we are here - we detected HTML block.
      // Let's roll down till block end.
      if (!HTML_SEQUENCES[i][1].test(lineText)) {
        for (; nextLine < endLine; nextLine++) {
          if (state.sCount[nextLine] < state.blkIndent) {
            break;
          }
          pos = state.bMarks[nextLine] + state.tShift[nextLine];
          max = state.eMarks[nextLine];
          lineText = state.src.slice(pos, max);
          if (HTML_SEQUENCES[i][1].test(lineText)) {
            if (lineText.length !== 0) {
              nextLine++;
            }
            break;
          }
        }
      }
      state.line = nextLine;
      token = state.push('html_block', '', 0);
      token.map = [startLine, nextLine];
      token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
      return true;
    };

    /***/
  }), ( /* 489 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // lheading (---, ===)
    module.exports = function lheading(state, startLine, endLine /*, silent*/) {
      var content,
        terminate,
        i,
        l,
        token,
        pos,
        max,
        level,
        marker,
        nextLine = startLine + 1,
        oldParentType,
        terminatorRules = state.md.block.ruler.getRules('paragraph');

      // if it's indented more than 3 spaces, it should be a code block
      if (state.sCount[startLine] - state.blkIndent >= 4) {
        return false;
      }
      oldParentType = state.parentType;
      state.parentType = 'paragraph'; // use paragraph to match terminatorRules

      // jump line-by-line until empty one or EOF
      for (; nextLine < endLine && !state.isEmpty(nextLine); nextLine++) {
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) {
          continue;
        }

        //
        // Check for underline in setext header
        //
        if (state.sCount[nextLine] >= state.blkIndent) {
          pos = state.bMarks[nextLine] + state.tShift[nextLine];
          max = state.eMarks[nextLine];
          if (pos < max) {
            marker = state.src.charCodeAt(pos);
            if (marker === 0x2D /* - */ || marker === 0x3D /* = */) {
              pos = state.skipChars(pos, marker);
              pos = state.skipSpaces(pos);
              if (pos >= max) {
                level = marker === 0x3D /* = */ ? 1 : 2;
                break;
              }
            }
          }
        }

        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) {
          continue;
        }

        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for (i = 0, l = terminatorRules.length; i < l; i++) {
          if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
          }
        }
        if (terminate) {
          break;
        }
      }
      if (!level) {
        // Didn't find valid underline
        return false;
      }
      content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
      state.line = nextLine + 1;
      token = state.push('heading_open', 'h' + String(level), 1);
      token.markup = String.fromCharCode(marker);
      token.map = [startLine, state.line];
      token = state.push('inline', '', 0);
      token.content = content;
      token.map = [startLine, state.line - 1];
      token.children = [];
      token = state.push('heading_close', 'h' + String(level), -1);
      token.markup = String.fromCharCode(marker);
      state.parentType = oldParentType;
      return true;
    };

    /***/
  }), ( /* 490 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Lists
    var isSpace = __webpack_require__(1).isSpace;

    // Search `[-+*][\n ]`, returns next pos after marker on success
    // or -1 on fail.
    function skipBulletListMarker(state, startLine) {
      var marker, pos, max, ch;
      pos = state.bMarks[startLine] + state.tShift[startLine];
      max = state.eMarks[startLine];
      marker = state.src.charCodeAt(pos++);
      // Check bullet
      if (marker !== 0x2A /* * */ && marker !== 0x2D /* - */ && marker !== 0x2B /* + */) {
        return -1;
      }
      if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!isSpace(ch)) {
          // " -test " - is not a list item
          return -1;
        }
      }
      return pos;
    }

    // Search `\d+[.)][\n ]`, returns next pos after marker on success
    // or -1 on fail.
    function skipOrderedListMarker(state, startLine) {
      var ch,
        start = state.bMarks[startLine] + state.tShift[startLine],
        pos = start,
        max = state.eMarks[startLine];

      // List marker should have at least 2 chars (digit + dot)
      if (pos + 1 >= max) {
        return -1;
      }
      ch = state.src.charCodeAt(pos++);
      if (ch < 0x30 /* 0 */ || ch > 0x39 /* 9 */) {
        return -1;
      }
      for (;;) {
        // EOL -> fail
        if (pos >= max) {
          return -1;
        }
        ch = state.src.charCodeAt(pos++);
        if (ch >= 0x30 /* 0 */ && ch <= 0x39 /* 9 */) {
          // List marker should have no more than 9 digits
          // (prevents integer overflow in browsers)
          if (pos - start >= 10) {
            return -1;
          }
          continue;
        }

        // found valid marker
        if (ch === 0x29 /* ) */ || ch === 0x2e /* . */) {
          break;
        }
        return -1;
      }
      if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!isSpace(ch)) {
          // " 1.test " - is not a list item
          return -1;
        }
      }
      return pos;
    }
    function markTightParagraphs(state, idx) {
      var i,
        l,
        level = state.level + 2;
      for (i = idx + 2, l = state.tokens.length - 2; i < l; i++) {
        if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
          state.tokens[i + 2].hidden = true;
          state.tokens[i].hidden = true;
          i += 2;
        }
      }
    }
    module.exports = function list(state, startLine, endLine, silent) {
      var ch,
        contentStart,
        i,
        indent,
        indentAfterMarker,
        initial,
        isOrdered,
        itemLines,
        l,
        listLines,
        listTokIdx,
        markerCharCode,
        markerValue,
        max,
        nextLine,
        offset,
        oldIndent,
        oldLIndent,
        oldParentType,
        oldTShift,
        oldTight,
        pos,
        posAfterMarker,
        prevEmptyEnd,
        start,
        terminate,
        terminatorRules,
        token,
        isTerminatingParagraph = false,
        tight = true;

      // if it's indented more than 3 spaces, it should be a code block
      if (state.sCount[startLine] - state.blkIndent >= 4) {
        return false;
      }

      // limit conditions when list can interrupt
      // a paragraph (validation mode only)
      if (silent && state.parentType === 'paragraph') {
        // Next list item should still terminate previous list item;
        //
        // This code can fail if plugins use blkIndent as well as lists,
        // but I hope the spec gets fixed long before that happens.
        //
        if (state.tShift[startLine] >= state.blkIndent) {
          isTerminatingParagraph = true;
        }
      }

      // Detect list type and position after marker
      if ((posAfterMarker = skipOrderedListMarker(state, startLine)) >= 0) {
        isOrdered = true;
        start = state.bMarks[startLine] + state.tShift[startLine];
        markerValue = Number(state.src.substr(start, posAfterMarker - start - 1));

        // If we're starting a new ordered list right after
        // a paragraph, it should start with 1.
        if (isTerminatingParagraph && markerValue !== 1) return false;
      } else if ((posAfterMarker = skipBulletListMarker(state, startLine)) >= 0) {
        isOrdered = false;
      } else {
        return false;
      }

      // If we're starting a new unordered list right after
      // a paragraph, first line should not be empty.
      if (isTerminatingParagraph) {
        if (state.skipSpaces(posAfterMarker) >= state.eMarks[startLine]) return false;
      }

      // We should terminate list on style change. Remember first one to compare.
      markerCharCode = state.src.charCodeAt(posAfterMarker - 1);

      // For validation mode we can terminate immediately
      if (silent) {
        return true;
      }

      // Start list
      listTokIdx = state.tokens.length;
      if (isOrdered) {
        token = state.push('ordered_list_open', 'ol', 1);
        if (markerValue !== 1) {
          token.attrs = [['start', markerValue]];
        }
      } else {
        token = state.push('bullet_list_open', 'ul', 1);
      }
      token.map = listLines = [startLine, 0];
      token.markup = String.fromCharCode(markerCharCode);

      //
      // Iterate list items
      //

      nextLine = startLine;
      prevEmptyEnd = false;
      terminatorRules = state.md.block.ruler.getRules('list');
      oldParentType = state.parentType;
      state.parentType = 'list';
      while (nextLine < endLine) {
        pos = posAfterMarker;
        max = state.eMarks[nextLine];
        initial = offset = state.sCount[nextLine] + posAfterMarker - (state.bMarks[startLine] + state.tShift[startLine]);
        while (pos < max) {
          ch = state.src.charCodeAt(pos);
          if (ch === 0x09) {
            offset += 4 - (offset + state.bsCount[nextLine]) % 4;
          } else if (ch === 0x20) {
            offset++;
          } else {
            break;
          }
          pos++;
        }
        contentStart = pos;
        if (contentStart >= max) {
          // trimming space in "-    \n  3" case, indent is 1 here
          indentAfterMarker = 1;
        } else {
          indentAfterMarker = offset - initial;
        }

        // If we have more than 4 spaces, the indent is 1
        // (the rest is just indented code block)
        if (indentAfterMarker > 4) {
          indentAfterMarker = 1;
        }

        // "  -  test"
        //  ^^^^^ - calculating total length of this thing
        indent = initial + indentAfterMarker;

        // Run subparser & write tokens
        token = state.push('list_item_open', 'li', 1);
        token.markup = String.fromCharCode(markerCharCode);
        token.map = itemLines = [startLine, 0];
        oldIndent = state.blkIndent;
        oldTight = state.tight;
        oldTShift = state.tShift[startLine];
        oldLIndent = state.sCount[startLine];
        state.blkIndent = indent;
        state.tight = true;
        state.tShift[startLine] = contentStart - state.bMarks[startLine];
        state.sCount[startLine] = offset;
        if (contentStart >= max && state.isEmpty(startLine + 1)) {
          // workaround for this case
          // (list item is empty, list terminates before "foo"):
          // ~~~~~~~~
          //   -
          //
          //     foo
          // ~~~~~~~~
          state.line = Math.min(state.line + 2, endLine);
        } else {
          state.md.block.tokenize(state, startLine, endLine, true);
        }

        // If any of list item is tight, mark list as tight
        if (!state.tight || prevEmptyEnd) {
          tight = false;
        }
        // Item become loose if finish with empty line,
        // but we should filter last element, because it means list finish
        prevEmptyEnd = state.line - startLine > 1 && state.isEmpty(state.line - 1);
        state.blkIndent = oldIndent;
        state.tShift[startLine] = oldTShift;
        state.sCount[startLine] = oldLIndent;
        state.tight = oldTight;
        token = state.push('list_item_close', 'li', -1);
        token.markup = String.fromCharCode(markerCharCode);
        nextLine = startLine = state.line;
        itemLines[1] = nextLine;
        contentStart = state.bMarks[startLine];
        if (nextLine >= endLine) {
          break;
        }

        //
        // Try to check if list is terminated or continued.
        //
        if (state.sCount[nextLine] < state.blkIndent) {
          break;
        }

        // fail if terminating block found
        terminate = false;
        for (i = 0, l = terminatorRules.length; i < l; i++) {
          if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
          }
        }
        if (terminate) {
          break;
        }

        // fail if list has another type
        if (isOrdered) {
          posAfterMarker = skipOrderedListMarker(state, nextLine);
          if (posAfterMarker < 0) {
            break;
          }
        } else {
          posAfterMarker = skipBulletListMarker(state, nextLine);
          if (posAfterMarker < 0) {
            break;
          }
        }
        if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) {
          break;
        }
      }

      // Finalize list
      if (isOrdered) {
        token = state.push('ordered_list_close', 'ol', -1);
      } else {
        token = state.push('bullet_list_close', 'ul', -1);
      }
      token.markup = String.fromCharCode(markerCharCode);
      listLines[1] = nextLine;
      state.line = nextLine;
      state.parentType = oldParentType;

      // mark paragraphs tight if needed
      if (tight) {
        markTightParagraphs(state, listTokIdx);
      }
      return true;
    };

    /***/
  }), ( /* 491 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Paragraph
    module.exports = function paragraph(state, startLine /*, endLine*/) {
      var content,
        terminate,
        i,
        l,
        token,
        oldParentType,
        nextLine = startLine + 1,
        terminatorRules = state.md.block.ruler.getRules('paragraph'),
        endLine = state.lineMax;
      oldParentType = state.parentType;
      state.parentType = 'paragraph';

      // jump line-by-line until empty one or EOF
      for (; nextLine < endLine && !state.isEmpty(nextLine); nextLine++) {
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) {
          continue;
        }

        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) {
          continue;
        }

        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for (i = 0, l = terminatorRules.length; i < l; i++) {
          if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
          }
        }
        if (terminate) {
          break;
        }
      }
      content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
      state.line = nextLine;
      token = state.push('paragraph_open', 'p', 1);
      token.map = [startLine, state.line];
      token = state.push('inline', '', 0);
      token.content = content;
      token.map = [startLine, state.line];
      token.children = [];
      token = state.push('paragraph_close', 'p', -1);
      state.parentType = oldParentType;
      return true;
    };

    /***/
  }), ( /* 492 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var normalizeReference = __webpack_require__(1).normalizeReference;
    var isSpace = __webpack_require__(1).isSpace;
    module.exports = function reference(state, startLine, _endLine, silent) {
      var ch,
        destEndPos,
        destEndLineNo,
        endLine,
        href,
        i,
        l,
        label,
        labelEnd,
        oldParentType,
        res,
        start,
        str,
        terminate,
        terminatorRules,
        title,
        lines = 0,
        pos = state.bMarks[startLine] + state.tShift[startLine],
        max = state.eMarks[startLine],
        nextLine = startLine + 1;

      // if it's indented more than 3 spaces, it should be a code block
      if (state.sCount[startLine] - state.blkIndent >= 4) {
        return false;
      }
      if (state.src.charCodeAt(pos) !== 0x5B /* [ */) {
        return false;
      }

      // Simple check to quickly interrupt scan on [link](url) at the start of line.
      // Can be useful on practice: https://github.com/markdown-it/markdown-it/issues/54
      while (++pos < max) {
        if (state.src.charCodeAt(pos) === 0x5D /* ] */ && state.src.charCodeAt(pos - 1) !== 0x5C /* \ */) {
          if (pos + 1 === max) {
            return false;
          }
          if (state.src.charCodeAt(pos + 1) !== 0x3A /* : */) {
            return false;
          }
          break;
        }
      }
      endLine = state.lineMax;

      // jump line-by-line until empty one or EOF
      terminatorRules = state.md.block.ruler.getRules('reference');
      oldParentType = state.parentType;
      state.parentType = 'reference';
      for (; nextLine < endLine && !state.isEmpty(nextLine); nextLine++) {
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) {
          continue;
        }

        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) {
          continue;
        }

        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for (i = 0, l = terminatorRules.length; i < l; i++) {
          if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
          }
        }
        if (terminate) {
          break;
        }
      }
      str = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
      max = str.length;
      for (pos = 1; pos < max; pos++) {
        ch = str.charCodeAt(pos);
        if (ch === 0x5B /* [ */) {
          return false;
        } else if (ch === 0x5D /* ] */) {
          labelEnd = pos;
          break;
        } else if (ch === 0x0A /* \n */) {
          lines++;
        } else if (ch === 0x5C /* \ */) {
          pos++;
          if (pos < max && str.charCodeAt(pos) === 0x0A) {
            lines++;
          }
        }
      }
      if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */) {
        return false;
      }

      // [label]:   destination   'title'
      //         ^^^ skip optional whitespace here
      for (pos = labelEnd + 2; pos < max; pos++) {
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) {
          lines++;
        } else if (isSpace(ch)) {
          /*eslint no-empty:0*/
        } else {
          break;
        }
      }

      // [label]:   destination   'title'
      //            ^^^^^^^^^^^ parse this
      res = state.md.helpers.parseLinkDestination(str, pos, max);
      if (!res.ok) {
        return false;
      }
      href = state.md.normalizeLink(res.str);
      if (!state.md.validateLink(href)) {
        return false;
      }
      pos = res.pos;
      lines += res.lines;

      // save cursor state, we could require to rollback later
      destEndPos = pos;
      destEndLineNo = lines;

      // [label]:   destination   'title'
      //                       ^^^ skipping those spaces
      start = pos;
      for (; pos < max; pos++) {
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) {
          lines++;
        } else if (isSpace(ch)) {
          /*eslint no-empty:0*/
        } else {
          break;
        }
      }

      // [label]:   destination   'title'
      //                          ^^^^^^^ parse this
      res = state.md.helpers.parseLinkTitle(str, pos, max);
      if (pos < max && start !== pos && res.ok) {
        title = res.str;
        pos = res.pos;
        lines += res.lines;
      } else {
        title = '';
        pos = destEndPos;
        lines = destEndLineNo;
      }

      // skip trailing spaces until the rest of the line
      while (pos < max) {
        ch = str.charCodeAt(pos);
        if (!isSpace(ch)) {
          break;
        }
        pos++;
      }
      if (pos < max && str.charCodeAt(pos) !== 0x0A) {
        if (title) {
          // garbage at the end of the line after title,
          // but it could still be a valid reference if we roll back
          title = '';
          pos = destEndPos;
          lines = destEndLineNo;
          while (pos < max) {
            ch = str.charCodeAt(pos);
            if (!isSpace(ch)) {
              break;
            }
            pos++;
          }
        }
      }
      if (pos < max && str.charCodeAt(pos) !== 0x0A) {
        // garbage at the end of the line
        return false;
      }
      label = normalizeReference(str.slice(1, labelEnd));
      if (!label) {
        // CommonMark 0.20 disallows empty labels
        return false;
      }

      // Reference can not terminate anything. This check is for safety only.
      /*istanbul ignore if*/
      if (silent) {
        return true;
      }
      if (typeof state.env.references === 'undefined') {
        state.env.references = {};
      }
      if (typeof state.env.references[label] === 'undefined') {
        state.env.references[label] = {
          title: title,
          href: href
        };
      }
      state.parentType = oldParentType;
      state.line = startLine + lines + 1;
      return true;
    };

    /***/
  }), ( /* 493 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Parser state class
    var Token = __webpack_require__(137);
    var isSpace = __webpack_require__(1).isSpace;
    function StateBlock(src, md, env, tokens) {
      var ch, s, start, pos, len, indent, offset, indent_found;
      this.src = src;

      // link to parser instance
      this.md = md;
      this.env = env;

      //
      // Internal state vartiables
      //

      this.tokens = tokens;
      this.bMarks = []; // line begin offsets for fast jumps
      this.eMarks = []; // line end offsets for fast jumps
      this.tShift = []; // offsets of the first non-space characters (tabs not expanded)
      this.sCount = []; // indents for each line (tabs expanded)

      // An amount of virtual spaces (tabs expanded) between beginning
      // of each line (bMarks) and real beginning of that line.
      //
      // It exists only as a hack because blockquotes override bMarks
      // losing information in the process.
      //
      // It's used only when expanding tabs, you can think about it as
      // an initial tab length, e.g. bsCount=21 applied to string `\t123`
      // means first tab should be expanded to 4-21%4 === 3 spaces.
      //
      this.bsCount = [];

      // block parser variables
      this.blkIndent = 0; // required block content indent
      // (for example, if we are in list)
      this.line = 0; // line index in src
      this.lineMax = 0; // lines count
      this.tight = false; // loose/tight mode for lists
      this.ddIndent = -1; // indent of the current dd block (-1 if there isn't any)

      // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
      // used in lists to determine if they interrupt a paragraph
      this.parentType = 'root';
      this.level = 0;

      // renderer
      this.result = '';

      // Create caches
      // Generate markers.
      s = this.src;
      indent_found = false;
      for (start = pos = indent = offset = 0, len = s.length; pos < len; pos++) {
        ch = s.charCodeAt(pos);
        if (!indent_found) {
          if (isSpace(ch)) {
            indent++;
            if (ch === 0x09) {
              offset += 4 - offset % 4;
            } else {
              offset++;
            }
            continue;
          } else {
            indent_found = true;
          }
        }
        if (ch === 0x0A || pos === len - 1) {
          if (ch !== 0x0A) {
            pos++;
          }
          this.bMarks.push(start);
          this.eMarks.push(pos);
          this.tShift.push(indent);
          this.sCount.push(offset);
          this.bsCount.push(0);
          indent_found = false;
          indent = 0;
          offset = 0;
          start = pos + 1;
        }
      }

      // Push fake entry to simplify cache bounds checks
      this.bMarks.push(s.length);
      this.eMarks.push(s.length);
      this.tShift.push(0);
      this.sCount.push(0);
      this.bsCount.push(0);
      this.lineMax = this.bMarks.length - 1; // don't count last fake line
    }

    // Push new token to "stream".
    //
    StateBlock.prototype.push = function (type, tag, nesting) {
      var token = new Token(type, tag, nesting);
      token.block = true;
      if (nesting < 0) {
        this.level--;
      }
      token.level = this.level;
      if (nesting > 0) {
        this.level++;
      }
      this.tokens.push(token);
      return token;
    };
    StateBlock.prototype.isEmpty = function isEmpty(line) {
      return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
    };
    StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
      for (var max = this.lineMax; from < max; from++) {
        if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) {
          break;
        }
      }
      return from;
    };

    // Skip spaces from given position.
    StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
      var ch;
      for (var max = this.src.length; pos < max; pos++) {
        ch = this.src.charCodeAt(pos);
        if (!isSpace(ch)) {
          break;
        }
      }
      return pos;
    };

    // Skip spaces from given position in reverse.
    StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
      if (pos <= min) {
        return pos;
      }
      while (pos > min) {
        if (!isSpace(this.src.charCodeAt(--pos))) {
          return pos + 1;
        }
      }
      return pos;
    };

    // Skip char codes from given position
    StateBlock.prototype.skipChars = function skipChars(pos, code) {
      for (var max = this.src.length; pos < max; pos++) {
        if (this.src.charCodeAt(pos) !== code) {
          break;
        }
      }
      return pos;
    };

    // Skip char codes reverse from given position - 1
    StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
      if (pos <= min) {
        return pos;
      }
      while (pos > min) {
        if (code !== this.src.charCodeAt(--pos)) {
          return pos + 1;
        }
      }
      return pos;
    };

    // cut lines range from source.
    StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
      var i,
        lineIndent,
        ch,
        first,
        last,
        queue,
        lineStart,
        line = begin;
      if (begin >= end) {
        return '';
      }
      queue = new Array(end - begin);
      for (i = 0; line < end; line++, i++) {
        lineIndent = 0;
        lineStart = first = this.bMarks[line];
        if (line + 1 < end || keepLastLF) {
          // No need for bounds check because we have fake entry on tail.
          last = this.eMarks[line] + 1;
        } else {
          last = this.eMarks[line];
        }
        while (first < last && lineIndent < indent) {
          ch = this.src.charCodeAt(first);
          if (isSpace(ch)) {
            if (ch === 0x09) {
              lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
            } else {
              lineIndent++;
            }
          } else if (first - lineStart < this.tShift[line]) {
            // patched tShift masked characters to look like spaces (blockquotes, list markers)
            lineIndent++;
          } else {
            break;
          }
          first++;
        }
        if (lineIndent > indent) {
          // partially expanding tabs in code blocks, e.g '\t\tfoobar'
          // with indent=2 becomes '  \tfoobar'
          queue[i] = new Array(lineIndent - indent + 1).join(' ') + this.src.slice(first, last);
        } else {
          queue[i] = this.src.slice(first, last);
        }
      }
      return queue.join('');
    };

    // re-export Token class to use in block rules
    StateBlock.prototype.Token = Token;
    module.exports = StateBlock;

    /***/
  }), ( /* 494 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // GFM table, non-standard
    var isSpace = __webpack_require__(1).isSpace;
    function getLine(state, line) {
      var pos = state.bMarks[line] + state.blkIndent,
        max = state.eMarks[line];
      return state.src.substr(pos, max - pos);
    }
    function escapedSplit(str) {
      var result = [],
        pos = 0,
        max = str.length,
        ch,
        escapes = 0,
        lastPos = 0,
        backTicked = false,
        lastBackTick = 0;
      ch = str.charCodeAt(pos);
      while (pos < max) {
        if (ch === 0x60 /* ` */) {
          if (backTicked) {
            // make \` close code sequence, but not open it;
            // the reason is: `\` is correct code block
            backTicked = false;
            lastBackTick = pos;
          } else if (escapes % 2 === 0) {
            backTicked = true;
            lastBackTick = pos;
          }
        } else if (ch === 0x7c /* | */ && escapes % 2 === 0 && !backTicked) {
          result.push(str.substring(lastPos, pos));
          lastPos = pos + 1;
        }
        if (ch === 0x5c /* \ */) {
          escapes++;
        } else {
          escapes = 0;
        }
        pos++;

        // If there was an un-closed backtick, go back to just after
        // the last backtick, but as if it was a normal character
        if (pos === max && backTicked) {
          backTicked = false;
          pos = lastBackTick + 1;
        }
        ch = str.charCodeAt(pos);
      }
      result.push(str.substring(lastPos));
      return result;
    }
    module.exports = function table(state, startLine, endLine, silent) {
      var ch, lineText, pos, i, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines;

      // should have at least two lines
      if (startLine + 2 > endLine) {
        return false;
      }
      nextLine = startLine + 1;
      if (state.sCount[nextLine] < state.blkIndent) {
        return false;
      }

      // if it's indented more than 3 spaces, it should be a code block
      if (state.sCount[nextLine] - state.blkIndent >= 4) {
        return false;
      }

      // first character of the second line should be '|', '-', ':',
      // and no other characters are allowed but spaces;
      // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp

      pos = state.bMarks[nextLine] + state.tShift[nextLine];
      if (pos >= state.eMarks[nextLine]) {
        return false;
      }
      ch = state.src.charCodeAt(pos++);
      if (ch !== 0x7C /* | */ && ch !== 0x2D /* - */ && ch !== 0x3A /* : */) {
        return false;
      }
      while (pos < state.eMarks[nextLine]) {
        ch = state.src.charCodeAt(pos);
        if (ch !== 0x7C /* | */ && ch !== 0x2D /* - */ && ch !== 0x3A /* : */ && !isSpace(ch)) {
          return false;
        }
        pos++;
      }
      lineText = getLine(state, startLine + 1);
      columns = lineText.split('|');
      aligns = [];
      for (i = 0; i < columns.length; i++) {
        t = columns[i].trim();
        if (!t) {
          // allow empty columns before and after table, but not in between columns;
          // e.g. allow ` |---| `, disallow ` ---||--- `
          if (i === 0 || i === columns.length - 1) {
            continue;
          } else {
            return false;
          }
        }
        if (!/^:?-+:?$/.test(t)) {
          return false;
        }
        if (t.charCodeAt(t.length - 1) === 0x3A /* : */) {
          aligns.push(t.charCodeAt(0) === 0x3A /* : */ ? 'center' : 'right');
        } else if (t.charCodeAt(0) === 0x3A /* : */) {
          aligns.push('left');
        } else {
          aligns.push('');
        }
      }
      lineText = getLine(state, startLine).trim();
      if (lineText.indexOf('|') === -1) {
        return false;
      }
      if (state.sCount[startLine] - state.blkIndent >= 4) {
        return false;
      }
      columns = escapedSplit(lineText.replace(/^\||\|$/g, ''));

      // header row will define an amount of columns in the entire table,
      // and align row shouldn't be smaller than that (the rest of the rows can)
      columnCount = columns.length;
      if (columnCount > aligns.length) {
        return false;
      }
      if (silent) {
        return true;
      }
      token = state.push('table_open', 'table', 1);
      token.map = tableLines = [startLine, 0];
      token = state.push('thead_open', 'thead', 1);
      token.map = [startLine, startLine + 1];
      token = state.push('tr_open', 'tr', 1);
      token.map = [startLine, startLine + 1];
      for (i = 0; i < columns.length; i++) {
        token = state.push('th_open', 'th', 1);
        token.map = [startLine, startLine + 1];
        if (aligns[i]) {
          token.attrs = [['style', 'text-align:' + aligns[i]]];
        }
        token = state.push('inline', '', 0);
        token.content = columns[i].trim();
        token.map = [startLine, startLine + 1];
        token.children = [];
        token = state.push('th_close', 'th', -1);
      }
      token = state.push('tr_close', 'tr', -1);
      token = state.push('thead_close', 'thead', -1);
      token = state.push('tbody_open', 'tbody', 1);
      token.map = tbodyLines = [startLine + 2, 0];
      for (nextLine = startLine + 2; nextLine < endLine; nextLine++) {
        if (state.sCount[nextLine] < state.blkIndent) {
          break;
        }
        lineText = getLine(state, nextLine).trim();
        if (lineText.indexOf('|') === -1) {
          break;
        }
        if (state.sCount[nextLine] - state.blkIndent >= 4) {
          break;
        }
        columns = escapedSplit(lineText.replace(/^\||\|$/g, ''));
        token = state.push('tr_open', 'tr', 1);
        for (i = 0; i < columnCount; i++) {
          token = state.push('td_open', 'td', 1);
          if (aligns[i]) {
            token.attrs = [['style', 'text-align:' + aligns[i]]];
          }
          token = state.push('inline', '', 0);
          token.content = columns[i] ? columns[i].trim() : '';
          token.children = [];
          token = state.push('td_close', 'td', -1);
        }
        token = state.push('tr_close', 'tr', -1);
      }
      token = state.push('tbody_close', 'tbody', -1);
      token = state.push('table_close', 'table', -1);
      tableLines[1] = tbodyLines[1] = nextLine;
      state.line = nextLine;
      return true;
    };

    /***/
  }), ( /* 495 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    module.exports = function block(state) {
      var token;
      if (state.inlineMode) {
        token = new state.Token('inline', '', 0);
        token.content = state.src;
        token.map = [0, 1];
        token.children = [];
        state.tokens.push(token);
      } else {
        state.md.block.parse(state.src, state.md, state.env, state.tokens);
      }
    };

    /***/
  }), ( /* 496 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    module.exports = function inline(state) {
      var tokens = state.tokens,
        tok,
        i,
        l;

      // Parse inlines
      for (i = 0, l = tokens.length; i < l; i++) {
        tok = tokens[i];
        if (tok.type === 'inline') {
          state.md.inline.parse(tok.content, state.md, state.env, tok.children);
        }
      }
    };

    /***/
  }), ( /* 497 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Replace link-like texts with link nodes.
    //
    // Currently restricted by `md.validateLink()` to http/https/ftp
    //
    var arrayReplaceAt = __webpack_require__(1).arrayReplaceAt;
    function isLinkOpen(str) {
      return /^<a[>\s]/i.test(str);
    }
    function isLinkClose(str) {
      return /^<\/a\s*>/i.test(str);
    }
    module.exports = function linkify(state) {
      var i,
        j,
        l,
        tokens,
        token,
        currentToken,
        nodes,
        ln,
        text,
        pos,
        lastPos,
        level,
        htmlLinkLevel,
        url,
        fullUrl,
        urlText,
        blockTokens = state.tokens,
        links;
      if (!state.md.options.linkify) {
        return;
      }
      for (j = 0, l = blockTokens.length; j < l; j++) {
        if (blockTokens[j].type !== 'inline' || !state.md.linkify.pretest(blockTokens[j].content)) {
          continue;
        }
        tokens = blockTokens[j].children;
        htmlLinkLevel = 0;

        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for (i = tokens.length - 1; i >= 0; i--) {
          currentToken = tokens[i];

          // Skip content of markdown links
          if (currentToken.type === 'link_close') {
            i--;
            while (tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open') {
              i--;
            }
            continue;
          }

          // Skip content of html tag links
          if (currentToken.type === 'html_inline') {
            if (isLinkOpen(currentToken.content) && htmlLinkLevel > 0) {
              htmlLinkLevel--;
            }
            if (isLinkClose(currentToken.content)) {
              htmlLinkLevel++;
            }
          }
          if (htmlLinkLevel > 0) {
            continue;
          }
          if (currentToken.type === 'text' && state.md.linkify.test(currentToken.content)) {
            text = currentToken.content;
            links = state.md.linkify.match(text);

            // Now split string to nodes
            nodes = [];
            level = currentToken.level;
            lastPos = 0;
            for (ln = 0; ln < links.length; ln++) {
              url = links[ln].url;
              fullUrl = state.md.normalizeLink(url);
              if (!state.md.validateLink(fullUrl)) {
                continue;
              }
              urlText = links[ln].text;

              // Linkifier might send raw hostnames like "example.com", where url
              // starts with domain name. So we prepend http:// in those cases,
              // and remove it afterwards.
              //
              if (!links[ln].schema) {
                urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
              } else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) {
                urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
              } else {
                urlText = state.md.normalizeLinkText(urlText);
              }
              pos = links[ln].index;
              if (pos > lastPos) {
                token = new state.Token('text', '', 0);
                token.content = text.slice(lastPos, pos);
                token.level = level;
                nodes.push(token);
              }
              token = new state.Token('link_open', 'a', 1);
              token.attrs = [['href', fullUrl]];
              token.level = level++;
              token.markup = 'linkify';
              token.info = 'auto';
              nodes.push(token);
              token = new state.Token('text', '', 0);
              token.content = urlText;
              token.level = level;
              nodes.push(token);
              token = new state.Token('link_close', 'a', -1);
              token.level = --level;
              token.markup = 'linkify';
              token.info = 'auto';
              nodes.push(token);
              lastPos = links[ln].lastIndex;
            }
            if (lastPos < text.length) {
              token = new state.Token('text', '', 0);
              token.content = text.slice(lastPos);
              token.level = level;
              nodes.push(token);
            }

            // replace current node
            blockTokens[j].children = tokens = arrayReplaceAt(tokens, i, nodes);
          }
        }
      }
    };

    /***/
  }), ( /* 498 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Normalize input string
    var NEWLINES_RE = /\r[\n\u0085]?|[\u2424\u2028\u0085]/g;
    var NULL_RE = /\u0000/g;
    module.exports = function inline(state) {
      var str;

      // Normalize newlines
      str = state.src.replace(NEWLINES_RE, '\n');

      // Replace NULL characters
      str = str.replace(NULL_RE, "\uFFFD");
      state.src = str;
    };

    /***/
  }), ( /* 499 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Simple typographyc replacements
    //
    // (c) (C) → ©
    // (tm) (TM) → ™
    // (r) (R) → ®
    // +- → ±
    // (p) (P) -> §
    // ... → … (also ?.... → ?.., !.... → !..)
    // ???????? → ???, !!!!! → !!!, `,,` → `,`
    // -- → &ndash;, --- → &mdash;
    //

    // TODO:
    // - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
    // - miltiplication 2 x 4 -> 2 × 4
    var RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;

    // Workaround for phantomjs - need regex without /g flag,
    // or root check will fail every second time
    var SCOPED_ABBR_TEST_RE = /\((c|tm|r|p)\)/i;
    var SCOPED_ABBR_RE = /\((c|tm|r|p)\)/ig;
    var SCOPED_ABBR = {
      c: '©',
      r: '®',
      p: '§',
      tm: '™'
    };
    function replaceFn(match, name) {
      return SCOPED_ABBR[name.toLowerCase()];
    }
    function replace_scoped(inlineTokens) {
      var i,
        token,
        inside_autolink = 0;
      for (i = inlineTokens.length - 1; i >= 0; i--) {
        token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) {
          token.content = token.content.replace(SCOPED_ABBR_RE, replaceFn);
        }
        if (token.type === 'link_open' && token.info === 'auto') {
          inside_autolink--;
        }
        if (token.type === 'link_close' && token.info === 'auto') {
          inside_autolink++;
        }
      }
    }
    function replace_rare(inlineTokens) {
      var i,
        token,
        inside_autolink = 0;
      for (i = inlineTokens.length - 1; i >= 0; i--) {
        token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) {
          if (RARE_RE.test(token.content)) {
            token.content = token.content.replace(/\+-/g, '±')
            // .., ..., ....... -> …
            // but ?..... & !..... -> ?.. & !..
            .replace(/\.{2,}/g, '…').replace(/([?!])…/g, '$1..').replace(/([?!]){4,}/g, '$1$1$1').replace(/,{2,}/g, ',')
            // em-dash
            .replace(/(^|[^-])---([^-]|$)/mg, "$1\u2014$2")
            // en-dash
            .replace(/(^|\s)--(\s|$)/mg, "$1\u2013$2").replace(/(^|[^-\s])--([^-\s]|$)/mg, "$1\u2013$2");
          }
        }
        if (token.type === 'link_open' && token.info === 'auto') {
          inside_autolink--;
        }
        if (token.type === 'link_close' && token.info === 'auto') {
          inside_autolink++;
        }
      }
    }
    module.exports = function replace(state) {
      var blkIdx;
      if (!state.md.options.typographer) {
        return;
      }
      for (blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--) {
        if (state.tokens[blkIdx].type !== 'inline') {
          continue;
        }
        if (SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) {
          replace_scoped(state.tokens[blkIdx].children);
        }
        if (RARE_RE.test(state.tokens[blkIdx].content)) {
          replace_rare(state.tokens[blkIdx].children);
        }
      }
    };

    /***/
  }), ( /* 500 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Convert straight quotation marks to typographic ones
    //
    var isWhiteSpace = __webpack_require__(1).isWhiteSpace;
    var isPunctChar = __webpack_require__(1).isPunctChar;
    var isMdAsciiPunct = __webpack_require__(1).isMdAsciiPunct;
    var QUOTE_TEST_RE = /['"]/;
    var QUOTE_RE = /['"]/g;
    var APOSTROPHE = "\u2019"; /* ’ */

    function replaceAt(str, index, ch) {
      return str.substr(0, index) + ch + str.substr(index + 1);
    }
    function process_inlines(tokens, state) {
      var i, token, text, t, pos, max, thisLevel, item, lastChar, nextChar, isLastPunctChar, isNextPunctChar, isLastWhiteSpace, isNextWhiteSpace, canOpen, canClose, j, isSingle, stack, openQuote, closeQuote;
      stack = [];
      for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        thisLevel = tokens[i].level;
        for (j = stack.length - 1; j >= 0; j--) {
          if (stack[j].level <= thisLevel) {
            break;
          }
        }
        stack.length = j + 1;
        if (token.type !== 'text') {
          continue;
        }
        text = token.content;
        pos = 0;
        max = text.length;

        /*eslint no-labels:0,block-scoped-var:0*/
        OUTER: while (pos < max) {
          QUOTE_RE.lastIndex = pos;
          t = QUOTE_RE.exec(text);
          if (!t) {
            break;
          }
          canOpen = canClose = true;
          pos = t.index + 1;
          isSingle = t[0] === "'";

          // Find previous character,
          // default to space if it's the beginning of the line
          //
          lastChar = 0x20;
          if (t.index - 1 >= 0) {
            lastChar = text.charCodeAt(t.index - 1);
          } else {
            for (j = i - 1; j >= 0; j--) {
              if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // lastChar defaults to 0x20
              if (tokens[j].type !== 'text') continue;
              lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
              break;
            }
          }

          // Find next character,
          // default to space if it's the end of the line
          //
          nextChar = 0x20;
          if (pos < max) {
            nextChar = text.charCodeAt(pos);
          } else {
            for (j = i + 1; j < tokens.length; j++) {
              if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // nextChar defaults to 0x20
              if (tokens[j].type !== 'text') continue;
              nextChar = tokens[j].content.charCodeAt(0);
              break;
            }
          }
          isLastPunctChar = isMdAsciiPunct(lastChar) || isPunctChar(String.fromCharCode(lastChar));
          isNextPunctChar = isMdAsciiPunct(nextChar) || isPunctChar(String.fromCharCode(nextChar));
          isLastWhiteSpace = isWhiteSpace(lastChar);
          isNextWhiteSpace = isWhiteSpace(nextChar);
          if (isNextWhiteSpace) {
            canOpen = false;
          } else if (isNextPunctChar) {
            if (!(isLastWhiteSpace || isLastPunctChar)) {
              canOpen = false;
            }
          }
          if (isLastWhiteSpace) {
            canClose = false;
          } else if (isLastPunctChar) {
            if (!(isNextWhiteSpace || isNextPunctChar)) {
              canClose = false;
            }
          }
          if (nextChar === 0x22 /* " */ && t[0] === '"') {
            if (lastChar >= 0x30 /* 0 */ && lastChar <= 0x39 /* 9 */) {
              // special case: 1"" - count first quote as an inch
              canClose = canOpen = false;
            }
          }
          if (canOpen && canClose) {
            // treat this as the middle of the word
            canOpen = false;
            canClose = isNextPunctChar;
          }
          if (!canOpen && !canClose) {
            // middle of word
            if (isSingle) {
              token.content = replaceAt(token.content, t.index, APOSTROPHE);
            }
            continue;
          }
          if (canClose) {
            // this could be a closing quote, rewind the stack to get a match
            for (j = stack.length - 1; j >= 0; j--) {
              item = stack[j];
              if (stack[j].level < thisLevel) {
                break;
              }
              if (item.single === isSingle && stack[j].level === thisLevel) {
                item = stack[j];
                if (isSingle) {
                  openQuote = state.md.options.quotes[2];
                  closeQuote = state.md.options.quotes[3];
                } else {
                  openQuote = state.md.options.quotes[0];
                  closeQuote = state.md.options.quotes[1];
                }

                // replace token.content *before* tokens[item.token].content,
                // because, if they are pointing at the same token, replaceAt
                // could mess up indices when quote length != 1
                token.content = replaceAt(token.content, t.index, closeQuote);
                tokens[item.token].content = replaceAt(tokens[item.token].content, item.pos, openQuote);
                pos += closeQuote.length - 1;
                if (item.token === i) {
                  pos += openQuote.length - 1;
                }
                text = token.content;
                max = text.length;
                stack.length = j;
                continue OUTER;
              }
            }
          }
          if (canOpen) {
            stack.push({
              token: i,
              pos: t.index,
              single: isSingle,
              level: thisLevel
            });
          } else if (canClose && isSingle) {
            token.content = replaceAt(token.content, t.index, APOSTROPHE);
          }
        }
      }
    }
    module.exports = function smartquotes(state) {
      /*eslint max-depth:0*/
      var blkIdx;
      if (!state.md.options.typographer) {
        return;
      }
      for (blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--) {
        if (state.tokens[blkIdx].type !== 'inline' || !QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) {
          continue;
        }
        process_inlines(state.tokens[blkIdx].children, state);
      }
    };

    /***/
  }), ( /* 501 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Core state object
    //
    var Token = __webpack_require__(137);
    function StateCore(src, md, env) {
      this.src = src;
      this.env = env;
      this.tokens = [];
      this.inlineMode = false;
      this.md = md; // link to parser instance
    }

    // re-export Token class to use in core rules
    StateCore.prototype.Token = Token;
    module.exports = StateCore;

    /***/
  }), ( /* 502 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Process autolinks '<protocol:...>'

    /*eslint max-len:0*/
    var EMAIL_RE = /^<([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)>/;
    var AUTOLINK_RE = /^<([a-zA-Z][a-zA-Z0-9+.\-]{1,31}):([^<>\x00-\x20]*)>/;
    module.exports = function autolink(state, silent) {
      var tail,
        linkMatch,
        emailMatch,
        url,
        fullUrl,
        token,
        pos = state.pos;
      if (state.src.charCodeAt(pos) !== 0x3C /* < */) {
        return false;
      }
      tail = state.src.slice(pos);
      if (tail.indexOf('>') < 0) {
        return false;
      }
      if (AUTOLINK_RE.test(tail)) {
        linkMatch = tail.match(AUTOLINK_RE);
        url = linkMatch[0].slice(1, -1);
        fullUrl = state.md.normalizeLink(url);
        if (!state.md.validateLink(fullUrl)) {
          return false;
        }
        if (!silent) {
          token = state.push('link_open', 'a', 1);
          token.attrs = [['href', fullUrl]];
          token.markup = 'autolink';
          token.info = 'auto';
          token = state.push('text', '', 0);
          token.content = state.md.normalizeLinkText(url);
          token = state.push('link_close', 'a', -1);
          token.markup = 'autolink';
          token.info = 'auto';
        }
        state.pos += linkMatch[0].length;
        return true;
      }
      if (EMAIL_RE.test(tail)) {
        emailMatch = tail.match(EMAIL_RE);
        url = emailMatch[0].slice(1, -1);
        fullUrl = state.md.normalizeLink('mailto:' + url);
        if (!state.md.validateLink(fullUrl)) {
          return false;
        }
        if (!silent) {
          token = state.push('link_open', 'a', 1);
          token.attrs = [['href', fullUrl]];
          token.markup = 'autolink';
          token.info = 'auto';
          token = state.push('text', '', 0);
          token.content = state.md.normalizeLinkText(url);
          token = state.push('link_close', 'a', -1);
          token.markup = 'autolink';
          token.info = 'auto';
        }
        state.pos += emailMatch[0].length;
        return true;
      }
      return false;
    };

    /***/
  }), ( /* 503 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Parse backticks
    module.exports = function backtick(state, silent) {
      var start,
        max,
        marker,
        matchStart,
        matchEnd,
        token,
        pos = state.pos,
        ch = state.src.charCodeAt(pos);
      if (ch !== 0x60 /* ` */) {
        return false;
      }
      start = pos;
      pos++;
      max = state.posMax;
      while (pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */) {
        pos++;
      }
      marker = state.src.slice(start, pos);
      matchStart = matchEnd = pos;
      while ((matchStart = state.src.indexOf('`', matchEnd)) !== -1) {
        matchEnd = matchStart + 1;
        while (matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */) {
          matchEnd++;
        }
        if (matchEnd - matchStart === marker.length) {
          if (!silent) {
            token = state.push('code_inline', 'code', 0);
            token.markup = marker;
            token.content = state.src.slice(pos, matchStart).replace(/[ \n]+/g, ' ').trim();
          }
          state.pos = matchEnd;
          return true;
        }
      }
      if (!silent) {
        state.pending += marker;
      }
      state.pos += marker.length;
      return true;
    };

    /***/
  }), ( /* 504 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // For each opening emphasis-like marker find a matching closing one
    //
    module.exports = function link_pairs(state) {
      var i,
        j,
        lastDelim,
        currDelim,
        delimiters = state.delimiters,
        max = state.delimiters.length;
      for (i = 0; i < max; i++) {
        lastDelim = delimiters[i];
        if (!lastDelim.close) {
          continue;
        }
        j = i - lastDelim.jump - 1;
        while (j >= 0) {
          currDelim = delimiters[j];
          if (currDelim.open && currDelim.marker === lastDelim.marker && currDelim.end < 0 && currDelim.level === lastDelim.level) {
            // typeofs are for backward compatibility with plugins
            var odd_match = (currDelim.close || lastDelim.open) && typeof currDelim.length !== 'undefined' && typeof lastDelim.length !== 'undefined' && (currDelim.length + lastDelim.length) % 3 === 0;
            if (!odd_match) {
              lastDelim.jump = i - j;
              lastDelim.open = false;
              currDelim.end = i;
              currDelim.jump = 0;
              break;
            }
          }
          j -= currDelim.jump + 1;
        }
      }
    };

    /***/
  }), ( /* 505 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Process html entity - &#123;, &#xAF;, &quot;, ...
    var entities = __webpack_require__(212);
    var has = __webpack_require__(1).has;
    var isValidEntityCode = __webpack_require__(1).isValidEntityCode;
    var fromCodePoint = __webpack_require__(1).fromCodePoint;
    var DIGITAL_RE = /^&#((?:x[a-f0-9]{1,8}|[0-9]{1,8}));/i;
    var NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
    module.exports = function entity(state, silent) {
      var ch,
        code,
        match,
        pos = state.pos,
        max = state.posMax;
      if (state.src.charCodeAt(pos) !== 0x26 /* & */) {
        return false;
      }
      if (pos + 1 < max) {
        ch = state.src.charCodeAt(pos + 1);
        if (ch === 0x23 /* # */) {
          match = state.src.slice(pos).match(DIGITAL_RE);
          if (match) {
            if (!silent) {
              code = match[1][0].toLowerCase() === 'x' ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
              state.pending += isValidEntityCode(code) ? fromCodePoint(code) : fromCodePoint(0xFFFD);
            }
            state.pos += match[0].length;
            return true;
          }
        } else {
          match = state.src.slice(pos).match(NAMED_RE);
          if (match) {
            if (has(entities, match[1])) {
              if (!silent) {
                state.pending += entities[match[1]];
              }
              state.pos += match[0].length;
              return true;
            }
          }
        }
      }
      if (!silent) {
        state.pending += '&';
      }
      state.pos++;
      return true;
    };

    /***/
  }), ( /* 506 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Process escaped chars and hardbreaks
    var isSpace = __webpack_require__(1).isSpace;
    var ESCAPED = [];
    for (var i = 0; i < 256; i++) {
      ESCAPED.push(0);
    }
    '\\!"#$%&\'()*+,./:;<=>?@[]^_`{|}~-'.split('').forEach(function (ch) {
      ESCAPED[ch.charCodeAt(0)] = 1;
    });
    module.exports = function escape(state, silent) {
      var ch,
        pos = state.pos,
        max = state.posMax;
      if (state.src.charCodeAt(pos) !== 0x5C /* \ */) {
        return false;
      }
      pos++;
      if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (ch < 256 && ESCAPED[ch] !== 0) {
          if (!silent) {
            state.pending += state.src[pos];
          }
          state.pos += 2;
          return true;
        }
        if (ch === 0x0A) {
          if (!silent) {
            state.push('hardbreak', 'br', 0);
          }
          pos++;
          // skip leading whitespaces from next line
          while (pos < max) {
            ch = state.src.charCodeAt(pos);
            if (!isSpace(ch)) {
              break;
            }
            pos++;
          }
          state.pos = pos;
          return true;
        }
      }
      if (!silent) {
        state.pending += '\\';
      }
      state.pos++;
      return true;
    };

    /***/
  }), ( /* 507 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Process html tags
    var HTML_TAG_RE = __webpack_require__(213).HTML_TAG_RE;
    function isLetter(ch) {
      /*eslint no-bitwise:0*/
      var lc = ch | 0x20; // to lower case
      return lc >= 0x61 /* a */ && lc <= 0x7a /* z */;
    }
    module.exports = function html_inline(state, silent) {
      var ch,
        match,
        max,
        token,
        pos = state.pos;
      if (!state.md.options.html) {
        return false;
      }

      // Check start
      max = state.posMax;
      if (state.src.charCodeAt(pos) !== 0x3C /* < */ || pos + 2 >= max) {
        return false;
      }

      // Quick fail on second char
      ch = state.src.charCodeAt(pos + 1);
      if (ch !== 0x21 /* ! */ && ch !== 0x3F /* ? */ && ch !== 0x2F /* / */ && !isLetter(ch)) {
        return false;
      }
      match = state.src.slice(pos).match(HTML_TAG_RE);
      if (!match) {
        return false;
      }
      if (!silent) {
        token = state.push('html_inline', '', 0);
        token.content = state.src.slice(pos, pos + match[0].length);
      }
      state.pos += match[0].length;
      return true;
    };

    /***/
  }), ( /* 508 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Process ![image](<src> "title")
    var normalizeReference = __webpack_require__(1).normalizeReference;
    var isSpace = __webpack_require__(1).isSpace;
    module.exports = function image(state, silent) {
      var attrs,
        code,
        content,
        label,
        labelEnd,
        labelStart,
        pos,
        ref,
        res,
        title,
        token,
        tokens,
        start,
        href = '',
        oldPos = state.pos,
        max = state.posMax;
      if (state.src.charCodeAt(state.pos) !== 0x21 /* ! */) {
        return false;
      }
      if (state.src.charCodeAt(state.pos + 1) !== 0x5B /* [ */) {
        return false;
      }
      labelStart = state.pos + 2;
      labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);

      // parser failed to find ']', so it's not a valid link
      if (labelEnd < 0) {
        return false;
      }
      pos = labelEnd + 1;
      if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */) {
        //
        // Inline link
        //

        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for (; pos < max; pos++) {
          code = state.src.charCodeAt(pos);
          if (!isSpace(code) && code !== 0x0A) {
            break;
          }
        }
        if (pos >= max) {
          return false;
        }

        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
          href = state.md.normalizeLink(res.str);
          if (state.md.validateLink(href)) {
            pos = res.pos;
          } else {
            href = '';
          }
        }

        // [link](  <href>  "title"  )
        //                ^^ skipping these spaces
        start = pos;
        for (; pos < max; pos++) {
          code = state.src.charCodeAt(pos);
          if (!isSpace(code) && code !== 0x0A) {
            break;
          }
        }

        // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title
        res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
        if (pos < max && start !== pos && res.ok) {
          title = res.str;
          pos = res.pos;

          // [link](  <href>  "title"  )
          //                         ^^ skipping these spaces
          for (; pos < max; pos++) {
            code = state.src.charCodeAt(pos);
            if (!isSpace(code) && code !== 0x0A) {
              break;
            }
          }
        } else {
          title = '';
        }
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */) {
          state.pos = oldPos;
          return false;
        }
        pos++;
      } else {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') {
          return false;
        }
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */) {
          start = pos + 1;
          pos = state.md.helpers.parseLinkLabel(state, pos);
          if (pos >= 0) {
            label = state.src.slice(start, pos++);
          } else {
            pos = labelEnd + 1;
          }
        } else {
          pos = labelEnd + 1;
        }

        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) {
          label = state.src.slice(labelStart, labelEnd);
        }
        ref = state.env.references[normalizeReference(label)];
        if (!ref) {
          state.pos = oldPos;
          return false;
        }
        href = ref.href;
        title = ref.title;
      }

      //
      // We found the end of the link, and know for a fact it's a valid link;
      // so all that's left to do is to call tokenizer.
      //
      if (!silent) {
        content = state.src.slice(labelStart, labelEnd);
        state.md.inline.parse(content, state.md, state.env, tokens = []);
        token = state.push('image', 'img', 0);
        token.attrs = attrs = [['src', href], ['alt', '']];
        token.children = tokens;
        token.content = content;
        if (title) {
          attrs.push(['title', title]);
        }
      }
      state.pos = pos;
      state.posMax = max;
      return true;
    };

    /***/
  }), ( /* 509 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Process [link](<to> "stuff")
    var normalizeReference = __webpack_require__(1).normalizeReference;
    var isSpace = __webpack_require__(1).isSpace;
    module.exports = function link(state, silent) {
      var attrs,
        code,
        label,
        labelEnd,
        labelStart,
        pos,
        res,
        ref,
        title,
        token,
        href = '',
        oldPos = state.pos,
        max = state.posMax,
        start = state.pos,
        parseReference = true;
      if (state.src.charCodeAt(state.pos) !== 0x5B /* [ */) {
        return false;
      }
      labelStart = state.pos + 1;
      labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);

      // parser failed to find ']', so it's not a valid link
      if (labelEnd < 0) {
        return false;
      }
      pos = labelEnd + 1;
      if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */) {
        //
        // Inline link
        //

        // might have found a valid shortcut link, disable reference parsing
        parseReference = false;

        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for (; pos < max; pos++) {
          code = state.src.charCodeAt(pos);
          if (!isSpace(code) && code !== 0x0A) {
            break;
          }
        }
        if (pos >= max) {
          return false;
        }

        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
          href = state.md.normalizeLink(res.str);
          if (state.md.validateLink(href)) {
            pos = res.pos;
          } else {
            href = '';
          }
        }

        // [link](  <href>  "title"  )
        //                ^^ skipping these spaces
        start = pos;
        for (; pos < max; pos++) {
          code = state.src.charCodeAt(pos);
          if (!isSpace(code) && code !== 0x0A) {
            break;
          }
        }

        // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title
        res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
        if (pos < max && start !== pos && res.ok) {
          title = res.str;
          pos = res.pos;

          // [link](  <href>  "title"  )
          //                         ^^ skipping these spaces
          for (; pos < max; pos++) {
            code = state.src.charCodeAt(pos);
            if (!isSpace(code) && code !== 0x0A) {
              break;
            }
          }
        } else {
          title = '';
        }
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */) {
          // parsing a valid shortcut link failed, fallback to reference
          parseReference = true;
        }
        pos++;
      }
      if (parseReference) {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') {
          return false;
        }
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */) {
          start = pos + 1;
          pos = state.md.helpers.parseLinkLabel(state, pos);
          if (pos >= 0) {
            label = state.src.slice(start, pos++);
          } else {
            pos = labelEnd + 1;
          }
        } else {
          pos = labelEnd + 1;
        }

        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) {
          label = state.src.slice(labelStart, labelEnd);
        }
        ref = state.env.references[normalizeReference(label)];
        if (!ref) {
          state.pos = oldPos;
          return false;
        }
        href = ref.href;
        title = ref.title;
      }

      //
      // We found the end of the link, and know for a fact it's a valid link;
      // so all that's left to do is to call tokenizer.
      //
      if (!silent) {
        state.pos = labelStart;
        state.posMax = labelEnd;
        token = state.push('link_open', 'a', 1);
        token.attrs = attrs = [['href', href]];
        if (title) {
          attrs.push(['title', title]);
        }
        state.md.inline.tokenize(state);
        token = state.push('link_close', 'a', -1);
      }
      state.pos = pos;
      state.posMax = max;
      return true;
    };

    /***/
  }), ( /* 510 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Proceess '\n'
    var isSpace = __webpack_require__(1).isSpace;
    module.exports = function newline(state, silent) {
      var pmax,
        max,
        pos = state.pos;
      if (state.src.charCodeAt(pos) !== 0x0A /* \n */) {
        return false;
      }
      pmax = state.pending.length - 1;
      max = state.posMax;

      // '  \n' -> hardbreak
      // Lookup in pending chars is bad practice! Don't copy to other rules!
      // Pending string is stored in concat mode, indexed lookups will cause
      // convertion to flat mode.
      if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
          if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
            state.pending = state.pending.replace(/ +$/, '');
            state.push('hardbreak', 'br', 0);
          } else {
            state.pending = state.pending.slice(0, -1);
            state.push('softbreak', 'br', 0);
          }
        } else {
          state.push('softbreak', 'br', 0);
        }
      }
      pos++;

      // skip heading spaces for next line
      while (pos < max && isSpace(state.src.charCodeAt(pos))) {
        pos++;
      }
      state.pos = pos;
      return true;
    };

    /***/
  }), ( /* 511 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Inline parser state
    var Token = __webpack_require__(137);
    var isWhiteSpace = __webpack_require__(1).isWhiteSpace;
    var isPunctChar = __webpack_require__(1).isPunctChar;
    var isMdAsciiPunct = __webpack_require__(1).isMdAsciiPunct;
    function StateInline(src, md, env, outTokens) {
      this.src = src;
      this.env = env;
      this.md = md;
      this.tokens = outTokens;
      this.pos = 0;
      this.posMax = this.src.length;
      this.level = 0;
      this.pending = '';
      this.pendingLevel = 0;
      this.cache = {}; // Stores { start: end } pairs. Useful for backtrack
      // optimization of pairs parse (emphasis, strikes).

      this.delimiters = []; // Emphasis-like delimiters
    }

    // Flush pending text
    //
    StateInline.prototype.pushPending = function () {
      var token = new Token('text', '', 0);
      token.content = this.pending;
      token.level = this.pendingLevel;
      this.tokens.push(token);
      this.pending = '';
      return token;
    };

    // Push new token to "stream".
    // If pending text exists - flush it as text token
    //
    StateInline.prototype.push = function (type, tag, nesting) {
      if (this.pending) {
        this.pushPending();
      }
      var token = new Token(type, tag, nesting);
      if (nesting < 0) {
        this.level--;
      }
      token.level = this.level;
      if (nesting > 0) {
        this.level++;
      }
      this.pendingLevel = this.level;
      this.tokens.push(token);
      return token;
    };

    // Scan a sequence of emphasis-like markers, and determine whether
    // it can start an emphasis sequence or end an emphasis sequence.
    //
    //  - start - position to scan from (it should point at a valid marker);
    //  - canSplitWord - determine if these markers can be found inside a word
    //
    StateInline.prototype.scanDelims = function (start, canSplitWord) {
      var pos = start,
        lastChar,
        nextChar,
        count,
        can_open,
        can_close,
        isLastWhiteSpace,
        isLastPunctChar,
        isNextWhiteSpace,
        isNextPunctChar,
        left_flanking = true,
        right_flanking = true,
        max = this.posMax,
        marker = this.src.charCodeAt(start);

      // treat beginning of the line as a whitespace
      lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;
      while (pos < max && this.src.charCodeAt(pos) === marker) {
        pos++;
      }
      count = pos - start;

      // treat end of the line as a whitespace
      nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;
      isLastPunctChar = isMdAsciiPunct(lastChar) || isPunctChar(String.fromCharCode(lastChar));
      isNextPunctChar = isMdAsciiPunct(nextChar) || isPunctChar(String.fromCharCode(nextChar));
      isLastWhiteSpace = isWhiteSpace(lastChar);
      isNextWhiteSpace = isWhiteSpace(nextChar);
      if (isNextWhiteSpace) {
        left_flanking = false;
      } else if (isNextPunctChar) {
        if (!(isLastWhiteSpace || isLastPunctChar)) {
          left_flanking = false;
        }
      }
      if (isLastWhiteSpace) {
        right_flanking = false;
      } else if (isLastPunctChar) {
        if (!(isNextWhiteSpace || isNextPunctChar)) {
          right_flanking = false;
        }
      }
      if (!canSplitWord) {
        can_open = left_flanking && (!right_flanking || isLastPunctChar);
        can_close = right_flanking && (!left_flanking || isNextPunctChar);
      } else {
        can_open = left_flanking;
        can_close = right_flanking;
      }
      return {
        can_open: can_open,
        can_close: can_close,
        length: count
      };
    };

    // re-export Token class to use in block rules
    StateInline.prototype.Token = Token;
    module.exports = StateInline;

    /***/
  }), ( /* 512 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Skip text characters for text token, place those to pending buffer
    // and increment current pos

    // Rule to skip pure text
    // '{}$%@~+=:' reserved for extentions

    // !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~

    // !!!! Don't confuse with "Markdown ASCII Punctuation" chars
    // http://spec.commonmark.org/0.15/#ascii-punctuation-character
    function isTerminatorChar(ch) {
      switch (ch) {
        case 0x0A /* \n */:
        case 0x21 /* ! */:
        case 0x23 /* # */:
        case 0x24 /* $ */:
        case 0x25 /* % */:
        case 0x26 /* & */:
        case 0x2A /* * */:
        case 0x2B /* + */:
        case 0x2D /* - */:
        case 0x3A /* : */:
        case 0x3C /* < */:
        case 0x3D /* = */:
        case 0x3E /* > */:
        case 0x40 /* @ */:
        case 0x5B /* [ */:
        case 0x5C /* \ */:
        case 0x5D /* ] */:
        case 0x5E /* ^ */:
        case 0x5F /* _ */:
        case 0x60 /* ` */:
        case 0x7B /* { */:
        case 0x7D /* } */:
        case 0x7E /* ~ */:
          return true;
        default:
          return false;
      }
    }
    module.exports = function text(state, silent) {
      var pos = state.pos;
      while (pos < state.posMax && !isTerminatorChar(state.src.charCodeAt(pos))) {
        pos++;
      }
      if (pos === state.pos) {
        return false;
      }
      if (!silent) {
        state.pending += state.src.slice(state.pos, pos);
      }
      state.pos = pos;
      return true;
    };

    // Alternative implementation, for memory.
    //
    // It costs 10% of performance, but allows extend terminators list, if place it
    // to `ParcerInline` property. Probably, will switch to it sometime, such
    // flexibility required.

    /*
    var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;
    
    module.exports = function text(state, silent) {
      var pos = state.pos,
          idx = state.src.slice(pos).search(TERMINATOR_RE);
    
      // first char is terminator -> empty text
      if (idx === 0) { return false; }
    
      // no terminator -> text till end of string
      if (idx < 0) {
        if (!silent) { state.pending += state.src.slice(pos); }
        state.pos = state.src.length;
        return true;
      }
    
      if (!silent) { state.pending += state.src.slice(pos, pos + idx); }
    
      state.pos += idx;
    
      return true;
    };*/

    /***/
  }), ( /* 513 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Merge adjacent text nodes into one, and re-calculate all token levels
    //
    module.exports = function text_collapse(state) {
      var curr,
        last,
        level = 0,
        tokens = state.tokens,
        max = state.tokens.length;
      for (curr = last = 0; curr < max; curr++) {
        // re-calculate levels
        level += tokens[curr].nesting;
        tokens[curr].level = level;
        if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') {
          // collapse two adjacent text nodes
          tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        } else {
          if (curr !== last) {
            tokens[last] = tokens[curr];
          }
          last++;
        }
      }
      if (curr !== last) {
        tokens.length = last;
      }
    };

    /***/
  }), ( /* 514 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    /* eslint-disable no-bitwise */
    var decodeCache = {};
    function getDecodeCache(exclude) {
      var i,
        ch,
        cache = decodeCache[exclude];
      if (cache) {
        return cache;
      }
      cache = decodeCache[exclude] = [];
      for (i = 0; i < 128; i++) {
        ch = String.fromCharCode(i);
        cache.push(ch);
      }
      for (i = 0; i < exclude.length; i++) {
        ch = exclude.charCodeAt(i);
        cache[ch] = '%' + ('0' + ch.toString(16).toUpperCase()).slice(-2);
      }
      return cache;
    }

    // Decode percent-encoded string.
    //
    function decode(string, exclude) {
      var cache;
      if (typeof exclude !== 'string') {
        exclude = decode.defaultChars;
      }
      cache = getDecodeCache(exclude);
      return string.replace(/(%[a-f0-9]{2})+/gi, function (seq) {
        var i,
          l,
          b1,
          b2,
          b3,
          b4,
          chr,
          result = '';
        for (i = 0, l = seq.length; i < l; i += 3) {
          b1 = parseInt(seq.slice(i + 1, i + 3), 16);
          if (b1 < 0x80) {
            result += cache[b1];
            continue;
          }
          if ((b1 & 0xE0) === 0xC0 && i + 3 < l) {
            // 110xxxxx 10xxxxxx
            b2 = parseInt(seq.slice(i + 4, i + 6), 16);
            if ((b2 & 0xC0) === 0x80) {
              chr = b1 << 6 & 0x7C0 | b2 & 0x3F;
              if (chr < 0x80) {
                result += "\uFFFD\uFFFD";
              } else {
                result += String.fromCharCode(chr);
              }
              i += 3;
              continue;
            }
          }
          if ((b1 & 0xF0) === 0xE0 && i + 6 < l) {
            // 1110xxxx 10xxxxxx 10xxxxxx
            b2 = parseInt(seq.slice(i + 4, i + 6), 16);
            b3 = parseInt(seq.slice(i + 7, i + 9), 16);
            if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
              chr = b1 << 12 & 0xF000 | b2 << 6 & 0xFC0 | b3 & 0x3F;
              if (chr < 0x800 || chr >= 0xD800 && chr <= 0xDFFF) {
                result += "\uFFFD\uFFFD\uFFFD";
              } else {
                result += String.fromCharCode(chr);
              }
              i += 6;
              continue;
            }
          }
          if ((b1 & 0xF8) === 0xF0 && i + 9 < l) {
            // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
            b2 = parseInt(seq.slice(i + 4, i + 6), 16);
            b3 = parseInt(seq.slice(i + 7, i + 9), 16);
            b4 = parseInt(seq.slice(i + 10, i + 12), 16);
            if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
              chr = b1 << 18 & 0x1C0000 | b2 << 12 & 0x3F000 | b3 << 6 & 0xFC0 | b4 & 0x3F;
              if (chr < 0x10000 || chr > 0x10FFFF) {
                result += "\uFFFD\uFFFD\uFFFD\uFFFD";
              } else {
                chr -= 0x10000;
                result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
              }
              i += 9;
              continue;
            }
          }
          result += "\uFFFD";
        }
        return result;
      });
    }
    decode.defaultChars = ';/?:@&=+$,#';
    decode.componentChars = '';
    module.exports = decode;

    /***/
  }), ( /* 515 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var encodeCache = {};

    // Create a lookup array where anything but characters in `chars` string
    // and alphanumeric chars is percent-encoded.
    //
    function getEncodeCache(exclude) {
      var i,
        ch,
        cache = encodeCache[exclude];
      if (cache) {
        return cache;
      }
      cache = encodeCache[exclude] = [];
      for (i = 0; i < 128; i++) {
        ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) {
          // always allow unencoded alphanumeric characters
          cache.push(ch);
        } else {
          cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
        }
      }
      for (i = 0; i < exclude.length; i++) {
        cache[exclude.charCodeAt(i)] = exclude[i];
      }
      return cache;
    }

    // Encode unsafe characters with percent-encoding, skipping already
    // encoded sequences.
    //
    //  - string       - string to encode
    //  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
    //  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
    //
    function encode(string, exclude, keepEscaped) {
      var i,
        l,
        code,
        nextCode,
        cache,
        result = '';
      if (typeof exclude !== 'string') {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = encode.defaultChars;
      }
      if (typeof keepEscaped === 'undefined') {
        keepEscaped = true;
      }
      cache = getEncodeCache(exclude);
      for (i = 0, l = string.length; i < l; i++) {
        code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */ && i + 2 < l) {
          if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
            result += string.slice(i, i + 3);
            i += 2;
            continue;
          }
        }
        if (code < 128) {
          result += cache[code];
          continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
          if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
            nextCode = string.charCodeAt(i + 1);
            if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
              result += encodeURIComponent(string[i] + string[i + 1]);
              i++;
              continue;
            }
          }
          result += '%EF%BF%BD';
          continue;
        }
        result += encodeURIComponent(string[i]);
      }
      return result;
    }
    encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
    encode.componentChars = "-_.!~*'()";
    module.exports = encode;

    /***/
  }), ( /* 516 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    module.exports = function format(url) {
      var result = '';
      result += url.protocol || '';
      result += url.slashes ? '//' : '';
      result += url.auth ? url.auth + '@' : '';
      if (url.hostname && url.hostname.indexOf(':') !== -1) {
        // ipv6 address
        result += '[' + url.hostname + ']';
      } else {
        result += url.hostname || '';
      }
      result += url.port ? ':' + url.port : '';
      result += url.pathname || '';
      result += url.search || '';
      result += url.hash || '';
      return result;
    };

    /***/
  }), ( /* 517 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    // Copyright Joyent, Inc. and other Node contributors.
    //
    // Permission is hereby granted, free of charge, to any person obtaining a
    // copy of this software and associated documentation files (the
    // "Software"), to deal in the Software without restriction, including
    // without limitation the rights to use, copy, modify, merge, publish,
    // distribute, sublicense, and/or sell copies of the Software, and to permit
    // persons to whom the Software is furnished to do so, subject to the
    // following conditions:
    //
    // The above copyright notice and this permission notice shall be included
    // in all copies or substantial portions of the Software.
    //
    // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
    // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
    // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
    // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
    // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
    // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
    // USE OR OTHER DEALINGS IN THE SOFTWARE.

    //
    // Changes from joyent/node:
    //
    // 1. No leading slash in paths,
    //    e.g. in `url.parse('http://foo?bar')` pathname is ``, not `/`
    //
    // 2. Backslashes are not replaced with slashes,
    //    so `http:\\example.org\` is treated like a relative path
    //
    // 3. Trailing colon is treated like a part of the path,
    //    i.e. in `http://example.org:foo` pathname is `:foo`
    //
    // 4. Nothing is URL-encoded in the resulting object,
    //    (in joyent/node some chars in auth and paths are encoded)
    //
    // 5. `url.parse()` does not have `parseQueryString` argument
    //
    // 6. Removed extraneous result properties: `host`, `path`, `query`, etc.,
    //    which can be constructed using other parts of the url.
    //
    function Url() {
      this.protocol = null;
      this.slashes = null;
      this.auth = null;
      this.port = null;
      this.hostname = null;
      this.hash = null;
      this.search = null;
      this.pathname = null;
    }

    // Reference: RFC 3986, RFC 1808, RFC 2396

    // define these here so at least they only have to be
    // compiled once on the first module load.
    var protocolPattern = /^([a-z0-9.+-]+:)/i,
      portPattern = /:[0-9]*$/,
      // Special case for a simple path URL
      simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
      // RFC 2396: characters reserved for delimiting URLs.
      // We actually just auto-escape these.
      delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],
      // RFC 2396: characters not allowed for various reasons.
      unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),
      // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
      autoEscape = ['\''].concat(unwise),
      // Characters that are never ever allowed in a hostname.
      // Note that any invalid chars are also handled, but these
      // are the ones that are *expected* to be seen, so we fast-path
      // them.
      nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
      hostEndingChars = ['/', '?', '#'],
      hostnameMaxLen = 255,
      hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
      hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
      // protocols that can allow "unsafe" and "unwise" chars.
      /* eslint-disable no-script-url */
      // protocols that never have a hostname.
      hostlessProtocol = {
        'javascript': true,
        'javascript:': true
      },
      // protocols that always contain a // bit.
      slashedProtocol = {
        'http': true,
        'https': true,
        'ftp': true,
        'gopher': true,
        'file': true,
        'http:': true,
        'https:': true,
        'ftp:': true,
        'gopher:': true,
        'file:': true
      };
    /* eslint-enable no-script-url */

    function urlParse(url, slashesDenoteHost) {
      if (url && url instanceof Url) {
        return url;
      }
      var u = new Url();
      u.parse(url, slashesDenoteHost);
      return u;
    }
    Url.prototype.parse = function (url, slashesDenoteHost) {
      var i,
        l,
        lowerProto,
        hec,
        slashes,
        rest = url;

      // trim before proceeding.
      // This is to support parse stuff like "  http://foo.com  \n"
      rest = rest.trim();
      if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
          this.pathname = simplePath[1];
          if (simplePath[2]) {
            this.search = simplePath[2];
          }
          return this;
        }
      }
      var proto = protocolPattern.exec(rest);
      if (proto) {
        proto = proto[0];
        lowerProto = proto.toLowerCase();
        this.protocol = proto;
        rest = rest.substr(proto.length);
      }

      // figure out if it's got a host
      // user@server is *always* interpreted as a hostname, and url
      // resolution will treat //foo/bar as host=foo,path=bar because that's
      // how the browser resolves relative URLs.
      if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && hostlessProtocol[proto])) {
          rest = rest.substr(2);
          this.slashes = true;
        }
      }
      if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c

        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.

        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for (i = 0; i < hostEndingChars.length; i++) {
          hec = rest.indexOf(hostEndingChars[i]);
          if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) {
            hostEnd = hec;
          }
        }

        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) {
          // atSign can be anywhere.
          atSign = rest.lastIndexOf('@');
        } else {
          // atSign must be in auth portion.
          // http://a@b/c@d => host:b auth:a path:/c@d
          atSign = rest.lastIndexOf('@', hostEnd);
        }

        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
          auth = rest.slice(0, atSign);
          rest = rest.slice(atSign + 1);
          this.auth = auth;
        }

        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for (i = 0; i < nonHostChars.length; i++) {
          hec = rest.indexOf(nonHostChars[i]);
          if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) {
            hostEnd = hec;
          }
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) {
          hostEnd = rest.length;
        }
        if (rest[hostEnd - 1] === ':') {
          hostEnd--;
        }
        var host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);

        // pull out port.
        this.parseHost(host);

        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || '';

        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';

        // validate a little.
        if (!ipv6Hostname) {
          var hostparts = this.hostname.split(/\./);
          for (i = 0, l = hostparts.length; i < l; i++) {
            var part = hostparts[i];
            if (!part) {
              continue;
            }
            if (!part.match(hostnamePartPattern)) {
              var newpart = '';
              for (var j = 0, k = part.length; j < k; j++) {
                if (part.charCodeAt(j) > 127) {
                  // we replace non-ASCII char with a temporary placeholder
                  // we need this to make sure size of hostname is not
                  // broken by replacing non-ASCII by nothing
                  newpart += 'x';
                } else {
                  newpart += part[j];
                }
              }
              // we test again with ASCII char only
              if (!newpart.match(hostnamePartPattern)) {
                var validParts = hostparts.slice(0, i);
                var notHost = hostparts.slice(i + 1);
                var bit = part.match(hostnamePartStart);
                if (bit) {
                  validParts.push(bit[1]);
                  notHost.unshift(bit[2]);
                }
                if (notHost.length) {
                  rest = notHost.join('.') + rest;
                }
                this.hostname = validParts.join('.');
                break;
              }
            }
          }
        }
        if (this.hostname.length > hostnameMaxLen) {
          this.hostname = '';
        }

        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) {
          this.hostname = this.hostname.substr(1, this.hostname.length - 2);
        }
      }

      // chop off from the tail first.
      var hash = rest.indexOf('#');
      if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
      }
      var qm = rest.indexOf('?');
      if (qm !== -1) {
        this.search = rest.substr(qm);
        rest = rest.slice(0, qm);
      }
      if (rest) {
        this.pathname = rest;
      }
      if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) {
        this.pathname = '';
      }
      return this;
    };
    Url.prototype.parseHost = function (host) {
      var port = portPattern.exec(host);
      if (port) {
        port = port[0];
        if (port !== ':') {
          this.port = port.substr(1);
        }
        host = host.substr(0, host.length - port.length);
      }
      if (host) {
        this.hostname = host;
      }
    };
    module.exports = urlParse;

    /***/
  }), ( /* 518 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    /**
     * Copyright 2013-present, Facebook, Inc.
     * All rights reserved.
     *
     * This source code is licensed under the BSD-style license found in the
     * LICENSE file in the root directory of this source tree. An additional grant
     * of patent rights can be found in the PATENTS file in the same directory.
     */
    var emptyFunction = __webpack_require__(446);
    var invariant = __webpack_require__(447);
    var ReactPropTypesSecret = __webpack_require__(519);
    module.exports = function () {
      function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) {
          // It is still safe when called from React.
          return;
        }
        invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
      }
      ;
      shim.isRequired = shim;
      function getShim() {
        return shim;
      }
      ;
      // Important!
      // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
      var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim
      };
      ReactPropTypes.checkPropTypes = emptyFunction;
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };

    /***/
  }), ( /* 519 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    /**
     * Copyright 2013-present, Facebook, Inc.
     * All rights reserved.
     *
     * This source code is licensed under the BSD-style license found in the
     * LICENSE file in the root directory of this source tree. An additional grant
     * of patent rights can be found in the PATENTS file in the same directory.
     */
    var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
    module.exports = ReactPropTypesSecret;

    /***/
  }), ( /* 520 */
  /***/function (module, exports, __webpack_require__) {
    /* WEBPACK VAR INJECTION */(function (module, global) {
      var __WEBPACK_AMD_DEFINE_RESULT__; /*! https://mths.be/punycode v1.4.1 by @mathias */
      ;
      (function (root) {
        /** Detect free variables */
        var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
        var freeModule = typeof module == 'object' && module && !module.nodeType && module;
        var freeGlobal = typeof global == 'object' && global;
        if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) {
          root = freeGlobal;
        }

        /**
         * The `punycode` object.
         * @name punycode
         * @type Object
         */
        var punycode,
          /** Highest positive signed 32-bit float value */
          maxInt = 2147483647,
          // aka. 0x7FFFFFFF or 2^31-1

          /** Bootstring parameters */
          base = 36,
          tMin = 1,
          tMax = 26,
          skew = 38,
          damp = 700,
          initialBias = 72,
          initialN = 128,
          // 0x80
          delimiter = '-',
          // '\x2D'

          /** Regular expressions */
          regexPunycode = /^xn--/,
          regexNonASCII = /[^\x20-\x7E]/,
          // unprintable ASCII chars + non-ASCII chars
          regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g,
          // RFC 3490 separators

          /** Error messages */
          errors = {
            'overflow': 'Overflow: input needs wider integers to process',
            'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
            'invalid-input': 'Invalid input'
          },
          /** Convenience shortcuts */
          baseMinusTMin = base - tMin,
          floor = Math.floor,
          stringFromCharCode = String.fromCharCode,
          /** Temporary variable */
          key;

        /*--------------------------------------------------------------------------*/

        /**
         * A generic error utility function.
         * @private
         * @param {String} type The error type.
         * @returns {Error} Throws a `RangeError` with the applicable error message.
         */
        function error(type) {
          throw new RangeError(errors[type]);
        }

        /**
         * A generic `Array#map` utility function.
         * @private
         * @param {Array} array The array to iterate over.
         * @param {Function} callback The function that gets called for every array
         * item.
         * @returns {Array} A new array of values returned by the callback function.
         */
        function map(array, fn) {
          var length = array.length;
          var result = [];
          while (length--) {
            result[length] = fn(array[length]);
          }
          return result;
        }

        /**
         * A simple `Array#map`-like wrapper to work with domain name strings or email
         * addresses.
         * @private
         * @param {String} domain The domain name or email address.
         * @param {Function} callback The function that gets called for every
         * character.
         * @returns {Array} A new string of characters returned by the callback
         * function.
         */
        function mapDomain(string, fn) {
          var parts = string.split('@');
          var result = '';
          if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + '@';
            string = parts[1];
          }
          // Avoid `split(regex)` for IE8 compatibility. See #17.
          string = string.replace(regexSeparators, '\x2E');
          var labels = string.split('.');
          var encoded = map(labels, fn).join('.');
          return result + encoded;
        }

        /**
         * Creates an array containing the numeric code points of each Unicode
         * character in the string. While JavaScript uses UCS-2 internally,
         * this function will convert a pair of surrogate halves (each of which
         * UCS-2 exposes as separate characters) into a single code point,
         * matching UTF-16.
         * @see `punycode.ucs2.encode`
         * @see <https://mathiasbynens.be/notes/javascript-encoding>
         * @memberOf punycode.ucs2
         * @name decode
         * @param {String} string The Unicode input string (UCS-2).
         * @returns {Array} The new array of code points.
         */
        function ucs2decode(string) {
          var output = [],
            counter = 0,
            length = string.length,
            value,
            extra;
          while (counter < length) {
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
              // high surrogate, and there is a next character
              extra = string.charCodeAt(counter++);
              if ((extra & 0xFC00) == 0xDC00) {
                // low surrogate
                output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
              } else {
                // unmatched surrogate; only append this code unit, in case the next
                // code unit is the high surrogate of a surrogate pair
                output.push(value);
                counter--;
              }
            } else {
              output.push(value);
            }
          }
          return output;
        }

        /**
         * Creates a string based on an array of numeric code points.
         * @see `punycode.ucs2.decode`
         * @memberOf punycode.ucs2
         * @name encode
         * @param {Array} codePoints The array of numeric code points.
         * @returns {String} The new Unicode string (UCS-2).
         */
        function ucs2encode(array) {
          return map(array, function (value) {
            var output = '';
            if (value > 0xFFFF) {
              value -= 0x10000;
              output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
              value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
          }).join('');
        }

        /**
         * Converts a basic code point into a digit/integer.
         * @see `digitToBasic()`
         * @private
         * @param {Number} codePoint The basic numeric code point value.
         * @returns {Number} The numeric value of a basic code point (for use in
         * representing integers) in the range `0` to `base - 1`, or `base` if
         * the code point does not represent a value.
         */
        function basicToDigit(codePoint) {
          if (codePoint - 48 < 10) {
            return codePoint - 22;
          }
          if (codePoint - 65 < 26) {
            return codePoint - 65;
          }
          if (codePoint - 97 < 26) {
            return codePoint - 97;
          }
          return base;
        }

        /**
         * Converts a digit/integer into a basic code point.
         * @see `basicToDigit()`
         * @private
         * @param {Number} digit The numeric value of a basic code point.
         * @returns {Number} The basic code point whose value (when used for
         * representing integers) is `digit`, which needs to be in the range
         * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
         * used; else, the lowercase form is used. The behavior is undefined
         * if `flag` is non-zero and `digit` has no uppercase form.
         */
        function digitToBasic(digit, flag) {
          //  0..25 map to ASCII a..z or A..Z
          // 26..35 map to ASCII 0..9
          return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
        }

        /**
         * Bias adaptation function as per section 3.4 of RFC 3492.
         * https://tools.ietf.org/html/rfc3492#section-3.4
         * @private
         */
        function adapt(delta, numPoints, firstTime) {
          var k = 0;
          delta = firstTime ? floor(delta / damp) : delta >> 1;
          delta += floor(delta / numPoints);
          for /* no initialization */
          (; delta > baseMinusTMin * tMax >> 1; k += base) {
            delta = floor(delta / baseMinusTMin);
          }
          return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
        }

        /**
         * Converts a Punycode string of ASCII-only symbols to a string of Unicode
         * symbols.
         * @memberOf punycode
         * @param {String} input The Punycode string of ASCII-only symbols.
         * @returns {String} The resulting string of Unicode symbols.
         */
        function decode(input) {
          // Don't use UCS-2
          var output = [],
            inputLength = input.length,
            out,
            i = 0,
            n = initialN,
            bias = initialBias,
            basic,
            j,
            index,
            oldi,
            w,
            k,
            digit,
            t,
            /** Cached calculation results */
            baseMinusT;

          // Handle the basic code points: let `basic` be the number of input code
          // points before the last delimiter, or `0` if there is none, then copy
          // the first basic code points to the output.

          basic = input.lastIndexOf(delimiter);
          if (basic < 0) {
            basic = 0;
          }
          for (j = 0; j < basic; ++j) {
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) {
              error('not-basic');
            }
            output.push(input.charCodeAt(j));
          }

          // Main decoding loop: start just after the last delimiter if any basic code
          // points were copied; start at the beginning otherwise.

          for /* no final expression */
          (index = basic > 0 ? basic + 1 : 0; index < inputLength;) {
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for /* no condition */
            (oldi = i, w = 1, k = base;; k += base) {
              if (index >= inputLength) {
                error('invalid-input');
              }
              digit = basicToDigit(input.charCodeAt(index++));
              if (digit >= base || digit > floor((maxInt - i) / w)) {
                error('overflow');
              }
              i += digit * w;
              t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
              if (digit < t) {
                break;
              }
              baseMinusT = base - t;
              if (w > floor(maxInt / baseMinusT)) {
                error('overflow');
              }
              w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);

            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) {
              error('overflow');
            }
            n += floor(i / out);
            i %= out;

            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
          }
          return ucs2encode(output);
        }

        /**
         * Converts a string of Unicode symbols (e.g. a domain name label) to a
         * Punycode string of ASCII-only symbols.
         * @memberOf punycode
         * @param {String} input The string of Unicode symbols.
         * @returns {String} The resulting Punycode string of ASCII-only symbols.
         */
        function encode(input) {
          var n,
            delta,
            handledCPCount,
            basicLength,
            bias,
            j,
            m,
            q,
            k,
            t,
            currentValue,
            output = [],
            /** `inputLength` will hold the number of code points in `input`. */
            inputLength,
            /** Cached calculation results */
            handledCPCountPlusOne,
            baseMinusT,
            qMinusT;

          // Convert the input in UCS-2 to Unicode
          input = ucs2decode(input);

          // Cache the length
          inputLength = input.length;

          // Initialize the state
          n = initialN;
          delta = 0;
          bias = initialBias;

          // Handle the basic code points
          for (j = 0; j < inputLength; ++j) {
            currentValue = input[j];
            if (currentValue < 0x80) {
              output.push(stringFromCharCode(currentValue));
            }
          }
          handledCPCount = basicLength = output.length;

          // `handledCPCount` is the number of code points that have been handled;
          // `basicLength` is the number of basic code points.

          // Finish the basic string - if it is not empty - with a delimiter
          if (basicLength) {
            output.push(delimiter);
          }

          // Main encoding loop:
          while (handledCPCount < inputLength) {
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for (m = maxInt, j = 0; j < inputLength; ++j) {
              currentValue = input[j];
              if (currentValue >= n && currentValue < m) {
                m = currentValue;
              }
            }

            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
              error('overflow');
            }
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for (j = 0; j < inputLength; ++j) {
              currentValue = input[j];
              if (currentValue < n && ++delta > maxInt) {
                error('overflow');
              }
              if (currentValue == n) {
                // Represent delta as a generalized variable-length integer
                for /* no condition */
                (q = delta, k = base;; k += base) {
                  t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                  if (q < t) {
                    break;
                  }
                  qMinusT = q - t;
                  baseMinusT = base - t;
                  output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                  q = floor(qMinusT / baseMinusT);
                }
                output.push(stringFromCharCode(digitToBasic(q, 0)));
                bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                delta = 0;
                ++handledCPCount;
              }
            }
            ++delta;
            ++n;
          }
          return output.join('');
        }

        /**
         * Converts a Punycode string representing a domain name or an email address
         * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
         * it doesn't matter if you call it on a string that has already been
         * converted to Unicode.
         * @memberOf punycode
         * @param {String} input The Punycoded domain name or email address to
         * convert to Unicode.
         * @returns {String} The Unicode representation of the given Punycode
         * string.
         */
        function toUnicode(input) {
          return mapDomain(input, function (string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
          });
        }

        /**
         * Converts a Unicode string representing a domain name or an email address to
         * Punycode. Only the non-ASCII parts of the domain name will be converted,
         * i.e. it doesn't matter if you call it with a domain that's already in
         * ASCII.
         * @memberOf punycode
         * @param {String} input The domain name or email address to convert, as a
         * Unicode string.
         * @returns {String} The Punycode representation of the given domain name or
         * email address.
         */
        function toASCII(input) {
          return mapDomain(input, function (string) {
            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
          });
        }

        /*--------------------------------------------------------------------------*/

        /** Define the public API */
        punycode = {
          /**
           * A string representing the current Punycode.js version number.
           * @memberOf punycode
           * @type String
           */
          'version': '1.4.1',
          /**
           * An object of methods to convert from JavaScript's internal character
           * representation (UCS-2) to Unicode code points, and back.
           * @see <https://mathiasbynens.be/notes/javascript-encoding>
           * @memberOf punycode
           * @type Object
           */
          'ucs2': {
            'decode': ucs2decode,
            'encode': ucs2encode
          },
          'decode': decode,
          'encode': encode,
          'toASCII': toASCII,
          'toUnicode': toUnicode
        };

        /** Expose `punycode` */
        // Some AMD build optimizers, like r.js, check for specific condition patterns
        // like the following:
        if (true) {
          !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
            return punycode;
          }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (freeExports && freeModule) {
          if (module.exports == freeExports) {
            // in Node.js, io.js, or RingoJS v0.8.0+
            freeModule.exports = punycode;
          } else {
            // in Narwhal or RingoJS v0.7.0-
            for (key in punycode) {
              punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
            }
          }
        } else {
          // in Rhino or a web browser
          root.punycode = punycode;
        }
      })(this);

      /* WEBPACK VAR INJECTION */
    }).call(exports, __webpack_require__(106)(module), __webpack_require__(80));

    /***/
  }), ( /* 521 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    var _extends3 = __webpack_require__(7);
    var _extends4 = _interopRequireDefault(_extends3);
    var _objectWithoutProperties2 = __webpack_require__(17);
    var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
    var _classCallCheck2 = __webpack_require__(12);
    var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
    var _possibleConstructorReturn2 = __webpack_require__(14);
    var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
    var _inherits2 = __webpack_require__(13);
    var _inherits3 = _interopRequireDefault(_inherits2);
    var _classnames = __webpack_require__(24);
    var _classnames2 = _interopRequireDefault(_classnames);
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _propTypes = __webpack_require__(10);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _all = __webpack_require__(138);
    var _all2 = _interopRequireDefault(_all);
    var _Button = __webpack_require__(219);
    var _Button2 = _interopRequireDefault(_Button);
    var _bootstrapUtils = __webpack_require__(41);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        'default': obj
      };
    }
    var propTypes = {
      vertical: _propTypes2['default'].bool,
      justified: _propTypes2['default'].bool,
      /**
       * Display block buttons; only useful when used with the "vertical" prop.
       * @type {bool}
       */
      block: (0, _all2['default'])(_propTypes2['default'].bool, function (_ref) {
        var block = _ref.block,
          vertical = _ref.vertical;
        return block && !vertical ? new Error('`block` requires `vertical` to be set to have any effect') : null;
      })
    };
    var defaultProps = {
      block: false,
      justified: false,
      vertical: false
    };
    var ButtonGroup = function (_React$Component) {
      (0, _inherits3['default'])(ButtonGroup, _React$Component);
      function ButtonGroup() {
        (0, _classCallCheck3['default'])(this, ButtonGroup);
        return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
      }
      ButtonGroup.prototype.render = function render() {
        var _extends2;
        var _props = this.props,
          block = _props.block,
          justified = _props.justified,
          vertical = _props.vertical,
          className = _props.className,
          props = (0, _objectWithoutProperties3['default'])(_props, ['block', 'justified', 'vertical', 'className']);
        var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
          bsProps = _splitBsProps[0],
          elementProps = _splitBsProps[1];
        var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps)] = !vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'vertical')] = vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2[(0, _bootstrapUtils.prefix)(_Button2['default'].defaultProps, 'block')] = block, _extends2));
        return _react2['default'].createElement('div', (0, _extends4['default'])({}, elementProps, {
          className: (0, _classnames2['default'])(className, classes)
        }));
      };
      return ButtonGroup;
    }(_react2['default'].Component);
    ButtonGroup.propTypes = propTypes;
    ButtonGroup.defaultProps = defaultProps;
    exports['default'] = (0, _bootstrapUtils.bsClass)('btn-group', ButtonGroup);
    module.exports = exports['default'];

    /***/
  }), ( /* 522 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    var _objectWithoutProperties2 = __webpack_require__(17);
    var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
    var _extends2 = __webpack_require__(7);
    var _extends3 = _interopRequireDefault(_extends2);
    var _classCallCheck2 = __webpack_require__(12);
    var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
    var _possibleConstructorReturn2 = __webpack_require__(14);
    var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
    var _inherits2 = __webpack_require__(13);
    var _inherits3 = _interopRequireDefault(_inherits2);
    var _classnames = __webpack_require__(24);
    var _classnames2 = _interopRequireDefault(_classnames);
    var _activeElement = __webpack_require__(391);
    var _activeElement2 = _interopRequireDefault(_activeElement);
    var _contains = __webpack_require__(89);
    var _contains2 = _interopRequireDefault(_contains);
    var _keycode = __webpack_require__(134);
    var _keycode2 = _interopRequireDefault(_keycode);
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _propTypes = __webpack_require__(10);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _reactDom = __webpack_require__(4);
    var _reactDom2 = _interopRequireDefault(_reactDom);
    var _all = __webpack_require__(138);
    var _all2 = _interopRequireDefault(_all);
    var _elementType = __webpack_require__(72);
    var _elementType2 = _interopRequireDefault(_elementType);
    var _isRequiredForA11y = __webpack_require__(218);
    var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
    var _uncontrollable = __webpack_require__(696);
    var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
    var _warning = __webpack_require__(255);
    var _warning2 = _interopRequireDefault(_warning);
    var _ButtonGroup = __webpack_require__(521);
    var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
    var _DropdownMenu = __webpack_require__(524);
    var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
    var _DropdownToggle = __webpack_require__(525);
    var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
    var _bootstrapUtils = __webpack_require__(41);
    var _createChainedFunction = __webpack_require__(96);
    var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
    var _PropTypes = __webpack_require__(531);
    var _ValidComponentChildren = __webpack_require__(141);
    var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        'default': obj
      };
    }
    var TOGGLE_ROLE = _DropdownToggle2['default'].defaultProps.bsRole;
    var MENU_ROLE = _DropdownMenu2['default'].defaultProps.bsRole;
    var propTypes = {
      /**
       * The menu will open above the dropdown button, instead of below it.
       */
      dropup: _propTypes2['default'].bool,
      /**
       * An html id attribute, necessary for assistive technologies, such as screen readers.
       * @type {string|number}
       * @required
       */
      id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
      componentClass: _elementType2['default'],
      /**
       * The children of a Dropdown may be a `<Dropdown.Toggle>` or a `<Dropdown.Menu>`.
       * @type {node}
       */
      children: (0, _all2['default'])((0, _PropTypes.requiredRoles)(TOGGLE_ROLE, MENU_ROLE), (0, _PropTypes.exclusiveRoles)(MENU_ROLE)),
      /**
       * Whether or not component is disabled.
       */
      disabled: _propTypes2['default'].bool,
      /**
       * Align the menu to the right side of the Dropdown toggle
       */
      pullRight: _propTypes2['default'].bool,
      /**
       * Whether or not the Dropdown is visible.
       *
       * @controllable onToggle
       */
      open: _propTypes2['default'].bool,
      defaultOpen: _propTypes2['default'].bool,
      /**
       * A callback fired when the Dropdown wishes to change visibility. Called with the requested
       * `open` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
       *
       * ```js
       * function(Boolean isOpen, Object event, { String source }) {}
       * ```
       * @controllable open
       */
      onToggle: _propTypes2['default'].func,
      /**
       * A callback fired when a menu item is selected.
       *
       * ```js
       * (eventKey: any, event: Object) => any
       * ```
       */
      onSelect: _propTypes2['default'].func,
      /**
       * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
       * a menu button.
       */
      role: _propTypes2['default'].string,
      /**
       * Which event when fired outside the component will cause it to be closed
       */
      rootCloseEvent: _propTypes2['default'].oneOf(['click', 'mousedown']),
      /**
       * @private
       */
      onMouseEnter: _propTypes2['default'].func,
      /**
       * @private
       */
      onMouseLeave: _propTypes2['default'].func
    };
    var defaultProps = {
      componentClass: _ButtonGroup2['default']
    };
    var Dropdown = function (_React$Component) {
      (0, _inherits3['default'])(Dropdown, _React$Component);
      function Dropdown(props, context) {
        (0, _classCallCheck3['default'])(this, Dropdown);
        var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
        _this.handleClose = _this.handleClose.bind(_this);
        _this._focusInDropdown = false;
        _this.lastOpenEventType = null;
        return _this;
      }
      Dropdown.prototype.componentDidMount = function componentDidMount() {
        this.focusNextOnOpen();
      };
      Dropdown.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
        if (!nextProps.open && this.props.open) {
          this._focusInDropdown = (0, _contains2['default'])(_reactDom2['default'].findDOMNode(this.menu), (0, _activeElement2['default'])(document));
        }
      };
      Dropdown.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        var open = this.props.open;
        var prevOpen = prevProps.open;
        if (open && !prevOpen) {
          this.focusNextOnOpen();
        }
        if (!open && prevOpen) {
          // if focus hasn't already moved from the menu let's return it
          // to the toggle
          if (this._focusInDropdown) {
            this._focusInDropdown = false;
            this.focus();
          }
        }
      };
      Dropdown.prototype.handleClick = function handleClick(event) {
        if (this.props.disabled) {
          return;
        }
        this.toggleOpen(event, {
          source: 'click'
        });
      };
      Dropdown.prototype.handleKeyDown = function handleKeyDown(event) {
        if (this.props.disabled) {
          return;
        }
        switch (event.keyCode) {
          case _keycode2['default'].codes.down:
            if (!this.props.open) {
              this.toggleOpen(event, {
                source: 'keydown'
              });
            } else if (this.menu.focusNext) {
              this.menu.focusNext();
            }
            event.preventDefault();
            break;
          case _keycode2['default'].codes.esc:
          case _keycode2['default'].codes.tab:
            this.handleClose(event, {
              source: 'keydown'
            });
            break;
          default:
        }
      };
      Dropdown.prototype.toggleOpen = function toggleOpen(event, eventDetails) {
        var open = !this.props.open;
        if (open) {
          this.lastOpenEventType = eventDetails.source;
        }
        if (this.props.onToggle) {
          this.props.onToggle(open, event, eventDetails);
        }
      };
      Dropdown.prototype.handleClose = function handleClose(event, eventDetails) {
        if (!this.props.open) {
          return;
        }
        this.toggleOpen(event, eventDetails);
      };
      Dropdown.prototype.focusNextOnOpen = function focusNextOnOpen() {
        var menu = this.menu;
        if (!menu.focusNext) {
          return;
        }
        if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
          menu.focusNext();
        }
      };
      Dropdown.prototype.focus = function focus() {
        var toggle = _reactDom2['default'].findDOMNode(this.toggle);
        if (toggle && toggle.focus) {
          toggle.focus();
        }
      };
      Dropdown.prototype.renderToggle = function renderToggle(child, props) {
        var _this2 = this;
        var ref = function ref(c) {
          _this2.toggle = c;
        };
        if (typeof child.ref === 'string') {
          false ? (0, _warning2['default'])(false, 'String refs are not supported on `<Dropdown.Toggle>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
        } else {
          ref = (0, _createChainedFunction2['default'])(child.ref, ref);
        }
        return (0, _react.cloneElement)(child, (0, _extends3['default'])({}, props, {
          ref: ref,
          bsClass: (0, _bootstrapUtils.prefix)(props, 'toggle'),
          onClick: (0, _createChainedFunction2['default'])(child.props.onClick, this.handleClick),
          onKeyDown: (0, _createChainedFunction2['default'])(child.props.onKeyDown, this.handleKeyDown)
        }));
      };
      Dropdown.prototype.renderMenu = function renderMenu(child, _ref) {
        var _this3 = this;
        var id = _ref.id,
          onSelect = _ref.onSelect,
          rootCloseEvent = _ref.rootCloseEvent,
          props = (0, _objectWithoutProperties3['default'])(_ref, ['id', 'onSelect', 'rootCloseEvent']);
        var ref = function ref(c) {
          _this3.menu = c;
        };
        if (typeof child.ref === 'string') {
          false ? (0, _warning2['default'])(false, 'String refs are not supported on `<Dropdown.Menu>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
        } else {
          ref = (0, _createChainedFunction2['default'])(child.ref, ref);
        }
        return (0, _react.cloneElement)(child, (0, _extends3['default'])({}, props, {
          ref: ref,
          labelledBy: id,
          bsClass: (0, _bootstrapUtils.prefix)(props, 'menu'),
          onClose: (0, _createChainedFunction2['default'])(child.props.onClose, this.handleClose),
          onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect, function (key, event) {
            return _this3.handleClose(event, {
              source: 'select'
            });
          }),
          rootCloseEvent: rootCloseEvent
        }));
      };
      Dropdown.prototype.render = function render() {
        var _classes,
          _this4 = this;
        var _props = this.props,
          Component = _props.componentClass,
          id = _props.id,
          dropup = _props.dropup,
          disabled = _props.disabled,
          pullRight = _props.pullRight,
          open = _props.open,
          onSelect = _props.onSelect,
          role = _props.role,
          bsClass = _props.bsClass,
          className = _props.className,
          rootCloseEvent = _props.rootCloseEvent,
          children = _props.children,
          props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'id', 'dropup', 'disabled', 'pullRight', 'open', 'onSelect', 'role', 'bsClass', 'className', 'rootCloseEvent', 'children']);
        delete props.onToggle;
        var classes = (_classes = {}, _classes[bsClass] = true, _classes.open = open, _classes.disabled = disabled, _classes);
        if (dropup) {
          classes[bsClass] = false;
          classes.dropup = true;
        }

        // This intentionally forwards bsSize and bsStyle (if set) to the
        // underlying component, to allow it to render size and style variants.

        return _react2['default'].createElement(Component, (0, _extends3['default'])({}, props, {
          className: (0, _classnames2['default'])(className, classes)
        }), _ValidComponentChildren2['default'].map(children, function (child) {
          switch (child.props.bsRole) {
            case TOGGLE_ROLE:
              return _this4.renderToggle(child, {
                id: id,
                disabled: disabled,
                open: open,
                role: role,
                bsClass: bsClass
              });
            case MENU_ROLE:
              return _this4.renderMenu(child, {
                id: id,
                open: open,
                pullRight: pullRight,
                bsClass: bsClass,
                onSelect: onSelect,
                rootCloseEvent: rootCloseEvent
              });
            default:
              return child;
          }
        }));
      };
      return Dropdown;
    }(_react2['default'].Component);
    Dropdown.propTypes = propTypes;
    Dropdown.defaultProps = defaultProps;
    (0, _bootstrapUtils.bsClass)('dropdown', Dropdown);
    var UncontrolledDropdown = (0, _uncontrollable2['default'])(Dropdown, {
      open: 'onToggle'
    });
    UncontrolledDropdown.Toggle = _DropdownToggle2['default'];
    UncontrolledDropdown.Menu = _DropdownMenu2['default'];
    exports['default'] = UncontrolledDropdown;
    module.exports = exports['default'];

    /***/
  }), ( /* 523 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    var _objectWithoutProperties2 = __webpack_require__(17);
    var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
    var _classCallCheck2 = __webpack_require__(12);
    var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
    var _possibleConstructorReturn2 = __webpack_require__(14);
    var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
    var _inherits2 = __webpack_require__(13);
    var _inherits3 = _interopRequireDefault(_inherits2);
    var _extends2 = __webpack_require__(7);
    var _extends3 = _interopRequireDefault(_extends2);
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _propTypes = __webpack_require__(10);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _Dropdown = __webpack_require__(522);
    var _Dropdown2 = _interopRequireDefault(_Dropdown);
    var _splitComponentProps2 = __webpack_require__(532);
    var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        'default': obj
      };
    }
    var propTypes = (0, _extends3['default'])({}, _Dropdown2['default'].propTypes, {
      // Toggle props.
      bsStyle: _propTypes2['default'].string,
      bsSize: _propTypes2['default'].string,
      title: _propTypes2['default'].node.isRequired,
      noCaret: _propTypes2['default'].bool,
      // Override generated docs from <Dropdown>.
      /**
       * @private
       */
      children: _propTypes2['default'].node
    });
    var DropdownButton = function (_React$Component) {
      (0, _inherits3['default'])(DropdownButton, _React$Component);
      function DropdownButton() {
        (0, _classCallCheck3['default'])(this, DropdownButton);
        return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
      }
      DropdownButton.prototype.render = function render() {
        var _props = this.props,
          bsSize = _props.bsSize,
          bsStyle = _props.bsStyle,
          title = _props.title,
          children = _props.children,
          props = (0, _objectWithoutProperties3['default'])(_props, ['bsSize', 'bsStyle', 'title', 'children']);
        var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Dropdown2['default'].ControlledComponent),
          dropdownProps = _splitComponentProps[0],
          toggleProps = _splitComponentProps[1];
        return _react2['default'].createElement(_Dropdown2['default'], (0, _extends3['default'])({}, dropdownProps, {
          bsSize: bsSize,
          bsStyle: bsStyle
        }), _react2['default'].createElement(_Dropdown2['default'].Toggle, (0, _extends3['default'])({}, toggleProps, {
          bsSize: bsSize,
          bsStyle: bsStyle
        }), title), _react2['default'].createElement(_Dropdown2['default'].Menu, null, children));
      };
      return DropdownButton;
    }(_react2['default'].Component);
    DropdownButton.propTypes = propTypes;
    exports['default'] = DropdownButton;
    module.exports = exports['default'];

    /***/
  }), ( /* 524 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    var _extends3 = __webpack_require__(7);
    var _extends4 = _interopRequireDefault(_extends3);
    var _objectWithoutProperties2 = __webpack_require__(17);
    var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
    var _from = __webpack_require__(278);
    var _from2 = _interopRequireDefault(_from);
    var _classCallCheck2 = __webpack_require__(12);
    var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
    var _possibleConstructorReturn2 = __webpack_require__(14);
    var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
    var _inherits2 = __webpack_require__(13);
    var _inherits3 = _interopRequireDefault(_inherits2);
    var _classnames = __webpack_require__(24);
    var _classnames2 = _interopRequireDefault(_classnames);
    var _keycode = __webpack_require__(134);
    var _keycode2 = _interopRequireDefault(_keycode);
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _propTypes = __webpack_require__(10);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _reactDom = __webpack_require__(4);
    var _reactDom2 = _interopRequireDefault(_reactDom);
    var _RootCloseWrapper = __webpack_require__(221);
    var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
    var _bootstrapUtils = __webpack_require__(41);
    var _createChainedFunction = __webpack_require__(96);
    var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
    var _ValidComponentChildren = __webpack_require__(141);
    var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        'default': obj
      };
    }
    var propTypes = {
      open: _propTypes2['default'].bool,
      pullRight: _propTypes2['default'].bool,
      onClose: _propTypes2['default'].func,
      labelledBy: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
      onSelect: _propTypes2['default'].func,
      rootCloseEvent: _propTypes2['default'].oneOf(['click', 'mousedown'])
    };
    var defaultProps = {
      bsRole: 'menu',
      pullRight: false
    };
    var DropdownMenu = function (_React$Component) {
      (0, _inherits3['default'])(DropdownMenu, _React$Component);
      function DropdownMenu(props) {
        (0, _classCallCheck3['default'])(this, DropdownMenu);
        var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
        _this.handleRootClose = _this.handleRootClose.bind(_this);
        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
        return _this;
      }
      DropdownMenu.prototype.handleRootClose = function handleRootClose(event) {
        this.props.onClose(event, {
          source: 'rootClose'
        });
      };
      DropdownMenu.prototype.handleKeyDown = function handleKeyDown(event) {
        switch (event.keyCode) {
          case _keycode2['default'].codes.down:
            this.focusNext();
            event.preventDefault();
            break;
          case _keycode2['default'].codes.up:
            this.focusPrevious();
            event.preventDefault();
            break;
          case _keycode2['default'].codes.esc:
          case _keycode2['default'].codes.tab:
            this.props.onClose(event, {
              source: 'keydown'
            });
            break;
          default:
        }
      };
      DropdownMenu.prototype.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
        var items = this.getFocusableMenuItems();
        var activeIndex = items.indexOf(document.activeElement);
        return {
          items: items,
          activeIndex: activeIndex
        };
      };
      DropdownMenu.prototype.getFocusableMenuItems = function getFocusableMenuItems() {
        var node = _reactDom2['default'].findDOMNode(this);
        if (!node) {
          return [];
        }
        return (0, _from2['default'])(node.querySelectorAll('[tabIndex="-1"]'));
      };
      DropdownMenu.prototype.focusNext = function focusNext() {
        var _getItemsAndActiveInd = this.getItemsAndActiveIndex(),
          items = _getItemsAndActiveInd.items,
          activeIndex = _getItemsAndActiveInd.activeIndex;
        if (items.length === 0) {
          return;
        }
        var nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
        items[nextIndex].focus();
      };
      DropdownMenu.prototype.focusPrevious = function focusPrevious() {
        var _getItemsAndActiveInd2 = this.getItemsAndActiveIndex(),
          items = _getItemsAndActiveInd2.items,
          activeIndex = _getItemsAndActiveInd2.activeIndex;
        if (items.length === 0) {
          return;
        }
        var prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
        items[prevIndex].focus();
      };
      DropdownMenu.prototype.render = function render() {
        var _extends2,
          _this2 = this;
        var _props = this.props,
          open = _props.open,
          pullRight = _props.pullRight,
          labelledBy = _props.labelledBy,
          onSelect = _props.onSelect,
          className = _props.className,
          rootCloseEvent = _props.rootCloseEvent,
          children = _props.children,
          props = (0, _objectWithoutProperties3['default'])(_props, ['open', 'pullRight', 'labelledBy', 'onSelect', 'className', 'rootCloseEvent', 'children']);
        var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['onClose']),
          bsProps = _splitBsPropsAndOmit[0],
          elementProps = _splitBsPropsAndOmit[1];
        var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'right')] = pullRight, _extends2));
        return _react2['default'].createElement(_RootCloseWrapper2['default'], {
          disabled: !open,
          onRootClose: this.handleRootClose,
          event: rootCloseEvent
        }, _react2['default'].createElement('ul', (0, _extends4['default'])({}, elementProps, {
          role: 'menu',
          className: (0, _classnames2['default'])(className, classes),
          'aria-labelledby': labelledBy
        }), _ValidComponentChildren2['default'].map(children, function (child) {
          return _react2['default'].cloneElement(child, {
            onKeyDown: (0, _createChainedFunction2['default'])(child.props.onKeyDown, _this2.handleKeyDown),
            onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect)
          });
        })));
      };
      return DropdownMenu;
    }(_react2['default'].Component);
    DropdownMenu.propTypes = propTypes;
    DropdownMenu.defaultProps = defaultProps;
    exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown-menu', DropdownMenu);
    module.exports = exports['default'];

    /***/
  }), ( /* 525 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    var _extends2 = __webpack_require__(7);
    var _extends3 = _interopRequireDefault(_extends2);
    var _objectWithoutProperties2 = __webpack_require__(17);
    var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
    var _classCallCheck2 = __webpack_require__(12);
    var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
    var _possibleConstructorReturn2 = __webpack_require__(14);
    var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
    var _inherits2 = __webpack_require__(13);
    var _inherits3 = _interopRequireDefault(_inherits2);
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _propTypes = __webpack_require__(10);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _classnames = __webpack_require__(24);
    var _classnames2 = _interopRequireDefault(_classnames);
    var _Button = __webpack_require__(219);
    var _Button2 = _interopRequireDefault(_Button);
    var _SafeAnchor = __webpack_require__(140);
    var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
    var _bootstrapUtils = __webpack_require__(41);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        'default': obj
      };
    }
    var propTypes = {
      noCaret: _propTypes2['default'].bool,
      open: _propTypes2['default'].bool,
      title: _propTypes2['default'].string,
      useAnchor: _propTypes2['default'].bool
    };
    var defaultProps = {
      open: false,
      useAnchor: false,
      bsRole: 'toggle'
    };
    var DropdownToggle = function (_React$Component) {
      (0, _inherits3['default'])(DropdownToggle, _React$Component);
      function DropdownToggle() {
        (0, _classCallCheck3['default'])(this, DropdownToggle);
        return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
      }
      DropdownToggle.prototype.render = function render() {
        var _props = this.props,
          noCaret = _props.noCaret,
          open = _props.open,
          useAnchor = _props.useAnchor,
          bsClass = _props.bsClass,
          className = _props.className,
          children = _props.children,
          props = (0, _objectWithoutProperties3['default'])(_props, ['noCaret', 'open', 'useAnchor', 'bsClass', 'className', 'children']);
        delete props.bsRole;
        var Component = useAnchor ? _SafeAnchor2['default'] : _Button2['default'];
        var useCaret = !noCaret;

        // This intentionally forwards bsSize and bsStyle (if set) to the
        // underlying component, to allow it to render size and style variants.

        // FIXME: Should this really fall back to `title` as children?

        return _react2['default'].createElement(Component, (0, _extends3['default'])({}, props, {
          role: 'button',
          className: (0, _classnames2['default'])(className, bsClass),
          'aria-haspopup': true,
          'aria-expanded': open
        }), children || props.title, useCaret && ' ', useCaret && _react2['default'].createElement('span', {
          className: 'caret'
        }));
      };
      return DropdownToggle;
    }(_react2['default'].Component);
    DropdownToggle.propTypes = propTypes;
    DropdownToggle.defaultProps = defaultProps;
    exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown-toggle', DropdownToggle);
    module.exports = exports['default'];

    /***/
  }), ( /* 526 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    var _extends2 = __webpack_require__(7);
    var _extends3 = _interopRequireDefault(_extends2);
    var _classCallCheck2 = __webpack_require__(12);
    var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
    var _possibleConstructorReturn2 = __webpack_require__(14);
    var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
    var _inherits2 = __webpack_require__(13);
    var _inherits3 = _interopRequireDefault(_inherits2);
    var _classnames = __webpack_require__(24);
    var _classnames2 = _interopRequireDefault(_classnames);
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _propTypes = __webpack_require__(10);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _Transition = __webpack_require__(542);
    var _Transition2 = _interopRequireDefault(_Transition);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        'default': obj
      };
    }
    var propTypes = {
      /**
       * Show the component; triggers the fade in or fade out animation
       */
      'in': _propTypes2['default'].bool,
      /**
       * Wait until the first "enter" transition to mount the component (add it to the DOM)
       */
      mountOnEnter: _propTypes2['default'].bool,
      /**
       * Unmount the component (remove it from the DOM) when it is faded out
       */
      unmountOnExit: _propTypes2['default'].bool,
      /**
       * Run the fade in animation when the component mounts, if it is initially
       * shown
       */
      transitionAppear: _propTypes2['default'].bool,
      /**
       * Duration of the fade animation in milliseconds, to ensure that finishing
       * callbacks are fired even if the original browser transition end events are
       * canceled
       */
      timeout: _propTypes2['default'].number,
      /**
       * Callback fired before the component fades in
       */
      onEnter: _propTypes2['default'].func,
      /**
       * Callback fired after the component starts to fade in
       */
      onEntering: _propTypes2['default'].func,
      /**
       * Callback fired after the has component faded in
       */
      onEntered: _propTypes2['default'].func,
      /**
       * Callback fired before the component fades out
       */
      onExit: _propTypes2['default'].func,
      /**
       * Callback fired after the component starts to fade out
       */
      onExiting: _propTypes2['default'].func,
      /**
       * Callback fired after the component has faded out
       */
      onExited: _propTypes2['default'].func
    };
    var defaultProps = {
      'in': false,
      timeout: 300,
      mountOnEnter: false,
      unmountOnExit: false,
      transitionAppear: false
    };
    var Fade = function (_React$Component) {
      (0, _inherits3['default'])(Fade, _React$Component);
      function Fade() {
        (0, _classCallCheck3['default'])(this, Fade);
        return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
      }
      Fade.prototype.render = function render() {
        return _react2['default'].createElement(_Transition2['default'], (0, _extends3['default'])({}, this.props, {
          className: (0, _classnames2['default'])(this.props.className, 'fade'),
          enteredClassName: 'in',
          enteringClassName: 'in'
        }));
      };
      return Fade;
    }(_react2['default'].Component);
    Fade.propTypes = propTypes;
    Fade.defaultProps = defaultProps;
    exports['default'] = Fade;
    module.exports = exports['default'];

    /***/
  }), ( /* 527 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    var _extends2 = __webpack_require__(7);
    var _extends3 = _interopRequireDefault(_extends2);
    var _objectWithoutProperties2 = __webpack_require__(17);
    var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
    var _classCallCheck2 = __webpack_require__(12);
    var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
    var _possibleConstructorReturn2 = __webpack_require__(14);
    var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
    var _inherits2 = __webpack_require__(13);
    var _inherits3 = _interopRequireDefault(_inherits2);
    var _classnames = __webpack_require__(24);
    var _classnames2 = _interopRequireDefault(_classnames);
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _propTypes = __webpack_require__(10);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _all = __webpack_require__(138);
    var _all2 = _interopRequireDefault(_all);
    var _SafeAnchor = __webpack_require__(140);
    var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
    var _bootstrapUtils = __webpack_require__(41);
    var _createChainedFunction = __webpack_require__(96);
    var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        'default': obj
      };
    }
    var propTypes = {
      /**
       * Highlight the menu item as active.
       */
      active: _propTypes2['default'].bool,
      /**
       * Disable the menu item, making it unselectable.
       */
      disabled: _propTypes2['default'].bool,
      /**
       * Styles the menu item as a horizontal rule, providing visual separation between
       * groups of menu items.
       */
      divider: (0, _all2['default'])(_propTypes2['default'].bool, function (_ref) {
        var divider = _ref.divider,
          children = _ref.children;
        return divider && children ? new Error('Children will not be rendered for dividers') : null;
      }),
      /**
       * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
       */
      eventKey: _propTypes2['default'].any,
      /**
       * Styles the menu item as a header label, useful for describing a group of menu items.
       */
      header: _propTypes2['default'].bool,
      /**
       * HTML `href` attribute corresponding to `a.href`.
       */
      href: _propTypes2['default'].string,
      /**
       * Callback fired when the menu item is clicked.
       */
      onClick: _propTypes2['default'].func,
      /**
       * Callback fired when the menu item is selected.
       *
       * ```js
       * (eventKey: any, event: Object) => any
       * ```
       */
      onSelect: _propTypes2['default'].func
    };
    var defaultProps = {
      divider: false,
      disabled: false,
      header: false
    };
    var MenuItem = function (_React$Component) {
      (0, _inherits3['default'])(MenuItem, _React$Component);
      function MenuItem(props, context) {
        (0, _classCallCheck3['default'])(this, MenuItem);
        var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
      }
      MenuItem.prototype.handleClick = function handleClick(event) {
        var _props = this.props,
          href = _props.href,
          disabled = _props.disabled,
          onSelect = _props.onSelect,
          eventKey = _props.eventKey;
        if (!href || disabled) {
          event.preventDefault();
        }
        if (disabled) {
          return;
        }
        if (onSelect) {
          onSelect(eventKey, event);
        }
      };
      MenuItem.prototype.render = function render() {
        var _props2 = this.props,
          active = _props2.active,
          disabled = _props2.disabled,
          divider = _props2.divider,
          header = _props2.header,
          onClick = _props2.onClick,
          className = _props2.className,
          style = _props2.style,
          props = (0, _objectWithoutProperties3['default'])(_props2, ['active', 'disabled', 'divider', 'header', 'onClick', 'className', 'style']);
        var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['eventKey', 'onSelect']),
          bsProps = _splitBsPropsAndOmit[0],
          elementProps = _splitBsPropsAndOmit[1];
        if (divider) {
          // Forcibly blank out the children; separators shouldn't render any.
          elementProps.children = undefined;
          return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
            role: 'separator',
            className: (0, _classnames2['default'])(className, 'divider'),
            style: style
          }));
        }
        if (header) {
          return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
            role: 'heading',
            className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(bsProps, 'header')),
            style: style
          }));
        }
        return _react2['default'].createElement('li', {
          role: 'presentation',
          className: (0, _classnames2['default'])(className, {
            active: active,
            disabled: disabled
          }),
          style: style
        }, _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, elementProps, {
          role: 'menuitem',
          tabIndex: '-1',
          onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
        })));
      };
      return MenuItem;
    }(_react2['default'].Component);
    MenuItem.propTypes = propTypes;
    MenuItem.defaultProps = defaultProps;
    exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown', MenuItem);
    module.exports = exports['default'];

    /***/
  }), ( /* 528 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    var _objectWithoutProperties2 = __webpack_require__(17);
    var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
    var _classCallCheck2 = __webpack_require__(12);
    var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
    var _possibleConstructorReturn2 = __webpack_require__(14);
    var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
    var _inherits2 = __webpack_require__(13);
    var _inherits3 = _interopRequireDefault(_inherits2);
    var _extends2 = __webpack_require__(7);
    var _extends3 = _interopRequireDefault(_extends2);
    var _classnames = __webpack_require__(24);
    var _classnames2 = _interopRequireDefault(_classnames);
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _propTypes = __webpack_require__(10);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _Overlay = __webpack_require__(539);
    var _Overlay2 = _interopRequireDefault(_Overlay);
    var _elementType = __webpack_require__(72);
    var _elementType2 = _interopRequireDefault(_elementType);
    var _Fade = __webpack_require__(526);
    var _Fade2 = _interopRequireDefault(_Fade);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        'default': obj
      };
    }
    var propTypes = (0, _extends3['default'])({}, _Overlay2['default'].propTypes, {
      /**
       * Set the visibility of the Overlay
       */
      show: _propTypes2['default'].bool,
      /**
       * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
       */
      rootClose: _propTypes2['default'].bool,
      /**
       * A callback invoked by the overlay when it wishes to be hidden. Required if
       * `rootClose` is specified.
       */
      onHide: _propTypes2['default'].func,
      /**
       * Use animation
       */
      animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
      /**
       * Callback fired before the Overlay transitions in
       */
      onEnter: _propTypes2['default'].func,
      /**
       * Callback fired as the Overlay begins to transition in
       */
      onEntering: _propTypes2['default'].func,
      /**
       * Callback fired after the Overlay finishes transitioning in
       */
      onEntered: _propTypes2['default'].func,
      /**
       * Callback fired right before the Overlay transitions out
       */
      onExit: _propTypes2['default'].func,
      /**
       * Callback fired as the Overlay begins to transition out
       */
      onExiting: _propTypes2['default'].func,
      /**
       * Callback fired after the Overlay finishes transitioning out
       */
      onExited: _propTypes2['default'].func,
      /**
       * Sets the direction of the Overlay.
       */
      placement: _propTypes2['default'].oneOf(['top', 'right', 'bottom', 'left'])
    });
    var defaultProps = {
      animation: _Fade2['default'],
      rootClose: false,
      show: false,
      placement: 'right'
    };
    var Overlay = function (_React$Component) {
      (0, _inherits3['default'])(Overlay, _React$Component);
      function Overlay() {
        (0, _classCallCheck3['default'])(this, Overlay);
        return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
      }
      Overlay.prototype.render = function render() {
        var _props = this.props,
          animation = _props.animation,
          children = _props.children,
          props = (0, _objectWithoutProperties3['default'])(_props, ['animation', 'children']);
        var transition = animation === true ? _Fade2['default'] : animation || null;
        var child = void 0;
        if (!transition) {
          child = (0, _react.cloneElement)(children, {
            className: (0, _classnames2['default'])(children.props.className, 'in')
          });
        } else {
          child = children;
        }
        return _react2['default'].createElement(_Overlay2['default'], (0, _extends3['default'])({}, props, {
          transition: transition
        }), child);
      };
      return Overlay;
    }(_react2['default'].Component);
    Overlay.propTypes = propTypes;
    Overlay.defaultProps = defaultProps;
    exports['default'] = Overlay;
    module.exports = exports['default'];

    /***/
  }), ( /* 529 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    var _objectWithoutProperties2 = __webpack_require__(17);
    var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
    var _classCallCheck2 = __webpack_require__(12);
    var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
    var _possibleConstructorReturn2 = __webpack_require__(14);
    var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
    var _inherits2 = __webpack_require__(13);
    var _inherits3 = _interopRequireDefault(_inherits2);
    var _extends2 = __webpack_require__(7);
    var _extends3 = _interopRequireDefault(_extends2);
    var _contains = __webpack_require__(89);
    var _contains2 = _interopRequireDefault(_contains);
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _propTypes = __webpack_require__(10);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _reactDom = __webpack_require__(4);
    var _reactDom2 = _interopRequireDefault(_reactDom);
    var _warning = __webpack_require__(255);
    var _warning2 = _interopRequireDefault(_warning);
    var _Overlay = __webpack_require__(528);
    var _Overlay2 = _interopRequireDefault(_Overlay);
    var _createChainedFunction = __webpack_require__(96);
    var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        'default': obj
      };
    }

    /**
     * Check if value one is inside or equal to the of value
     *
     * @param {string} one
     * @param {string|array} of
     * @returns {boolean}
     */
    function isOneOf(one, of) {
      if (Array.isArray(of)) {
        return of.indexOf(one) >= 0;
      }
      return one === of;
    }
    var triggerType = _propTypes2['default'].oneOf(['click', 'hover', 'focus']);
    var propTypes = (0, _extends3['default'])({}, _Overlay2['default'].propTypes, {
      /**
      * Specify which action or actions trigger Overlay visibility
      */
      trigger: _propTypes2['default'].oneOfType([triggerType, _propTypes2['default'].arrayOf(triggerType)]),
      /**
       * A millisecond delay amount to show and hide the Overlay once triggered
       */
      delay: _propTypes2['default'].number,
      /**
       * A millisecond delay amount before showing the Overlay once triggered.
       */
      delayShow: _propTypes2['default'].number,
      /**
       * A millisecond delay amount before hiding the Overlay once triggered.
       */
      delayHide: _propTypes2['default'].number,
      // FIXME: This should be `defaultShow`.
      /**
       * The initial visibility state of the Overlay. For more nuanced visibility
       * control, consider using the Overlay component directly.
       */
      defaultOverlayShown: _propTypes2['default'].bool,
      /**
       * An element or text to overlay next to the target.
       */
      overlay: _propTypes2['default'].node.isRequired,
      /**
       * @private
       */
      onBlur: _propTypes2['default'].func,
      /**
       * @private
       */
      onClick: _propTypes2['default'].func,
      /**
       * @private
       */
      onFocus: _propTypes2['default'].func,
      /**
       * @private
       */
      onMouseOut: _propTypes2['default'].func,
      /**
       * @private
       */
      onMouseOver: _propTypes2['default'].func,
      // Overridden props from `<Overlay>`.
      /**
       * @private
       */
      target: _propTypes2['default'].oneOf([null]),
      /**
      * @private
      */
      onHide: _propTypes2['default'].oneOf([null]),
      /**
       * @private
       */
      show: _propTypes2['default'].oneOf([null])
    });
    var defaultProps = {
      defaultOverlayShown: false,
      trigger: ['hover', 'focus']
    };
    var OverlayTrigger = function (_React$Component) {
      (0, _inherits3['default'])(OverlayTrigger, _React$Component);
      function OverlayTrigger(props, context) {
        (0, _classCallCheck3['default'])(this, OverlayTrigger);
        var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
        _this.handleToggle = _this.handleToggle.bind(_this);
        _this.handleDelayedShow = _this.handleDelayedShow.bind(_this);
        _this.handleDelayedHide = _this.handleDelayedHide.bind(_this);
        _this.handleHide = _this.handleHide.bind(_this);
        _this.handleMouseOver = function (e) {
          return _this.handleMouseOverOut(_this.handleDelayedShow, e);
        };
        _this.handleMouseOut = function (e) {
          return _this.handleMouseOverOut(_this.handleDelayedHide, e);
        };
        _this._mountNode = null;
        _this.state = {
          show: props.defaultOverlayShown
        };
        return _this;
      }
      OverlayTrigger.prototype.componentDidMount = function componentDidMount() {
        this._mountNode = document.createElement('div');
        this.renderOverlay();
      };
      OverlayTrigger.prototype.componentDidUpdate = function componentDidUpdate() {
        this.renderOverlay();
      };
      OverlayTrigger.prototype.componentWillUnmount = function componentWillUnmount() {
        _reactDom2['default'].unmountComponentAtNode(this._mountNode);
        this._mountNode = null;
        clearTimeout(this._hoverShowDelay);
        clearTimeout(this._hoverHideDelay);
      };
      OverlayTrigger.prototype.handleToggle = function handleToggle() {
        if (this.state.show) {
          this.hide();
        } else {
          this.show();
        }
      };
      OverlayTrigger.prototype.handleDelayedShow = function handleDelayedShow() {
        var _this2 = this;
        if (this._hoverHideDelay != null) {
          clearTimeout(this._hoverHideDelay);
          this._hoverHideDelay = null;
          return;
        }
        if (this.state.show || this._hoverShowDelay != null) {
          return;
        }
        var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;
        if (!delay) {
          this.show();
          return;
        }
        this._hoverShowDelay = setTimeout(function () {
          _this2._hoverShowDelay = null;
          _this2.show();
        }, delay);
      };
      OverlayTrigger.prototype.handleDelayedHide = function handleDelayedHide() {
        var _this3 = this;
        if (this._hoverShowDelay != null) {
          clearTimeout(this._hoverShowDelay);
          this._hoverShowDelay = null;
          return;
        }
        if (!this.state.show || this._hoverHideDelay != null) {
          return;
        }
        var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;
        if (!delay) {
          this.hide();
          return;
        }
        this._hoverHideDelay = setTimeout(function () {
          _this3._hoverHideDelay = null;
          _this3.hide();
        }, delay);
      };

      // Simple implementation of mouseEnter and mouseLeave.
      // React's built version is broken: https://github.com/facebook/react/issues/4251
      // for cases when the trigger is disabled and mouseOut/Over can cause flicker
      // moving from one child element to another.

      OverlayTrigger.prototype.handleMouseOverOut = function handleMouseOverOut(handler, e) {
        var target = e.currentTarget;
        var related = e.relatedTarget || e.nativeEvent.toElement;
        if (!related || related !== target && !(0, _contains2['default'])(target, related)) {
          handler(e);
        }
      };
      OverlayTrigger.prototype.handleHide = function handleHide() {
        this.hide();
      };
      OverlayTrigger.prototype.show = function show() {
        this.setState({
          show: true
        });
      };
      OverlayTrigger.prototype.hide = function hide() {
        this.setState({
          show: false
        });
      };
      OverlayTrigger.prototype.makeOverlay = function makeOverlay(overlay, props) {
        return _react2['default'].createElement(_Overlay2['default'], (0, _extends3['default'])({}, props, {
          show: this.state.show,
          onHide: this.handleHide,
          target: this
        }), overlay);
      };
      OverlayTrigger.prototype.renderOverlay = function renderOverlay() {
        _reactDom2['default'].unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
      };
      OverlayTrigger.prototype.render = function render() {
        var _props = this.props,
          trigger = _props.trigger,
          overlay = _props.overlay,
          children = _props.children,
          onBlur = _props.onBlur,
          onClick = _props.onClick,
          onFocus = _props.onFocus,
          onMouseOut = _props.onMouseOut,
          onMouseOver = _props.onMouseOver,
          props = (0, _objectWithoutProperties3['default'])(_props, ['trigger', 'overlay', 'children', 'onBlur', 'onClick', 'onFocus', 'onMouseOut', 'onMouseOver']);
        delete props.delay;
        delete props.delayShow;
        delete props.delayHide;
        delete props.defaultOverlayShown;
        var child = _react2['default'].Children.only(children);
        var childProps = child.props;
        var triggerProps = {};
        if (this.state.show) {
          triggerProps['aria-describedby'] = overlay.props.id;
        }

        // FIXME: The logic here for passing through handlers on this component is
        // inconsistent. We shouldn't be passing any of these props through.

        triggerProps.onClick = (0, _createChainedFunction2['default'])(childProps.onClick, onClick);
        if (isOneOf('click', trigger)) {
          triggerProps.onClick = (0, _createChainedFunction2['default'])(triggerProps.onClick, this.handleToggle);
        }
        if (isOneOf('hover', trigger)) {
          false ? (0, _warning2['default'])(!(trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.') : void 0;
          triggerProps.onMouseOver = (0, _createChainedFunction2['default'])(childProps.onMouseOver, onMouseOver, this.handleMouseOver);
          triggerProps.onMouseOut = (0, _createChainedFunction2['default'])(childProps.onMouseOut, onMouseOut, this.handleMouseOut);
        }
        if (isOneOf('focus', trigger)) {
          triggerProps.onFocus = (0, _createChainedFunction2['default'])(childProps.onFocus, onFocus, this.handleDelayedShow);
          triggerProps.onBlur = (0, _createChainedFunction2['default'])(childProps.onBlur, onBlur, this.handleDelayedHide);
        }
        this._overlay = this.makeOverlay(overlay, props);
        return (0, _react.cloneElement)(child, triggerProps);
      };
      return OverlayTrigger;
    }(_react2['default'].Component);
    OverlayTrigger.propTypes = propTypes;
    OverlayTrigger.defaultProps = defaultProps;
    exports['default'] = OverlayTrigger;
    module.exports = exports['default'];

    /***/
  }), ( /* 530 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    var _extends3 = __webpack_require__(7);
    var _extends4 = _interopRequireDefault(_extends3);
    var _objectWithoutProperties2 = __webpack_require__(17);
    var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
    var _classCallCheck2 = __webpack_require__(12);
    var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
    var _possibleConstructorReturn2 = __webpack_require__(14);
    var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
    var _inherits2 = __webpack_require__(13);
    var _inherits3 = _interopRequireDefault(_inherits2);
    var _classnames = __webpack_require__(24);
    var _classnames2 = _interopRequireDefault(_classnames);
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _propTypes = __webpack_require__(10);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _isRequiredForA11y = __webpack_require__(218);
    var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
    var _bootstrapUtils = __webpack_require__(41);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        'default': obj
      };
    }
    var propTypes = {
      /**
       * An html id attribute, necessary for accessibility
       * @type {string|number}
       * @required
       */
      id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
      /**
       * Sets the direction the Tooltip is positioned towards.
       */
      placement: _propTypes2['default'].oneOf(['top', 'right', 'bottom', 'left']),
      /**
       * The "top" position value for the Tooltip.
       */
      positionTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
      /**
       * The "left" position value for the Tooltip.
       */
      positionLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
      /**
       * The "top" position value for the Tooltip arrow.
       */
      arrowOffsetTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
      /**
       * The "left" position value for the Tooltip arrow.
       */
      arrowOffsetLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string])
    };
    var defaultProps = {
      placement: 'right'
    };
    var Tooltip = function (_React$Component) {
      (0, _inherits3['default'])(Tooltip, _React$Component);
      function Tooltip() {
        (0, _classCallCheck3['default'])(this, Tooltip);
        return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
      }
      Tooltip.prototype.render = function render() {
        var _extends2;
        var _props = this.props,
          placement = _props.placement,
          positionTop = _props.positionTop,
          positionLeft = _props.positionLeft,
          arrowOffsetTop = _props.arrowOffsetTop,
          arrowOffsetLeft = _props.arrowOffsetLeft,
          className = _props.className,
          style = _props.style,
          children = _props.children,
          props = (0, _objectWithoutProperties3['default'])(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'className', 'style', 'children']);
        var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
          bsProps = _splitBsProps[0],
          elementProps = _splitBsProps[1];
        var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
        var outerStyle = (0, _extends4['default'])({
          top: positionTop,
          left: positionLeft
        }, style);
        var arrowStyle = {
          top: arrowOffsetTop,
          left: arrowOffsetLeft
        };
        return _react2['default'].createElement('div', (0, _extends4['default'])({}, elementProps, {
          role: 'tooltip',
          className: (0, _classnames2['default'])(className, classes),
          style: outerStyle
        }), _react2['default'].createElement('div', {
          className: (0, _bootstrapUtils.prefix)(bsProps, 'arrow'),
          style: arrowStyle
        }), _react2['default'].createElement('div', {
          className: (0, _bootstrapUtils.prefix)(bsProps, 'inner')
        }, children));
      };
      return Tooltip;
    }(_react2['default'].Component);
    Tooltip.propTypes = propTypes;
    Tooltip.defaultProps = defaultProps;
    exports['default'] = (0, _bootstrapUtils.bsClass)('tooltip', Tooltip);
    module.exports = exports['default'];

    /***/
  }), ( /* 531 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    exports.requiredRoles = requiredRoles;
    exports.exclusiveRoles = exclusiveRoles;
    var _createChainableTypeChecker = __webpack_require__(95);
    var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
    var _ValidComponentChildren = __webpack_require__(141);
    var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        'default': obj
      };
    }
    function requiredRoles() {
      for (var _len = arguments.length, roles = Array(_len), _key = 0; _key < _len; _key++) {
        roles[_key] = arguments[_key];
      }
      return (0, _createChainableTypeChecker2['default'])(function (props, propName, component) {
        var missing = void 0;
        roles.every(function (role) {
          if (!_ValidComponentChildren2['default'].some(props.children, function (child) {
            return child.props.bsRole === role;
          })) {
            missing = role;
            return false;
          }
          return true;
        });
        if (missing) {
          return new Error('(children) ' + component + ' - Missing a required child with bsRole: ' + (missing + '. ' + component + ' must have at least one child of each of ') + ('the following bsRoles: ' + roles.join(', ')));
        }
        return null;
      });
    }
    function exclusiveRoles() {
      for (var _len2 = arguments.length, roles = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        roles[_key2] = arguments[_key2];
      }
      return (0, _createChainableTypeChecker2['default'])(function (props, propName, component) {
        var duplicate = void 0;
        roles.every(function (role) {
          var childrenWithRole = _ValidComponentChildren2['default'].filter(props.children, function (child) {
            return child.props.bsRole === role;
          });
          if (childrenWithRole.length > 1) {
            duplicate = role;
            return false;
          }
          return true;
        });
        if (duplicate) {
          return new Error('(children) ' + component + ' - Duplicate children detected of bsRole: ' + (duplicate + '. Only one child each allowed with the following ') + ('bsRoles: ' + roles.join(', ')));
        }
        return null;
      });
    }

    /***/
  }), ( /* 532 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    var _entries = __webpack_require__(166);
    var _entries2 = _interopRequireDefault(_entries);
    exports["default"] = splitComponentProps;
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        "default": obj
      };
    }
    function splitComponentProps(props, Component) {
      var componentPropTypes = Component.propTypes;
      var parentProps = {};
      var childProps = {};
      (0, _entries2["default"])(props).forEach(function (_ref) {
        var propName = _ref[0],
          propValue = _ref[1];
        if (componentPropTypes[propName]) {
          parentProps[propName] = propValue;
        } else {
          childProps[propName] = propValue;
        }
      });
      return [parentProps, childProps];
    }
    module.exports = exports["default"];

    /***/
  }), ( /* 533 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    var ReactPropTypesSecret = __webpack_require__(534);
    function emptyFunction() {}
    function emptyFunctionWithReset() {}
    emptyFunctionWithReset.resetWarningCache = emptyFunction;
    module.exports = function () {
      function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) {
          // It is still safe when called from React.
          return;
        }
        var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
        err.name = 'Invariant Violation';
        throw err;
      }
      ;
      shim.isRequired = shim;
      function getShim() {
        return shim;
      }
      ;
      // Important!
      // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
      var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
      };
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };

    /***/
  }), ( /* 534 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
    module.exports = ReactPropTypesSecret;

    /***/
  }), ( /* 535 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    function _objectWithoutProperties(obj, keys) {
      var target = {};
      for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
      }
      return target;
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var hoistNonReactStatic = __webpack_require__(450);
    var React = __webpack_require__(0);
    var ReactDOM = __webpack_require__(4);
    module.exports = function enhanceWithClickOutside(WrappedComponent) {
      var componentName = WrappedComponent.displayName || WrappedComponent.name;
      var EnhancedComponent = function (_React$Component) {
        _inherits(EnhancedComponent, _React$Component);
        function EnhancedComponent(props) {
          _classCallCheck(this, EnhancedComponent);
          var _this = _possibleConstructorReturn(this, (EnhancedComponent.__proto__ || Object.getPrototypeOf(EnhancedComponent)).call(this, props));
          _this.handleClickOutside = _this.handleClickOutside.bind(_this);
          return _this;
        }
        _createClass(EnhancedComponent, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            document.addEventListener('click', this.handleClickOutside, true);
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            document.removeEventListener('click', this.handleClickOutside, true);
          }
        }, {
          key: 'handleClickOutside',
          value: function handleClickOutside(e) {
            var domNode = this.__domNode;
            if ((!domNode || !domNode.contains(e.target)) && this.__wrappedInstance && typeof this.__wrappedInstance.handleClickOutside === 'function') {
              this.__wrappedInstance.handleClickOutside(e);
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var _this2 = this;
            var _props = this.props,
              wrappedRef = _props.wrappedRef,
              rest = _objectWithoutProperties(_props, ['wrappedRef']);
            return React.createElement(WrappedComponent, _extends({}, rest, {
              ref: function ref(c) {
                _this2.__wrappedInstance = c;
                _this2.__domNode = ReactDOM.findDOMNode(c);
                wrappedRef && wrappedRef(c);
              }
            }));
          }
        }]);
        return EnhancedComponent;
      }(React.Component);
      EnhancedComponent.displayName = 'clickOutside(' + componentName + ')';
      return hoistNonReactStatic(EnhancedComponent, WrappedComponent);
    };

    /***/
  }), ( /* 536 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    /** @license React v16.9.0
     * react-is.production.min.js
     *
     * Copyright (c) Facebook, Inc. and its affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    Object.defineProperty(exports, "__esModule", {
      value: !0
    });
    var b = "function" === typeof Symbol && Symbol.for,
      c = b ? Symbol.for("react.element") : 60103,
      d = b ? Symbol.for("react.portal") : 60106,
      e = b ? Symbol.for("react.fragment") : 60107,
      f = b ? Symbol.for("react.strict_mode") : 60108,
      g = b ? Symbol.for("react.profiler") : 60114,
      h = b ? Symbol.for("react.provider") : 60109,
      k = b ? Symbol.for("react.context") : 60110,
      l = b ? Symbol.for("react.async_mode") : 60111,
      m = b ? Symbol.for("react.concurrent_mode") : 60111,
      n = b ? Symbol.for("react.forward_ref") : 60112,
      p = b ? Symbol.for("react.suspense") : 60113,
      q = b ? Symbol.for("react.suspense_list") : 60120,
      r = b ? Symbol.for("react.memo") : 60115,
      t = b ? Symbol.for("react.lazy") : 60116,
      v = b ? Symbol.for("react.fundamental") : 60117,
      w = b ? Symbol.for("react.responder") : 60118;
    function x(a) {
      if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch (u) {
          case c:
            switch (a = a.type, a) {
              case l:
              case m:
              case e:
              case g:
              case f:
              case p:
                return a;
              default:
                switch (a = a && a.$$typeof, a) {
                  case k:
                  case n:
                  case h:
                    return a;
                  default:
                    return u;
                }
            }
          case t:
          case r:
          case d:
            return u;
        }
      }
    }
    function y(a) {
      return x(a) === m;
    }
    exports.typeOf = x;
    exports.AsyncMode = l;
    exports.ConcurrentMode = m;
    exports.ContextConsumer = k;
    exports.ContextProvider = h;
    exports.Element = c;
    exports.ForwardRef = n;
    exports.Fragment = e;
    exports.Lazy = t;
    exports.Memo = r;
    exports.Portal = d;
    exports.Profiler = g;
    exports.StrictMode = f;
    exports.Suspense = p;
    exports.isValidElementType = function (a) {
      return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === v || a.$$typeof === w);
    };
    exports.isAsyncMode = function (a) {
      return y(a) || x(a) === l;
    };
    exports.isConcurrentMode = y;
    exports.isContextConsumer = function (a) {
      return x(a) === k;
    };
    exports.isContextProvider = function (a) {
      return x(a) === h;
    };
    exports.isElement = function (a) {
      return "object" === typeof a && null !== a && a.$$typeof === c;
    };
    exports.isForwardRef = function (a) {
      return x(a) === n;
    };
    exports.isFragment = function (a) {
      return x(a) === e;
    };
    exports.isLazy = function (a) {
      return x(a) === t;
    };
    exports.isMemo = function (a) {
      return x(a) === r;
    };
    exports.isPortal = function (a) {
      return x(a) === d;
    };
    exports.isProfiler = function (a) {
      return x(a) === g;
    };
    exports.isStrictMode = function (a) {
      return x(a) === f;
    };
    exports.isSuspense = function (a) {
      return x(a) === p;
    };

    /***/
  }), ( /* 537 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    if (true) {
      module.exports = __webpack_require__(536);
    } else {
      module.exports = require('./cjs/react-is.development.js');
    }

    /***/
  }), ( /* 538 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    var _propTypes = __webpack_require__(52);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _componentOrElement = __webpack_require__(139);
    var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _reactDom = __webpack_require__(4);
    var _reactDom2 = _interopRequireDefault(_reactDom);
    var _getContainer = __webpack_require__(142);
    var _getContainer2 = _interopRequireDefault(_getContainer);
    var _ownerDocument = __webpack_require__(73);
    var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    /**
     * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
     * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
     * The children of `<Portal/>` component will be appended to the `container` specified.
     */
    var Portal = function (_React$Component) {
      _inherits(Portal, _React$Component);
      function Portal() {
        var _temp, _this, _ret;
        _classCallCheck(this, Portal);
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._mountOverlayTarget = function () {
          if (!_this._overlayTarget) {
            _this._overlayTarget = document.createElement('div');
            _this._portalContainerNode = (0, _getContainer2.default)(_this.props.container, (0, _ownerDocument2.default)(_this).body);
            _this._portalContainerNode.appendChild(_this._overlayTarget);
          }
        }, _this._unmountOverlayTarget = function () {
          if (_this._overlayTarget) {
            _this._portalContainerNode.removeChild(_this._overlayTarget);
            _this._overlayTarget = null;
          }
          _this._portalContainerNode = null;
        }, _this._renderOverlay = function () {
          var overlay = !_this.props.children ? null : _react2.default.Children.only(_this.props.children);

          // Save reference for future access.
          if (overlay !== null) {
            _this._mountOverlayTarget();
            var initialRender = !_this._overlayInstance;
            _this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget, function () {
              if (initialRender && _this.props.onRendered) {
                _this.props.onRendered();
              }
            });
          } else {
            // Unrender if the component is null for transitions to null
            _this._unrenderOverlay();
            _this._unmountOverlayTarget();
          }
        }, _this._unrenderOverlay = function () {
          if (_this._overlayTarget) {
            _reactDom2.default.unmountComponentAtNode(_this._overlayTarget);
            _this._overlayInstance = null;
          }
        }, _this.getMountNode = function () {
          return _this._overlayTarget;
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }
      Portal.prototype.componentDidMount = function componentDidMount() {
        this._isMounted = true;
        this._renderOverlay();
      };
      Portal.prototype.componentDidUpdate = function componentDidUpdate() {
        this._renderOverlay();
      };
      Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (this._overlayTarget && nextProps.container !== this.props.container) {
          this._portalContainerNode.removeChild(this._overlayTarget);
          this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
          this._portalContainerNode.appendChild(this._overlayTarget);
        }
      };
      Portal.prototype.componentWillUnmount = function componentWillUnmount() {
        this._isMounted = false;
        this._unrenderOverlay();
        this._unmountOverlayTarget();
      };
      Portal.prototype.render = function render() {
        return null;
      };
      return Portal;
    }(_react2.default.Component);
    Portal.displayName = 'Portal';
    Portal.propTypes = {
      /**
       * A Node, Component instance, or function that returns either. The `container` will have the Portal children
       * appended to it.
       */
      container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
      onRendered: _propTypes2.default.func
    };
    exports.default = Portal;
    module.exports = exports['default'];

    /***/
  }), ( /* 539 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    var _propTypes = __webpack_require__(52);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _elementType = __webpack_require__(72);
    var _elementType2 = _interopRequireDefault(_elementType);
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _Portal = __webpack_require__(540);
    var _Portal2 = _interopRequireDefault(_Portal);
    var _Position = __webpack_require__(541);
    var _Position2 = _interopRequireDefault(_Position);
    var _RootCloseWrapper = __webpack_require__(221);
    var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _objectWithoutProperties(obj, keys) {
      var target = {};
      for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
      }
      return target;
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    /**
     * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
     */
    var Overlay = function (_React$Component) {
      _inherits(Overlay, _React$Component);
      function Overlay(props, context) {
        _classCallCheck(this, Overlay);
        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
        _this.handleHidden = function () {
          _this.setState({
            exited: true
          });
          if (_this.props.onExited) {
            var _this$props;
            (_this$props = _this.props).onExited.apply(_this$props, arguments);
          }
        };
        _this.state = {
          exited: !props.show
        };
        _this.onHiddenListener = _this.handleHidden.bind(_this);
        return _this;
      }
      Overlay.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (nextProps.show) {
          this.setState({
            exited: false
          });
        } else if (!nextProps.transition) {
          // Otherwise let handleHidden take care of marking exited.
          this.setState({
            exited: true
          });
        }
      };
      Overlay.prototype.render = function render() {
        var _props = this.props,
          container = _props.container,
          containerPadding = _props.containerPadding,
          target = _props.target,
          placement = _props.placement,
          shouldUpdatePosition = _props.shouldUpdatePosition,
          rootClose = _props.rootClose,
          children = _props.children,
          Transition = _props.transition,
          props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);

        // Don't un-render the overlay while it's transitioning out.

        var mountOverlay = props.show || Transition && !this.state.exited;
        if (!mountOverlay) {
          // Don't bother showing anything if we don't have to.
          return null;
        }
        var child = children;

        // Position is be inner-most because it adds inline styles into the child,
        // which the other wrappers don't forward correctly.
        child = _react2.default.createElement(_Position2.default, {
          container: container,
          containerPadding: containerPadding,
          target: target,
          placement: placement,
          shouldUpdatePosition: shouldUpdatePosition
        }, child);
        if (Transition) {
          var onExit = props.onExit,
            onExiting = props.onExiting,
            onEnter = props.onEnter,
            onEntering = props.onEntering,
            onEntered = props.onEntered;

          // This animates the child node by injecting props, so it must precede
          // anything that adds a wrapping div.

          child = _react2.default.createElement(Transition, {
            'in': props.show,
            transitionAppear: true,
            onExit: onExit,
            onExiting: onExiting,
            onExited: this.onHiddenListener,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered
          }, child);
        }

        // This goes after everything else because it adds a wrapping div.
        if (rootClose) {
          child = _react2.default.createElement(_RootCloseWrapper2.default, {
            onRootClose: props.onHide
          }, child);
        }
        return _react2.default.createElement(_Portal2.default, {
          container: container
        }, child);
      };
      return Overlay;
    }(_react2.default.Component);
    Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {
      /**
       * Set the visibility of the Overlay
       */
      show: _propTypes2.default.bool,
      /**
       * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
       */
      rootClose: _propTypes2.default.bool,
      /**
       * A Callback fired by the Overlay when it wishes to be hidden.
       *
       * __required__ when `rootClose` is `true`.
       *
       * @type func
       */
      onHide: function onHide(props) {
        var propType = _propTypes2.default.func;
        if (props.rootClose) {
          propType = propType.isRequired;
        }
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        return propType.apply(undefined, [props].concat(args));
      },
      /**
       * A `<Transition/>` component used to animate the overlay changes visibility.
       */
      transition: _elementType2.default,
      /**
       * Callback fired before the Overlay transitions in
       */
      onEnter: _propTypes2.default.func,
      /**
       * Callback fired as the Overlay begins to transition in
       */
      onEntering: _propTypes2.default.func,
      /**
       * Callback fired after the Overlay finishes transitioning in
       */
      onEntered: _propTypes2.default.func,
      /**
       * Callback fired right before the Overlay transitions out
       */
      onExit: _propTypes2.default.func,
      /**
       * Callback fired as the Overlay begins to transition out
       */
      onExiting: _propTypes2.default.func,
      /**
       * Callback fired after the Overlay finishes transitioning out
       */
      onExited: _propTypes2.default.func
    });
    exports.default = Overlay;
    module.exports = exports['default'];

    /***/
  }), ( /* 540 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    var _propTypes = __webpack_require__(52);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _componentOrElement = __webpack_require__(139);
    var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _reactDom = __webpack_require__(4);
    var _reactDom2 = _interopRequireDefault(_reactDom);
    var _getContainer = __webpack_require__(142);
    var _getContainer2 = _interopRequireDefault(_getContainer);
    var _ownerDocument = __webpack_require__(73);
    var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
    var _LegacyPortal = __webpack_require__(538);
    var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    /**
     * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
     * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
     * The children of `<Portal/>` component will be appended to the `container` specified.
     */
    var Portal = function (_React$Component) {
      _inherits(Portal, _React$Component);
      function Portal() {
        var _temp, _this, _ret;
        _classCallCheck(this, Portal);
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.setContainer = function () {
          var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
          _this._portalContainerNode = (0, _getContainer2.default)(props.container, (0, _ownerDocument2.default)(_this).body);
        }, _this.getMountNode = function () {
          return _this._portalContainerNode;
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }
      Portal.prototype.componentDidMount = function componentDidMount() {
        this.setContainer();
        this.forceUpdate(this.props.onRendered);
      };
      Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (nextProps.container !== this.props.container) {
          this.setContainer(nextProps);
        }
      };
      Portal.prototype.componentWillUnmount = function componentWillUnmount() {
        this._portalContainerNode = null;
      };
      Portal.prototype.render = function render() {
        return this.props.children && this._portalContainerNode ? _reactDom2.default.createPortal(this.props.children, this._portalContainerNode) : null;
      };
      return Portal;
    }(_react2.default.Component);
    Portal.displayName = 'Portal';
    Portal.propTypes = {
      /**
       * A Node, Component instance, or function that returns either. The `container` will have the Portal children
       * appended to it.
       */
      container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
      onRendered: _propTypes2.default.func
    };
    exports.default = _reactDom2.default.createPortal ? Portal : _LegacyPortal2.default;
    module.exports = exports['default'];

    /***/
  }), ( /* 541 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    var _classnames = __webpack_require__(222);
    var _classnames2 = _interopRequireDefault(_classnames);
    var _propTypes = __webpack_require__(52);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _componentOrElement = __webpack_require__(139);
    var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _reactDom = __webpack_require__(4);
    var _reactDom2 = _interopRequireDefault(_reactDom);
    var _calculatePosition = __webpack_require__(544);
    var _calculatePosition2 = _interopRequireDefault(_calculatePosition);
    var _getContainer = __webpack_require__(142);
    var _getContainer2 = _interopRequireDefault(_getContainer);
    var _ownerDocument = __webpack_require__(73);
    var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _objectWithoutProperties(obj, keys) {
      var target = {};
      for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
      }
      return target;
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    /**
     * The Position component calculates the coordinates for its child, to position
     * it relative to a `target` component or node. Useful for creating callouts
     * and tooltips, the Position component injects a `style` props with `left` and
     * `top` values for positioning your component.
     *
     * It also injects "arrow" `left`, and `top` values for styling callout arrows
     * for giving your components a sense of directionality.
     */
    var Position = function (_React$Component) {
      _inherits(Position, _React$Component);
      function Position(props, context) {
        _classCallCheck(this, Position);
        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
        _this.getTarget = function () {
          var target = _this.props.target;
          var targetElement = typeof target === 'function' ? target() : target;
          return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
        };
        _this.maybeUpdatePosition = function (placementChanged) {
          var target = _this.getTarget();
          if (!_this.props.shouldUpdatePosition && target === _this._lastTarget && !placementChanged) {
            return;
          }
          _this.updatePosition(target);
        };
        _this.state = {
          positionLeft: 0,
          positionTop: 0,
          arrowOffsetLeft: null,
          arrowOffsetTop: null
        };
        _this._needsFlush = false;
        _this._lastTarget = null;
        return _this;
      }
      Position.prototype.componentDidMount = function componentDidMount() {
        this.updatePosition(this.getTarget());
      };
      Position.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
        this._needsFlush = true;
      };
      Position.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this._needsFlush) {
          this._needsFlush = false;
          this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
        }
      };
      Position.prototype.render = function render() {
        var _props = this.props,
          children = _props.children,
          className = _props.className,
          props = _objectWithoutProperties(_props, ['children', 'className']);
        var _state = this.state,
          positionLeft = _state.positionLeft,
          positionTop = _state.positionTop,
          arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);

        // These should not be forwarded to the child.

        delete props.target;
        delete props.container;
        delete props.containerPadding;
        delete props.shouldUpdatePosition;
        var child = _react2.default.Children.only(children);
        return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
          // FIXME: Don't forward `positionLeft` and `positionTop` via both props
          // and `props.style`.
          positionLeft: positionLeft,
          positionTop: positionTop,
          className: (0, _classnames2.default)(className, child.props.className),
          style: _extends({}, child.props.style, {
            left: positionLeft,
            top: positionTop
          })
        }));
      };
      Position.prototype.updatePosition = function updatePosition(target) {
        this._lastTarget = target;
        if (!target) {
          this.setState({
            positionLeft: 0,
            positionTop: 0,
            arrowOffsetLeft: null,
            arrowOffsetTop: null
          });
          return;
        }
        var overlay = _reactDom2.default.findDOMNode(this);
        var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
        this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
      };
      return Position;
    }(_react2.default.Component);
    Position.propTypes = {
      /**
       * A node, element, or function that returns either. The child will be
       * be positioned next to the `target` specified.
       */
      target: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
      /**
       * "offsetParent" of the component
       */
      container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
      /**
       * Minimum spacing in pixels between container border and component border
       */
      containerPadding: _propTypes2.default.number,
      /**
       * How to position the component relative to the target
       */
      placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
      /**
       * Whether the position should be changed on each update
       */
      shouldUpdatePosition: _propTypes2.default.bool
    };
    Position.displayName = 'Position';
    Position.defaultProps = {
      containerPadding: 0,
      placement: 'right',
      shouldUpdatePosition: false
    };
    exports.default = Position;
    module.exports = exports['default'];

    /***/
  }), ( /* 542 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    var _classnames = __webpack_require__(222);
    var _classnames2 = _interopRequireDefault(_classnames);
    var _on = __webpack_require__(197);
    var _on2 = _interopRequireDefault(_on);
    var _properties = __webpack_require__(201);
    var _properties2 = _interopRequireDefault(_properties);
    var _propTypes = __webpack_require__(52);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _reactDom = __webpack_require__(4);
    var _reactDom2 = _interopRequireDefault(_reactDom);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _objectWithoutProperties(obj, keys) {
      var target = {};
      for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
      }
      return target;
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var transitionEndEvent = _properties2.default.end;
    var UNMOUNTED = exports.UNMOUNTED = 0;
    var EXITED = exports.EXITED = 1;
    var ENTERING = exports.ENTERING = 2;
    var ENTERED = exports.ENTERED = 3;
    var EXITING = exports.EXITING = 4;

    /**
     * The Transition component lets you define and run css transitions with a simple declarative api.
     * It works similar to React's own [CSSTransitionGroup](http://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup)
     * but is specifically optimized for transitioning a single child "in" or "out".
     *
     * You don't even need to use class based css transitions if you don't want to (but it is easiest).
     * The extensive set of lifecycle callbacks means you have control over
     * the transitioning now at each step of the way.
     */

    var Transition = function (_React$Component) {
      _inherits(Transition, _React$Component);
      function Transition(props, context) {
        _classCallCheck(this, Transition);
        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
        _this.updateStatus = function () {
          if (_this.nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            _this.cancelNextCallback();
            var node = _reactDom2.default.findDOMNode(_this);
            if (_this.nextStatus === ENTERING) {
              _this.props.onEnter(node);
              _this.safeSetState({
                status: ENTERING
              }, function () {
                _this.props.onEntering(node);
                _this.onTransitionEnd(node, function () {
                  _this.safeSetState({
                    status: ENTERED
                  }, function () {
                    _this.props.onEntered(node);
                  });
                });
              });
            } else {
              _this.props.onExit(node);
              _this.safeSetState({
                status: EXITING
              }, function () {
                _this.props.onExiting(node);
                _this.onTransitionEnd(node, function () {
                  _this.safeSetState({
                    status: EXITED
                  }, function () {
                    _this.props.onExited(node);
                  });
                });
              });
            }
            _this.nextStatus = null;
          } else if (_this.props.unmountOnExit && _this.state.status === EXITED) {
            _this.setState({
              status: UNMOUNTED
            });
          }
        };
        _this.cancelNextCallback = function () {
          if (_this.nextCallback !== null) {
            _this.nextCallback.cancel();
            _this.nextCallback = null;
          }
        };
        _this.safeSetState = function (nextState, callback) {
          // This shouldn't be necessary, but there are weird race conditions with
          // setState callbacks and unmounting in testing, so always make sure that
          // we can cancel any pending setState callbacks after we unmount.
          _this.setState(nextState, _this.setNextCallback(callback));
        };
        _this.setNextCallback = function (callback) {
          var active = true;
          _this.nextCallback = function (event) {
            if (active) {
              active = false;
              _this.nextCallback = null;
              callback(event);
            }
          };
          _this.nextCallback.cancel = function () {
            active = false;
          };
          return _this.nextCallback;
        };
        _this.onTransitionEnd = function (node, handler) {
          _this.setNextCallback(handler);
          if (node) {
            (0, _on2.default)(node, transitionEndEvent, _this.nextCallback);
            setTimeout(_this.nextCallback, _this.props.timeout);
          } else {
            setTimeout(_this.nextCallback, 0);
          }
        };
        var initialStatus = void 0;
        _this.nextStatus = null;
        if (props.in) {
          if (props.transitionAppear) {
            initialStatus = EXITED;
            _this.nextStatus = ENTERING;
          } else {
            initialStatus = ENTERED;
          }
        } else {
          if (props.unmountOnExit || props.mountOnEnter) {
            initialStatus = UNMOUNTED;
          } else {
            initialStatus = EXITED;
          }
        }
        _this.state = {
          status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
      }
      Transition.prototype.componentDidMount = function componentDidMount() {
        this.updateStatus();
      };
      Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var status = this.state.status;
        if (nextProps.in) {
          if (status === UNMOUNTED) {
            this.setState({
              status: EXITED
            });
          }
          if (status !== ENTERING && status !== ENTERED) {
            this.nextStatus = ENTERING;
          }
        } else {
          if (status === ENTERING || status === ENTERED) {
            this.nextStatus = EXITING;
          }
        }
      };
      Transition.prototype.componentDidUpdate = function componentDidUpdate() {
        this.updateStatus();
      };
      Transition.prototype.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
      };
      Transition.prototype.render = function render() {
        var status = this.state.status;
        if (status === UNMOUNTED) {
          return null;
        }
        var _props = this.props,
          children = _props.children,
          className = _props.className,
          childProps = _objectWithoutProperties(_props, ['children', 'className']);
        Object.keys(Transition.propTypes).forEach(function (key) {
          return delete childProps[key];
        });
        var transitionClassName = void 0;
        if (status === EXITED) {
          transitionClassName = this.props.exitedClassName;
        } else if (status === ENTERING) {
          transitionClassName = this.props.enteringClassName;
        } else if (status === ENTERED) {
          transitionClassName = this.props.enteredClassName;
        } else if (status === EXITING) {
          transitionClassName = this.props.exitingClassName;
        }
        var child = _react2.default.Children.only(children);
        return _react2.default.cloneElement(child, _extends({}, childProps, {
          className: (0, _classnames2.default)(child.props.className, className, transitionClassName)
        }));
      };
      return Transition;
    }(_react2.default.Component);
    Transition.propTypes = {
      /**
       * Show the component; triggers the enter or exit animation
       */
      in: _propTypes2.default.bool,
      /**
       * Wait until the first "enter" transition to mount the component (add it to the DOM)
       */
      mountOnEnter: _propTypes2.default.bool,
      /**
       * Unmount the component (remove it from the DOM) when it is not shown
       */
      unmountOnExit: _propTypes2.default.bool,
      /**
       * Run the enter animation when the component mounts, if it is initially
       * shown
       */
      transitionAppear: _propTypes2.default.bool,
      /**
       * A Timeout for the animation, in milliseconds, to ensure that a node doesn't
       * transition indefinately if the browser transitionEnd events are
       * canceled or interrupted.
       *
       * By default this is set to a high number (5 seconds) as a failsafe. You should consider
       * setting this to the duration of your animation (or a bit above it).
       */
      timeout: _propTypes2.default.number,
      /**
       * CSS class or classes applied when the component is exited
       */
      exitedClassName: _propTypes2.default.string,
      /**
       * CSS class or classes applied while the component is exiting
       */
      exitingClassName: _propTypes2.default.string,
      /**
       * CSS class or classes applied when the component is entered
       */
      enteredClassName: _propTypes2.default.string,
      /**
       * CSS class or classes applied while the component is entering
       */
      enteringClassName: _propTypes2.default.string,
      /**
       * Callback fired before the "entering" classes are applied
       */
      onEnter: _propTypes2.default.func,
      /**
       * Callback fired after the "entering" classes are applied
       */
      onEntering: _propTypes2.default.func,
      /**
       * Callback fired after the "enter" classes are applied
       */
      onEntered: _propTypes2.default.func,
      /**
       * Callback fired before the "exiting" classes are applied
       */
      onExit: _propTypes2.default.func,
      /**
       * Callback fired after the "exiting" classes are applied
       */
      onExiting: _propTypes2.default.func,
      /**
       * Callback fired after the "exited" classes are applied
       */
      onExited: _propTypes2.default.func
    };

    // Name the function so it is clearer in the documentation
    function noop() {}
    Transition.displayName = 'Transition';
    Transition.defaultProps = {
      in: false,
      unmountOnExit: false,
      transitionAppear: false,
      timeout: 5000,
      onEnter: noop,
      onEntering: noop,
      onEntered: noop,
      onExit: noop,
      onExiting: noop,
      onExited: noop
    };
    exports.default = Transition;

    /***/
  }), ( /* 543 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    exports.default = function (node, event, handler, capture) {
      (0, _on2.default)(node, event, handler, capture);
      return {
        remove: function remove() {
          (0, _off2.default)(node, event, handler, capture);
        }
      };
    };
    var _on = __webpack_require__(197);
    var _on2 = _interopRequireDefault(_on);
    var _off = __webpack_require__(392);
    var _off2 = _interopRequireDefault(_off);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    module.exports = exports['default'];

    /***/
  }), ( /* 544 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    exports.default = calculatePosition;
    var _offset = __webpack_require__(198);
    var _offset2 = _interopRequireDefault(_offset);
    var _position = __webpack_require__(394);
    var _position2 = _interopRequireDefault(_position);
    var _scrollTop = __webpack_require__(199);
    var _scrollTop2 = _interopRequireDefault(_scrollTop);
    var _ownerDocument = __webpack_require__(73);
    var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function getContainerDimensions(containerNode) {
      var width = void 0,
        height = void 0,
        scroll = void 0;
      if (containerNode.tagName === 'BODY') {
        width = window.innerWidth;
        height = window.innerHeight;
        scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
      } else {
        var _getOffset = (0, _offset2.default)(containerNode);
        width = _getOffset.width;
        height = _getOffset.height;
        scroll = (0, _scrollTop2.default)(containerNode);
      }
      return {
        width: width,
        height: height,
        scroll: scroll
      };
    }
    function getTopDelta(top, overlayHeight, container, padding) {
      var containerDimensions = getContainerDimensions(container);
      var containerScroll = containerDimensions.scroll;
      var containerHeight = containerDimensions.height;
      var topEdgeOffset = top - padding - containerScroll;
      var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;
      if (topEdgeOffset < 0) {
        return -topEdgeOffset;
      } else if (bottomEdgeOffset > containerHeight) {
        return containerHeight - bottomEdgeOffset;
      } else {
        return 0;
      }
    }
    function getLeftDelta(left, overlayWidth, container, padding) {
      var containerDimensions = getContainerDimensions(container);
      var containerWidth = containerDimensions.width;
      var leftEdgeOffset = left - padding;
      var rightEdgeOffset = left + padding + overlayWidth;
      if (leftEdgeOffset < 0) {
        return -leftEdgeOffset;
      } else if (rightEdgeOffset > containerWidth) {
        return containerWidth - rightEdgeOffset;
      }
      return 0;
    }
    function calculatePosition(placement, overlayNode, target, container, padding) {
      var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);
      var _getOffset2 = (0, _offset2.default)(overlayNode),
        overlayHeight = _getOffset2.height,
        overlayWidth = _getOffset2.width;
      var positionLeft = void 0,
        positionTop = void 0,
        arrowOffsetLeft = void 0,
        arrowOffsetTop = void 0;
      if (placement === 'left' || placement === 'right') {
        positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;
        if (placement === 'left') {
          positionLeft = childOffset.left - overlayWidth;
        } else {
          positionLeft = childOffset.left + childOffset.width;
        }
        var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);
        positionTop += topDelta;
        arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
        arrowOffsetLeft = void 0;
      } else if (placement === 'top' || placement === 'bottom') {
        positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;
        if (placement === 'top') {
          positionTop = childOffset.top - overlayHeight;
        } else {
          positionTop = childOffset.top + childOffset.height;
        }
        var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);
        positionLeft += leftDelta;
        arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
        arrowOffsetTop = void 0;
      } else {
        throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
      }
      return {
        positionLeft: positionLeft,
        positionTop: positionTop,
        arrowOffsetLeft: arrowOffsetLeft,
        arrowOffsetTop: arrowOffsetTop
      };
    }
    module.exports = exports['default'];

    /***/
  }), ( /* 545 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    var ReactPropTypesSecret = __webpack_require__(546);
    function emptyFunction() {}
    function emptyFunctionWithReset() {}
    emptyFunctionWithReset.resetWarningCache = emptyFunction;
    module.exports = function () {
      function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) {
          // It is still safe when called from React.
          return;
        }
        var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
        err.name = 'Invariant Violation';
        throw err;
      }
      ;
      shim.isRequired = shim;
      function getShim() {
        return shim;
      }
      ;
      // Important!
      // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
      var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
      };
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };

    /***/
  }), ( /* 546 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
    module.exports = ReactPropTypesSecret;

    /***/
  }), ( /* 547 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _reactDom = __webpack_require__(4);
    var _reactDom2 = _interopRequireDefault(_reactDom);
    var _propTypes = __webpack_require__(549);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var KEYCODES = {
      ESCAPE: 27
    };
    var Portal = function (_React$Component) {
      _inherits(Portal, _React$Component);
      function Portal() {
        _classCallCheck(this, Portal);
        var _this = _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this));
        _this.state = {
          active: false
        };
        _this.handleWrapperClick = _this.handleWrapperClick.bind(_this);
        _this.closePortal = _this.closePortal.bind(_this);
        _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
        _this.handleKeydown = _this.handleKeydown.bind(_this);
        _this.portal = null;
        _this.node = null;
        return _this;
      }
      _createClass(Portal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (this.props.closeOnEsc) {
            document.addEventListener('keydown', this.handleKeydown);
          }
          if (this.props.closeOnOutsideClick) {
            document.addEventListener('mouseup', this.handleOutsideMouseClick);
            document.addEventListener('touchstart', this.handleOutsideMouseClick);
          }
          if (this.props.isOpened) {
            this.openPortal();
          }
        }
      }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
          // portal's 'is open' state is handled through the prop isOpened
          if (typeof newProps.isOpened !== 'undefined') {
            if (newProps.isOpened) {
              if (this.state.active) {
                this.renderPortal(newProps);
              } else {
                this.openPortal(newProps);
              }
            }
            if (!newProps.isOpened && this.state.active) {
              this.closePortal();
            }
          }

          // portal handles its own 'is open' state
          if (typeof newProps.isOpened === 'undefined' && this.state.active) {
            this.renderPortal(newProps);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (this.props.closeOnEsc) {
            document.removeEventListener('keydown', this.handleKeydown);
          }
          if (this.props.closeOnOutsideClick) {
            document.removeEventListener('mouseup', this.handleOutsideMouseClick);
            document.removeEventListener('touchstart', this.handleOutsideMouseClick);
          }
          this.closePortal(true);
        }
      }, {
        key: 'handleWrapperClick',
        value: function handleWrapperClick(e) {
          e.preventDefault();
          e.stopPropagation();
          if (this.state.active) {
            return;
          }
          this.openPortal();
        }
      }, {
        key: 'openPortal',
        value: function openPortal() {
          var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
          this.setState({
            active: true
          });
          this.renderPortal(props);
          this.props.onOpen(this.node);
        }
      }, {
        key: 'closePortal',
        value: function closePortal() {
          var _this2 = this;
          var isUnmounted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
          var resetPortalState = function resetPortalState(overrideIsUnmounted) {
            if (_this2.node) {
              _reactDom2.default.unmountComponentAtNode(_this2.node);
              document.body.removeChild(_this2.node);
            }
            _this2.portal = null;
            _this2.node = null;
            var finalIsUnmounted = overrideIsUnmounted === undefined ? isUnmounted : overrideIsUnmounted;
            if (finalIsUnmounted !== true) {
              _this2.setState({
                active: false
              });
            }
          };
          if (this.state.active) {
            if (this.props.beforeClose) {
              this.props.beforeClose(this.node, resetPortalState);
            } else {
              resetPortalState();
            }
            this.props.onClose();
          }
        }
      }, {
        key: 'handleOutsideMouseClick',
        value: function handleOutsideMouseClick(e) {
          if (!this.state.active) {
            return;
          }
          var root = (0, _reactDom.findDOMNode)(this.portal);
          if (root.contains(e.target) || e.button && e.button !== 0) {
            return;
          }
          e.stopPropagation();
          this.closePortal();
        }
      }, {
        key: 'handleKeydown',
        value: function handleKeydown(e) {
          if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
            this.closePortal();
          }
        }
      }, {
        key: 'renderPortal',
        value: function renderPortal(props) {
          if (!this.node) {
            this.node = document.createElement('div');
            document.body.appendChild(this.node);
          }
          var children = props.children;
          // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
          if (typeof props.children.type === 'function') {
            children = _react2.default.cloneElement(props.children, {
              closePortal: this.closePortal
            });
          }
          this.portal = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, children, this.node, this.props.onUpdate);
        }
      }, {
        key: 'render',
        value: function render() {
          if (this.props.openByClickOn) {
            return _react2.default.cloneElement(this.props.openByClickOn, {
              onClick: this.handleWrapperClick
            });
          }
          return null;
        }
      }]);
      return Portal;
    }(_react2.default.Component);
    exports.default = Portal;
    Portal.propTypes = {
      children: _propTypes2.default.element.isRequired,
      openByClickOn: _propTypes2.default.element,
      closeOnEsc: _propTypes2.default.bool,
      closeOnOutsideClick: _propTypes2.default.bool,
      isOpened: _propTypes2.default.bool,
      onOpen: _propTypes2.default.func,
      onClose: _propTypes2.default.func,
      beforeClose: _propTypes2.default.func,
      onUpdate: _propTypes2.default.func
    };
    Portal.defaultProps = {
      onOpen: function onOpen() {},
      onClose: function onClose() {},
      onUpdate: function onUpdate() {}
    };
    module.exports = exports['default'];

    /***/
  }), ( /* 548 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    var ReactPropTypesSecret = __webpack_require__(550);
    function emptyFunction() {}
    function emptyFunctionWithReset() {}
    emptyFunctionWithReset.resetWarningCache = emptyFunction;
    module.exports = function () {
      function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) {
          // It is still safe when called from React.
          return;
        }
        var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
        err.name = 'Invariant Violation';
        throw err;
      }
      ;
      shim.isRequired = shim;
      function getShim() {
        return shim;
      }
      ;
      // Important!
      // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
      var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
      };
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };

    /***/
  }), ( /* 549 */
  /***/function (module, exports, __webpack_require__) {
    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    if (false) {
      var ReactIs = require('react-is');

      // By explicitly using `prop-types` you are opting into new development behavior.
      // http://fb.me/prop-types-in-prod
      var throwOnDirectAccess = true;
      module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
    } else {
      // By explicitly using `prop-types` you are opting into new production behavior.
      // http://fb.me/prop-types-in-prod
      module.exports = __webpack_require__(548)();
    }

    /***/
  }), ( /* 550 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
    module.exports = ReactPropTypesSecret;

    /***/
  }), ( /* 551 */
  /***/function (module, exports) {
    function isBackward(selection) {
      var startNode = selection.anchorNode;
      var startOffset = selection.anchorOffset;
      var endNode = selection.focusNode;
      var endOffset = selection.focusOffset;
      var position = startNode.compareDocumentPosition(endNode);
      return !(position === 4 || position === 0 && startOffset < endOffset);
    }
    module.exports = isBackward;

    /***/
  }), ( /* 552 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    var _slateDevLogger = __webpack_require__(16);
    var _slateDevLogger2 = _interopRequireDefault(_slateDevLogger);
    var _slate = __webpack_require__(22);
    var _immutable = __webpack_require__(2);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    /**
     * Deserialize a plain text `string` to a state.
     *
     * @param {String} string
     * @param {Object} options
     *   @property {Boolean} toJSON
     *   @property {String|Object|Block} defaultBlock
     *   @property {Array|Set} defaultMarks
     * @return {State}
     */

    function deserialize(string) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _options$defaultBlock = options.defaultBlock,
        defaultBlock = _options$defaultBlock === undefined ? 'line' : _options$defaultBlock,
        _options$defaultMarks = options.defaultMarks,
        defaultMarks = _options$defaultMarks === undefined ? [] : _options$defaultMarks,
        _options$toJSON = options.toJSON,
        toJSON = _options$toJSON === undefined ? false : _options$toJSON;
      if (options.toRaw) {
        _slateDevLogger2.default.deprecate('0.23.0', 'The `options.toRaw` argument of the `Plain` serializer is deprecated, use `options.toJSON` instead.');
        toJSON = options.toRaw;
      }
      if (_immutable.Set.isSet(defaultMarks)) {
        defaultMarks = defaultMarks.toArray();
      }
      defaultBlock = _slate.Node.createProperties(defaultBlock);
      defaultMarks = defaultMarks.map(_slate.Mark.createProperties);
      var json = {
        kind: 'state',
        document: {
          kind: 'document',
          data: {},
          nodes: string.split('\n').map(function (line) {
            return _extends({}, defaultBlock, {
              kind: 'block',
              isVoid: false,
              data: {},
              nodes: [{
                kind: 'text',
                ranges: [{
                  kind: 'range',
                  text: line,
                  marks: defaultMarks
                }]
              }]
            });
          })
        }
      };
      var ret = toJSON ? json : _slate.State.fromJSON(json);
      return ret;
    }

    /**
     * Serialize a `state` to plain text.
     *
     * @param {State} state
     * @return {String}
     */

    function serialize(state) {
      return serializeNode(state.document);
    }

    /**
     * Serialize a `node` to plain text.
     *
     * @param {Node} node
     * @return {String}
     */

    function serializeNode(node) {
      if (node.kind == 'document' || node.kind == 'block' && _slate.Block.isBlockList(node.nodes)) {
        return node.nodes.map(serializeNode).join('\n');
      } else {
        return node.text;
      }
    }

    /**
     * Export.
     *
     * @type {Object}
     */

    exports.default = {
      deserialize: deserialize,
      serialize: serialize
    };

    /***/
  }), ( /* 553 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    var _slateBase64Serializer = __webpack_require__(97);
    var _slateBase64Serializer2 = _interopRequireDefault(_slateBase64Serializer);
    var _debug = __webpack_require__(20);
    var _debug2 = _interopRequireDefault(_debug);
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _slatePropTypes = __webpack_require__(53);
    var _slatePropTypes2 = _interopRequireDefault(_slatePropTypes);
    var _propTypes = __webpack_require__(54);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _getWindow = __webpack_require__(94);
    var _getWindow2 = _interopRequireDefault(_getWindow);
    var _keycode = __webpack_require__(134);
    var _keycode2 = _interopRequireDefault(_keycode);
    var _slate = __webpack_require__(22);
    var _transferTypes = __webpack_require__(143);
    var _transferTypes2 = _interopRequireDefault(_transferTypes);
    var _node = __webpack_require__(555);
    var _node2 = _interopRequireDefault(_node);
    var _extendSelection = __webpack_require__(559);
    var _extendSelection2 = _interopRequireDefault(_extendSelection);
    var _findClosestNode = __webpack_require__(225);
    var _findClosestNode2 = _interopRequireDefault(_findClosestNode);
    var _getCaretPosition = __webpack_require__(561);
    var _getCaretPosition2 = _interopRequireDefault(_getCaretPosition);
    var _getHtmlFromNativePaste = __webpack_require__(562);
    var _getHtmlFromNativePaste2 = _interopRequireDefault(_getHtmlFromNativePaste);
    var _getPoint = __webpack_require__(227);
    var _getPoint2 = _interopRequireDefault(_getPoint);
    var _getTransferData = __webpack_require__(563);
    var _getTransferData2 = _interopRequireDefault(_getTransferData);
    var _setTransferData = __webpack_require__(228);
    var _setTransferData2 = _interopRequireDefault(_setTransferData);
    var _environment = __webpack_require__(98);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    /**
     * Debug.
     *
     * @type {Function}
     */

    var debug = (0, _debug2.default)('slate:content');

    /**
     * Content.
     *
     * @type {Component}
     */

    var Content = function (_React$Component) {
      _inherits(Content, _React$Component);

      /**
       * Constructor.
       *
       * @param {Object} props
       */

      /**
       * Property types.
       *
       * @type {Object}
       */

      function Content(props) {
        _classCallCheck(this, Content);
        var _this = _possibleConstructorReturn(this, (Content.__proto__ || Object.getPrototypeOf(Content)).call(this, props));
        _this.componentDidMount = function () {
          _this.updateSelection();
          if (_this.props.autoFocus) {
            _this.element.focus();
          }
        };
        _this.componentDidUpdate = function () {
          _this.updateSelection();
        };
        _this.updateSelection = function () {
          var _this$props = _this.props,
            editor = _this$props.editor,
            state = _this$props.state;
          var selection = state.selection;
          var window = (0, _getWindow2.default)(_this.element);
          var native = window.getSelection();

          // If both selections are blurred, do nothing.
          if (!native.rangeCount && selection.isBlurred) return;

          // If the selection has been blurred, but is still inside the editor in the
          // DOM, blur it manually.
          if (selection.isBlurred) {
            if (!_this.isInEditor(native.anchorNode)) return;
            native.removeAllRanges();
            _this.element.blur();
            debug('updateSelection', {
              selection: selection,
              native: native
            });
            return;
          }

          // If the selection isn't set, do nothing.
          if (selection.isUnset) return;

          // Otherwise, figure out which DOM nodes should be selected...
          var anchorKey = selection.anchorKey,
            anchorOffset = selection.anchorOffset,
            focusKey = selection.focusKey,
            focusOffset = selection.focusOffset,
            isCollapsed = selection.isCollapsed;
          var anchor = (0, _getCaretPosition2.default)(anchorKey, anchorOffset, state, editor, _this.element);
          var focus = isCollapsed ? anchor : (0, _getCaretPosition2.default)(focusKey, focusOffset, state, editor, _this.element);

          // If they are already selected, do nothing.
          if (anchor.node == native.anchorNode && anchor.offset == native.anchorOffset && focus.node == native.focusNode && focus.offset == native.focusOffset) {
            return;
          }

          // Otherwise, set the `isSelecting` flag and update the selection.
          _this.tmp.isSelecting = true;
          native.removeAllRanges();
          var range = window.document.createRange();
          range.setStart(anchor.node, anchor.offset);
          native.addRange(range);
          if (!isCollapsed) (0, _extendSelection2.default)(native, focus.node, focus.offset);

          // Then unset the `isSelecting` flag after a delay.
          setTimeout(function () {
            // COMPAT: In Firefox, it's not enough to create a range, you also need to
            // focus the contenteditable element too. (2016/11/16)
            if (_environment.IS_FIREFOX) _this.element.focus();
            _this.tmp.isSelecting = false;
          });
          debug('updateSelection', {
            selection: selection,
            native: native
          });
        };
        _this.ref = function (element) {
          _this.element = element;
        };
        _this.isInEditor = function (target) {
          var element = _this.element;
          // COMPAT: Text nodes don't have `isContentEditable` property. So, when
          // `target` is a text node use its parent node for check.

          var el = target.nodeType === 3 ? target.parentNode : target;
          return el.isContentEditable && (el === element || (0, _findClosestNode2.default)(el, '[data-slate-editor]') === element);
        };
        _this.onBeforeInput = function (event) {
          if (_this.props.readOnly) return;
          if (!_this.isInEditor(event.target)) return;
          var data = {};
          debug('onBeforeInput', {
            event: event,
            data: data
          });
          _this.props.onBeforeInput(event, data);
        };
        _this.onBlur = function (event) {
          if (_this.props.readOnly) return;
          if (_this.tmp.isCopying) return;
          if (!_this.isInEditor(event.target)) return;

          // If the active element is still the editor, the blur event is due to the
          // window itself being blurred (eg. when changing tabs) so we should ignore
          // the event, since we want to maintain focus when returning.
          var window = (0, _getWindow2.default)(_this.element);
          if (window.document.activeElement == _this.element) return;
          var data = {};
          debug('onBlur', {
            event: event,
            data: data
          });
          _this.props.onBlur(event, data);
        };
        _this.onFocus = function (event) {
          if (_this.props.readOnly) return;
          if (_this.tmp.isCopying) return;
          if (!_this.isInEditor(event.target)) return;

          // COMPAT: If the editor has nested editable elements, the focus can go to
          // those elements. In Firefox, this must be prevented because it results in
          // issues with keyboard navigation. (2017/03/30)
          if (_environment.IS_FIREFOX && event.target != _this.element) {
            _this.element.focus();
            return;
          }
          var data = {};
          debug('onFocus', {
            event: event,
            data: data
          });
          _this.props.onFocus(event, data);
        };
        _this.onCompositionStart = function (event) {
          if (!_this.isInEditor(event.target)) return;
          _this.tmp.isComposing = true;
          _this.tmp.compositions++;
          debug('onCompositionStart', {
            event: event
          });
        };
        _this.onCompositionEnd = function (event) {
          if (!_this.isInEditor(event.target)) return;
          _this.tmp.forces++;
          var count = _this.tmp.compositions;

          // The `count` check here ensures that if another composition starts
          // before the timeout has closed out this one, we will abort unsetting the
          // `isComposing` flag, since a composition in still in affect.
          setTimeout(function () {
            if (_this.tmp.compositions > count) return;
            _this.tmp.isComposing = false;
          });
          debug('onCompositionEnd', {
            event: event
          });
        };
        _this.onCopy = function (event) {
          if (!_this.isInEditor(event.target)) return;
          var window = (0, _getWindow2.default)(event.target);
          _this.tmp.isCopying = true;
          window.requestAnimationFrame(function () {
            _this.tmp.isCopying = false;
          });
          var state = _this.props.state;
          var data = {};
          data.type = 'fragment';
          data.fragment = state.fragment;
          debug('onCopy', {
            event: event,
            data: data
          });
          _this.props.onCopy(event, data);
        };
        _this.onCut = function (event) {
          if (_this.props.readOnly) return;
          if (!_this.isInEditor(event.target)) return;
          var window = (0, _getWindow2.default)(event.target);
          _this.tmp.isCopying = true;
          window.requestAnimationFrame(function () {
            _this.tmp.isCopying = false;
          });
          var state = _this.props.state;
          var data = {};
          data.type = 'fragment';
          data.fragment = state.fragment;
          debug('onCut', {
            event: event,
            data: data
          });
          _this.props.onCut(event, data);
        };
        _this.onDragEnd = function (event) {
          if (!_this.isInEditor(event.target)) return;
          _this.tmp.isDragging = false;
          _this.tmp.isInternalDrag = null;
          debug('onDragEnd', {
            event: event
          });
        };
        _this.onDragOver = function (event) {
          if (!_this.isInEditor(event.target)) return;
          if (_this.tmp.isDragging) return;
          _this.tmp.isDragging = true;
          _this.tmp.isInternalDrag = false;
          debug('onDragOver', {
            event: event
          });
        };
        _this.onDragStart = function (event) {
          if (!_this.isInEditor(event.target)) return;
          _this.tmp.isDragging = true;
          _this.tmp.isInternalDrag = true;
          var dataTransfer = event.nativeEvent.dataTransfer;
          var data = (0, _getTransferData2.default)(dataTransfer);

          // If it's a node being dragged, the data type is already set.
          if (data.type == 'node') return;
          var state = _this.props.state;
          var fragment = state.fragment;
          var encoded = _slateBase64Serializer2.default.serializeNode(fragment);
          (0, _setTransferData2.default)(dataTransfer, _transferTypes2.default.FRAGMENT, encoded);
          debug('onDragStart', {
            event: event
          });
        };
        _this.onDrop = function (event) {
          event.preventDefault();
          if (_this.props.readOnly) return;
          if (!_this.isInEditor(event.target)) return;
          var window = (0, _getWindow2.default)(event.target);
          var _this$props2 = _this.props,
            state = _this$props2.state,
            editor = _this$props2.editor;
          var nativeEvent = event.nativeEvent;
          var dataTransfer = nativeEvent.dataTransfer,
            x = nativeEvent.x,
            y = nativeEvent.y;
          var data = (0, _getTransferData2.default)(dataTransfer);

          // Resolve the point where the drop occured.
          var range = void 0;

          // COMPAT: In Firefox, `caretRangeFromPoint` doesn't exist. (2016/07/25)
          if (window.document.caretRangeFromPoint) {
            range = window.document.caretRangeFromPoint(x, y);
          } else {
            range = window.document.createRange();
            range.setStart(nativeEvent.rangeParent, nativeEvent.rangeOffset);
          }
          var _range = range,
            startContainer = _range.startContainer,
            startOffset = _range.startOffset;
          var point = (0, _getPoint2.default)(startContainer, startOffset, state, editor);
          if (!point) return;
          var target = _slate.Selection.create({
            anchorKey: point.key,
            anchorOffset: point.offset,
            focusKey: point.key,
            focusOffset: point.offset,
            isFocused: true
          });

          // Add drop-specific information to the data.
          data.target = target;

          // COMPAT: Edge throws "Permission denied" errors when
          // accessing `dropEffect` or `effectAllowed` (2017/7/12)
          try {
            data.effect = dataTransfer.dropEffect;
          } catch (err) {
            data.effect = null;
          }
          if (data.type == 'fragment' || data.type == 'node') {
            data.isInternal = _this.tmp.isInternalDrag;
          }
          debug('onDrop', {
            event: event,
            data: data
          });
          _this.props.onDrop(event, data);
        };
        _this.onInput = function (event) {
          if (_this.tmp.isComposing) return;
          if (_this.props.state.isBlurred) return;
          if (!_this.isInEditor(event.target)) return;
          debug('onInput', {
            event: event
          });
          var window = (0, _getWindow2.default)(event.target);
          var _this$props3 = _this.props,
            state = _this$props3.state,
            editor = _this$props3.editor;

          // Get the selection point.

          var native = window.getSelection();
          var anchorNode = native.anchorNode,
            anchorOffset = native.anchorOffset;
          var point = (0, _getPoint2.default)(anchorNode, anchorOffset, state, editor);
          if (!point) return;

          // Get the range in question.
          var key = point.key,
            index = point.index,
            start = point.start,
            end = point.end;
          var document = state.document,
            selection = state.selection;
          var schema = editor.getSchema();
          var decorators = document.getDescendantDecorators(key, schema);
          var node = document.getDescendant(key);
          var block = document.getClosestBlock(node.key);
          var ranges = node.getRanges(decorators);
          var lastText = block.getLastText();

          // Get the text information.
          var textContent = anchorNode.textContent;
          var lastChar = textContent.charAt(textContent.length - 1);
          var isLastText = node == lastText;
          var isLastRange = index == ranges.size - 1;

          // If we're dealing with the last leaf, and the DOM text ends in a new line,
          // we will have added another new line in <Leaf>'s render method to account
          // for browsers collapsing a single trailing new lines, so remove it.
          if (isLastText && isLastRange && lastChar == '\n') {
            textContent = textContent.slice(0, -1);
          }

          // If the text is no different, abort.
          var range = ranges.get(index);
          var text = range.text,
            marks = range.marks;
          if (textContent == text) return;

          // Determine what the selection should be after changing the text.
          var delta = textContent.length - text.length;
          var after = selection.collapseToEnd().move(delta);

          // Change the current state to have the text replaced.
          editor.change(function (change) {
            change.select({
              anchorKey: key,
              anchorOffset: start,
              focusKey: key,
              focusOffset: end
            }).delete().insertText(textContent, marks).select(after);
          });
        };
        _this.onKeyDown = function (event) {
          if (_this.props.readOnly) return;
          if (!_this.isInEditor(event.target)) return;
          var altKey = event.altKey,
            ctrlKey = event.ctrlKey,
            metaKey = event.metaKey,
            shiftKey = event.shiftKey,
            which = event.which;
          var key = (0, _keycode2.default)(which);
          var data = {};

          // Keep track of an `isShifting` flag, because it's often used to trigger
          // "Paste and Match Style" commands, but isn't available on the event in a
          // normal paste event.
          if (key == 'shift') {
            _this.tmp.isShifting = true;
          }

          // When composing, these characters commit the composition but also move the
          // selection before we're able to handle it, so prevent their default,
          // selection-moving behavior.
          if (_this.tmp.isComposing && (key == 'left' || key == 'right' || key == 'up' || key == 'down')) {
            event.preventDefault();
            return;
          }

          // Add helpful properties for handling hotkeys to the data object.
          data.code = which;
          data.key = key;
          data.isAlt = altKey;
          data.isCmd = _environment.IS_MAC ? metaKey && !altKey : false;
          data.isCtrl = ctrlKey && !altKey;
          data.isLine = _environment.IS_MAC ? metaKey : false;
          data.isMeta = metaKey;
          data.isMod = _environment.IS_MAC ? metaKey && !altKey : ctrlKey && !altKey;
          data.isModAlt = _environment.IS_MAC ? metaKey && altKey : ctrlKey && altKey;
          data.isShift = shiftKey;
          data.isWord = _environment.IS_MAC ? altKey : ctrlKey;

          // These key commands have native behavior in contenteditable elements which
          // will cause our state to be out of sync, so prevent them.
          if (key == 'enter' || key == 'backspace' || key == 'delete' || key == 'b' && data.isMod || key == 'i' && data.isMod || key == 'y' && data.isMod || key == 'z' && data.isMod) {
            event.preventDefault();
          }
          debug('onKeyDown', {
            event: event,
            data: data
          });
          _this.props.onKeyDown(event, data);
        };
        _this.onKeyUp = function (event) {
          var altKey = event.altKey,
            ctrlKey = event.ctrlKey,
            metaKey = event.metaKey,
            shiftKey = event.shiftKey,
            which = event.which;
          var key = (0, _keycode2.default)(which);
          var data = {};
          if (key == 'shift') {
            _this.tmp.isShifting = false;
          }

          // Add helpful properties for handling hotkeys to the data object.
          data.code = which;
          data.key = key;
          data.isAlt = altKey;
          data.isCmd = _environment.IS_MAC ? metaKey && !altKey : false;
          data.isCtrl = ctrlKey && !altKey;
          data.isLine = _environment.IS_MAC ? metaKey : false;
          data.isMeta = metaKey;
          data.isMod = _environment.IS_MAC ? metaKey && !altKey : ctrlKey && !altKey;
          data.isModAlt = _environment.IS_MAC ? metaKey && altKey : ctrlKey && altKey;
          data.isShift = shiftKey;
          data.isWord = _environment.IS_MAC ? altKey : ctrlKey;
          debug('onKeyUp', {
            event: event,
            data: data
          });
          _this.props.onKeyUp(event, data);
        };
        _this.onPaste = function (event) {
          if (_this.props.readOnly) return;
          if (!_this.isInEditor(event.target)) return;
          var data = (0, _getTransferData2.default)(event.clipboardData);

          // Attach the `isShift` flag, so that people can use it to trigger "Paste
          // and Match Style" logic.
          data.isShift = !!_this.tmp.isShifting;
          debug('onPaste', {
            event: event,
            data: data
          });

          // COMPAT: In IE 11, only plain text can be retrieved from the event's
          // `clipboardData`. To get HTML, use the browser's native paste action which
          // can only be handled synchronously. (2017/06/23)
          if (_environment.IS_IE) {
            // Do not use `event.preventDefault()` as we need the native paste action.
            (0, _getHtmlFromNativePaste2.default)(event.target, function (html) {
              // If pasted HTML can be retreived, it is added to the `data` object,
              // setting the `type` to `html`.
              _this.props.onPaste(event, html === undefined ? data : _extends({}, data, {
                html: html,
                type: 'html'
              }));
            });
          } else {
            event.preventDefault();
            _this.props.onPaste(event, data);
          }
        };
        _this.onSelect = function (event) {
          if (_this.props.readOnly) return;
          if (_this.tmp.isCopying) return;
          if (_this.tmp.isComposing) return;
          if (_this.tmp.isSelecting) return;
          if (!_this.isInEditor(event.target)) return;
          var window = (0, _getWindow2.default)(event.target);
          var _this$props4 = _this.props,
            state = _this$props4.state,
            editor = _this$props4.editor;
          var document = state.document,
            selection = state.selection;
          var native = window.getSelection();
          var data = {};

          // If there are no ranges, the editor was blurred natively.
          if (!native.rangeCount) {
            data.selection = selection.set('isFocused', false);
          }

          // Otherwise, determine the Slate selection from the native one.
          else {
            var anchorNode = native.anchorNode,
              anchorOffset = native.anchorOffset,
              focusNode = native.focusNode,
              focusOffset = native.focusOffset;
            var anchor = (0, _getPoint2.default)(anchorNode, anchorOffset, state, editor);
            var focus = (0, _getPoint2.default)(focusNode, focusOffset, state, editor);
            if (!anchor || !focus) return;

            // There are situations where a select event will fire with a new native
            // selection that resolves to the same internal position. In those cases
            // we don't need to trigger any changes, since our internal model is
            // already up to date, but we do want to update the native selection again
            // to make sure it is in sync.
            if (anchor.key == selection.anchorKey && anchor.offset == selection.anchorOffset && focus.key == selection.focusKey && focus.offset == selection.focusOffset && selection.isFocused) {
              _this.updateSelection();
              return;
            }
            var properties = {
              anchorKey: anchor.key,
              anchorOffset: anchor.offset,
              focusKey: focus.key,
              focusOffset: focus.offset,
              isFocused: true,
              isBackward: null
            };
            var anchorText = document.getNode(anchor.key);
            var focusText = document.getNode(focus.key);
            var anchorInline = document.getClosestInline(anchor.key);
            var focusInline = document.getClosestInline(focus.key);
            var focusBlock = document.getClosestBlock(focus.key);
            var anchorBlock = document.getClosestBlock(anchor.key);

            // COMPAT: If the anchor point is at the start of a non-void, and the
            // focus point is inside a void node with an offset that isn't `0`, set
            // the focus offset to `0`. This is due to void nodes <span>'s being
            // positioned off screen, resulting in the offset always being greater
            // than `0`. Since we can't know what it really should be, and since an
            // offset of `0` is less destructive because it creates a hanging
            // selection, go with `0`. (2017/09/07)
            if (anchorBlock && !anchorBlock.isVoid && anchor.offset == 0 && focusBlock && focusBlock.isVoid && focus.offset != 0) {
              properties.focusOffset = 0;
            }

            // COMPAT: If the selection is at the end of a non-void inline node, and
            // there is a node after it, put it in the node after instead. This
            // standardizes the behavior, since it's indistinguishable to the user.
            if (anchorInline && !anchorInline.isVoid && anchor.offset == anchorText.text.length) {
              var block = document.getClosestBlock(anchor.key);
              var next = block.getNextText(anchor.key);
              if (next) {
                properties.anchorKey = next.key;
                properties.anchorOffset = 0;
              }
            }
            if (focusInline && !focusInline.isVoid && focus.offset == focusText.text.length) {
              var _block = document.getClosestBlock(focus.key);
              var _next = _block.getNextText(focus.key);
              if (_next) {
                properties.focusKey = _next.key;
                properties.focusOffset = 0;
              }
            }
            data.selection = selection.merge(properties).normalize(document);
          }
          debug('onSelect', {
            event: event,
            data: data
          });
          _this.props.onSelect(event, data);
        };
        _this.renderNode = function (child, isSelected) {
          var _this$props5 = _this.props,
            editor = _this$props5.editor,
            readOnly = _this$props5.readOnly,
            schema = _this$props5.schema,
            state = _this$props5.state;
          var document = state.document;
          return _react2.default.createElement(_node2.default, {
            block: null,
            editor: editor,
            isSelected: isSelected,
            key: child.key,
            node: child,
            parent: document,
            readOnly: readOnly,
            schema: schema,
            state: state
          });
        };
        _this.tmp = {};
        _this.tmp.compositions = 0;
        _this.tmp.forces = 0;
        return _this;
      }

      /**
       * When the editor first mounts in the DOM we need to:
       *
       *   - Update the selection, in case it starts focused.
       *   - Focus the editor if `autoFocus` is set.
       */

      /**
       * Default properties.
       *
       * @type {Object}
       */

      /**
       * On update, update the selection.
       */

      /**
       * Update the native DOM selection to reflect the internal model.
       */

      /**
       * The React ref method to set the root content element locally.
       *
       * @param {Element} element
       */

      /**
       * Check if an event `target` is fired from within the contenteditable
       * element. This should be false for edits happening in non-contenteditable
       * children, such as void nodes and other nested Slate editors.
       *
       * @param {Element} target
       * @return {Boolean}
       */

      /**
       * On before input, bubble up.
       *
       * @param {Event} event
       */

      /**
       * On blur, update the selection to be not focused.
       *
       * @param {Event} event
       */

      /**
       * On focus, update the selection to be focused.
       *
       * @param {Event} event
       */

      /**
       * On composition start, set the `isComposing` flag.
       *
       * @param {Event} event
       */

      /**
       * On composition end, remove the `isComposing` flag on the next tick. Also
       * increment the `forces` key, which will force the contenteditable element
       * to completely re-render, since IME puts React in an unreconcilable state.
       *
       * @param {Event} event
       */

      /**
       * On copy, defer to `onCutCopy`, then bubble up.
       *
       * @param {Event} event
       */

      /**
       * On cut, defer to `onCutCopy`, then bubble up.
       *
       * @param {Event} event
       */

      /**
       * On drag end, unset the `isDragging` flag.
       *
       * @param {Event} event
       */

      /**
       * On drag over, set the `isDragging` flag and the `isInternalDrag` flag.
       *
       * @param {Event} event
       */

      /**
       * On drag start, set the `isDragging` flag and the `isInternalDrag` flag.
       *
       * @param {Event} event
       */

      /**
       * On drop.
       *
       * @param {Event} event
       */

      /**
       * On input, handle spellcheck and other similar edits that don't go trigger
       * the `onBeforeInput` and instead update the DOM directly.
       *
       * @param {Event} event
       */

      /**
       * On key down, prevent the default behavior of certain commands that will
       * leave the editor in an out-of-sync state, then bubble up.
       *
       * @param {Event} event
       */

      /**
       * On key up, unset the `isShifting` flag.
       *
       * @param {Event} event
       */

      /**
       * On paste, determine the type and bubble up.
       *
       * @param {Event} event
       */

      /**
       * On select, update the current state's selection.
       *
       * @param {Event} event
       */

      _createClass(Content, [{
        key: 'render',
        /**
         * Render the editor content.
         *
         * @return {Element}
         */

        value: function render() {
          var _this2 = this;
          var props = this.props;
          var className = props.className,
            readOnly = props.readOnly,
            state = props.state,
            tabIndex = props.tabIndex,
            role = props.role,
            tagName = props.tagName;
          var Container = tagName;
          var document = state.document,
            selection = state.selection;
          var indexes = document.getSelectionIndexes(selection, selection.isFocused);
          var children = document.nodes.toArray().map(function (child, i) {
            var isSelected = !!indexes && indexes.start <= i && i < indexes.end;
            return _this2.renderNode(child, isSelected);
          });
          var style = _extends({
            // Prevent the default outline styles.
            outline: 'none',
            // Preserve adjacent whitespace and new lines.
            whiteSpace: 'pre-wrap',
            // Allow words to break if they are too long.
            wordWrap: 'break-word'
          }, readOnly ? {} : {
            WebkitUserModify: 'read-write-plaintext-only'
          }, props.style);

          // COMPAT: In Firefox, spellchecking can remove entire wrapping elements
          // including inline ones like `<a>`, which is jarring for the user but also
          // causes the DOM to get into an irreconcilable state. (2016/09/01)
          var spellCheck = _environment.IS_FIREFOX ? false : props.spellCheck;
          debug('render', {
            props: props
          });
          return _react2.default.createElement(Container, {
            'data-slate-editor': true,
            key: this.tmp.forces,
            ref: this.ref,
            'data-key': document.key,
            contentEditable: !readOnly,
            suppressContentEditableWarning: true,
            className: className,
            onBeforeInput: this.onBeforeInput,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            onCompositionEnd: this.onCompositionEnd,
            onCompositionStart: this.onCompositionStart,
            onCopy: this.onCopy,
            onCut: this.onCut,
            onDragEnd: this.onDragEnd,
            onDragOver: this.onDragOver,
            onDragStart: this.onDragStart,
            onDrop: this.onDrop,
            onInput: this.onInput,
            onKeyDown: this.onKeyDown,
            onKeyUp: this.onKeyUp,
            onPaste: this.onPaste,
            onSelect: this.onSelect,
            autoCorrect: props.autoCorrect,
            spellCheck: spellCheck,
            style: style,
            role: readOnly ? null : role || 'textbox',
            tabIndex: tabIndex
            // COMPAT: The Grammarly Chrome extension works by changing the DOM out
            // from under `contenteditable` elements, which leads to weird behaviors
            // so we have to disable it like this. (2017/04/24)
            ,
            'data-gramm': false
          }, children, this.props.children);
        }

        /**
         * Render a `child` node of the document.
         *
         * @param {Node} child
         * @param {Boolean} isSelected
         * @return {Element}
         */
      }]);
      return Content;
    }(_react2.default.Component);

    /**
     * Export.
     *
     * @type {Component}
     */

    Content.propTypes = {
      autoCorrect: _propTypes2.default.bool.isRequired,
      autoFocus: _propTypes2.default.bool.isRequired,
      children: _propTypes2.default.array.isRequired,
      className: _propTypes2.default.string,
      editor: _propTypes2.default.object.isRequired,
      onBeforeInput: _propTypes2.default.func.isRequired,
      onBlur: _propTypes2.default.func.isRequired,
      onCopy: _propTypes2.default.func.isRequired,
      onCut: _propTypes2.default.func.isRequired,
      onDrop: _propTypes2.default.func.isRequired,
      onFocus: _propTypes2.default.func.isRequired,
      onKeyDown: _propTypes2.default.func.isRequired,
      onKeyUp: _propTypes2.default.func.isRequired,
      onPaste: _propTypes2.default.func.isRequired,
      onSelect: _propTypes2.default.func.isRequired,
      readOnly: _propTypes2.default.bool.isRequired,
      role: _propTypes2.default.string,
      schema: _slatePropTypes2.default.schema.isRequired,
      spellCheck: _propTypes2.default.bool.isRequired,
      state: _slatePropTypes2.default.state.isRequired,
      style: _propTypes2.default.object,
      tabIndex: _propTypes2.default.number,
      tagName: _propTypes2.default.string
    };
    Content.defaultProps = {
      style: {},
      tagName: 'div'
    };
    exports.default = Content;

    /***/
  }), ( /* 554 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    var _debug = __webpack_require__(20);
    var _debug2 = _interopRequireDefault(_debug);
    var _reactPortal = __webpack_require__(547);
    var _reactPortal2 = _interopRequireDefault(_reactPortal);
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _slatePropTypes = __webpack_require__(53);
    var _slatePropTypes2 = _interopRequireDefault(_slatePropTypes);
    var _propTypes = __webpack_require__(54);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _slateDevLogger = __webpack_require__(16);
    var _slateDevLogger2 = _interopRequireDefault(_slateDevLogger);
    var _slate = __webpack_require__(22);
    var _core = __webpack_require__(558);
    var _core2 = _interopRequireDefault(_core);
    var _noop = __webpack_require__(564);
    var _noop2 = _interopRequireDefault(_noop);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _toConsumableArray(arr) {
      if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
          arr2[i] = arr[i];
        }
        return arr2;
      } else {
        return Array.from(arr);
      }
    }
    function _objectWithoutProperties(obj, keys) {
      var target = {};
      for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
      }
      return target;
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    /**
     * Debug.
     *
     * @type {Function}
     */

    var debug = (0, _debug2.default)('slate:editor');

    /**
     * Event handlers to mix in to the editor.
     *
     * @type {Array}
     */

    var EVENT_HANDLERS = ['onBeforeInput', 'onBlur', 'onFocus', 'onCopy', 'onCut', 'onDrop', 'onKeyDown', 'onKeyUp', 'onPaste', 'onSelect'];

    /**
     * Plugin-related properties of the editor.
     *
     * @type {Array}
     */

    var PLUGINS_PROPS = [].concat(EVENT_HANDLERS, ['placeholder', 'placeholderClassName', 'placeholderStyle', 'plugins', 'schema']);

    /**
     * Editor.
     *
     * @type {Component}
     */

    var Editor = function (_React$Component) {
      _inherits(Editor, _React$Component);

      /**
       * When constructed, create a new `Stack` and run `onBeforeChange`.
       *
       * @param {Object} props
       */

      /**
       * Property types.
       *
       * @type {Object}
       */

      function Editor(props) {
        _classCallCheck(this, Editor);
        var _this = _possibleConstructorReturn(this, (Editor.__proto__ || Object.getPrototypeOf(Editor)).call(this, props));
        _initialiseProps.call(_this);
        _this.tmp = {};
        _this.state = {};

        // Create a new `Stack`, omitting the `onChange` property since that has
        // special significance on the editor itself.
        var state = props.state;
        var plugins = resolvePlugins(props);
        var stack = _slate.Stack.create({
          plugins: plugins
        });
        _this.state.stack = stack;

        // Cache and set the state.
        _this.cacheState(state);
        _this.state.state = state;

        // Create a bound event handler for each event.

        var _loop = function _loop(i) {
          var method = EVENT_HANDLERS[i];
          _this[method] = function () {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            var stk = _this.state.stack;
            var change = _this.state.state.change();
            stk[method].apply(stk, [change, _this].concat(args));
            stk.onBeforeChange(change, _this);
            stk.onChange(change, _this);
            _this.onChange(change);
          };
        };
        for (var i = 0; i < EVENT_HANDLERS.length; i++) {
          _loop(i);
        }
        if (props.onDocumentChange) {
          _slateDevLogger2.default.deprecate('0.22.10', 'The `onDocumentChange` prop is deprecated because it led to confusing UX issues, see https://github.com/ianstormtaylor/slate/issues/614#issuecomment-327868679');
        }
        if (props.onSelectionChange) {
          _slateDevLogger2.default.deprecate('0.22.10', 'The `onSelectionChange` prop is deprecated because it led to confusing UX issues, see https://github.com/ianstormtaylor/slate/issues/614#issuecomment-327868679');
        }
        return _this;
      }

      /**
       * When the `props` are updated, create a new `Stack` if necessary.
       *
       * @param {Object} props
       */

      /**
       * Default properties.
       *
       * @type {Object}
       */

      /**
       * Cache a `state` in memory to be able to compare against it later, for
       * things like `onDocumentChange`.
       *
       * @param {State} state
       */

      /**
       * Programmatically blur the editor.
       */

      /**
       * Programmatically focus the editor.
       */

      /**
       * Get the editor's current schema.
       *
       * @return {Schema}
       */

      /**
       * Get the editor's current state.
       *
       * @return {State}
       */

      /**
       * Perform a change `fn` on the editor's current state.
       *
       * @param {Function} fn
       */

      /**
       * On change.
       *
       * @param {Change} change
       */

      _createClass(Editor, [{
        key: 'render',
        /**
         * Render the editor.
         *
         * @return {Element}
         */

        value: function render() {
          var props = this.props,
            state = this.state;
          var stack = state.stack;
          var children = stack.renderPortal(state.state, this).map(function (child, i) {
            return _react2.default.createElement(_reactPortal2.default, {
              key: i,
              isOpened: true
            }, child);
          });
          debug('render', {
            props: props,
            state: state
          });
          var tree = stack.render(state.state, this, _extends({}, props, {
            children: children
          }));
          return tree;
        }
      }]);
      return Editor;
    }(_react2.default.Component);

    /**
     * Resolve an array of plugins from `props`.
     *
     * In addition to the plugins provided in `props.plugins`, this will create
     * two other plugins:
     *
     * - A plugin made from the top-level `props` themselves, which are placed at
     * the beginning of the stack. That way, you can add a `onKeyDown` handler,
     * and it will override all of the existing plugins.
     *
     * - A "core" functionality plugin that handles the most basic events in
     * Slate, like deleting characters, splitting blocks, etc.
     *
     * @param {Object} props
     * @return {Array}
     */

    Editor.propTypes = {
      autoCorrect: _propTypes2.default.bool,
      autoFocus: _propTypes2.default.bool,
      className: _propTypes2.default.string,
      onBeforeChange: _propTypes2.default.func,
      onChange: _propTypes2.default.func,
      placeholder: _propTypes2.default.any,
      placeholderClassName: _propTypes2.default.string,
      placeholderStyle: _propTypes2.default.object,
      plugins: _propTypes2.default.array,
      readOnly: _propTypes2.default.bool,
      role: _propTypes2.default.string,
      schema: _propTypes2.default.object,
      spellCheck: _propTypes2.default.bool,
      state: _slatePropTypes2.default.state.isRequired,
      style: _propTypes2.default.object,
      tabIndex: _propTypes2.default.number
    };
    Editor.defaultProps = {
      autoFocus: false,
      autoCorrect: true,
      onChange: _noop2.default,
      plugins: [],
      readOnly: false,
      schema: {},
      spellCheck: true
    };
    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;
      this.componentWillReceiveProps = function (props) {
        var state = props.state;

        // If any plugin-related properties will change, create a new `Stack`.

        for (var _i = 0; _i < PLUGINS_PROPS.length; _i++) {
          var prop = PLUGINS_PROPS[_i];
          if (props[prop] == _this2.props[prop]) continue;
          var plugins = resolvePlugins(props);
          var stack = _slate.Stack.create({
            plugins: plugins
          });
          _this2.setState({
            stack: stack
          });
        }

        // Cache and save the state.
        _this2.cacheState(state);
        _this2.setState({
          state: state
        });
      };
      this.cacheState = function (state) {
        _this2.tmp.document = state.document;
        _this2.tmp.selection = state.selection;
      };
      this.blur = function () {
        _this2.change(function (t) {
          return t.blur();
        });
      };
      this.focus = function () {
        _this2.change(function (t) {
          return t.focus();
        });
      };
      this.getSchema = function () {
        return _this2.state.stack.schema;
      };
      this.getState = function () {
        return _this2.state.state;
      };
      this.change = function (fn) {
        var change = _this2.state.state.change();
        fn(change);
        _this2.onChange(change);
      };
      this.onChange = function (change) {
        if (_slate.State.isState(change)) {
          throw new Error('As of slate@0.22.0 the `editor.onChange` method must be passed a `Change` object not a `State` object.');
        }
        var _props = _this2.props,
          onChange = _props.onChange,
          onDocumentChange = _props.onDocumentChange,
          onSelectionChange = _props.onSelectionChange;
        var _tmp = _this2.tmp,
          document = _tmp.document,
          selection = _tmp.selection;
        var state = change.state;
        if (state == _this2.state.state) return;
        onChange(change);
        if (onDocumentChange && state.document != document) onDocumentChange(state.document, change);
        if (onSelectionChange && state.selection != selection) onSelectionChange(state.selection, change);
      };
    };
    function resolvePlugins(props) {
      // eslint-disable-next-line no-unused-vars
      var state = props.state,
        onChange = props.onChange,
        _props$plugins = props.plugins,
        plugins = _props$plugins === undefined ? [] : _props$plugins,
        overridePlugin = _objectWithoutProperties(props, ['state', 'onChange', 'plugins']);
      var corePlugin = (0, _core2.default)(props);
      return [overridePlugin].concat(_toConsumableArray(plugins), [corePlugin]);
    }

    /**
     * Mix in the property types for the event handlers.
     */

    for (var i = 0; i < EVENT_HANDLERS.length; i++) {
      var property = EVENT_HANDLERS[i];
      Editor.propTypes[property] = _propTypes2.default.func;
    }

    /**
     * Export.
     *
     * @type {Component}
     */

    exports.default = Editor;

    /***/
  }), ( /* 555 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    var _slateBase64Serializer = __webpack_require__(97);
    var _slateBase64Serializer2 = _interopRequireDefault(_slateBase64Serializer);
    var _debug = __webpack_require__(20);
    var _debug2 = _interopRequireDefault(_debug);
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _reactDom = __webpack_require__(4);
    var _reactDom2 = _interopRequireDefault(_reactDom);
    var _slatePropTypes = __webpack_require__(53);
    var _slatePropTypes2 = _interopRequireDefault(_slatePropTypes);
    var _propTypes = __webpack_require__(54);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _getWindow = __webpack_require__(94);
    var _getWindow2 = _interopRequireDefault(_getWindow);
    var _transferTypes = __webpack_require__(143);
    var _transferTypes2 = _interopRequireDefault(_transferTypes);
    var _leaf = __webpack_require__(223);
    var _leaf2 = _interopRequireDefault(_leaf);
    var _void = __webpack_require__(556);
    var _void2 = _interopRequireDefault(_void);
    var _scrollToSelection = __webpack_require__(566);
    var _scrollToSelection2 = _interopRequireDefault(_scrollToSelection);
    var _setTransferData = __webpack_require__(228);
    var _setTransferData2 = _interopRequireDefault(_setTransferData);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    /**
     * Debug.
     *
     * @type {Function}
     */

    var debug = (0, _debug2.default)('slate:node');

    /**
     * Node.
     *
     * @type {Component}
     */

    var Node = function (_React$Component) {
      _inherits(Node, _React$Component);

      /**
       * Constructor.
       *
       * @param {Object} props
       */

      function Node(props) {
        _classCallCheck(this, Node);
        var _this = _possibleConstructorReturn(this, (Node.__proto__ || Object.getPrototypeOf(Node)).call(this, props));
        _initialiseProps.call(_this);
        var node = props.node,
          schema = props.schema;
        _this.state = {};
        _this.state.Component = node.kind == 'text' ? null : node.getComponent(schema);
        return _this;
      }

      /**
       * Debug.
       *
       * @param {String} message
       * @param {Mixed} ...args
       */

      /**
       * Property types.
       *
       * @type {Object}
       */

      /**
       * On receiving new props, update the `Component` renderer.
       *
       * @param {Object} props
       */

      /**
       * Should the node update?
       *
       * @param {Object} nextProps
       * @param {Object} state
       * @return {Boolean}
       */

      /**
       * On mount, update the scroll position.
       */

      /**
       * After update, update the scroll position if the node's content changed.
       *
       * @param {Object} prevProps
       * @param {Object} prevState
       */

      /**
       * There is a corner case, that some nodes are unmounted right after they update
       * Then, when the timer execute, it will throw the error
       * `findDOMNode was called on an unmounted component`
       * We should clear the timer from updateScroll here
       */

      /**
       * Update the scroll position after a change as occured if this is a leaf
       * block and it has the selection's ending edge. This ensures that scrolling
       * matches native `contenteditable` behavior even for cases where the edit is
       * not applied natively, like when enter is pressed.
       */

      /**
       * On drag start, add a serialized representation of the node to the data.
       *
       * @param {Event} e
       */

      _createClass(Node, [{
        key: 'render',
        /**
         * Render.
         *
         * @return {Element}
         */

        value: function render() {
          var props = this.props;
          var node = this.props.node;
          this.debug('render', {
            props: props
          });
          return node.kind == 'text' ? this.renderText() : this.renderElement();
        }

        /**
         * Render a `child` node.
         *
         * @param {Node} child
         * @param {Boolean} isSelected
         * @return {Element}
         */

        /**
         * Render an element `node`.
         *
         * @return {Element}
         */

        /**
         * Render a text node.
         *
         * @return {Element}
         */

        /**
         * Render a single leaf node given a `range` and `offset`.
         *
         * @param {List<Range>} ranges
         * @param {Range} range
         * @param {Number} index
         * @param {Number} offset
         * @return {Element} leaf
         */
      }]);
      return Node;
    }(_react2.default.Component);

    /**
     * Export.
     *
     * @type {Component}
     */

    Node.propTypes = {
      block: _slatePropTypes2.default.block,
      editor: _propTypes2.default.object.isRequired,
      isSelected: _propTypes2.default.bool.isRequired,
      node: _slatePropTypes2.default.node.isRequired,
      parent: _slatePropTypes2.default.node.isRequired,
      readOnly: _propTypes2.default.bool.isRequired,
      schema: _slatePropTypes2.default.schema.isRequired,
      state: _slatePropTypes2.default.state.isRequired
    };
    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;
      this.debug = function (message) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        var node = _this2.props.node;
        var key = node.key,
          kind = node.kind,
          type = node.type;
        var id = kind == 'text' ? key + ' (' + kind + ')' : key + ' (' + type + ')';
        debug.apply(undefined, [message, '' + id].concat(args));
      };
      this.componentWillReceiveProps = function (props) {
        if (props.node.kind == 'text') return;
        if (props.node == _this2.props.node) return;
        var Component = props.node.getComponent(props.schema);
        _this2.setState({
          Component: Component
        });
      };
      this.shouldComponentUpdate = function (nextProps) {
        var props = _this2.props;
        var Component = _this2.state.Component;
        var n = nextProps;
        var p = props;

        // If the `Component` has enabled suppression of update checking, always
        // return true so that it can deal with update checking itself.
        if (Component && Component.suppressShouldComponentUpdate) return true;

        // If the `readOnly` status has changed, re-render in case there is any
        // user-land logic that depends on it, like nested editable contents.
        if (n.readOnly != p.readOnly) return true;

        // If the node has changed, update. PERF: There are cases where it will have
        // changed, but it's properties will be exactly the same (eg. copy-paste)
        // which this won't catch. But that's rare and not a drag on performance, so
        // for simplicity we just let them through.
        if (n.node != p.node) return true;

        // If the node's selection state has changed, re-render in case there is any
        // user-land logic depends on it to render.
        if (n.isSelected != p.isSelected) return true;

        // If the node is a text node, re-render if the current decorations have
        // changed, even if the content of the text node itself hasn't.
        if (n.node.kind == 'text' && n.schema.hasDecorators) {
          var nDecorators = n.state.document.getDescendantDecorators(n.node.key, n.schema);
          var pDecorators = p.state.document.getDescendantDecorators(p.node.key, p.schema);
          var nRanges = n.node.getRanges(nDecorators);
          var pRanges = p.node.getRanges(pDecorators);
          if (!nRanges.equals(pRanges)) return true;
        }

        // If the node is a text node, and its parent is a block node, and it was
        // the last child of the block, re-render to cleanup extra `<br/>` or `\n`.
        if (n.node.kind == 'text' && n.parent.kind == 'block') {
          var pLast = p.parent.nodes.last();
          var nLast = n.parent.nodes.last();
          if (p.node == pLast && n.node != nLast) return true;
        }

        // Otherwise, don't update.
        return false;
      };
      this.componentDidMount = function () {
        _this2.updateScroll();
      };
      this.componentDidUpdate = function (prevProps, prevState) {
        if (_this2.props.node != prevProps.node) _this2.updateScroll();
      };
      this.componentWillUnmount = function () {
        clearTimeout(_this2.scrollTimer);
      };
      this.updateScroll = function () {
        var _props = _this2.props,
          node = _props.node,
          state = _props.state;
        var selection = state.selection;

        // If this isn't a block, or it's a wrapping block, abort.

        if (node.kind != 'block') return;
        if (node.nodes.first().kind == 'block') return;

        // If the selection is blurred, or this block doesn't contain it, abort.
        if (selection.isBlurred) return;
        if (!selection.hasEndIn(node)) return;

        // The native selection will be updated after componentDidMount or componentDidUpdate.
        // Use setTimeout to queue scrolling to the last when the native selection has been updated to the correct value.
        _this2.scrollTimer = setTimeout(function () {
          var el = _reactDom2.default.findDOMNode(_this2);
          var window = (0, _getWindow2.default)(el);
          var native = window.getSelection();
          (0, _scrollToSelection2.default)(native);
          _this2.debug('updateScroll', el);
        });
      };
      this.onDragStart = function (e) {
        var node = _this2.props.node;

        // Only void node are draggable

        if (!node.isVoid) {
          return;
        }
        var encoded = _slateBase64Serializer2.default.serializeNode(node, {
          preserveKeys: true
        });
        var dataTransfer = e.nativeEvent.dataTransfer;
        (0, _setTransferData2.default)(dataTransfer, _transferTypes2.default.NODE, encoded);
        _this2.debug('onDragStart', e);
      };
      this.renderNode = function (child, isSelected) {
        var _props2 = _this2.props,
          block = _props2.block,
          editor = _props2.editor,
          node = _props2.node,
          readOnly = _props2.readOnly,
          schema = _props2.schema,
          state = _props2.state;
        return _react2.default.createElement(Node, {
          block: node.kind == 'block' ? node : block,
          editor: editor,
          isSelected: isSelected,
          key: child.key,
          node: child,
          parent: node,
          readOnly: readOnly,
          schema: schema,
          state: state
        });
      };
      this.renderElement = function () {
        var _props3 = _this2.props,
          editor = _props3.editor,
          isSelected = _props3.isSelected,
          node = _props3.node,
          parent = _props3.parent,
          readOnly = _props3.readOnly,
          state = _props3.state;
        var Component = _this2.state.Component;
        var selection = state.selection;
        var indexes = node.getSelectionIndexes(selection, isSelected);
        var children = node.nodes.toArray().map(function (child, i) {
          var isChildSelected = !!indexes && indexes.start <= i && i < indexes.end;
          return _this2.renderNode(child, isChildSelected);
        });

        // Attributes that the developer must to mix into the element in their
        // custom node renderer component.
        var attributes = {
          'data-key': node.key,
          'onDragStart': _this2.onDragStart
        };

        // If it's a block node with inline children, add the proper `dir` attribute
        // for text direction.
        if (node.kind == 'block' && node.nodes.first().kind != 'block') {
          var direction = node.getTextDirection();
          if (direction == 'rtl') attributes.dir = 'rtl';
        }
        var element = _react2.default.createElement(Component, {
          attributes: attributes,
          editor: editor,
          isSelected: isSelected,
          key: node.key,
          node: node,
          parent: parent,
          readOnly: readOnly,
          state: state
        }, children);
        return node.isVoid ? _react2.default.createElement(_void2.default, _this2.props, element) : element;
      };
      this.renderText = function () {
        var _props4 = _this2.props,
          node = _props4.node,
          schema = _props4.schema,
          state = _props4.state;
        var document = state.document;
        var decorators = schema.hasDecorators ? document.getDescendantDecorators(node.key, schema) : [];
        var ranges = node.getRanges(decorators);
        var offset = 0;
        var leaves = ranges.map(function (range, i) {
          var leaf = _this2.renderLeaf(ranges, range, i, offset);
          offset += range.text.length;
          return leaf;
        });
        return _react2.default.createElement('span', {
          'data-key': node.key
        }, leaves);
      };
      this.renderLeaf = function (ranges, range, index, offset) {
        var _props5 = _this2.props,
          block = _props5.block,
          node = _props5.node,
          parent = _props5.parent,
          schema = _props5.schema,
          state = _props5.state,
          editor = _props5.editor;
        var text = range.text,
          marks = range.marks;
        return _react2.default.createElement(_leaf2.default, {
          key: node.key + '-' + index,
          block: block,
          editor: editor,
          index: index,
          marks: marks,
          node: node,
          offset: offset,
          parent: parent,
          ranges: ranges,
          schema: schema,
          state: state,
          text: text
        });
      };
    };
    exports.default = Node;

    /***/
  }), ( /* 556 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    var _debug = __webpack_require__(20);
    var _debug2 = _interopRequireDefault(_debug);
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _slatePropTypes = __webpack_require__(53);
    var _slatePropTypes2 = _interopRequireDefault(_slatePropTypes);
    var _propTypes = __webpack_require__(54);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _slate = __webpack_require__(22);
    var _leaf = __webpack_require__(223);
    var _leaf2 = _interopRequireDefault(_leaf);
    var _offsetKey = __webpack_require__(144);
    var _offsetKey2 = _interopRequireDefault(_offsetKey);
    var _environment = __webpack_require__(98);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    /**
     * Debug.
     *
     * @type {Function}
     */

    var debug = (0, _debug2.default)('slate:void');

    /**
     * Void.
     *
     * @type {Component}
     */

    var Void = function (_React$Component) {
      _inherits(Void, _React$Component);
      function Void() {
        var _ref;
        var _temp, _this, _ret;
        _classCallCheck(this, Void);
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Void.__proto__ || Object.getPrototypeOf(Void)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
      }

      /**
       * Property types.
       *
       * @type {Object}
       */

      /**
       * State
       *
       * @type {Object}
       */

      /**
       * Debug.
       *
       * @param {String} message
       * @param {Mixed} ...args
       */

      /**
       * When one of the wrapper elements it clicked, select the void node.
       *
       * @param {Event} event
       */

      /**
       * Increment counter, and temporarily switch node to editable to allow drop events
       * Counter required as onDragLeave fires when hovering over child elements
       *
       * @param {Event} event
       */

      /**
       * Decrement counter, and if counter 0, then no longer dragging over node
       * and thus switch back to non-editable
       *
       * @param {Event} event
       */

      /**
       * If dropped item onto node, then reset state
       *
       * @param {Event} event
       */

      _createClass(Void, [{
        key: 'render',
        /**
         * Render.
         *
         * @return {Element}
         */

        value: function render() {
          var props = this.props;
          var children = props.children,
            node = props.node;
          var Tag = void 0,
            style = void 0;

          // Make the outer wrapper relative, so the spacer can overlay it.
          if (node.kind === 'block') {
            Tag = 'div';
            style = {
              position: 'relative'
            };
          } else {
            Tag = 'span';
          }
          this.debug('render', {
            props: props
          });
          return _react2.default.createElement(Tag, {
            'data-slate-void': true,
            style: style,
            onClick: this.onClick,
            onDragEnter: this.onDragEnter,
            onDragLeave: this.onDragLeave,
            onDrop: this.onDrop
          }, this.renderSpacer(), _react2.default.createElement(Tag, {
            contentEditable: this.state.editable
          }, children));
        }

        /**
         * Render a fake spacer leaf, which will catch the cursor when it the void
         * node is navigated to with the arrow keys. Having this spacer there means
         * the browser continues to manage the selection natively, so it keeps track
         * of the right offset when moving across the block.
         *
         * @return {Element}
         */

        /**
         * Render a fake leaf.
         *
         * @return {Element}
         */
      }]);
      return Void;
    }(_react2.default.Component);

    /**
     * Export.
     *
     * @type {Component}
     */

    Void.propTypes = {
      block: _slatePropTypes2.default.block,
      children: _propTypes2.default.any.isRequired,
      editor: _propTypes2.default.object.isRequired,
      node: _slatePropTypes2.default.node.isRequired,
      parent: _slatePropTypes2.default.node.isRequired,
      readOnly: _propTypes2.default.bool.isRequired,
      schema: _slatePropTypes2.default.schema.isRequired,
      state: _slatePropTypes2.default.state.isRequired
    };
    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;
      this.state = {
        dragCounter: 0,
        editable: false
      };
      this.debug = function (message) {
        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }
        var node = _this2.props.node;
        var key = node.key,
          type = node.type;
        var id = key + ' (' + type + ')';
        debug.apply(undefined, [message, '' + id].concat(args));
      };
      this.onClick = function (event) {
        if (_this2.props.readOnly) return;
        _this2.debug('onClick', {
          event: event
        });
        var _props = _this2.props,
          node = _props.node,
          editor = _props.editor;
        editor.change(function (change) {
          change
          // COMPAT: In Chrome & Safari, selections that are at the zero offset of
          // an inline node will be automatically replaced to be at the last
          // offset of a previous inline node, which screws us up, so we always
          // want to set it to the end of the node. (2016/11/29)
          .collapseToEndOf(node).focus();
        });
      };
      this.onDragEnter = function () {
        _this2.setState(function (prevState) {
          var dragCounter = prevState.dragCounter + 1;
          return {
            dragCounter: dragCounter,
            editable: undefined
          };
        });
      };
      this.onDragLeave = function () {
        _this2.setState(function (prevState) {
          var dragCounter = prevState.dragCounter - 1;
          var editable = dragCounter === 0 ? false : undefined;
          return {
            dragCounter: dragCounter,
            editable: editable
          };
        });
      };
      this.onDrop = function () {
        _this2.setState({
          dragCounter: 0,
          editable: false
        });
      };
      this.renderSpacer = function () {
        var node = _this2.props.node;
        var style = void 0;
        if (node.kind == 'block') {
          style = _environment.IS_FIREFOX ? {
            pointerEvents: 'none',
            width: '0px',
            height: '0px',
            lineHeight: '0px',
            visibility: 'hidden'
          } : {
            position: 'absolute',
            top: '0px',
            left: '-9999px',
            textIndent: '-9999px'
          };
        } else {
          style = {
            color: 'transparent'
          };
        }
        return _react2.default.createElement('span', {
          style: style
        }, _this2.renderLeaf());
      };
      this.renderLeaf = function () {
        var _props2 = _this2.props,
          block = _props2.block,
          node = _props2.node,
          schema = _props2.schema,
          state = _props2.state,
          editor = _props2.editor;
        var child = node.getFirstText();
        var ranges = child.getRanges();
        var text = '';
        var offset = 0;
        var marks = _slate.Mark.createSet();
        var index = 0;
        var offsetKey = _offsetKey2.default.stringify({
          key: child.key,
          index: index
        });
        return _react2.default.createElement(_leaf2.default, {
          key: offsetKey,
          block: node.kind == 'block' ? node : block,
          editor: editor,
          index: index,
          marks: marks,
          node: child,
          offset: offset,
          parent: node,
          ranges: ranges,
          schema: schema,
          state: state,
          text: text
        });
      };
    };
    exports.default = Void;

    /***/
  }), ( /* 557 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.findDOMNode = exports.Placeholder = exports.Editor = undefined;
    var _editor = __webpack_require__(554);
    var _editor2 = _interopRequireDefault(_editor);
    var _placeholder = __webpack_require__(224);
    var _placeholder2 = _interopRequireDefault(_placeholder);
    var _findDomNode = __webpack_require__(226);
    var _findDomNode2 = _interopRequireDefault(_findDomNode);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    /**
     * Export.
     *
     * @type {Object}
     */

    exports.Editor = _editor2.default;
    exports.Placeholder = _placeholder2.default;
    exports.findDOMNode = _findDomNode2.default;

    /**
     * Utils.
     */

    /**
     * Components.
     */

    exports.default = {
      Editor: _editor2.default,
      Placeholder: _placeholder2.default,
      findDOMNode: _findDomNode2.default
    };

    /***/
  }), ( /* 558 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    var _slateBase64Serializer = __webpack_require__(97);
    var _slateBase64Serializer2 = _interopRequireDefault(_slateBase64Serializer);
    var _debug = __webpack_require__(20);
    var _debug2 = _interopRequireDefault(_debug);
    var _slatePlainSerializer = __webpack_require__(569);
    var _slatePlainSerializer2 = _interopRequireDefault(_slatePlainSerializer);
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _getWindow = __webpack_require__(94);
    var _getWindow2 = _interopRequireDefault(_getWindow);
    var _slate = __webpack_require__(22);
    var _content = __webpack_require__(553);
    var _content2 = _interopRequireDefault(_content);
    var _placeholder = __webpack_require__(224);
    var _placeholder2 = _interopRequireDefault(_placeholder);
    var _getPoint = __webpack_require__(227);
    var _getPoint2 = _interopRequireDefault(_getPoint);
    var _findDomNode = __webpack_require__(226);
    var _findDomNode2 = _interopRequireDefault(_findDomNode);
    var _environment = __webpack_require__(98);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    /**
     * Debug.
     *
     * @type {Function}
     */

    var debug = (0, _debug2.default)('slate:core');

    /**
     * The default plugin.
     *
     * @param {Object} options
     *   @property {Element} placeholder
     *   @property {String} placeholderClassName
     *   @property {Object} placeholderStyle
     * @return {Object}
     */

    function Plugin() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var placeholder = options.placeholder,
        placeholderClassName = options.placeholderClassName,
        placeholderStyle = options.placeholderStyle;

      /**
       * On before change, enforce the editor's schema.
       *
       * @param {Change} change
       * @param {Editor} schema
       */

      function onBeforeChange(change, editor) {
        var state = change.state;
        var schema = editor.getSchema();
        var prevState = editor.getState();

        // PERF: Skip normalizing if the document hasn't changed, since the core
        // schema only normalizes changes to the document, not selection.
        if (prevState && state.document == prevState.document) return;
        change.normalize(schema);
        debug('onBeforeChange');
      }

      /**
       * On before input, correct any browser inconsistencies.
       *
       * @param {Event} e
       * @param {Object} data
       * @param {Change} change
       * @param {Editor} editor
       */

      function onBeforeInput(e, data, change, editor) {
        debug('onBeforeInput', {
          data: data
        });
        e.preventDefault();
        var state = change.state;
        var selection = state.selection;
        var anchorKey = selection.anchorKey,
          anchorOffset = selection.anchorOffset,
          focusKey = selection.focusKey,
          focusOffset = selection.focusOffset;

        // COMPAT: In iOS, when using predictive text suggestions, the native
        // selection will be changed to span the existing word, so that the word is
        // replaced. But the `select` fires after the `beforeInput` event, even
        // though the native selection is updated. So we need to manually check if
        // the selection has gotten out of sync, and adjust it if so. (03/18/2017)

        var window = (0, _getWindow2.default)(e.target);
        var native = window.getSelection();
        var a = (0, _getPoint2.default)(native.anchorNode, native.anchorOffset, state, editor);
        var f = (0, _getPoint2.default)(native.focusNode, native.focusOffset, state, editor);
        var hasMismatch = a && f && (anchorKey != a.key || anchorOffset != a.offset || focusKey != f.key || focusOffset != f.offset);
        if (hasMismatch) {
          change.select({
            anchorKey: a.key,
            anchorOffset: a.offset,
            focusKey: f.key,
            focusOffset: f.offset
          });
        }
        change.insertText(e.data);
      }

      /**
       * On blur.
       *
       * @param {Event} e
       * @param {Object} data
       * @param {Change} change
       */

      function onBlur(e, data, change) {
        debug('onBlur', {
          data: data
        });
        change.blur();
      }

      /**
       * On copy.
       *
       * @param {Event} e
       * @param {Object} data
       * @param {Change} change
       */

      function onCopy(e, data, change) {
        debug('onCopy', data);
        onCutOrCopy(e, data, change);
      }

      /**
       * On cut.
       *
       * @param {Event} e
       * @param {Object} data
       * @param {Change} change
       * @param {Editor} editor
       */

      function onCut(e, data, change, editor) {
        debug('onCut', data);
        onCutOrCopy(e, data, change);
        var window = (0, _getWindow2.default)(e.target);

        // Once the fake cut content has successfully been added to the clipboard,
        // delete the content in the current selection.
        window.requestAnimationFrame(function () {
          editor.change(function (t) {
            return t.delete();
          });
        });
      }

      /**
       * On cut or copy, create a fake selection so that we can add a Base 64
       * encoded copy of the fragment to the HTML, to decode on future pastes.
       *
       * @param {Event} e
       * @param {Object} data
       * @param {Change} change
       */

      function onCutOrCopy(e, data, change) {
        var window = (0, _getWindow2.default)(e.target);
        var native = window.getSelection();
        var state = change.state;
        var endBlock = state.endBlock,
          endInline = state.endInline;
        var isVoidBlock = endBlock && endBlock.isVoid;
        var isVoidInline = endInline && endInline.isVoid;
        var isVoid = isVoidBlock || isVoidInline;

        // If the selection is collapsed, and it isn't inside a void node, abort.
        if (native.isCollapsed && !isVoid) return;
        var fragment = data.fragment;
        var encoded = _slateBase64Serializer2.default.serializeNode(fragment);
        var range = native.getRangeAt(0);
        var contents = range.cloneContents();
        var attach = contents.childNodes[0];

        // If the end node is a void node, we need to move the end of the range from
        // the void node's spacer span, to the end of the void node's content.
        if (isVoid) {
          var _r = range.cloneRange();
          var node = (0, _findDomNode2.default)(isVoidBlock ? endBlock : endInline);
          _r.setEndAfter(node);
          contents = _r.cloneContents();
          attach = contents.childNodes[contents.childNodes.length - 1].firstChild;
        }

        // Remove any zero-width space spans from the cloned DOM so that they don't
        // show up elsewhere when pasted.
        var zws = [].slice.call(contents.querySelectorAll('[data-slate-zero-width]'));
        zws.forEach(function (zw) {
          return zw.parentNode.removeChild(zw);
        });

        // COMPAT: In Chrome and Safari, if the last element in the selection to
        // copy has `contenteditable="false"` the copy will fail, and nothing will
        // be put in the clipboard. So we remove them all. (2017/05/04)
        if (_environment.IS_CHROME || _environment.IS_SAFARI) {
          var els = [].slice.call(contents.querySelectorAll('[contenteditable="false"]'));
          els.forEach(function (el) {
            return el.removeAttribute('contenteditable');
          });
        }

        // Set a `data-slate-fragment` attribute on a non-empty node, so it shows up
        // in the HTML, and can be used for intra-Slate pasting. If it's a text
        // node, wrap it in a `<span>` so we have something to set an attribute on.
        if (attach.nodeType == 3) {
          var span = window.document.createElement('span');
          span.appendChild(attach);
          contents.appendChild(span);
          attach = span;
        }
        attach.setAttribute('data-slate-fragment', encoded);

        // Add the phony content to the DOM, and select it, so it will be copied.
        var body = window.document.querySelector('body');
        var div = window.document.createElement('div');
        div.setAttribute('contenteditable', true);
        div.style.position = 'absolute';
        div.style.left = '-9999px';
        div.appendChild(contents);
        body.appendChild(div);

        // COMPAT: In Firefox, trying to use the terser `native.selectAllChildren`
        // throws an error, so we use the older `range` equivalent. (2016/06/21)
        var r = window.document.createRange();
        r.selectNodeContents(div);
        native.removeAllRanges();
        native.addRange(r);

        // Revert to the previous selection right after copying.
        window.requestAnimationFrame(function () {
          body.removeChild(div);
          native.removeAllRanges();
          native.addRange(range);
        });
      }

      /**
       * On drop.
       *
       * @param {Event} e
       * @param {Object} data
       * @param {Change} change
       */

      function onDrop(e, data, change) {
        debug('onDrop', {
          data: data
        });
        switch (data.type) {
          case 'text':
          case 'html':
            return onDropText(e, data, change);
          case 'fragment':
            return onDropFragment(e, data, change);
          case 'node':
            return onDropNode(e, data, change);
        }
      }

      /**
       * On drop node, insert the node wherever it is dropped.
       *
       * @param {Event} e
       * @param {Object} data
       * @param {Change} change
       */

      function onDropNode(e, data, change) {
        debug('onDropNode', {
          data: data
        });
        var state = change.state;
        var selection = state.selection;
        var node = data.node,
          target = data.target,
          isInternal = data.isInternal;

        // If the drag is internal and the target is after the selection, it
        // needs to account for the selection's content being deleted.

        if (isInternal && selection.endKey == target.endKey && selection.endOffset < target.endOffset) {
          target = target.move(selection.startKey == selection.endKey ? 0 - selection.endOffset + selection.startOffset : 0 - selection.endOffset);
        }
        if (isInternal) {
          change.delete();
        }
        if (_slate.Block.isBlock(node)) {
          change.select(target).insertBlock(node).removeNodeByKey(node.key);
        }
        if (_slate.Inline.isInline(node)) {
          change.select(target).insertInline(node).removeNodeByKey(node.key);
        }
      }

      /**
       * On drop fragment.
       *
       * @param {Event} e
       * @param {Object} data
       * @param {Change} change
       */

      function onDropFragment(e, data, change) {
        debug('onDropFragment', {
          data: data
        });
        var state = change.state;
        var selection = state.selection;
        var fragment = data.fragment,
          target = data.target,
          isInternal = data.isInternal;

        // If the drag is internal and the target is after the selection, it
        // needs to account for the selection's content being deleted.

        if (isInternal && selection.endKey == target.endKey && selection.endOffset < target.endOffset) {
          target = target.move(selection.startKey == selection.endKey ? 0 - selection.endOffset + selection.startOffset : 0 - selection.endOffset);
        }
        if (isInternal) {
          change.delete();
        }
        change.select(target).insertFragment(fragment);
      }

      /**
       * On drop text, split the blocks at new lines.
       *
       * @param {Event} e
       * @param {Object} data
       * @param {Change} change
       */

      function onDropText(e, data, change) {
        debug('onDropText', {
          data: data
        });
        var state = change.state;
        var document = state.document;
        var text = data.text,
          target = data.target;
        var anchorKey = target.anchorKey;
        change.select(target);
        var hasVoidParent = document.hasVoidParent(anchorKey);

        // Insert text into nearest text node
        if (hasVoidParent) {
          var node = document.getNode(anchorKey);
          while (hasVoidParent) {
            node = document.getNextText(node.key);
            if (!node) break;
            hasVoidParent = document.hasVoidParent(node.key);
          }
          if (node) change.collapseToStartOf(node);
        }
        text.split('\n').forEach(function (line, i) {
          if (i > 0) change.splitBlock();
          change.insertText(line);
        });
      }

      /**
       * On key down.
       *
       * @param {Event} e
       * @param {Object} data
       * @param {Change} change
       */

      function onKeyDown(e, data, change) {
        debug('onKeyDown', {
          data: data
        });
        switch (data.key) {
          case 'enter':
            return onKeyDownEnter(e, data, change);
          case 'backspace':
            return onKeyDownBackspace(e, data, change);
          case 'delete':
            return onKeyDownDelete(e, data, change);
          case 'left':
            return onKeyDownLeft(e, data, change);
          case 'right':
            return onKeyDownRight(e, data, change);
          case 'up':
            return onKeyDownUp(e, data, change);
          case 'down':
            return onKeyDownDown(e, data, change);
          case 'd':
            return onKeyDownD(e, data, change);
          case 'h':
            return onKeyDownH(e, data, change);
          case 'k':
            return onKeyDownK(e, data, change);
          case 'y':
            return onKeyDownY(e, data, change);
          case 'z':
            return onKeyDownZ(e, data, change);
        }
      }

      /**
       * On `enter` key down, split the current block in half.
       *
       * @param {Event} e
       * @param {Object} data
       * @param {Change} change
       */

      function onKeyDownEnter(e, data, change) {
        var state = change.state;
        var document = state.document,
          startKey = state.startKey;
        var hasVoidParent = document.hasVoidParent(startKey);

        // For void nodes, we don't want to split. Instead we just move to the start
        // of the next text node if one exists.
        if (hasVoidParent) {
          var text = document.getNextText(startKey);
          if (!text) return;
          change.collapseToStartOf(text);
          return;
        }
        change.splitBlock();
      }

      /**
       * On `backspace` key down, delete backwards.
       *
       * @param {Event} e
       * @param {Object} data
       * @param {Change} change
       */

      function onKeyDownBackspace(e, data, change) {
        var boundary = 'Char';
        if (data.isWord) boundary = 'Word';
        if (data.isLine) boundary = 'Line';
        change['delete' + boundary + 'Backward']();
      }

      /**
       * On `delete` key down, delete forwards.
       *
       * @param {Event} e
       * @param {Object} data
       * @param {Change} change
       */

      function onKeyDownDelete(e, data, change) {
        var boundary = 'Char';
        if (data.isWord) boundary = 'Word';
        if (data.isLine) boundary = 'Line';
        change['delete' + boundary + 'Forward']();
      }

      /**
       * On `left` key down, move backward.
       *
       * COMPAT: This is required to make navigating with the left arrow work when
       * a void node is selected.
       *
       * COMPAT: This is also required to solve for the case where an inline node is
       * surrounded by empty text nodes with zero-width spaces in them. Without this
       * the zero-width spaces will cause two arrow keys to jump to the next text.
       *
       * @param {Event} e
       * @param {Object} data
       * @param {Change} change
       */

      function onKeyDownLeft(e, data, change) {
        var state = change.state;
        if (data.isCtrl) return;
        if (data.isAlt) return;
        if (state.isExpanded) return;
        var document = state.document,
          startKey = state.startKey,
          startText = state.startText;
        var hasVoidParent = document.hasVoidParent(startKey);

        // If the current text node is empty, or we're inside a void parent, we're
        // going to need to handle the selection behavior.
        if (startText.text == '' || hasVoidParent) {
          e.preventDefault();
          var previous = document.getPreviousText(startKey);

          // If there's no previous text node in the document, abort.
          if (!previous) return;

          // If the previous text is in the current block, and inside a non-void
          // inline node, move one character into the inline node.
          var startBlock = state.startBlock;
          var previousBlock = document.getClosestBlock(previous.key);
          var previousInline = document.getClosestInline(previous.key);
          if (previousBlock === startBlock && previousInline && !previousInline.isVoid) {
            var extendOrMove = data.isShift ? 'extend' : 'move';
            change.collapseToEndOf(previous)[extendOrMove](-1);
            return;
          }

          // Otherwise, move to the end of the previous node.
          change.collapseToEndOf(previous);
        }
      }

      /**
       * On `right` key down, move forward.
       *
       * COMPAT: This is required to make navigating with the right arrow work when
       * a void node is selected.
       *
       * COMPAT: This is also required to solve for the case where an inline node is
       * surrounded by empty text nodes with zero-width spaces in them. Without this
       * the zero-width spaces will cause two arrow keys to jump to the next text.
       *
       * COMPAT: In Chrome & Safari, selections that are at the zero offset of
       * an inline node will be automatically replaced to be at the last offset
       * of a previous inline node, which screws us up, so we never want to set the
       * selection to the very start of an inline node here. (2016/11/29)
       *
       * @param {Event} e
       * @param {Object} data
       * @param {Change} change
       */

      function onKeyDownRight(e, data, change) {
        var state = change.state;
        if (data.isCtrl) return;
        if (data.isAlt) return;
        if (state.isExpanded) return;
        var document = state.document,
          startKey = state.startKey,
          startText = state.startText;
        var hasVoidParent = document.hasVoidParent(startKey);

        // If the current text node is empty, or we're inside a void parent, we're
        // going to need to handle the selection behavior.
        if (startText.text == '' || hasVoidParent) {
          e.preventDefault();
          var next = document.getNextText(startKey);

          // If there's no next text node in the document, abort.
          if (!next) return;

          // If the next text is inside a void node, move to the end of it.
          if (document.hasVoidParent(next.key)) {
            change.collapseToEndOf(next);
            return;
          }

          // If the next text is in the current block, and inside an inline node,
          // move one character into the inline node.
          var startBlock = state.startBlock;
          var nextBlock = document.getClosestBlock(next.key);
          var nextInline = document.getClosestInline(next.key);
          if (nextBlock == startBlock && nextInline) {
            var extendOrMove = data.isShift ? 'extend' : 'move';
            change.collapseToStartOf(next)[extendOrMove](1);
            return;
          }

          // Otherwise, move to the start of the next text node.
          change.collapseToStartOf(next);
        }
      }

      /**
       * On `up` key down, for Macs, move the selection to start of the block.
       *
       * COMPAT: Certain browsers don't handle the selection updates properly. In
       * Chrome, option-shift-up doesn't properly extend the selection. And in
       * Firefox, option-up doesn't properly move the selection.
       *
       * @param {Event} e
       * @param {Object} data
       * @param {Change} change
       */

      function onKeyDownUp(e, data, change) {
        if (!_environment.IS_MAC || data.isCtrl || !data.isAlt) return;
        var state = change.state;
        var selection = state.selection,
          document = state.document,
          focusKey = state.focusKey,
          focusBlock = state.focusBlock;
        var transform = data.isShift ? 'extendToStartOf' : 'collapseToStartOf';
        var block = selection.hasFocusAtStartOf(focusBlock) ? document.getPreviousBlock(focusKey) : focusBlock;
        if (!block) return;
        var text = block.getFirstText();
        e.preventDefault();
        change[transform](text);
      }

      /**
       * On `down` key down, for Macs, move the selection to end of the block.
       *
       * COMPAT: Certain browsers don't handle the selection updates properly. In
       * Chrome, option-shift-down doesn't properly extend the selection. And in
       * Firefox, option-down doesn't properly move the selection.
       *
       * @param {Event} e
       * @param {Object} data
       * @param {Change} change
       */

      function onKeyDownDown(e, data, change) {
        if (!_environment.IS_MAC || data.isCtrl || !data.isAlt) return;
        var state = change.state;
        var selection = state.selection,
          document = state.document,
          focusKey = state.focusKey,
          focusBlock = state.focusBlock;
        var transform = data.isShift ? 'extendToEndOf' : 'collapseToEndOf';
        var block = selection.hasFocusAtEndOf(focusBlock) ? document.getNextBlock(focusKey) : focusBlock;
        if (!block) return;
        var text = block.getLastText();
        e.preventDefault();
        change[transform](text);
      }

      /**
       * On `d` key down, for Macs, delete one character forward.
       *
       * @param {Event} e
       * @param {Object} data
       * @param {Change} change
       */

      function onKeyDownD(e, data, change) {
        if (!_environment.IS_MAC || !data.isCtrl) return;
        e.preventDefault();
        change.deleteCharForward();
      }

      /**
       * On `h` key down, for Macs, delete until the end of the line.
       *
       * @param {Event} e
       * @param {Object} data
       * @param {Change} change
       */

      function onKeyDownH(e, data, change) {
        if (!_environment.IS_MAC || !data.isCtrl) return;
        e.preventDefault();
        change.deleteCharBackward();
      }

      /**
       * On `k` key down, for Macs, delete until the end of the line.
       *
       * @param {Event} e
       * @param {Object} data
       * @param {Change} change
       */

      function onKeyDownK(e, data, change) {
        if (!_environment.IS_MAC || !data.isCtrl) return;
        e.preventDefault();
        change.deleteLineForward();
      }

      /**
       * On `y` key down, redo.
       *
       * @param {Event} e
       * @param {Object} data
       * @param {Change} change
       */

      function onKeyDownY(e, data, change) {
        if (!data.isMod) return;
        change.redo();
      }

      /**
       * On `z` key down, undo or redo.
       *
       * @param {Event} e
       * @param {Object} data
       * @param {Change} change
       */

      function onKeyDownZ(e, data, change) {
        if (!data.isMod) return;
        change[data.isShift ? 'redo' : 'undo']();
      }

      /**
       * On paste.
       *
       * @param {Event} e
       * @param {Object} data
       * @param {Change} change
       */

      function onPaste(e, data, change) {
        debug('onPaste', {
          data: data
        });
        switch (data.type) {
          case 'fragment':
            return onPasteFragment(e, data, change);
          case 'text':
          case 'html':
            return onPasteText(e, data, change);
        }
      }

      /**
       * On paste fragment.
       *
       * @param {Event} e
       * @param {Object} data
       * @param {Change} change
       */

      function onPasteFragment(e, data, change) {
        debug('onPasteFragment', {
          data: data
        });
        change.insertFragment(data.fragment);
      }

      /**
       * On paste text, split blocks at new lines.
       *
       * @param {Event} e
       * @param {Object} data
       * @param {Change} change
       */

      function onPasteText(e, data, change) {
        debug('onPasteText', {
          data: data
        });
        var state = change.state;
        var document = state.document,
          selection = state.selection,
          startBlock = state.startBlock;
        if (startBlock.isVoid) return;
        var text = data.text;
        var defaultBlock = startBlock;
        var defaultMarks = document.getMarksAtRange(selection.collapseToStart());
        var fragment = _slatePlainSerializer2.default.deserialize(text, {
          defaultBlock: defaultBlock,
          defaultMarks: defaultMarks
        }).document;
        change.insertFragment(fragment);
      }

      /**
       * On select.
       *
       * @param {Event} e
       * @param {Object} data
       * @param {Change} change
       */

      function onSelect(e, data, change) {
        debug('onSelect', {
          data: data
        });
        change.select(data.selection);
      }

      /**
       * Render.
       *
       * @param {Object} props
       * @param {State} state
       * @param {Editor} editor
       * @return {Object}
       */

      function render(props, state, editor) {
        return _react2.default.createElement(_content2.default, {
          autoCorrect: props.autoCorrect,
          autoFocus: props.autoFocus,
          className: props.className,
          children: props.children,
          editor: editor,
          onBeforeInput: editor.onBeforeInput,
          onBlur: editor.onBlur,
          onFocus: editor.onFocus,
          onCopy: editor.onCopy,
          onCut: editor.onCut,
          onDrop: editor.onDrop,
          onKeyDown: editor.onKeyDown,
          onKeyUp: editor.onKeyUp,
          onPaste: editor.onPaste,
          onSelect: editor.onSelect,
          readOnly: props.readOnly,
          role: props.role,
          schema: editor.getSchema(),
          spellCheck: props.spellCheck,
          state: state,
          style: props.style,
          tabIndex: props.tabIndex,
          tagName: props.tagName
        });
      }

      /**
       * A default schema rule to render block nodes.
       *
       * @type {Object}
       */

      var BLOCK_RENDER_RULE = {
        match: function match(node) {
          return node.kind == 'block';
        },
        render: function render(props) {
          return _react2.default.createElement('div', _extends({}, props.attributes, {
            style: {
              position: 'relative'
            }
          }), props.children, placeholder ? _react2.default.createElement(_placeholder2.default, {
            className: placeholderClassName,
            node: props.node,
            parent: props.state.document,
            state: props.state,
            style: placeholderStyle
          }, placeholder) : null);
        }
      };

      /**
       * A default schema rule to render inline nodes.
       *
       * @type {Object}
       */

      var INLINE_RENDER_RULE = {
        match: function match(node) {
          return node.kind == 'inline';
        },
        render: function render(props) {
          return _react2.default.createElement('span', _extends({}, props.attributes, {
            style: {
              position: 'relative'
            }
          }), props.children);
        }
      };

      /**
       * Add default rendering rules to the schema.
       *
       * @type {Object}
       */

      var schema = {
        rules: [BLOCK_RENDER_RULE, INLINE_RENDER_RULE]
      };

      /**
       * Return the core plugin.
       *
       * @type {Object}
       */

      return {
        onBeforeChange: onBeforeChange,
        onBeforeInput: onBeforeInput,
        onBlur: onBlur,
        onCopy: onCopy,
        onCut: onCut,
        onDrop: onDrop,
        onKeyDown: onKeyDown,
        onPaste: onPaste,
        onSelect: onSelect,
        render: render,
        schema: schema
      };
    }

    /**
     * Export.
     *
     * @type {Object}
     */

    exports.default = Plugin;

    /***/
  }), ( /* 559 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    /**
     * Extends a DOM `selection` to a given `el` and `offset`.
     *
     * COMPAT: In IE11, `selection.extend` doesn't exist natively, so we have to
     * polyfill it with this. (2017/09/06)
     *
     * https://gist.github.com/tyler-johnson/0a3e8818de3f115b2a2dc47468ac0099
     *
     * @param {Selection} selection
     * @param {Element} el
     * @param {Number} offset
     * @return {Selection}
     */

    function extendSelection(selection, el, offset) {
      // Use native method whenever possible.
      if (typeof selection.extend === 'function') {
        return selection.extend(el, offset);
      }
      var range = document.createRange();
      var anchor = document.createRange();
      var focus = document.createRange();
      anchor.setStart(selection.anchorNode, selection.anchorOffset);
      focus.setStart(el, offset);
      var v = focus.compareBoundaryPoints(window.Range.START_TO_START, anchor);

      // If the focus is after the anchor...
      if (v >= 0) {
        range.setStart(selection.anchorNode, selection.anchorOffset);
        range.setEnd(el, offset);
      }

      // Otherwise, if the anchor if after the focus...
      else {
        range.setStart(el, offset);
        range.setEnd(selection.anchorNode, selection.anchorOffset);
      }
      selection.removeAllRanges();
      selection.addRange(range);
      return selection;
    }

    /**
     * Export.
     *
     * @type {Function}
     */

    exports.default = extendSelection;

    /***/
  }), ( /* 560 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    /**
     * Find the deepest descendant of a DOM `element`.
     *
     * @param {Element} node
     * @return {Element}
     */

    function findDeepestNode(element) {
      return element.firstChild ? findDeepestNode(element.firstChild) : element;
    }

    /**
     * Export.
     *
     * @type {Function}
     */

    exports.default = findDeepestNode;

    /***/
  }), ( /* 561 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _findDeepestNode = __webpack_require__(560);
    var _findDeepestNode2 = _interopRequireDefault(_findDeepestNode);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    /**
     * Get caret position from selection point.
     *
     * @param {String} key
     * @param {Number} offset
     * @param {State} state
     * @param {Editor} editor
     * @param {Element} el
     * @return {Object}
     */

    function getCaretPosition(key, offset, state, editor, el) {
      var document = state.document;
      var text = document.getDescendant(key);
      var schema = editor.getSchema();
      var decorators = document.getDescendantDecorators(key, schema);
      var ranges = text.getRanges(decorators);
      var a = 0;
      var index = void 0;
      var off = void 0;
      ranges.forEach(function (range, i) {
        var length = range.text.length;
        a += length;
        if (a < offset) return;
        index = i;
        off = offset - (a - length);
        return false;
      });
      var span = el.querySelector('[data-offset-key="' + key + '-' + index + '"]');
      var node = (0, _findDeepestNode2.default)(span);
      return {
        node: node,
        offset: off
      };
    }

    /**
     * Export.
     *
     * @type {Function}
     */

    exports.default = getCaretPosition;

    /***/
  }), ( /* 562 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _reactDom = __webpack_require__(4);

    /**
     * Get clipboard HTML data by capturing the HTML inserted by the browser's
     * native paste action. To make this work, `preventDefault()` may not be
     * called on the `onPaste` event. As this method is asynchronous, a callback
     * is needed to return the HTML content. This solution was adapted from
     * http://stackoverflow.com/a/6804718.
     *
     * @param {Component} component
     * @param {Function} callback
     */

    function getHtmlFromNativePaste(component, callback) {
      var el = (0, _reactDom.findDOMNode)(component);

      // Create an off-screen clone of the element and give it focus.
      var clone = el.cloneNode();
      clone.setAttribute('class', '');
      clone.setAttribute('style', 'position: fixed; left: -9999px');
      el.parentNode.insertBefore(clone, el);
      clone.focus();

      // Tick forward so the native paste behaviour occurs in cloned element and we
      // can get what was pasted from the DOM.
      setTimeout(function () {
        if (clone.childElementCount > 0) {
          // If the node contains any child nodes, that is the HTML content.
          var html = clone.innerHTML;
          clone.parentNode.removeChild(clone);
          callback(html);
        } else {
          // Only plain text, no HTML.
          callback();
        }
      }, 0);
    }

    /**
     * Export.
     *
     * @type {Function}
     */

    exports.default = getHtmlFromNativePaste;

    /***/
  }), ( /* 563 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _slicedToArray = function () {
      function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
          for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
          }
        } catch (err) {
          _d = true;
          _e = err;
        } finally {
          try {
            if (!_n && _i["return"]) _i["return"]();
          } finally {
            if (_d) throw _e;
          }
        }
        return _arr;
      }
      return function (arr, i) {
        if (Array.isArray(arr)) {
          return arr;
        } else if (Symbol.iterator in Object(arr)) {
          return sliceIterator(arr, i);
        } else {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
      };
    }();
    var _slateBase64Serializer = __webpack_require__(97);
    var _slateBase64Serializer2 = _interopRequireDefault(_slateBase64Serializer);
    var _transferTypes = __webpack_require__(143);
    var _transferTypes2 = _interopRequireDefault(_transferTypes);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    /**
     * Fragment matching regexp for HTML nodes.
     *
     * @type {RegExp}
     */

    var FRAGMENT_MATCHER = / data-slate-fragment="([^\s"]+)"/;

    /**
     * Get the data and type from a native data `transfer`.
     *
     * @param {DataTransfer} transfer
     * @return {Object}
     */

    function getTransferData(transfer) {
      var fragment = getType(transfer, _transferTypes2.default.FRAGMENT);
      var node = getType(transfer, _transferTypes2.default.NODE);
      var html = getType(transfer, 'text/html');
      var rich = getType(transfer, 'text/rtf');
      var text = getType(transfer, 'text/plain');
      var files = void 0;

      // If there isn't a fragment, but there is HTML, check to see if the HTML is
      // actually an encoded fragment.
      if (!fragment && html && ~html.indexOf(' data-slate-fragment="')) {
        var matches = FRAGMENT_MATCHER.exec(html);
        var _matches = _slicedToArray(matches, 2),
          full = _matches[0],
          encoded = _matches[1]; // eslint-disable-line no-unused-vars

        if (encoded) fragment = encoded;
      }

      // COMPAT: Edge doesn't handle custom data types
      // These will be embedded in text/plain in this case (2017/7/12)
      if (text) {
        var embeddedTypes = getEmbeddedTypes(text);
        if (embeddedTypes[_transferTypes2.default.FRAGMENT]) fragment = embeddedTypes[_transferTypes2.default.FRAGMENT];
        if (embeddedTypes[_transferTypes2.default.NODE]) node = embeddedTypes[_transferTypes2.default.NODE];
        if (embeddedTypes['text/plain']) text = embeddedTypes['text/plain'];
      }

      // Decode a fragment or node if they exist.
      if (fragment) fragment = _slateBase64Serializer2.default.deserializeNode(fragment);
      if (node) node = _slateBase64Serializer2.default.deserializeNode(node);

      // COMPAT: Edge sometimes throws 'NotSupportedError'
      // when accessing `transfer.items` (2017/7/12)
      try {
        // Get and normalize files if they exist.
        if (transfer.items && transfer.items.length) {
          files = Array.from(transfer.items).map(function (item) {
            return item.kind == 'file' ? item.getAsFile() : null;
          }).filter(function (exists) {
            return exists;
          });
        } else if (transfer.files && transfer.files.length) {
          files = Array.from(transfer.files);
        }
      } catch (err) {
        if (transfer.files && transfer.files.length) {
          files = Array.from(transfer.files);
        }
      }

      // Determine the type of the data.
      var data = {
        files: files,
        fragment: fragment,
        html: html,
        node: node,
        rich: rich,
        text: text
      };
      data.type = getTransferType(data);
      return data;
    }

    /**
     * Takes text input, checks whether contains embedded data
     * and returns object with original text +/- additional data
     *
     * @param {String} text
     * @return {Object}
     */

    function getEmbeddedTypes(text) {
      var prefix = 'SLATE-DATA-EMBED::';
      if (text.substring(0, prefix.length) !== prefix) {
        return {
          'text/plain': text
        };
      }

      // Attempt to parse, if fails then just standard text/plain
      // Otherwise, already had data embedded
      try {
        return JSON.parse(text.substring(prefix.length));
      } catch (err) {
        throw new Error('Unable to parse custom embedded drag data');
      }
    }

    /**
     * Get the type of a transfer from its `data`.
     *
     * @param {Object} data
     * @return {String}
     */

    function getTransferType(data) {
      if (data.fragment) return 'fragment';
      if (data.node) return 'node';

      // COMPAT: Microsoft Word adds an image of the selected text to the data.
      // Since files are preferred over HTML or text, this would cause the type to
      // be considered `files`. But it also adds rich text data so we can check
      // for that and properly set the type to `html` or `text`. (2016/11/21)
      if (data.rich && data.html) return 'html';
      if (data.rich && data.text) return 'text';
      if (data.files && data.files.length) return 'files';
      if (data.html) return 'html';
      if (data.text) return 'text';
      return 'unknown';
    }

    /**
     * Get one of types `TYPES.FRAGMENT`, `TYPES.NODE`, `text/html`, `text/rtf` or
     * `text/plain` from transfers's `data` if possible, otherwise return null.
     *
     * @param {Object} transfer
     * @param {String} type
     * @return {String}
     */

    function getType(transfer, type) {
      if (!transfer.types || !transfer.types.length) {
        // COMPAT: In IE 11, there is no `types` field but `getData('Text')`
        // is supported`. (2017/06/23)
        return type === 'text/plain' ? transfer.getData('Text') || null : null;
      }
      return transfer.types.indexOf(type) !== -1 ? transfer.getData(type) || null : null;
    }

    /**
     * Export.
     *
     * @type {Function}
     */

    exports.default = getTransferData;

    /***/
  }), ( /* 564 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    /**
     * Noop.
     *
     * @return {Void}
     */

    function noop() {}

    /**
     * Export.
     *
     * @type {Function}
     */

    exports.default = noop;

    /***/
  }), ( /* 565 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    /**
     * From a DOM selection's `node` and `offset`, normalize so that it always
     * refers to a text node.
     *
     * @param {Element} node
     * @param {Number} offset
     * @return {Object}
     */

    function normalizeNodeAndOffset(node, offset) {
      // If it's an element node, its offset refers to the index of its children
      // including comment nodes, so try to find the right text child node.
      if (node.nodeType == 1 && node.childNodes.length) {
        var isLast = offset == node.childNodes.length;
        var direction = isLast ? 'backward' : 'forward';
        var index = isLast ? offset - 1 : offset;
        node = getEditableChild(node, index, direction);

        // If the node has children, traverse until we have a leaf node. Leaf nodes
        // can be either text nodes, or other void DOM nodes.
        while (node.nodeType == 1 && node.childNodes.length) {
          var i = isLast ? node.childNodes.length - 1 : 0;
          node = getEditableChild(node, i, direction);
        }

        // Determine the new offset inside the text node.
        offset = isLast ? node.textContent.length : 0;
      }

      // Return the node and offset.
      return {
        node: node,
        offset: offset
      };
    }

    /**
     * Get the nearest editable child at `index` in a `parent`, preferring
     * `direction`.
     *
     * @param {Element} parent
     * @param {Number} index
     * @param {String} direction ('forward' or 'backward')
     * @return {Element|Null}
     */

    function getEditableChild(parent, index, direction) {
      var childNodes = parent.childNodes;
      var child = childNodes[index];
      var i = index;
      var triedForward = false;
      var triedBackward = false;

      // While the child is a comment node, or an element node with no children,
      // keep iterating to find a sibling non-void, non-comment node.
      while (child.nodeType == 8 || child.nodeType == 1 && child.childNodes.length == 0 || child.nodeType == 1 && child.getAttribute('contenteditable') == 'false') {
        if (triedForward && triedBackward) break;
        if (i >= childNodes.length) {
          triedForward = true;
          i = index - 1;
          direction = 'backward';
          continue;
        }
        if (i < 0) {
          triedBackward = true;
          i = index + 1;
          direction = 'forward';
          continue;
        }
        child = childNodes[i];
        if (direction == 'forward') i++;
        if (direction == 'backward') i--;
      }
      return child || null;
    }

    /**
     * Export.
     *
     * @type {Function}
     */

    exports.default = normalizeNodeAndOffset;

    /***/
  }), ( /* 566 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _getWindow = __webpack_require__(94);
    var _getWindow2 = _interopRequireDefault(_getWindow);
    var _selectionIsBackward = __webpack_require__(551);
    var _selectionIsBackward2 = _interopRequireDefault(_selectionIsBackward);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    /**
     * Scroll the current selection's focus point into view if needed.
     *
     * @param {Selection} selection
     */

    function scrollToSelection(selection) {
      if (!selection.anchorNode) return;
      var window = (0, _getWindow2.default)(selection.anchorNode);
      var backward = (0, _selectionIsBackward2.default)(selection);
      var range = selection.getRangeAt(0);
      var rect = range.getBoundingClientRect();
      var innerWidth = window.innerWidth,
        innerHeight = window.innerHeight,
        pageYOffset = window.pageYOffset,
        pageXOffset = window.pageXOffset;
      var top = (backward ? rect.top : rect.bottom) + pageYOffset;
      var left = (backward ? rect.left : rect.right) + pageXOffset;
      var x = left < pageXOffset || innerWidth + pageXOffset < left ? left - innerWidth / 2 : pageXOffset;
      var y = top < pageYOffset || innerHeight + pageYOffset < top ? top - innerHeight / 2 : pageYOffset;
      window.scrollTo(x, y);
    }

    /**
     * Export.
     *
     * @type {Function}
     */

    exports.default = scrollToSelection;

    /***/
  }), ( /* 567 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    var ReactPropTypesSecret = __webpack_require__(568);
    function emptyFunction() {}
    function emptyFunctionWithReset() {}
    emptyFunctionWithReset.resetWarningCache = emptyFunction;
    module.exports = function () {
      function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) {
          // It is still safe when called from React.
          return;
        }
        var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
        err.name = 'Invariant Violation';
        throw err;
      }
      ;
      shim.isRequired = shim;
      function getShim() {
        return shim;
      }
      ;
      // Important!
      // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
      var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
      };
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };

    /***/
  }), ( /* 568 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
    module.exports = ReactPropTypesSecret;

    /***/
  }), ( /* 569 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    var _slateDevLogger = __webpack_require__(16);
    var _slateDevLogger2 = _interopRequireDefault(_slateDevLogger);
    var _slate = __webpack_require__(22);
    var _immutable = __webpack_require__(2);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    /**
     * Deserialize a plain text `string` to a state.
     *
     * @param {String} string
     * @param {Object} options
     *   @property {Boolean} toJSON
     *   @property {String|Object|Block} defaultBlock
     *   @property {Array|Set} defaultMarks
     * @return {State}
     */

    function deserialize(string) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _options$defaultBlock = options.defaultBlock,
        defaultBlock = _options$defaultBlock === undefined ? 'line' : _options$defaultBlock,
        _options$defaultMarks = options.defaultMarks,
        defaultMarks = _options$defaultMarks === undefined ? [] : _options$defaultMarks,
        _options$toJSON = options.toJSON,
        toJSON = _options$toJSON === undefined ? false : _options$toJSON;
      if (options.toRaw) {
        _slateDevLogger2.default.deprecate('0.23.0', 'The `options.toRaw` argument of the `Plain` serializer is deprecated, use `options.toJSON` instead.');
        toJSON = options.toRaw;
      }
      if (_immutable.Set.isSet(defaultMarks)) {
        defaultMarks = defaultMarks.toArray();
      }
      defaultBlock = _slate.Node.createProperties(defaultBlock);
      defaultMarks = defaultMarks.map(_slate.Mark.createProperties);
      var json = {
        kind: 'state',
        document: {
          kind: 'document',
          data: {},
          nodes: string.split('\n').map(function (line) {
            return _extends({}, defaultBlock, {
              kind: 'block',
              isVoid: false,
              data: {},
              nodes: [{
                kind: 'text',
                ranges: [{
                  kind: 'range',
                  text: line,
                  marks: defaultMarks
                }]
              }]
            });
          })
        }
      };
      var ret = toJSON ? json : _slate.State.fromJSON(json);
      return ret;
    }

    /**
     * Serialize a `state` to plain text.
     *
     * @param {State} state
     * @return {String}
     */

    function serialize(state) {
      return serializeNode(state.document);
    }

    /**
     * Serialize a `node` to plain text.
     *
     * @param {Node} node
     * @return {String}
     */

    function serializeNode(node) {
      if (node.kind == 'document' || node.kind == 'block' && _slate.Block.isBlockList(node.nodes)) {
        return node.nodes.map(serializeNode).join('\n');
      } else {
        return node.text;
      }
    }

    /**
     * Export.
     *
     * @type {Object}
     */

    exports.default = {
      deserialize: deserialize,
      serialize: serialize
    };

    /***/
  }), ( /* 570 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _block = __webpack_require__(55);
    var _block2 = _interopRequireDefault(_block);
    var _inline = __webpack_require__(56);
    var _inline2 = _interopRequireDefault(_inline);
    var _mark = __webpack_require__(42);
    var _mark2 = _interopRequireDefault(_mark);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    /**
     * Changes.
     *
     * @type {Object}
     */

    var Changes = {};

    /**
     * Mix in the changes that just pass through to their at-range equivalents
     * because they don't have any effect on the selection.
     */

    var PROXY_TRANSFORMS = ['deleteBackward', 'deleteCharBackward', 'deleteLineBackward', 'deleteWordBackward', 'deleteForward', 'deleteCharForward', 'deleteWordForward', 'deleteLineForward', 'setBlock', 'setInline', 'splitInline', 'unwrapBlock', 'unwrapInline', 'wrapBlock', 'wrapInline'];
    PROXY_TRANSFORMS.forEach(function (method) {
      Changes[method] = function (change) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        var state = change.state;
        var selection = state.selection;
        var methodAtRange = method + 'AtRange';
        change[methodAtRange].apply(change, [selection].concat(args));
      };
    });

    /**
     * Add a `mark` to the characters in the current selection.
     *
     * @param {Change} change
     * @param {Mark} mark
     */

    Changes.addMark = function (change, mark) {
      mark = _mark2.default.create(mark);
      var state = change.state;
      var document = state.document,
        selection = state.selection;
      if (selection.isExpanded) {
        change.addMarkAtRange(selection, mark);
      } else if (selection.marks) {
        var marks = selection.marks.add(mark);
        var sel = selection.set('marks', marks);
        change.select(sel);
      } else {
        var _marks = document.getActiveMarksAtRange(selection).add(mark);
        var _sel = selection.set('marks', _marks);
        change.select(_sel);
      }
    };

    /**
     * Delete at the current selection.
     *
     * @param {Change} change
     */

    Changes.delete = function (change) {
      var state = change.state;
      var selection = state.selection;
      change.deleteAtRange(selection);

      // Ensure that the selection is collapsed to the start, because in certain
      // cases when deleting across inline nodes, when splitting the inline node the
      // end point of the selection will end up after the split point.
      change.collapseToStart();
    };

    /**
     * Insert a `block` at the current selection.
     *
     * @param {Change} change
     * @param {String|Object|Block} block
     */

    Changes.insertBlock = function (change, block) {
      block = _block2.default.create(block);
      var state = change.state;
      var selection = state.selection;
      change.insertBlockAtRange(selection, block);

      // If the node was successfully inserted, update the selection.
      var node = change.state.document.getNode(block.key);
      if (node) change.collapseToEndOf(node);
    };

    /**
     * Insert a `fragment` at the current selection.
     *
     * @param {Change} change
     * @param {Document} fragment
     */

    Changes.insertFragment = function (change, fragment) {
      if (!fragment.nodes.size) return;
      var state = change.state;
      var _state = state,
        document = _state.document,
        selection = _state.selection;
      var _state2 = state,
        startText = _state2.startText,
        endText = _state2.endText,
        startInline = _state2.startInline;
      var lastText = fragment.getLastText();
      var lastInline = fragment.getClosestInline(lastText.key);
      var keys = document.getTexts().map(function (text) {
        return text.key;
      });
      var isAppending = !startInline || selection.hasEdgeAtStartOf(startText) || selection.hasEdgeAtEndOf(endText);
      change.insertFragmentAtRange(selection, fragment);
      state = change.state;
      document = state.document;
      var newTexts = document.getTexts().filter(function (n) {
        return !keys.includes(n.key);
      });
      var newText = isAppending ? newTexts.last() : newTexts.takeLast(2).first();
      if (newText && lastInline) {
        change.select(selection.collapseToEndOf(newText));
      } else if (newText) {
        change.select(selection.collapseToStartOf(newText).move(lastText.text.length));
      } else {
        change.select(selection.collapseToStart().move(lastText.text.length));
      }
    };

    /**
     * Insert an `inline` at the current selection.
     *
     * @param {Change} change
     * @param {String|Object|Inline} inline
     */

    Changes.insertInline = function (change, inline) {
      inline = _inline2.default.create(inline);
      var state = change.state;
      var selection = state.selection;
      change.insertInlineAtRange(selection, inline);

      // If the node was successfully inserted, update the selection.
      var node = change.state.document.getNode(inline.key);
      if (node) change.collapseToEndOf(node);
    };

    /**
     * Insert a string of `text` with optional `marks` at the current selection.
     *
     * @param {Change} change
     * @param {String} text
     * @param {Set<Mark>} marks (optional)
     */

    Changes.insertText = function (change, text, marks) {
      var state = change.state;
      var document = state.document,
        selection = state.selection;
      marks = marks || selection.marks;
      change.insertTextAtRange(selection, text, marks);

      // If the text was successfully inserted, and the selection had marks on it,
      // unset the selection's marks.
      if (selection.marks && document != change.state.document) {
        change.select({
          marks: null
        });
      }
    };

    /**
     * Split the block node at the current selection, to optional `depth`.
     *
     * @param {Change} change
     * @param {Number} depth (optional)
     */

    Changes.splitBlock = function (change) {
      var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var state = change.state;
      var selection = state.selection;
      change.splitBlockAtRange(selection, depth).collapseToEnd();
    };

    /**
     * Remove a `mark` from the characters in the current selection.
     *
     * @param {Change} change
     * @param {Mark} mark
     */

    Changes.removeMark = function (change, mark) {
      mark = _mark2.default.create(mark);
      var state = change.state;
      var document = state.document,
        selection = state.selection;
      if (selection.isExpanded) {
        change.removeMarkAtRange(selection, mark);
      } else if (selection.marks) {
        var marks = selection.marks.remove(mark);
        var sel = selection.set('marks', marks);
        change.select(sel);
      } else {
        var _marks2 = document.getActiveMarksAtRange(selection).remove(mark);
        var _sel2 = selection.set('marks', _marks2);
        change.select(_sel2);
      }
    };

    /**
     * Add or remove a `mark` from the characters in the current selection,
     * depending on whether it's already there.
     *
     * @param {Change} change
     * @param {Mark} mark
     */

    Changes.toggleMark = function (change, mark) {
      mark = _mark2.default.create(mark);
      var state = change.state;
      var exists = state.activeMarks.has(mark);
      if (exists) {
        change.removeMark(mark);
      } else {
        change.addMark(mark);
      }
    };

    /**
     * Wrap the current selection with prefix/suffix.
     *
     * @param {Change} change
     * @param {String} prefix
     * @param {String} suffix
     */

    Changes.wrapText = function (change, prefix) {
      var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : prefix;
      var state = change.state;
      var selection = state.selection;
      change.wrapTextAtRange(selection, prefix, suffix);

      // If the selection was collapsed, it will have moved the start offset too.
      if (selection.isCollapsed) {
        change.moveStart(0 - prefix.length);
      }

      // Adding the suffix will have pushed the end of the selection further on, so
      // we need to move it back to account for this.
      change.moveEnd(0 - suffix.length);

      // There's a chance that the selection points moved "through" each other,
      // resulting in a now-incorrect selection direction.
      if (selection.isForward != change.state.selection.isForward) {
        change.flip();
      }
    };

    /**
     * Export.
     *
     * @type {Object}
     */

    exports.default = Changes;

    /***/
  }), ( /* 571 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _immutable = __webpack_require__(2);
    var _block = __webpack_require__(55);
    var _block2 = _interopRequireDefault(_block);
    var _inline = __webpack_require__(56);
    var _inline2 = _interopRequireDefault(_inline);
    var _mark = __webpack_require__(42);
    var _mark2 = _interopRequireDefault(_mark);
    var _node = __webpack_require__(43);
    var _node2 = _interopRequireDefault(_node);
    var _string = __webpack_require__(583);
    var _string2 = _interopRequireDefault(_string);
    var _core = __webpack_require__(149);
    var _core2 = _interopRequireDefault(_core);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    /**
     * Changes.
     *
     * @type {Object}
     */

    var Changes = {};

    /**
     * Add a new `mark` to the characters at `range`.
     *
     * @param {Change} change
     * @param {Selection} range
     * @param {Mixed} mark
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.addMarkAtRange = function (change, range, mark) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (range.isCollapsed) return;
      var _options$normalize = options.normalize,
        normalize = _options$normalize === undefined ? true : _options$normalize;
      var state = change.state;
      var document = state.document;
      var startKey = range.startKey,
        startOffset = range.startOffset,
        endKey = range.endKey,
        endOffset = range.endOffset;
      var texts = document.getTextsAtRange(range);
      texts.forEach(function (node) {
        var key = node.key;
        var index = 0;
        var length = node.text.length;
        if (key == startKey) index = startOffset;
        if (key == endKey) length = endOffset;
        if (key == startKey && key == endKey) length = endOffset - startOffset;
        change.addMarkByKey(key, index, length, mark, {
          normalize: normalize
        });
      });
    };

    /**
     * Delete everything in a `range`.
     *
     * @param {Change} change
     * @param {Selection} range
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.deleteAtRange = function (change, range) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (range.isCollapsed) return;

      // Snapshot the selection, which creates an extra undo save point, so that
      // when you undo a delete, the expanded selection will be retained.
      change.snapshotSelection();
      var _options$normalize2 = options.normalize,
        normalize = _options$normalize2 === undefined ? true : _options$normalize2;
      var state = change.state;
      var startKey = range.startKey,
        startOffset = range.startOffset,
        endKey = range.endKey,
        endOffset = range.endOffset;
      var document = state.document;
      var isStartVoid = document.hasVoidParent(startKey);
      var isEndVoid = document.hasVoidParent(endKey);
      var startBlock = document.getClosestBlock(startKey);
      var endBlock = document.getClosestBlock(endKey);

      // Check if we have a "hanging" selection case where the even though the
      // selection extends into the start of the end node, we actually want to
      // ignore that for UX reasons.
      var isHanging = startOffset == 0 && endOffset == 0 && isStartVoid == false && startKey == startBlock.getFirstText().key && endKey == endBlock.getFirstText().key;

      // If it's a hanging selection, nudge it back to end in the previous text.
      if (isHanging) {
        var prevText = document.getPreviousText(endKey);
        endKey = prevText.key;
        endOffset = prevText.text.length;
        isEndVoid = document.hasVoidParent(endKey);
      }

      // If the start node is inside a void node, remove the void node and update
      // the starting point to be right after it, continuously until the start point
      // is not a void, or until the entire range is handled.
      while (isStartVoid) {
        var startVoid = document.getClosestVoid(startKey);
        var _nextText = document.getNextText(startKey);
        change.removeNodeByKey(startVoid.key, {
          normalize: false
        });

        // If the start and end keys are the same, we're done.
        if (startKey == endKey) return;

        // If there is no next text node, we're done.
        if (!_nextText) return;

        // Continue...
        document = change.state.document;
        startKey = _nextText.key;
        startOffset = 0;
        isStartVoid = document.hasVoidParent(startKey);
      }

      // If the end node is inside a void node, do the same thing but backwards. But
      // we don't need any aborting checks because if we've gotten this far there
      // must be a non-void node that will exit the loop.
      while (isEndVoid) {
        var endVoid = document.getClosestVoid(endKey);
        var _prevText = document.getPreviousText(endKey);
        change.removeNodeByKey(endVoid.key, {
          normalize: false
        });

        // Continue...
        document = change.state.document;
        endKey = _prevText.key;
        endOffset = _prevText.text.length;
        isEndVoid = document.hasVoidParent(endKey);
      }

      // If the start and end key are the same, and it was a hanging selection, we
      // can just remove the entire block.
      if (startKey == endKey && isHanging) {
        change.removeNodeByKey(startBlock.key);
        return;
      }

      // Otherwise, if it wasn't hanging, we're inside a single text node, so we can
      // simply remove the text in the range.
      else if (startKey == endKey) {
        var index = startOffset;
        var length = endOffset - startOffset;
        change.removeTextByKey(startKey, index, length, {
          normalize: normalize
        });
        return;
      }

      // Otherwise, we need to remove more than one node, so first split at the
      // range edges within a common ancestor, without normalizing. This makes it
      // easy, because we can then just remove every node inside the split.
      document = change.state.document;
      var ancestor = document.getCommonAncestor(startKey, endKey);
      var startChild = ancestor.getFurthestAncestor(startKey);
      var endChild = ancestor.getFurthestAncestor(endKey);
      change.splitDescendantsByKey(startChild.key, startKey, startOffset, {
        normalize: false
      });
      change.splitDescendantsByKey(endChild.key, endKey, endOffset, {
        normalize: false
      });

      // Refresh the variables after the split.
      document = change.state.document;
      ancestor = document.getCommonAncestor(startKey, endKey);
      startChild = ancestor.getFurthestAncestor(startKey);
      endChild = ancestor.getFurthestAncestor(endKey);

      // Determine which are the middle nodes.
      var nextText = document.getNextText(endKey);
      var startIndex = ancestor.nodes.indexOf(startChild);
      var endIndex = ancestor.nodes.indexOf(endChild);
      var middles = ancestor.nodes.slice(startIndex + 1, endIndex + 1);
      startBlock = document.getClosestBlock(startKey);
      endBlock = document.getClosestBlock(nextText.key);

      // Remove all of the middle nodes, between the splits.
      middles.forEach(function (child) {
        change.removeNodeByKey(child.key, {
          normalize: false
        });
      });

      // If the start and end blocks are different, and the selection was hanging,
      // remove the start block and the orphaned end block.
      if (startBlock.key != endBlock.key && isHanging) {
        change.removeNodeByKey(startBlock.key, {
          normalize: false
        });
        change.removeNodeByKey(endBlock.key, {
          normalize: false
        });
      }

      // Otherwise, move all of the nodes from the end block into the start block.
      else if (startBlock.key != endBlock.key) {
        endBlock.nodes.forEach(function (child, i) {
          var newKey = startBlock.key;
          var newIndex = startBlock.nodes.size + i;
          change.moveNodeByKey(child.key, newKey, newIndex, {
            normalize: false
          });
        });

        // Remove parents of endBlock as long as they have a single child.
        var lonely = document.getFurthestOnlyChildAncestor(endBlock.key) || endBlock;
        change.removeNodeByKey(lonely.key, {
          normalize: false
        });
      }
      if (normalize) {
        change.normalizeNodeByKey(ancestor.key, _core2.default);
      }
    };

    /**
     * Delete backward until the character boundary at a `range`.
     *
     * @param {Change} change
     * @param {Selection} range
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.deleteCharBackwardAtRange = function (change, range, options) {
      var state = change.state;
      var document = state.document;
      var startKey = range.startKey,
        startOffset = range.startOffset;
      var startBlock = document.getClosestBlock(startKey);
      var offset = startBlock.getOffset(startKey);
      var o = offset + startOffset;
      var text = startBlock.text;
      var n = _string2.default.getCharOffsetBackward(text, o);
      change.deleteBackwardAtRange(range, n, options);
    };

    /**
     * Delete backward until the line boundary at a `range`.
     *
     * @param {Change} change
     * @param {Selection} range
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.deleteLineBackwardAtRange = function (change, range, options) {
      var state = change.state;
      var document = state.document;
      var startKey = range.startKey,
        startOffset = range.startOffset;
      var startBlock = document.getClosestBlock(startKey);
      var offset = startBlock.getOffset(startKey);
      var o = offset + startOffset;
      change.deleteBackwardAtRange(range, o, options);
    };

    /**
     * Delete backward until the word boundary at a `range`.
     *
     * @param {Change} change
     * @param {Selection} range
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.deleteWordBackwardAtRange = function (change, range, options) {
      var state = change.state;
      var document = state.document;
      var startKey = range.startKey,
        startOffset = range.startOffset;
      var startBlock = document.getClosestBlock(startKey);
      var offset = startBlock.getOffset(startKey);
      var o = offset + startOffset;
      var text = startBlock.text;
      var n = _string2.default.getWordOffsetBackward(text, o);
      change.deleteBackwardAtRange(range, n, options);
    };

    /**
     * Delete backward `n` characters at a `range`.
     *
     * @param {Change} change
     * @param {Selection} range
     * @param {Number} n (optional)
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.deleteBackwardAtRange = function (change, range) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var _options$normalize3 = options.normalize,
        normalize = _options$normalize3 === undefined ? true : _options$normalize3;
      var state = change.state;
      var document = state.document;
      var _range = range,
        startKey = _range.startKey,
        focusOffset = _range.focusOffset;

      // If the range is expanded, perform a regular delete instead.

      if (range.isExpanded) {
        change.deleteAtRange(range, {
          normalize: normalize
        });
        return;
      }
      var block = document.getClosestBlock(startKey);

      // If the closest block is void, delete it.
      if (block && block.isVoid) {
        change.removeNodeByKey(block.key, {
          normalize: normalize
        });
        return;
      }

      // If the closest is not void, but empty, remove it
      if (block && !block.isVoid && block.isEmpty && document.nodes.size !== 1) {
        change.removeNodeByKey(block.key, {
          normalize: normalize
        });
        return;
      }

      // If the closest inline is void, delete it.
      var inline = document.getClosestInline(startKey);
      if (inline && inline.isVoid) {
        change.removeNodeByKey(inline.key, {
          normalize: normalize
        });
        return;
      }

      // If the range is at the start of the document, abort.
      if (range.isAtStartOf(document)) {
        return;
      }

      // If the range is at the start of the text node, we need to figure out what
      // is behind it to know how to delete...
      var text = document.getDescendant(startKey);
      if (range.isAtStartOf(text)) {
        var prev = document.getPreviousText(text.key);
        var prevBlock = document.getClosestBlock(prev.key);
        var prevInline = document.getClosestInline(prev.key);

        // If the previous block is void, remove it.
        if (prevBlock && prevBlock.isVoid) {
          change.removeNodeByKey(prevBlock.key, {
            normalize: normalize
          });
          return;
        }

        // If the previous inline is void, remove it.
        if (prevInline && prevInline.isVoid) {
          change.removeNodeByKey(prevInline.key, {
            normalize: normalize
          });
          return;
        }

        // If we're deleting by one character and the previous text node is not
        // inside the current block, we need to merge the two blocks together.
        if (n == 1 && prevBlock != block) {
          range = range.merge({
            anchorKey: prev.key,
            anchorOffset: prev.text.length
          });
          change.deleteAtRange(range, {
            normalize: normalize
          });
          return;
        }
      }

      // If the focus offset is farther than the number of characters to delete,
      // just remove the characters backwards inside the current node.
      if (n < focusOffset) {
        range = range.merge({
          focusOffset: focusOffset - n,
          isBackward: true
        });
        change.deleteAtRange(range, {
          normalize: normalize
        });
        return;
      }

      // Otherwise, we need to see how many nodes backwards to go.
      var node = text;
      var offset = 0;
      var traversed = focusOffset;
      while (n > traversed) {
        node = document.getPreviousText(node.key);
        var next = traversed + node.text.length;
        if (n <= next) {
          offset = next - n;
          break;
        } else {
          traversed = next;
        }
      }

      // If the focus node is inside a void, go up until right after it.
      if (document.hasVoidParent(node.key)) {
        var parent = document.getClosestVoid(node.key);
        node = document.getNextText(parent.key);
        offset = 0;
      }
      range = range.merge({
        focusKey: node.key,
        focusOffset: offset,
        isBackward: true
      });
      change.deleteAtRange(range, {
        normalize: normalize
      });
    };

    /**
     * Delete forward until the character boundary at a `range`.
     *
     * @param {Change} change
     * @param {Selection} range
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.deleteCharForwardAtRange = function (change, range, options) {
      var state = change.state;
      var document = state.document;
      var startKey = range.startKey,
        startOffset = range.startOffset;
      var startBlock = document.getClosestBlock(startKey);
      var offset = startBlock.getOffset(startKey);
      var o = offset + startOffset;
      var text = startBlock.text;
      var n = _string2.default.getCharOffsetForward(text, o);
      change.deleteForwardAtRange(range, n, options);
    };

    /**
     * Delete forward until the line boundary at a `range`.
     *
     * @param {Change} change
     * @param {Selection} range
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.deleteLineForwardAtRange = function (change, range, options) {
      var state = change.state;
      var document = state.document;
      var startKey = range.startKey,
        startOffset = range.startOffset;
      var startBlock = document.getClosestBlock(startKey);
      var offset = startBlock.getOffset(startKey);
      var o = offset + startOffset;
      change.deleteForwardAtRange(range, o, options);
    };

    /**
     * Delete forward until the word boundary at a `range`.
     *
     * @param {Change} change
     * @param {Selection} range
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.deleteWordForwardAtRange = function (change, range, options) {
      var state = change.state;
      var document = state.document;
      var startKey = range.startKey,
        startOffset = range.startOffset;
      var startBlock = document.getClosestBlock(startKey);
      var offset = startBlock.getOffset(startKey);
      var o = offset + startOffset;
      var text = startBlock.text;
      var n = _string2.default.getWordOffsetForward(text, o);
      change.deleteForwardAtRange(range, n, options);
    };

    /**
     * Delete forward `n` characters at a `range`.
     *
     * @param {Change} change
     * @param {Selection} range
     * @param {Number} n (optional)
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.deleteForwardAtRange = function (change, range) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var _options$normalize4 = options.normalize,
        normalize = _options$normalize4 === undefined ? true : _options$normalize4;
      var state = change.state;
      var document = state.document;
      var _range2 = range,
        startKey = _range2.startKey,
        focusOffset = _range2.focusOffset;

      // If the range is expanded, perform a regular delete instead.

      if (range.isExpanded) {
        change.deleteAtRange(range, {
          normalize: normalize
        });
        return;
      }
      var block = document.getClosestBlock(startKey);

      // If the closest block is void, delete it.
      if (block && block.isVoid) {
        change.removeNodeByKey(block.key, {
          normalize: normalize
        });
        return;
      }

      // If the closest is not void, but empty, remove it
      if (block && !block.isVoid && block.isEmpty && document.nodes.size !== 1) {
        change.removeNodeByKey(block.key, {
          normalize: normalize
        });
        return;
      }

      // If the closest inline is void, delete it.
      var inline = document.getClosestInline(startKey);
      if (inline && inline.isVoid) {
        change.removeNodeByKey(inline.key, {
          normalize: normalize
        });
        return;
      }

      // If the range is at the start of the document, abort.
      if (range.isAtEndOf(document)) {
        return;
      }

      // If the range is at the start of the text node, we need to figure out what
      // is behind it to know how to delete...
      var text = document.getDescendant(startKey);
      if (range.isAtEndOf(text)) {
        var next = document.getNextText(text.key);
        var nextBlock = document.getClosestBlock(next.key);
        var nextInline = document.getClosestInline(next.key);

        // If the previous block is void, remove it.
        if (nextBlock && nextBlock.isVoid) {
          change.removeNodeByKey(nextBlock.key, {
            normalize: normalize
          });
          return;
        }

        // If the previous inline is void, remove it.
        if (nextInline && nextInline.isVoid) {
          change.removeNodeByKey(nextInline.key, {
            normalize: normalize
          });
          return;
        }

        // If we're deleting by one character and the previous text node is not
        // inside the current block, we need to merge the two blocks together.
        if (n == 1 && nextBlock != block) {
          range = range.merge({
            focusKey: next.key,
            focusOffset: 0
          });
          change.deleteAtRange(range, {
            normalize: normalize
          });
          return;
        }
      }

      // If the remaining characters to the end of the node is greater than or equal
      // to the number of characters to delete, just remove the characters forwards
      // inside the current node.
      if (n <= text.text.length - focusOffset) {
        range = range.merge({
          focusOffset: focusOffset + n
        });
        change.deleteAtRange(range, {
          normalize: normalize
        });
        return;
      }

      // Otherwise, we need to see how many nodes forwards to go.
      var node = text;
      var offset = focusOffset;
      var traversed = text.text.length - focusOffset;
      while (n > traversed) {
        node = document.getNextText(node.key);
        var _next = traversed + node.text.length;
        if (n <= _next) {
          offset = n - traversed;
          break;
        } else {
          traversed = _next;
        }
      }

      // If the focus node is inside a void, go up until right before it.
      if (document.hasVoidParent(node.key)) {
        var parent = document.getClosestVoid(node.key);
        node = document.getPreviousText(parent.key);
        offset = node.text.length;
      }
      range = range.merge({
        focusKey: node.key,
        focusOffset: offset
      });
      change.deleteAtRange(range, {
        normalize: normalize
      });
    };

    /**
     * Insert a `block` node at `range`.
     *
     * @param {Change} change
     * @param {Selection} range
     * @param {Block|String|Object} block
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.insertBlockAtRange = function (change, range, block) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      block = _block2.default.create(block);
      var _options$normalize5 = options.normalize,
        normalize = _options$normalize5 === undefined ? true : _options$normalize5;
      if (range.isExpanded) {
        change.deleteAtRange(range);
        range = range.collapseToStart();
      }
      var state = change.state;
      var document = state.document;
      var _range3 = range,
        startKey = _range3.startKey,
        startOffset = _range3.startOffset;
      var startBlock = document.getClosestBlock(startKey);
      var parent = document.getParent(startBlock.key);
      var index = parent.nodes.indexOf(startBlock);
      if (startBlock.isVoid) {
        var extra = range.isAtEndOf(startBlock) ? 1 : 0;
        change.insertNodeByKey(parent.key, index + extra, block, {
          normalize: normalize
        });
      } else if (startBlock.isEmpty) {
        change.removeNodeByKey(startBlock.key);
        change.insertNodeByKey(parent.key, index, block, {
          normalize: normalize
        });
      } else if (range.isAtStartOf(startBlock)) {
        change.insertNodeByKey(parent.key, index, block, {
          normalize: normalize
        });
      } else if (range.isAtEndOf(startBlock)) {
        change.insertNodeByKey(parent.key, index + 1, block, {
          normalize: normalize
        });
      } else {
        change.splitDescendantsByKey(startBlock.key, startKey, startOffset, {
          normalize: false
        });
        change.insertNodeByKey(parent.key, index + 1, block, {
          normalize: normalize
        });
      }
      if (normalize) {
        change.normalizeNodeByKey(parent.key, _core2.default);
      }
    };

    /**
     * Insert a `fragment` at a `range`.
     *
     * @param {Change} change
     * @param {Selection} range
     * @param {Document} fragment
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.insertFragmentAtRange = function (change, range, fragment) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var _options$normalize6 = options.normalize,
        normalize = _options$normalize6 === undefined ? true : _options$normalize6;

      // If the range is expanded, delete it first.

      if (range.isExpanded) {
        change.deleteAtRange(range, {
          normalize: false
        });
        range = range.collapseToStart();
      }

      // If the fragment is empty, there's nothing to do after deleting.
      if (!fragment.nodes.size) return;

      // Regenerate the keys for all of the fragments nodes, so that they're
      // guaranteed not to collide with the existing keys in the document. Otherwise
      // they will be rengerated automatically and we won't have an easy way to
      // reference them.
      fragment = fragment.mapDescendants(function (child) {
        return child.regenerateKey();
      });

      // Calculate a few things...
      var _range4 = range,
        startKey = _range4.startKey,
        startOffset = _range4.startOffset;
      var state = change.state;
      var document = state.document;
      var startText = document.getDescendant(startKey);
      var startBlock = document.getClosestBlock(startText.key);
      var startChild = startBlock.getFurthestAncestor(startText.key);
      var isAtStart = range.isAtStartOf(startBlock);
      var parent = document.getParent(startBlock.key);
      var index = parent.nodes.indexOf(startBlock);
      var blocks = fragment.getBlocks();
      var firstBlock = blocks.first();
      var lastBlock = blocks.last();

      // If the fragment only contains a void block, use `insertBlock` instead.
      if (firstBlock == lastBlock && firstBlock.isVoid) {
        change.insertBlockAtRange(range, firstBlock, options);
        return;
      }

      // If the first and last block aren't the same, we need to insert all of the
      // nodes after the fragment's first block at the index.
      if (firstBlock != lastBlock) {
        var lonelyParent = fragment.getFurthest(firstBlock.key, function (p) {
          return p.nodes.size == 1;
        });
        var lonelyChild = lonelyParent || firstBlock;
        var startIndex = parent.nodes.indexOf(startBlock);
        fragment = fragment.removeDescendant(lonelyChild.key);
        fragment.nodes.forEach(function (node, i) {
          var newIndex = startIndex + i + 1;
          change.insertNodeByKey(parent.key, newIndex, node, {
            normalize: false
          });
        });
      }

      // Check if we need to split the node.
      if (startOffset != 0) {
        change.splitDescendantsByKey(startChild.key, startKey, startOffset, {
          normalize: false
        });
      }

      // Update our variables with the new state.
      document = change.state.document;
      startText = document.getDescendant(startKey);
      startBlock = document.getClosestBlock(startKey);
      startChild = startBlock.getFurthestAncestor(startText.key);

      // If the first and last block aren't the same, we need to move any of the
      // starting block's children after the split into the last block of the
      // fragment, which has already been inserted.
      if (firstBlock != lastBlock) {
        var nextChild = isAtStart ? startChild : startBlock.getNextSibling(startChild.key);
        var nextNodes = nextChild ? startBlock.nodes.skipUntil(function (n) {
          return n.key == nextChild.key;
        }) : (0, _immutable.List)();
        var lastIndex = lastBlock.nodes.size;
        nextNodes.forEach(function (node, i) {
          var newIndex = lastIndex + i;
          change.moveNodeByKey(node.key, lastBlock.key, newIndex, {
            normalize: false
          });
        });
      }

      // If the starting block is empty, we replace it entirely with the first block
      // of the fragment, since this leads to a more expected behavior for the user.
      if (startBlock.isEmpty) {
        change.removeNodeByKey(startBlock.key, {
          normalize: false
        });
        change.insertNodeByKey(parent.key, index, firstBlock, {
          normalize: false
        });
      }

      // Otherwise, we maintain the starting block, and insert all of the first
      // block's inline nodes into it at the split point.
      else {
        var inlineChild = startBlock.getFurthestAncestor(startText.key);
        var inlineIndex = startBlock.nodes.indexOf(inlineChild);
        firstBlock.nodes.forEach(function (inline, i) {
          var o = startOffset == 0 ? 0 : 1;
          var newIndex = inlineIndex + i + o;
          change.insertNodeByKey(startBlock.key, newIndex, inline, {
            normalize: false
          });
        });
      }

      // Normalize if requested.
      if (normalize) {
        change.normalizeNodeByKey(parent.key, _core2.default);
      }
    };

    /**
     * Insert an `inline` node at `range`.
     *
     * @param {Change} change
     * @param {Selection} range
     * @param {Inline|String|Object} inline
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.insertInlineAtRange = function (change, range, inline) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var _options$normalize7 = options.normalize,
        normalize = _options$normalize7 === undefined ? true : _options$normalize7;
      inline = _inline2.default.create(inline);
      if (range.isExpanded) {
        change.deleteAtRange(range, {
          normalize: false
        });
        range = range.collapseToStart();
      }
      var state = change.state;
      var document = state.document;
      var _range5 = range,
        startKey = _range5.startKey,
        startOffset = _range5.startOffset;
      var parent = document.getParent(startKey);
      var startText = document.assertDescendant(startKey);
      var index = parent.nodes.indexOf(startText);
      if (parent.isVoid) return;
      change.splitNodeByKey(startKey, startOffset, {
        normalize: false
      });
      change.insertNodeByKey(parent.key, index + 1, inline, {
        normalize: false
      });
      if (normalize) {
        change.normalizeNodeByKey(parent.key, _core2.default);
      }
    };

    /**
     * Insert `text` at a `range`, with optional `marks`.
     *
     * @param {Change} change
     * @param {Selection} range
     * @param {String} text
     * @param {Set<Mark>} marks (optional)
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.insertTextAtRange = function (change, range, text, marks) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      var normalize = options.normalize;
      var state = change.state;
      var document = state.document;
      var startKey = range.startKey,
        startOffset = range.startOffset;
      var parent = document.getParent(startKey);
      if (parent.isVoid) return;
      if (range.isExpanded) {
        change.deleteAtRange(range, {
          normalize: false
        });
      }

      // PERF: Unless specified, don't normalize if only inserting text.
      if (normalize !== undefined) {
        normalize = range.isExpanded;
      }
      change.insertTextByKey(startKey, startOffset, text, marks, {
        normalize: normalize
      });
    };

    /**
     * Remove an existing `mark` to the characters at `range`.
     *
     * @param {Change} change
     * @param {Selection} range
     * @param {Mark|String} mark (optional)
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.removeMarkAtRange = function (change, range, mark) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (range.isCollapsed) return;
      var _options$normalize8 = options.normalize,
        normalize = _options$normalize8 === undefined ? true : _options$normalize8;
      var state = change.state;
      var document = state.document;
      var texts = document.getTextsAtRange(range);
      var startKey = range.startKey,
        startOffset = range.startOffset,
        endKey = range.endKey,
        endOffset = range.endOffset;
      texts.forEach(function (node) {
        var key = node.key;
        var index = 0;
        var length = node.text.length;
        if (key == startKey) index = startOffset;
        if (key == endKey) length = endOffset;
        if (key == startKey && key == endKey) length = endOffset - startOffset;
        change.removeMarkByKey(key, index, length, mark, {
          normalize: normalize
        });
      });
    };

    /**
     * Set the `properties` of block nodes in a `range`.
     *
     * @param {Change} change
     * @param {Selection} range
     * @param {Object|String} properties
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.setBlockAtRange = function (change, range, properties) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var _options$normalize9 = options.normalize,
        normalize = _options$normalize9 === undefined ? true : _options$normalize9;
      var state = change.state;
      var document = state.document;
      var blocks = document.getBlocksAtRange(range);
      blocks.forEach(function (block) {
        change.setNodeByKey(block.key, properties, {
          normalize: normalize
        });
      });
    };

    /**
     * Set the `properties` of inline nodes in a `range`.
     *
     * @param {Change} change
     * @param {Selection} range
     * @param {Object|String} properties
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.setInlineAtRange = function (change, range, properties) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var _options$normalize10 = options.normalize,
        normalize = _options$normalize10 === undefined ? true : _options$normalize10;
      var state = change.state;
      var document = state.document;
      var inlines = document.getInlinesAtRange(range);
      inlines.forEach(function (inline) {
        change.setNodeByKey(inline.key, properties, {
          normalize: normalize
        });
      });
    };

    /**
     * Split the block nodes at a `range`, to optional `height`.
     *
     * @param {Change} change
     * @param {Selection} range
     * @param {Number} height (optional)
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.splitBlockAtRange = function (change, range) {
      var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var _options$normalize11 = options.normalize,
        normalize = _options$normalize11 === undefined ? true : _options$normalize11;
      if (range.isExpanded) {
        change.deleteAtRange(range, {
          normalize: normalize
        });
        range = range.collapseToStart();
      }
      var _range6 = range,
        startKey = _range6.startKey,
        startOffset = _range6.startOffset;
      var state = change.state;
      var document = state.document;
      var node = document.assertDescendant(startKey);
      var parent = document.getClosestBlock(node.key);
      var h = 0;
      while (parent && parent.kind == 'block' && h < height) {
        node = parent;
        parent = document.getClosestBlock(parent.key);
        h++;
      }
      change.splitDescendantsByKey(node.key, startKey, startOffset, {
        normalize: normalize
      });
    };

    /**
     * Split the inline nodes at a `range`, to optional `height`.
     *
     * @param {Change} change
     * @param {Selection} range
     * @param {Number} height (optional)
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.splitInlineAtRange = function (change, range) {
      var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Infinity;
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var _options$normalize12 = options.normalize,
        normalize = _options$normalize12 === undefined ? true : _options$normalize12;
      if (range.isExpanded) {
        change.deleteAtRange(range, {
          normalize: normalize
        });
        range = range.collapseToStart();
      }
      var _range7 = range,
        startKey = _range7.startKey,
        startOffset = _range7.startOffset;
      var state = change.state;
      var document = state.document;
      var node = document.assertDescendant(startKey);
      var parent = document.getClosestInline(node.key);
      var h = 0;
      while (parent && parent.kind == 'inline' && h < height) {
        node = parent;
        parent = document.getClosestInline(parent.key);
        h++;
      }
      change.splitDescendantsByKey(node.key, startKey, startOffset, {
        normalize: normalize
      });
    };

    /**
     * Add or remove a `mark` from the characters at `range`, depending on whether
     * it's already there.
     *
     * @param {Change} change
     * @param {Selection} range
     * @param {Mixed} mark
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.toggleMarkAtRange = function (change, range, mark) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (range.isCollapsed) return;
      mark = _mark2.default.create(mark);
      var _options$normalize13 = options.normalize,
        normalize = _options$normalize13 === undefined ? true : _options$normalize13;
      var state = change.state;
      var document = state.document;
      var marks = document.getActiveMarksAtRange(range);
      var exists = marks.some(function (m) {
        return m.equals(mark);
      });
      if (exists) {
        change.removeMarkAtRange(range, mark, {
          normalize: normalize
        });
      } else {
        change.addMarkAtRange(range, mark, {
          normalize: normalize
        });
      }
    };

    /**
     * Unwrap all of the block nodes in a `range` from a block with `properties`.
     *
     * @param {Change} change
     * @param {Selection} range
     * @param {String|Object} properties
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.unwrapBlockAtRange = function (change, range, properties) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      properties = _node2.default.createProperties(properties);
      var _options$normalize14 = options.normalize,
        normalize = _options$normalize14 === undefined ? true : _options$normalize14;
      var state = change.state;
      var document = state.document;
      var blocks = document.getBlocksAtRange(range);
      var wrappers = blocks.map(function (block) {
        return document.getClosest(block.key, function (parent) {
          if (parent.kind != 'block') return false;
          if (properties.type != null && parent.type != properties.type) return false;
          if (properties.isVoid != null && parent.isVoid != properties.isVoid) return false;
          if (properties.data != null && !parent.data.isSuperset(properties.data)) return false;
          return true;
        });
      }).filter(function (exists) {
        return exists;
      }).toOrderedSet().toList();
      wrappers.forEach(function (block) {
        var first = block.nodes.first();
        var last = block.nodes.last();
        var parent = document.getParent(block.key);
        var index = parent.nodes.indexOf(block);
        var children = block.nodes.filter(function (child) {
          return blocks.some(function (b) {
            return child == b || child.hasDescendant(b.key);
          });
        });
        var firstMatch = children.first();
        var lastMatch = children.last();
        if (first == firstMatch && last == lastMatch) {
          block.nodes.forEach(function (child, i) {
            change.moveNodeByKey(child.key, parent.key, index + i, {
              normalize: false
            });
          });
          change.removeNodeByKey(block.key, {
            normalize: false
          });
        } else if (last == lastMatch) {
          block.nodes.skipUntil(function (n) {
            return n == firstMatch;
          }).forEach(function (child, i) {
            change.moveNodeByKey(child.key, parent.key, index + 1 + i, {
              normalize: false
            });
          });
        } else if (first == firstMatch) {
          block.nodes.takeUntil(function (n) {
            return n == lastMatch;
          }).push(lastMatch).forEach(function (child, i) {
            change.moveNodeByKey(child.key, parent.key, index + i, {
              normalize: false
            });
          });
        } else {
          var firstText = firstMatch.getFirstText();
          change.splitDescendantsByKey(block.key, firstText.key, 0, {
            normalize: false
          });
          document = change.state.document;
          children.forEach(function (child, i) {
            if (i == 0) {
              var extra = child;
              child = document.getNextBlock(child.key);
              change.removeNodeByKey(extra.key, {
                normalize: false
              });
            }
            change.moveNodeByKey(child.key, parent.key, index + 1 + i, {
              normalize: false
            });
          });
        }
      });

      // TODO: optmize to only normalize the right block
      if (normalize) {
        change.normalizeDocument(_core2.default);
      }
    };

    /**
     * Unwrap the inline nodes in a `range` from an inline with `properties`.
     *
     * @param {Change} change
     * @param {Selection} range
     * @param {String|Object} properties
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.unwrapInlineAtRange = function (change, range, properties) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      properties = _node2.default.createProperties(properties);
      var _options$normalize15 = options.normalize,
        normalize = _options$normalize15 === undefined ? true : _options$normalize15;
      var state = change.state;
      var document = state.document;
      var texts = document.getTextsAtRange(range);
      var inlines = texts.map(function (text) {
        return document.getClosest(text.key, function (parent) {
          if (parent.kind != 'inline') return false;
          if (properties.type != null && parent.type != properties.type) return false;
          if (properties.isVoid != null && parent.isVoid != properties.isVoid) return false;
          if (properties.data != null && !parent.data.isSuperset(properties.data)) return false;
          return true;
        });
      }).filter(function (exists) {
        return exists;
      }).toOrderedSet().toList();
      inlines.forEach(function (inline) {
        var parent = change.state.document.getParent(inline.key);
        var index = parent.nodes.indexOf(inline);
        inline.nodes.forEach(function (child, i) {
          change.moveNodeByKey(child.key, parent.key, index + i, {
            normalize: false
          });
        });
      });

      // TODO: optmize to only normalize the right block
      if (normalize) {
        change.normalizeDocument(_core2.default);
      }
    };

    /**
     * Wrap all of the blocks in a `range` in a new `block`.
     *
     * @param {Change} change
     * @param {Selection} range
     * @param {Block|Object|String} block
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.wrapBlockAtRange = function (change, range, block) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      block = _block2.default.create(block);
      block = block.set('nodes', block.nodes.clear());
      var _options$normalize16 = options.normalize,
        normalize = _options$normalize16 === undefined ? true : _options$normalize16;
      var state = change.state;
      var document = state.document;
      var blocks = document.getBlocksAtRange(range);
      var firstblock = blocks.first();
      var lastblock = blocks.last();
      var parent = void 0,
        siblings = void 0,
        index = void 0;

      // If there is only one block in the selection then we know the parent and
      // siblings.
      if (blocks.length === 1) {
        parent = document.getParent(firstblock.key);
        siblings = blocks;
      }

      // Determine closest shared parent to all blocks in selection.
      else {
        parent = document.getClosest(firstblock.key, function (p1) {
          return !!document.getClosest(lastblock.key, function (p2) {
            return p1 == p2;
          });
        });
      }

      // If no shared parent could be found then the parent is the document.
      if (parent == null) parent = document;

      // Create a list of direct children siblings of parent that fall in the
      // selection.
      if (siblings == null) {
        var indexes = parent.nodes.reduce(function (ind, node, i) {
          if (node == firstblock || node.hasDescendant(firstblock.key)) ind[0] = i;
          if (node == lastblock || node.hasDescendant(lastblock.key)) ind[1] = i;
          return ind;
        }, []);
        index = indexes[0];
        siblings = parent.nodes.slice(indexes[0], indexes[1] + 1);
      }

      // Get the index to place the new wrapped node at.
      if (index == null) {
        index = parent.nodes.indexOf(siblings.first());
      }

      // Inject the new block node into the parent.
      change.insertNodeByKey(parent.key, index, block, {
        normalize: false
      });

      // Move the sibling nodes into the new block node.
      siblings.forEach(function (node, i) {
        change.moveNodeByKey(node.key, block.key, i, {
          normalize: false
        });
      });
      if (normalize) {
        change.normalizeNodeByKey(parent.key, _core2.default);
      }
    };

    /**
     * Wrap the text and inlines in a `range` in a new `inline`.
     *
     * @param {Change} change
     * @param {Selection} range
     * @param {Inline|Object|String} inline
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.wrapInlineAtRange = function (change, range, inline) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var state = change.state;
      var document = state.document;
      var _options$normalize17 = options.normalize,
        normalize = _options$normalize17 === undefined ? true : _options$normalize17;
      var startKey = range.startKey,
        startOffset = range.startOffset,
        endKey = range.endKey,
        endOffset = range.endOffset;
      if (range.isCollapsed) {
        // Wrapping an inline void
        var inlineParent = document.getClosestInline(startKey);
        if (!inlineParent.isVoid) {
          return;
        }
        return change.wrapInlineByKey(inlineParent.key, inline, options);
      }
      inline = _inline2.default.create(inline);
      inline = inline.set('nodes', inline.nodes.clear());
      var blocks = document.getBlocksAtRange(range);
      var startBlock = document.getClosestBlock(startKey);
      var endBlock = document.getClosestBlock(endKey);
      var startChild = startBlock.getFurthestAncestor(startKey);
      var endChild = endBlock.getFurthestAncestor(endKey);
      change.splitDescendantsByKey(endChild.key, endKey, endOffset, {
        normalize: false
      });
      change.splitDescendantsByKey(startChild.key, startKey, startOffset, {
        normalize: false
      });
      document = change.state.document;
      startBlock = document.getDescendant(startBlock.key);
      endBlock = document.getDescendant(endBlock.key);
      startChild = startBlock.getFurthestAncestor(startKey);
      endChild = endBlock.getFurthestAncestor(endKey);
      var startIndex = startBlock.nodes.indexOf(startChild);
      var endIndex = endBlock.nodes.indexOf(endChild);
      if (startBlock == endBlock) {
        document = change.state.document;
        startBlock = document.getClosestBlock(startKey);
        startChild = startBlock.getFurthestAncestor(startKey);
        var startInner = document.getNextSibling(startChild.key);
        var startInnerIndex = startBlock.nodes.indexOf(startInner);
        var endInner = startKey == endKey ? startInner : startBlock.getFurthestAncestor(endKey);
        var inlines = startBlock.nodes.skipUntil(function (n) {
          return n == startInner;
        }).takeUntil(function (n) {
          return n == endInner;
        }).push(endInner);
        var node = inline.regenerateKey();
        change.insertNodeByKey(startBlock.key, startInnerIndex, node, {
          normalize: false
        });
        inlines.forEach(function (child, i) {
          change.moveNodeByKey(child.key, node.key, i, {
            normalize: false
          });
        });
        if (normalize) {
          change.normalizeNodeByKey(startBlock.key, _core2.default);
        }
      } else {
        var startInlines = startBlock.nodes.slice(startIndex + 1);
        var endInlines = endBlock.nodes.slice(0, endIndex + 1);
        var startNode = inline.regenerateKey();
        var endNode = inline.regenerateKey();
        change.insertNodeByKey(startBlock.key, startIndex - 1, startNode, {
          normalize: false
        });
        change.insertNodeByKey(endBlock.key, endIndex, endNode, {
          normalize: false
        });
        startInlines.forEach(function (child, i) {
          change.moveNodeByKey(child.key, startNode.key, i, {
            normalize: false
          });
        });
        endInlines.forEach(function (child, i) {
          change.moveNodeByKey(child.key, endNode.key, i, {
            normalize: false
          });
        });
        if (normalize) {
          change.normalizeNodeByKey(startBlock.key, _core2.default).normalizeNodeByKey(endBlock.key, _core2.default);
        }
        blocks.slice(1, -1).forEach(function (block) {
          var node = inline.regenerateKey();
          change.insertNodeByKey(block.key, 0, node, {
            normalize: false
          });
          block.nodes.forEach(function (child, i) {
            change.moveNodeByKey(child.key, node.key, i, {
              normalize: false
            });
          });
          if (normalize) {
            change.normalizeNodeByKey(block.key, _core2.default);
          }
        });
      }
    };

    /**
     * Wrap the text in a `range` in a prefix/suffix.
     *
     * @param {Change} change
     * @param {Selection} range
     * @param {String} prefix
     * @param {String} suffix (optional)
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.wrapTextAtRange = function (change, range, prefix) {
      var suffix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : prefix;
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      var _options$normalize18 = options.normalize,
        normalize = _options$normalize18 === undefined ? true : _options$normalize18;
      var startKey = range.startKey,
        endKey = range.endKey;
      var start = range.collapseToStart();
      var end = range.collapseToEnd();
      if (startKey == endKey) {
        end = end.move(prefix.length);
      }
      change.insertTextAtRange(start, prefix, [], {
        normalize: normalize
      });
      change.insertTextAtRange(end, suffix, [], {
        normalize: normalize
      });
    };

    /**
     * Export.
     *
     * @type {Object}
     */

    exports.default = Changes;

    /***/
  }), ( /* 572 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _block = __webpack_require__(55);
    var _block2 = _interopRequireDefault(_block);
    var _inline = __webpack_require__(56);
    var _inline2 = _interopRequireDefault(_inline);
    var _mark = __webpack_require__(42);
    var _mark2 = _interopRequireDefault(_mark);
    var _node = __webpack_require__(43);
    var _node2 = _interopRequireDefault(_node);
    var _core = __webpack_require__(149);
    var _core2 = _interopRequireDefault(_core);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _toConsumableArray(arr) {
      if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
          arr2[i] = arr[i];
        }
        return arr2;
      } else {
        return Array.from(arr);
      }
    }

    /**
     * Changes.
     *
     * @type {Object}
     */

    var Changes = {};

    /**
     * Add mark to text at `offset` and `length` in node by `key`.
     *
     * @param {Change} change
     * @param {String} key
     * @param {Number} offset
     * @param {Number} length
     * @param {Mixed} mark
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.addMarkByKey = function (change, key, offset, length, mark) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      mark = _mark2.default.create(mark);
      var _options$normalize = options.normalize,
        normalize = _options$normalize === undefined ? true : _options$normalize;
      var state = change.state;
      var document = state.document;
      var path = document.getPath(key);
      var node = document.getNode(key);
      var ranges = node.getRanges();
      var operations = [];
      var bx = offset;
      var by = offset + length;
      var o = 0;
      ranges.forEach(function (range) {
        var ax = o;
        var ay = ax + range.text.length;
        o += range.text.length;

        // If the range doesn't overlap with the operation, continue on.
        if (ay < bx || by < ax) return;

        // If the range already has the mark, continue on.
        if (range.marks.has(mark)) return;

        // Otherwise, determine which offset and characters overlap.
        var start = Math.max(ax, bx);
        var end = Math.min(ay, by);
        operations.push({
          type: 'add_mark',
          path: path,
          offset: start,
          length: end - start,
          mark: mark
        });
      });
      change.applyOperations(operations);
      if (normalize) {
        var parent = document.getParent(key);
        change.normalizeNodeByKey(parent.key, _core2.default);
      }
    };

    /**
     * Insert a `fragment` at `index` in a node by `key`.
     *
     * @param {Change} change
     * @param {String} key
     * @param {Number} index
     * @param {Fragment} fragment
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.insertFragmentByKey = function (change, key, index, fragment) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      var _options$normalize2 = options.normalize,
        normalize = _options$normalize2 === undefined ? true : _options$normalize2;
      fragment.nodes.forEach(function (node, i) {
        change.insertNodeByKey(key, index + i, node);
      });
      if (normalize) {
        change.normalizeNodeByKey(key, _core2.default);
      }
    };

    /**
     * Insert a `node` at `index` in a node by `key`.
     *
     * @param {Change} change
     * @param {String} key
     * @param {Number} index
     * @param {Node} node
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.insertNodeByKey = function (change, key, index, node) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      var _options$normalize3 = options.normalize,
        normalize = _options$normalize3 === undefined ? true : _options$normalize3;
      var state = change.state;
      var document = state.document;
      var path = document.getPath(key);
      change.applyOperation({
        type: 'insert_node',
        path: [].concat(_toConsumableArray(path), [index]),
        node: node
      });
      if (normalize) {
        change.normalizeNodeByKey(key, _core2.default);
      }
    };

    /**
     * Insert `text` at `offset` in node by `key`.
     *
     * @param {Change} change
     * @param {String} key
     * @param {Number} offset
     * @param {String} text
     * @param {Set<Mark>} marks (optional)
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.insertTextByKey = function (change, key, offset, text, marks) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      var _options$normalize4 = options.normalize,
        normalize = _options$normalize4 === undefined ? true : _options$normalize4;
      var state = change.state;
      var document = state.document;
      var path = document.getPath(key);
      var node = document.getNode(key);
      marks = marks || node.getMarksAtIndex(offset);
      change.applyOperation({
        type: 'insert_text',
        path: path,
        offset: offset,
        text: text,
        marks: marks
      });
      if (normalize) {
        var parent = document.getParent(key);
        change.normalizeNodeByKey(parent.key, _core2.default);
      }
    };

    /**
     * Merge a node by `key` with the previous node.
     *
     * @param {Change} change
     * @param {String} key
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.mergeNodeByKey = function (change, key) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var _options$normalize5 = options.normalize,
        normalize = _options$normalize5 === undefined ? true : _options$normalize5;
      var state = change.state;
      var document = state.document;
      var path = document.getPath(key);
      var previous = document.getPreviousSibling(key);
      if (!previous) {
        throw new Error('Unable to merge node with key "' + key + '", no previous key.');
      }
      var position = previous.kind == 'text' ? previous.text.length : previous.nodes.size;
      change.applyOperation({
        type: 'merge_node',
        path: path,
        position: position
      });
      if (normalize) {
        var parent = document.getParent(key);
        change.normalizeNodeByKey(parent.key, _core2.default);
      }
    };

    /**
     * Move a node by `key` to a new parent by `newKey` and `index`.
     * `newKey` is the key of the container (it can be the document itself)
     *
     * @param {Change} change
     * @param {String} key
     * @param {String} newKey
     * @param {Number} index
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.moveNodeByKey = function (change, key, newKey, newIndex) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      var _options$normalize6 = options.normalize,
        normalize = _options$normalize6 === undefined ? true : _options$normalize6;
      var state = change.state;
      var document = state.document;
      var path = document.getPath(key);
      var newPath = document.getPath(newKey);
      change.applyOperation({
        type: 'move_node',
        path: path,
        newPath: [].concat(_toConsumableArray(newPath), [newIndex])
      });
      if (normalize) {
        var parent = document.getCommonAncestor(key, newKey);
        change.normalizeNodeByKey(parent.key, _core2.default);
      }
    };

    /**
     * Remove mark from text at `offset` and `length` in node by `key`.
     *
     * @param {Change} change
     * @param {String} key
     * @param {Number} offset
     * @param {Number} length
     * @param {Mark} mark
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.removeMarkByKey = function (change, key, offset, length, mark) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      mark = _mark2.default.create(mark);
      var _options$normalize7 = options.normalize,
        normalize = _options$normalize7 === undefined ? true : _options$normalize7;
      var state = change.state;
      var document = state.document;
      var path = document.getPath(key);
      var node = document.getNode(key);
      var ranges = node.getRanges();
      var operations = [];
      var bx = offset;
      var by = offset + length;
      var o = 0;
      ranges.forEach(function (range) {
        var ax = o;
        var ay = ax + range.text.length;
        o += range.text.length;

        // If the range doesn't overlap with the operation, continue on.
        if (ay < bx || by < ax) return;

        // If the range already has the mark, continue on.
        if (!range.marks.has(mark)) return;

        // Otherwise, determine which offset and characters overlap.
        var start = Math.max(ax, bx);
        var end = Math.min(ay, by);
        operations.push({
          type: 'remove_mark',
          path: path,
          offset: start,
          length: end - start,
          mark: mark
        });
      });
      change.applyOperations(operations);
      if (normalize) {
        var parent = document.getParent(key);
        change.normalizeNodeByKey(parent.key, _core2.default);
      }
    };

    /**
     * Remove a node by `key`.
     *
     * @param {Change} change
     * @param {String} key
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.removeNodeByKey = function (change, key) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var _options$normalize8 = options.normalize,
        normalize = _options$normalize8 === undefined ? true : _options$normalize8;
      var state = change.state;
      var document = state.document;
      var path = document.getPath(key);
      var node = document.getNode(key);
      change.applyOperation({
        type: 'remove_node',
        path: path,
        node: node
      });
      if (normalize) {
        var parent = document.getParent(key);
        change.normalizeNodeByKey(parent.key, _core2.default);
      }
    };

    /**
     * Remove text at `offset` and `length` in node by `key`.
     *
     * @param {Change} change
     * @param {String} key
     * @param {Number} offset
     * @param {Number} length
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.removeTextByKey = function (change, key, offset, length) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      var _options$normalize9 = options.normalize,
        normalize = _options$normalize9 === undefined ? true : _options$normalize9;
      var state = change.state;
      var document = state.document;
      var path = document.getPath(key);
      var node = document.getNode(key);
      var ranges = node.getRanges();
      var text = node.text;
      var removals = [];
      var bx = offset;
      var by = offset + length;
      var o = 0;
      ranges.forEach(function (range) {
        var ax = o;
        var ay = ax + range.text.length;
        o += range.text.length;

        // If the range doesn't overlap with the removal, continue on.
        if (ay < bx || by < ax) return;

        // Otherwise, determine which offset and characters overlap.
        var start = Math.max(ax, bx);
        var end = Math.min(ay, by);
        var string = text.slice(start, end);
        removals.push({
          type: 'remove_text',
          path: path,
          offset: start,
          text: string,
          marks: range.marks
        });
      });

      // Apply in reverse order, so subsequent removals don't impact previous ones.
      change.applyOperations(removals.reverse());
      if (normalize) {
        var block = document.getClosestBlock(key);
        change.normalizeNodeByKey(block.key, _core2.default);
      }
    };

    /**
     * Set `properties` on mark on text at `offset` and `length` in node by `key`.
     *
     * @param {Change} change
     * @param {String} key
     * @param {Number} offset
     * @param {Number} length
     * @param {Mark} mark
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.setMarkByKey = function (change, key, offset, length, mark, properties) {
      var options = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
      mark = _mark2.default.create(mark);
      properties = _mark2.default.createProperties(properties);
      var _options$normalize10 = options.normalize,
        normalize = _options$normalize10 === undefined ? true : _options$normalize10;
      var state = change.state;
      var document = state.document;
      var path = document.getPath(key);
      change.applyOperation({
        type: 'set_mark',
        path: path,
        offset: offset,
        length: length,
        mark: mark,
        properties: properties
      });
      if (normalize) {
        var parent = document.getParent(key);
        change.normalizeNodeByKey(parent.key, _core2.default);
      }
    };

    /**
     * Set `properties` on a node by `key`.
     *
     * @param {Change} change
     * @param {String} key
     * @param {Object|String} properties
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.setNodeByKey = function (change, key, properties) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      properties = _node2.default.createProperties(properties);
      var _options$normalize11 = options.normalize,
        normalize = _options$normalize11 === undefined ? true : _options$normalize11;
      var state = change.state;
      var document = state.document;
      var path = document.getPath(key);
      var node = document.getNode(key);
      change.applyOperation({
        type: 'set_node',
        path: path,
        node: node,
        properties: properties
      });
      if (normalize) {
        change.normalizeNodeByKey(node.key, _core2.default);
      }
    };

    /**
     * Split a node by `key` at `position`.
     *
     * @param {Change} change
     * @param {String} key
     * @param {Number} position
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.splitNodeByKey = function (change, key, position) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var _options$normalize12 = options.normalize,
        normalize = _options$normalize12 === undefined ? true : _options$normalize12;
      var state = change.state;
      var document = state.document;
      var path = document.getPath(key);
      change.applyOperation({
        type: 'split_node',
        path: path,
        position: position
      });
      if (normalize) {
        var parent = document.getParent(key);
        change.normalizeNodeByKey(parent.key, _core2.default);
      }
    };

    /**
     * Split a node deeply down the tree by `key`, `textKey` and `textOffset`.
     *
     * @param {Change} change
     * @param {String} key
     * @param {Number} position
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.splitDescendantsByKey = function (change, key, textKey, textOffset) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      if (key == textKey) {
        change.splitNodeByKey(textKey, textOffset, options);
        return;
      }
      var _options$normalize13 = options.normalize,
        normalize = _options$normalize13 === undefined ? true : _options$normalize13;
      var state = change.state;
      var document = state.document;
      var text = document.getNode(textKey);
      var ancestors = document.getAncestors(textKey);
      var nodes = ancestors.skipUntil(function (a) {
        return a.key == key;
      }).reverse().unshift(text);
      var previous = void 0;
      nodes.forEach(function (node) {
        var index = previous ? node.nodes.indexOf(previous) + 1 : textOffset;
        previous = node;
        change.splitNodeByKey(node.key, index, {
          normalize: false
        });
      });
      if (normalize) {
        var parent = document.getParent(key);
        change.normalizeNodeByKey(parent.key, _core2.default);
      }
    };

    /**
     * Unwrap content from an inline parent with `properties`.
     *
     * @param {Change} change
     * @param {String} key
     * @param {Object|String} properties
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.unwrapInlineByKey = function (change, key, properties, options) {
      var state = change.state;
      var document = state.document,
        selection = state.selection;
      var node = document.assertDescendant(key);
      var first = node.getFirstText();
      var last = node.getLastText();
      var range = selection.moveToRangeOf(first, last);
      change.unwrapInlineAtRange(range, properties, options);
    };

    /**
     * Unwrap content from a block parent with `properties`.
     *
     * @param {Change} change
     * @param {String} key
     * @param {Object|String} properties
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.unwrapBlockByKey = function (change, key, properties, options) {
      var state = change.state;
      var document = state.document,
        selection = state.selection;
      var node = document.assertDescendant(key);
      var first = node.getFirstText();
      var last = node.getLastText();
      var range = selection.moveToRangeOf(first, last);
      change.unwrapBlockAtRange(range, properties, options);
    };

    /**
     * Unwrap a single node from its parent.
     *
     * If the node is surrounded with siblings, its parent will be
     * split. If the node is the only child, the parent is removed, and
     * simply replaced by the node itself.  Cannot unwrap a root node.
     *
     * @param {Change} change
     * @param {String} key
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.unwrapNodeByKey = function (change, key) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var _options$normalize14 = options.normalize,
        normalize = _options$normalize14 === undefined ? true : _options$normalize14;
      var state = change.state;
      var document = state.document;
      var parent = document.getParent(key);
      var node = parent.getChild(key);
      var index = parent.nodes.indexOf(node);
      var isFirst = index === 0;
      var isLast = index === parent.nodes.size - 1;
      var parentParent = document.getParent(parent.key);
      var parentIndex = parentParent.nodes.indexOf(parent);
      if (parent.nodes.size === 1) {
        change.moveNodeByKey(key, parentParent.key, parentIndex, {
          normalize: false
        });
        change.removeNodeByKey(parent.key, options);
      } else if (isFirst) {
        // Just move the node before its parent.
        change.moveNodeByKey(key, parentParent.key, parentIndex, options);
      } else if (isLast) {
        // Just move the node after its parent.
        change.moveNodeByKey(key, parentParent.key, parentIndex + 1, options);
      } else {
        // Split the parent.
        change.splitNodeByKey(parent.key, index, {
          normalize: false
        });

        // Extract the node in between the splitted parent.
        change.moveNodeByKey(key, parentParent.key, parentIndex + 1, {
          normalize: false
        });
        if (normalize) {
          change.normalizeNodeByKey(parentParent.key, _core2.default);
        }
      }
    };

    /**
     * Wrap a node in an inline with `properties`.
     *
     * @param {Change} change
     * @param {String} key The node to wrap
     * @param {Block|Object|String} inline The wrapping inline (its children are discarded)
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.wrapInlineByKey = function (change, key, inline, options) {
      inline = _inline2.default.create(inline);
      inline = inline.set('nodes', inline.nodes.clear());
      var document = change.state.document;
      var node = document.assertDescendant(key);
      var parent = document.getParent(node.key);
      var index = parent.nodes.indexOf(node);
      change.insertNodeByKey(parent.key, index, inline, {
        normalize: false
      });
      change.moveNodeByKey(node.key, inline.key, 0, options);
    };

    /**
     * Wrap a node in a block with `properties`.
     *
     * @param {Change} change
     * @param {String} key The node to wrap
     * @param {Block|Object|String} block The wrapping block (its children are discarded)
     * @param {Object} options
     *   @property {Boolean} normalize
     */

    Changes.wrapBlockByKey = function (change, key, block, options) {
      block = _block2.default.create(block);
      block = block.set('nodes', block.nodes.clear());
      var document = change.state.document;
      var node = document.assertDescendant(key);
      var parent = document.getParent(node.key);
      var index = parent.nodes.indexOf(node);
      change.insertNodeByKey(parent.key, index, block, {
        normalize: false
      });
      change.moveNodeByKey(node.key, block.key, 0, options);
    };

    /**
     * Export.
     *
     * @type {Object}
     */

    exports.default = Changes;

    /***/
  }), ( /* 573 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _immutable = __webpack_require__(2);
    var _schema = __webpack_require__(99);
    var _schema2 = _interopRequireDefault(_schema);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    /**
     * Changes.
     *
     * @type {Object}
     */

    var Changes = {};

    /**
     * Normalize the document and selection with a `schema`.
     *
     * @param {Change} change
     * @param {Schema} schema
     */

    Changes.normalize = function (change, schema) {
      change.normalizeDocument(schema);
    };

    /**
     * Normalize the document with a `schema`.
     *
     * @param {Change} change
     * @param {Schema} schema
     */

    Changes.normalizeDocument = function (change, schema) {
      var state = change.state;
      var document = state.document;
      change.normalizeNodeByKey(document.key, schema);
    };

    /**
     * Normalize a `node` and its children with a `schema`.
     *
     * @param {Change} change
     * @param {Node|String} key
     * @param {Schema} schema
     */

    Changes.normalizeNodeByKey = function (change, key, schema) {
      assertSchema(schema);

      // If the schema has no validation rules, there's nothing to normalize.
      if (!schema.hasValidators) return;
      var state = change.state;
      var document = state.document;
      var node = document.assertNode(key);
      normalizeNodeAndChildren(change, node, schema);
    };

    /**
     * Normalize a `node` and its children with a `schema`.
     *
     * @param {Change} change
     * @param {Node} node
     * @param {Schema} schema
     */

    function normalizeNodeAndChildren(change, node, schema) {
      if (node.kind == 'text') {
        normalizeNode(change, node, schema);
        return;
      }

      // We can't just loop the children and normalize them, because in the process
      // of normalizing one child, we might end up creating another. Instead, we
      // have to normalize one at a time, and check for new children along the way.
      // PERF: use a mutable array here instead of an immutable stack.
      var keys = node.nodes.toArray().map(function (n) {
        return n.key;
      });

      // While there is still a child key that hasn't been normalized yet...

      var _loop = function _loop() {
        var ops = change.operations.length;
        var key = void 0;

        // PERF: use a mutable set here since we'll be add to it a lot.
        var set = new _immutable.Set().asMutable();

        // Unwind the stack, normalizing every child and adding it to the set.
        while (key = keys[0]) {
          var child = node.getChild(key);
          normalizeNodeAndChildren(change, child, schema);
          set.add(key);
          keys.shift();
        }

        // Turn the set immutable to be able to compare against it.
        set = set.asImmutable();

        // PERF: Only re-find the node and re-normalize any new children if
        // operations occured that might have changed it.
        if (change.operations.length != ops) {
          node = refindNode(change, node);

          // Add any new children back onto the stack.
          node.nodes.forEach(function (n) {
            if (set.has(n.key)) return;
            keys.unshift(n.key);
          });
        }
      };
      while (keys.length) {
        _loop();
      }

      // Normalize the node itself if it still exists.
      if (node) {
        normalizeNode(change, node, schema);
      }
    }

    /**
     * Re-find a reference to a node that may have been modified or removed
     * entirely by a change.
     *
     * @param {Change} change
     * @param {Node} node
     * @return {Node}
     */

    function refindNode(change, node) {
      var state = change.state;
      var document = state.document;
      return node.kind == 'document' ? document : document.getDescendant(node.key);
    }

    /**
     * Normalize a `node` with a `schema`, but not its children.
     *
     * @param {Change} change
     * @param {Node} node
     * @param {Schema} schema
     */

    function normalizeNode(change, node, schema) {
      var max = schema.rules.length;
      var iterations = 0;
      function iterate(t, n) {
        var failure = n.validate(schema);
        if (!failure) return;

        // Run the `normalize` function for the rule with the invalid value.
        var value = failure.value,
          rule = failure.rule;
        rule.normalize(t, n, value);

        // Re-find the node reference, in case it was updated. If the node no longer
        // exists, we're done for this branch.
        n = refindNode(t, n);
        if (!n) return;

        // Increment the iterations counter, and check to make sure that we haven't
        // exceeded the max. Without this check, it's easy for the `validate` or
        // `normalize` function of a schema rule to be written incorrectly and for
        // an infinite invalid loop to occur.
        iterations++;
        if (iterations > max) {
          throw new Error('A schema rule could not be validated after sufficient iterations. This is usually due to a `rule.validate` or `rule.normalize` function of a schema being incorrectly written, causing an infinite loop.');
        }

        // Otherwise, iterate again.
        iterate(t, n);
      }
      iterate(change, node);
    }

    /**
     * Assert that a `schema` exists.
     *
     * @param {Schema} schema
     */

    function assertSchema(schema) {
      if (_schema2.default.isSchema(schema)) {
        return;
      } else if (schema == null) {
        throw new Error('You must pass a `schema` object.');
      } else {
        throw new Error('You passed an invalid `schema` object: ' + schema + '.');
      }
    }

    /**
     * Export.
     *
     * @type {Object}
     */

    exports.default = Changes;

    /***/
  }), ( /* 574 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _invert = __webpack_require__(233);
    var _invert2 = _interopRequireDefault(_invert);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    /**
     * Changes.
     *
     * @type {Object}
     */

    var Changes = {};

    /**
     * Redo to the next state in the history.
     *
     * @param {Change} change
     */

    Changes.redo = function (change) {
      var state = change.state;
      var _state = state,
        history = _state.history;
      if (!history) return;
      var _history = history,
        undos = _history.undos,
        redos = _history.redos;
      var next = redos.peek();
      if (!next) return;

      // Shift the next state into the undo stack.
      redos = redos.pop();
      undos = undos.push(next);

      // Replay the next operations.
      next.forEach(function (op) {
        change.applyOperation(op, {
          save: false
        });
      });

      // Update the history.
      state = change.state;
      history = history.set('undos', undos).set('redos', redos);
      state = state.set('history', history);
      change.state = state;
    };

    /**
     * Undo the previous operations in the history.
     *
     * @param {Change} change
     */

    Changes.undo = function (change) {
      var state = change.state;
      var _state2 = state,
        history = _state2.history;
      if (!history) return;
      var _history2 = history,
        undos = _history2.undos,
        redos = _history2.redos;
      var previous = undos.peek();
      if (!previous) return;

      // Shift the previous operations into the redo stack.
      undos = undos.pop();
      redos = redos.push(previous);

      // Replay the inverse of the previous operations.
      previous.slice().reverse().map(_invert2.default).forEach(function (inverse) {
        change.applyOperation(inverse, {
          save: false
        });
      });

      // Update the history.
      state = change.state;
      history = history.set('undos', undos).set('redos', redos);
      state = state.set('history', history);
      change.state = state;
    };

    /**
     * Export.
     *
     * @type {Object}
     */

    exports.default = Changes;

    /***/
  }), ( /* 575 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _slicedToArray = function () {
      function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
          for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
          }
        } catch (err) {
          _d = true;
          _e = err;
        } finally {
          try {
            if (!_n && _i["return"]) _i["return"]();
          } finally {
            if (_d) throw _e;
          }
        }
        return _arr;
      }
      return function (arr, i) {
        if (Array.isArray(arr)) {
          return arr;
        } else if (Symbol.iterator in Object(arr)) {
          return sliceIterator(arr, i);
        } else {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
      };
    }();
    var _isEmpty = __webpack_require__(451);
    var _isEmpty2 = _interopRequireDefault(_isEmpty);
    var _slateDevLogger = __webpack_require__(16);
    var _slateDevLogger2 = _interopRequireDefault(_slateDevLogger);
    var _pick = __webpack_require__(161);
    var _pick2 = _interopRequireDefault(_pick);
    var _selection = __webpack_require__(147);
    var _selection2 = _interopRequireDefault(_selection);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    /**
     * Changes.
     *
     * @type {Object}
     */

    var Changes = {};

    /**
     * Set `properties` on the selection.
     *
     * @param {Change} change
     * @param {Object} properties
     */

    Changes.select = function (change, properties) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      properties = _selection2.default.createProperties(properties);
      var _options$snapshot = options.snapshot,
        snapshot = _options$snapshot === undefined ? false : _options$snapshot;
      var state = change.state;
      var document = state.document,
        selection = state.selection;
      var props = {};
      var sel = selection.toJSON();
      var next = selection.merge(properties).normalize(document);
      properties = (0, _pick2.default)(next, Object.keys(properties));

      // Remove any properties that are already equal to the current selection. And
      // create a dictionary of the previous values for all of the properties that
      // are being changed, for the inverse operation.
      for (var k in properties) {
        if (snapshot == false && properties[k] == sel[k]) continue;
        props[k] = properties[k];
      }

      // Resolve the selection keys into paths.
      sel.anchorPath = sel.anchorKey == null ? null : document.getPath(sel.anchorKey);
      delete sel.anchorKey;
      if (props.anchorKey) {
        props.anchorPath = props.anchorKey == null ? null : document.getPath(props.anchorKey);
        delete props.anchorKey;
      }
      sel.focusPath = sel.focusKey == null ? null : document.getPath(sel.focusKey);
      delete sel.focusKey;
      if (props.focusKey) {
        props.focusPath = props.focusKey == null ? null : document.getPath(props.focusKey);
        delete props.focusKey;
      }

      // If the selection moves, clear any marks, unless the new selection
      // properties change the marks in some way.
      var moved = ['anchorPath', 'anchorOffset', 'focusPath', 'focusOffset'].some(function (p) {
        return props.hasOwnProperty(p);
      });
      if (sel.marks && properties.marks == sel.marks && moved) {
        props.marks = null;
      }

      // If there are no new properties to set, abort.
      if ((0, _isEmpty2.default)(props)) {
        return;
      }

      // Apply the operation.
      change.applyOperation({
        type: 'set_selection',
        properties: props,
        selection: sel
      }, snapshot ? {
        skip: false,
        merge: false
      } : {});
    };

    /**
     * Select the whole document.
     *
     * @param {Change} change
     */

    Changes.selectAll = function (change) {
      var state = change.state;
      var document = state.document,
        selection = state.selection;
      var next = selection.moveToRangeOf(document);
      change.select(next);
    };

    /**
     * Snapshot the current selection.
     *
     * @param {Change} change
     */

    Changes.snapshotSelection = function (change) {
      var state = change.state;
      var selection = state.selection;
      change.select(selection, {
        snapshot: true
      });
    };

    /**
     * Set `properties` on the selection.
     *
     * @param {Mixed} ...args
     * @param {Change} change
     */

    Changes.moveTo = function (change, properties) {
      _slateDevLogger2.default.deprecate('0.17.0', 'The `moveTo()` change is deprecated, please use `select()` instead.');
      change.select(properties);
    };

    /**
     * Unset the selection's marks.
     *
     * @param {Change} change
     */

    Changes.unsetMarks = function (change) {
      _slateDevLogger2.default.deprecate('0.17.0', 'The `unsetMarks()` change is deprecated.');
      change.select({
        marks: null
      });
    };

    /**
     * Unset the selection, removing an association to a node.
     *
     * @param {Change} change
     */

    Changes.unsetSelection = function (change) {
      _slateDevLogger2.default.deprecate('0.17.0', 'The `unsetSelection()` change is deprecated, please use `deselect()` instead.');
      change.select({
        anchorKey: null,
        anchorOffset: 0,
        focusKey: null,
        focusOffset: 0,
        isFocused: false,
        isBackward: false
      });
    };

    /**
     * Mix in selection changes that are just a proxy for the selection method.
     */

    var PROXY_TRANSFORMS = ['blur', 'collapseTo', 'collapseToAnchor', 'collapseToEnd', 'collapseToEndOf', 'collapseToFocus', 'collapseToStart', 'collapseToStartOf', 'extend', 'extendTo', 'extendToEndOf', 'extendToStartOf', 'flip', 'focus', 'move', 'moveAnchor', 'moveAnchorOffsetTo', 'moveAnchorTo', 'moveAnchorToEndOf', 'moveAnchorToStartOf', 'moveEnd', 'moveEndOffsetTo', 'moveEndTo', 'moveFocus', 'moveFocusOffsetTo', 'moveFocusTo', 'moveFocusToEndOf', 'moveFocusToStartOf', 'moveOffsetsTo', 'moveStart', 'moveStartOffsetTo', 'moveStartTo',
    // 'moveTo', Commented out for now, since it conflicts with a deprecated one.
    'moveToEnd', 'moveToEndOf', 'moveToRangeOf', 'moveToStart', 'moveToStartOf', 'deselect'];
    PROXY_TRANSFORMS.forEach(function (method) {
      Changes[method] = function (change) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        var normalize = method != 'deselect';
        var state = change.state;
        var document = state.document,
          selection = state.selection;
        var next = selection[method].apply(selection, args);
        if (normalize) next = next.normalize(document);
        change.select(next);
      };
    });

    /**
     * Mix in node-related changes.
     */

    var PREFIXES = ['moveTo', 'collapseTo', 'extendTo'];
    var DIRECTIONS = ['Next', 'Previous'];
    var KINDS = ['Block', 'Inline', 'Text'];
    PREFIXES.forEach(function (prefix) {
      var edges = ['Start', 'End'];
      if (prefix == 'moveTo') {
        edges.push('Range');
      }
      edges.forEach(function (edge) {
        DIRECTIONS.forEach(function (direction) {
          KINDS.forEach(function (kind) {
            var get = 'get' + direction + kind;
            var getAtRange = 'get' + kind + 'sAtRange';
            var index = direction == 'Next' ? 'last' : 'first';
            var method = '' + prefix + edge + 'Of';
            var name = '' + method + direction + kind;
            Changes[name] = function (change) {
              var state = change.state;
              var document = state.document,
                selection = state.selection;
              var nodes = document[getAtRange](selection);
              var node = nodes[index]();
              var target = document[get](node.key);
              if (!target) return;
              var next = selection[method](target);
              change.select(next);
            };
          });
        });
      });
    });

    /**
     * Mix in deprecated changes with a warning.
     */

    var DEPRECATED_TRANSFORMS = [['extendBackward', 'extend', 'The `extendBackward(n)` change is deprecated, please use `extend(n)` instead with a negative offset.'], ['extendForward', 'extend', 'The `extendForward(n)` change is deprecated, please use `extend(n)` instead.'], ['moveBackward', 'move', 'The `moveBackward(n)` change is deprecated, please use `move(n)` instead with a negative offset.'], ['moveForward', 'move', 'The `moveForward(n)` change is deprecated, please use `move(n)` instead.'], ['moveStartOffset', 'moveStart', 'The `moveStartOffset(n)` change is deprecated, please use `moveStart(n)` instead.'], ['moveEndOffset', 'moveEnd', 'The `moveEndOffset(n)` change is deprecated, please use `moveEnd()` instead.'], ['moveToOffsets', 'moveOffsetsTo', 'The `moveToOffsets()` change is deprecated, please use `moveOffsetsTo()` instead.'], ['flipSelection', 'flip', 'The `flipSelection()` change is deprecated, please use `flip()` instead.']];
    DEPRECATED_TRANSFORMS.forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 3),
        old = _ref2[0],
        current = _ref2[1],
        warning = _ref2[2];
      Changes[old] = function (change) {
        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }
        _slateDevLogger2.default.deprecate('0.17.0', warning);
        var state = change.state;
        var document = state.document,
          selection = state.selection;
        var sel = selection[current].apply(selection, args).normalize(document);
        change.select(sel);
      };
    });

    /**
     * Export.
     *
     * @type {Object}
     */

    exports.default = Changes;

    /***/
  }), ( /* 576 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    /**
     * Changes.
     *
     * @type {Object}
     */

    var Changes = {};

    /**
     * Set `properties` on the top-level state's data.
     *
     * @param {Change} change
     * @param {Object} properties
     */

    Changes.setData = function (change, properties) {
      var state = change.state;
      var data = state.data;
      change.applyOperation({
        type: 'set_data',
        properties: properties,
        data: data
      });
    };

    /**
     * Export.
     *
     * @type {Object}
     */

    exports.default = Changes;

    /***/
  }), ( /* 577 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    var _debug = __webpack_require__(20);
    var _debug2 = _interopRequireDefault(_debug);
    var _slateDevLogger = __webpack_require__(16);
    var _slateDevLogger2 = _interopRequireDefault(_slateDevLogger);
    var _pick = __webpack_require__(161);
    var _pick2 = _interopRequireDefault(_pick);
    var _modelTypes = __webpack_require__(11);
    var _modelTypes2 = _interopRequireDefault(_modelTypes);
    var _changes = __webpack_require__(229);
    var _changes2 = _interopRequireDefault(_changes);
    var _apply = __webpack_require__(232);
    var _apply2 = _interopRequireDefault(_apply);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    /**
     * Debug.
     *
     * @type {Function}
     */

    var debug = (0, _debug2.default)('slate:change');

    /**
     * Change.
     *
     * @type {Change}
     */

    var Change = function () {
      _createClass(Change, null, [{
        key: 'isChange',
        /**
         * Check if a `value` is a `Change`.
         *
         * @param {Any} value
         * @return {Boolean}
         */

        value: function isChange(value) {
          return !!(value && value[_modelTypes2.default.CHANGE]);
        }

        /**
         * Create a new `Change` with `attrs`.
         *
         * @param {Object} attrs
         *   @property {State} state
         */
      }]);
      function Change(attrs) {
        _classCallCheck(this, Change);
        var state = attrs.state;
        this.state = state;
        this.operations = [];
        this.flags = (0, _pick2.default)(attrs, ['merge', 'save']);
      }

      /**
       * Get the kind.
       *
       * @return {String}
       */

      _createClass(Change, [{
        key: 'applyOperation',
        /**
         * Apply an `operation` to the current state, saving the operation to the
         * history if needed.
         *
         * @param {Object} operation
         * @param {Object} options
         * @return {Change}
         */

        value: function applyOperation(operation) {
          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var operations = this.operations,
            flags = this.flags;
          var state = this.state;
          var _state = state,
            history = _state.history;

          // Default options to the change-level flags, this allows for setting
          // specific options for all of the operations of a given change.

          options = _extends({}, flags, options);

          // Derive the default option values.
          var _options = options,
            _options$merge = _options.merge,
            merge = _options$merge === undefined ? operations.length == 0 ? null : true : _options$merge,
            _options$save = _options.save,
            save = _options$save === undefined ? true : _options$save,
            _options$skip = _options.skip,
            skip = _options$skip === undefined ? null : _options$skip;

          // Apply the operation to the state.

          debug('apply', {
            operation: operation,
            save: save,
            merge: merge
          });
          state = (0, _apply2.default)(state, operation);

          // If needed, save the operation to the history.
          if (history && save) {
            history = history.save(operation, {
              merge: merge,
              skip: skip
            });
            state = state.set('history', history);
          }

          // Update the mutable change object.
          this.state = state;
          this.operations.push(operation);
          return this;
        }

        /**
         * Apply a series of `operations` to the current state.
         *
         * @param {Array} operations
         * @param {Object} options
         * @return {Change}
         */
      }, {
        key: 'applyOperations',
        value: function applyOperations(operations, options) {
          var _this = this;
          operations.forEach(function (op) {
            return _this.applyOperation(op, options);
          });
          return this;
        }

        /**
         * Call a change `fn` with arguments.
         *
         * @param {Function} fn
         * @param {Mixed} ...args
         * @return {Change}
         */
      }, {
        key: 'call',
        value: function call(fn) {
          for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }
          fn.apply(undefined, [this].concat(args));
          return this;
        }

        /**
         * Set an operation flag by `key` to `value`.
         *
         * @param {String} key
         * @param {Any} value
         * @return {Change}
         */
      }, {
        key: 'setOperationFlag',
        value: function setOperationFlag(key, value) {
          this.flags[key] = value;
          return this;
        }

        /**
         * Unset an operation flag by `key`.
         *
         * @param {String} key
         * @return {Change}
         */
      }, {
        key: 'unsetOperationFlag',
        value: function unsetOperationFlag(key) {
          delete this.flags[key];
          return this;
        }

        /**
         * Deprecated.
         *
         * @return {State}
         */
      }, {
        key: 'apply',
        value: function apply() {
          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          _slateDevLogger2.default.deprecate('0.22.0', 'The `change.apply()` method is deprecrated and no longer necessary, as all operations are applied immediately when invoked. You can access the change\'s state, which is already pre-computed, directly via `change.state` instead.');
          return this.state;
        }
      }, {
        key: 'kind',
        get: function get() {
          return 'change';
        }
      }]);
      return Change;
    }();

    /**
     * Attach a pseudo-symbol for type checking.
     */

    Change.prototype[_modelTypes2.default.CHANGE] = true;

    /**
     * Add a change method for each of the changes.
     */

    Object.keys(_changes2.default).forEach(function (type) {
      Change.prototype[type] = function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        debug(type, {
          args: args
        });
        this.call.apply(this, [_changes2.default[type]].concat(args));
        return this;
      };
    })

    /**
     * Add deprecation warnings in case people try to access a change as a state.
     */;
    ['hasUndos', 'hasRedos', 'isBlurred', 'isFocused', 'isCollapsed', 'isExpanded', 'isBackward', 'isForward', 'startKey', 'endKey', 'startOffset', 'endOffset', 'anchorKey', 'focusKey', 'anchorOffset', 'focusOffset', 'startBlock', 'endBlock', 'anchorBlock', 'focusBlock', 'startInline', 'endInline', 'anchorInline', 'focusInline', 'startText', 'endText', 'anchorText', 'focusText', 'characters', 'marks', 'blocks', 'fragment', 'inlines', 'texts', 'isEmpty'].forEach(function (getter) {
      Object.defineProperty(Change.prototype, getter, {
        get: function get() {
          _slateDevLogger2.default.deprecate('0.22.0', 'You attempted to access the `' + getter + '` property of what was previously a `state` object but is now a `change` object. This syntax has been deprecated as plugins are now passed `change` objects instead of `state` objects.');
          return this.state[getter];
        }
      });
    });
    Change.prototype.transform = function () {
      _slateDevLogger2.default.deprecate('0.22.0', 'You attempted to call `.transform()` on what was previously a `state` object but is now already a `change` object. This syntax has been deprecated as plugins are now passed `change` objects instead of `state` objects.');
      return this;
    };

    /**
     * Export.
     *
     * @type {Change}
     */

    exports.default = Change;

    /***/
  }), ( /* 578 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    var _debug = __webpack_require__(20);
    var _debug2 = _interopRequireDefault(_debug);
    var _immutable = __webpack_require__(2);
    var _modelTypes = __webpack_require__(11);
    var _modelTypes2 = _interopRequireDefault(_modelTypes);
    var _schema2 = __webpack_require__(99);
    var _schema3 = _interopRequireDefault(_schema2);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    /**
     * Debug.
     *
     * @type {Function}
     */

    var debug = (0, _debug2.default)('slate:stack');

    /**
     * Methods that are triggered on events and can change the state.
     *
     * @type {Array}
     */

    var METHODS = ['onBeforeInput', 'onBeforeChange', 'onBlur', 'onCopy', 'onCut', 'onDrop', 'onFocus', 'onKeyDown', 'onKeyUp', 'onPaste', 'onSelect', 'onChange'];

    /**
     * Default properties.
     *
     * @type {Object}
     */

    var DEFAULTS = {
      plugins: [],
      schema: new _schema3.default()
    };

    /**
     * Stack.
     *
     * @type {Stack}
     */

    var Stack = function (_Record) {
      _inherits(Stack, _Record);
      function Stack() {
        _classCallCheck(this, Stack);
        return _possibleConstructorReturn(this, (Stack.__proto__ || Object.getPrototypeOf(Stack)).apply(this, arguments));
      }
      _createClass(Stack, [{
        key: 'render',
        /**
         * Invoke `render` on all of the plugins in reverse, building up a tree of
         * higher-order components.
         *
         * @param {State} state
         * @param {Editor} editor
         * @param {Object} children
         * @param {Object} props
         * @return {Component}
         */

        value: function render(state, editor, props) {
          debug('render');
          var plugins = this.plugins.slice().reverse();
          var children = void 0;
          for (var i = 0; i < plugins.length; i++) {
            var plugin = plugins[i];
            if (!plugin.render) continue;
            children = plugin.render(props, state, editor);
            props.children = children;
          }
          return children;
        }

        /**
         * Invoke `renderPortal` on all of the plugins, building a list of portals.
         *
         * @param {State} state
         * @param {Editor} editor
         * @return {Array}
         */
      }, {
        key: 'renderPortal',
        value: function renderPortal(state, editor) {
          debug('renderPortal');
          var portals = [];
          for (var i = 0; i < this.plugins.length; i++) {
            var plugin = this.plugins[i];
            if (!plugin.renderPortal) continue;
            var portal = plugin.renderPortal(state, editor);
            if (portal) portals.push(portal);
          }
          return portals;
        }
      }, {
        key: 'kind',
        /**
         * Get the kind.
         *
         * @return {String}
         */

        get: function get() {
          return 'stack';
        }
      }], [{
        key: 'create',
        /**
         * Constructor.
         *
         * @param {Object} attrs
         *   @property {Array} plugins
         *   @property {Schema|Object} schema
         *   @property {Function} ...handlers
         */

        value: function create() {
          var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var plugins = attrs.plugins;
          var schema = resolveSchema(plugins);
          var stack = new Stack({
            plugins: plugins,
            schema: schema
          });
          return stack;
        }

        /**
         * Check if a `value` is a `Stack`.
         *
         * @param {Any} value
         * @return {Boolean}
         */
      }, {
        key: 'isStack',
        value: function isStack(value) {
          return !!(value && value[_modelTypes2.default.STACK]);
        }
      }]);
      return Stack;
    }((0, _immutable.Record)(DEFAULTS));

    /**
     * Attach a pseudo-symbol for type checking.
     */

    Stack.prototype[_modelTypes2.default.STACK] = true;

    /**
     * Mix in the stack methods.
     *
     * @param {Change} change
     * @param {Editor} editor
     * @param {Mixed} ...args
     */

    var _loop = function _loop(i) {
      var method = METHODS[i];
      Stack.prototype[method] = function (change, editor) {
        debug(method);
        for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          args[_key - 2] = arguments[_key];
        }
        for (var k = 0; k < this.plugins.length; k++) {
          var plugin = this.plugins[k];
          if (!plugin[method]) continue;
          var next = plugin[method].apply(plugin, args.concat([change, editor]));
          if (next != null) break;
        }
      };
    };
    for (var i = 0; i < METHODS.length; i++) {
      _loop(i);
    }

    /**
     * Resolve a schema from a set of `plugins`.
     *
     * @param {Array} plugins
     * @return {Schema}
     */

    function resolveSchema(plugins) {
      var rules = [];
      for (var i = 0; i < plugins.length; i++) {
        var plugin = plugins[i];
        if (plugin.schema == null) continue;
        var _schema = _schema3.default.create(plugin.schema);
        rules = rules.concat(_schema.rules);
      }
      var schema = _schema3.default.create({
        rules: rules
      });
      return schema;
    }

    /**
     * Export.
     *
     * @type {Stack}
     */

    exports.default = Stack;

    /***/
  }), ( /* 579 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    var _isPlainObject = __webpack_require__(9);
    var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
    var _slateDevLogger = __webpack_require__(16);
    var _slateDevLogger2 = _interopRequireDefault(_slateDevLogger);
    var _immutable = __webpack_require__(2);
    var _modelTypes = __webpack_require__(11);
    var _modelTypes2 = _interopRequireDefault(_modelTypes);
    var _core = __webpack_require__(149);
    var _core2 = _interopRequireDefault(_core);
    var _change = __webpack_require__(577);
    var _change2 = _interopRequireDefault(_change);
    var _document = __webpack_require__(74);
    var _document2 = _interopRequireDefault(_document);
    var _history = __webpack_require__(230);
    var _history2 = _interopRequireDefault(_history);
    var _selection = __webpack_require__(147);
    var _selection2 = _interopRequireDefault(_selection);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    /**
     * Default properties.
     *
     * @type {Object}
     */

    var DEFAULTS = {
      document: _document2.default.create(),
      selection: _selection2.default.create(),
      history: _history2.default.create(),
      data: new _immutable.Map()
    };

    /**
     * State.
     *
     * @type {State}
     */

    var State = function (_Record) {
      _inherits(State, _Record);
      function State() {
        _classCallCheck(this, State);
        return _possibleConstructorReturn(this, (State.__proto__ || Object.getPrototypeOf(State)).apply(this, arguments));
      }
      _createClass(State, [{
        key: 'change',
        /**
         * Create a new `Change` with the current state as a starting point.
         *
         * @param {Object} attrs
         * @return {Change}
         */

        value: function change() {
          var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return new _change2.default(_extends({}, attrs, {
            state: this
          }));
        }

        /**
         * Deprecated.
         *
         * @return {Change}
         */
      }, {
        key: 'transform',
        value: function transform() {
          _slateDevLogger2.default.deprecate('0.22.0', 'The `state.transform()` method has been deprecated in favor of `state.change()`.');
          return this.change.apply(this, arguments);
        }

        /**
         * Return a JSON representation of the state.
         *
         * @param {Object} options
         * @return {Object}
         */
      }, {
        key: 'toJSON',
        value: function toJSON() {
          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var object = {
            data: this.data.toJSON(),
            document: this.document.toJSON(options),
            kind: this.kind,
            history: this.history.toJSON(),
            selection: this.selection.toJSON()
          };
          if (!options.preserveHistory) {
            delete object.history;
          }
          if (!options.preserveSelection) {
            delete object.selection;
          }
          if (!options.preserveStateData) {
            delete object.data;
          }
          if (options.preserveSelection && !options.preserveKeys) {
            var document = this.document,
              selection = this.selection;
            object.selection.anchorPath = document.getPath(selection.anchorKey);
            object.selection.focusPath = document.getPath(selection.focusKey);
            delete object.selection.anchorKey;
            delete object.selection.focusKey;
          }
          return object;
        }

        /**
         * Alias `toJS`.
         */
      }, {
        key: 'toJS',
        value: function toJS(options) {
          return this.toJSON(options);
        }
      }, {
        key: 'kind',
        /**
         * Get the kind.
         *
         * @return {String}
         */

        get: function get() {
          return 'state';
        }

        /**
         * Are there undoable events?
         *
         * @return {Boolean}
         */
      }, {
        key: 'hasUndos',
        get: function get() {
          return this.history.undos.size > 0;
        }

        /**
         * Are there redoable events?
         *
         * @return {Boolean}
         */
      }, {
        key: 'hasRedos',
        get: function get() {
          return this.history.redos.size > 0;
        }

        /**
         * Is the current selection blurred?
         *
         * @return {Boolean}
         */
      }, {
        key: 'isBlurred',
        get: function get() {
          return this.selection.isBlurred;
        }

        /**
         * Is the current selection focused?
         *
         * @return {Boolean}
         */
      }, {
        key: 'isFocused',
        get: function get() {
          return this.selection.isFocused;
        }

        /**
         * Is the current selection collapsed?
         *
         * @return {Boolean}
         */
      }, {
        key: 'isCollapsed',
        get: function get() {
          return this.selection.isCollapsed;
        }

        /**
         * Is the current selection expanded?
         *
         * @return {Boolean}
         */
      }, {
        key: 'isExpanded',
        get: function get() {
          return this.selection.isExpanded;
        }

        /**
         * Is the current selection backward?
         *
         * @return {Boolean} isBackward
         */
      }, {
        key: 'isBackward',
        get: function get() {
          return this.selection.isBackward;
        }

        /**
         * Is the current selection forward?
         *
         * @return {Boolean}
         */
      }, {
        key: 'isForward',
        get: function get() {
          return this.selection.isForward;
        }

        /**
         * Get the current start key.
         *
         * @return {String}
         */
      }, {
        key: 'startKey',
        get: function get() {
          return this.selection.startKey;
        }

        /**
         * Get the current end key.
         *
         * @return {String}
         */
      }, {
        key: 'endKey',
        get: function get() {
          return this.selection.endKey;
        }

        /**
         * Get the current start offset.
         *
         * @return {String}
         */
      }, {
        key: 'startOffset',
        get: function get() {
          return this.selection.startOffset;
        }

        /**
         * Get the current end offset.
         *
         * @return {String}
         */
      }, {
        key: 'endOffset',
        get: function get() {
          return this.selection.endOffset;
        }

        /**
         * Get the current anchor key.
         *
         * @return {String}
         */
      }, {
        key: 'anchorKey',
        get: function get() {
          return this.selection.anchorKey;
        }

        /**
         * Get the current focus key.
         *
         * @return {String}
         */
      }, {
        key: 'focusKey',
        get: function get() {
          return this.selection.focusKey;
        }

        /**
         * Get the current anchor offset.
         *
         * @return {String}
         */
      }, {
        key: 'anchorOffset',
        get: function get() {
          return this.selection.anchorOffset;
        }

        /**
         * Get the current focus offset.
         *
         * @return {String}
         */
      }, {
        key: 'focusOffset',
        get: function get() {
          return this.selection.focusOffset;
        }

        /**
         * Get the current start text node's closest block parent.
         *
         * @return {Block}
         */
      }, {
        key: 'startBlock',
        get: function get() {
          return this.selection.isUnset ? null : this.document.getClosestBlock(this.selection.startKey);
        }

        /**
         * Get the current end text node's closest block parent.
         *
         * @return {Block}
         */
      }, {
        key: 'endBlock',
        get: function get() {
          return this.selection.isUnset ? null : this.document.getClosestBlock(this.selection.endKey);
        }

        /**
         * Get the current anchor text node's closest block parent.
         *
         * @return {Block}
         */
      }, {
        key: 'anchorBlock',
        get: function get() {
          return this.selection.isUnset ? null : this.document.getClosestBlock(this.selection.anchorKey);
        }

        /**
         * Get the current focus text node's closest block parent.
         *
         * @return {Block}
         */
      }, {
        key: 'focusBlock',
        get: function get() {
          return this.selection.isUnset ? null : this.document.getClosestBlock(this.selection.focusKey);
        }

        /**
         * Get the current start text node's closest inline parent.
         *
         * @return {Inline}
         */
      }, {
        key: 'startInline',
        get: function get() {
          return this.selection.isUnset ? null : this.document.getClosestInline(this.selection.startKey);
        }

        /**
         * Get the current end text node's closest inline parent.
         *
         * @return {Inline}
         */
      }, {
        key: 'endInline',
        get: function get() {
          return this.selection.isUnset ? null : this.document.getClosestInline(this.selection.endKey);
        }

        /**
         * Get the current anchor text node's closest inline parent.
         *
         * @return {Inline}
         */
      }, {
        key: 'anchorInline',
        get: function get() {
          return this.selection.isUnset ? null : this.document.getClosestInline(this.selection.anchorKey);
        }

        /**
         * Get the current focus text node's closest inline parent.
         *
         * @return {Inline}
         */
      }, {
        key: 'focusInline',
        get: function get() {
          return this.selection.isUnset ? null : this.document.getClosestInline(this.selection.focusKey);
        }

        /**
         * Get the current start text node.
         *
         * @return {Text}
         */
      }, {
        key: 'startText',
        get: function get() {
          return this.selection.isUnset ? null : this.document.getDescendant(this.selection.startKey);
        }

        /**
         * Get the current end node.
         *
         * @return {Text}
         */
      }, {
        key: 'endText',
        get: function get() {
          return this.selection.isUnset ? null : this.document.getDescendant(this.selection.endKey);
        }

        /**
         * Get the current anchor node.
         *
         * @return {Text}
         */
      }, {
        key: 'anchorText',
        get: function get() {
          return this.selection.isUnset ? null : this.document.getDescendant(this.selection.anchorKey);
        }

        /**
         * Get the current focus node.
         *
         * @return {Text}
         */
      }, {
        key: 'focusText',
        get: function get() {
          return this.selection.isUnset ? null : this.document.getDescendant(this.selection.focusKey);
        }

        /**
         * Get the characters in the current selection.
         *
         * @return {List<Character>}
         */
      }, {
        key: 'characters',
        get: function get() {
          return this.selection.isUnset ? new _immutable.List() : this.document.getCharactersAtRange(this.selection);
        }

        /**
         * Get the marks of the current selection.
         *
         * @return {Set<Mark>}
         */
      }, {
        key: 'marks',
        get: function get() {
          return this.selection.isUnset ? new _immutable.Set() : this.selection.marks || this.document.getMarksAtRange(this.selection);
        }

        /**
         * Get the active marks of the current selection.
         *
         * @return {Set<Mark>}
         */
      }, {
        key: 'activeMarks',
        get: function get() {
          return this.selection.isUnset ? new _immutable.Set() : this.selection.marks || this.document.getActiveMarksAtRange(this.selection);
        }

        /**
         * Get the block nodes in the current selection.
         *
         * @return {List<Block>}
         */
      }, {
        key: 'blocks',
        get: function get() {
          return this.selection.isUnset ? new _immutable.List() : this.document.getBlocksAtRange(this.selection);
        }

        /**
         * Get the fragment of the current selection.
         *
         * @return {Document}
         */
      }, {
        key: 'fragment',
        get: function get() {
          return this.selection.isUnset ? _document2.default.create() : this.document.getFragmentAtRange(this.selection);
        }

        /**
         * Get the inline nodes in the current selection.
         *
         * @return {List<Inline>}
         */
      }, {
        key: 'inlines',
        get: function get() {
          return this.selection.isUnset ? new _immutable.List() : this.document.getInlinesAtRange(this.selection);
        }

        /**
         * Get the text nodes in the current selection.
         *
         * @return {List<Text>}
         */
      }, {
        key: 'texts',
        get: function get() {
          return this.selection.isUnset ? new _immutable.List() : this.document.getTextsAtRange(this.selection);
        }

        /**
         * Check whether the selection is empty.
         *
         * @return {Boolean}
         */
      }, {
        key: 'isEmpty',
        get: function get() {
          var startOffset = this.startOffset,
            endOffset = this.endOffset;
          if (this.isCollapsed) {
            return true;
          }
          if (endOffset != 0 && startOffset != 0) {
            return false;
          }
          return this.fragment.text.length == 0;
        }
      }], [{
        key: 'create',
        /**
         * Create a new `State` with `attrs`.
         *
         * @param {Object|State} attrs
         * @param {Object} options
         * @return {State}
         */

        value: function create() {
          var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          if (State.isState(attrs)) {
            return attrs;
          }
          if ((0, _isPlainObject2.default)(attrs)) {
            return State.fromJSON(attrs);
          }
          throw new Error('`State.create` only accepts objects or states, but you passed it: ' + attrs);
        }

        /**
         * Create a `State` from a JSON `object`.
         *
         * @param {Object} object
         * @param {Object} options
         *   @property {Boolean} normalize
         *   @property {Array} plugins
         * @return {State}
         */
      }, {
        key: 'fromJSON',
        value: function fromJSON(object) {
          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var _object$document = object.document,
            document = _object$document === undefined ? {} : _object$document,
            _object$selection = object.selection,
            selection = _object$selection === undefined ? {} : _object$selection;
          var data = new _immutable.Map();
          document = _document2.default.fromJSON(document);
          selection = _selection2.default.fromJSON(selection);

          // Allow plugins to set a default value for `data`.
          if (options.plugins) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;
            try {
              for (var _iterator = options.plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var plugin = _step.value;
                if (plugin.data) data = data.merge(plugin.data);
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          }

          // Then merge in the `data` provided.
          if ('data' in object) {
            data = data.merge(object.data);
          }
          if (selection.isUnset) {
            var text = document.getFirstText();
            if (text) selection = selection.collapseToStartOf(text);
          }
          var state = new State({
            data: data,
            document: document,
            selection: selection
          });
          if (options.normalize !== false) {
            state = state.change({
              save: false
            }).normalize(_core2.default).state;
          }
          return state;
        }

        /**
         * Alias `fromJS`.
         */
      }, {
        key: 'isState',
        /**
         * Check if a `value` is a `State`.
         *
         * @param {Any} value
         * @return {Boolean}
         */

        value: function isState(value) {
          return !!(value && value[_modelTypes2.default.STATE]);
        }
      }]);
      return State;
    }((0, _immutable.Record)(DEFAULTS));

    /**
     * Attach a pseudo-symbol for type checking.
     */

    State.fromJS = State.fromJSON;
    State.prototype[_modelTypes2.default.STATE] = true;

    /**
     * Export.
     */

    exports.default = State;

    /***/
  }), ( /* 580 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _apply = __webpack_require__(232);
    var _apply2 = _interopRequireDefault(_apply);
    var _invert = __webpack_require__(233);
    var _invert2 = _interopRequireDefault(_invert);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    /**
     * Export.
     *
     * @type {Object}
     */

    exports.default = {
      apply: _apply2.default,
      invert: _invert2.default
    };

    /***/
  }), ( /* 581 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    /**
     * Check if an `index` of a `text` node is in a `range`.
     *
     * @param {Number} index
     * @param {Text} text
     * @param {Selection} range
     * @return {Boolean}
     */

    function isIndexInRange(index, text, range) {
      var startKey = range.startKey,
        startOffset = range.startOffset,
        endKey = range.endKey,
        endOffset = range.endOffset;
      if (text.key == startKey && text.key == endKey) {
        return startOffset <= index && index < endOffset;
      } else if (text.key == startKey) {
        return startOffset <= index;
      } else if (text.key == endKey) {
        return index < endOffset;
      } else {
        return true;
      }
    }

    /**
     * Export.
     *
     * @type {Function}
     */

    exports.default = isIndexInRange;

    /***/
  }), ( /* 582 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    /**
     * Check if an `object` is a React component.
     *
     * @param {Object} object
     * @return {Boolean}
     */

    function isReactComponent(object) {
      return object && object.prototype && object.prototype.isReactComponent;
    }

    /**
     * Export.
     *
     * @type {Function}
     */

    exports.default = isReactComponent;

    /***/
  }), ( /* 583 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _esrever = __webpack_require__(444);

    /**
     * Surrogate pair start and end points.
     *
     * @type {Number}
     */

    var SURROGATE_START = 0xD800;
    var SURROGATE_END = 0xDFFF;

    /**
     * A regex to match space characters.
     *
     * @type {RegExp}
     */

    var SPACE = /\s/;

    /**
     * A regex to match chameleon characters, that count as word characters as long
     * as they are inside of a word.
     *
     * @type {RegExp}
     */

    var CHAMELEON = /['\u2018\u2019]/;

    /**
     * A regex that matches punctuation.
     *
     * @type {RegExp}
     */

    var PUNCTUATION = /[\u0021-\u0023\u0025-\u002A\u002C-\u002F\u003A\u003B\u003F\u0040\u005B-\u005D\u005F\u007B\u007D\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;

    /**
     * Is a character `code` in a surrogate character.
     *
     * @param {Number} code
     * @return {Boolean}
     */

    function isSurrogate(code) {
      return SURROGATE_START <= code && code <= SURROGATE_END;
    }

    /**
     * Is a character a word character? Needs the `remaining` characters too.
     *
     * @param {String} char
     * @param {String|Void} remaining
     * @return {Boolean}
     */

    function isWord(char, remaining) {
      if (SPACE.test(char)) return false;

      // If it's a chameleon character, recurse to see if the next one is or not.
      if (CHAMELEON.test(char)) {
        var next = remaining.charAt(0);
        var length = getCharLength(next);
        next = remaining.slice(0, length);
        var rest = remaining.slice(length);
        if (isWord(next, rest)) return true;
      }
      if (PUNCTUATION.test(char)) return false;
      return true;
    }

    /**
     * Get the length of a `character`.
     *
     * @param {String} char
     * @return {Number}
     */

    function getCharLength(char) {
      return isSurrogate(char.charCodeAt(0)) ? 2 : 1;
    }

    /**
     * Get the offset to the end of the first character in `text`.
     *
     * @param {String} text
     * @return {Number}
     */

    function getCharOffset(text) {
      var char = text.charAt(0);
      return getCharLength(char);
    }

    /**
     * Get the offset to the end of the character before an `offset` in `text`.
     *
     * @param {String} text
     * @param {Number} offset
     * @return {Number}
     */

    function getCharOffsetBackward(text, offset) {
      text = text.slice(0, offset);
      text = (0, _esrever.reverse)(text);
      return getCharOffset(text);
    }

    /**
     * Get the offset to the end of the character after an `offset` in `text`.
     *
     * @param {String} text
     * @param {Number} offset
     * @return {Number}
     */

    function getCharOffsetForward(text, offset) {
      text = text.slice(offset);
      return getCharOffset(text);
    }

    /**
     * Get the offset to the end of the first word in `text`.
     *
     * @param {String} text
     * @return {Number}
     */

    function getWordOffset(text) {
      var length = 0;
      var i = 0;
      var started = false;
      var char = void 0;
      while (char = text.charAt(i)) {
        var l = getCharLength(char);
        char = text.slice(i, i + l);
        var rest = text.slice(i + l);
        if (isWord(char, rest)) {
          started = true;
          length += l;
        } else if (!started) {
          length += l;
        } else {
          break;
        }
        i += l;
      }
      return length;
    }

    /**
     * Get the offset to the end of the word before an `offset` in `text`.
     *
     * @param {String} text
     * @param {Number} offset
     * @return {Number}
     */

    function getWordOffsetBackward(text, offset) {
      text = text.slice(0, offset);
      text = (0, _esrever.reverse)(text);
      var o = getWordOffset(text);
      return o;
    }

    /**
     * Get the offset to the end of the word after an `offset` in `text`.
     *
     * @param {String} text
     * @param {Number} offset
     * @return {Number}
     */

    function getWordOffsetForward(text, offset) {
      text = text.slice(offset);
      var o = getWordOffset(text);
      return o;
    }

    /**
     * Export.
     *
     * @type {Object}
     */

    exports.default = {
      getCharOffsetForward: getCharOffsetForward,
      getCharOffsetBackward: getCharOffsetBackward,
      getWordOffsetBackward: getWordOffsetBackward,
      getWordOffsetForward: getWordOffsetForward
    };

    /***/
  }), ( /* 584 */
  /***/function (module, exports, __webpack_require__) {
    var getNative = __webpack_require__(44),
      root = __webpack_require__(25);

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(root, 'DataView');
    module.exports = DataView;

    /***/
  }), ( /* 585 */
  /***/function (module, exports, __webpack_require__) {
    var hashClear = __webpack_require__(632),
      hashDelete = __webpack_require__(633),
      hashGet = __webpack_require__(634),
      hashHas = __webpack_require__(635),
      hashSet = __webpack_require__(636);

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
        length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    module.exports = Hash;

    /***/
  }), ( /* 586 */
  /***/function (module, exports, __webpack_require__) {
    var getNative = __webpack_require__(44),
      root = __webpack_require__(25);

    /* Built-in method references that are verified to be native. */
    var Promise = getNative(root, 'Promise');
    module.exports = Promise;

    /***/
  }), ( /* 587 */
  /***/function (module, exports, __webpack_require__) {
    var getNative = __webpack_require__(44),
      root = __webpack_require__(25);

    /* Built-in method references that are verified to be native. */
    var Set = getNative(root, 'Set');
    module.exports = Set;

    /***/
  }), ( /* 588 */
  /***/function (module, exports, __webpack_require__) {
    var MapCache = __webpack_require__(152),
      setCacheAdd = __webpack_require__(658),
      setCacheHas = __webpack_require__(659);

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
        length = values == null ? 0 : values.length;
      this.__data__ = new MapCache();
      while (++index < length) {
        this.add(values[index]);
      }
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;
    module.exports = SetCache;

    /***/
  }), ( /* 589 */
  /***/function (module, exports, __webpack_require__) {
    var root = __webpack_require__(25);

    /** Built-in value references. */
    var Uint8Array = root.Uint8Array;
    module.exports = Uint8Array;

    /***/
  }), ( /* 590 */
  /***/function (module, exports, __webpack_require__) {
    var getNative = __webpack_require__(44),
      root = __webpack_require__(25);

    /* Built-in method references that are verified to be native. */
    var WeakMap = getNative(root, 'WeakMap');
    module.exports = WeakMap;

    /***/
  }), ( /* 591 */
  /***/function (module, exports) {
    /**
     * A faster alternative to `Function#apply`, this function invokes `func`
     * with the `this` binding of `thisArg` and the arguments of `args`.
     *
     * @private
     * @param {Function} func The function to invoke.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} args The arguments to invoke `func` with.
     * @returns {*} Returns the result of `func`.
     */
    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);
        case 1:
          return func.call(thisArg, args[0]);
        case 2:
          return func.call(thisArg, args[0], args[1]);
        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }
    module.exports = apply;

    /***/
  }), ( /* 592 */
  /***/function (module, exports) {
    /**
     * A specialized version of `_.filter` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function arrayFilter(array, predicate) {
      var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result[resIndex++] = value;
        }
      }
      return result;
    }
    module.exports = arrayFilter;

    /***/
  }), ( /* 593 */
  /***/function (module, exports, __webpack_require__) {
    var baseTimes = __webpack_require__(616),
      isArguments = __webpack_require__(158),
      isArray = __webpack_require__(26),
      isBuffer = __webpack_require__(246),
      isIndex = __webpack_require__(155),
      isTypedArray = __webpack_require__(248);

    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
        isArg = !isArr && isArguments(value),
        isBuff = !isArr && !isArg && isBuffer(value),
        isType = !isArr && !isArg && !isBuff && isTypedArray(value),
        skipIndexes = isArr || isArg || isBuff || isType,
        result = skipIndexes ? baseTimes(value.length, String) : [],
        length = result.length;
      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
        // Safari 9 has enumerable `arguments.length` in strict mode.
        key == 'length' ||
        // Node.js 0.10 has enumerable non-index properties on buffers.
        isBuff && (key == 'offset' || key == 'parent') ||
        // PhantomJS 2 has enumerable non-index properties on typed arrays.
        isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
        // Skip index properties.
        isIndex(key, length)))) {
          result.push(key);
        }
      }
      return result;
    }
    module.exports = arrayLikeKeys;

    /***/
  }), ( /* 594 */
  /***/function (module, exports) {
    /**
     * A specialized version of `_.map` for arrays without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function arrayMap(array, iteratee) {
      var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);
      while (++index < length) {
        result[index] = iteratee(array[index], index, array);
      }
      return result;
    }
    module.exports = arrayMap;

    /***/
  }), ( /* 595 */
  /***/function (module, exports) {
    /**
     * A specialized version of `_.some` for arrays without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function arraySome(array, predicate) {
      var index = -1,
        length = array == null ? 0 : array.length;
      while (++index < length) {
        if (predicate(array[index], index, array)) {
          return true;
        }
      }
      return false;
    }
    module.exports = arraySome;

    /***/
  }), ( /* 596 */
  /***/function (module, exports, __webpack_require__) {
    var baseAssignValue = __webpack_require__(597),
      eq = __webpack_require__(157);

    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
        baseAssignValue(object, key, value);
      }
    }
    module.exports = assignValue;

    /***/
  }), ( /* 597 */
  /***/function (module, exports, __webpack_require__) {
    var defineProperty = __webpack_require__(237);

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }
    module.exports = baseAssignValue;

    /***/
  }), ( /* 598 */
  /***/function (module, exports) {
    /**
     * The base implementation of `_.findIndex` and `_.findLastIndex` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} predicate The function invoked per iteration.
     * @param {number} fromIndex The index to search from.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function baseFindIndex(array, predicate, fromIndex, fromRight) {
      var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);
      while (fromRight ? index-- : ++index < length) {
        if (predicate(array[index], index, array)) {
          return index;
        }
      }
      return -1;
    }
    module.exports = baseFindIndex;

    /***/
  }), ( /* 599 */
  /***/function (module, exports, __webpack_require__) {
    var arrayPush = __webpack_require__(235),
      isFlattenable = __webpack_require__(637);

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
        length = array.length;
      predicate || (predicate = isFlattenable);
      result || (result = []);
      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }
    module.exports = baseFlatten;

    /***/
  }), ( /* 600 */
  /***/function (module, exports, __webpack_require__) {
    var arrayPush = __webpack_require__(235),
      isArray = __webpack_require__(26);

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }
    module.exports = baseGetAllKeys;

    /***/
  }), ( /* 601 */
  /***/function (module, exports) {
    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }
    module.exports = baseHasIn;

    /***/
  }), ( /* 602 */
  /***/function (module, exports, __webpack_require__) {
    var baseGetTag = __webpack_require__(76),
      isObjectLike = __webpack_require__(79);

    /** `Object#toString` result references. */
    var argsTag = '[object Arguments]';

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }
    module.exports = baseIsArguments;

    /***/
  }), ( /* 603 */
  /***/function (module, exports, __webpack_require__) {
    var Stack = __webpack_require__(234),
      equalArrays = __webpack_require__(238),
      equalByTag = __webpack_require__(622),
      equalObjects = __webpack_require__(623),
      getTag = __webpack_require__(629),
      isArray = __webpack_require__(26),
      isBuffer = __webpack_require__(246),
      isTypedArray = __webpack_require__(248);

    /** Used to compose bitmasks for value comparisons. */
    var COMPARE_PARTIAL_FLAG = 1;

    /** `Object#toString` result references. */
    var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      objectTag = '[object Object]';

    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
        othIsArr = isArray(other),
        objTag = objIsArr ? arrayTag : getTag(object),
        othTag = othIsArr ? arrayTag : getTag(other);
      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;
      var objIsObj = objTag == objectTag,
        othIsObj = othTag == objectTag,
        isSameTag = objTag == othTag;
      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack());
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
          othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
            othUnwrapped = othIsWrapped ? other.value() : other;
          stack || (stack = new Stack());
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack());
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }
    module.exports = baseIsEqualDeep;

    /***/
  }), ( /* 604 */
  /***/function (module, exports, __webpack_require__) {
    var Stack = __webpack_require__(234),
      baseIsEqual = __webpack_require__(154);

    /** Used to compose bitmasks for value comparisons. */
    var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
        length = index,
        noCustomizer = !customizer;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
          objValue = object[key],
          srcValue = data[1];
        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack();
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
            return false;
          }
        }
      }
      return true;
    }
    module.exports = baseIsMatch;

    /***/
  }), ( /* 605 */
  /***/function (module, exports, __webpack_require__) {
    var isFunction = __webpack_require__(247),
      isMasked = __webpack_require__(639),
      isObject = __webpack_require__(78),
      toSource = __webpack_require__(242);

    /**
     * Used to match `RegExp`
     * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
     */
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

    /** Used to detect host constructors (Safari). */
    var reIsHostCtor = /^\[object .+?Constructor\]$/;

    /** Used for built-in method references. */
    var funcProto = Function.prototype,
      objectProto = Object.prototype;

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }
    module.exports = baseIsNative;

    /***/
  }), ( /* 606 */
  /***/function (module, exports, __webpack_require__) {
    var baseGetTag = __webpack_require__(76),
      isLength = __webpack_require__(159),
      isObjectLike = __webpack_require__(79);

    /** `Object#toString` result references. */
    var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      objectTag = '[object Object]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      weakMapTag = '[object WeakMap]';
    var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

    /** Used to identify `toStringTag` values of typed arrays. */
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }
    module.exports = baseIsTypedArray;

    /***/
  }), ( /* 607 */
  /***/function (module, exports, __webpack_require__) {
    var isPrototype = __webpack_require__(640),
      nativeKeys = __webpack_require__(653);

    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }
    module.exports = baseKeys;

    /***/
  }), ( /* 608 */
  /***/function (module, exports, __webpack_require__) {
    var baseIsMatch = __webpack_require__(604),
      getMatchData = __webpack_require__(626),
      matchesStrictComparable = __webpack_require__(241);

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function (object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }
    module.exports = baseMatches;

    /***/
  }), ( /* 609 */
  /***/function (module, exports, __webpack_require__) {
    var baseIsEqual = __webpack_require__(154),
      get = __webpack_require__(673),
      hasIn = __webpack_require__(243),
      isKey = __webpack_require__(156),
      isStrictComparable = __webpack_require__(240),
      matchesStrictComparable = __webpack_require__(241),
      toKey = __webpack_require__(77);

    /** Used to compose bitmasks for value comparisons. */
    var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function (object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }
    module.exports = baseMatchesProperty;

    /***/
  }), ( /* 610 */
  /***/function (module, exports, __webpack_require__) {
    var basePickBy = __webpack_require__(611),
      hasIn = __webpack_require__(243);

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function (value, path) {
        return hasIn(object, path);
      });
    }
    module.exports = basePick;

    /***/
  }), ( /* 611 */
  /***/function (module, exports, __webpack_require__) {
    var baseGet = __webpack_require__(153),
      baseSet = __webpack_require__(614),
      castPath = __webpack_require__(102);

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
        length = paths.length,
        result = {};
      while (++index < length) {
        var path = paths[index],
          value = baseGet(object, path);
        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }
    module.exports = basePickBy;

    /***/
  }), ( /* 612 */
  /***/function (module, exports) {
    /**
     * The base implementation of `_.property` without support for deep paths.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function baseProperty(key) {
      return function (object) {
        return object == null ? undefined : object[key];
      };
    }
    module.exports = baseProperty;

    /***/
  }), ( /* 613 */
  /***/function (module, exports, __webpack_require__) {
    var baseGet = __webpack_require__(153);

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function (object) {
        return baseGet(object, path);
      };
    }
    module.exports = basePropertyDeep;

    /***/
  }), ( /* 614 */
  /***/function (module, exports, __webpack_require__) {
    var assignValue = __webpack_require__(596),
      castPath = __webpack_require__(102),
      isIndex = __webpack_require__(155),
      isObject = __webpack_require__(78),
      toKey = __webpack_require__(77);

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);
      var index = -1,
        length = path.length,
        lastIndex = length - 1,
        nested = object;
      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
          newValue = value;
        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }
    module.exports = baseSet;

    /***/
  }), ( /* 615 */
  /***/function (module, exports, __webpack_require__) {
    var constant = __webpack_require__(669),
      defineProperty = __webpack_require__(237),
      identity = __webpack_require__(244);

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function (func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };
    module.exports = baseSetToString;

    /***/
  }), ( /* 616 */
  /***/function (module, exports) {
    /**
     * The base implementation of `_.times` without support for iteratee shorthands
     * or max array length checks.
     *
     * @private
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     */
    function baseTimes(n, iteratee) {
      var index = -1,
        result = Array(n);
      while (++index < n) {
        result[index] = iteratee(index);
      }
      return result;
    }
    module.exports = baseTimes;

    /***/
  }), ( /* 617 */
  /***/function (module, exports, __webpack_require__) {
    var Symbol = __webpack_require__(75),
      arrayMap = __webpack_require__(594),
      isArray = __webpack_require__(26),
      isSymbol = __webpack_require__(105);

    /** Used as references for various `Number` constants. */
    var INFINITY = 1 / 0;

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
      symbolToString = symbolProto ? symbolProto.toString : undefined;

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = value + '';
      return result == '0' && 1 / value == -INFINITY ? '-0' : result;
    }
    module.exports = baseToString;

    /***/
  }), ( /* 618 */
  /***/function (module, exports) {
    /**
     * The base implementation of `_.unary` without support for storing metadata.
     *
     * @private
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     */
    function baseUnary(func) {
      return function (value) {
        return func(value);
      };
    }
    module.exports = baseUnary;

    /***/
  }), ( /* 619 */
  /***/function (module, exports) {
    /**
     * Checks if a `cache` value for `key` exists.
     *
     * @private
     * @param {Object} cache The cache to query.
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function cacheHas(cache, key) {
      return cache.has(key);
    }
    module.exports = cacheHas;

    /***/
  }), ( /* 620 */
  /***/function (module, exports, __webpack_require__) {
    var root = __webpack_require__(25);

    /** Used to detect overreaching core-js shims. */
    var coreJsData = root['__core-js_shared__'];
    module.exports = coreJsData;

    /***/
  }), ( /* 621 */
  /***/function (module, exports, __webpack_require__) {
    var baseIteratee = __webpack_require__(236),
      isArrayLike = __webpack_require__(245),
      keys = __webpack_require__(160);

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function (collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = baseIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function predicate(key) {
            return iteratee(iterable[key], key, iterable);
          };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }
    module.exports = createFind;

    /***/
  }), ( /* 622 */
  /***/function (module, exports, __webpack_require__) {
    var Symbol = __webpack_require__(75),
      Uint8Array = __webpack_require__(589),
      eq = __webpack_require__(157),
      equalArrays = __webpack_require__(238),
      mapToArray = __webpack_require__(651),
      setToArray = __webpack_require__(660);

    /** Used to compose bitmasks for value comparisons. */
    var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

    /** `Object#toString` result references. */
    var boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]';
    var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]';

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
      symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;
        case arrayBufferTag:
          if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;
        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);
        case errorTag:
          return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == other + '';
        case mapTag:
          var convert = mapToArray;
        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);
          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;
        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }
    module.exports = equalByTag;

    /***/
  }), ( /* 623 */
  /***/function (module, exports, __webpack_require__) {
    var getAllKeys = __webpack_require__(625);

    /** Used to compose bitmasks for value comparisons. */
    var COMPARE_PARTIAL_FLAG = 1;

    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
        objProps = getAllKeys(object),
        objLength = objProps.length,
        othProps = getAllKeys(other),
        othLength = othProps.length;
      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);
      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
          othValue = other[key];
        if (customizer) {
          var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
          othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }
    module.exports = equalObjects;

    /***/
  }), ( /* 624 */
  /***/function (module, exports, __webpack_require__) {
    var flatten = __webpack_require__(672),
      overRest = __webpack_require__(657),
      setToString = __webpack_require__(661);

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }
    module.exports = flatRest;

    /***/
  }), ( /* 625 */
  /***/function (module, exports, __webpack_require__) {
    var baseGetAllKeys = __webpack_require__(600),
      getSymbols = __webpack_require__(628),
      keys = __webpack_require__(160);

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }
    module.exports = getAllKeys;

    /***/
  }), ( /* 626 */
  /***/function (module, exports, __webpack_require__) {
    var isStrictComparable = __webpack_require__(240),
      keys = __webpack_require__(160);

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
        length = result.length;
      while (length--) {
        var key = result[length],
          value = object[key];
        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }
    module.exports = getMatchData;

    /***/
  }), ( /* 627 */
  /***/function (module, exports, __webpack_require__) {
    var Symbol = __webpack_require__(75);

    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Built-in value references. */
    var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
        tag = value[symToStringTag];
      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}
      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }
    module.exports = getRawTag;

    /***/
  }), ( /* 628 */
  /***/function (module, exports, __webpack_require__) {
    var arrayFilter = __webpack_require__(592),
      stubArray = __webpack_require__(677);

    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /** Built-in value references. */
    var propertyIsEnumerable = objectProto.propertyIsEnumerable;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeGetSymbols = Object.getOwnPropertySymbols;

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function (symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };
    module.exports = getSymbols;

    /***/
  }), ( /* 629 */
  /***/function (module, exports, __webpack_require__) {
    var DataView = __webpack_require__(584),
      Map = __webpack_require__(151),
      Promise = __webpack_require__(586),
      Set = __webpack_require__(587),
      WeakMap = __webpack_require__(590),
      baseGetTag = __webpack_require__(76),
      toSource = __webpack_require__(242);

    /** `Object#toString` result references. */
    var mapTag = '[object Map]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      setTag = '[object Set]',
      weakMapTag = '[object WeakMap]';
    var dataViewTag = '[object DataView]';

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
      mapCtorString = toSource(Map),
      promiseCtorString = toSource(Promise),
      setCtorString = toSource(Set),
      weakMapCtorString = toSource(WeakMap);

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
      getTag = function getTag(value) {
        var result = baseGetTag(value),
          Ctor = result == objectTag ? value.constructor : undefined,
          ctorString = Ctor ? toSource(Ctor) : '';
        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString:
              return dataViewTag;
            case mapCtorString:
              return mapTag;
            case promiseCtorString:
              return promiseTag;
            case setCtorString:
              return setTag;
            case weakMapCtorString:
              return weakMapTag;
          }
        }
        return result;
      };
    }
    module.exports = getTag;

    /***/
  }), ( /* 630 */
  /***/function (module, exports) {
    /**
     * Gets the value at `key` of `object`.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function getValue(object, key) {
      return object == null ? undefined : object[key];
    }
    module.exports = getValue;

    /***/
  }), ( /* 631 */
  /***/function (module, exports, __webpack_require__) {
    var castPath = __webpack_require__(102),
      isArguments = __webpack_require__(158),
      isArray = __webpack_require__(26),
      isIndex = __webpack_require__(155),
      isLength = __webpack_require__(159),
      toKey = __webpack_require__(77);

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);
      var index = -1,
        length = path.length,
        result = false;
      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
    }
    module.exports = hasPath;

    /***/
  }), ( /* 632 */
  /***/function (module, exports, __webpack_require__) {
    var nativeCreate = __webpack_require__(104);

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }
    module.exports = hashClear;

    /***/
  }), ( /* 633 */
  /***/function (module, exports) {
    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }
    module.exports = hashDelete;

    /***/
  }), ( /* 634 */
  /***/function (module, exports, __webpack_require__) {
    var nativeCreate = __webpack_require__(104);

    /** Used to stand-in for `undefined` hash values. */
    var HASH_UNDEFINED = '__lodash_hash_undefined__';

    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }
    module.exports = hashGet;

    /***/
  }), ( /* 635 */
  /***/function (module, exports, __webpack_require__) {
    var nativeCreate = __webpack_require__(104);

    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
    }
    module.exports = hashHas;

    /***/
  }), ( /* 636 */
  /***/function (module, exports, __webpack_require__) {
    var nativeCreate = __webpack_require__(104);

    /** Used to stand-in for `undefined` hash values. */
    var HASH_UNDEFINED = '__lodash_hash_undefined__';

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
      return this;
    }
    module.exports = hashSet;

    /***/
  }), ( /* 637 */
  /***/function (module, exports, __webpack_require__) {
    var Symbol = __webpack_require__(75),
      isArguments = __webpack_require__(158),
      isArray = __webpack_require__(26);

    /** Built-in value references. */
    var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
    }
    module.exports = isFlattenable;

    /***/
  }), ( /* 638 */
  /***/function (module, exports) {
    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
    }
    module.exports = isKeyable;

    /***/
  }), ( /* 639 */
  /***/function (module, exports, __webpack_require__) {
    var coreJsData = __webpack_require__(620);

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = function () {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? 'Symbol(src)_1.' + uid : '';
    }();

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    module.exports = isMasked;

    /***/
  }), ( /* 640 */
  /***/function (module, exports) {
    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
        proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
      return value === proto;
    }
    module.exports = isPrototype;

    /***/
  }), ( /* 641 */
  /***/function (module, exports) {
    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }
    module.exports = listCacheClear;

    /***/
  }), ( /* 642 */
  /***/function (module, exports, __webpack_require__) {
    var assocIndexOf = __webpack_require__(101);

    /** Used for built-in method references. */
    var arrayProto = Array.prototype;

    /** Built-in value references. */
    var splice = arrayProto.splice;

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
        index = assocIndexOf(data, key);
      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }
    module.exports = listCacheDelete;

    /***/
  }), ( /* 643 */
  /***/function (module, exports, __webpack_require__) {
    var assocIndexOf = __webpack_require__(101);

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
        index = assocIndexOf(data, key);
      return index < 0 ? undefined : data[index][1];
    }
    module.exports = listCacheGet;

    /***/
  }), ( /* 644 */
  /***/function (module, exports, __webpack_require__) {
    var assocIndexOf = __webpack_require__(101);

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }
    module.exports = listCacheHas;

    /***/
  }), ( /* 645 */
  /***/function (module, exports, __webpack_require__) {
    var assocIndexOf = __webpack_require__(101);

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
        index = assocIndexOf(data, key);
      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }
    module.exports = listCacheSet;

    /***/
  }), ( /* 646 */
  /***/function (module, exports, __webpack_require__) {
    var Hash = __webpack_require__(585),
      ListCache = __webpack_require__(100),
      Map = __webpack_require__(151);

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash(),
        'map': new (Map || ListCache)(),
        'string': new Hash()
      };
    }
    module.exports = mapCacheClear;

    /***/
  }), ( /* 647 */
  /***/function (module, exports, __webpack_require__) {
    var getMapData = __webpack_require__(103);

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }
    module.exports = mapCacheDelete;

    /***/
  }), ( /* 648 */
  /***/function (module, exports, __webpack_require__) {
    var getMapData = __webpack_require__(103);

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }
    module.exports = mapCacheGet;

    /***/
  }), ( /* 649 */
  /***/function (module, exports, __webpack_require__) {
    var getMapData = __webpack_require__(103);

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }
    module.exports = mapCacheHas;

    /***/
  }), ( /* 650 */
  /***/function (module, exports, __webpack_require__) {
    var getMapData = __webpack_require__(103);

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
        size = data.size;
      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }
    module.exports = mapCacheSet;

    /***/
  }), ( /* 651 */
  /***/function (module, exports) {
    /**
     * Converts `map` to its key-value pairs.
     *
     * @private
     * @param {Object} map The map to convert.
     * @returns {Array} Returns the key-value pairs.
     */
    function mapToArray(map) {
      var index = -1,
        result = Array(map.size);
      map.forEach(function (value, key) {
        result[++index] = [key, value];
      });
      return result;
    }
    module.exports = mapToArray;

    /***/
  }), ( /* 652 */
  /***/function (module, exports, __webpack_require__) {
    var memoize = __webpack_require__(675);

    /** Used as the maximum memoize cache size. */
    var MAX_MEMOIZE_SIZE = 500;

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function (key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });
      var cache = result.cache;
      return result;
    }
    module.exports = memoizeCapped;

    /***/
  }), ( /* 653 */
  /***/function (module, exports, __webpack_require__) {
    var overArg = __webpack_require__(656);

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeKeys = overArg(Object.keys, Object);
    module.exports = nativeKeys;

    /***/
  }), ( /* 654 */
  /***/function (module, exports, __webpack_require__) {
    /* WEBPACK VAR INJECTION */(function (module) {
      var freeGlobal = __webpack_require__(239);

      /** Detect free variable `exports`. */
      var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

      /** Detect free variable `module`. */
      var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

      /** Detect the popular CommonJS extension `module.exports`. */
      var moduleExports = freeModule && freeModule.exports === freeExports;

      /** Detect free variable `process` from Node.js. */
      var freeProcess = moduleExports && freeGlobal.process;

      /** Used to access faster Node.js helpers. */
      var nodeUtil = function () {
        try {
          // Use `util.types` for Node.js 10+.
          var types = freeModule && freeModule.require && freeModule.require('util').types;
          if (types) {
            return types;
          }

          // Legacy `process.binding('util')` for Node.js < 10.
          return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
      }();
      module.exports = nodeUtil;

      /* WEBPACK VAR INJECTION */
    }).call(exports, __webpack_require__(106)(module));

    /***/
  }), ( /* 655 */
  /***/function (module, exports) {
    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }
    module.exports = objectToString;

    /***/
  }), ( /* 656 */
  /***/function (module, exports) {
    /**
     * Creates a unary function that invokes `func` with its argument transformed.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {Function} transform The argument transform.
     * @returns {Function} Returns the new function.
     */
    function overArg(func, transform) {
      return function (arg) {
        return func(transform(arg));
      };
    }
    module.exports = overArg;

    /***/
  }), ( /* 657 */
  /***/function (module, exports, __webpack_require__) {
    var apply = __webpack_require__(591);

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeMax = Math.max;

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? func.length - 1 : start, 0);
      return function () {
        var args = arguments,
          index = -1,
          length = nativeMax(args.length - start, 0),
          array = Array(length);
        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }
    module.exports = overRest;

    /***/
  }), ( /* 658 */
  /***/function (module, exports) {
    /** Used to stand-in for `undefined` hash values. */
    var HASH_UNDEFINED = '__lodash_hash_undefined__';

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }
    module.exports = setCacheAdd;

    /***/
  }), ( /* 659 */
  /***/function (module, exports) {
    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }
    module.exports = setCacheHas;

    /***/
  }), ( /* 660 */
  /***/function (module, exports) {
    /**
     * Converts `set` to an array of its values.
     *
     * @private
     * @param {Object} set The set to convert.
     * @returns {Array} Returns the values.
     */
    function setToArray(set) {
      var index = -1,
        result = Array(set.size);
      set.forEach(function (value) {
        result[++index] = value;
      });
      return result;
    }
    module.exports = setToArray;

    /***/
  }), ( /* 661 */
  /***/function (module, exports, __webpack_require__) {
    var baseSetToString = __webpack_require__(615),
      shortOut = __webpack_require__(662);

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);
    module.exports = setToString;

    /***/
  }), ( /* 662 */
  /***/function (module, exports) {
    /** Used to detect hot functions by number of calls within a span of milliseconds. */
    var HOT_COUNT = 800,
      HOT_SPAN = 16;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeNow = Date.now;

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
        lastCalled = 0;
      return function () {
        var stamp = nativeNow(),
          remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }
    module.exports = shortOut;

    /***/
  }), ( /* 663 */
  /***/function (module, exports, __webpack_require__) {
    var ListCache = __webpack_require__(100);

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache();
      this.size = 0;
    }
    module.exports = stackClear;

    /***/
  }), ( /* 664 */
  /***/function (module, exports) {
    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
        result = data['delete'](key);
      this.size = data.size;
      return result;
    }
    module.exports = stackDelete;

    /***/
  }), ( /* 665 */
  /***/function (module, exports) {
    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }
    module.exports = stackGet;

    /***/
  }), ( /* 666 */
  /***/function (module, exports) {
    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }
    module.exports = stackHas;

    /***/
  }), ( /* 667 */
  /***/function (module, exports, __webpack_require__) {
    var ListCache = __webpack_require__(100),
      Map = __webpack_require__(151),
      MapCache = __webpack_require__(152);

    /** Used as the size to enable large array optimizations. */
    var LARGE_ARRAY_SIZE = 200;

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }
    module.exports = stackSet;

    /***/
  }), ( /* 668 */
  /***/function (module, exports, __webpack_require__) {
    var memoizeCapped = __webpack_require__(652);

    /** Used to match property names within property paths. */
    var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

    /** Used to match backslashes in property paths. */
    var reEscapeChar = /\\(\\)?/g;

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function (string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function (match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
      });
      return result;
    });
    module.exports = stringToPath;

    /***/
  }), ( /* 669 */
  /***/function (module, exports) {
    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function () {
        return value;
      };
    }
    module.exports = constant;

    /***/
  }), ( /* 670 */
  /***/function (module, exports, __webpack_require__) {
    var createFind = __webpack_require__(621),
      findIndex = __webpack_require__(671);

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);
    module.exports = find;

    /***/
  }), ( /* 671 */
  /***/function (module, exports, __webpack_require__) {
    var baseFindIndex = __webpack_require__(598),
      baseIteratee = __webpack_require__(236),
      toInteger = __webpack_require__(680);

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeMax = Math.max;

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, baseIteratee(predicate, 3), index);
    }
    module.exports = findIndex;

    /***/
  }), ( /* 672 */
  /***/function (module, exports, __webpack_require__) {
    var baseFlatten = __webpack_require__(599);

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }
    module.exports = flatten;

    /***/
  }), ( /* 673 */
  /***/function (module, exports, __webpack_require__) {
    var baseGet = __webpack_require__(153);

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }
    module.exports = get;

    /***/
  }), ( /* 674 */
  /***/function (module, exports, __webpack_require__) {
    var baseIsEqual = __webpack_require__(154);

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }
    module.exports = isEqual;

    /***/
  }), ( /* 675 */
  /***/function (module, exports, __webpack_require__) {
    var MapCache = __webpack_require__(152);

    /** Error message constants. */
    var FUNC_ERROR_TEXT = 'Expected a function';

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function memoized() {
        var args = arguments,
          key = resolver ? resolver.apply(this, args) : args[0],
          cache = memoized.cache;
        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache)();
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;
    module.exports = memoize;

    /***/
  }), ( /* 676 */
  /***/function (module, exports, __webpack_require__) {
    var baseProperty = __webpack_require__(612),
      basePropertyDeep = __webpack_require__(613),
      isKey = __webpack_require__(156),
      toKey = __webpack_require__(77);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }
    module.exports = property;

    /***/
  }), ( /* 677 */
  /***/function (module, exports) {
    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }
    module.exports = stubArray;

    /***/
  }), ( /* 678 */
  /***/function (module, exports) {
    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }
    module.exports = stubFalse;

    /***/
  }), ( /* 679 */
  /***/function (module, exports, __webpack_require__) {
    var toNumber = __webpack_require__(681);

    /** Used as references for various `Number` constants. */
    var INFINITY = 1 / 0,
      MAX_INTEGER = 1.7976931348623157e+308;

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }
    module.exports = toFinite;

    /***/
  }), ( /* 680 */
  /***/function (module, exports, __webpack_require__) {
    var toFinite = __webpack_require__(679);

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
        remainder = result % 1;
      return result === result ? remainder ? result - remainder : result : 0;
    }
    module.exports = toInteger;

    /***/
  }), ( /* 681 */
  /***/function (module, exports, __webpack_require__) {
    var isObject = __webpack_require__(78),
      isSymbol = __webpack_require__(105);

    /** Used as references for various `Number` constants. */
    var NAN = 0 / 0;

    /** Used to match leading and trailing whitespace. */
    var reTrim = /^\s+|\s+$/g;

    /** Used to detect bad signed hexadecimal string values. */
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

    /** Used to detect binary string values. */
    var reIsBinary = /^0b[01]+$/i;

    /** Used to detect octal string values. */
    var reIsOctal = /^0o[0-7]+$/i;

    /** Built-in method references without a dependency on `root`. */
    var freeParseInt = parseInt;

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? other + '' : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
    }
    module.exports = toNumber;

    /***/
  }), ( /* 682 */
  /***/function (module, exports, __webpack_require__) {
    var baseToString = __webpack_require__(617);

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }
    module.exports = toString;

    /***/
  }), ( /* 683 */
  /***/function (module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag

    // load the styles
    var content = __webpack_require__(385);
    if (typeof content === 'string') content = [[module.i, content, '']];
    // add the styles to the DOM
    var update = __webpack_require__(249)(content, {});
    if (content.locals) module.exports = content.locals;
    // Hot Module Replacement
    if (false) {
      // When the styles change, update the <style> tags
      if (!content.locals) {
        module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js??ref--3-2!../../../../node_modules/less-loader/index.js??ref--3-3!./PlainMarkdownInput.less", function () {
          var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js??ref--3-2!../../../../node_modules/less-loader/index.js??ref--3-3!./PlainMarkdownInput.less");
          if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];
          update(newContent);
        });
      }
      // When the module is disposed, remove the <style> tags
      module.hot.dispose(function () {
        update();
      });
    }

    /***/
  }), ( /* 684 */
  /***/function (module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag

    // load the styles
    var content = __webpack_require__(386);
    if (typeof content === 'string') content = [[module.i, content, '']];
    // add the styles to the DOM
    var update = __webpack_require__(249)(content, {});
    if (content.locals) module.exports = content.locals;
    // Hot Module Replacement
    if (false) {
      // When the styles change, update the <style> tags
      if (!content.locals) {
        module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/postcss-loader/index.js??ref--3-2!../../../../../../node_modules/less-loader/index.js??ref--3-3!./Autocomplete.less", function () {
          var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/postcss-loader/index.js??ref--3-2!../../../../../../node_modules/less-loader/index.js??ref--3-3!./Autocomplete.less");
          if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];
          update(newContent);
        });
      }
      // When the module is disposed, remove the <style> tags
      module.hot.dispose(function () {
        update();
      });
    }

    /***/
  }), ( /* 685 */
  /***/function (module, exports) {
    var toString = Object.prototype.toString;
    module.exports = function (val) {
      switch (toString.call(val)) {
        case '[object Function]':
          return 'function';
        case '[object Date]':
          return 'date';
        case '[object RegExp]':
          return 'regexp';
        case '[object Arguments]':
          return 'arguments';
        case '[object Array]':
          return 'array';
        case '[object String]':
          return 'string';
      }
      if (typeof val == 'object' && val && typeof val.length == 'number') {
        try {
          if (typeof val.callee == 'function') return 'arguments';
        } catch (ex) {
          if (ex instanceof TypeError) {
            return 'arguments';
          }
        }
      }
      if (val === null) return 'null';
      if (val === undefined) return 'undefined';
      if (val && val.nodeType === 1) return 'element';
      if (val === Object(val)) return 'object';
      return typeof val;
    };

    /***/
  }), ( /* 686 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var isPrototype = __webpack_require__(690);
    module.exports = function (value) {
      if (typeof value !== "function") return false;
      if (!hasOwnProperty.call(value, "length")) return false;
      try {
        if (typeof value.length !== "number") return false;
        if (typeof value.call !== "function") return false;
        if (typeof value.apply !== "function") return false;
      } catch (error) {
        return false;
      }
      return !isPrototype(value);
    };

    /***/
  }), ( /* 687 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    module.exports = function (value) {
      try {
        return value.toString();
      } catch (error) {
        try {
          return String(value);
        } catch (error2) {
          return null;
        }
      }
    };

    /***/
  }), ( /* 688 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var safeToString = __webpack_require__(687);
    var reNewLine = /[\n\r\u2028\u2029]/g;
    module.exports = function (value) {
      var string = safeToString(value);
      if (string === null) return "<Non-coercible to string value>";
      // Trim if too long
      if (string.length > 100) string = string.slice(0, 99) + "…";
      // Replace eventual new lines
      string = string.replace(reNewLine, function (char) {
        switch (char) {
          case "\n":
            return "\\n";
          case "\r":
            return "\\r";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          /* istanbul ignore next */
          default:
            throw new Error("Unexpected character");
        }
      });
      return string;
    };

    /***/
  }), ( /* 689 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var resolveException = __webpack_require__(250),
      is = __webpack_require__(251);
    module.exports = function (value /*, options*/) {
      if (is(value)) return value;
      return resolveException(value, "%v is not a plain function", arguments[1]);
    };

    /***/
  }), ( /* 690 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var isObject = __webpack_require__(162);
    module.exports = function (value) {
      if (!isObject(value)) return false;
      try {
        if (!value.constructor) return false;
        return value.constructor.prototype === value;
      } catch (error) {
        return false;
      }
    };

    /***/
  }), ( /* 691 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var isValue = __webpack_require__(58),
      isObject = __webpack_require__(162);
    var objectToString = Object.prototype.toString;
    module.exports = function (value) {
      if (!isValue(value)) return null;
      if (isObject(value)) {
        // Reject Object.prototype.toString coercion
        var valueToString = value.toString;
        if (typeof valueToString !== "function") return null;
        if (valueToString === objectToString) return null;
        // Note: It can be object coming from other realm, still as there's no ES3 and CSP compliant
        // way to resolve its realm's Object.prototype.toString it's left as not addressed edge case
      }
      try {
        return "" + value; // Ensure implicit coercion
      } catch (error) {
        return null;
      }
    };

    /***/
  }), ( /* 692 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    var resolveException = __webpack_require__(250),
      is = __webpack_require__(58);
    module.exports = function (value /*, options*/) {
      if (is(value)) return value;
      return resolveException(value, "Cannot use %v", arguments[1]);
    };

    /***/
  }), ( /* 693 */
  /***/function (module, exports) {
    module.exports = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

    /***/
  }), ( /* 694 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.Any = __webpack_require__(254);
    exports.Cc = __webpack_require__(252);
    exports.Cf = __webpack_require__(693);
    exports.P = __webpack_require__(163);
    exports.Z = __webpack_require__(253);

    /***/
  }), ( /* 695 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    exports.default = createUncontrollable;
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _invariant = __webpack_require__(133);
    var _invariant2 = _interopRequireDefault(_invariant);
    var _utils = __webpack_require__(697);
    var utils = _interopRequireWildcard(_utils);
    function _interopRequireWildcard(obj) {
      if (obj && obj.__esModule) {
        return obj;
      } else {
        var newObj = {};
        if (obj != null) {
          for (var key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
          }
        }
        newObj.default = obj;
        return newObj;
      }
    }
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    function createUncontrollable(mixin, set) {
      return uncontrollable;
      function uncontrollable(Component, controlledValues) {
        var _class, _temp;
        var methods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        var displayName = Component.displayName || Component.name || 'Component',
          basePropTypes = utils.getType(Component).propTypes,
          isCompositeComponent = utils.isReactComponent(Component),
          controlledProps = Object.keys(controlledValues),
          propTypes;
        var OMIT_PROPS = ['valueLink', 'checkedLink'].concat(controlledProps.map(utils.defaultKey));
        propTypes = utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);
        (0, _invariant2.default)(isCompositeComponent || !methods.length, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));
        methods = utils.transform(methods, function (obj, method) {
          obj[method] = function () {
            var _refs$inner;
            return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
          };
        }, {});
        var component = (_temp = _class = function (_React$Component) {
          _inherits(component, _React$Component);
          function component() {
            _classCallCheck(this, component);
            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
          }
          component.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return !mixin.shouldComponentUpdate || mixin.shouldComponentUpdate.apply(this, args);
          };
          component.prototype.componentWillMount = function componentWillMount() {
            var _this2 = this;
            var props = this.props;
            this._values = {};
            controlledProps.forEach(function (key) {
              _this2._values[key] = props[utils.defaultKey(key)];
            });
          };

          /**
           * If a prop switches from controlled to Uncontrolled
           * reset its value to the defaultValue
           */

          component.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var _this3 = this;
            var props = this.props;
            if (mixin.componentWillReceiveProps) {
              mixin.componentWillReceiveProps.call(this, nextProps);
            }
            controlledProps.forEach(function (key) {
              if (utils.getValue(nextProps, key) === undefined && utils.getValue(props, key) !== undefined) {
                _this3._values[key] = nextProps[utils.defaultKey(key)];
              }
            });
          };
          component.prototype.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
          };
          component.prototype.getControlledInstance = function getControlledInstance() {
            return this.refs.inner;
          };
          component.prototype.render = function render() {
            var _this4 = this;
            var newProps = {},
              props = omitProps(this.props);
            utils.each(controlledValues, function (handle, propName) {
              var linkPropName = utils.getLinkName(propName),
                prop = _this4.props[propName];
              if (linkPropName && !isProp(_this4.props, propName) && isProp(_this4.props, linkPropName)) {
                prop = _this4.props[linkPropName].value;
              }
              newProps[propName] = prop !== undefined ? prop : _this4._values[propName];
              newProps[handle] = setAndNotify.bind(_this4, propName);
            });
            newProps = _extends({}, props, newProps, {
              ref: isCompositeComponent ? 'inner' : null
            });
            return _react2.default.createElement(Component, newProps);
          };
          return component;
        }(_react2.default.Component), _class.displayName = 'Uncontrolled(' + displayName + ')', _class.propTypes = propTypes, _temp);
        _extends(component.prototype, methods);
        component.ControlledComponent = Component;

        /**
         * useful when wrapping a Component and you want to control
         * everything
         */
        component.deferControlTo = function (newComponent) {
          var additions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var nextMethods = arguments[2];
          return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
        };
        return component;
        function setAndNotify(propName, value) {
          var linkName = utils.getLinkName(propName),
            handler = this.props[controlledValues[propName]];
          if (linkName && isProp(this.props, linkName) && !handler) {
            handler = this.props[linkName].requestChange;
          }
          for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
            args[_key2 - 2] = arguments[_key2];
          }
          set(this, propName, handler, value, args);
        }
        function isProp(props, prop) {
          return props[prop] !== undefined;
        }
        function omitProps(props) {
          var result = {};
          utils.each(props, function (value, key) {
            if (OMIT_PROPS.indexOf(key) === -1) result[key] = value;
          });
          return result;
        }
      }
    }
    module.exports = exports['default'];

    /***/
  }), ( /* 696 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    var _createUncontrollable = __webpack_require__(695);
    var _createUncontrollable2 = _interopRequireDefault(_createUncontrollable);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    var mixin = {
      shouldComponentUpdate: function shouldComponentUpdate() {
        //let the forceUpdate trigger the update
        return !this._notifying;
      }
    };
    function set(component, propName, handler, value, args) {
      if (handler) {
        component._notifying = true;
        handler.call.apply(handler, [component, value].concat(args));
        component._notifying = false;
      }
      component._values[propName] = value;
      if (!component.unmounted) component.forceUpdate();
    }
    exports.default = (0, _createUncontrollable2.default)(mixin, set);
    module.exports = exports['default'];

    /***/
  }), ( /* 697 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    exports.__esModule = true;
    exports.version = undefined;
    exports.uncontrolledPropTypes = uncontrolledPropTypes;
    exports.getType = getType;
    exports.getValue = getValue;
    exports.getLinkName = getLinkName;
    exports.defaultKey = defaultKey;
    exports.chain = chain;
    exports.transform = transform;
    exports.each = each;
    exports.has = has;
    exports.isReactComponent = isReactComponent;
    var _react = __webpack_require__(0);
    var _react2 = _interopRequireDefault(_react);
    var _invariant = __webpack_require__(133);
    var _invariant2 = _interopRequireDefault(_invariant);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function readOnlyPropType(handler, name) {
      return function (props, propName) {
        if (props[propName] !== undefined) {
          if (!props[handler]) {
            return new Error('You have provided a `' + propName + '` prop to ' + '`' + name + '` without an `' + handler + '` handler. This will render a read-only field. ' + 'If the field should be mutable use `' + defaultKey(propName) + '`. Otherwise, set `' + handler + '`');
          }
        }
      };
    }
    function uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
      var propTypes = {};
      if (false) {
        transform(controlledValues, function (obj, handler, prop) {
          (0, _invariant2.default)(typeof handler === 'string' && handler.trim().length, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);
          obj[prop] = readOnlyPropType(handler, displayName);
        }, propTypes);
      }
      return propTypes;
    }
    var version = exports.version = _react2.default.version.split('.').map(parseFloat);
    function getType(component) {
      if (version[0] >= 15 || version[0] === 0 && version[1] >= 13) return component;
      return component.type;
    }
    function getValue(props, name) {
      var linkPropName = getLinkName(name);
      if (linkPropName && !isProp(props, name) && isProp(props, linkPropName)) return props[linkPropName].value;
      return props[name];
    }
    function isProp(props, prop) {
      return props[prop] !== undefined;
    }
    function getLinkName(name) {
      return name === 'value' ? 'valueLink' : name === 'checked' ? 'checkedLink' : null;
    }
    function defaultKey(key) {
      return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
    }
    function chain(thisArg, a, b) {
      return function chainedFunction() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        a && a.call.apply(a, [thisArg].concat(args));
        b && b.call.apply(b, [thisArg].concat(args));
      };
    }
    function transform(obj, cb, seed) {
      each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
      return seed;
    }
    function each(obj, cb, thisArg) {
      if (Array.isArray(obj)) return obj.forEach(cb, thisArg);
      for (var key in obj) {
        if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
      }
    }
    function has(o, k) {
      return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
    }

    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     * All rights reserved.
     *
     * This source code is licensed under the BSD-style license found in the
     * LICENSE file in the root directory of this source tree. An additional grant
     * of patent rights can be found in the PATENTS file in the same directory.
     */
    function isReactComponent(component) {
      return !!(component && component.prototype && component.prototype.isReactComponent);
    }

    /***/
  }), ( /* 698 */
  /***/function (module, exports, __webpack_require__) {
    __webpack_require__(258);
    __webpack_require__(257);
    __webpack_require__(259);
    module.exports = __webpack_require__(256);

    /***/
  }
  /******/)]);
});